var process = require("./shim/process.js");
var vP13224 = require("./data/serverProps.js");
var serverProps = vP13224;
var clientExtensionBridge = require("./shim/clientExtensionBridge.js");
var vP132243 = require("./shim/frvrSDK.js");
var blah = require("./data/rarities.js");
var rarities = blah;
if (location.hostname == "localhost" && FRVR.channelCharacteristics.allowNavigation) {
  location.hostname = "127.0.0.1";
}
const v10510 = typeof vWP_MMToken != "undefined";
if (v10510) {
  vWP_MMToken = vWP_MMToken.split("").map(p13226 => String.fromCharCode(p13226.charCodeAt(0) - 5)).join("");
}
function f1727() {
  var v10511 = parent !== window;
  var v10512 = null;
  if (v10511) {
    v10512 = document.referrer;
  }
  return v10512;
}
const vLSPadding1pxBorderradi = "padding: 1px; border-radius: 3px 0 0 3px; color: #fff; background: #606060;";
const vLSPadding1pxBorderradi2 = "padding: 1px; border-radius: 0 3px 3px 0; color: #fff; background";
const v10513 = navigator.userAgent.toString();
console.info("%c Browser %c " + v10513.slice(v10513.lastIndexOf(") ") + 2, v10513.length) + " ", vLSPadding1pxBorderradi, vLSPadding1pxBorderradi2 + ": #1475b2;");
const v10514 = v10513.includes("io.krunker.steam") && v10513 != "io.krunker.steam";
const krl = String.fromCharCode(75, 82, 76).toLowerCase();
require("./register-sw.js");
var config = require("./config.js");
function isMobileClient() {
  return window._isMobile;
}
function checkIsMobileClient() {
  return isMobileClient();
}
const vEval = eval;
var isNode = vEval("typeof require == \"function\"") && config.isProd;
var webdriver = navigator.webdriver;
Object.defineProperty(navigator, "webdriver", {
  configurable: false,
  writable: false
});
FRVR.lifecycle.onGamePause = function () {};
FRVR.lifecycle.onSuspend = function () {};
FRVR.lifecycle.onResume = function () {};
FRVR.lifecycle.onAudioSuspend = function () {};
FRVR.lifecycle.onAudioResume = function () {};
window.requestAnimationFrame = window.requestAnimationFrame.isProxy ? (p13227, p13228) => {
  var v10518 = Date.now();
  let vF90 = () => {
    if (Date.now() > v10518 + p13228) {
      p13227();
    } else {
      requestIdleCallback(vF90);
    }
  };
  requestIdleCallback(vF90);
} : window.requestAnimationFrame;
var arrayIsArray = [] instanceof Array;
Object.defineProperty(window, "requestAnimationFrame", {
  configurable: false,
  writable: false
});
Object.defineProperty(window, "clearTimeout", {
  configurable: false,
  writable: false
});
Object.defineProperty(window, "setInterval", {
  configurable: false,
  writable: false
});
Object.defineProperty(window, "clearInterval", {
  configurable: false,
  writable: false
});
Object.defineProperty(CanvasRenderingContext2D.prototype, "measureText", {
  configurable: false,
  writable: false
});
Object.defineProperty(CanvasRenderingContext2D.prototype, "fillText", {
  configurable: false,
  writable: false
});
function f1730() {
  return typeof window != "undefined" && typeof window.process == "object" && window.process.type === "renderer" || typeof process != "undefined" && typeof process.versions == "object" && process.versions.electron || typeof navigator == "object" && typeof navigator.userAgent == "string" && !!(navigator.userAgent.indexOf("Electron") >= 0);
}
const vF1730 = f1730();
window.isDeskCli = isNode || f1730();
var v10520 = typeof Storage != "undefined";
try {
  window.localStorage.canStore = true;
} catch {
  v10520 = false;
}
window.saveVal = function (p13229, p13230) {
  if (v10520) {
    localStorage.setItem(p13229, p13230);
  }
};
function deleteVal(p13231) {
  if (v10520) {
    localStorage.removeItem(p13231);
  }
}
window.getSavedVal = function (p13232) {
  if (v10520) {
    return localStorage.getItem(p13232);
  } else {
    return null;
  }
};
var i18n = new (require("./libs/i18n.js"))();
function f1732(p13233, p13234) {
  if (isMobileClient()) {
    return p13234(true);
  }
  var v10522 = p13233 ? {
    action: p13233
  } : undefined;
  if (typeof grecaptcha == "undefined") {
    p13234(null, true);
  } else {
    grecaptcha.enterprise.execute(config.recaptchaKey, v10522).then(p13235 => {
      p13234(p13235);
    });
  }
}
const vA577 = ["msstart_sdk_init"];
const vF91 = (p13236, p13237, p13238) => {
  if (!window.forceMergeQueryString) {
    return p13237;
  }
  const v10523 = new URLSearchParams(p13236.search);
  const v10524 = new URLPattern(p13237, window.location.origin);
  const v10525 = new URLSearchParams(v10524.search);
  p13238.forEach(p13239 => {
    if (v10523.has(p13239)) {
      v10525.set(p13239, v10523.get(p13239));
    }
  });
  const v10526 = v10525.toString().replace(/%3A/g, ":");
  if (v10526.length === 0) {
    return p13237;
  } else {
    return p13237.split("?")[0] + "?" + v10526;
  }
};
window.openURL = function (p13240, p13241) {
  if (p13240.charAt(0) === "/") {
    p13240 = vF91(window.location, p13240, vA577);
  }
  if (p13241) {
    window.open(p13240, "_self");
  } else {
    window.open(p13240, "_blank");
  }
};
window.openDiscord = function () {
  window.open(config.discordInvite, "_blank");
};
var v10527 = String.fromCharCode(99, 104, 111, 110, 107, 101, 114, 99, 104, 101, 97, 116, 115).toLowerCase();
var gameLoopPaused = false;
var v10529 = false;
var v10530;
var v10531;
if (typeof document.hidden == "undefined") {
  if (typeof document.msHidden == "undefined") {
    if (typeof document.webkitHidden != "undefined") {
      v10530 = "webkitHidden";
      v10531 = "webkitvisibilitychange";
    }
  } else {
    v10530 = "msHidden";
    v10531 = "msvisibilitychange";
  }
} else {
  v10530 = "hidden";
  v10531 = "visibilitychange";
}
function f1733() {
  v10529 = document[v10530];
}
if (typeof document.addEventListener != "undefined" && v10530 !== undefined) {
  document.addEventListener(v10531, f1733, false);
}
var params = new URLSearchParams(window.location.search.replace("#", "%23").replace("+", "%2B"));
var hashParams = new URLSearchParams(window.location.hash.replace("#", "?"));
function getParam(p13242, p13243) {
  var v10534 = params.get(p13242);
  if (v10534 != null && /[^\w\_\-\.\!]+/gmi.test(v10534)) {
    v10534 = p13243;
  }
  if (p13243 == null) {
    return v10534;
  } else {
    return v10534 || p13243;
  }
}
var v10535 = parseInt(getParam("tm", 0)) || 0;
var vF1734 = getParam("play", null);
var vF17342 = getParam("host", null);
var v10536 = vF1734 || vF17342 || null;
var vF17343 = getParam("mod", null);
if (vF1734 || vF17342) {
  loadGamNm.innerHTML = i18n.t("generic.loading.simple") + " " + (vF1734 || vF17342) + " ...";
}
var v10537 = params.has("twitch_auth");
var v10538 = params.get("code");
var twitchDropsInfo = params.has("twitch_drops") ? params.get("twitch_drops") : params.get("twitch_info");
var v10540 = getSavedVal("lastViewedUpdate") || null;
var vO334 = {
  default: "Default"
};
window.updateAudioInputs = function () {
  if (navigator && navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
    navigator.mediaDevices.enumerateDevices().then(p13244 => {
      var v10541 = p13244.filter(p13245 => p13245.kind == "audioinput");
      vO334 = v10541.length ? Object.fromEntries(Object.keys(v10541).map(p13246 => p13246 = [v10541[p13246].deviceId, v10541[p13246].label || "Unknown Device"])) : {
        default: "Default"
      };
      if (SETTINGS) {
        SETTINGS.list.audioInput.options = vO334;
      }
    });
  }
};
updateAudioInputs();
window.getAudioInputs = () => vO334;
var ClientManager = require("./libs/ClientManager.js").default;
ClientManager.PING_REGION_CACHE_KEY = "pingRegion7";
ClientManager.USE_PORT = false;
ClientManager.MERGE_QUERY = !!window.forceMergeQueryString;
var client = new ClientManager(config.matchmakerURL, config.availableRegions, config.dedicatedOnlyRegions);
var v10544 = null;
var v10545 = null;
var v10546 = null;
var v10547 = null;
var v10548 = null;
var v10549 = null;
FRVR.tracker.addExtraFieldFunction(function (p13247) {
  if (v10545) {
    p13247.krunker_session_id = v10545;
  }
  if (v10544) {
    if (Game && Game.map) {
      p13247.map_id = Game.mapIndex;
    }
    if (Game && Game.map) {
      p13247.map_name = Game.map.getMapName();
    }
    if (Game && Game.map) {
      p13247.user_generated = !!Game.map.maps && !!Game.map.maps[Game.mapIndex] && !!Game.map.maps[Game.mapIndex].creator;
    }
    if (Game && Game.mode) {
      p13247.game_mode_id = Game.modeIndex;
    }
    if (Game && Game.mode) {
      p13247.game_mode_name = Game.mode.name;
    }
    if (v10544) {
      p13247.match_id = v10544;
    }
    if (Game && Game.roundId) {
      p13247.round_id = Game.roundId;
    }
    if (Game && Game.sessionId) {
      p13247.game_session_id = Game.sessionId;
    }
    if (io && io.socket && io.socket.url) {
      p13247.server = (new URL(io.socket.url).hostname + "").replace("cf_", "");
    }
    p13247.server_type = Game && Game.isCustom ? "custom" : "quickplay";
  }
});
function f1735(p13248) {
  client.switchGame(p13248, !FRVR.channelCharacteristics.allowNavigation);
}
function f1736(p13249, p13250) {
  if (p13250) {
    p13250.textContent = "...";
  }
  client.fetchGameInfo(p13249).then(p13251 => {
    var [v10550, v10551, v10552, v10553, v10554] = p13251;
    if (v10552 >= v10553) {
      if (p13250) {
        p13250.textContent = i18n.t("matchmaker.full");
      }
    } else {
      f1735(p13249);
    }
    if (p13250) {
      requestAnimationFrame(() => {
        p13250.textContent = Math.min(v10552, v10553) + "/" + v10553;
      }, 1000);
    }
  }).catch(() => {
    if (p13250) {
      p13250.textContent = "ERROR";
    }
  });
}
window.switchServer = f1735;
window.checkedSwitchServer = f1736;
var respawnCountdownTimer = null;
function f1737(p13252) {
  SOUND.play("tick_0", 0.2);
  setInstructionSubtitle(i18n.t("respawn.auto", p13252 - 1));
  if (p13252 > 1 && v10794) {
    respawnCountdownTimer = requestAnimationFrame(function () {
      if (v10794) {
        f1737(p13252 - 1);
      } else {
        setInstructionSubtitle(null);
      }
    }, 1000);
  } else {
    setInstructionSubtitle(null);
  }
}
window.showGames = function (p13253) {
  windows[9].hostType = p13253 || null;
  showWindow(10);
};
const vO335 = {
  type: "Scene",
  name: "Main",
  get children() {
    if (!hasSceneAccessFlag) {
      hasSceneAccessFlag = true;
    }
    return RENDER.scene.children || [];
  }
};
const vO336 = {
  parent: {
    type: "Scene",
    name: "Main",
    get children() {
      if (!hasSceneAccessFlag) {
        hasSceneAccessFlag = true;
      }
      return RENDER.scene.children || [];
    }
  }
};
Object.defineProperty(window, "rentDediServer", {
  writeable: false,
  value: function (p13254, p13255) {
    var v10556 = null;
    dediHostErr.style.display = "block";
    var v10557 = windows[7].dediServers.data[windows[7].servInd];
    var v10558 = v10557.CONF ? JSON.parse(v10557.CONF) : null;
    if (v10557.TRM <= 0) {
      v10558 = null;
    }
    if (!v11724 && !v10558) {
      v10556 = "Please select a game to host";
    }
    if (v10556) {
      dediHostErr.innerHTML = v10556;
      dediHostErr.style.color = "#ff3232";
    } else {
      var v10559 = document.getElementById("rentServBtn");
      if (v10559) {
        v10559.style.display = "none";
      }
      var v10560 = document.getElementById("updDediServBtn");
      if (v10560) {
        v10560.style.display = "none";
      }
      dediHostErr.innerHTML = "Please Wait...";
      dediHostErr.style.color = "#fff";
      io.send("rdsrv", p13254, {
        typ: dediHostDur.value,
        mid: v11724 ? v11724.id : v10558.gid,
        gnm: v11724 ? v11724.name : v10558.mn
      }, p13255);
    }
  }
});
Object.defineProperty(window, "createPrivateRoom", {
  writeable: false,
  value: function (p13256) {
    p13256 = isGameHost && p13256 && account && account.canRehost;
    if (config.isComp) {
      hostGameMsg.innerHTML = "<span class='error'>" + i18n.t("custom.host.ranked") + "</span>";
      return;
    }
    var v10561 = config.hostTypes[vLN01938 || 0] || {};
    var vA578 = [];
    var v10562 = document.getElementById("rawMapData");
    for (var vLN01678 = 0; vLN01678 < maps.length; vLN01678++) {
      if (maps[vLN01678] != 13) {
        var v10566 = document.getElementById("gameMap" + vLN01678);
        if (v10566 && v10566.checked) {
          vA578.push(vLN01678);
        }
      }
    }
    if (vA578.length == 0 && !v11724 && (!v10562 || v10562.value == "")) {
      hostGameMsg.innerHTML = "<span class='error' style='margin-bottom:10px'>" + i18n.t("custom.map.missing") + "</span>";
      return;
    }
    var v10564 = windows[7];
    if (!v10561.comp && !v10561.restrict) {
      var vA579 = [];
      for (var vLN01678 = 0; vLN01678 < gameModes.length; vLN01678++) {
        if (!gameModes[vLN01678].preventCustomGames || account && account.isDev) {
          var v10566 = document.getElementById("gameMode" + vLN01678);
          if (v10566 && v10566.checked) {
            vA579.push(vLN01678);
          }
        }
      }
      if (vA579.length == 0) {
        hostGameMsg.innerHTML = "<span class='error'>" + i18n.t("custom.mode.missing") + "</span>";
        return;
      }
      var vA580 = [];
      for (var vLN01678 = 0, v10566; vLN01678 < Game.classConfig.length; vLN01678++) {
        v10566 = document.getElementById("gameClass" + vLN01678);
        if (v10566 && v10566.checked) {
          vA580.push(vLN01678);
        }
      }
      if (vA580.length == 0) {
        hostGameMsg.innerHTML = "<span class='error'>" + i18n.t("custom.class.missing") + "</span>";
        return;
      }
      if (v10564.costVal && (!account || account.funds < v10564.costVal)) {
        hostGameMsg.innerHTML = "<span class='error'>" + i18n.t("funds.insufficient") + "</span>";
        return;
      }
      var v10567 = document.getElementById("passCode");
      if (v10567 && v10567.value != "" && v10567.value.length > 16) {
        hostGameMsg.innerHTML = "<span class='error'>" + i18n.t("custom.passcode.long") + "</span>";
        return;
      }
    }
    var v10568 = document.getElementById("shareToHub");
    var v10569 = document.getElementById("krRewards");
    var v10570 = document.getElementById("defaultSetts");
    var v10571 = document.getElementById("makePrivate");
    var vO337 = {
      private: !!v10571 && v10571.checked,
      krRewards: !!v10569 && v10569.checked,
      defaultSetts: !!v10570 && v10570.checked,
      share: !!v10568 && v10568.checked,
      customMap: v11724 ? v11724.name : null,
      rawMapData: v10562 ? v10562.value : null,
      maps: vA578,
      modes: vA579,
      classes: vA580,
      override: vLN01938,
      passCode: v10567 ? v10567.value : null
    };
    for (var vLN01678 = 0, v10585; vLN01678 < config.serverConfig.length; vLN01678++) {
      v10585 = document.getElementById("customS" + config.serverConfig[vLN01678].varN);
      let v10573;
      v10573 = config.serverConfig[vLN01678].bool ? v10585 ? v10585.checked : 0 : config.serverConfig[vLN01678].input ? v10585 ? UTILS.sanitizeStr(v10585.value) : 0 : config.serverConfig[vLN01678].select ? v10585 && config.serverConfig[vLN01678].options[v10585.value] != null ? parseInt(v10585.value) : config.serverConfig[vLN01678].def : v10585 ? parseFloat(v10585.value) : config.serverConfig[vLN01678].def || 0;
      vO337[config.serverConfig[vLN01678].varN] = v10573;
    }
    if (!v10561.comp && !v10561.restrict) {
      for (var vLN01678 = 0; vLN01678 < config.serverUpg.length; vLN01678++) {
        var v10574 = config.serverUpg[vLN01678].varN;
        var v10585 = document.getElementById("servUp" + v10574);
        if (v10585) {
          vO337[v10574] = v10585.checked;
        }
      }
      if (v10564.wepConf) {
        for (var vLN01677 = 0; vLN01677 < Game.weapons.length; vLN01677++) {
          for (var vLN01678 = 0; vLN01678 < config.weaponConfig.length; vLN01678++) {
            if (Game.weapons[vLN01677][config.weaponConfig[vLN01678].varN] == null) {
              continue;
            }
            var v10585 = document.getElementById("customW" + vLN01677 + "" + config.weaponConfig[vLN01678].varN);
            let v10577;
            if (config.weaponConfig[vLN01678].bool) {
              v10577 = v10585 ? v10585.checked : 0;
            } else if (config.weaponConfig[vLN01678].select) {
              v10577 = v10585 && config.weaponConfig[vLN01678].options[v10585.value] != null ? parseInt(v10585.value) : config.weaponConfig[vLN01678].def;
            } else if (config.weaponConfig[vLN01678].input) {
              v10577 = v10585 ? v10585.value : "";
              if (!UTILS.isString(v10577)) {
                v10577 = Game.weapons[vLN01677][config.weaponConfig[vLN01678].varN];
              }
              if (/[^\w \-\|]+/gmi.test(v10577)) {
                v10577 = Game.weapons[vLN01677][config.weaponConfig[vLN01678].varN];
              }
              if (v10577.length > (config.weaponConfig[vLN01678].len || 16)) {
                v10577 = Game.weapons[vLN01677][config.weaponConfig[vLN01678].varN];
              }
            } else {
              var v10584 = config.weaponConfig[vLN01678].decs;
              v10577 = v10585 ? UTILS.fixFloat(v10585.value, v10584) : 0;
            }
            if (v10577 != Game.weapons[vLN01677][config.weaponConfig[vLN01678].varN]) {
              if (!vO337.weps) {
                vO337.weps = {};
              }
              if (!vO337.weps[vLN01677]) {
                vO337.weps[vLN01677] = {};
              }
              vO337.weps[vLN01677][config.weaponConfig[vLN01678].varN] = v10577;
            }
          }
        }
      }
      if (v10564.clsConf) {
        for (var vLN01677 = 0; vLN01677 < Game.classes.length; vLN01677++) {
          for (var vLN01678 = 0; vLN01678 < config.classConfig.length; vLN01678++) {
            if (Game.classes[vLN01677][config.classConfig[vLN01678].varN] == null) {
              continue;
            }
            var v10585 = document.getElementById("customC" + vLN01677 + "" + config.classConfig[vLN01678].varN);
            let v10580;
            if (config.classConfig[vLN01678].bool) {
              v10580 = v10585 ? v10585.checked : 0;
            } else if (config.classConfig[vLN01678].select) {
              v10580 = v10585 && config.classConfig[vLN01678].options[v10585.value] != null ? parseInt(v10585.value) : config.classConfig[vLN01678].def;
            } else if (config.classConfig[vLN01678].input) {
              v10580 = v10585 ? v10585.value : "";
              if (!UTILS.isString(v10580)) {
                v10580 = Game.classes[vLN01677][config.classConfig[vLN01678].varN];
              }
              if (/[^\w \-\|]+/gmi.test(v10580)) {
                v10580 = Game.classes[vLN01677][config.classConfig[vLN01678].varN];
              }
              if (v10580.length > (config.classConfig[vLN01678].len || 16)) {
                v10580 = Game.classes[vLN01677][config.classConfig[vLN01678].varN];
              }
            } else {
              var v10584 = config.classConfig[vLN01678].decs;
              v10580 = v10585 ? UTILS.fixFloat(v10585.value, v10584) : 0;
            }
            if (v10580 != Game.classes[vLN01677][config.classConfig[vLN01678].varN]) {
              if (!vO337.cls) {
                vO337.cls = {};
              }
              if (!vO337.cls[vLN01677]) {
                vO337.cls[vLN01677] = {};
              }
              vO337.cls[vLN01677][config.classConfig[vLN01678].varN] = v10580;
            }
          }
        }
      }
      if (v10564.effectConf) {
        for (var vLN01677 = 0; vLN01677 < Game.effects.length; vLN01677++) {
          for (var vLN01678 = 0; vLN01678 < config.effectConfig.length; vLN01678++) {
            if (Game.effects[vLN01677][config.effectConfig[vLN01678].varN] == null) {
              continue;
            }
            var v10585 = document.getElementById("customE" + vLN01677 + "" + config.effectConfig[vLN01678].varN);
            let v10583;
            if (config.effectConfig[vLN01678].bool) {
              v10583 = v10585 ? v10585.checked : 0;
            } else if (config.effectConfig[vLN01678].select) {
              v10583 = v10585 && config.effectConfig[vLN01678].options[v10585.value] != null ? parseInt(v10585.value) : config.effectConfig[vLN01678].def;
            } else if (config.effectConfig[vLN01678].input) {
              v10583 = v10585 ? v10585.value : "";
              if (!UTILS.isString(v10583)) {
                v10583 = Game.effects[vLN01677][config.effectConfig[vLN01678].varN];
              }
              if (/[^\w \-\|]+/gmi.test(v10583)) {
                v10583 = Game.effects[vLN01677][config.effectConfig[vLN01678].varN];
              }
              if (v10583.length > (config.effectConfig[vLN01678].len || 16)) {
                v10583 = Game.effects[vLN01677][config.effectConfig[vLN01678].varN];
              }
            } else {
              var v10584 = config.effectConfig[vLN01678].decs;
              v10583 = v10585 ? UTILS.fixFloat(v10585.value, v10584) : 0;
            }
            if (v10583 != Game.effects[vLN01677][config.effectConfig[vLN01678].varN]) {
              if (!vO337.prks) {
                vO337.prks = {};
              }
              if (!vO337.prks[vLN01677]) {
                vO337.prks[vLN01677] = {};
              }
              vO337.prks[vLN01677][config.effectConfig[vLN01678].varN] = v10583;
            }
          }
        }
      }
    }
    hostGameMsg.innerHTML = i18n.t("generic.wait");
    var v10585 = document.getElementById("startServBtn");
    if (v10585) {
      v10585.style.background = "#595959";
      v10585.style.pointerEvents = "none";
    }
    v10585 = document.getElementById("rehostServBtn");
    if (v10585) {
      v10585.style.background = "#595959";
      v10585.style.pointerEvents = "none";
    }
    if (account) {
      io.send("custom", vO337, undefined, !!p13256);
    } else {
      f1732("hosting", function (p13257, p13258) {
        if (p13258) {
          io_customResponse(i18n.t("custom.tryagain"));
        } else {
          io.send("custom", vO337, p13257, !!p13256);
        }
      });
    }
  }
});
function io_customResponse(p13259, p13260, p13261) {
  try {
    hostGameMsg.innerHTML = p13259 + (p13260 ? "<a class='menuLink' style='float:right' onclick='copyGameLink(this, &quot;" + p13260 + "&quot;)'>Click to Copy</a>" : "");
    hostActionH.style.display = p13260 ? "none" : "block";
    teamLink1.innerHTML = p13260 && p13261 ? config.teamNames[0] + " Team Link <a class='menuLink' style='float:right' onclick='copyGameLink(this, &quot;" + p13260 + "&quot;,1)'>Copy</a>" : "";
    teamLink2.innerHTML = p13260 && p13261 ? config.teamNames[1] + " Team Link <a class='menuLink' style='float:right' onclick='copyGameLink(this, &quot;" + p13260 + "&quot;,2)'>Copy</a>" : "";
  } catch (e117) {}
  var v10586 = document.getElementById("startServBtn");
  if (v10586) {
    v10586.style.background = "#4582d1";
    v10586.style.pointerEvents = "all";
  }
  v10586 = document.getElementById("rehostServBtn");
  if (v10586) {
    v10586.style.background = "var(--red)";
    v10586.style.pointerEvents = "all";
  }
  if (p13260) {
    var v10587 = document.getElementById("rawMapData");
    if (v10587) {
      v10587.value = "";
    }
    UI.toggleWindow(false);
    f1739(p13260);
  }
  v11724 = null;
  v11723 = null;
  vLN01938 = 0;
  if (!p13260 && v10536) {
    location.href = vF91(window.location, location.origin, vA577);
  }
}
function f1739(p13262) {
  var v10588 = client.generateHref(p13262);
  if (!SETTINGS.tmp.streamMode && FRVR.channelCharacteristics.allowNavigation) {
    window.history.replaceState({}, "Krunker", v10588);
  }
  windows[1].lastLoadTime = 0;
  v10544 = p13262;
}
Object.defineProperty(console, "_commandLineAPI", {
  get: function () {
    throw "";
  }
});
Object.defineProperty(window, "requestAnimFrame", {
  writeable: false,
  value: function () {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (p13263) {
      window.requestAnimationFrame(p13263, 1000 / 60);
    };
  }()
});
var v10589 = Date.now();
window.requestAnimFrameF = function (p13264, p13265) {
  var v10590 = Math.max(0, 16 - (p13265 - v10589));
  var v10591 = window.requestAnimationFrame(function () {
    p13264(p13265 + v10590);
  }, v10590);
  v10589 = p13265 + v10590;
  return v10591;
};
var UI = require("./libs/UI.js");
UI.toggleMobileUI(checkIsMobileClient());
var COLORS = require("./data/colors.js");
var prices = require("./data/prices.js");
var gameModes = require("./data/gameModes.js");
var Account = require("./data/account.js");
var UTILS = require("./libs/utils.js");
var overlay = require("./libs/game-overlay.js");
var GameObj = require("./data/game.js");
var shaderRendering = getSavedVal("kro_setngss_shaderRendering") == "true";
var RENDER = new (require("./libs/render.js"))(overlay, UI, false, shaderRendering, checkIsMobileClient());
var THREE = RENDER.THREE;
var SOUND = window.SOUND = new (require("./libs/sound.js"))();
var PARTICLES = new (require("./libs/particles.js"))(RENDER);
var DIV = new (require("./libs/animDiv.js"))(RENDER);
var API_CLIENT = require("./libs/apiClient.js");
var io = require("./libs/io-client.js");
var ioSandbox = new (require("./libs/io-sandbox.js"))();
var Game = new GameObj(false, 0, null, RENDER, null, SOUND, PARTICLES, overlay, io);
UI.Game = Game;
var CONTROLS = new (require("./libs/controls.js"))(RENDER, UI, Game, io, overlay, checkIsMobileClient());
Game.controls = CONTROLS;
var initGameUI = require("./ui/init.js").init.game(Game, i18n);
var SETTINGS = new (require("./libs/settings.js"))(RENDER, PARTICLES, CONTROLS, Game, ClientManager, initGameUI, UI, overlay, io, i18n, vF1730);
Game.settings = SETTINGS;
Game.ui = UI;
if (!window.canShowNFTs) {
  UTILS.removeNFT(Game.store);
}
var maps = require("./data/maps.js")();
var Player = require("./data/player.js");
var reticles = require("./data/reticles.js");
var aimRecticles = require("./data/aimRecticles.js");
var backgrounds = require("./data/backgrounds.js");
var itemTypes = require("./data/itemTypes.js");
var weaponTypes = require("./data/weaponTypes.js");
var QrCode = require("./shim/qrcode.js");
var Filter = require("unwashed-words");
var filter = new Filter();
var version = require("../version.json");
var sandboxGame = null;
var sandboxPlayer = null;
var tmpPlayer;
var account;
var friends;
var player;
var otherPlayer;
var inputFrame;
Object.defineProperty(Game, "tmpPlayer", {
  get() {
    return tmpPlayer;
  }
});
RENDER.updateGameEnvironment = function (p13266, p13267) {
  RENDER.updateEnvironment(Game, p13266, p13267);
};
var currentHostId = null;
var freeMouseAngle;
window.locked = false;
var queuedInputStateChanges = {};
var lastQueuedInputValues = {};
var inputResyncFlag = 0;
var freeMouseRay = new THREE.Ray();
var queuedInputFrameTimes = [];
var queuedInputServerTimes = null;
var queuedInputLookDeltas = [];
var lastSentInputLookDeltas = [];
var freeMousePoint = new THREE.Vector3();
var freeMousePlane = new THREE.Plane();
var isGameHost = false;
var firstQueuedInputId = null;
var hasQueuedInputStateChanges = false;
var inputSendTimer = 0;
var queuedInputFrameIndex = 0;
var team = 0;
var propCameraDistance = 30;
var menuCameraYaw = 0;
var pendingScorePopupValue = 0;
var currentPing = -1;
var lastSocketPing = 0;
var inputFrameDelta = 0;
var clientFrameCount = 0;
var endMessageSent = false;
var activeKickVoteTargetAlias = false;
var chatAndFeedItems = [];
var latestLeaderboardData = null;
var classIndex = 0;
var currentKillStreak = 0;
var currentMapVoteData = [];
var kickVoteSubmittedAliases = [];
var hasStartedKickVote = false;
var lastPlayerSyncTime = 0;
var currentKpdCase = null;
var useDefaultCosmetics = false;
var hasStaticMenuCamera = false;
var focusedPlayerId = null;
var testCode = getSavedVal("testCode");
var lastPriorityPopupTime = 0;
var gameplayStartTime = 0;
var shouldConfirmPageUnload = false;
var countryCode = null;
var forceOneFpsUpdate = false;
var matchRewardSummary = {};
var lockoutTimer;
var gameTime;
var gameTimeDiff;
var lastGameTimeDiff;
var lastGameTime;
var lastUpdateRateTime;
var endAnimationTimer;
var deathDelayTimer;
var tempDomElement;
var mapVoteState;
var classPreviewDelayTicks;
var classPreviewEnabled;
var classPreviewVisible;
FRVR.tracker.addExtraFieldFunction(function (p13268) {
  if (account) {
    p13268.krunker_user_id = account.id;
  }
});
window.onbeforeunload = function () {
  f2077();
  if (shouldConfirmPageUnload) {
    return true;
  }
};
var mutedChatAccountIds = f2057("mute_chat");
var mutedVoiceAccountIds = f2057("mute_voice");
if (!mutedChatAccountIds || !mutedChatAccountIds.length) {
  mutedChatAccountIds = [];
}
if (!mutedVoiceAccountIds || !mutedVoiceAccountIds.length) {
  mutedVoiceAccountIds = [];
}
var settingsViewMode = parseInt(getSavedVal("krk_advanced")) || 0 ? "advanced" : "basic";
var devConsentStyleOverride = null;
if (!config.isProd) {
  devConsentStyleOverride = document.createElement("style");
  devConsentStyleOverride.innerHTML = "#onetrust-consent-sdk {display: none!important}";
  document.head.append(devConsentStyleOverride);
}
function io_customNetworkMessage(p13269, p13270) {
  if (config.serverScripting) {
    if (Game && Game.mainScript && Game.mainScript.onNetworkMessage) {
      Game.mainScript.onNetworkMessage(p13269, p13270);
    }
  }
}
var favoriteItemIds = getSavedVal("krk_favList") || "[]";
window.updateFavList = function (p13271, p13272) {
  if (!p13272) {
    try {
      p13271 = JSON.parse(p13271);
    } catch (e118) {
      p13271 = [];
    }
  }
  favoriteItemIds = p13271;
  saveVal("krk_favList", JSON.stringify(p13271));
  updateSprayWheel(true);
};
updateFavList(favoriteItemIds);
var customReticles = getSavedVal("krk_custRet") || "[]";
window.setCustomRets = function (p13273, p13274) {
  if (!p13274) {
    try {
      p13273 = JSON.parse(p13273);
    } catch (e119) {
      p13273 = [];
    }
  }
  customReticles = p13273;
  saveVal("krk_custRet", JSON.stringify(p13273));
};
setCustomRets(customReticles);
var legacyCustomAdsDotUrl = getSavedVal("kro_setngss_customADSDot");
legacyCustomAdsDotUrl = sanitizeCustomImageUrl(legacyCustomAdsDotUrl);
if (legacyCustomAdsDotUrl) {
  customReticles.push(["OLD", legacyCustomAdsDotUrl]);
  setCustomRets(customReticles, true);
  legacyCustomAdsDotUrl = null;
  deleteVal("kro_setngss_customADSDot");
}
var customScopes = getSavedVal("krk_custScps") || "[]";
window.setCustomScopes = function (p13275, p13276) {
  if (!p13276) {
    try {
      p13275 = JSON.parse(p13275);
    } catch (e120) {
      p13275 = [];
    }
  }
  customScopes = p13275;
  saveVal("krk_custScps", JSON.stringify(p13275));
};
setCustomScopes(customScopes);
var legacyCustomScopeUrl = getSavedVal("kro_setngss_customScope");
legacyCustomScopeUrl = sanitizeCustomImageUrl(legacyCustomScopeUrl);
if (legacyCustomScopeUrl) {
  customScopes.push(["OLD", legacyCustomScopeUrl]);
  setCustomScopes(customScopes, true);
  legacyCustomScopeUrl = null;
  deleteVal("kro_setngss_customScope");
}
var customImages = getSavedVal("krk_custImgs") || "[]";
window.setCustomImages = function (p13277, p13278) {
  if (!p13278) {
    try {
      p13277 = JSON.parse(p13277);
    } catch (e121) {
      p13277 = [];
    }
  }
  customImages = p13277;
  saveVal("krk_custImgs", JSON.stringify(p13277));
};
setCustomImages(customImages);
function sanitizeCustomImageUrl(p13279) {
  if (p13279) {
    if (/\.(jpg|jpeg|png|gif|webp|ico)/.test(p13279)) {
      if (p13279 && p13279.replace) {
        p13279 = p13279.replace(/\u0027/g, "").replace(/\u0022/g, "");
      }
      if (p13279 && UTILS.isURL(p13279) && !/\.svg/.test(p13279)) {
        return p13279;
      } else {
        return null;
      }
    } else {
      return null;
    }
  } else {
    return null;
  }
}
Object.defineProperty(window, "selectImage", {
  writeable: false,
  value: function (p13280, p13281, p13282) {
    if (p13280 >= 0) {
      p13281 = UTILS.assetsUrl("/img/backgrounds/" + backgrounds[p13280].id + "." + (backgrounds[p13280].type || "png"));
    }
    setSetting(p13282, p13281);
    clearPops();
  }
});
Object.defineProperty(window, "removeImage", {
  writeable: false,
  value: function (p13283, p13284) {
    f1822(window.event);
    if (customImages[p13283]) {
      customImages.splice(p13283, 1);
      setCustomImages(customImages, true);
      imagePopup(p13284);
    }
  }
});
var customImageCategories = ["Backgrounds", "Overlays", "Scopes", "Reticles", "Icons"];
window.imagePopup = function (p13285, p13286) {
  var v10652 = "<div class='imageListHeader'>Image Collection<div class='imageListAdd' onclick='window.imageNewPopup(&quot;" + p13285 + "&quot;)' onmouseenter='playTick()'>Add Image</div></div>";
  p13286 = UTILS.limitMM(parseInt(p13286) || 0, 0, customImageCategories.length - 1);
  v10652 += "<div id='skinList' style='margin-top:18px'>";
  v10652 += "<div id='imagesTabLayout'>";
  v10652 += customImageCategories.map((p13287, p13288) => "<div class='imageTab " + (p13288 == p13286 ? "tabAIMG" : "") + "' onmouseenter='playTick()'\n\t\tonclick='playSelect(0.1);imagePopup(&quot;" + p13285 + "&quot;, " + p13288 + ")'>" + p13287 + "</div>").join("\n");
  v10652 += "</div>";
  for (var vLN01694 = 0; vLN01694 < customImages.length; ++vLN01694) {
    player = customImages[vLN01694];
    if (player) {
      var v10653 = player[0].replace(/[^a-zA-Z0-9 _-]+/gim, "");
      var v10655 = sanitizeCustomImageUrl(player[1]);
      var v10654 = UTILS.limitMM(parseInt(player[2]) || 0, 0, customImageCategories.length - 1);
      if (v10654 != p13286) {
        continue;
      }
      v10652 += "<div class='imageListItem'><div class='imageActionOvrl'><div class='imageActionHol'><div class='imageActionB' onclick='selectImage(-2, &quot;" + v10655 + "&quot;, &quot;" + p13285 + "&quot;)' title='Select' style='margin-top:0px;'><span class='material-icons' style='font-size:50px;color:#fff;'>play_arrow</span></div><div class='imageActionSep' style='margin-left:2px'></div><div class='imageActionB' onclick='removeImage(" + vLN01694 + ", &quot;" + p13285 + "&quot;)' title='Delete' style='margin-top:0px;'><span class='material-icons' style='font-size:50px;color:#fff;'>delete_forever</span></div></div></div><div class='imageListThumbH'><img loading='lazy' class='imageListThumb' draggable='false' src='" + (v10655 || "") + "' onmouseenter='playTick()' /></div><div class='imageListName'>" + (v10653 || "Custom") + "<span class='imageListType'>Custom</span></div></div>";
    }
  }
  for (var vLN01694 = 0; vLN01694 < backgrounds.length; ++vLN01694) {
    player = backgrounds[vLN01694];
    if (player) {
      if (p13286 != 0) {
        continue;
      }
      var v10655 = UTILS.assetsUrl("/img/backgrounds/" + player.id + "." + (player.type || "png"));
      v10652 += "<div class='imageListItem'><div class='imageActionOvrl'><div class='imageActionHol'><div class='imageActionB' onclick='selectImage(" + vLN01694 + ", null, &quot;" + p13285 + "&quot;)' title='Select' style='margin-top:0px;'><span class='material-icons' style='font-size:50px;color:#fff;'>play_arrow</span></div></div></div><div class='imageListThumbH'><img loading='lazy' class='imageListThumb' draggable='false' src='" + (v10655 || "") + "' onmouseenter='playTick()' /></div><div class='imageListName'>" + player.name + "<span class='imageListType'>Default</span></div></div>";
    }
  }
  v10652 += "</div>";
  genericPopup(v10652, "imagePop");
};
window.imageNewPopup = function (p13289) {
  var v10656 = "<div class='imageListHeader' style='font-size: 26px;'>New Image</div><div style='font-size:20px;color:#fff'><div style='margin-top: 3px;font-size: 22px;color: rgba(255, 255, 255, 0.7);'>Name:<input type='text' id='newCustName' class='inputGrey2' placeholder='Name'></div><div style='margin-top: 3px;font-size: 22px;color: rgba(255, 255, 255, 0.7);'>Category:<select id='newCustCat' class='inputGrey2'>" + customImageCategories.map((p13290, p13291) => "<option value='" + p13291 + "'>" + p13290 + "</option>").join("\n") + "</select></div><div style='margin-top: 4px;font-size: 22px;color: rgba(255, 255, 255, 0.7);'>Image:<input type='url' id='newCustImg' class='inputGrey2' placeholder='Image URL'></div><div class='mapFndB' onclick='window.addNewImage(&quot;" + p13289 + "&quot;)' onmouseover='playTick(0.1)' style='background-color:#fc5a4e;width: 380px;margin-top: 10px;'>Add</div></div>";
  genericPopup(v10656, "imageNewPop");
};
window.addNewImage = function (p13292) {
  var v10657 = document.getElementById("newCustImg");
  var v10658 = document.getElementById("newCustName");
  var v10659 = document.getElementById("newCustCat");
  if (v10658 && v10657 && v10657.value && v10658.value) {
    var v10660 = v10658.value.replace(/[^a-zA-Z0-9 _-]+/gim, "");
    if (!v10660.length) {
      return io_showPopup(null, "Invalid Name");
    }
    var vF17412 = sanitizeCustomImageUrl(v10657.value);
    if (!vF17412) {
      return io_showPopup(null, "Invalid Image");
    }
    var v10661 = UTILS.limitMM(parseInt(v10659 ? v10659.value : 0) || 0, 0, customImageCategories.length - 1);
    customImages.push([v10660, vF17412, v10661]);
    setCustomImages(customImages, true);
    imagePopup(p13292);
  } else {
    return io_showPopup(null, "Something Went Wrong");
  }
};
var accountStateFlag = false;
function f1742(p13293) {
  if (!config.isProd) {
    return p13293;
  }
  var v10663 = tmpPlayer.id.split("").map(p13294 => p13294.charCodeAt(0) * 50).reduce((p13295, p13296) => p13295 + p13296) * 50 + 122;
  return (p13293 - 15 ^ v10663) / 1000;
}
var lastLoadedModUrl = getSavedVal("krk_lastMod") || "";
window.setLastMod = function (p13297) {
  lastLoadedModUrl = p13297;
  saveVal("krk_lastMod", p13297);
};
setLastMod(lastLoadedModUrl);
var uiScale = 1;
var baseUiWidth = 1700;
var baseUiHeight = 900;
var crosshairScale;
var lastWindowHeight;
var lastWindowWidth;
window.scaleBase = function (p13298, p13299) {
  if (SETTINGS.tmp.uiScaling !== undefined) {
    var v10668 = window.innerHeight;
    var v10669 = window.innerWidth;
    if (p13299 || lastWindowHeight != v10668 || lastWindowWidth != v10669) {
      lastWindowHeight = v10668;
      lastWindowWidth = v10669;
      var vA588 = [uiBase];
      if (!SETTINGS.tmp.uiScaling) {
        vA588.forEach(p13300 => {
          p13300.style.transform = "";
          p13300.style.width = "";
          p13300.style.height = "";
        });
      } else {
        var v10670 = baseUiWidth * SETTINGS.tmp.scaleUI;
        var v10671 = baseUiHeight * SETTINGS.tmp.scaleUI;
        var v10672 = v10669 / v10670;
        var v10673 = v10668 / v10671;
        if (v10673 < v10672) {
          uiScale = v10673;
          vA588.forEach(p13301 => {
            p13301.style.transform = "scale(" + v10673.toFixed(3) + ")";
            p13301.style.width = (v10669 / v10673).toFixed(3) + "px";
            p13301.style.height = v10671 + "px";
          });
        } else {
          uiScale = v10672;
          vA588.forEach(p13302 => {
            p13302.style.transform = "scale(" + v10672.toFixed(3) + ")";
            p13302.style.width = v10670 + "px";
            p13302.style.height = (v10668 / v10672).toFixed(3) + "px";
          });
        }
      }
      crosshairScale = v10668 / uiScale / 693;
      overlay.resize();
      RENDER.resize();
    }
  }
};
window.addEventListener("resize", scaleBase);
window.refreshChat = function () {
  while (chatList.childNodes.length >= config.chatListLength) {
    var v10674 = chatList.childNodes[0];
    chatAndFeedItems[parseInt(v10674.id.replace("chatMsg_", ""))].life = 0;
    chatList.removeChild(v10674);
  }
};
window.refreshFeed = function (p13303) {
  while (killFeed.childNodes.length >= p13303) {
    var v10675 = killFeed.childNodes[0];
    chatAndFeedItems[parseInt(v10675.id.replace("feed_", ""))].life = 0;
    killFeed.removeChild(v10675);
  }
};
window.updateChatTimer = function (p13304) {
  if (chatAndFeedItems) {
    for (var v10676 in chatAndFeedItems) {
      chatAndFeedItems[v10676].life -= p13304 * 1000;
    }
  }
};
window.switchLeaderboard = function (p13305, p13306) {
  var v10677 = Game && Game.mode && Game.mode.forceOldScoreboard;
  if (v10677 || p13306) {
    p13305 = true;
  }
  var v10678 = !!p13305;
  SETTINGS.tmp.leaderType = p13305 ? 0 : 1;
  leaderboardHolder.style.display = v10678 ? "block" : "none";
  killFeed.style.display = !v10678 && SETTINGS.list.showKills.val ? "inline-grid" : "none";
  document.getElementsByClassName("topRightCounters")[0].style.width = v10678 ? "400px" : "auto";
  if (latestLeaderboardData) {
    io_updateLeaders(latestLeaderboardData);
  }
};
window.refreshClassDisplay = function () {
  if (classPreviewScene) {
    updateClassPreview();
  }
};
var packetTallyInterval;
window.updatePacketLoop = function (enabled) {
  f1778();
  if (enabled) {
    packetTallyInterval = setInterval(f1778, 1000);
  } else {
    clearInterval(packetTallyInterval);
  }
};
var challengeModeEnabled = false;
window.toggleChal = function (p13308) {
  challengeModeEnabled = p13308;
};
function io_addDebugPoing(p13309) {
  RENDER.addSphere(p13309.x, p13309.y - 0.25, p13309.z, 0.5, 0.5, 0.5, {
    colr: 16711680
  });
}
window.updateWeaponShow = function (p13310, p13311) {
  if (tmpPlayer) {
    if (p13310 == 0) {
      for (var vLN01698 = 0, v10682; vLN01698 < tmpPlayer.loadout.length; vLN01698++) {
        v10682 = Game.weaponConfig[tmpPlayer.loadout[vLN01698]];
        if (tmpPlayer.weaponMeshes[vLN01698]) {
          if (v10682.melee) {
            if (tmpPlayer.armMeshes[0]) {
              tmpPlayer.armMeshes[0].visible = p13311;
            }
            if (tmpPlayer.armMeshes[1]) {
              if (!tmpPlayer.armMeshes[1].realMat) {
                tmpPlayer.armMeshes[1].realMat = tmpPlayer.armMeshes[1].material;
              }
              tmpPlayer.armMeshes[1].material = p13311 ? tmpPlayer.armMeshes[1].realMat : RENDER.invisMat;
            }
          } else if (tmpPlayer.mergedArmMeshes[vLN01698]) {
            tmpPlayer.mergedArmMeshes[vLN01698].visible = p13311;
          }
        }
      }
    } else if (p13310 == 1) {
      for (var vLN01698 = 0, v10682; vLN01698 < tmpPlayer.loadout.length; vLN01698++) {
        v10682 = Game.weaponConfig[tmpPlayer.loadout[vLN01698]];
        if (!v10682.secondary && !v10682.melee && tmpPlayer.weaponMeshes[vLN01698] && tmpPlayer.loadoutIndex == vLN01698) {
          tmpPlayer.weaponMeshes[vLN01698].visible = p13311;
        }
      }
    } else if (p13310 == 2) {
      for (var vLN01698 = 0; vLN01698 < tmpPlayer.loadout.length; vLN01698++) {
        if (Game.weaponConfig[tmpPlayer.loadout[vLN01698]].secondary && tmpPlayer.weaponMeshes[vLN01698] && tmpPlayer.loadoutIndex == vLN01698) {
          tmpPlayer.weaponMeshes[vLN01698].visible = p13311;
        }
      }
    } else if (p13310 == 3) {
      for (var vLN01698 = 0; vLN01698 < tmpPlayer.loadout.length; vLN01698++) {
        if (Game.weaponConfig[tmpPlayer.loadout[vLN01698]].melee && tmpPlayer.weaponMeshes[vLN01698] && tmpPlayer.loadoutIndex == vLN01698) {
          tmpPlayer.weaponMeshes[vLN01698].visible = p13311;
        }
      }
    }
  }
};
window.updateFov = function (p13312, p13313, p13314) {
  if (tmpPlayer && p13314 > -1) {
    if (tmpPlayer.currentWeaponId != p13314) {
      return;
    }
    p13313 = p13313 == null ? SETTINGS.tmp[(p13312 == 0 ? "fov" : "fpsFOV") + "_" + p13314] : p13313;
  } else {
    p13313 = SETTINGS.tmp[p13312 == 0 ? "fov" : "fpsFOV"];
  }
  if (p13312 == 0) {
    RENDER.setFov(p13313);
  } else {
    RENDER.setFPSFov(p13313);
  }
};
window.bundleFilters = function (p13315, p13316) {
  if (p13316 != null) {
    var v10683 = "saturate(" + p13316 + "%)";
    overlay.canvas.style.filter = v10683;
    RENDER.renderer.domElement.style.filter = v10683;
    uiBase.style.filter = v10683;
    return;
  }
  var vA589 = [];
  var v10684 = p13315 == 1;
  if (SETTINGS.tmp[v10684 ? "menuSaturation" : "saturationn"] != 1) {
    vA589.push("saturate(" + SETTINGS.tmp[v10684 ? "menuSaturation" : "saturationn"] * 100 + "%)");
  }
  if (SETTINGS.tmp[v10684 ? "menuHue" : "hue"] != 0) {
    vA589.push("hue-rotate(" + SETTINGS.tmp[v10684 ? "menuHue" : "hue"] * 3.6 + "deg)");
  }
  if (v10684) {
    if (vA589.length) {
      uiBase.style.filter = vA589.join(" ");
    } else {
      uiBase.style.removeProperty("filter");
    }
  } else if (vA589.length) {
    overlay.canvas.style.filter = vA589.join(" ");
    RENDER.renderer.domElement.style.filter = vA589.join(" ");
  } else {
    overlay.canvas.style.removeProperty("filter");
    RENDER.renderer.domElement.style.removeProperty("filter");
  }
};
window.updateAimDot = function (p13317, p13318) {
  var v10685 = reticles[p13317];
  if (p13317 == -1) {
    return RENDER.aimDot.display = false;
  }
  if (p13317 == -2) {
    RENDER.aimDot.savedCustom = p13318 || "";
  } else if (v10685) {
    p13318 = UTILS.assetsUrl("/textures/reticles/reticle_" + v10685.id + "." + (v10685.type || "png"));
  }
  p13318 = p13318 && p13318.length && UTILS.isURL(p13318) && !/\.svg/.test(p13318) ? p13318 : UTILS.assetsUrl("/textures/reticles/reticle_0.png");
  if (/\.(jpg|jpeg|png)/.test(p13318)) {
    RENDER.aimDot.image.isReady = false;
    RENDER.aimDot.image.onload = () => RENDER.aimDot.image.isReady = true;
    RENDER.aimDot.image.src = p13318;
    RENDER.aimDot.custom = false;
  } else {
    aimDot.src = p13318;
    RENDER.aimDot.custom = true;
  }
  RENDER.aimDot.display = true;
  reticleIndex = p13317;
};
const hasChonkerCheatsGlobal = () => !!window.hasOwnProperty(v10527);
const getDisabledIntegrityFlag = () => false;
window.updateScope = function (p13319, p13320) {
  var v10686 = aimRecticles[p13319];
  if (p13319 == -1) {
    return RENDER.aimRecticle.display = false;
  }
  if (p13319 == -2) {
    RENDER.aimRecticle.savedCustom = p13320 || "";
  } else if (v10686) {
    p13320 = UTILS.assetsUrl("/textures/scopes/scope_" + v10686.id + "." + (v10686.type || "png"));
  }
  p13320 = p13320 && p13320.length && UTILS.isURL(p13320) && !/\.svg/.test(p13320) ? p13320 : UTILS.assetsUrl("/textures/scopes/scope_0.png");
  if (/\.(jpg|jpeg|png)/.test(p13320)) {
    RENDER.aimRecticle.image.isReady = false;
    RENDER.aimRecticle.image.onload = () => RENDER.aimRecticle.image.isReady = true;
    RENDER.aimRecticle.image.src = p13320;
    RENDER.aimRecticle.custom = false;
  } else {
    recticleImg.src = p13320;
    RENDER.aimRecticle.custom = true;
  }
  RENDER.aimRecticle.display = true;
  scopeIndex = p13319;
};
SETTINGS.init();
window.checkTerms = function (p13321) {
  if (p13321) {
    consentBlock.style.display = "none";
    saveVal("consent", 1);
  } else {
    f2072(document.getElementById("consentShake"));
  }
};
var getObjectCreateDateDescriptor = () => Reflect.getOwnPropertyDescriptor(Object.prototype, "createDate");
Math.PI2 = Math.PI * 2;
Number.prototype.map = function (p13322, p13323, p13324, p13325) {
  return (this - p13322) * (p13325 - p13324) / (p13323 - p13322) + p13324;
};
Math.lerpAngle = function (p13326, p13327, p13328) {
  var v10687 = Math.abs(p13327 - p13326);
  if (v10687 > Math.PI) {
    if (p13326 > p13327) {
      p13327 += Math.PI2;
    } else {
      p13326 += Math.PI2;
    }
  }
  var v10688 = p13327 + (p13326 - p13327) * p13328;
  if (v10688 >= 0 && v10688 <= Math.PI2) {
    return v10688;
  } else {
    return v10688 % Math.PI2;
  }
};
console.warn = function () {};
console.info = function () {};
var ssjunkerconfig = String.fromCharCode(115, 115, 106, 117, 110, 107, 101, 114, 99, 111, 110, 102, 105, 103).toLowerCase();
const hasSsjunkerConfigFlag = !!v10520 && !!localStorage && !!localStorage.hasOwnProperty(ssjunkerconfig);
const getHiddenWindowHeaderProbe = () => windows[11].header == "" ? undefined : windows[11].header + "";
window.toggleStrm = function (p13329) {
  if (FRVR.channelCharacteristics.allowNavigation) {
    window.history.pushState(document.title, document.title, p13329 ? "/" : client.generateHref(v10544));
  }
  io_updateLeaders(latestLeaderboardData);
};
var inGame = false;
UI.loading = false;
const hasKrlLocalStorageFlag = !!v10520 && !!localStorage && !!localStorage.hasOwnProperty(krl);
var hasSceneAccessFlag = false;
Object.defineProperty(window, "enterGame", {
  writeable: false,
  value: function (forceExitSpectate) {
    if (UI.embedPlayer) {
      UI.toggleEmbedPlayer(false);
    }
    if (lockoutTimer) {
      io_failedToEnder();
      return;
    }
    if (activeFeaturedStream && !activeFeaturedStream.f) {
      activeFeaturedStream = false;
      rotateStreamPanel();
    }
    if (respawnCountdownTimer) {
      clearTimeout(respawnCountdownTimer);
      respawnCountdownTimer = null;
      setInstructionSubtitle(null);
    }
    if (forceExitSpectate) {
      window.setSpect(false);
    }
    if (Game.isSandbox && (!inGame || window.spectating && !spectateEnabled)) {
      var sandboxSpawnTeam = sandboxPlayer == null ? vLN1150 : sandboxPlayer.team;
      var selectedTeam = sandboxPlayer ? sandboxPlayer.checkPoint : null;
      var savedCheckpoint = sandboxPlayer ? sandboxPlayer.checkPointList : [];
      var savedCustomLoadout = sandboxPlayer ? sandboxPlayer.customLoadout : null;
      savedCustomLoadout = sandboxGame.mode.keepLoadout ? savedCustomLoadout : null;
      var savedWeaponTier = sandboxPlayer ? sandboxPlayer.weaponTier : 0;
      var savedHeadMultiplier = sandboxPlayer ? sandboxPlayer.headMlt : 1;
      var sandboxSpawnPoint = selectedTeam && sandboxGame.map.manager.objects[selectedTeam] ? sandboxGame.map.manager.objects[selectedTeam] : sandboxGame.getSpawnPoint(sandboxSpawnTeam, sandboxPlayer);
      var selectedClassConfig = sandboxGame.classConfig[parseInt(classIndex)];
      var selectedClassLoadout = selectedClassConfig.loadout;
      var selectedLoadoutSkins = [skinsLoadout[selectedClassLoadout[0]] == null ? -1 : skinsLoadout[selectedClassLoadout[0]], skinsLoadout[secondaryIndex] != null && selectedClassConfig.secondary ? skinsLoadout[secondaryIndex] : -1];
      var selectedLoadoutCharms = [selectedCharms[0] == -2 ? f1800(null, itemTypes.CHARM) : parseInt(selectedCharms[0]), selectedCharms[1] != null && selectedClassConfig.secondary ? selectedCharms[1] == -2 ? f1800(null, itemTypes.CHARM) : parseInt(selectedCharms[1]) : -1];
      var forceDefaultAttachment = sandboxGame.weaponConfig[selectedClassLoadout[0]].forceAttach;
      if (Game.store.skins[selectedLoadoutSkins[0]] && Game.store.skins[selectedLoadoutSkins[0]].forceAttach) {
        forceDefaultAttachment = true;
      }
      var randomPropId = sandboxGame.mode && sandboxGame.mode.prop ? sandboxGame.players.randomProp() : null;
      sandboxPlayer = window.sandboxPlayer = sandboxGame.players.add(io.socketId, null, 0, 0, 0, window.isBotFTUE ? "Guest_2" : "Local User", parseInt(classIndex), selectedLoadoutSkins, parseInt(faceIndex), parseInt(shoeIndex), parseInt(hatIndex), parseInt(headIndex), parseInt(bodyIndex), parseInt(backIndex), parseInt(waistIndex), parseInt(petIndex), parseInt(wristIndex), parseInt(meleeIndex), skinColIndex, hairCol, parseInt(dyeIndex), forceDefaultAttachment ? 0 : parseInt(attachIndex), parseInt(pcStatIndex), selectedClassConfig.secondary ? parseInt(secondaryIndex) : null, randomPropId, null, null, false, savedCustomLoadout, null, null, null, savedHeadMultiplier, selectedLoadoutCharms, [], false);
      if (sandboxPlayer) {
        sandboxPlayer.team = sandboxSpawnTeam || sandboxPlayer.team;
        sandboxPlayer.x = sandboxSpawnPoint.x;
        sandboxPlayer.y = sandboxSpawnPoint.y;
        sandboxPlayer.z = sandboxSpawnPoint.z;
        sandboxPlayer.fakeX = sandboxPlayer.x;
        sandboxPlayer.fakeY = sandboxPlayer.y;
        sandboxPlayer.fakeZ = sandboxPlayer.z;
        sandboxPlayer.setInitPos();
        sandboxPlayer.xDire = -((sandboxSpawnPoint.dir || 0) + 1) * Math.PI / 2;
        sandboxPlayer.checkPoint = selectedTeam;
        sandboxPlayer.checkPointList = savedCheckpoint;
        sandboxPlayer.weaponTier = savedWeaponTier;
        sandboxPlayer.sprayIndex = parseInt(sprayIndex);
        sandboxPlayer.playerCardIndex = parseInt(playerCardIndex);
        sandboxPlayer.streakIndexs = [parseInt(streakIndex1), parseInt(streakIndex2), parseInt(streakIndex3)];
        sandboxPlayer.maxPossibleStreak = 0;
        sandboxPlayer.streakIndexs.forEach(p13331 => {
          if (sandboxGame.streaks[p13331] && sandboxGame.streaks[p13331].kills) {
            sandboxPlayer.maxPossibleStreak = sandboxGame.streaks[p13331].kills;
          }
        });
        sandboxPlayer.spectating = spectateEnabled;
        sandboxPlayer.spawnTime = Date.now();
        if (spectateEnabled) {
          sandboxPlayer.active = false;
          sandboxPlayer.spawned = false;
          if (!sandboxGame.waitTimers || sandboxGame.waitTimers[0].noJoin || sandboxGame.waitTimers[0].contTime) {
            sandboxPlayer.lives = 0;
          }
        } else {
          sandboxPlayer.active = true;
          sandboxPlayer.spawned = false;
        }
        if (sandboxPlayer.active && !sandboxPlayer.spawned || account && account.isDev) {
          if (!currentKpdCase) {
            sandboxPlayer.affectStats = true;
          }
          sandboxPlayer.spawned = true;
        }
        sandboxPlayer.send("start", UTILS.getTime(sandboxGame.gameTimer), sandboxPlayer.team, spectateEnabled, sandboxPlayer.challMode, sandboxGame.moveLock ? 1 : 0, 1, null, sandboxPlayer.classIndex);
        sandboxGame.players.sync();
        sandboxGame.players.syncLeaders(true);
      }
      inGame = true;
      UI.toggleMenu(false);
    } else if (io.connected && (!inGame || window.spectating && !spectateEnabled)) {
      overlay.bloodOpacity = 0;
      bloodDisplay.style.display = "none";
      inGame = true;
      CONTROLS.idleTimer = 0;
      UI.toggleMenu(false);
      instructions.innerHTML = "";
      UI.loading = true;
      var selectedClassConfig = parseInt(classIndex);
      var selectedClassLoadout = Game.classConfig[selectedClassConfig].loadout;
      var selectedLoadoutSkins = [useDefaultCosmetics ? -1 : skinsLoadout[selectedClassLoadout[0]] == null ? -1 : skinsLoadout[selectedClassLoadout[0]] == -2 ? f1800(selectedClassLoadout[0] + 1) : skinsLoadout[selectedClassLoadout[0]], useDefaultCosmetics ? -1 : skinsLoadout[secondaryIndex] != null && Game.classConfig[selectedClassConfig].secondary ? skinsLoadout[secondaryIndex] == -2 ? f1800(secondaryIndex + 1) : skinsLoadout[secondaryIndex] : -1];
      var selectedLoadoutCharms = [useDefaultCosmetics ? -1 : selectedCharms[0] == -2 ? f1800(null, itemTypes.CHARM) : parseInt(selectedCharms[0]), useDefaultCosmetics ? -1 : selectedCharms[1] != null && Game.classConfig[selectedClassConfig].secondary ? selectedCharms[1] == -2 ? f1800(null, itemTypes.CHARM) : parseInt(selectedCharms[1]) : -1];
      io.send("en", [selectedClassConfig, useDefaultCosmetics ? -1 : sprayIndex == -2 ? f1800(null, itemTypes.SPRAY) : parseInt(sprayIndex), selectedLoadoutSkins, useDefaultCosmetics ? -1 : hatIndex == -2 ? f1800(null, itemTypes.HAT) : parseInt(hatIndex), useDefaultCosmetics ? -1 : bodyIndex == -2 ? f1800(null, itemTypes.BODY) : parseInt(bodyIndex), parseInt(secondaryIndex), spectateEnabled ? 1 : 0, challengeModeEnabled ? 1 : 0, vLN1150, useDefaultCosmetics ? -1 : meleeIndex == -2 ? f1800(null, itemTypes.MELEE) : parseInt(meleeIndex), skinColIndex, parseFloat(SETTINGS.tmp.lagComp), parseInt(attachIndex), parseInt(pcStatIndex), dyeIndex == -2 ? f1800(null, itemTypes.DYE) : parseInt(dyeIndex), useDefaultCosmetics ? -1 : shoeIndex == -2 ? f1800(null, itemTypes.SHOE) : parseInt(shoeIndex), useDefaultCosmetics ? -1 : waistIndex == -2 ? f1800(null, itemTypes.WAIST) : parseInt(waistIndex), hairCol, chatCol, SETTINGS.tmp.anonMode ? 1 : 0, useDefaultCosmetics ? -1 : faceIndex == -2 ? f1800(null, itemTypes.FACE) : parseInt(faceIndex), useDefaultCosmetics ? -1 : petIndex == -2 ? f1800(null, itemTypes.PET) : parseInt(petIndex), SETTINGS.tmp.verifiedBadge ? 1 : 0, SETTINGS.tmp.premiumBadge ? 1 : 0, SETTINGS.tmp.partnerBadge ? 1 : 0, SETTINGS.tmp.customBadge ? 1 : 0, useDefaultCosmetics ? -1 : wristIndex == -2 ? f1800(null, itemTypes.WRIST) : parseInt(wristIndex), streakIndex1, streakIndex2, streakIndex3, selectedLoadoutCharms, useDefaultCosmetics ? -1 : backIndex == -2 ? f1800(null, itemTypes.BACK) : parseInt(backIndex), useDefaultCosmetics ? -1 : headIndex == -2 ? f1800(null, itemTypes.HEAD) : parseInt(headIndex), useDefaultCosmetics ? -1 : playerCardIndex == -2 ? f1800(null, itemTypes.PLAYER_CARD) : parseInt(playerCardIndex)], 16, 18, !!hasKrlLocalStorageFlag, !!hasSceneAccessFlag, false, false, !!getObjectCreateDateDescriptor(), hasSsjunkerConfigFlag, getHiddenWindowHeaderProbe(), !!hasChonkerCheatsGlobal(), !!getDisabledIntegrityFlag());
    }
    chatList.scrollTop = chatList.scrollHeight - chatList.clientHeight;
  }
});
function io_failedToEnder(failureMessage) {
  UI.loading = false;
  f1771();
  f2042();
  if (failureMessage) {
    io_addChat(-1, null, failureMessage, 2, "#ed4242");
  }
}
var twitchEmbedScriptLoaded = false;
function createTwitchEmbedPlayer(embedElementId, embedPlayerOptions) {
  UI.embedPlayer = new Twitch.Player(embedElementId, embedPlayerOptions);
  if (UI.useEmbedPlayer) {
    UI.toggleEmbedPlayer(true);
  }
}
function loadTwitchEmbedPlayer(embedElementId, embedPlayerOptions) {
  if (!twitchEmbedScriptLoaded) {
    var twitchEmbedScript = document.createElement("script");
    twitchEmbedScript.type = "text/javascript";
    twitchEmbedScript.async = true;
    twitchEmbedScript.src = "//player.twitch.tv/js/embed/v1.js";
    twitchEmbedScript.addEventListener("load", function () {
      twitchEmbedScriptLoaded = true;
      createTwitchEmbedPlayer(embedElementId, embedPlayerOptions);
    }, false);
    var documentHead = document.getElementsByTagName("head")[0];
    documentHead.appendChild(twitchEmbedScript);
    twitchEmbedScriptLoaded = true;
  } else {
    createTwitchEmbedPlayer(embedElementId, embedPlayerOptions);
  }
}
var xsollaScriptLoaded = false;
var xsollaWidgetLoading = false;
var xsollaPaymentStatus = null;
function f1747(p13337, p13338) {
  if (xsollaWidgetLoading) {
    io_addChat(-1, null, "Xsolla is currently loading", 2);
    return;
  } else {
    f1748();
    xsollaWidgetLoading = true;
    XPayStationWidget.off();
    XPayStationWidget.on(XPayStationWidget.eventTypes.CLOSE, function () {
      xsollaWidgetLoading = false;
      if (xsollaPaymentStatus == "troubled") {
        purchaseError("xsolla");
      } else {
        purchaseCancel("xsolla");
      }
      xsollaPaymentStatus = null;
    });
    XPayStationWidget.on(XPayStationWidget.eventTypes.INIT, function () {
      XPayStationWidget.open();
    });
    XPayStationWidget.on(XPayStationWidget.eventTypes.STATUS, function (p13339, p13340) {
      xsollaPaymentStatus = p13340.paymentInfo.status;
    });
    XPayStationWidget.on(XPayStationWidget.eventTypes.STATUS_DONE, function (p13341, p13342) {
      xsollaWidgetLoading = false;
      io.send("xsin", p13342.paymentInfo.invoice);
    });
    XPayStationWidget.on(XPayStationWidget.eventTypes.STATUS, function (p13343, p13344) {
      xsollaPaymentStatus = p13344.paymentInfo.status;
    });
    window.XPayStationWidget.init({
      access_token: p13337,
      lightbox: {
        width: "740px",
        height: "630px",
        spinner: "round"
      },
      sandbox: p13338
    });
    return;
  }
}
function f1748() {
  xsollaWidgetLoading = false;
  xsollaPaymentStatus = null;
  var v10712 = document.querySelector(".xpaystation-widget-lightbox");
  if (v10712) {
    v10712.remove();
  }
}
function io_loadXsolla(p13345, p13346, p13347) {
  if (!xsollaScriptLoaded) {
    var v10713 = document.createElement("script");
    v10713.type = "text/javascript";
    v10713.async = true;
    v10713.src = "//static.xsolla.com/embed/paystation/1.0.7/widget.min.js";
    v10713.addEventListener("load", function () {
      f1747(p13345, p13346, p13347);
    }, false);
    var v10714 = document.getElementsByTagName("head")[0];
    v10714.appendChild(v10713);
    xsollaScriptLoaded = true;
  } else if (window.XPayStationWidget) {
    f1747(p13345, p13346, p13347);
  }
}
function f1750() {
  var v10715 = document.createElement("script");
  v10715.type = "text/javascript";
  v10715.async = true;
  v10715.src = "//www.paypalobjects.com/api/checkout.min.js";
  var v10716 = document.getElementsByTagName("head")[0];
  v10716.appendChild(v10715);
}
if (window.canShowPaypal) {
  f1750();
}
function f1751(p13348) {
  return config.apiURL + p13348;
}
var selectedPurchaseIndex = 0;
var selectedPurchaseAmount = 0;
var purchaseErrorVisible = false;
window.cancelPurchase = function () {
  if (purchaseErrorVisible) {
    CONTROLS.idleTimer = 0;
    purchaseResponse.style.display = "none";
    selectedPurchaseIndex = 0;
    selectedPurchaseAmount = 0;
    purchaseLoad.style.display = "none";
    purchaseErrorVisible = false;
  }
};
function io_updateFunds(p13349, p13350) {
  if (account) {
    if (p13349 != null || p13349 != null) {
      account.funds = parseInt(p13349);
    }
    if (p13350 != null || p13350 != null) {
      account.junk = parseFloat(p13350);
    }
  }
  updateMenuAccountData();
}
function io_updateChallengeRewards(p13351, p13352, p13353, p13354, p13355) {
  if (p13354) {
    logEventFRVR("item_flow", {
      item: "junks",
      flow_type: "source",
      amount: p13354,
      item_context: "challenge",
      item_context_details: "type_challenge",
      wallet: account ? account.junk : 0
    });
  }
  if (p13355) {
    logEventFRVR("item_flow", {
      item: "krunkers",
      flow_type: "source",
      amount: p13355,
      item_context: "challenge",
      item_context_details: "type_challenge",
      wallet: account ? account.funds : 0
    });
  }
  if (account && ((p13352 != null || p13352 != null) && (account.funds = parseInt(p13352)), (p13353 != null || p13353 != null) && (account.junk = parseFloat(p13353)), p13351 && p13351.length)) {
    for (var vLN01701 = 0; vLN01701 < p13351.length; vLN01701++) {
      account.addSkin(p13351[vLN01701]);
    }
  }
  updateMenuAccountData();
}
function io_foundJunk(p13356, p13357) {
  logEventFRVR("item_flow", {
    item: "junks",
    flow_type: "source",
    amount: parseFloat(p13357).toFixed(2),
    item_context: "map_rotation",
    wallet: account ? account.junk : 0
  });
  if (account && p13356 != null || p13356 != null) {
    account.junk = parseFloat(p13356);
  }
  io_addChat(-1, null, "<span style='color:#fff'>You</span> found <span style='color:#cc51f8'>[" + parseFloat(p13357).toFixed(2) + "]</span> Junk", 1);
  matchRewardSummary.junk = (matchRewardSummary.junk || 0) + parseFloat(p13357);
}
function io_surveyBundleResponse(p13358, p13359, p13360) {
  if (!p13358) {
    if (p13360 && p13360.length) {
      for (var vLN01702 = 0; vLN01702 < p13360.length; vLN01702++) {
        account.addSkin(p13360[vLN01702]);
      }
    }
    io_showPopup("SUCCESS", null, "Bundle Recieved");
    updateMenuAccountData();
    updateWindow(null, true);
    UI.toggleMenuHider(true);
    purchaseLoad.style.display = "none";
    logEventFRVR("survey_bundle_recieved");
  } else {
    io_showPopup(null, p13358);
  }
}
function io_purchaseResponse(p13361, p13362, p13363, p13364, p13365, p13366, p13367, p13368) {
  CONTROLS.idleTimer = 0;
  f1748();
  if (p13362) {
    purchaseError(p13361, p13362, "kr_" + Game.store.purchases[parseInt(p13364) || 0].val);
  } else {
    var v10718 = Game.store.purchases[p13364].val;
    if (account) {
      if (UTILS.isNumber(p13364)) {
        io_showPopup("SUCCESS", null, i18n.t("purchase.kr.success", UTILS.commaNumber(v10718)));
        logEventFRVR("item_flow", {
          item: "krunkers",
          flow_type: "source",
          amount: v10718,
          item_context: "iap_shop",
          wallet: account ? account.funds : 0
        });
      }
      account.funds = p13363;
    }
    updateMenuAccountData();
    updateWindow(null, true);
    UI.toggleMenuHider(true);
    purchaseLoad.style.display = "none";
    logEventFRVR("iap_request_payment_success", {
      product_id: "kr_" + v10718,
      price_amount: p13365,
      price_currency_code: p13366,
      payment_provider: p13361,
      transaction_id: p13367,
      external_transaction_id: p13368,
      productId: "kr_" + v10718,
      priceValue: p13365,
      currencyCode: p13366,
      provider: p13361,
      transactionId: p13368,
      trackingName: v10718 + " KR",
      label: v10718 + " KR"
    });
  }
}
function io_purchasePremiumResponse(p13369, p13370, p13371, p13372, p13373, p13374, p13375, p13376) {
  CONTROLS.idleTimer = 0;
  f1748();
  var v10719 = Game.store.premium[parseInt(p13371) || 0];
  if (p13370) {
    purchaseError(p13369, p13370, "premium_" + v10719.val);
  } else {
    if (account) {
      if (v10719) {
        io_showPopup("SUCCESS", null, "Premium Purchased");
      }
      account.premiumT = p13372;
    }
    updateMenuAccountData();
    updateWindow(null, true);
    UI.toggleMenuHider(true);
    purchaseLoad.style.display = "none";
    logEventFRVR("iap_request_payment_success", {
      product_id: "premium_" + p13371,
      payment_provider: p13369,
      price_amount: p13373,
      price_currency_code: p13374,
      transaction_id: p13375,
      external_transaction_id: p13376,
      productId: "premium_" + p13371,
      provider: p13369,
      priceValue: p13373,
      currencyCode: p13374,
      transactionId: p13376,
      trackingName: "Premium " + p13371,
      label: "premium_ " + p13371
    });
  }
}
function io_purchaseBundleResponse(p13377, p13378, p13379, p13380, p13381, p13382, p13383, p13384, p13385, p13386) {
  CONTROLS.idleTimer = 0;
  f1748();
  if (p13378) {
    purchaseError(p13377, p13378, "bundle_" + p13382);
  } else {
    if (account) {
      if (p13379 != null || p13379 != null) {
        account.funds = parseInt(p13379);
      }
      if (p13380 != null || p13380 != null) {
        account.junk = parseFloat(p13380);
      }
      if (p13381 && p13381.length) {
        for (var vLN01703 = 0; vLN01703 < p13381.length; vLN01703++) {
          account.addSkin(p13381[vLN01703]);
        }
      }
      io_showPopup("SUCCESS", null, "Bundle Purchased");
    }
    if (Array.isArray(bundleData)) {
      var v10720 = bundleData.findIndex(p13387 => p13387.ID == p13382);
      bundleData[v10720].OWNED = true;
    }
    updateMenuAccountData();
    updateWindow(null, true);
    UI.toggleMenuHider(true);
    purchaseLoad.style.display = "none";
    logEventFRVR("iap_request_payment_success", {
      product_id: "bundle_" + p13382,
      payment_provider: p13377,
      price_amount: p13383,
      price_currency_code: p13384,
      transaction_id: p13385,
      external_transaction_id: p13386,
      productId: "bundle_" + p13382,
      provider: p13377,
      priceValue: p13383,
      currencyCode: p13384,
      transactionId: p13386,
      trackingName: "Bundle " + p13382,
      label: "Bundle " + p13382
    });
  }
}
window.XsollaPopup = function (p13388, p13389) {
  closePurchaseSelector();
  var v10721 = document.getElementById("creatorCodeI") || {};
  io.send("xst", selectedPurchaseIndex, v10721.value || null, SETTINGS.list.lang.val, p13388, p13389, window.paymentsChannelId);
};
var bundleData = null;
var activeBundleSoundId = false;
function f1759(p13390, p13391) {
  var v10724 = null;
  if (p13390 != null && bundleData) {
    v10724 = bundleData.find(p13392 => p13392.ID == p13390);
  } else if (bundleData && bundleData.length) {
    bundleData.sort((p13393, p13394) => {
      const v10725 = getSavedVal("bundle_" + p13393.ID) || 0;
      const v10726 = getSavedVal("bundle_" + p13394.ID) || 0;
      return (v10725 || -1) - (v10726 || -1);
    });
    const v10727 = bundleData.filter(p13395 => !p13395.OWNED);
    if (v10727.length > 0) {
      v10724 = v10727[0];
    }
  }
  if (!p13391 && Date.now() - lastPriorityPopupTime <= config.priorityPopTimer) {
    return undefined;
  } else {
    return v10724;
  }
}
function f1760(p13396) {
  saveVal("bundle_" + p13396.ID, Date.now());
}
function io_allBundleData(p13397) {
  bundleData = p13397;
  const v10728 = UTILS.getRandom(p13397 || [{
    ID: 9,
    NM: "No Bundle"
  }]);
  homeStoreAdC.style.backgroundImage = "url(" + UTILS.assetsUrl("/img/backgrounds/bundles/b_" + v10728.ID + ".png") + ")";
  homeStoreAdC.style.backgroundSize = "cover";
  homeStoreAdTx.innerHTML = v10728.NAME;
  bundleQuickBuyB.innerHTML = "$" + v10728.PRICE;
  homeStoreAd.onclick = function () {
    bundlePopup(true, false, v10728.ID);
  };
}
function io_availableBundleData(p13398) {
  if (bundleData) {
    bundleData.forEach(p13399 => {
      p13399.OWNED = !p13398.includes(p13399.ID);
    });
  }
  if (!v10537) {
    bundlePopup(undefined, true);
  }
}
window.bundlePopup = function (p13400, p13401, p13402) {
  var vF1759 = f1759(p13402, p13400);
  if (vF1759) {
    if (menuHolder.style.display == "none") {
      return;
    }
    const vGetSavedVal4 = getSavedVal("bundle_" + vF1759.ID);
    const v10729 = vF1759.PRICE === 0;
    const v10730 = vF1759.NAME.toLowerCase().includes("starter");
    const v10731 = (!!v10730 || !!v10729) && !v10514;
    const v10732 = parseInt(vF1759.FUNDS) || 0;
    const v10733 = (parseFloat(vF1759.JUNK) || 0).toFixed(2);
    var vLSdivStylemargintop15p = "<div style='margin-top:15px;'>";
    const v10734 = vF1759.SKINS.split(",");
    const vA594 = [];
    const vA595 = [];
    var vLN01704 = 0;
    for (var vLN01707 = 0, v10735; vLN01707 < 12;) {
      v10735 = Game.store.skins[v10734[vLN01704]];
      vLN01704++;
      if (v10735) {
        var vLN01706 = 0;
        if (v10735.collection) {
          if (vA595.includes(v10735.collection)) {
            continue;
          }
          vA595.push(v10735.collection);
          vLN01706 = Game.store.skins.filter(p13403 => p13403 && p13403.collection == v10735.collection).length;
        }
        const v10736 = Game.store.rarities[v10735.rarity].color;
        if (v10735.type == itemTypes.SPRAY && v10735.frames && vA594.indexOf(v10735.frames) == -1) {
          vA594.push(v10735.frames);
        }
        vLSdivStylemargintop15p += "<div class='bundlItmC' style='background:url(" + v10735.thumbnail + ");" + (v10735.type == itemTypes.SPRAY && v10735.frames ? "background-size: cover !important;" + UTILS.getFrameAnim(v10735, "sprayAnmB") : "background-size: contain;background-position: center;") + "border: 3px solid " + v10736 + ";' onclick='viewItem(" + v10735.index + ")'>" + (vLN01706 ? "<div class='bundlItmCnt'>+" + (vLN01706 - 1) + "</div>" : "") + "</div>";
      } else {
        vLSdivStylemargintop15p += "<div class='bundlItmC' style='border: 3px solid #707070;'></div>";
      }
      vLN01707++;
    }
    vLSdivStylemargintop15p += "</div>";
    var v10737 = JSON.parse(getSavedVal("krk_cc") || "{}");
    if (v10737 && Date.now() - v10737.t >= config.creatorReset) {
      deleteVal("krk_cc");
      v10737 = null;
    } else {
      v10737 = v10737.code;
    }
    var v10738 = account && account.refCode ? account.refCode : null;
    if (v10738 && (v10738 + "").toLowerCase() == "krunker") {
      v10738 = null;
    }
    const v10739 = v10737 || v10738 || null;
    if (!v10729) {
      var v10740 = "<div class='bundlCreatorH'><div class='bundlCreatorText'>" + i18n.t("windows.store.creator") + "</div><div><input type='text' id='bundlCreatorCode' class='smlInput' " + (v10739 ? "value='" + v10739 + "'" : "placeholder='Enter Creator Code'") + " " + (v10737 ? "disabled" : "") + "/><div id='bundlCreatorCodeBtn' style='background-color:" + (v10737 ? "#eb5656" : "#41c300") + "' onclick='creatorCodeAction(" + (v10737 ? 0 : 1) + ", 1)'>" + (v10737 ? "Remove" : "Save") + "</div></div></div>";
    }
    var vLS43 = "";
    if (vA594.length) {
      vLS43 += "<style>";
      for (var vLN01707 = 0; vLN01707 < vA594.length; vLN01707++) {
        vLS43 += "@keyframes sprayAnmB" + vA594[vLN01707] + " {100%{background-position:-" + vA594[vLN01707] * 81 + "px}}";
      }
      vLS43 += "</style>";
    }
    vLS43 += "<div class='bundlPopImg' style='background:url(" + UTILS.assetsUrl("/img/backgrounds/bundles/b_" + vF1759.ID + ".png") + ");background-size: cover;'></div><div class='bundlPopCurncs'>" + (v10733 > 0 ? "<div style='color:#cfcfcf'>+ <span style='color:#7d7d7d;'>" + v10733 + "</span> <span class='material-icons' style='color:#cc51f8;font-size:35px;margin-left:-5px;vertical-align:top;'>plumbing</span></div>" : "") + (v10732 ? "<div style='color:#cfcfcf'>+ <span style='color:#7d7d7d;'>" + v10732 + "</span> <span style='color:#fbc02d'>KR</span></div>" : "") + "</div><div class='bundlPopSidH'><div class='bundlPopNam'>" + vF1759.NAME + "</div><div class='bundlPopInfo'>" + vF1759.INFO + "</div>" + vLSdivStylemargintop15p + v10740;
    vLS43 += "<div class='bundlPopBuyH'>";
    if (v10731) {
      vLS43 += "<div class='bundlPopBuy" + (v10729 ? "C" : "S") + "' onclick='selectBundle(this, " + vF1759.ID + ", true)'>\n\t\t\t\tComplete Free Survey</div>";
    }
    if (!v10729) {
      vLS43 += "<div class='bundlPopBuy" + (v10731 ? "B" : "C") + "' onclick='selectBundle(this, " + vF1759.ID + ", false)'>\n\t\t\t\tBuy - " + vF1759.PRICE + " USD</div>";
    }
    vLS43 += "</div>";
    resetPops();
    bundlePop.style.display = "block";
    bundlePop.innerHTML = vLS43;
    if (vF1759.ID > 1) {
      SOUND.play("bundle_" + vF1759.ID, vF1759.ID == 12 ? 1 : 0.1, true, vF1759.ID == 6 ? 1.25 : 1);
      activeBundleSoundId = "bundle_" + vF1759.ID;
    }
    f1760(vF1759);
  } else if (p13401) {
    freeKRAuto(true);
  } else {
    updateWindow(14);
  }
};
window.selectBundle = function (p13404, p13405, p13406, p13407) {
  var v10741 = document.getElementById("bundlCreatorCode") || {};
  if (!p13407 && v10514) {
    return io_showPopup(null, "Invalid Steam Account");
  }
  if (p13407 && v10514) {
    if (p13406) {
      return io_showPopup(null, "Not available on Steam");
    }
    var v10742 = !!window.ClientSession && !!window.ClientSession.settings && !!window.ClientSession.settings.gameCap && !!window.ClientSession.settings.gameCap.val;
    if (!v10742) {
      return io_showPopup(null, "Game Capture must be enabled to use Steam Purchase");
    }
    io.send("stpbV", p13407 + "", p13405, v10741.value || null);
  } else if (p13406) {
    window.showAd({
      type: FRVR.ads.AdType.SURVEY,
      onComplete: () => io.connected ? void io.send("svyb", p13405) : (io_showPopup("SUCCESS", null, "Refresh page to recieve bundle"), void saveVal("2390v", p13405)),
      onError: () => io_showPopup(null, "Try again later")
    });
  } else {
    io.send("xstb", p13405, v10741.value || null, SETTINGS.list.lang.val, null, null, window.paymentsChannelId);
  }
  logEventFRVR("iap_request_payment", {
    product_id: "bundle_" + p13405,
    productId: "bundle_" + p13405,
    trackingName: "Bundle " + p13405,
    label: "Bundle " + p13405,
    provider: v10514 ? "steam" : "xsolla"
  });
  p13404.style.pointerEvents = "none";
  requestAnimationFrame(() => {
    if (p13404) {
      p13404.style.pointerEvents = "";
    }
  }, 3500);
};
window.selectBPTier = function (p13408, p13409, p13410) {
  var v10743 = document.getElementById("battlepassCreatorCode") || {};
  if (!p13410 && v10514) {
    return io_showPopup(null, "Invalid Steam Account");
  }
  if (p13410 && v10514) {
    var v10744 = !!window.ClientSession && !!window.ClientSession.settings && !!window.ClientSession.settings.gameCap && !!window.ClientSession.settings.gameCap.val;
    if (!v10744) {
      return io_showPopup(null, "Game Capture must be enabled to use Steam Purchase");
    }
    io.send("stpbpV", p13410 + "", p13409, v10743.value || null);
  } else {
    io.send("xstbp", p13409, v10743.value || null, SETTINGS.list.lang.val, null, null, window.paymentsChannelId);
  }
  p13408.style.pointerEvents = "none";
  requestAnimationFrame(() => {
    if (p13408) {
      p13408.style.pointerEvents = "";
    }
  }, 3500);
};
window.skipLevels = function (p13411, p13412) {
  var v10745 = document.getElementById("bp-skip-num");
  if (v10745) {
    var v10746 = parseInt(v10745.textContent) || 1;
    if (!p13412 && v10514) {
      return io_showPopup(null, "Invalid Steam Account");
    }
    if (p13412 && v10514) {
      var v10747 = !!window.ClientSession && !!window.ClientSession.settings && !!window.ClientSession.settings.gameCap && !!window.ClientSession.settings.gameCap.val;
      if (!v10747) {
        return io_showPopup(null, "Game Capture must be enabled to use Steam Purchase");
      }
      io.send("stpbplV", p13412 + "", v10746);
    } else {
      io.send("xstbpl", v10746, SETTINGS.list.lang.val, null, null, window.paymentsChannelId);
    }
    p13411.style.pointerEvents = "none";
    requestAnimationFrame(() => {
      if (p13411) {
        p13411.style.pointerEvents = "";
      }
    }, 3500);
  }
};
window.showDrops = function () {
  clearPops();
  showWindow(5);
  windows[4].switchTab(4);
  setHed_twitch.click();
};
window.authorizeSteamPayment = function (p13413) {
  CONTROLS.idleTimer = 0;
  if (v10514 && account) {
    io.send("stpA", p13413);
  }
};
window.showPurchase = function (p13414, p13415) {
  if (Game.store.purchases[p13414]) {
    CONTROLS.idleTimer = 0;
  }
  if (!account) {
    showWindow(5);
    return;
  }
  var v10748 = Game.store.purchases[p13414 || 0].val;
  if (!p13415 && v10514) {
    return io_showPopup(null, "Invalid Steam Account");
  }
  if (p13415 && v10514) {
    var v10749 = !!window.ClientSession && !!window.ClientSession.settings && !!window.ClientSession.settings.gameCap && !!window.ClientSession.settings.gameCap.val;
    if (!v10749) {
      return io_showPopup(null, "Game Capture must be enabled to use Steam Overlay");
    }
    var v10754 = document.getElementById("creatorCodeI") || {};
    io.send("stpV", p13415 + "", p13414, v10754.value || null, 1);
    logEventFRVR("iap_request_payment", {
      product_id: "kr_" + v10748,
      productId: "kr_" + v10748,
      trackingName: v10748 + " KR",
      label: v10748 + " KR",
      provider: "steam"
    });
    return;
  }
  logEventFRVR("iap_request_payment", {
    product_id: "kr_" + v10748,
    productId: "kr_" + v10748,
    trackingName: v10748 + " KR",
    label: v10748 + " KR"
  });
  selectedPurchaseIndex = p13414;
  purchaseHolder.style.display = "block";
  var v10751 = document.getElementById("xsollaPayB");
  if (v10751) {
    var v10752 = config.xsollaEnabled || account && account.isDev;
    if (v10752) {
      v10751.innerHTML = "<img src='" + UTILS.assetsUrl("/img/xsolla.png") + "' style='width:26px;margin-right:13px;margin-bottom:-4px' />Credit/Debit Card";
    } else {
      v10751.style.display = "none";
    }
  }
  if (window.canShowPaypal) {
    var v10753 = document.getElementById("paypal-button");
    var v10754 = document.getElementById("creatorCodeI") || {};
    if (v10753) {
      v10753.innerHTML = "";
    }
    if (account) {
      paypal.Button.render({
        style: {
          size: "large",
          color: "blue",
          shape: "rect",
          label: "paypal",
          tagline: false
        },
        env: "production",
        commit: true,
        payment: function (p13416, p13417) {
          closePurchaseSelector();
          return p13417.request.post(f1751("/my-api/create-payment/"), {
            pIndex: selectedPurchaseIndex,
            acID: account.id,
            creID: v10754.value || null
          }).then(function (p13418) {
            return p13418.id;
          });
        },
        onAuthorize: function (p13419, p13420) {
          return p13420.request.post(f1751("/my-api/execute-payment/"), {
            pIndex: selectedPurchaseIndex,
            acID: account.id,
            creID: v10754.value || null,
            paymentID: p13419.paymentID,
            payerID: p13419.payerID
          }).then(function (p13421) {
            if (p13421 && p13421.funds != null && p13421.funds != null) {
              io_purchaseResponse("paypal", null, p13421.funds, selectedPurchaseIndex, p13421.price, "USD");
            } else {
              purchaseError("paypal", p13421, "kr_" + Game.store.purchases[parseInt(selectedPurchaseIndex) || 0].val);
            }
          });
        },
        onError: function (p13422) {
          purchaseError("paypal", p13422, "kr_" + Game.store.purchases[parseInt(selectedPurchaseIndex) || 0].val);
        },
        onCancel: function () {
          purchaseCancel("paypal", "kr_" + Game.store.purchases[parseInt(selectedPurchaseIndex) || 0].val);
        }
      }, "#paypal-button");
    }
  }
};
window.closePurchaseSelector = function () {
  purchaseHolder.style.display = "none";
};
window.purchaseCancel = function (p13423, p13424) {
  closePurchaseSelector();
  logEventFRVR("iap_request_payment_failed", {
    payment_provider: p13423,
    product_id: p13424,
    productId: p13424,
    provider: p13423,
    err: "Purchase cancelled by user"
  });
};
window.purchaseError = function (p13425, p13426, p13427) {
  purchaseErrorVisible = true;
  var vLSPurchaseError = "Purchase Error";
  if (p13426 && p13426.err) {
    vLSPurchaseError = p13426.err;
  }
  purchaseResponse.style.display = "block";
  purchaseRespH.innerHTML = vLSPurchaseError + " <a href='javascript:;' onclick='cancelPurchase()'>" + i18n.t("purchase.error.click") + "</a>";
  logEventFRVR("iap_request_payment_failed", {
    payment_provider: p13425,
    product_id: p13427,
    provider: p13425,
    productId: p13427,
    err: vLSPurchaseError
  });
};
purchaseResponse.onclick = function () {
  purchaseResponse.style.display = "none";
};
function io_updateCountry(p13428) {
  countryCode = p13428;
}
var spectatorPlayerStats = {};
var spectatorInterpState = {};
var spectateEnabled = false;
var spectateCameraInitialized = false;
window.noMouseInp = false;
CONTROLS.spect.target = null;
var spectatingObjectiveCamera = false;
var spectatorThirdPerson = true;
var spectatorThirdPersonFollow = true;
window.spectating = false;
var showSpectatorNameTags = true;
window.setSpect = function (p13429) {
  specBtn.checked = p13429;
  spectateEnabled = p13429;
  f2042();
};
window.toggleSpect = function () {
  spectateEnabled = !spectateEnabled;
  specBtn.checked = spectateEnabled;
  cmpSpectTgl.innerHTML = spectateEnabled ? "visibility" : "visibility_off";
  cmpSpectBtn.style.backgroundColor = spectateEnabled ? "#8ec72c" : "#eb4034";
  f2042();
};
function f1764(p13430) {
  RENDER.aimRecticle.opacity = 0;
  aimRecticle.style.opacity = 0;
  spectatorThirdPerson = p13430;
  if (spectatorThirdPerson) {
    spectatorThirdPersonFollow = true;
  } else {
    spectatorThirdPersonFollow = null;
    window.noMouseInp = false;
  }
  CONTROLS.setCamPosOff();
  specIns.textContent = spectatorThirdPerson ? "Third Person" : "First Person";
}
function f1765() {
  CONTROLS.spect.target = null;
  io_interMProg(0, false);
  io_interProg(0);
}
window.spectMode = function (p13431) {
  if (Game && Game.players) {
    if (!p13431) {
      if (spectatingObjectiveCamera) {
        CONTROLS.object.rotation.x = 0;
        CONTROLS.object.rotation.y = 0;
        CONTROLS.object.rotation.z = 0;
      }
      spectatingObjectiveCamera = false;
      spectateCameraInitialized = false;
      f1765();
      spectatorInterpState = {};
      CONTROLS.setCamPosOff();
      io.send("fpSp");
    } else {
      var v10761 = null;
      for (var v10762 = spectatingObjectiveCamera ? Game.map.manager.spectateCams[Game.activeObjective || 0] : Game.players.list, v10763 = Math.max(0, CONTROLS.spect.target ? v10762.indexOf(CONTROLS.spect.target) : 0), vLN01708 = 0; vLN01708 < v10762.length; ++vLN01708) {
        v10763 += p13431;
        if (v10763 >= v10762.length) {
          v10763 = 0;
        } else if (v10763 < 0) {
          v10763 = v10762.length - 1;
        }
        player = v10762[v10763];
        if (player && player.active && (!player.isBot || player.isBot && !Game.mode.botsAsAI)) {
          v10761 = player;
          break;
        }
      }
      if (CONTROLS.spect.target != v10761) {
        f1765();
        CONTROLS.spect.target = v10761;
        spectateCameraInitialized = false;
        if (!spectatingObjectiveCamera) {
          io.send("fpSp", v10761 ? v10761.sid : null);
        }
      }
    }
    window.noMouseInp = !!spectatingObjectiveCamera;
    f1766();
    RENDER.zoom(1);
    RENDER.aimRecticle.opacity = 0;
    aimRecticle.style.opacity = 0;
  }
};
function f1766(v10764) {
  var v10764 = CONTROLS.spect.target;
  if (!v10764) {
    specNames.style.display = "block";
    specStats.style.display = "none";
    specSUS.style.display = "none";
  } else {
    var v10765 = spectatorPlayerStats[v10764.sid] || {};
    var v10766 = (v10765.HP || 0) / (v10765.MHP || 100) * 100;
    specNames.style.display = "none";
    if (specStatsInner.innerHTML.length) {
      if (!specStatsInner.children[0].src.includes("icon_" + (v10764.classIndex || 0))) {
        specStatsInner.children[0].src = UTILS.assetsUrl("textures/classes/icon_" + (v10764.classIndex || 0) + ".png", true);
      }
      if (specStatsInner.children[1].id != "f_" + v10764.flagIndex) {
        specStatsInner.children[1].id = "f_" + v10764.flagIndex;
        specStatsInner.children[1].className = "specFlag" + (v10764.flagIndex > -1 ? " flag-icon flag-icon-" + Game.flags[v10764.flagIndex][1] : "");
      }
      if (specStatsInner.children[2].children[0].id != "lvl_" + v10764.levell) {
        specStatsInner.children[2].children[0].id = "lvl_" + v10764.level;
        specStatsInner.children[2].children[0].textContent = v10764.level;
        specStatsInner.children[2].children[0].style.color = "white";
      }
      if (specStatsInner.children[2].children[1].id != "s_" + v10764.sid) {
        specStatsInner.children[2].children[1].id = "s_" + v10764.sid;
        specStatsInner.children[2].children[1].innerHTML = v10764.alias + (v10764.clan ? "<span style='color:" + COLORS.getClanCol(v10764.clan, "rgba(255,255,255,0.5)") + "'> [" + v10764.clan + "]</span>" : "");
      }
      specStatsInner.children[2].children[2].style.display = v10764.featured ? "inline-block" : "none";
      spectHPV.textContent = (v10765.HP || 0) + " | " + (v10765.MHP || 100);
      spectHPBI.style.width = v10766 + "%";
      spectHPBI.style.backgroundColor = v10766 <= 30 ? SETTINGS.tmp.hudHealthLow : SETTINGS.tmp.hudHealthHigh;
    } else {
      var v10767 = "<img class='spectPIcon' src='" + UTILS.assetsUrl("textures/classes/icon_" + (v10764.classIndex || 0) + ".png", true) + "' /><span id='f_" + v10764.flagIndex + "' class='specFlag" + (v10764.flagIndex > -1 ? " flag-icon flag-icon-" + Game.flags[v10764.flagIndex][1] : "") + "'></span><div style='display:inline-block;width:200px;vertical-align:top'><div class='specLevelBox' id='lvl_" + v10764.level + "' style='color:white;'>" + v10764.level + "</div><span class='specPHead' id='s_" + v10764.sid + "'>" + v10764.alias + (v10764.clan ? "<span style='color:" + COLORS.getClanCol(v10764.clan, "rgba(255,255,255,0.5)") + "'> [" + v10764.clan + "]</span>" : "") + "</span><i class='material-icons specVerified' style='display:" + (v10764.featured ? "inline-block" : "none") + "'>check_circle</i><div id='spectHPB'><span id='spectHPV'>" + (v10765.HP || 0) + " | " + (v10765.MHP || 100) + "</span><div id='spectHPBI' style='width:" + v10766 + "%;" + ("background-color:" + (v10766 <= 30 ? SETTINGS.tmp.hudHealthLow : SETTINGS.tmp.hudHealthHigh)) + "'></div></div></div>";
      specStatsInner.innerHTML = v10767;
    }
    specSUS.style.display = currentKpdCase && currentKpdCase.sus == v10764.id ? "inline-block" : "none";
    specStats.style.display = "inline-block";
  }
}
function f1767(p13433, p13434, p13435) {
  if (!spectatorPlayerStats[p13433]) {
    spectatorPlayerStats[p13433] = {};
  }
  spectatorPlayerStats[p13433][p13434] = p13435;
  if (specStats.style.display == "inline-block") {
    f1766();
  }
}
const voiceChatFileReader = new FileReader();
var isVoiceRecording = false;
var canStartVoiceRecording = true;
var voiceChatQueues = {};
var voiceMediaRecorder;
var voiceRecordInterval;
function queueVoiceChatAudio(sourcePlayer, speakerName, audioDataUrl, volumeMultiplier, isFinalChunk, speakerAccountId) {
  if (SETTINGS.tmp.muteSpec && (sid == null || sourcePlayer && !sourcePlayer.active)) {
    return;
  }
  if (speakerAccountId != null && mutedVoiceAccountIds.includes(speakerAccountId)) {
    return;
  }
  if (!voiceChatQueues[speakerName]) {
    voiceChatQueues[speakerName] = [];
  }
  const v10773 = !!sourcePlayer && !!SETTINGS.tmp.voiceChatType;
  var v10774 = new Howl({
    src: [audioDataUrl],
    volume: SOUND.volumes[0] * volumeMultiplier * 2,
    onload: function () {
      if (!isFinalChunk && !(v10774.duration() <= config.voiceChatMaxLength * 1.2)) {
        f1769(speakerName, false, true);
      } else {
        v10774.on("end", function () {
          f1769(speakerName, isFinalChunk);
        });
        v10774.isReady = true;
        if (voiceChatQueues[speakerName] && voiceChatQueues[speakerName].indexOf(v10774) == 0) {
          if (v10773) {
            v10774.pos(v10774.srcObj.x, v10774.srcObj.y + v10774.srcObj.height - config.cameraHeight, v10774.srcObj.z);
            v10774.pannerAttr({
              refDistance: SETTINGS.tmp.voiceDistance,
              rolloffFactor: 1
            });
          }
          v10774.play();
        }
      }
    }
  });
  v10774.srcObj = sourcePlayer;
  voiceChatQueues[speakerName].push(v10774);
  window.updateWindow(23);
}
function f1769(p13442, p13443, p13444) {
  if (voiceChatQueues[p13442] && voiceChatQueues[p13442][0] && (p13444 ? voiceChatQueues[p13442].splice(voiceChatQueues[p13442].length - 1, 1) : voiceChatQueues[p13442].splice(0, 1), voiceChatQueues[p13442][0] && voiceChatQueues[p13442][0].isReady)) {
    var v10775 = voiceChatQueues[p13442][0];
    var v10776 = v10775.play();
    const v10777 = !!v10775.srcObj && !!SETTINGS.tmp.voiceChatType;
    if (v10777) {
      v10775.pos(v10775.srcObj.x, v10775.srcObj.y + v10775.srcObj.height - config.cameraHeight, v10775.srcObj.z);
    }
  }
  if (!voiceChatQueues[p13442] || !voiceChatQueues[p13442].length || !!p13443) {
    voiceChatQueues[p13442] = null;
    delete voiceChatQueues[p13442];
  }
  window.updateWindow(23);
}
function io_voiceChat(p13445, p13446, p13447, p13448, p13449, p13450, p13451) {
  if (SOUND.volumes[1] * p13449 > 0) {
    if (SETTINGS.tmp.streamMode) {
      p13446 = UTILS.scrambleS(p13446);
    }
    try {
      player = Game.players.findBySid(p13447);
      if (p13448 == -1 || p13448 == vLN02023) {
        queueVoiceChatAudio(player, p13446, p13445, SOUND.volumes[1] * p13449, p13450, p13451);
      }
    } catch (e122) {}
  }
}
voiceChatFileReader.addEventListener("load", function () {
  var v10778 = voiceChatFileReader.result;
  io.send("vc", v10778, vLN02023, SETTINGS.tmp.micVolume, parseInt(SETTINGS.tmp.micQuality));
});
window.toggleRecord = function (p13452) {
  if (document.activeElement.tagName == "INPUT") {
    return;
  }
  var v10779 = SETTINGS.tmp.voiceChatTrigger;
  var v10780 = !voiceIcon.classList.contains("voiceOff");
  if (v10779 == 0) {
    p13452 = p13452 == 1 ? ~~!v10780 : ~~!!v10780;
  }
  let vParseInt31 = parseInt(SETTINGS.tmp.micQuality);
  if (p13452 && !isVoiceRecording && canStartVoiceRecording) {
    navigator.mediaDevices.getUserMedia({
      audio: {
        deviceId: {
          exact: SETTINGS.tmp.audioInput
        }
      },
      video: false
    }).then(function (p13453) {
      canStartVoiceRecording = false;
      voiceIcon.classList.toggle("voiceOn", true);
      voiceIcon.classList.toggle("voiceOff", false);
      isVoiceRecording = true;
      voiceMediaRecorder = new MediaRecorder(p13453, {
        mimetype: "audio/ogg; codecs=opus",
        bitsPerSecond: vParseInt31
      });
      const vA596 = [];
      voiceMediaRecorder.addEventListener("dataavailable", function (p13454) {
        if (p13454.data.size > 0) {
          vA596.push(p13454.data);
        }
      });
      voiceMediaRecorder.addEventListener("stop", function () {
        var v10781 = new Blob(vA596, {
          type: "audio/ogg; codecs=opus"
        });
        voiceChatFileReader.readAsDataURL(v10781);
        vA596.length = 0;
      });
      voiceMediaRecorder.start();
      voiceRecordInterval = setInterval(function () {
        if (voiceMediaRecorder.state == "recording") {
          voiceMediaRecorder.stop();
        }
        if (isVoiceRecording) {
          voiceMediaRecorder.start();
        } else {
          voiceIcon.classList.toggle("voiceOn", false);
          voiceIcon.classList.toggle("voiceOff", true);
          if (voiceRecordInterval) {
            clearInterval(voiceRecordInterval);
          }
          canStartVoiceRecording = true;
        }
      }, config.voiceRate);
    }).catch(function () {
      isVoiceRecording = false;
      voiceIcon.classList.toggle("voiceOn", false);
      voiceIcon.classList.toggle("voiceOff", true);
      if (voiceRecordInterval) {
        clearInterval(voiceRecordInterval);
      }
    });
  } else if (!p13452 && isVoiceRecording && voiceMediaRecorder) {
    isVoiceRecording = false;
  }
};
function f1771(p13455) {
  infoHolder.style.display = null;
  aHolder.style.display = null;
  inGame = false;
  CONTROLS.idleTimer = 0;
  if (spinUI.style.display != "block") {
    UI.toggleMenu(true, p13455 === true);
    CONTROLS.toggle(false);
  }
}
window.updateSliderLabel = function (p13456, p13457) {
  var v10783 = document.getElementById("customSet" + p13456);
  if (v10783) {
    v10783.textContent = p13457;
  }
  var v10783 = document.getElementById("customSetPrev" + p13456);
  if (v10783) {
    v10783.textContent = p13457;
  }
};
window.updateSliderLabel2 = function (p13458, p13459, p13460, p13461) {
  var v10784 = document.getElementById("custom" + (p13458 == 0 ? "W" : p13458 == 2 ? "E" : "C") + "Set" + p13459 + "_" + p13460);
  if (v10784) {
    v10784.textContent = p13461;
  }
};
Object.defineProperty(window, "setSetting", {
  writeable: false,
  value: function (p13462, p13463, p13464, p13465, p13466) {
    SETTINGS.set(p13462, p13463, p13464, p13465, p13466);
  }
});
window.resetSettings = function () {
  if (confirm(i18n.t("settings.reset.confirm"))) {
    selectSettingPre(0, undefined, true);
    Object.keys(localStorage).filter(p13467 => p13467.includes("cont_")).forEach(p13468 => localStorage.removeItem(p13468));
    CONTROLS.resetBinds();
    showWindow(1, true);
  }
};
window.exportSettings = p13469 => SETTINGS.export(p13469);
window.importSettingsPopup = () => {
  genericPopup("<div class='pubHed'>Import Settings</div><div style='color:rgba(255,255,255,0.7);font-size:19px;text-align:center;margin-bottom:15px;'>Copy Paste Settings Text Here</div><textarea id='importTxt' rows='3' onkeydown='if(event.keyCode == 13) importSettings();'></textarea><div class='mapFndB' onclick='importSettings()' onmouseover='playTick(0.1)' style='margin-left: 0px;margin-top: 10px;background-color:#4ca9f5;width: 380px;'>Import</div>", "importPop");
  importTxt.focus();
};
window.importSettings = function () {
  var v10785 = document.getElementById("importTxt");
  if (v10785 && v10785.value.length) {
    SETTINGS.import(v10785.value);
  }
  clearPops();
};
function f1772(p13470) {
  var v10786 = null;
  if (Game && Game.classConfig[p13470].mdl && Game.classConfig[p13470].aID.length) {
    v10786 = UTILS.isString(Game.classConfig[p13470].aID) && Game.classConfig[p13470].aID.includes("c") ? parseInt(Game.classConfig[p13470].aID.replace(/[^\d]/g, "")) : null;
  }
  if (v10786 > 0) {
    return UTILS.userAssetsUrl("/" + v10786 + "/icon.png");
  } else {
    return UTILS.assetsUrl("/textures/classes/icon_" + p13470 + ".png");
  }
}
function f1773() {
  f1781(menuMiniProfilePic, account ? account.id : null, account && account.premiumT > 0, f1772(tmpPlayer ? tmpPlayer.classIndex : classIndex));
  f1781(bottomLeftClassImg, account ? account.id : null, account && account.premiumT > 0, f1772(tmpPlayer ? tmpPlayer.classIndex : classIndex));
}
var v10787 = getSavedVal("preIndex") || 2;
window.selectSettingPre = function (p13471, p13472, p13473) {
  if (v10787 != p13471) {
    if (p13471 == 0) {
      if (!p13473 && !confirm(i18n.t("settings.reset.confirm"))) {
        let v10788 = document.getElementById("settingsPreset");
        [...v10788.children].forEach(p13474 => {
          p13474.selected = p13474.value == v10787;
        });
        return;
      }
      var v10789 = {};
      Object.keys(SETTINGS.list).forEach(function (p13475) {
        if (v10787 == 2 && SETTINGS.list[p13475].val != SETTINGS.list[p13475].def) {
          v10789[p13475] = SETTINGS.list[p13475].val;
        }
        setSetting(p13475, SETTINGS.list[p13475].def, true);
      });
      if (v10787 == 2) {
        saveVal("krk_customPre", JSON.stringify(v10789));
      }
    } else if (p13471 == 1 || p13471 == 3) {
      var v10789 = {};
      Object.keys(SETTINGS.list).forEach(function (p13476) {
        if (v10787 == 2) {
          v10789[p13476] = SETTINGS.list[p13476].val;
        }
        setSetting(p13476, SETTINGS.list[p13476][p13471 == 1 ? "pro" : "perf"] == null ? SETTINGS.list[p13476].def : SETTINGS.list[p13476][p13471 == 1 ? "pro" : "perf"], true);
      });
      if (v10787 == 2) {
        saveVal("krk_customPre", JSON.stringify(v10789));
      }
    } else if (p13471 == 2 && !p13472) {
      try {
        var v10789 = JSON.parse(getSavedVal("krk_customPre") || "{}");
        for (var v10790 in v10789) {
          if (SETTINGS.list[v10790]) {
            setSetting(v10790, v10789[v10790], true);
          }
        }
        CONTROLS.checkScroll();
      } catch (e123) {
        alert(e123);
      }
    }
    v10787 = p13471;
    saveVal("preIndex", v10787);
    if (!p13473) {
      showWindow(1, true);
    }
  }
};
window.aspectSelect = function (p13477, p13478) {
  var v10791 = p13478.selectedIndex - 1;
  var v10792 = document.getElementById("slid_" + p13477);
  if (v10792) {
    if (v10791 == 0) {
      v10792.value = "";
    } else {
      v10792.value = config.customRatios[v10791];
    }
  }
  p13478.selectedIndex = 0;
  setSetting(p13477, v10792.value);
};
var vO346 = {};
window.delayExecute = function (p13479, p13480, p13481 = 600) {
  clearTimeout(vO346[p13479]);
  vO346[p13479] = requestAnimationFrame(function () {
    setSetting(p13479, p13480.value);
  }, p13481);
  return true;
};
var vO347 = {};
window.delayExecute2 = function (p13482, p13483, p13484, p13485 = 600) {
  clearTimeout(vO347[p13482 + "_" + p13483]);
  vO347[p13482 + "_" + p13483] = requestAnimationFrame(function () {
    setShaderInput(p13482, p13483, p13484.value);
  }, p13485);
  return true;
};
Object.defineProperty(window, "setShaderInput", {
  writeable: false,
  value: function (p13486, p13487, p13488) {
    var v10793 = RENDER.shaderInputs[p13486];
    if (v10793) {
      v10793 = RENDER.shaderInputs[p13486][p13487];
      if (v10793) {
        if (p13488 == "false") {
          p13488 = false;
        }
        if (p13488 == "true") {
          p13488 = true;
        }
        if (v10793.min || v10793.max) {
          p13488 = Math.min(v10793.max, Math.max(v10793.min, +p13488));
        }
        if (v10793.toggle) {
          p13488 = ~~!!p13488;
        }
        if (document.getElementById("shader_" + p13486 + "_" + p13487)) {
          document.getElementById("shader_" + p13486 + "_" + p13487).value = p13488;
        }
        if (document.getElementById("shader_input_" + p13486 + "_" + p13487)) {
          document.getElementById("shader_input_" + p13486 + "_" + p13487).value = p13488;
        }
        RENDER.shaderInputs[p13486][p13487].val = p13488;
        if (p13487 == 0) {
          RENDER.postprocessing.composer.passes[RENDER.postprocessing.composer.passes.length - RENDER.shaderInputs.length + p13486].enabled = !!p13488;
        } else {
          RENDER.postprocessing.composer.passes[RENDER.postprocessing.composer.passes.length - RENDER.shaderInputs.length + p13486].uniforms[v10793.name].value = p13488;
        }
      }
    }
  }
});
Object.defineProperty(window, "focusChat", {
  writeable: false,
  value: function (p13489) {
    if (SETTINGS.tmp.shwChat == 1) {
      chatList.style.display = p13489 ? "block" : "none";
    }
  }
});
window.changeCont = function (p13490, p13491, p13492) {
  showWindow(7, true);
  CONTROLS.inputChanger = [p13490, p13491, p13492];
  document.getElementById("cont" + p13490 + (p13492 == null ? "" : "_" + p13492) + (p13491 ? "_alt" : "")).innerHTML = i18n.t("settings.controls.press");
};
window.changeContSet = function (p13493, p13494) {
  CONTROLS.toggleSets[p13493] = p13494;
  saveVal("cont_" + (p13493 + 27) + "_set", p13494);
  showWindow(7, true);
};
window.changeContMsg = function (p13495, p13496) {
  p13496 = filterCM(p13496);
  CONTROLS.chatMessages[p13495] = p13496;
  saveVal("cont_" + (p13495 + 43) + "_set", p13496);
};
window.unbindCont = function (p13497, p13498, p13499) {
  showWindow(7, true);
  CONTROLS.inputChanger = null;
  document.getElementById("cont" + p13497 + (p13499 == null ? "" : "_" + p13499) + (p13498 ? "_alt" : "")).innerHTML = "UNBOUND";
  CONTROLS.updateBind(p13497, p13498, p13499, -1);
};
window.resetCont = function (p13500, p13501, p13502) {
  showWindow(7, true);
  CONTROLS.inputChanger = null;
  CONTROLS.resetBind(p13500, p13501, p13502);
  document.getElementById("cont" + p13500 + (p13502 == null ? "" : "_" + p13502) + (p13501 ? "_alt" : "")).innerHTML = UTILS.getKeyName(p13502 == null ? CONTROLS.binds[p13500].val : CONTROLS.binds[p13500][p13502].val);
};
window.updateKeybindUI = function (p13503, p13504) {
  if (p13503 == "reset" || p13504) {
    speedRunRstKey.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.reset.val) + "]";
  }
  if (p13503 == "resetLast" || p13504) {
    speedRunRstLKey.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.resetLast.val) + "]";
  }
  if (p13503 == "kickVoteY" || p13504) {
    kickVoteY.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.kickVoteY.val) + "]";
  }
  if (p13503 == "kickVoteN" || p13504) {
    kickVoteN.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.kickVoteN.val) + "]";
  }
  if (p13503 == "specObj" || p13504) {
    specObjCam.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.specObj.val) + "]";
  }
  if (p13503 == "specFree" || p13504) {
    specFreeCam.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.specFree.val) + "]";
  }
  if (p13503 == "specNames" || p13504) {
    specNamesF.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.specNames.val) + "]";
  }
  if (p13503 == "specFirst" || p13504) {
    specFirstP.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.specFirst.val) + "]";
  }
  if (p13503 == "specFocus" || p13504) {
    specFocus.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.specFocus.val) + "]";
  }
  if (p13503 == "kpdVision" || p13504) {
    kpdVision.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.kpdVision.val) + "]";
  }
  if (p13503 == "kpdVoteY" || p13504) {
    kpdVoteY.lastChild.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.kpdVoteY.val) + "]";
  }
  if (p13503 == "kpdVoteN" || p13504) {
    kpdVoteN.lastChild.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.kpdVoteN.val) + "]";
  }
  if (p13503 == "taunt0" || p13504) {
    taunt0.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.taunt[0].val) + "]";
  }
  if (p13503 == "taunt1" || p13504) {
    taunt1.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.taunt[1].val) + "]";
  }
  if (p13503 == "taunt2" || p13504) {
    taunt2.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.taunt[2].val) + "]";
  }
  if (p13503 == "taunt3" || p13504) {
    taunt3.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.taunt[3].val) + "]";
  }
  if (p13503 == "taunt4" || p13504) {
    taunt4.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.taunt[4].val) + "]";
  }
  if (p13503 == "taunt5" || p13504) {
    taunt5.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.taunt[5].val) + "]";
  }
  if (p13503 == "propRand" || p13504) {
    pickRandProp.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.propRand.val) + "]";
  }
  if (p13503 == "prop" || p13504) {
    pickProp.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.prop.val) + "]";
  }
  if (p13503 == "propRot" || p13504) {
    rotProp.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.propRot.val) + "]";
  }
  if (p13503 == "propRotR" || p13504) {
    rotRProp.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.propRotR.val) + "]";
  }
  if (p13503 == "specMiniMap" || p13504) {
    specMinimap.innerHTML = "[" + UTILS.getKeyName(CONTROLS.binds.specMiniMap.val) + "]";
  }
};
window.canAfford = function (p13505) {
  return account && account.funds >= p13505;
};
function io_updateAccount(p13506) {
  if (account) {
    account.setData(p13506);
    account.activeChallenges = Game.challenges.updateNames(account.activeChallenges, i18n);
  }
  updateWindow(5);
  updateMenuAccountData();
  updateSprayWheel(true);
}
window.refreshMenuAcc = function () {
  updateMenuAccountData();
  updateClassPreview();
};
window.updateMenuAccountData = function () {
  if (account) {
    signedOutHeaderBar.style.display = "none";
    signedInHeaderBar.style.display = null;
    if (account.level >= config.rewardMinLvl) {
      updateRewardTimer();
    }
    menuAccountUsername.textContent = account.premiumT && SETTINGS.tmp.premiumBadge ? account.alias : account.name;
    menuKRCount.innerHTML = UTILS.commaNumber(account.funds) + " <span style='color:#fbc02d'>KR</span>";
    menuJNKCount.innerHTML = UTILS.commaFloat(parseFloat(account.junk || 0).toFixed(2)) + "<span class='material-icons' style='color:#cc51f8;font-size:27px;margin-left:5px;vertical-align:top;margin-right:-5px;'>plumbing</span>";
    menuLevelBar.style.width = account.levelProg + "%";
    mLevelContV.textContent = account.level || 1;
    if (signedInHeaderBar.offsetWidth) {
      signedInHeaderBar.style.borderRadius = "0px";
    }
  } else {
    signedOutHeaderBar.style.display = null;
    signedInHeaderBar.style.display = "none";
  }
};
function io_updateSettings(p13507) {
  if (p13507 && p13507 != "") {
    try {
      JSON.parse(p13507);
    } catch (e124) {
      return io_showPopup(null, i18n.t("settings.loaded.none"));
    }
    SETTINGS.import(p13507);
    io_showPopup("SUCCESS", null, i18n.t("settings.loaded"));
  } else {
    io_showPopup(null, i18n.t("settings.loaded.none"));
  }
}
window.uploadSettings = function () {
  if (account) {
    io_loadingPopup("Loading...");
    io.send("uploadS", exportSettings(true));
    return;
  } else {
    return io_showPopup(null, i18n.t("account.login.required"));
  }
};
window.fetchSettings = function () {
  if (account) {
    io.send("getS");
    return;
  } else {
    return io_showPopup(null, i18n.t("account.login.required"));
  }
};
var v10794 = null;
function setInstructionSubtitle(p13508) {
  if (io.connected && p13508 != v10794) {
    v10794 = inGame || CONTROLS.locked || endMidHolder.style.display == "inline-block" ? null : p13508;
    f2042();
  }
}
var v10795;
function f1777() {
  v10795 = COLORS.ping.low;
  if (currentPing >= 150) {
    v10795 = COLORS.ping.high;
  } else if (currentPing >= 50) {
    v10795 = COLORS.ping.medium;
  }
  pingText.textContent = currentPing == -1 ? "-" : currentPing;
  if (pingText.style.color != v10795) {
    pingText.style.color = v10795;
  }
  if (menuHolder.style.display != "none") {
    menuPingText.textContent = currentPing == -1 ? "-" : currentPing;
    if (menuPingIcon.style.color != v10795) {
      menuPingIcon.style.color = v10795;
    }
  }
}
function f1778() {
  ingressPacketCount.textContent = io.ingressPacketCount + " P/s";
  ingressDataSize.textContent = (io.ingressDataSize / 1000).toFixed(2) + " KB/s";
  egressPacketCount.textContent = io.egressPacketCount + " P/s";
  egressDataSize.textContent = (io.egressDataSize / 1000).toFixed(2) + " KB/s";
  tickPacketCount.textContent = io.tickPacketCount + " TPS";
  // BUG: can't pick pro preset in offline mode
  if (io.resetPacketTally) io.resetPacketTally();
}
const vA597 = [];
let vLN01709 = 0;
let v10796;
function updateFpsCounter() {
  if (SETTINGS.tmp.showFPS) {
    while (vA597.length > 0 && vA597[0] <= gameTime - 1000) {
      vA597.shift();
    }
    vA597.push(gameTime);
    v10796 = vA597.length;
    if (v10796 && gameTime - vLN01709 >= SETTINGS.tmp.fpsRate) {
      vLN01709 = gameTime;
      ingameFPS.textContent = v10796;
      if (menuHolder.style.display != "none") {
        menuFPS.textContent = v10796;
      }
    }
  }
}
function io_announcement(p13509) {
  io_showPopup("INFO", null, p13509 || config.accAnnounce);
}
function f1781(p13510, p13511, p13512, p13513) {
  var v10797 = null;
  if (Game && Game.classConfig[classIndex].mdl && Game.classConfig[classIndex].aID.length) {
    v10797 = UTILS.isString(Game.classConfig[classIndex].aID) && Game.classConfig[classIndex].aID.includes("c") ? parseInt(Game.classConfig[classIndex].aID.replace(/[^\d]/g, "")) : null;
  }
  p13510.setAttribute("onerror", "this.onerror=null;this.src=\"" + p13513 + "\";");
  p13510.src = v10797 > 0 ? UTILS.userAssetsUrl("/" + v10797 + "/icon.png") : p13512 > 0 ? UTILS.userAssetsUrl("/p" + p13511 + "/profile.png") : p13513;
}
var loginToken = null;
var v10799 = false;
var vF17344 = getParam("ref", 0);
function f1782() {
  if (vF17344 && !getSavedVal("krunker_username")) {
    showWindow(5);
  }
}
function showAccountResponse(p13514) {
  try {
    accResp.innerHTML = p13514 || "";
    accResp.style.display = p13514 ? "block" : "none";
  } catch (e125) {}
}
function accountAction(p13515, p13516, p13517) {
  v10799 = p13515 == 0;
  if (p13515 >= 0) {
    showAccountResponse(i18n.t("generic.wait"));
  }
  io.send("a", p13515, p13516, p13517);
}
function io_accountResponse(p13518, p13519, p13520, p13521, p13522) {
  friendCon.innerHTML = "";
  if (p13518) {
    showAccountResponse(p13518);
  } else {
    if (v10799) {
      window.gradualMenuProgress(1);
      saveVal("krunker_new", 1);
    } else if (window.isNewUserReturning) {
      window.gradualMenuProgress(window.gradualMenuStage || 1);
    } else {
      window.fullMenu();
      deleteVal("krunker_new");
    }
    v10799 = false;
    saveVal("krunker_haslogin", true);
    if (window.getSavedVal("krunker_id") != p13519) {
      clearSavedAccountState();
    }
    account = new Account(p13519, p13520, null);
    saveVal("krunker_id", p13519);
    saveVal("krunker_username", p13520);
    io_updateAccount(p13521);
    window.totalLogins = getSavedVal("total_logins") || 0;
    window.totalLogins++;
    saveVal("total_logins", window.totalLogins);
    account.activeChallenges = Game.challenges.updateNames(account.activeChallenges, i18n);
    if (account.hack) {
      window.activeHacker = true;
    }
    if (p13522) {
      saveVal("krunker_token", p13522);
      loginToken = p13522;
    }
    if (window.hasOwnProperty("KrunkerAppLogin")) {
      window.KrunkerAppLogin.postMessage(p13522 || null);
    }
    if (account && v10537 && v10538) {
      io.send("vtw", v10538);
    } else {
      window.updateWindow(null, true);
      updateClassPreview();
      f1773();
      if (config.hideLoginWindowAfterLogin) {
        UI.toggleWindow(false);
      }
      if (account.hack) {
        genericPopup("<div style='text-align:center'><div style='font-size:80px;color:#eb3434'>BANNED</div><div style='color:#fff'>" + i18n.t("account.banned.hack") + "</div><div style='color:#fff'>" + i18n.t("account.banned.appeal") + "</div><div style='margin-top:10px;color:#3483eb'>krunker+banappeal@frvr.com</div><div style='height:10px'></div></div>", "contPop");
      } else {
        Object(vP132243.navigateBack)();
        if (getSavedVal("2390v")) {
          io.send("svyb", parseInt(getSavedVal("2390v")));
          deleteVal("2390v");
        }
        if (account.premiumT > 0) {
          aHider.style.display = "none";
          topRightAdHolder.style.display = "none";
        }
        if (config.differentStorePopups) {
          window.totalLogins = parseInt(getSavedVal("total_logins")) || 0;
          if (window.totalLogins % 3 == 1) {
            showWindow(14);
            windows[13].switchTab(1);
          }
          if (window.totalLogins % 3 == 2) {
            showWindow(14);
            windows[13].switchTab(3);
          }
        }
      }
      newUserGuide.style.display = account.level > 20 ? "none" : "";
    }
    f2076();
  }
}
window.registerAcc = function () {
  var v10800 = document.getElementById("accName") || {};
  var v10801 = document.getElementById("accPass") || {};
  showAccountResponse(i18n.t("generic.wait"));
  f1732("register", function (p13523, p13524) {
    if (p13524) {
      showAccountResponse("Please try again.");
    } else {
      logEventFRVR("account_register");
      accountAction(0, [v10800.value, v10801.value, vF17344], p13523);
    }
  });
};
function f1786() {
  if (!vF17344 && !v10537) {
    loginToken = getSavedVal("krunker_token");
    var currentUsername = getSavedVal("krunker_username");
    if (loginToken && currentUsername) {
      accountAction(1, [currentUsername, null, loginToken]);
    }
    m.redraw();
    let v10802 = Date.now();
    saveVal("krunker_last", v10802);
    requestAnimationFrame(() => io.send("sb", "welc", currentUsername));
  }
}
Object.defineProperty(window, "loginAcc", {
  writeable: false,
  value: function () {
    var usernameInput = document.getElementById("accName") || {};
    var passwordInput = document.getElementById("accPass") || {};
    logEventFRVR("account_login");
    accountAction(1, [usernameInput.value, passwordInput.value, null], null);
  }
});
Object.defineProperty(window, "logoutAcc", {
  writeable: false,
  value: function (skipClassWindow) {
    accountAction(-1);
    showAccountResponse();
    clearSavedAccountState();
    selectSecondary(2, skipClassWindow);
    io_updateAccount();
    showWindow(5);
    updateClassPreview();
    updateSprayWheel(true);
    clearSpinHistory();
  }
});
function clearSavedAccountState() {
  deleteVal("krunker_id");
  deleteVal("krunker_username");
  deleteVal("krunker_token");
  deleteVal("skins");
  deleteVal("hatIndex");
  deleteVal("headIndex");
  deleteVal("playerCardIndex");
  deleteVal("waistIndex");
  deleteVal("bodyIndex");
  deleteVal("backIndex");
  deleteVal("meleeIndex");
  deleteVal("skinColIndex");
  deleteVal("hairCol");
  deleteVal("chatCol");
  deleteVal("dyeIndex");
  deleteVal("faceIndex");
  deleteVal("shoeIndex");
  deleteVal("petIndex");
  deleteVal("classindex");
  deleteVal("secondaryInd");
  deleteVal("krunker_last_with_login");
  hatIndex = -1;
  headIndex = -1;
  playerCardIndex = -1;
  waistIndex = -1;
  bodyIndex = -1;
  backIndex = -1;
  meleeIndex = -1;
  skinColIndex = -1;
  hairCol = -1;
  chatCol = -1;
  dyeIndex = -1;
  faceIndex = -1;
  shoeIndex = -1;
  petIndex = -1;
  skinsLoadout = {};
  selectedCharms = [];
  windows[12].clanData = null;
  windows[4].drops = null;
  loginToken = null;
  account = null;
  friends = null;
  accountStateFlag = false;
}
var v10805 = false;
window.newTok = function (p13526) {
  if (p13526) {
    saveVal("krunker_token", p13526);
    loginToken = p13526;
  }
};
window.logoutSessions = function (p13527) {
  if (p13527) {
    p13527.style.display = "none";
  }
  v10805 = true;
  io.send("las");
};
Object.defineProperty(window, "requestDeletion", {
  writeable: false,
  value: function (p13528) {
    var v10806 = "<div style='color:#fff;font-size:20px;position:relative;margin-bottom:15px;'>" + (p13528 ? i18n.t("account.delete.request") + "</div>" : i18n.t("account.delete.cancel") + "</div>") + "<div id='confirmBtn' onclick='requestConfirm(" + p13528 + ")' onmouseover='playTick(0.1)'>YES</div><div id='declineBtn' onclick='clearPops()' onmouseover='playTick(0.1)'>NO</div>";
    genericPopup(v10806, "confPop");
  }
});
window.requestConfirm = function (p13529) {
  io.send("rqd", p13529);
  account.reqDel = p13529;
  clearPops();
  updateWindow(5);
};
Object.defineProperty(window, "changePass", {
  writeable: false,
  value: function () {
    newPRes.innerHTML = "Please wait...";
    io.send("upp", oldPass.value, newPass.value, repNPass.value);
  }
});
function io_newPassResponse(p13530, p13531) {
  if (p13531 && p13531.length > 0) {
    window.newTok(p13531);
  }
  newPRes.innerHTML = p13530;
}
window.onKeyDown2FA = p13532 => {
  if (window.event.keyCode == 13) {
    var v10807 = document.getElementsByClassName("twoFAIn");
    if (v10807) {
      var vLN01710 = 0;
      [...v10807].forEach(p13533 => {
        vLN01710 += p13533.value.length;
      });
      if (vLN01710 < config.twoFAKeyLen) {
        event.preventDefault();
      } else {
        twoFAbtn.click();
      }
    }
  }
  if (window.event.keyCode == 8) {
    event.preventDefault();
    if (!p13532.value.length && p13532.previousElementSibling) {
      p13532.previousElementSibling.focus();
      if (p13532.previousElementSibling) {
        p13532.previousElementSibling.value = "";
      }
    } else {
      p13532.value = "";
    }
  }
};
window.onInput2FA = p13534 => {
  if (window.event.inputType == "deleteContentBackward") {
    if (!p13534.value.length && p13534.previousElementSibling) {
      p13534.previousElementSibling.focus();
    }
  } else if (p13534.nextElementSibling) {
    if (p13534.value.length > 1) {
      p13534.value = p13534.value.slice(-1);
    }
    p13534.nextElementSibling.focus();
  } else {
    twoFAbtn.click();
  }
};
var v10808 = null;
function f1789(p13535) {
  var vLS44 = "";
  for (var vLN01711 = 0; vLN01711 < p13535; ++vLN01711) {
    vLS44 += "<input class='twoFAIn' type='number' min='0' max='9'\n\t\t\tmaxlength='1' placeholder=' ' oninput='onInput2FA(this);'\n\t\t\tonkeydown='onKeyDown2FA(this);' " + (vLN01711 == 0 ? "autofocus" : "") + ">";
  }
  return vLS44;
}
Object.defineProperty(window, "twoFAres", {
  writeable: false,
  value: function (p13536, p13537, p13538, p13539) {
    v10808 = p13537;
    clearPops();
    if (p13536) {
      if (p13536 == 1) {
        twoFAPop.style.display = "none";
      } else if (p13536 == 2 && account) {
        account.twoFA = p13539;
        updateWindow(5);
      }
    } else {
      twoFAPop.style.display = "block";
      twoFAbtn.innerHTML = "Submit";
      twoFAbtn.className = "twoFAbtn";
      twoFAForm.innerHTML = f1789(config.twoFAKeyLen);
      if (p13538) {
        QrCode.toDataURL(p13538, function (p13540, p13541) {
          twoFAqr.style.display = "block";
          twoFAqr.lastElementChild.src = p13541;
        });
      }
    }
  }
});
Object.defineProperty(window, "act2FA", {
  writeable: false,
  value: function () {
    io.send("a2FA");
  }
});
Object.defineProperty(window, "dact2FA", {
  writeable: false,
  value: function () {
    io.send("d2FA");
  }
});
Object.defineProperty(window, "sub2FA", {
  writeable: false,
  value: function () {
    var vLS45 = "";
    var v10809 = document.getElementsByClassName("twoFAIn");
    for (var vLN01712 = 0; vLN01712 < config.twoFAKeyLen; ++vLN01712) {
      if (v10809 && v10809[vLN01712] && v10809[vLN01712].value && v10809[vLN01712].value.length == 1) {
        vLS45 += v10809[vLN01712].value;
      }
    }
    if (vLS45.length == config.twoFAKeyLen) {
      twoFAbtn.innerHTML = "...";
      twoFAbtn.className = "twoFAbtnN";
      io.send(v10808 || "2fa", vLS45);
    }
  }
});
var v10810 = null;
var v10811 = false;
function f1790() {
  if (!v10811) {
    v10811 = true;
    networkLag.style.display = "block";
    v10810 = requestAnimationFrame(function () {
      f1791();
    }, 10000);
  }
}
function f1791() {
  networkLag.style.display = "none";
  if (v10810) {
    clearTimeout(v10810);
    v10810 = null;
  }
}
var vLN01713 = 0;
var v10812 = false;
var v10813 = Date.now();
function f1792() {
  const v10814 = config.rewardTime - ((gameTime || Date.now()) - parseInt(account && account.lastReward || 0));
  if (v10814 < 0) {
    return 0;
  } else {
    return v10814;
  }
}
function updateRewardTimer() {
  vLN01713 = f1792();
}
function f1794() {
  if (!v10537 && !v10538 && !isMobileClient()) {
    updateRewardTimer();
    v10812 = !!(vLN01713 <= 0) && !v10514;
    if (v10812) {
      freeKRAuto();
    }
  }
}
window.freeKRAuto = function (p13542) {};
window.freeKRPopup = function () {
  if (!(Date.now() - lastPriorityPopupTime <= config.priorityPopTimer) && menuHolder.style.display != "none" && bundlePop.style.display != "block") {
    genericPopup("<div style='text-align:center'><div style='margin-top:210px;'><div class='button buttonCL buttonP' style='border: 6px solid #b447ff !important;height: 40px;background-color: rgba(0, 0, 0, 0.55);' onmouseenter='playTick(0.1);' onclick='playSelect(0.1);claimReward();'>CLAIM KR</div></div></div>", "claimPop");
    v10813 = Date.now();
    logEventFRVR("pop_up", {
      label: "free_kr"
    });
  }
};
window.accountCreatePopup = function () {
  genericPopup("<div id=\"acpImg\">\n\t\t\t<div id=\"acpImgBack\"></div>\n\t\t\t<div id=\"acpImgFront\"></div>\n\t\t\t<div id=\"acpImgGrad\"></div>\n\t\t</div>\n\t\t<div id=\"acpText\">\n\t\t\t<div id=\"acpHeader\">Tired of watching these Ads?</div>\n\t\t\t<div id=\"acpInfo\">Register and get rid of these ads on Krunker!</div>\n\t\t</div>\n\t\t<div id=\"acpButtonHolder\">\n\t\t\t<div class='button buttonP acpButton'\n\t\t\t\tstyle='border: 2px solid var(--yellow) !important'\n\t\t\t\tonclick='playSelect(0.1);clearPops();showWindow(5);'>Register</div>\n\t\t\t<div class='button buttonP acpButton'\n\t\t\t\tonclick='playSelect(0.1);clearPops();'>I like Ads</div>\n\t\t</div>", "accountCreatePop");
};
window.claimReward = function () {
  if (!isMobileClient()) {
    clearPops();
    if (!(vLN01713 > 0)) {
      logEventFRVR("btn_click", {
        label: "free_kr"
      });
      io.send("sfkr");
      showAd({
        onComplete: () => {
          logEventFRVR("win_open", {
            destination: "spin_free",
            source: "free_kr"
          });
          prizeWheel(4);
        },
        onShow: () => io.send("lfkr"),
        onError: p13543 => {
          io.send("fkrf");
          if (p13543 != "skipped") {
            alert(i18n.t(p13543));
          }
        }
      });
    }
  }
};
window.customizeExport = function () {
  var vO348 = {};
  if (customReticles.length) {
    vO348.reticles = customReticles;
  }
  if (customScopes.length) {
    vO348.scopes = customScopes;
  }
  if (customImages.length) {
    vO348.images = customImages;
  }
  if (favoriteItemIds.length) {
    vO348.favorites = favoriteItemIds;
  }
  let vGetSavedVal6 = getSavedVal("krk_loadouts");
  vGetSavedVal6 = vGetSavedVal6 ? JSON.parse(vGetSavedVal6) : {};
  if (Object.keys(vGetSavedVal6).length) {
    vO348.loadouts = vGetSavedVal6;
  }
  return vO348;
};
Object.defineProperty(window, "setClassIndex", {
  writeable: false,
  value: function (p13544) {
    classIndex = Game.classes[p13544] ? p13544 : 0;
    if (window.selectFace && faceIndex > 0) {
      let v10815 = Game.store.skins[faceIndex].name;
      if (v10815 !== Game.classConfig[p13544].name) {
        let v10816 = Game.classConfig.find(p13545 => {
          if (p13545.name === v10815) {
            return true;
          }
        });
        if (v10816) {
          window.selectFace(-1);
        }
      }
    }
  }
});
var vLN1150 = 1;
var skinColIndex = getSavedVal("skinColIndex") || -1;
var hairCol = getSavedVal("hairCol") || -1;
var chatCol = getSavedVal("chatCol") || -1;
var dyeIndex = getSavedVal("dyeIndex") || -1;
var faceIndex = getSavedVal("faceIndex") || -1;
var shoeIndex = getSavedVal("shoeIndex") || -1;
var attachIndex = getSavedVal("attachIndex") || 0;
var reticleIndex = getSavedVal("reticleIndex") || 0;
var savedReticle = getSavedVal("savedReticle") || "";
updateAimDot(reticleIndex, sanitizeCustomImageUrl(savedReticle));
var scopeIndex = getSavedVal("scopeIndex") || 0;
var savedScope = getSavedVal("savedScope") || "";
updateScope(scopeIndex, sanitizeCustomImageUrl(savedScope));
var meleeIndex = getSavedVal("meleeIndex") || -1;
var bodyIndex = getSavedVal("bodyIndex") || -1;
var backIndex = getSavedVal("backIndex") || -1;
var hatIndex = getSavedVal("hatIndex") || -1;
var headIndex = getSavedVal("headIndex") || -1;
var playerCardIndex = getSavedVal("playerCardIndex") || -1;
var waistIndex = getSavedVal("waistIndex") || -1;
var petIndex = getSavedVal("petIndex") || -1;
var wristIndex = getSavedVal("wristIndex") || -1;
var savedSkins = getSavedVal("skins");
var skinsLoadout = savedSkins ? JSON.parse(savedSkins) : {};
var savedCharms = getSavedVal("charms");
var selectedCharms = savedCharms ? JSON.parse(savedCharms) : [];
setClassIndex(getSavedVal("classindex") || 0);
var secondaryIndex = getSavedVal("secondaryInd") || 2;
var pcStatIndex = getSavedVal("pcStatIndex") || -1;
var activeSkinSel = 0;
var vLN01715 = 0;
function f1795(p13546, p13547, p13548) {
  if (!UTILS.isNumber(p13547)) {
    p13547 = p13548 == null ? -1 : p13548;
  }
  if (!Game.streaks[p13547]) {
    p13547 = -1;
  }
  if (Game.streaks[p13547] && Game.streaks[p13547].slot != p13546) {
    p13547 = -1;
  }
  return p13547;
}
var streakIndex1 = parseInt(getSavedVal("streakIndex1"));
streakIndex1 = f1795(0, streakIndex1);
var streakIndex2 = parseInt(getSavedVal("streakIndex2"));
streakIndex2 = f1795(1, streakIndex2);
var streakIndex3 = parseInt(getSavedVal("streakIndex3"));
streakIndex3 = f1795(2, streakIndex3, 0);
function f1796(p13549, p13550) {
  if (inGame && account && account.isDev && p13550 && SETTINGS.list.forceUpdate.val) {
    io.send("prmA", 10, [p13549, ...(Array.isArray(p13550) ? p13550 : [p13550]), !!SETTINGS.list.forceRegen.val]);
  }
}
Object.defineProperty(window, "selectHat", {
  writeable: false,
  value: function (p13551, p13552, p13553) {
    saveVal("hatIndex", p13551);
    hatIndex = p13551;
    updateClassPreview();
    if (!p13552) {
      showWindow(3);
    }
    if (p13553) {
      updateWindow(3);
    }
    f1796("hat", p13551);
  }
});
Object.defineProperty(window, "selectHead", {
  writeable: false,
  value: function (p13554, p13555, p13556) {
    saveVal("headIndex", p13554);
    headIndex = p13554;
    updateClassPreview();
    if (!p13555) {
      showWindow(3);
    }
    if (p13556) {
      updateWindow(3);
    }
    f1796("head", p13554);
  }
});
Object.defineProperty(window, "selectPlayerCard", {
  writeable: false,
  value: function (p13557, p13558, p13559) {
    saveVal("playerCardIndex", p13557);
    playerCardIndex = p13557;
    updateClassPreview();
    if (!p13558) {
      showWindow(3);
    }
    if (p13559) {
      updateWindow(3);
    }
    f1796("playercard", p13557);
  }
});
Object.defineProperty(window, "selectBody", {
  writeable: false,
  value: function (p13560, p13561, p13562) {
    saveVal("bodyIndex", p13560);
    bodyIndex = p13560;
    updateClassPreview();
    if (!p13561) {
      showWindow(3);
    }
    if (p13562) {
      updateWindow(3);
    }
    f1796("body", p13560);
  }
});
Object.defineProperty(window, "selectBack", {
  writeable: false,
  value: function (p13563, p13564, p13565) {
    saveVal("backIndex", p13563);
    backIndex = p13563;
    updateClassPreview();
    if (!p13564) {
      showWindow(3);
    }
    if (p13565) {
      updateWindow(3);
    }
    f1796("back", p13563);
  }
});
Object.defineProperty(window, "selectWaist", {
  writeable: false,
  value: function (p13566, p13567, p13568) {
    saveVal("waistIndex", p13566);
    waistIndex = p13566;
    updateClassPreview();
    if (!p13567) {
      showWindow(3);
    }
    if (p13568) {
      updateWindow(3);
    }
    f1796("waist", p13566);
  }
});
Object.defineProperty(window, "selectPet", {
  writeable: false,
  value: function (p13569, p13570, p13571) {
    saveVal("petIndex", p13569);
    petIndex = p13569;
    updateClassPreview();
    if (!p13570) {
      showWindow(3);
    }
    if (p13571) {
      updateWindow(3);
    }
    f1796("pet", p13569);
  }
});
Object.defineProperty(window, "selectWrist", {
  writeable: false,
  value: function (p13572, p13573, p13574) {
    saveVal("wristIndex", p13572);
    wristIndex = p13572;
    updateClassPreview();
    if (!p13573) {
      showWindow(3);
    }
    if (p13574) {
      updateWindow(3);
    }
    f1796("wrist", p13572);
  }
});
Object.defineProperty(window, "charmSelector", {
  writeable: false,
  value: function (p13575) {
    f1822(window.event);
    vLN01715 = p13575;
    showWindow(46);
  }
});
Object.defineProperty(window, "overrideCharm", {
  writeable: false,
  value: function (p13576) {
    selectedCharms = [-1, -1];
    selectCharm(p13576);
  }
});
Object.defineProperty(window, "selectCharm", {
  writeable: false,
  value: function (p13577, p13578, p13579) {
    player = Game.store.skins[p13577];
    selectedCharms[vLN01715] = player || p13577 == -2 ? p13577 : -1;
    if (selectedCharms[0] == selectedCharms[1] && selectedCharms[vLN01715] >= 0) {
      var v10841 = account && account.skins.some(p13580 => p13580.ind === p13577 && p13580.cnt > 1);
      if (!v10841) {
        selectedCharms[vLN01715] = -1;
        genericPopup("<div class=\"popHeader\">Charm Error</div>Charm already in use<div style=\"margin-top: 20px;\">" + ("<div class=\"charmBtn\" onmouseenter=\"playTick(0.1);\" onclick=\"playSelect(0.1);clearPops();overrideCharm(" + p13577 + ");\">Override</div>") + "<div class=\"charmBtn\" style=\"background:var(--green)\" onmouseenter=\"playTick(0.1);\" onclick=\"playSelect(0.1);clearPops();\">Ok</div></div>", "charmErrorPop");
        return;
      }
    }
    saveVal("charms", JSON.stringify(selectedCharms));
    if (!p13578) {
      showWindow(3);
    }
    if (p13579) {
      updateWindow(3);
    }
  }
});
Object.defineProperty(window, "selectMelee", {
  writeable: false,
  value: function (p13581, p13582, p13583) {
    saveVal("meleeIndex", p13581);
    meleeIndex = p13581;
    updateClassPreview();
    if (!p13582) {
      showWindow(3);
    }
    if (p13583) {
      updateWindow(3);
    }
    f1796("melee", p13581);
  }
});
Object.defineProperty(window, "selectSecondary", {
  writeable: false,
  value: function (p13584, p13585) {
    saveVal("secondaryInd", p13584);
    secondaryIndex = p13584;
    updateClassPreview();
    if (!p13585) {
      showWindow(3);
    }
    if (inGame && account && account.isDev && p13584 && SETTINGS.list.forceUpdate.val) {
      var v10842 = Game.classConfig[parseInt(classIndex)].loadout;
      var vA598 = [useDefaultCosmetics ? -1 : skinsLoadout[v10842[0]] == null ? -1 : skinsLoadout[v10842[0]] == -2 ? f1800(v10842[0] + 1) : skinsLoadout[v10842[0]], useDefaultCosmetics ? -1 : skinsLoadout[secondaryIndex] != null && Game.classConfig[parseInt(classIndex)].secondary ? skinsLoadout[secondaryIndex] == -2 ? f1800(secondaryIndex + 1) : skinsLoadout[secondaryIndex] : -1];
      f1796("skins", [vA598, secondaryIndex]);
    }
  }
});
Object.defineProperty(window, "selectSkinColor", {
  writeable: false,
  value: function (p13586) {
    saveVal("skinColIndex", p13586);
    skinColIndex = p13586;
    updateClassPreview();
    updateWindow(3);
  }
});
Object.defineProperty(window, "selectHairColor", {
  writeable: false,
  value: function (p13587) {
    saveVal("hairCol", p13587);
    hairCol = p13587;
    updateClassPreview();
    updateWindow(3);
  }
});
Object.defineProperty(window, "selectChatColor", {
  writeable: false,
  value: function (p13588) {
    saveVal("chatCol", p13588);
    chatCol = p13588;
    updateClassPreview();
    updateWindow(3);
  }
});
Object.defineProperty(window, "selectAttachment", {
  writeable: false,
  value: function (p13589) {
    saveVal("attachIndex", p13589);
    attachIndex = p13589;
    updateClassPreview();
    showWindow(3);
  }
});
Object.defineProperty(window, "selectReticle", {
  writeable: false,
  value: function (p13590, p13591) {
    saveVal("reticleIndex", p13590);
    reticleIndex = p13590;
    savedReticle = sanitizeCustomImageUrl(p13591);
    saveVal("savedReticle", savedReticle || "");
    updateAimDot(p13590, savedReticle ? savedReticle : RENDER.aimDot.savedCustom);
    updateClassPreview();
    showWindow(3);
  }
});
Object.defineProperty(window, "removeReticle", {
  writeable: false,
  value: function (p13592) {
    f1822(window.event);
    if (customReticles[p13592]) {
      customReticles.splice(p13592, 1);
      setCustomRets(customReticles, true);
      updateWindow(32);
    }
  }
});
Object.defineProperty(window, "selectScope", {
  writeable: false,
  value: function (p13593, p13594) {
    saveVal("scopeIndex", p13593);
    scopeIndex = p13593;
    savedScope = sanitizeCustomImageUrl(p13594);
    saveVal("savedScope", savedScope || "");
    updateScope(p13593, savedScope ? savedScope : RENDER.aimRecticle.savedCustom);
    updateClassPreview();
    showWindow(3);
  }
});
Object.defineProperty(window, "removeScope", {
  writeable: false,
  value: function (p13595) {
    f1822(window.event);
    if (customScopes[p13595]) {
      customScopes.splice(p13595, 1);
      setCustomScopes(customScopes, true);
      updateWindow(41);
    }
  }
});
Object.defineProperty(window, "selectClass", {
  writeable: false,
  value: function (p13596) {
    saveVal("classindex", p13596);
    if (Game.classConfig[p13596].txts) {
      io_showSpeechBubble(Game.classConfig[p13596].txts[UTILS.randInt(0, Game.classConfig[p13596].txts.length - 1)]);
    } else if (!UTILS.randInt(0, 2)) {
      io_showSpeechBubble(["Let's Go!", "Alright!", "I'm Ready!"][UTILS.randInt(0, 2)]);
    }
    setClassIndex(p13596);
    updateClassPreview();
    windows[2].switchTab(1, true);
    updSyncDat("c", p13596);
    if (Game && Game.isSandbox && tmpPlayer && sandboxGame.classes[p13596] && sandboxPlayer.classIndex != p13596) {
      sandboxPlayer.classIndex = p13596;
      sandboxPlayer.updateItems(sandboxGame, true, true, undefined, undefined, true);
    }
  }
});
Object.defineProperty(window, "skinSelector", {
  writeable: false,
  value: function (p13597, p13598, p13599) {
    activeSkinSel = p13597;
    if (p13598) {
      saveVal("secondaryInd", p13597);
      secondaryIndex = p13597;
    }
    updateClassPreview();
    if (!p13599) {
      showWindow(15);
    }
    if (inGame && account && account.isDev && p13597 && SETTINGS.list.forceUpdate.val) {
      var v10843 = Game.classConfig[parseInt(classIndex)].loadout;
      var vA599 = [useDefaultCosmetics ? -1 : skinsLoadout[v10843[0]] == null ? -1 : skinsLoadout[v10843[0]] == -2 ? f1800(v10843[0] + 1) : skinsLoadout[v10843[0]], useDefaultCosmetics ? -1 : skinsLoadout[secondaryIndex] != null && Game.classConfig[parseInt(classIndex)].secondary ? skinsLoadout[secondaryIndex] == -2 ? f1800(secondaryIndex + 1) : skinsLoadout[secondaryIndex] : -1];
      f1796("skins", [vA599, secondaryIndex]);
    }
  }
});
Object.defineProperty(window, "viewAttachments", {
  writeable: false,
  value: function () {
    f1822(window.event);
    showWindow(31);
  }
});
Object.defineProperty(window, "selectStat", {
  writeable: false,
  value: function (p13600) {
    saveVal("pcStatIndex", p13600);
    pcStatIndex = p13600;
    updateClassPreview();
    updateWindow(3);
  }
});
Object.defineProperty(window, "selectDye", {
  writeable: false,
  value: function (p13601, p13602, p13603) {
    saveVal("dyeIndex", p13601);
    dyeIndex = p13601;
    updateClassPreview();
    if (!p13602) {
      showWindow(3);
    }
    if (p13603) {
      updateWindow(3);
    }
    f1796("dye", p13601);
  }
});
Object.defineProperty(window, "selectFace", {
  writeable: false,
  value: function (p13604, p13605, p13606) {
    saveVal("faceIndex", p13604);
    faceIndex = p13604;
    updateClassPreview();
    if (!p13605) {
      showWindow(3);
    }
    if (p13606) {
      updateWindow(3);
    }
    f1796("face", p13604);
  }
});
Object.defineProperty(window, "selectShoe", {
  writeable: false,
  value: function (p13607, p13608, p13609) {
    saveVal("shoeIndex", p13607);
    shoeIndex = p13607;
    updateClassPreview();
    if (!p13608) {
      showWindow(3);
    }
    if (p13609) {
      updateWindow(3);
    }
    f1796("shoes", p13607);
  }
});
Object.defineProperty(window, "selectStreak", {
  writeable: false,
  value: function (p13610, p13611) {
    p13610 = parseInt(p13610);
    if (!Game.streaks[p13610] || Game.streaks[p13610].slot != p13611) {
      p13610 = -1;
    }
    var v10844 = true;
    if (p13611 == 0) {
      saveVal("streakIndex1", p13610);
      if (streakIndex1 == p13610) {
        v10844 = false;
      }
      streakIndex1 = p13610;
    } else if (p13611 == 1) {
      saveVal("streakIndex2", p13610);
      if (streakIndex2 == p13610) {
        v10844 = false;
      }
      streakIndex2 = p13610;
    } else if (p13611 == 2) {
      saveVal("streakIndex3", p13610);
      if (streakIndex3 == p13610) {
        v10844 = false;
      }
      streakIndex3 = p13610;
    }
    updateClassPreview();
    if (v10844) {
      updateWindow(45);
    }
  }
});
Object.defineProperty(window, "selectFlag", {
  writeable: false,
  value: function (p13612) {
    if (account) {
      io.send("flg", parseInt(p13612));
    }
  }
});
Object.defineProperty(window, "selectBadge", {
  writeable: false,
  value: function (p13613) {
    if (account) {
      io.send("bdg", parseInt(p13613));
    }
  }
});
Object.defineProperty(window, "claimBadge", {
  writeable: false,
  value: function (p13614) {
    if (account) {
      io.send("cbdg", parseInt(p13614));
    }
  }
});
window.selectBadgePop = function () {
  if (account) {
    var vLN01716 = 0;
    for (var vLN01718 = 0; vLN01718 < Game.badges.length; vLN01718++) {
      if (!(account.badges.indexOf(Game.badges[vLN01718].index) >= 0)) {
        if (Game.badges[vLN01718].claimable && Game.badges[vLN01718].req(account)) {
          vLN01716++;
        }
      }
    }
    if (!account.badges.length && vLN01716 <= 0) {
      return io_showPopup(null, "You dont own any badges");
    }
    if (account.stats.bdg == null) {
      account.stats.bdg = -1;
    }
    var vLSdivClassimageListHea = "<div class='imageListHeader'>Badge Collection</div>";
    vLSdivClassimageListHea += "<div id='skinList' style='margin-top:18px;text-align: center;'>";
    for (var v10845 = [...Game.badges].sort(function (p13615, p13616) {
        return (account.badges.indexOf(p13616.index) > -1 ? 1 : 0) - (account.badges.indexOf(p13615.index) > -1 ? 1 : 0);
      }).sort(function (p13617, p13618) {
        var v10846 = p13617.claimable && p13617.req(account) && account.badges.indexOf(p13617.index) == -1;
        var v10847 = p13618.claimable && p13618.req(account) && account.badges.indexOf(p13618.index) == -1;
        return (v10847 ? 1 : 0) - (v10846 ? 1 : 0);
      }), vLN01718 = 0; vLN01718 < v10845.length; vLN01718++) {
      var v10848 = account.badges.indexOf(v10845[vLN01718].index) > -1;
      var v10849 = !v10848 && v10845[vLN01718].claimable && v10845[vLN01718].req(account);
      vLSdivClassimageListHea += "<div class='badgeCard'" + (v10848 ? " onclick='selectBadge(" + v10845[vLN01718].index + ")'" : v10849 ? " onclick='claimBadge(" + v10845[vLN01718].index + ")' style='outline: 2px inset #FBC02D;'" : "") + "><img class='badgeImg' src='" + v10845[vLN01718].url + "'><div class='badgeName'>" + (v10845[vLN01718].name || "Unknown") + "</div><div class='badgeDesc'>" + (v10845[vLN01718].desc || "No Description") + "</div>" + (v10849 ? "<div class='badgeBound'><span class='material-icons' style='font-size:30px;color:#FBC02D;'>lock_open</span></div>" : v10848 ? "" : "<div class='badgeBound'><span class='material-icons' style='font-size:30px;color:#fff;'>lock</span></div>") + "</div>";
    }
    vLSdivClassimageListHea += "</div>";
    genericPopup(vLSdivClassimageListHea, "badgePop");
  }
};
Object.defineProperty(window, "toggleStatus", {
  writeable: false,
  value: function (p13619) {
    if (account) {
      io.send("hds", !!p13619);
    }
  }
});
Object.defineProperty(window, "selectRegen", {
  writeable: false,
  value: function () {
    if (inGame && account && account.isDev) {
      io.send("prmA", 11, "regen");
    }
  }
});
Object.defineProperty(window, "selectPack", {
  writeable: false,
  value: function (p13620, p13621) {
    window.ClientSession.togglePack(p13620, p13621);
    selectPackPop();
  }
});
Object.defineProperty(window, "downloadPack", {
  writeable: false,
  value: function (p13622) {
    io_loadingPopup("Downloading Mod...");
    if (windows[3].listData[windows[3].tabIndex] && windows[3].listData[windows[3].tabIndex].list) {
      let v10850 = windows[3].listData[windows[3].tabIndex].list.find(p13623 => p13623 && p13623.mod_id == p13622);
      if (v10850) {
        let v10851 = UTILS.getAssetData(v10850.mod_info);
        let v10852 = v10851 && v10851.t ? UTILS.userAssetsUrl("/m" + ("d" + v10850.mod_id) + "/thumb.png") : null;
        let v10853 = UTILS.cleanseString(v10850.creatorname);
        let v10854 = parseInt(v10850.mod_updatecounter) || 1;
        let v10855 = v10850.mod_name + "";
        let v10856 = v10850.mod_url;
        if (v10856 == "ua") {
          v10856 = UTILS.userAssetsUrl("/md" + v10850.mod_id + "/mod.zip");
        }
        window.ClientSession.downloadPack(v10856, v10855, v10853, v10852, v10854);
      }
    } else {
      io_showPopup(null, "No Mod Found");
    }
  }
});
window.packRes = function (...iÎìììiî) {
  io_showPopup(...iÎìììiî);
};
window.selectPackPop = function () {
  if (!window.ClientSession || !window.ClientSession.packs) {
    return;
  }
  let vLSdivClassimageListHea2 = "<div class='imageListHeader'>Resource Packs</div>";
  vLSdivClassimageListHea2 += "<div id='skinList' style='margin-top:18px;text-align: center;'>";
  let v10857 = window.ClientSession.packs.loaded;
  for (var vLN01719 = 0; vLN01719 < v10857.length; vLN01719++) {
    vLSdivClassimageListHea2 += "<div class='badgeCard' onclick='selectPack(" + vLN01719 + ", " + (v10857[vLN01719].enabled ? 0 : 1) + ")'><img class='badgeImg' src='" + (v10857[vLN01719].png || "./img/cube.png") + "'><div class='badgeName'>" + (v10857[vLN01719].name || "Unknown").replace(/[^\w +#]/gmi, "") + "</div><div class='badgeDesc'>By " + (v10857[vLN01719].author || "Unknown").replace(/[^\w +#]/gmi, "") + "</div>" + (v10857[vLN01719].enabled ? "" : "<div class='badgeBound'><span class='material-icons' style='font-size:30px;color:#fff;'>lock</span></div>") + "</div>";
  }
  vLSdivClassimageListHea2 += "<div style='margin-top:18px;text-align: center;color: var(--red);margin-bottom: -4px;'>" + (v10857.length ? "Changes take effect after a restart!" : "No Packs Found!") + "</div>";
  vLSdivClassimageListHea2 += "</div>";
  genericPopup(vLSdivClassimageListHea2, "badgePop");
};
function f1797(p13624) {
  var v10858 = "<div class='settName' title='" + (SETTINGS.list[p13624].info || "") + "'" + (SETTINGS.list[p13624].hide == null ? "" : "id='" + p13624 + "_div' style='display:" + (SETTINGS.list[p13624].hide ? "none" : "block") + "'") + ">" + i18n.t(SETTINGS.list[p13624].name) + (SETTINGS.list[p13624].needsRestart ? " <span style='color: #eb5656'>*</span>" : SETTINGS.list[p13624].verified ? " <i class='material-icons' style='color:#2196F3;font-size:33px;vertical-align:bottom;'>check_circle</i>" : "") + " ";
  v10858 += SETTINGS.list[p13624].html ? SETTINGS.list[p13624].html() : initGameUI._html.settings.input[SETTINGS.list[p13624].type] ? initGameUI._html.settings.input[SETTINGS.list[p13624].type](SETTINGS.list[p13624]) : initGameUI._html.settings.input.generic(SETTINGS.list[p13624]);
  v10858 += "</div>";
  return v10858;
}
function f1798(p13625) {
  var vLSdivStylefloatright = "<div style='float:right'>";
  vLSdivStylefloatright += SETTINGS.list[p13625].html ? SETTINGS.list[p13625].html() : initGameUI._html.settings.input[SETTINGS.list[p13625].type] ? initGameUI._html.settings.input[SETTINGS.list[p13625].type](SETTINGS.list[p13625]) : initGameUI._html.settings.input.generic(SETTINGS.list[p13625]);
  vLSdivStylefloatright += "</div>";
  return vLSdivStylefloatright;
}
var v10859 = null;
var v10860 = Object.keys(Game.store.skins).filter(p13626 => Game.store.skins[parseInt(p13626)] && Game.store.skins[parseInt(p13626)].free).map(p13627 => p13627 = {
  ind: parseInt(p13627),
  cnt: 1
});
function f1799(p13628, p13629) {
  if (!v10859) {
    v10859 = Object.keys(Game.store.skins).map(p13630 => p13630 = {
      ind: parseInt(p13630),
      cnt: 1
    });
  }
  var v10861 = Game.isSandbox || p13628 && p13628.isDev ? v10859 : p13628 ? p13628.skins : [];
  if (!Game.isSandbox && (!p13628 || !p13628.isDev) && p13629) {
    v10861 = v10861.concat(v10860);
    var v10862 = Game.store.skins.filter(p13631 => !v10861.find(p13632 => p13632 && p13632.ind === p13631.index) && (!!p13631.creators && !!account && !!(p13631.creators.indexOf(account.name.toLowerCase()) > -1) || !!p13631.streamers && !!account && !!account.twitch && !!(p13631.streamers.indexOf(account.twitch.toLowerCase()) > -1) || !!p13631.kpd && !!account && (!!account.isMod || !!account.isDeputy) || !p13631.creator && !!((p13631.seas || 0) >= 6) && !!account && !!account.isSkinMaker && !p13631.blocked)).map(p13633 => p13633 = {
      ind: parseInt(p13633.index),
      cnt: 1
    });
    v10861 = v10861.concat(v10862);
  }
  return v10861;
}
function f1800(p13634, p13635, p13636) {
  if (!account) {
    return -1;
  }
  var v10863 = f1799(account, true).filter(p13637 => Game.store.skins[p13637.ind] && (p13635 == null ? !Game.store.skins[p13637.ind].type && Game.store.skins[p13637.ind].weapon == p13634 : Game.store.skins[p13637.ind].type == p13635) && (Game.store.skins[p13637.ind].classIndex == null || Game.store.skins[p13637.ind].classIndex == classIndex) && (p13636 == null || (Game.store.skins[p13637.ind].rarity || 0) <= p13636));
  var v10864 = v10863.filter(p13638 => favoriteItemIds.indexOf(p13638.ind) >= 0);
  if (v10864.length) {
    return UTILS.getRandom(v10864).ind || -1;
  } else if (v10863.length) {
    return UTILS.getRandom(v10863).ind || -1;
  } else {
    return -1;
  }
}
Object.defineProperty(window, "selectSkin", {
  writeable: false,
  value: function (p13639, p13640, p13641) {
    player = Game.store.skins[p13639];
    skinsLoadout[p13640] = player || p13639 == -2 ? p13639 : undefined;
    saveVal("skins", JSON.stringify(skinsLoadout));
    updateClassPreview();
    if (!p13641) {
      showWindow(3);
    }
    if (inGame && account && account.isDev && p13639 && SETTINGS.list.forceUpdate.val) {
      var v10865 = Game.classConfig[parseInt(classIndex)].loadout;
      var vA600 = [useDefaultCosmetics ? -1 : skinsLoadout[v10865[0]] == null ? -1 : skinsLoadout[v10865[0]] == -2 ? f1800(v10865[0] + 1) : skinsLoadout[v10865[0]], useDefaultCosmetics ? -1 : skinsLoadout[secondaryIndex] != null && Game.classConfig[parseInt(classIndex)].secondary ? skinsLoadout[secondaryIndex] == -2 ? f1800(secondaryIndex + 1) : skinsLoadout[secondaryIndex] : -1];
      io.send("prmA", 10, ["skins", vA600, secondaryIndex, !!SETTINGS.list.forceRegen.val]);
    }
  }
});
var vLN750 = 750;
var vLN600 = 600;
var classPreviewCamera = new THREE.PerspectiveCamera(15, 1, 0.1, 100);
var classPreviewScene;
var classPreviewPlayer;
var v10869;
classPreviewCamera.aspect = vLN750 / vLN600;
classPreviewCamera.updateProjectionMatrix();
var classPreviewRenderer = new THREE.WebGLRenderer({
  canvas: classPreviewCanvas,
  precision: "mediump",
  antialias: false,
  alpha: true
});
classPreviewRenderer.setSize(vLN750, vLN600);
classPreviewRenderer.setPixelRatio(window.devicePixelRatio * SETTINGS.tmp.resolution);
window.updateClassRender = function () {
  classPreviewRenderer.setPixelRatio(window.devicePixelRatio * SETTINGS.tmp.resolution);
};
var v10871 = new THREE.Vector3();
var vO349 = {};
classPreviewCamera.position.x = -30;
classPreviewCamera.position.y = 17;
classPreviewCamera.position.z = -35;
function updateClassPreview(p13642) {
  function f1802(p13643, p13644 = true) {
    if (vLS46) {
      vLS46 += " - ";
    }
    var vLSInherit = "inherit";
    var v10872 = Game.weaponConfig[p13643].name;
    var v10873 = false;
    var v10874 = UTILS.assetsUrl("/textures/previews/" + (p13643 == 12 ? "cosmetics/3_default.png" : "weapons/" + Game.weaponConfig[p13643].src + ".png"));
    if (skinsLoadout[p13643] != null) {
      var v10875 = Game.store.skins[skinsLoadout[p13643]];
      if (v10875) {
        v10873 = Game.store.rarities[v10875.rarity].animate;
        vLSInherit = Game.store.rarities[v10875.rarity].color;
        v10872 = v10875.name;
        v10874 = v10875.thumbnail;
      }
    }
    vLS46 += "<span " + (RENDER.rarityAnim && v10873 ? "class='rainbowText' " : "") + "style='color:" + (p13644 ? vLSInherit : "inherit") + "'>" + v10872 + "</span>";
    menuClassIcn.src = v10874;
  }
  var v10876 = Game.classConfig[vO349.class || classIndex];
  menuClassName.textContent = vO349.classN || v10876.name;
  menuClassContainer.style.zIndex = p13642 || 99999;
  var vLS46 = "";
  for (var v10877 of v10876.loadout) {
    f1802(v10877);
  }
  menuClassSubtext.innerHTML = vLS46;
  var vLS47 = "";
  if (account && account.stats.bdg == null) {
    account.stats.bdg = -1;
  }
  var v10878 = account && account.stats.bdg >= 0 && Game.badges[account.stats.bdg] && SETTINGS.tmp.customBadge && account.badges.indexOf(account.stats.bdg) >= 0 ? Game.badges[account.stats.bdg] : null;
  if (vO349.name) {
    vLS47 = (vO349.lvl ? "<div class='menuClassLevelBox' style='color:#fb2d2d'>" + vO349.lvl + "</div>" : "") + (vO349.clan ? "<span class='menuClassPlayerClan' style='color:#FF6A0B'>[" + vO349.clan + "] </span>" : "") + vO349.name + " <i class='material-icons menuClassPlayerPremium'>beenhere</i>";
  } else {
    vLS47 += (account ? "<div class='menuClassLevelBox' style='color:white;'>" + (account.level || 0) + "</div>" : "") + "<span class='menuClassPlayerName'>" + (account ? account.premiumT && SETTINGS.tmp.premiumBadge ? account.alias || account.name : account.name : tmpPlayer ? "Guest_" + tmpPlayer.sid : "Guest") + "</span>" + (account && account.clan ? "<span class='menuClassPlayerClan' style='color:" + COLORS.getClanCol(account.clan, "rgba(255,255,255,0.5)") + "'>[" + account.clan + "]</span>" : "") + (account && account.partnerApp == 2 && SETTINGS.tmp.partnerBadge ? "<i class='material-icons menuClassPlayerPartner'>verified</i>" : "") + (account && account.premiumT && SETTINGS.tmp.premiumBadge ? "<i class='material-icons menuClassPlayerPremium'>beenhere</i>" : "") + (account && account.featured && SETTINGS.tmp.verifiedBadge ? "<i class='material-icons menuClassPlayerVerified'>check_circle</i>" : "") + (v10878 ? "<img src='" + v10878.url + "' class='menuClassPlayerCustom'>" : "");
  }
  menuClassNameTag.innerHTML = vLS47;
  if (v10514) {
    menuClassNameTag.style.cssText += "margin-top: -350px !important;";
  }
  if (!classPreviewScene) {
    classPreviewScene = new THREE.Scene();
    classPreviewScene.name = "Class";
    classPreviewScene.add(new THREE.AmbientLight(9937064));
    var v10879 = new THREE.DirectionalLight(15923452, 0.5);
    v10879.position.set(10, 17, -10);
    classPreviewScene.add(v10879);
  }
  var vA601 = [skinsLoadout[v10876.loadout[0]] != null || skinsLoadout[v10876.loadout[0]] != -2 ? skinsLoadout[v10876.loadout[0]] : -1, skinsLoadout[v10876.loadout[1]] == null ? -1 : skinsLoadout[v10876.loadout[1]]];
  if (classPreviewPlayer) {
    Game.pets.remove(classPreviewPlayer);
  }
  var v10880 = !Game || !Game.disableMeshes;
  classPreviewPlayer = new Player(-1, this, Game, true);
  classPreviewPlayer.sid = -1;
  classPreviewPlayer.init(0, 0, 0, "preview", false);
  classPreviewPlayer.skins = vA601;
  classPreviewPlayer.hatIndex = vO349.hat || (hatIndex == -2 ? -1 : hatIndex);
  classPreviewPlayer.headIndex = vO349.head || (headIndex == -2 ? -1 : headIndex);
  classPreviewPlayer.bodyIndex = vO349.body || (bodyIndex == -2 ? -1 : bodyIndex);
  classPreviewPlayer.backIndex = vO349.back || (backIndex == -2 ? -1 : backIndex);
  classPreviewPlayer.waistIndex = vO349.waist || waistIndex == -2 ? -1 : waistIndex;
  classPreviewPlayer.petIndex = vO349.pet || petIndex == -2 ? -1 : petIndex;
  classPreviewPlayer.meleeIndex = vO349.melee || (meleeIndex == -2 ? -1 : meleeIndex);
  classPreviewPlayer.attachIndex = Game.weaponConfig[v10876.loadout[0]].forceAttach || Game.store.skins[vA601[0]] && Game.store.skins[vA601[0]].forceAttach ? 0 : parseInt(attachIndex);
  classPreviewPlayer.skinColIndex = skinColIndex;
  classPreviewPlayer.hairCol = hairCol;
  classPreviewPlayer.dyeIndex = vO349.dye || dyeIndex;
  classPreviewPlayer.faceIndex = vO349.face || (faceIndex == -2 ? -1 : faceIndex);
  classPreviewPlayer.shoeIndex = vO349.shoe || (shoeIndex == -2 ? -1 : shoeIndex);
  classPreviewPlayer.wristIndex = vO349.wrist || (wristIndex == -2 ? -1 : wristIndex);
  classPreviewPlayer.secIndex = secondaryIndex;
  classPreviewPlayer.setClass(Game, vO349.class || classIndex, secondaryIndex, true);
  Game.players.swapWeapon(classPreviewPlayer, 0, true);
  if (v10869) {
    classPreviewScene.remove(v10869);
  }
  v10869 = Game.players.generateMeshes(classPreviewPlayer, false, true, v10880);
  classPreviewScene.add(v10869);
  Game.players.updateHeadSize(classPreviewPlayer, tmpPlayer ? tmpPlayer.headMlt : 1);
  classPreviewPlayer.swapTime = 0;
  if (classPreviewPlayer.weaponMeshes && classPreviewPlayer.weaponMeshes[0]) {
    classPreviewPlayer.weaponMeshes[0].visible = true;
  }
  vO349 = {};
  v10871.set(0, config.playerHeight * 0.8, 0);
  classPreviewCamera.lookAt(v10871);
  if (classPreviewPlayer.petIndex >= 0 && v10880) {
    Game.pets.add(classPreviewPlayer, true);
  }
}
updateClassPreview();
var v10881 = getSavedVal("krk_hideFull") == "true";
window.toggleHF = function (p13645) {
  v10881 = p13645;
  saveVal("krk_hideFull", p13645);
};
toggleHF(v10881);
var v10882 = getSavedVal("krk_regionPriority") == "true";
window.toggleRP = function (p13646) {
  v10882 = p13646;
  saveVal("krk_regionPriority", p13646);
};
toggleRP(true);
window.windows = [{
  header: i18n.t("windows.settings.header"),
  label: "settings",
  sticky: true,
  dark: true,
  popup: true,
  width: 1200,
  maxH: "calc(100% - 270px)",
  settingSearch: null,
  tabIndex: 0,
  settingType: settingsViewMode || "basic",
  tabs: {
    basic: [{
      name: "General",
      categories: ["local", "serverb", "kpd", "dev"]
    }, {
      name: "Display",
      categories: ["interface", "quality"]
    }, {
      name: "Game",
      categories: ["binds", "gameplay", "mobile", "viewmodel"]
    }, {
      name: "Sound",
      categories: ["audio"]
    }].concat(vF1730 ? {
      name: "Client",
      categories: ["client"]
    } : []),
    advanced: [{
      name: "General",
      categories: ["local", "network", "serverb", "popup", "experimental", "kpd", "dev"]
    }, {
      name: "Controls",
      categories: ["binds", "gameplay", "controller", "mobile"]
    }, {
      name: "Display",
      categories: ["interface", "spectating", "minimap", "medals", "crosshair", "crosshairm", "hitmarker", "chat"]
    }, {
      name: "Render",
      categories: ["shaders", "quality", "post", "editing"]
    }, {
      name: "Game",
      categories: ["gameprivacy", "viewmodel", "mods"]
    }, {
      name: "Sound",
      categories: ["audio"]
    }].concat(vF1730 ? {
      name: "Client",
      categories: ["client"]
    } : [])
  },
  searchList: function () {
    var v10883 = document.getElementById("settSearch");
    this.settingSearch = v10883 && v10883.value != "" ? v10883.value : null;
    if (this.settingSearch) {
      if (this.tabIndex == -1) {
        v10883 = document.getElementById("settHolder");
        if (v10883) {
          v10883.innerHTML = this.getSettings();
        }
      } else {
        this.changeTab(this.tabIndex = -1);
      }
    } else {
      this.changeTab(this.tabIndex = 0);
    }
  },
  collapseFolder: function (p13647) {
    let v10884 = document.getElementById("setBod_" + p13647.id.split("setHed_")[1]);
    let v10885 = v10884.style.display == "none";
    p13647.children[0].innerHTML = "keyboard_arrow_" + (v10885 ? "down" : "right");
    v10884.style.display = v10885 ? null : "none";
  },
  changeTab: function (p13648) {
    this.tabIndex = p13648;
    var v10886;
    if (p13648 > -1) {
      v10886 = document.getElementById("settSearch");
      this.settingSearch = null;
      if (v10886) {
        v10886.value = "";
      }
    }
    v10886 = document.getElementById("settingsTabLayout");
    if (v10886) {
      v10886.innerHTML = this.getTabs();
    }
    v10886 = document.getElementById("settHolder");
    if (v10886) {
      v10886.innerHTML = this.getSettings();
    }
  },
  currWep: 0,
  changeWep: function (p13649) {
    this.currWep = parseInt(p13649.value);
    updateWindow(1);
  },
  applyAllWeps: function (p13650) {
    var v10887 = Object.keys(SETTINGS.list).filter(p13651 => SETTINGS.list[p13651][p13650 == "gpSetts" ? "perWepG" : "perWep"]);
    for (var vLN01720 = 0; vLN01720 < Game.weapons.length; vLN01720++) {
      for (var vLN01721 = 0, v10888; vLN01721 < v10887.length; vLN01721++) {
        v10888 = SETTINGS.list[v10887[vLN01721]];
        setSetting(v10887[vLN01721] + "_" + vLN01720, SETTINGS.list[v10887[vLN01721] + "_" + this.currWep].val);
      }
    }
    updateWindow(1);
  },
  resetAllWeps: function (p13652) {
    var v10889 = Object.keys(SETTINGS.list).filter(p13653 => SETTINGS.list[p13653][p13652 == "gpSetts" ? "perWepG" : "perWep"]);
    for (var vLN01722 = 0; vLN01722 < Game.weapons.length; vLN01722++) {
      for (var vLN01723 = 0, v10890; vLN01723 < v10889.length; vLN01723++) {
        v10890 = SETTINGS.list[v10889[vLN01723]];
        setSetting(v10889[vLN01723] + "_" + vLN01722, SETTINGS.list[v10889[vLN01723] + "_" + this.currWep].def);
      }
    }
    updateWindow(1);
  },
  toggleType: function (p13654) {
    if (this.tabIndex != -1 && !this.tabs[this.settingType][this.tabIndex]) {
      this.tabIndex = 0;
    }
    this.settingType = !p13654.checked ? "basic" : "advanced";
    saveVal("krk_advanced", ~~!!p13654.checked);
    requestAnimationFrame(() => updateWindow(1), 250);
  },
  getTabs: function () {
    let v10891 = this.tabIndex == -1 ? p13655 => "class='settingTab' style='border-bottom: 5px solid transparent'" : p13656 => "class='settingTab " + (p13656 == this.tabIndex ? "tabANew" : "") + "'";
    return this.tabs[this.settingType].map((p13657, p13658) => "<div " + v10891(p13658) + " onmouseenter='playTick()'\n\t\t\tonclick='playSelect(0.1);window.windows[0].changeTab(" + p13658 + ")'>" + p13657.name + "</div>").join("\n");
  },
  getSettings: function () {
    var vLS48 = "";
    let vLSSettingsshadersheade = "settings.shaders.header";
    let vLSSettingscontrolschan = "settings.controls.change";
    if (this.tabs[this.settingType][this.tabIndex] && this.tabs[this.settingType][this.tabIndex].categories.includes("binds") || this.settingSearch && this.searchMatches({
      name: vLSSettingscontrolschan
    })) {
      vLS48 += "<div class='setBodH'><div class=\"settName\" style=\"margin-top:15px\">\n\t\t\t\t" + i18n.t(vLSSettingscontrolschan) + "\n\t\t\t\t<div class=\"settingsBtn\" style=\"width: auto;\" onclick=\"showWindow(7)\">Edit</div>\n\t\t\t</div></div>";
    }
    if (this.tabs[this.settingType][this.tabIndex] && this.tabs[this.settingType][this.tabIndex].categories.includes("shaders") || this.settingSearch && this.searchMatches({
      name: vLSSettingsshadersheade
    })) {
      try {
        if (RENDER.shaderInputs.length) {
          vLS48 += "<div class='setHed'>" + i18n.t(vLSSettingsshadersheade) + "</div><div class='setBodH'>";
          for (var vLN01724 = 0; vLN01724 < RENDER.shaderInputs.length; vLN01724++) {
            player = RENDER.shaderInputs[vLN01724];
            for (var vLN01725 = 0, v10892; vLN01725 < player.length; vLN01725++) {
              v10892 = player[vLN01725].val;
              vLS48 += "<div class=\"settName\" style=\"margin-top:15px\">" + player[vLN01725].name.replace(/[^\w +#]/gmi, "");
              if (player[vLN01725].toggle) {
                v10892 = !!v10892;
                vLS48 += "<label class='switch' style='margin-left:10px'>\n\t\t\t\t\t\t\t\t\t<input type='checkbox' onclick='setShaderInput(" + vLN01724 + ", " + vLN01725 + ", this.checked)'\n\t\t\t\t\t\t\t\t\t" + (v10892 ? "checked" : "") + "><span class='slider'></span></label>";
              } else {
                v10892 = parseFloat(v10892) || 0;
                vLS48 += "<input type='number' class='sliderVal' id='shader_input_" + vLN01724 + "_" + vLN01725 + "' min='" + player[vLN01725].min + "'\n\t\t\t\t\t\t\t\t\tmax='" + player[vLN01725].max + "' value='" + v10892 + "' onkeypress='return delayExecute2(" + vLN01724 + ", " + vLN01725 + ", this)'\n\t\t\t\t\t\t\t\t\tstyle='margin-right:0px;border-width:0px' />\n\t\t\t\t\t\t\t\t\t<div class='slidecontainer'><input type='range' id='shader_" + vLN01724 + "_" + vLN01725 + "' min='" + player[vLN01725].min + "'\n\t\t\t\t\t\t\t\t\tmax='" + player[vLN01725].max + "' step='" + player[vLN01725].step + "' value='" + v10892 + "' class='sliderM'\n\t\t\t\t\t\t\t\t\toninput='setShaderInput(" + vLN01724 + ", " + vLN01725 + ", this.value)'></div>";
              }
              vLS48 += "</div>";
            }
          }
          vLS48 += "</div>";
        }
      } catch (e126) {}
    }
    if (this.tabIndex == 0) {
      vLS48 += "<div class='setSugBox2' onclick='selectSettingPre(0)'>Default<div class='segSugIH'><div class='setSugInf'>Krunkers default Settings</div></div></div><div class='setSugBox2' onclick='selectSettingPre(1)'>Pro<div class='segSugIH'><div class='setSugInf'>Basic competitive preset</div></div></div><div class='setSugBox2' onclick='selectSettingPre(3)'>Performance<div class='segSugIH'><div class='setSugInf'>Recommended for Laptops & Chromebooks</div></div></div><div class='setSugBox2' onclick='selectSettingPre(2)'>Custom<div class='segSugIH'><div class='setSugInf'>Custom preset</div></div></div>";
    }
    let vLSSettingsbackup = "settings.backup";
    if (account && this.tabIndex == 0 || this.settingSearch && this.searchMatches({
      name: vLSSettingsbackup
    })) {
      vLS48 += "<div class='setBodH'><div class=\"settName\" style=\"margin-top:15px\">\n\t\t\t\t" + i18n.t(vLSSettingsbackup) + "\n\t\t\t\t<div class=\"settingsBtn\" style=\"width: auto;\" onclick=\"uploadSettings()\">Upload</div>\n\t\t\t\t<div class=\"settingsBtn\" style=\"width: auto;\" onclick=\"fetchSettings()\">Download</div>\n\t\t\t</div></div>";
    }
    var vA602 = [];
    for (var v10895 in SETTINGS.list) {
      if (SETTINGS.list[v10895].noShow) {
        continue;
      }
      if (SETTINGS.list[v10895].dev) {
        SETTINGS.list[v10895].hide = !account || !account.isDev;
      }
      if (SETTINGS.list[v10895].kpd && !SETTINGS.list[v10895].hide) {
        SETTINGS.list[v10895].hide = !account || !account.isDev && !account.isMod && !account.isDeputy;
      }
      if (SETTINGS.list[v10895].admin) {
        SETTINGS.list[v10895].hide = !account || !account.isDev && !account.isAdmin;
      }
      if (this.settingType == "basic" && SETTINGS.list[v10895].sType == "advanced") {
        continue;
      }
      let vF98 = p13659 => {
        if (!vA602[SETTINGS.list[v10895].cat]) {
          vA602[SETTINGS.list[v10895].cat] = {
            cnt: 0,
            body: [],
            head: "<div class='setHed' id='setHed_" + SETTINGS.list[v10895].cat + "' style='display:none' onclick='window.windows[0].collapseFolder(this)'><span class='material-icons plusOrMinus'>keyboard_arrow_down</span> " + i18n.t("settings." + SETTINGS.list[v10895].cat + ".header") + "</div><div class='setBodH' id='setBod_" + SETTINGS.list[v10895].cat + "' style='display:none'>"
          };
        }
        var vV10893 = v10895;
        if ((SETTINGS.tmp.vmSetts == 1 && SETTINGS.list[v10895].perWep || SETTINGS.tmp.gpSetts == 1 && SETTINGS.list[v10895].perWepG) && window.windows[0].currWep >= 0) {
          vV10893 = v10895 + "_" + window.windows[0].currWep;
        }
        var v10894 = "<div class='settName' title='" + (SETTINGS.list[v10895].info || "") + "'" + (SETTINGS.list[v10895].hide == null ? "" : "id='" + v10895 + "_div' style='display:" + (SETTINGS.list[v10895].hide ? "none" : "block") + "'") + ">" + i18n.t(SETTINGS.list[vV10893].name) + (SETTINGS.list[vV10893].needsRestart ? " <span style='color: #eb5656'>*</span>" : SETTINGS.list[vV10893].verified ? " <i class='material-icons' style='color:#2196F3;font-size:33px;vertical-align:bottom;'>check_circle</i>" : SETTINGS.list[vV10893].premium ? " <i class='material-icons' style='color:#FBC02D;font-size:33px;vertical-align:bottom;'>beenhere</i>" : SETTINGS.list[vV10893].partner ? " <i class='material-icons' style='color:#993299;font-size:33px;vertical-align:bottom;'>verified</i>" : "") + " ";
        if (SETTINGS.list[vV10893].collection) {
          v10894 += "<div class='openCollection material-icons' onclick='imagePopup(&quot;" + vV10893 + "&quot;)'>collections</div>";
        }
        v10894 += SETTINGS.list[vV10893].html ? SETTINGS.list[vV10893].html() : initGameUI._html.settings.input[SETTINGS.list[vV10893].type] ? initGameUI._html.settings.input[SETTINGS.list[vV10893].type](SETTINGS.list[vV10893]) : initGameUI._html.settings.input.generic(SETTINGS.list[vV10893]);
        v10894 += "</div>";
        if ((v10895 == "vmSetts" || v10895 == "gpSetts") && SETTINGS.list[v10895].val == 1) {
          v10894 += "<div class='settName'>Select Weapon<select onchange='window.windows[0].changeWep(this)' class='inputGrey2'>";
          for (var vLN01726 = 0; vLN01726 < Game.weapons.length; vLN01726++) {
            v10894 += "<option value='" + vLN01726 + "' " + (window.windows[0].currWep == vLN01726 ? "selected" : "") + ">" + Game.weapons[vLN01726].name + "</option>";
          }
          v10894 += "</select>";
          v10894 += "<div class='settingsBtn' style='width: auto;' onclick='window.windows[0].applyAllWeps(&quot;" + v10895 + "&quot;)'>Apply To All</div>";
          v10894 += "<div class='settingsBtn' style='width: auto;' onclick='window.windows[0].resetAllWeps(&quot;" + v10895 + "&quot;)'>Reset All</div>";
          v10894 += "</div>";
        }
        vA602[SETTINGS.list[v10895].cat].body.push(v10894);
        if (!SETTINGS.list[v10895].hide) {
          vA602[SETTINGS.list[v10895].cat].cnt++;
        }
      };
      if (this.settingSearch) {
        if (this.searchMatches(SETTINGS.list[v10895]) && !SETTINGS.list[v10895].hide) {
          vF98();
        }
      } else if (this.tabs[this.settingType][this.tabIndex] && this.tabs[this.settingType][this.tabIndex].categories.includes(SETTINGS.list[v10895].cat)) {
        vF98();
      }
    }
    if (window.ClientSession && window.ClientSession.settings) {
      for (var v10895 in window.ClientSession.settings) {
        if (window.ClientSession.settings[v10895].dev) {
          window.ClientSession.settings[v10895].hide = !account || !account.isDev;
        }
        if (window.ClientSession.settings[v10895].admin) {
          window.ClientSession.settings[v10895].hide = !account || !account.isDev && !account.isAdmin;
        }
        let vF99 = p13660 => {
          if (!vA602[window.ClientSession.settings[v10895].cat]) {
            vA602[window.ClientSession.settings[v10895].cat] = {
              cnt: 0,
              body: [],
              head: "<div class='setHed' id='setHed_" + window.ClientSession.settings[v10895].cat + "' style='display:none' onclick='window.windows[0].collapseFolder(this)'><span class='material-icons plusOrMinus'>keyboard_arrow_down</span> " + i18n.t("settings." + window.ClientSession.settings[v10895].cat + ".header") + "</div><div class='setBodH' id='setBod_" + window.ClientSession.settings[v10895].cat + "' style='display:none'>"
            };
          }
          var v10896 = "<div class='settName' title='" + (window.ClientSession.settings[v10895].info || "") + "'" + (window.ClientSession.settings[v10895].hide == null ? "" : "id='" + v10895 + "_div' style='display:" + (window.ClientSession.settings[v10895].hide ? "none" : "block") + "'") + ">" + i18n.t(window.ClientSession.settings[v10895].name) + (window.ClientSession.settings[v10895].needsRestart ? " <span style='color: #eb5656'>*</span>" : window.ClientSession.settings[v10895].verified ? " <i class='material-icons' style='color:#2196F3;font-size:33px;vertical-align:bottom;'>check_circle</i>" : window.ClientSession.settings[v10895].premium ? " <i class='material-icons' style='color:#FBC02D;font-size:33px;vertical-align:bottom;'>beenhere</i>" : window.ClientSession.settings[v10895].partner ? " <i class='material-icons' style='color:#993299;font-size:33px;vertical-align:bottom;'>verified</i>" : "") + " ";
          v10896 += window.ClientSession.settings[v10895].html ? window.ClientSession.settings[v10895].html() : initGameUI._html.settings.input[window.ClientSession.settings[v10895].type] ? initGameUI._html.settings.input[window.ClientSession.settings[v10895].type](window.ClientSession.settings[v10895], "window.ClientSession") : initGameUI._html.settings.input.generic(window.ClientSession.settings[v10895], "window.ClientSession");
          v10896 += "</div>";
          vA602[window.ClientSession.settings[v10895].cat].body.push(v10896);
          if (!window.ClientSession.settings[v10895].hide) {
            vA602[window.ClientSession.settings[v10895].cat].cnt++;
          }
        };
        if (this.settingSearch) {
          if (this.searchMatches(window.ClientSession.settings[v10895]) && !window.ClientSession.settings[v10895].hide) {
            vF99();
          }
        } else if (this.tabs[this.settingType][this.tabIndex].categories.includes(window.ClientSession.settings[v10895].cat)) {
          vF99();
        }
      }
    }
    for (var v10897 in vA602) {
      vLS48 += vA602[v10897].head + vA602[v10897].body.join("") + "</div>";
      if (vA602[v10897].cnt) {
        vLS48 = vLS48.replace("id='setHed_" + v10897 + "' style='display:none'", "id='setHed_" + v10897 + "'");
        vLS48 = vLS48.replace("id='setBod_" + v10897 + "' style='display:none'", "id='setBod_" + v10897 + "'");
      }
    }
    var vVLS48 = vLS48;
    if (vVLS48.length) {
      return vVLS48;
    } else {
      return "<div class='setHed'>" + i18n.t("settings.none") + "</div>";
    }
  },
  genList: function () {
    var vLSdivClasssettingsBtnS = "<div class=\"settingsBtn\" style='width:auto;background-color:#994cd1' onclick='openOneTrust()'>Manage Ads</div>";
    var v10898 = "<div class='settingsHeader'>\n\t\t\t<div style='display:inline-block;text-align:right;float:right;'>\n\t\t\t\t" + (window.canShowAds ? vLSdivClasssettingsBtnS : "") + "\n\t\t\t\t<div class=\"settingsBtn\" onclick='resetSettings()'>" + i18n.t("settings.reset") + "</div>\n\t\t\t\t<div class=\"settingsBtn\" onclick='exportSettings()'>" + i18n.t("settings.export") + "</div>\n\t\t\t\t<div class=\"settingsBtn\" onclick='importSettingsPopup()'>" + i18n.t("settings.import") + "</div>\n\t\t\t\t<select id=\"settingsPreset\" onchange=\"selectSettingPre(this.value)\" class=\"inputGrey2\" style=\"margin-left:0px;font-size:14px\">\n\t\t\t\t\t<option value=\"0\" " + (v10787 == 0 ? "selected" : "") + ">Default</option>\n\t\t\t\t\t<option value=\"1\" " + (v10787 == 1 ? "selected" : "") + ">Pro</option>\n\t\t\t\t\t<option value=\"3\" " + (v10787 == 3 ? "selected" : "") + ">Performance</option>\n\t\t\t\t\t<option value=\"2\" " + (v10787 == 2 ? "selected" : "") + ">Custom</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<div style='display:inline-block;width:415px;'>\n\t\t\t\t<input id='settSearch' style='width: 220px;'\n\t\t\t\t\t" + (this.settingSearch ? "value='" + this.settingSearch + "'" : "") + "\n\t\t\t\t\ttype='text' placeholder='" + i18n.t("generic.search") + "' oninput='windows[0].searchList()'>\n\t\t\t\t<label class=\"advancedSwitch\">\n\t\t\t\t\t<input type=\"checkbox\" id=\"typeBtn\" " + (this.settingType == "advanced" ? "checked" : "") + "\n\t\t\t\t\t\tonclick='windows[0].toggleType(this)'>\n\t\t\t\t\t<div class=\"advancedSlider\"></div>\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div id='settingsTabLayout'>" + this.getTabs() + "</div>\n\t\t</div>";
    v10898 += "<div id='settHolder'>" + this.getSettings() + "</div>";
    return v10898;
  },
  gen: function () {
    return this.genList();
  },
  searchMatches: function (p13661) {
    return !!p13661.name && ((i18n.t(p13661.name) || "").toLowerCase().indexOf((this.settingSearch || "").toLowerCase()) >= 0 || (i18n.t("settings." + p13661.cat + ".header") || "").toLowerCase().indexOf((this.settingSearch || "").toLowerCase()) >= 0);
  }
}, {
  header: i18n.t("windows.servers.header"),
  label: "server_browser",
  sticky: true,
  lastLoadTime: 0,
  startTime: 0,
  width: 1150,
  loadedServers: false,
  serverListData: [],
  pingData: {},
  socialPlayerCount: 0,
  editorPlayerCount: 0,
  customsInfo: [],
  gen: function () {
    if (Date.now() - this.lastLoadTime < config.serverBrowserRate) {
      return this.genList();
    } else {
      this.lastLoadTime = Date.now();
      return this.loadData();
    }
  },
  loadData: function () {
    var v10899 = client.fetchGameList();
    var v10900 = fetch(config.socialURL + "/player-count").then(p13662 => p13662.json()).catch(p13663 => {}).then(p13664 => {
      if (p13664 && (windows[1].socialPlayerCount = p13664.playerCount, windows[1].loadedServers && windowHolder.style.display == "block" && vLN01909 == 2)) {
        var v10901 = document.getElementById("socialCnt");
        if (v10901) {
          v10901.innerHTML = i18n.t("windows.servers.social", UTILS.commaNumber(this.socialPlayerCount));
        }
      }
    });
    var v10902 = fetch(config.editorURL + "/player-count").then(p13665 => p13665.json()).catch(p13666 => {}).then(p13667 => {
      if (p13667 && (windows[1].editorPlayerCount = p13667.playerCount, windows[1].loadedServers && windowHolder.style.display == "block" && vLN01909 == 2)) {
        var v10903 = document.getElementById("editorCnt");
        if (v10903) {
          v10903.innerHTML = i18n.t("windows.servers.editor", UTILS.commaNumber(this.editorPlayerCount));
        }
      }
    });
    if (client.getRegionPing) {
      var v10904 = client.getRegionPing().then(p13668 => {
        windows[1].pingData = p13668;
        if (windows[1].loadedServers && windowHolder.style.display == "block" && vLN01909 == 2) {
          window.showWindow(2, true);
        }
      });
    }
    this.loadedServers = false;
    Promise.all([v10899]).then(p13669 => {
      var v10913 = p13669[0];
      this.totalPlayerCount = v10913.totalPlayerCount;
      var v10906 = v10913.games;
      this.serverListData = v10906;
      this.customsInfo.length = 0;
      this.startTime = Date.now();
      var v10907 = false;
      for (var v10908 of v10906) {
        var [v10909, v10910, v10911, v10912, v10913] = v10908;
        if (v10913.c && v10913.cm) {
          var v10914 = v10913.h || v10913.i;
          var v10915 = this.customsInfo.findIndex(p13670 => p13670.n == v10914);
          if (this.customsInfo[v10915]) {
            this.customsInfo[v10915].c += v10911;
          } else {
            this.customsInfo.push({
              n: v10914,
              i: v10913.cm,
              c: v10911,
              oc: v10913.oc,
              ds: v10913.ds
            });
          }
        }
        const v10916 = v10913.v;
        if ((config.useLooseClient || !v10916 || v10916 != version) && v10909 === v10544) {
          v10907 = true;
          break;
        }
      }
      this.customsInfo = this.customsInfo.sort((p13671, p13672) => (p13672.c || -1) - (p13671.c || -1));
      if (v10907) {
        window.showWindow(2, true);
      } else {
        client.fetchGameInfo(v10544).then(p13673 => {
          this.privateServerData = p13673;
          if (windowHolder.style.display == "block" && vLN01909 == 2) {
            window.showWindow(2, true);
          }
        });
      }
      windows[1].loadedServers = true;
    });
    return "<div style='padding-top:19px;>" + i18n.t("generic.loading") + "</div>";
  },
  expandedRegion: -1,
  totalPlayerCount: 0,
  serverSearch: null,
  autoPlaySearch: null,
  searchList: function (p13674) {
    var v10917 = document.getElementById("serverSearch");
    if (p13674) {
      v10917.value = p13674;
    }
    this.serverSearch = v10917 && v10917.value != "" ? v10917.value : null;
    if (p13674) {
      this.expandedRegion = this.serverSearch == "Krunk_Plaza" ? 0 : 1;
    }
    v10917 = document.getElementById("serverHolder");
    if (v10917) {
      v10917.innerHTML = this.getServers();
    }
  },
  getServers: function (p13675, p13676) {
    var v10918 = !!v10520 && localStorage.debugServerList;
    var v10919 = !!SETTINGS.tmp.oldBrowser;
    var v10920 = SETTINGS.list.defaultRegion.val;
    var v10921 = !SETTINGS.list.showRegion.val;
    var v10922 = !!SETTINGS.list.showServerTimer.val;
    var v10923 = p13676 || SETTINGS.tmp.defaultRegionOnly;
    var vLS49 = "";
    var vO350 = {};
    var vA603 = [];
    if (v10919) {
      vO350 = {
        official: {
          order: 1,
          name: "Official Customs",
          players: 0,
          games: []
        },
        custom: {
          order: 1,
          name: "Custom Games",
          players: 0,
          games: []
        }
      };
      var v10935 = false;
      for (var vLN01729 = 0; vLN01729 < this.serverListData.length; vLN01729++) {
        var v10936 = this.serverListData[vLN01729];
        var [v10965, v10959, v10967, v10968, v10969] = v10936;
        if (v10969 && (!v10923 || v10920 == v10959)) {
          if (!vO350[v10959]) {
            var v10931 = v10921 ? v10920 == v10959 ? "Default Region" : v10547 == v10959 ? "Current Region" : "Hidden Region" : config.regionNames[v10959];
            vO350[v10959] = {
              name: v10931,
              players: 0,
              games: []
            };
            if (v10920 == v10959) {
              vO350[v10959].order = 1;
            }
          }
          var v10932 = v10969.oc ? "official" : v10969.c && !this.autoPlaySearch ? "custom" : v10959;
          v10936[2] = Math.min(v10967, v10968);
          if (v10544 === v10965) {
            v10935 = true;
          }
          if (!this.autoPlaySearch && !this.serverSearch || this.searchMatches(v10936)) {
            vO350[v10932].players += v10967;
          }
          vO350[v10932].games.push(v10936);
        }
      }
      if (!v10935) {
        if (this.privateServerData) {
          if (this.privateServerData[4]) {
            vO350.custom.games.push(this.privateServerData);
          } else {
            console.warn("Server doesn't have data yet.");
          }
        } else {
          console.warn("Missing private server data.");
        }
      }
      for (var v10959 in vO350) {
        if (vO350.hasOwnProperty(v10959) && vO350[v10959].games && vO350[v10959].games.length) {
          vA603.push(vO350[v10959]);
        }
      }
      vA603 = vA603.sort((p13677, p13678) => (p13678.order || -1) - (p13677.order || -1));
      for (var v10959 of vA603) {
        v10959.games.sort((p13679, p13680) => (p13680[4].pr ? 1 : 0) - (p13679[4].pr ? 1 : 0) || p13680[2] - p13679[2]);
        if ((v10959.name == "Custom Games" || v10959.name == "Official Customs") && v10882) {
          v10959.games.sort((p13681, p13682) => v10920 == p13681[1] && v10920 != p13682[1] ? -1 : v10920 == p13682[1] && v10920 != p13681[1] ? 1 : 0);
        }
      }
    } else {
      for (var vLN01729 = 0; vLN01729 < gameModes.length; ++vLN01729) {
        vO350[gameModes[vLN01729].alias] = {
          name: gameModes[vLN01729].name,
          players: 0,
          games: []
        };
      }
      var v10935 = false;
      for (var vLN01729 = 0; vLN01729 < this.serverListData.length; vLN01729++) {
        var v10936 = this.serverListData[vLN01729];
        var [iÍíiïíï, iIîîìîí, iÌiiìîí, iÏìïiïì, iIìiìïì] = v10936;
        v10936[2] = Math.min(v10967, v10968);
        var v10942 = !!v10969.c;
        if (v10969.oc) {
          v10942 = false;
        }
        if (v10969 && (!v10923 || v10920 == v10959)) {
          var v10972 = gameModes[v10969.g];
          if (v10972 && vO350[v10972.alias]) {
            if (this.tabIndex != 0 || !v10942) {
              if (this.tabIndex != 1 || v10942) {
                if (v10544 === v10965) {
                  v10935 = true;
                }
                if (!this.autoPlaySearch && !this.serverSearch || this.searchMatches(v10936)) {
                  vO350[v10972.alias].players += v10967;
                }
                vO350[v10972.alias].games.push(v10936);
              }
            }
          }
        }
      }
      for (var v10959 in vO350) {
        if (vO350.hasOwnProperty(v10959) && vO350[v10959].games.length) {
          vA603.push(vO350[v10959]);
        }
      }
      vA603 = vA603.sort((p13683, p13684) => (p13684.players || 0) - (p13683.players || 0));
      for (var v10959 of vA603) {
        var v10946 = Object.keys(config.regionIND);
        v10959.games.sort((p13685, p13686) => {
          var v10947 = !!p13686[4].c;
          if (p13686[4].oc) {
            v10947 = false;
          }
          var v10948 = !!p13685[4].c;
          if (p13685[4].oc) {
            v10948 = false;
          }
          var v10949 = p13686[2];
          var v10950 = p13685[2];
          v10949 += v10946.indexOf(p13686[1]) * 100;
          v10950 += v10946.indexOf(p13685[1]) * 100;
          if (p13686[4].pr) {
            v10949 += v10947 ? 20000 : 50;
          }
          if (p13685[4].pr) {
            v10950 += v10948 ? 20000 : 50;
          }
          if (p13686[1] == v10920) {
            v10949 += 10000;
          }
          if (p13685[1] == v10920) {
            v10950 += 10000;
          }
          if (p13686[2] <= 0 && !p13686[4].pr) {
            v10949 -= 50000;
          }
          if (p13685[2] <= 0 && !p13685[4].pr) {
            v10950 -= 50000;
          }
          return v10949 - v10950;
        });
      }
    }
    if (p13675 != null) {
      var vA604 = [];
      var v10959 = vA603[p13675];
      if (!v10959 || !v10959.games) {
        return vA604;
      }
      v10959.games = v10959.games.filter(p13687 => p13687[2] < p13687[3] && p13687[2] > 0);
      for (var vLN01733 = 0; vLN01733 < v10959.games.length; vLN01733++) {
        var v10964 = v10959.games[vLN01733];
        var [iÍíiïíï, v10966, iÌiiìîí, iÏìïiïì, iIìiìïì] = v10964;
        var v10971 = v10544 && v10544 == v10965;
        if ((!this.autoPlaySearch && !this.serverSearch || !!this.searchMatches(v10964)) && !v10971) {
          vA604.push(v10965);
        }
      }
      return vA604;
    }
    for (var vLN01731 = 0, v10959; vLN01731 < vA603.length; vLN01731++) {
      v10959 = vA603[vLN01731];
      v10959.games = v10959.games.filter(p13688 => !v10881 || p13688[2] != p13688[3]);
      var v10960 = v10959.name + "<span style='float:right;color:rgba(255,255,255,0.9)'>" + v10959.players + " <span style='color:rgba(255,255,255,0.6)'>online</span></span>";
      var v10961 = this.expandedRegion == vLN01731;
      var v10962 = v10961 ? "expand_more" : "navigate_next";
      vLS49 += "<div class='setHed' style='margin-top:20px;' onmouseenter='playTick()' onclick='playSelect(0.1);setExpandedRegion(" + (v10961 ? -1 : vLN01731) + ")' style='cursor: pointer;'><span class='material-icons plusOrMinus'>" + v10962 + "</span> " + v10960 + "<div class='quickJoin' onclick='quickJoinRegion(" + vLN01731 + "," + (v10919 ? 0 : 1) + ")'>Quick Join</div></div>";
      if (v10961) {
        vLS49 += "<div class='setBodH' style='padding-top:10px;padding-bottom:10px;'>";
        var vLN01732 = 0;
        var v10963 = Date.now();
        for (var vLN01733 = 0; vLN01733 < v10959.games.length; vLN01733++) {
          var v10964 = v10959.games[vLN01733];
          var [iÍíiïíï, iÎiìïïï, iÌiiìîí, iÏìïiïì, iIìiìïì, v10970] = v10964;
          var v10971 = v10544 && v10544 == v10965;
          if ((!v10923 || v10920 == v10966) && (!this.autoPlaySearch && !this.serverSearch || this.searchMatches(v10964))) {
            vLN01732++;
            var v10972 = gameModes[v10969.g] ? gameModes[v10969.g].alias || "" : "";
            var v10973 = gameModes[v10969.g] && gameModes[v10969.g].doubleXP && !v10969.ds && !v10969.c;
            var v10974 = !!v10969.oc;
            var v10975 = !!v10969.oc || !!v10969.ds;
            var v10976 = v10918 ? v10965 : v10969.h || v10969.i;
            if (!v10969.oc && !v10969.ds && !v10969.c && !v10969.h && !v10919 && !!v10972) {
              v10976 = v10972 + "_" + v10976;
            }
            var v10977 = COLORS.ping.low;
            if ((this.pingData[v10966] || 0) / 2 >= 150) {
              v10977 = COLORS.ping.high;
            } else if ((this.pingData[v10966] || 0) / 2 >= 50) {
              v10977 = COLORS.ping.medium;
            }
            var v10978 = !v10969.oc && !v10969.c && !v10969.ds && v10922;
            var v10979 = Math.max(0, (v10970 || 0) - (v10963 - this.startTime) / 1000);
            var v10980 = UTILS.getReadableTime((v10979 || 0) * 1000, true, undefined, true);
            var v10981 = (v10969.c || v10919 ? v10969.ds || v10969.h ? "" : v10972 + "_" : "[YEND] ") + (v10974 ? " <div class='krIcon' style='margin-top:-14px;vertical-align:middle;background-color: var(--green);'>OFFICIAL</div> " : "") + (v10975 ? " <div class='krIcon' style='margin-top:-14px;vertical-align:middle;background-color: var(--blue);'>24/7</div> " : "") + (v10973 ? " <div class='krIcon' style='margin-top:-14px;vertical-align:middle;background-color: var(--yellow);'>2XP</div> " : "") + v10976 + (v10969.kr ? " <div class='krIcon' style='margin-top:-6px;vertical-align:middle'>KR</div> " : "") + (v10969.pr ? " <span class='material-icons' style='margin-top:-6px;color:#FBC02D;vertical-align:middle'>star</span> " : "") + (v10969.pw ? " <span class='material-icons' style='margin-top:-6px;color:#FBC02D;vertical-align:middle'>lock</span> " : "") + "<div class='serverPCount'>" + v10967 + "/" + v10968 + "</div>" + (v10969.c || !v10919 || v10919 && v10969.oc ? "<div class='serverRegion'>" + (v10921 ? v10920 == v10966 ? "DEFAULT" : v10547 == v10966 ? "CURRENT" : "HIDDEN" : v10965.split(":")[0]) + " -&nbsp;</div>" : "") + ("<div class='serverPing material-icons' style='color:" + (v10977 || COLORS.ping.low) + "!important;'>signal_cellular_alt</div>") + (v10978 ? "<div class=\"serverTimeLeft\" data-time-left=\"" + (v10979 || 0) + "\">" + (v10980 ? i18n.t("windows.servers.timeLeft", v10980) : i18n.t("windows.servers.starting")) + "</div>" : "");
            var v10982 = "checkedSwitchServer(\"" + v10965 + "\", this.querySelector(\".serverPCount\"))";
            vLS49 += "<div class='settName settNameIn' onmouseenter='playTick()'style='" + (v10971 ? "color:#fff !important;" : "") + "padding-top:10px;margin-top:0px;' onclick='playSelect(0.1);" + v10982 + "'>" + v10981 + "</div>";
          }
        }
        if (!v10959.games.length || !vLN01732) {
          vLS49 += "<div style='margin-left: 30px;margin-top: 5px;margin-bottom: 2px;'>" + i18n.t("windows.servers.none") + "</div>";
        }
        vLS49 += "</div>";
      }
    }
    return vLS49;
  },
  tabIndex: 0,
  switchTab: function (p13689) {
    this.tabIndex = p13689;
    this.expandedRegion = -1;
    updateWindow(2);
  },
  genList: function () {
    var vThis130 = this;
    window.setExpandedRegion = function (p13690) {
      vThis130.expandedRegion = p13690;
      vThis130.lastLoadTime = Date.now();
      var v10983 = document.getElementById("serverHolder");
      if (v10983) {
        v10983.innerHTML = vThis130.getServers();
      }
    };
    var v10984;
    if (SETTINGS.tmp.oldBrowser) {
      v10984 = "<div class='serverHeader'><div class='setBodH' style='padding:10px;margin-top:0px;margin-bottom:8px;width:calc(100% - 20px) !important;margin-left:0px;'><div style='display:inline-block'><a onclick='showWindow(42)'>+ Host Game</a></div><div style='display:inline-block;'><input id='serverSearch' style='width:450px;margin-left:16px;margin-right:18px' type='text' placeholder='Search: FFA, SYD, Burg'" + (this.serverSearch ? " value='" + this.serverSearch + "'" : "") + " oninput='windows[1].searchList()'></input></div><div style='float:right;display:inline-block;'><div id='hostMenuBtn' onclick='windows[0].tabIndex=0;showWindow(1);'><span class='material-icons' style='color:#fff;font-size:40px;margin-bottom:-1px;'>miscellaneous_services</span></div></div><div id=\"hideFull\" style=\"display:inline-block;float:right;margin-right:20px;margin-top:3px;\"><span style='color:#fff'>" + i18n.t("windows.servers.hide") + "</span><label class='switch2' style='margin-top: 4px;margin-left: 11px;'><input type='checkbox' onclick='toggleHF(this.checked);windows[1].searchList()'" + (v10881 ? " checked" : "") + "><span class='slider2'></span></label></div></div></div><div style='height:10px'></div>";
      if (this.customsInfo.length >= 3) {
        v10984 += "<div class='carousel' id='carousel-infinite' style='margin-bottom:25px;'>";
        this.customsInfo.length = Math.min(31, this.customsInfo.length);
        for (var vLN01735 = 0, v10985; vLN01735 < this.customsInfo.length; vLN01735++) {
          v10985 = !!this.customsInfo[vLN01735].oc || !!this.customsInfo[vLN01735].ds;
          v10984 += "<div class='slide' onclick='windows[1].searchList(&quot;" + UTILS.cleanseString(this.customsInfo[vLN01735].n) + "&quot;)'><img class='slideImg' loading='lazy' src='" + UTILS.userAssetsUrl("/m" + this.customsInfo[vLN01735].i + "/thumb.png") + "' onerror='this.onerror=null;this.src=\"./img/noimg.png\";'><div class='slideName'>" + this.customsInfo[vLN01735].n + "</div><div class='slidePlayers'><span class='material-icons'>person</span>" + this.customsInfo[vLN01735].c + "</div>" + (v10985 ? "<div class='slideTag'>24/7</div>" : "") + "</div>";
        }
        v10984 += "</div>";
      }
      v10984 += "<div style='font-size:20px'>";
      v10984 += "<div id='serverHolder'>" + this.getServers() + "</div>";
      v10984 += "<div class='setBodH' style='padding-bottom:10px;margin-top:30px;padding-top:0px;margin-left:0px;width:calc(100% - 40px);'><div style='height:10px'></div><b style='font-size:26px;color:rgba(255,255,255,0.8)'><span style='font-size:26px;color:rgba(255,255,255,0.8)' id='playerCnt'>" + i18n.t("windows.servers.online", UTILS.commaNumber(this.totalPlayerCount)) + "</span><span style='float:right;font-size:26px;color:font-size:26px;color:rgba(255,255,255,0.6);position: absolute;left: 50%;transform: translateX(-50%);' id='editorCnt'>" + i18n.t("windows.servers.editor", UTILS.commaNumber(this.editorPlayerCount)) + "</span><span style='float:right;font-size:26px;color:rgba(255,255,255,0.6)' id='socialCnt'>" + i18n.t("windows.servers.social", UTILS.commaNumber(this.socialPlayerCount)) + "</span></b></div>";
      v10984 += "</div>";
    } else {
      v10984 = "<div class='serverHeader'><div class='setBodH' style='padding:10px;margin-top:0px;margin-bottom:8px;width:calc(100% - 20px) !important;margin-left:0px;'><div style='display:inline-block'><a onclick='showWindow(42)'>+ Host Game</a></div><div style='display:inline-block;'><input id='serverSearch' style='width:450px;margin-left:16px;margin-right:18px' type='text' placeholder='Search: FFA, SYD, Burg'" + (this.serverSearch ? " value='" + this.serverSearch + "'" : "") + " oninput='windows[1].searchList()'></input></div><div style='float:right;display:inline-block;'><div id='hostMenuBtn' onclick='windows[0].tabIndex=0;showWindow(1);'><span class='material-icons' style='color:#fff;font-size:40px;margin-bottom:-1px;'>miscellaneous_services</span></div></div><div id=\"hideFull\" style=\"display:inline-block;float:right;margin-right:20px;margin-top:3px;\"><span style='color:#fff'>" + i18n.t("windows.servers.hide") + "</span><label class='switch2' style='margin-top: 4px;margin-left: 11px;'><input type='checkbox' onclick='toggleHF(this.checked);windows[1].searchList()'" + (v10881 ? " checked" : "") + "><span class='slider2'></span></label></div></div></div><div style='height:10px'></div>";
      v10984 += "<div class='bigMenTabs' style='margin-top:0px !important;margin-bottom:30px !important;'>";
      for (var vLN01735 = 0; vLN01735 < config.serverTabs.length; ++vLN01735) {
        v10984 += "<div class='bigMenTab" + (this.tabIndex == vLN01735 ? " bigMenTabA" : "") + "' style='height:18px;' onclick='playSelect();windows[1].switchTab(" + vLN01735 + ")'>" + config.serverTabs[vLN01735] + "</div>";
      }
      v10984 += "</div>";
      if (this.tabIndex != 2) {
        v10984 += "<div id='serverHolder'>" + this.getServers() + "</div>";
      }
      v10984 += "<div class='setBodH' style='padding-bottom:10px;margin-top:30px;padding-top:0px;margin-left:0px;width:calc(100% - 40px);'><div style='height:10px'></div><b style='font-size:26px;color:rgba(255,255,255,0.8)'><span style='font-size:26px;color:rgba(255,255,255,0.8)' id='playerCnt'>" + i18n.t("windows.servers.online", UTILS.commaNumber(this.totalPlayerCount)) + "</span><span style='float:right;font-size:26px;color:font-size:26px;color:rgba(255,255,255,0.6);position: absolute;left: 50%;transform: translateX(-50%);' id='editorCnt'>" + i18n.t("windows.servers.editor", UTILS.commaNumber(this.editorPlayerCount)) + "</span><span style='float:right;font-size:26px;color:rgba(255,255,255,0.6)' id='socialCnt'>" + i18n.t("windows.servers.social", UTILS.commaNumber(this.socialPlayerCount)) + "</span></b></div>";
      v10984 += "</div>";
    }
    return v10984;
  },
  updateTimeLeft: function (p13691) {
    let v10986 = p13691.querySelectorAll("[data-time-left]:not([data-time-left=\"0\"])");
    v10986.forEach(p13692 => {
      let vParseInt35 = parseInt(p13692.dataset.timeLeft);
      vParseInt35--;
      p13692.dataset.timeLeft = vParseInt35;
      let v10987 = UTILS.getReadableTime((vParseInt35 || 0) * 1000, true, undefined, true);
      p13692.textContent = "" + (v10987 ? i18n.t("windows.servers.timeLeft", v10987) : i18n.t("windows.servers.starting"));
    });
  },
  timeLeftInterval: null,
  updateTimers: function () {
    windows[1].stopTimers();
    windows[1].timeLeftInterval = setInterval(() => {
      let v10988 = document.getElementById("serverHolder");
      if (v10988) {
        windows[1].updateTimeLeft(v10988);
        return;
      } else {
        windows[1].stopTimers();
        return;
      }
    }, 1000);
  },
  stopTimers: function () {
    clearInterval(windows[1].timeLeftInterval);
    windows[1].timeLeftInterval = null;
  },
  post: function () {
    if (this.customsInfo.length >= 3 && SETTINGS.tmp.oldBrowser) {
      var v10989 = document.getElementById("carousel-infinite");
      if (v10989) {
        var v10990 = new PureJSCarousel({
          carousel: "#carousel-infinite",
          slide: ".slide"
        });
      } else {
        requestAnimationFrame(function () {
          var v10991 = new PureJSCarousel({
            carousel: "#carousel-infinite",
            slide: ".slide"
          });
        }, 200);
      }
    }
    if (SETTINGS.list.showServerTimer.val) {
      this.updateTimers();
    }
  },
  close: function () {
    windows[1].stopTimers();
  },
  searchMatches(p13693) {
    var [v10992, v10993, v10994, v10995, v10996] = p13693;
    if (!v10996) {
      return false;
    }
    var v10997 = gameModes[v10996.g] ? gameModes[v10996.g].alias || "" : "";
    var v10998 = v10996.h || v10996.i;
    if (!v10996.oc && !v10996.c && !SETTINGS.tmp.oldBrowser && !!v10997) {
      v10998 = v10997 + "_" + v10998;
    }
    var v10999 = (v10996.c || SETTINGS.tmp.oldBrowser ? v10997 + "_" : "") + v10998;
    var v11000 = config.regionNames[v10993];
    var v11001 = (this.autoPlaySearch || this.serverSearch || "").toLowerCase();
    return (v10996.h || v10996.i || "").toLowerCase().indexOf(v11001) >= 0 || (v10992.split(":")[0] || "").toLowerCase().indexOf(v11001) >= 0 || (v10998 || "").toLowerCase().indexOf(v11001) >= 0 || (v10997 || "").toLowerCase().indexOf(v11001) >= 0 || (v10999 || "").toLowerCase().indexOf(v11001) >= 0 || (v10993 || "").toLowerCase().indexOf(v11001) >= 0 || (v11000 || "").toLowerCase().indexOf(v11001) >= 0;
  }
}, {
  header: i18n.t("windows.loadout.header"),
  label: "customize",
  import: function (p13694) {
    if (p13694) {
      var vO351 = {};
      for (var v11002 in p13694) {
        if (p13694[v11002]) {
          vO351[v11002.replace(/[^a-zA-Z0-9 _-]+/gim, "")] = p13694[v11002];
        }
      }
      saveVal("krk_loadouts", JSON.stringify(vO351));
    }
  },
  action: function (p13695) {
    var v11003 = loadoutSelect.value.replace(/[^a-zA-Z0-9 _-]+/gim, "");
    if ((p13695 == 0 || p13695 == 2) && v11003 == "Select") {
      return;
    }
    let vGetSavedVal9 = getSavedVal("krk_loadouts");
    vGetSavedVal9 = vGetSavedVal9 ? JSON.parse(vGetSavedVal9) : {};
    var v11004 = loadoutName.value.length ? loadoutName.value : v11003 == "Select" ? "Preset1" : v11003;
    if (p13695 == 2) {
      if (vGetSavedVal9[v11003]) {
        delete vGetSavedVal9[v11003];
      }
      saveVal("krk_loadouts", JSON.stringify(vGetSavedVal9));
    } else {
      let v11005 = p13695 == 1 ? {} : vGetSavedVal9[v11003];
      if (p13695 == 1) {
        v11005.skinColIndex = skinColIndex;
        v11005.hairCol = hairCol;
        v11005.chatCol = chatCol;
        v11005.dyeIndex = parseInt(dyeIndex);
        v11005.faceIndex = parseInt(faceIndex);
        v11005.shoeIndex = parseInt(shoeIndex);
        v11005.attachIndex = parseInt(attachIndex);
        v11005.reticleIndex = parseInt(reticleIndex);
        v11005.savedReticle = savedReticle;
        v11005.scopeIndex = parseInt(scopeIndex);
        v11005.savedScope = savedScope;
        v11005.meleeIndex = parseInt(meleeIndex);
        v11005.bodyIndex = parseInt(bodyIndex);
        v11005.backIndex = parseInt(backIndex);
        v11005.petIndex = parseInt(petIndex);
        v11005.wristIndex = parseInt(wristIndex);
        v11005.hatIndex = parseInt(hatIndex);
        v11005.headIndex = parseInt(headIndex);
        v11005.playerCardIndex = parseInt(playerCardIndex);
        v11005.waistIndex = parseInt(waistIndex);
        v11005.secondaryInd = parseInt(secondaryIndex);
        v11005.pcStatIndex = parseInt(pcStatIndex);
        v11005.classindex = parseInt(classIndex);
        v11005.streakIndex1 = parseInt(streakIndex1);
        v11005.streakIndex2 = parseInt(streakIndex2);
        v11005.streakIndex3 = parseInt(streakIndex3);
        v11005.skins = JSON.stringify(skinsLoadout || {});
        v11005.charms = JSON.stringify(selectedCharms || []);
        vGetSavedVal9[v11004] = v11005;
        saveVal("krk_loadouts", JSON.stringify(vGetSavedVal9));
      } else if (p13695 == 0) {
        if ("skinColIndex" in v11005) {
          saveVal("skinColIndex", v11005.skinColIndex);
          skinColIndex = v11005.skinColIndex;
        }
        if ("hairCol" in v11005) {
          saveVal("hairCol", v11005.hairCol);
          hairCol = v11005.hairCol;
        }
        if ("chatCol" in v11005) {
          saveVal("chatCol", v11005.chatCol);
          chatCol = v11005.chatCol;
        }
        if ("dyeIndex" in v11005) {
          saveVal("dyeIndex", v11005.dyeIndex);
          dyeIndex = v11005.dyeIndex;
        }
        if ("faceIndex" in v11005) {
          saveVal("faceIndex", v11005.faceIndex);
          faceIndex = v11005.faceIndex;
        }
        if ("shoeIndex" in v11005) {
          saveVal("shoeIndex", v11005.shoeIndex);
          shoeIndex = v11005.shoeIndex;
        }
        if ("attachIndex" in v11005) {
          saveVal("attachIndex", v11005.attachIndex);
          attachIndex = v11005.attachIndex;
        }
        if ("reticleIndex" in v11005) {
          saveVal("reticleIndex", v11005.reticleIndex);
          reticleIndex = v11005.reticleIndex;
          savedReticle = sanitizeCustomImageUrl(v11005.savedReticle);
          saveVal("savedReticle", savedReticle || "");
          updateAimDot(reticleIndex, savedReticle);
        }
        if ("scopeIndex" in v11005) {
          saveVal("scopeIndex", v11005.scopeIndex);
          scopeIndex = v11005.scopeIndex;
          savedScope = sanitizeCustomImageUrl(v11005.savedScope);
          saveVal("savedScope", savedScope || "");
          updateScope(scopeIndex, savedScope);
        }
        if ("meleeIndex" in v11005) {
          saveVal("meleeIndex", v11005.meleeIndex);
          meleeIndex = v11005.meleeIndex;
        }
        if ("bodyIndex" in v11005) {
          saveVal("bodyIndex", v11005.bodyIndex);
          bodyIndex = v11005.bodyIndex;
        }
        if ("backIndex" in v11005) {
          saveVal("backIndex", v11005.backIndex);
          backIndex = v11005.backIndex;
        }
        if ("hatIndex" in v11005) {
          saveVal("hatIndex", v11005.hatIndex);
          hatIndex = v11005.hatIndex;
        }
        if ("headIndex" in v11005) {
          saveVal("headIndex", v11005.headIndex);
          headIndex = v11005.headIndex;
        }
        if ("playerCardIndex" in v11005) {
          saveVal("playerCardIndex", v11005.playerCardIndex);
          playerCardIndex = v11005.playerCardIndex;
        }
        if ("waistIndex" in v11005) {
          saveVal("waistIndex", v11005.waistIndex);
          waistIndex = v11005.waistIndex;
        }
        if ("pcStatIndex" in v11005) {
          saveVal("pcStatIndex", v11005.pcStatIndex);
          pcStatIndex = v11005.pcStatIndex;
        }
        if ("secondaryInd" in v11005) {
          saveVal("secondaryInd", v11005.secondaryInd);
          secondaryIndex = v11005.secondaryInd;
        }
        if ("classindex" in v11005) {
          saveVal("classindex", v11005.classindex);
          setClassIndex(v11005.classindex || 0);
        }
        if ("skins" in v11005) {
          savedSkins = v11005.skins;
          skinsLoadout = savedSkins ? JSON.parse(savedSkins) : {};
          saveVal("skins", JSON.stringify(skinsLoadout));
        }
        if ("charms" in v11005) {
          savedCharms = v11005.charms;
          selectedCharms = savedCharms ? JSON.parse(savedCharms) : [];
          saveVal("charms", JSON.stringify(selectedCharms));
        }
        if ("petIndex" in v11005) {
          saveVal("petIndex", v11005.petIndex);
          petIndex = v11005.petIndex;
        }
        if ("wristIndex" in v11005) {
          saveVal("wristIndex", v11005.wristIndex);
          wristIndex = v11005.wristIndex;
        }
        if ("streakIndex1" in v11005) {
          saveVal("streakIndex1", v11005.streakIndex1);
          streakIndex1 = v11005.streakIndex1;
          if (!UTILS.isNumber(streakIndex1)) {
            streakIndex1 = -1;
          }
          if (!Game.streaks[streakIndex1]) {
            streakIndex1 = -1;
          }
        }
        if ("streakIndex2" in v11005) {
          saveVal("streakIndex2", v11005.streakIndex2);
          streakIndex2 = v11005.streakIndex2;
          if (!UTILS.isNumber(streakIndex2)) {
            streakIndex2 = 1;
          }
          if (!Game.streaks[streakIndex2]) {
            streakIndex2 = -1;
          }
        }
        if ("streakIndex3" in v11005) {
          saveVal("streakIndex3", v11005.streakIndex3);
          streakIndex3 = v11005.streakIndex3;
          if (!UTILS.isNumber(streakIndex3)) {
            streakIndex3 = 0;
          }
          if (!Game.streaks[streakIndex3]) {
            streakIndex3 = -1;
          }
        }
        updateClassPreview();
        updateWindow(3);
      }
    }
    windows[2].genLoadouts();
  },
  genLoadouts: function (p13696 = false) {
    let vGetSavedVal10 = getSavedVal("krk_loadouts");
    vGetSavedVal10 = vGetSavedVal10 ? JSON.parse(vGetSavedVal10) : {};
    var vLSspanClasssettNameSma = "<span class='settNameSmall' style='margin:0;margin-bottom:5px;border-bottom: unset;'><input id='loadoutName' type='text' class='formInput' placeholder='Loadout name' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' style='border:none;background:#eee;padding-bottom:6px;float:left;margin-top:5px;margin-bottom:5px;'><select id='loadoutSelect'><option selected>Select</option>";
    for (let v11006 in vGetSavedVal10) {
      vLSspanClasssettNameSma += "<option>" + v11006 + "</option>";
    }
    vLSspanClasssettNameSma += "</select>";
    vLSspanClasssettNameSma += "<div class='loadoutBtn' onclick='windows[2].action(2)'>Delete</div><div class='loadoutBtn' onclick='windows[2].action(1)'>Save</div><div class='loadoutBtn' onclick='windows[2].action(0)'>Load</div></span>";
    if (p13696) {
      return vLSspanClasssettNameSma;
    } else {
      loadoutHolder.innerHTML = vLSspanClasssettNameSma;
      return;
    }
  },
  width: 850,
  tabIndex: 1,
  tabSub: 0,
  switchTab: function (p13697, p13698, p13699) {
    this.tabSub = p13699 || 0;
    if (this.tabIndex != p13697 || p13698) {
      this.tabIndex = p13697;
      menuWindow.scrollTop = 0;
      updateWindow(3);
    }
  },
  goBack: function () {
    showWindow(3);
  },
  gen: function () {
    var vLS50 = "";
    vLS50 += "<div id='selectorContainer'>";
    vLS50 += "<div class='selectorItem" + (this.tabIndex == 0 ? " selectedItem" : "") + "' onclick='windows[2].switchTab(0)' onmouseenter='playTick()'><div class='selectorLabel'>Class</div><img loading='lazy' class='selectorIcon pixelated' src='" + UTILS.assetsUrl("/img/customize/class.png") + "'></div>";
    vLS50 += "<div class='selectorItem" + (this.tabIndex == 1 ? " selectedItem" : "") + "' onclick='windows[2].switchTab(1)' onmouseenter='playTick()'><div class='selectorLabel'>Loadout</div><img loading='lazy' class='selectorIcon crisp-edges' src='" + UTILS.assetsUrl("/img/customize/loadout.png") + "'></div>";
    vLS50 += "<div class='selectorItem" + (this.tabIndex == 2 ? " selectedItem" : "") + "' style='font-size: 17px' onclick='windows[2].switchTab(2)' onmouseenter='playTick()'><div class='selectorLabel'>Customize</div><img loading='lazy' class='selectorIcon' src='" + UTILS.assetsUrl("/img/customize/outfit.png") + "'></div>";
    vLS50 += "<div class='selectorItem" + (this.tabIndex == 3 ? " selectedItem" : "") + "' onclick='windows[2].switchTab(3)' onmouseenter='playTick()'><div class='selectorLabel'>Other</div><img loading='lazy' class='selectorIcon' src='" + UTILS.assetsUrl("/img/customize/other.png") + ".png'></div>";
    vLS50 += "</div>";
    vLS50 += "<div id='customizeContainer'" + (this.tabIndex == 2 ? " style='margin-bottom: -10px;text-align: center;'" : "") + ">";
    if (this.tabIndex == 0) {
      vLS50 += "<div class='skinList' style='text-align: center;'>";
      for (var vLN01740 = 0; vLN01740 < Game.classConfig.length; ++vLN01740) {
        player = Game.classConfig[vLN01740];
        if (Game.config.classes.indexOf(vLN01740) >= 0) {
          var v11007 = account && account.stats && account.stats["c" + vLN01740] ? account.stats["c" + vLN01740] : 0;
          var v11008 = config.rankVar * Math.sqrt(v11007);
          var v11009 = Math.floor(v11008);
          var v11010 = Math.round((v11008 - v11009) * 100);
          var v11011 = v11009 > 1 ? Math.pow(v11009 / config.rankVar, 2) : 0;
          var v11012 = Math.pow((v11009 + 1) / config.rankVar, 2);
          v11009 = Math.max(1, v11009 + 1);
          var v11013 = !player.req || player.req(account, Game) || Game.isSandbox;
          vLS50 += "<div class=\"classCard\" onmouseenter=\"playTick()\" " + (v11013 ? "onclick=\"selectClass(" + vLN01740 + ")\"" : "") + ">\n\t\t\t\t\t\t<div class=\"classImgH\">\n\t\t\t\t\t\t\t<img loading=\"lazy\" style=\"image-rendering:pixelated\" class=\"classImgC\" src=\"" + f1772(vLN01740) + "\">\n\t\t\t\t\t\t\t<div class='classHP'>" + player.health + "<span style='color: #868484;font-size: 12px;'> HP</span></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"className\">" + player.name + "</div>\n\t\t\t\t\t\t<div class=\"classWeap\">" + (v11013 ? Game.weaponConfig[player.loadout[0]].name : i18n.t("windows.secondary." + (player.customOnly ? "customOnly" : player.premiumOnly ? "premiumOnly" : "req"), player.minRec)) + "</div>\n\t\t\t\t\t\t<div class='classXPBar'>\n\t\t\t\t\t\t\t<div class='clsXPBarC' style='width:calc(" + v11010 + "% - 8px)'></div>\n\t\t\t\t\t\t\t<div class='clsXPBarV'>" + (parseInt(v11007 - v11011) + " / " + parseInt(v11012 - v11011)) + "</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class='classLvl'>Lvl " + v11009 + "</div>\n\t\t\t\t\t\t" + (v11013 ? "" : "<div class='lockedClass'>\n\t\t\t\t\t\t\t<span class='material-icons' style='font-size: 70px;color:" + (player.premiumOnly ? "var(--yellow)" : "#fff") + ";'>\n\t\t\t\t\t\t\t" + (player.premiumOnly ? "beenhere" : "lock") + "\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>") + "\n\t\t\t\t\t</div>";
        }
      }
      vLS50 += "</div>";
    } else if (this.tabIndex == 1) {
      var v11014 = Game.classConfig[classIndex];
      if (Game.config.classes.indexOf(parseInt(classIndex)) < 0) {
        classIndex = Game.config.classes[0];
        v11014 = Game.classConfig[classIndex];
      }
      var v11015 = v11014.loadout[0] == 12 ? "None" : Game.weaponConfig[v11014.loadout[0]].name;
      var vLSefefef = "#efefef";
      var v11016 = null;
      var v11017 = false;
      var v11018 = UTILS.assetsUrl("/textures/previews/weapons/" + Game.weaponConfig[v11014.loadout[0]].src + ".png");
      var v11019 = v11014.secondary && Game.weaponConfig[secondaryIndex] ? Game.weaponConfig[secondaryIndex].name : "None";
      var v11020 = v11014.secondary ? "#2196F3" : "#efefef";
      var v11021 = null;
      var v11022 = false;
      var v11023 = UTILS.assetsUrl("/textures/previews/weapons/" + Game.weaponConfig[secondaryIndex].src + ".png");
      var v11024 = meleeIndex == -2 ? "Random" : "Combat Knife";
      var vLSefefef2 = "#efefef";
      var v11025 = null;
      var v11026 = false;
      var v11027 = UTILS.assetsUrl("/textures/previews/cosmetics/3_default.png");
      var v11028 = (Game.weaponConfig[v11014.loadout[0]].attach != null || Game.store.skins[skinsLoadout[v11014.loadout[0]]] && Game.store.skins[skinsLoadout[v11014.loadout[0]]].attachBypass) && !Game.weaponConfig[v11014.loadout[0]].forceAttach;
      var vLSNone = "None";
      var vLSefefef3 = "#efefef";
      var v11029 = null;
      var v11030 = false;
      var v11031 = UTILS.assetsUrl("/textures/previews/cosmetics/12_default.png");
      var vLSNone2 = "None";
      var vLSefefef4 = "#efefef";
      var v11032 = null;
      var v11033 = false;
      var v11034 = UTILS.assetsUrl("/textures/previews/cosmetics/12_default.png");
      if (account) {
        if (skinsLoadout[v11014.loadout[0]] != null && v11014.loadout[0] != 12) {
          var vO352 = Game.store.skins[skinsLoadout[v11014.loadout[0]]];
          if (vO352) {
            vLSefefef = Game.store.rarities[vO352.rarity || 0].color;
            if (Game.store.rarities[vO352.rarity]) {
              v11016 = Game.store.rarities[vO352.rarity].color;
            }
            v11017 = Game.store.rarities[vO352.rarity || 0].animate;
            v11015 = vO352.name;
            v11018 = vO352.thumbnail;
            if (vO352.forceAttach) {
              v11028 = false;
            }
          } else if (skinsLoadout[v11014.loadout[0]] == -2) {
            v11015 = "Random";
            vLSefefef = "#2196F3";
          }
        }
        if (v11014.secondary && skinsLoadout[secondaryIndex] != null) {
          var vO352 = Game.store.skins[skinsLoadout[secondaryIndex]];
          if (vO352) {
            v11020 = Game.store.rarities[vO352.rarity || 0].color;
            if (Game.store.rarities[vO352.rarity]) {
              v11021 = Game.store.rarities[vO352.rarity].color;
            }
            v11022 = Game.store.rarities[vO352.rarity || 0].animate;
            v11019 = vO352.name;
            v11023 = vO352.thumbnail;
          } else if (skinsLoadout[secondaryIndex] == -2) {
            v11019 = "Random";
          }
        }
        if (meleeIndex >= 0 && Game.store.skins[meleeIndex]) {
          var vO352 = Game.store.skins[meleeIndex];
          if (vO352) {
            v11026 = Game.store.rarities[vO352.rarity || 0].animate;
            if (Game.store.rarities[vO352.rarity]) {
              v11025 = Game.store.rarities[vO352.rarity].color;
            }
            v11024 = vO352.name;
            vLSefefef2 = Game.store.rarities[vO352.rarity || 0].color;
            v11027 = vO352.thumbnail;
          }
        }
        if (v11014.loadout[0] != 12) {
          var v11039 = Game.store.skins[selectedCharms[0]];
          if (v11039) {
            vLSefefef3 = Game.store.rarities[v11039.rarity || 0].color;
            if (Game.store.rarities[v11039.rarity]) {
              v11029 = Game.store.rarities[v11039.rarity].color;
            }
            v11030 = Game.store.rarities[v11039.rarity || 0].animate;
            vLSNone = v11039.name;
            v11031 = v11039.thumbnail;
          } else if (selectedCharms[0] == -2) {
            vLSNone = "Random";
            vLSefefef3 = "#2196F3";
          }
        }
        if (v11014.secondary) {
          var v11039 = Game.store.skins[selectedCharms[1]];
          if (v11039) {
            vLSefefef4 = Game.store.rarities[v11039.rarity || 0].color;
            if (Game.store.rarities[v11039.rarity]) {
              v11032 = Game.store.rarities[v11039.rarity].color;
            }
            v11033 = Game.store.rarities[v11039.rarity || 0].animate;
            vLSNone2 = v11039.name;
            v11034 = v11039.thumbnail;
          } else if (selectedCharms[1] == -2) {
            vLSNone2 = "Random";
            vLSefefef4 = "#2196F3";
          }
        }
      }
      var v11040 = v11028 && Game.attach[attachIndex] ? Game.attach[attachIndex].name : "None";
      var vV11028 = v11028;
      var v11041 = vV11028 && reticles[reticleIndex] ? reticles[reticleIndex].name : reticleIndex == -2 ? "Custom" : "None";
      var v11042 = vV11028 && reticles[reticleIndex] ? UTILS.assetsUrl("/textures/reticles/reticle_" + reticles[reticleIndex].id + "." + (reticles[reticleIndex].type || "png")) : reticleIndex == -2 ? savedReticle : "";
      var v11043 = Game.weaponConfig[v11014.loadout[0]].scope != null;
      var v11044 = v11043 && aimRecticles[scopeIndex] ? aimRecticles[scopeIndex].name : scopeIndex == -2 ? "Custom" : "None";
      var v11045 = v11043 && aimRecticles[scopeIndex] ? UTILS.assetsUrl("/textures/scopes/scope_" + aimRecticles[scopeIndex].id + "." + (aimRecticles[scopeIndex].type || "png")) : scopeIndex == -2 ? savedScope : "";
      vLS50 += "<div id='loadoutHolder' style='text-align:left;margin-bottom:5px;margin-top: -8px;'>" + windows[2].genLoadouts(true) + "</div>";
      vLS50 += "<div style='margin-top: 10px;'>";
      vLS50 += "<div class='custContainer" + (v11014.loadout[0] == 12 ? "" : " contCanSelect' onclick='skinSelector(" + v11014.loadout[0] + ")") + "' style='width: 47.5%;height: 163px;' onmouseenter='playTick()'>";
      vLS50 += "<div class='custItNm'>" + i18n.t("windows.loadout.primary") + "</div>";
      vLS50 += "<span class='settLabel " + (vLSefefef == "#292929" ? "greyShad" : "blackShad") + "" + (RENDER.rarityAnim && v11017 ? " rainbowText" : "") + "' style='color:" + vLSefefef + ";right: unset;left: 8px;'>" + v11015 + "</span>";
      if (v11015 == "Random") {
        vLS50 += "<img draggable='false' class='custIcon custSil' src='" + v11018 + "'>";
        vLS50 += "<div class='selRandom blackShad'>?</div>";
      } else if (v11015 == "None") {
        vLS50 += "<div class='selRandom blackShad'>X</div>";
      } else {
        vLS50 += "<img class='custIcon' src='" + v11018 + "'" + (v11016 ? " style='filter:drop-shadow(0 0 0.2rem " + v11016 + "88)'" : "") + ">";
      }
      var v11046 = Game.weaponConfig[v11014.loadout[0]] && Game.weaponConfig[v11014.loadout[0]].charm && (!Game.store.skins[selectedCharms[0]] || !Game.store.skins[selectedCharms[0]].noCharm);
      vLS50 += v11046 ? "<div class=\"custSubContainer\" onclick=\"charmSelector(0)\">\n\t\t\t\t<div class=\"custItNm\" style=\"font-size: 12px;\">" + i18n.t("windows.loadout.charm") + "</div>\n\t\t\t\t" + (vLSNone == "None" ? "<div class=\"selRandom blackShad\" style=\"font-size: 20px;\">X</div>" : vLSNone == "Random" ? "<img draggable='false' class='custIcon custSil' src='" + v11031 + "'>\n\t\t\t\t\t<div class='selRandom blackShad' style=\"font-size: 20px;\">?</div>" : "<img class=\"custIcon\" src=\"" + v11031 + "\" " + (v11029 ? " style=\"margin-top:0;filter:drop-shadow(0 0 0.2rem " + v11029 + "88)\"" : "") + ">") + "\n\t\t\t</div>" : "";
      vLS50 += v11028 ? "<div class=\"custSubContainer contCanSelect" + (v11046 ? " bottom" : "") + "\" onclick=\"viewAttachments()\">\n\t\t\t\t<div class=\"custItNm\" style=\"font-size: 12px;\">" + i18n.t("windows.loadout.primary.sight") + "</div>\n\t\t\t\t" + (v11040 == "None" ? "<div class=\"selRandom blackShad\" style=\"font-size: 20px;\">X</div>" : "<img class=\"custIcon\" src=\"" + UTILS.assetsUrl("/textures/previews/attach/attach_" + Game.attach[attachIndex].id + ".png") + "\">") + "\n\t\t\t</div>" : "";
      vLS50 += "</div> ";
      vLS50 += "<div class='custContainer" + (v11014.secondary ? " contCanSelect' onclick='showWindow(20)" : "") + "' style='width: 47.5%;height: 163px;' onmouseenter='playTick()'>";
      vLS50 += "<div class='custItNm'>" + i18n.t("windows.loadout.secondary") + "</div>";
      vLS50 += "<span class='settLabel " + (v11020 == "#292929" ? "greyShad" : "blackShad") + "" + (RENDER.rarityAnim && v11022 ? " rainbowText" : "") + "' style='color:" + v11020 + ";right: unset;left: 8px;'>" + v11019 + "</span>";
      if (v11019 == "Random") {
        vLS50 += "<img draggable='false' class='custIcon custSil' src='" + v11023 + "'>";
        vLS50 += "<div class='selRandom blackShad'>?</div>";
      } else if (v11019 == "None") {
        vLS50 += "<div class='selRandom blackShad'>X</div>";
      } else {
        vLS50 += "<img class='custIcon' src='" + v11023 + "'" + (v11021 ? " style='filter:drop-shadow(0 0 0.2rem " + v11021 + "88)'" : "") + ">";
      }
      var v11047 = v11014.secondary && Game.weaponConfig[secondaryIndex] && Game.weaponConfig[secondaryIndex].charm && (!Game.store.skins[selectedCharms[1]] || !Game.store.skins[selectedCharms[1]].noCharm);
      vLS50 += v11047 ? "<div class=\"custSubContainer\" onclick=\"charmSelector(1)\">\n\t\t\t\t<div class=\"custItNm\" style=\"font-size: 12px;\">" + i18n.t("windows.loadout.charm") + "</div>\n\t\t\t\t" + (vLSNone2 == "None" ? "<div class=\"selRandom blackShad\" style=\"font-size: 20px;\">X</div>" : vLSNone2 == "Random" ? "<img draggable='false' class='custIcon custSil' src='" + v11034 + "'>\n\t\t\t\t\t<div class='selRandom blackShad' style=\"font-size: 20px;\">?</div>" : "<img class=\"custIcon\" src=\"" + v11034 + "\" " + (v11032 ? " style=\"margin-top:0;filter:drop-shadow(0 0 0.2rem " + v11032 + "88)\"" : "") + ">") + "\n\t\t\t</div>" : "";
      vLS50 += "</div> ";
      vLS50 += "<div class='custContainer contCanSelect' onclick='showWindow(26)' style='width: 30.7%;height: 163px;' onmouseenter='playTick()'>";
      vLS50 += "<div class='custItNm'>" + i18n.t("windows.loadout.melee") + "</div>";
      vLS50 += "<span class='settLabel " + (vLSefefef2 == "#292929" ? "greyShad" : "blackShad") + "" + (RENDER.rarityAnim && v11026 ? " rainbowText" : "") + "' style='color:" + vLSefefef2 + "'>" + v11024 + "</span>";
      if (v11024 == "Random") {
        vLS50 += "<img draggable='false' class='custIcon custSil' src='" + v11027 + "'>";
        vLS50 += "<div class='selRandom blackShad'>?</div>";
      } else if (v11024 == "None") {
        vLS50 += "<div class='selRandom blackShad'>X</div>";
      } else {
        vLS50 += "<img class='custIcon' src='" + v11027 + "'" + (v11025 ? " style='filter:drop-shadow(0 0 0.2rem " + v11025 + "88)'" : "") + ">";
      }
      vLS50 += "</div> ";
      var v11048 = vV11028 || v11043;
      vLS50 += "<div class='custContainer" + (vV11028 || v11043 ? " contCanSelect' onclick='showWindow(" + (vV11028 ? 32 : 41) + ")" : "") + "' onmouseenter='playTick()' style='width: 30.7%;height: 163px;'>";
      vLS50 += "<div class='custItNm'>" + i18n.t("windows.loadout.primary." + (vV11028 ? "reticle" : "scope")) + "</div>";
      vLS50 += "<span class='settLabel blackShad' style='color:" + ((vV11028 || v11043) && (vV11028 ? v11041 : v11044) != "None" ? "#2196F3" : "#efefef") + "'>" + (vV11028 ? v11041 : v11044) + "</span>";
      vLS50 += (vV11028 || v11043) && (vV11028 ? v11041 : v11044) != "None" && (vV11028 ? v11042 : v11045) ? "<img class='custIconScope' src='" + (vV11028 ? v11042 : v11045) + "'>" : "<div class='selRandom blackShad'>X</div>";
      vLS50 += "</div> ";
      var vA605 = [streakIndex1, streakIndex2, streakIndex3];
      vLS50 += "<div class='custContainer contCanSelect' onclick='showWindow(45)' onmouseenter='playTick()' style='width: 30.7%;height: 163px;'>";
      vLS50 += "<div class='custItNm'>" + i18n.t("windows.loadout.streaks") + "</div>";
      var vLS51 = "";
      for (var vLN01740 = 0; vLN01740 < vA605.length; vLN01740++) {
        if (Game.streaks[vA605[vLN01740]]) {
          vLS51 += "<img class='custStreakIcon' src='" + UTILS.assetsUrl("/img/streaks/" + vA605[vLN01740] + ".png") + "'>";
        }
      }
      vLS50 += vLS51 ? "<div class='custStreakIconH'>" + vLS51 + "</div>" : "<div class='selRandom blackShad'>X</div>";
      vLS50 += "</div>";
    } else if (this.tabIndex == 2) {
      for (var vA606 = [["hat", 1, hatIndex, 16, 1], ["head", 15, headIndex, 51, 0], ["face", 7, faceIndex, 39], ["body", 2, bodyIndex, 17, 4], ["back", 14, backIndex, 50, 3], ["dye", 5, dyeIndex, 34], ["waist", 6, waistIndex, 38], ["shoe", 8, shoeIndex, 40], ["pet", 9, petIndex, 43], ["wrist", 11, wristIndex, 44], ["spray", null, sprayIndex, 9], ["playerCard", 16, playerCardIndex, 52]], vA607 = [], vLN01740 = 0; vLN01740 < vA606.length; vLN01740++) {
        var v11049 = false;
        var vLSefefef5 = "#efefef";
        var v11050 = vA606[vLN01740][2] == -2 ? "Random" : "None";
        var v11051 = vA606[vLN01740][0] == "spray" ? UTILS.assetsUrl("/textures/sprays/0.png") : UTILS.assetsUrl("/textures/previews/cosmetics/" + vA606[vLN01740][1] + "_default.png");
        var vO352 = {};
        var vLSBlackShad = "blackShad";
        var v11052 = vA606[vLN01740][1] == 16 ? "custIconCard" : "custIcon";
        var v11053 = vA606[vLN01740][4] != null;
        var v11054 = account && account.premiumT > 0;
        if (Game.isSandbox) {
          v11053 = false;
        }
        if (account && account.isDev) {
          v11053 = false;
        }
        var v11055 = false;
        if (v11053 && !v11054) {
          var v11056 = vA606[vA606[vLN01740][4]];
          var v11057 = v11056[2] && (v11056[2] >= 0 || v11056[2] == -2);
          v11055 = !!v11057;
          if (v11055) {
            vA606[vLN01740][2] = -1;
          }
        }
        if (vA606[vLN01740][2] >= 0 && Game.store.skins[vA606[vLN01740][2]] && (account || Game.store.skins[vA606[vLN01740][2]].free)) {
          vO352 = Game.store.skins[vA606[vLN01740][2]];
          if (vO352) {
            v11050 = vO352.name;
            v11049 = Game.store.rarities[vO352.rarity || 0].animate;
            vLSefefef5 = Game.store.rarities[vO352.rarity || 0].color;
            if (vO352.rarity == rarities.CONTRABAND) {
              vLSBlackShad = "greyShad";
            }
            v11051 = vO352.thumbnail;
          }
        }
        if (v11055) {
          vLS50 += "<div class='custContainer' onclick='windows[13].premium()' style='width: 22.5%;height: 174px;'>";
          vLS50 += "<div class='custItNm blackShad'>" + i18n.t("windows.loadout." + vA606[vLN01740][0]) + "</div>";
          vLS50 += "<div class=\"custPremReq blackShad\">\n\t\t\t\t\t\t<div style=\"color: var(--yellow);font-size: 15px;\">Premium Required to use Both</div>\n\t\t\t\t\t\tor\n\t\t\t\t\t\t<div style=\"color: var(--red);font-size: 15px;\">Remove " + i18n.t("windows.loadout." + vA606[vA606[vLN01740][4]][0]) + "</div>\n\t\t\t\t\t</div>";
          vLS50 += "</div> ";
        } else {
          vLS50 += "<div class='custContainer contCanSelect' onclick='showWindow(" + vA606[vLN01740][3] + ")' onmouseenter='playTick()' style='width: 22.25%;height: 174px;'>";
          vLS50 += "<div class='custItNm blackShad'>" + i18n.t("windows.loadout." + vA606[vLN01740][0]) + "</div>";
          vLS50 += "<div class='custClear' onclick='windows[" + (vA606[vLN01740][3] - 1) + "].clear();'><span class='material-icons'>close</span></div>";
          vLS50 += "<span class='custLabel " + vLSBlackShad + "" + (RENDER.rarityAnim && v11049 ? " rainbowText" : "") + "' style='color:" + vLSefefef5 + "'>" + v11050 + "</span>";
          if (v11050 == "Random") {
            vLS50 += "<img draggable='false' class='" + v11052 + " custSil' style='margin-top: 0px;' src='" + v11051 + "'>";
            vLS50 += "<div class='selRandom blackShad'>?</div>";
          } else if (v11050 == "None") {
            vLS50 += "<div class='selRandom blackShad'>X</div>";
          } else if (vO352 && vO352.type == itemTypes.SPRAY) {
            if (vO352.frames && vA607.indexOf(vO352.frames) == -1) {
              vA607.push(vO352.frames);
            }
            vLS50 += "<div draggable='false' class='custIconSpray' style='background: url(&quot;" + vO352.thumbnail + "&quot;) -1px;" + UTILS.getFrameAnim(vO352, "custIconAnm") + "'></div>";
          } else {
            vLS50 += "<img class='" + v11052 + "' style='margin-top: 0px;' src='" + v11051 + "'>";
          }
          vLS50 += "</div> ";
        }
      }
      vLS50 += "<div style='margin-bottom: 10px'></div>";
      if (vA607.length) {
        vLS50 += "<style>";
        for (var vLN01740 = 0; vLN01740 < vA607.length; vLN01740++) {
          vLS50 += "@keyframes custIconAnm" + vA607[vLN01740] + " {100%{background-position:-" + vA607[vLN01740] * 144 + "px}}";
        }
        vLS50 += "</style>";
      }
    } else if (this.tabIndex == 3) {
      vLS50 += "<div class='settName' style='border-bottom:unset;'>" + i18n.t("windows.loadout.color.skin") + (account && account.premiumT > 0 ? "<input class='skinColorItem' " + (UTILS.isHexColor(skinColIndex) ? "value='" + skinColIndex + "' " : "") + "type='color' style='border-radius:2px;width:40px;' onmouseenter='playTick()' onchange='selectSkinColor(this.value)'>" : "<i class='material-icons premiumSkinCol' onclick='windows[13].premium()'>add_circle_outline</i>");
      for (var vLN01740 = config.skinColors.length - 1; vLN01740 >= 0; vLN01740--) {
        if (!config.skinColors[vLN01740].req || config.skinColors[vLN01740].req(account)) {
          vLS50 += "<div class='skinColorItem" + (parseInt(skinColIndex) == vLN01740 ? " activeSkin" : "") + "' style='background-color:#" + config.skinColors[vLN01740].col.toString(16) + "' onmouseenter='playTick()' onclick='selectSkinColor(" + vLN01740 + ")'></div>";
        }
      }
      vLS50 += "</div>";
      vLS50 += "<div class='settName' style='border-bottom:unset;'>" + i18n.t("windows.loadout.color.hair") + (account && account.premiumT > 0 ? "<input class='skinColorItem' " + (UTILS.isHexColor(hairCol) ? "value='" + hairCol + "' " : "") + "type='color' style='border-radius:2px;width:40px;' onmouseenter='playTick()' onchange='selectHairColor(this.value)'>" : "<i class='material-icons premiumSkinCol' onclick='windows[13].premium()'>add_circle_outline</i>") + "</div>";
      vLS50 += "<div class='settName' style='border-bottom:unset;'>" + i18n.t("windows.loadout.color.chat") + (account && account.premiumT > 0 ? "<input class='skinColorItem' value='" + (UTILS.isHexColor(chatCol) ? chatCol : "#ffffff") + "' type='color' style='border-radius:2px;width:40px;' onmouseenter='playTick()' onchange='selectChatColor(this.value)'>" : "<i class='material-icons premiumSkinCol' onclick='windows[13].premium()'>add_circle_outline</i>") + "</div>";
      vLS50 += "<div class='settName' style='border-bottom:unset;'>" + i18n.t("windows.loadout.stat") + "<select onchange='selectStat(this.value)' class='inputGrey2' style='font-size:16px;padding:4px;margin-bottom: 5px;'><option value='-1' " + (pcStatIndex == -1 ? "selected" : "") + ">None</option>";
      for (var vLN01740 = 0; vLN01740 < config.playerCardStats.length; vLN01740++) {
        vLS50 += "<option value='" + vLN01740 + "' " + (pcStatIndex == vLN01740 ? "selected" : "") + ">" + config.playerCardStats[vLN01740].name + "</option>";
      }
      vLS50 += "</select></div>";
    }
    vLS50 += "</div>";
    return vLS50;
  }
}, {
  header: i18n.t("windows.mods.header"),
  label: "mods",
  tabIndex: 0,
  width: 1460,
  maxH: "calc(100% - 325px)",
  yPos: 48,
  dark: true,
  popup: true,
  listData: {},
  loadedMods: [],
  searchId: config.modTabs.findIndex(p13700 => p13700.search),
  searchMods: function () {
    searchResultsMO.innerHTML = "Loading...";
    API_CLIENT.searchMod(mdSrch.value, f1853);
  },
  searchResp: function (p13701) {
    var vLS52 = "";
    if (p13701.length) {
      vLS52 += "<div style='height:10px'></div>";
      vLS52 += f1825(p13701, "mod", this.searchId);
      if (!this.listData[this.tabIndex]) {
        this.listData[this.tabIndex] = {};
      }
      this.listData[this.tabIndex].list = p13701;
    } else {
      vLS52 = i18n.t("windows.mods.none");
    }
    if (document.getElementById("searchResultsMO")) {
      document.getElementById("searchResultsMO").innerHTML = vLS52;
    }
  },
  loadMore: function (p13702) {
    if (!this.listData[this.tabIndex].waiting) {
      if (p13702) {
        p13702.className = "loadMoreW";
        p13702.innerHTML = "Loading...";
      }
      this.listData[this.tabIndex].waiting = true;
      this.listData[this.tabIndex].loadInd += 1;
      API_CLIENT.listMods(this.tabIndex, this.listData[this.tabIndex].loadInd, account ? account.id : null, f1852);
    }
  },
  modsLoaded: function (p13703, p13704, p13705) {
    if (modList) {
      this.listData[p13704].waiting = false;
      if (!p13703 || !p13703.length) {
        if (!this.listData[p13704].dat) {
          modList.innerHTML = i18n.t("windows.mods.none");
          this.listData[p13704] = null;
        }
      } else if (p13705) {
        if (!this.listData[p13704].dat) {
          modList.innerHTML = p13705;
          this.listData[p13704] = null;
        }
      } else {
        var vIii22 = f1825(p13703, "mod", p13704);
        this.listData[p13704].dat = (this.listData[p13704].dat || "") + vIii22;
        this.listData[p13704].list = p13703;
        if (this.tabIndex == p13704) {
          updateWindow(4);
        }
      }
    }
  },
  switchTab: function (p13706) {
    if (this.tabIndex != p13706) {
      this.tabIndex = p13706;
      updateWindow(4);
    }
  },
  autoload: function (p13707, p13708) {
    var v11059 = this.listData[this.tabIndex].list.find(p13709 => p13709.mod_id == p13707);
    v11059;
  },
  loaded: function (p13710, p13711, p13712, p13713, p13714, p13715, p13716, p13717) {
    var vO353 = {};
    if (p13716) {
      vO353.t = 1;
    }
    if (!this.loadedMods.find(p13718 => p13718.name == p13713)) {
      if (!p13713 && p13717) {
        p13713 = "Auto Loaded";
      }
      if (!p13713 && p13712) {
        p13713 = "Server Mod";
      }
      this.loadedMods.push({
        mod_name: p13713 || "Mod",
        mod_url: p13710,
        mod_id: p13714,
        creatorname: p13715,
        mod_info: JSON.stringify(vO353)
      });
    }
  },
  reset: function (p13719) {
    this.loadedMods.length = 0;
    RENDER.reset();
    RENDER.resetShaderPasses();
    SOUND.reset();
    var v11060 = document.getElementById("customCSS");
    if (v11060) {
      v11060.remove();
    }
    if (v11760) {
      mainLogo.src = v11760;
    }
    modVote.style.display = "none";
    if (p13719) {
      io_addChat(-1, null, "Mods Cleared", 2);
    } else {
      updateWindow(4);
      io_showPopup("SUCCESS", null, [i18n.t("mod.reset.0"), "<small>" + i18n.t("mod.reset.1") + "</small>"]);
    }
  },
  gen: function () {
    var v11061 = config.modTabs[this.tabIndex];
    var vLSdivClassbigMenTabs = "<div class='bigMenTabs'>";
    for (var vLN01741 = 0; vLN01741 < config.modTabs.length; ++vLN01741) {
      vLSdivClassbigMenTabs += "<div class='bigMenTab" + (this.tabIndex == vLN01741 ? " bigMenTabA" : "") + "' onmouseenter='playTick(0.1);' onclick='playSelect();windows[3].switchTab(" + vLN01741 + ")'>" + (config.modTabs[vLN01741].txt || config.modTabs[vLN01741].n) + "</div>";
    }
    vLSdivClassbigMenTabs += "</div>";
    var vLS53 = "";
    if (v11061.search) {
      vLS53 = "<input type='text' id='mdSrch' class='smlInput' placeholder='Mod Name or Keyword' onkeydown='if(window.event.keyCode==13)windows[3].searchMods()' /><div class='searchBtn' onclick='windows[3].searchMods()'><span class='material-icons' style='color:#fff;font-size:45px;margin-bottom:-30px;line-height:75px'>search</span></div><div style='color:rgba(0,0,0,0.5);margin-top:10px' id='searchResultsMO'></div>";
    } else if (v11061.noLoad) {
      if (this.loadedMods.length) {
        vLS53 += f1826(this.loadedMods);
        vLS53 += "<div class='loadMoreD' onclick='windows[3].reset()'>Reset Mods</div>";
      } else {
        vLS53 += i18n.t("windows.mods.none");
      }
    } else if (this.listData[this.tabIndex]) {
      if (this.listData[this.tabIndex].dat) {
        vLS53 = this.listData[this.tabIndex].dat;
        if (this.listData[this.tabIndex].waiting) {
          vLS53 += "<div class='loadMoreW'>Loading...</div>";
        } else if (!v11061.sendID && !v11061.noPages) {
          vLS53 += "<div class='loadMoreD' onclick='windows[3].loadMore(this)'>Load More</div>";
        }
      } else {
        vLS53 = "<div class='loadMoreW'>Loading...</div>";
      }
    } else {
      vLS53 = "<div class='loadMoreW'>Loading...</div>";
      this.listData[this.tabIndex] = {
        loadInd: 0
      };
      API_CLIENT.listMods(this.tabIndex, 0, account ? account.id : null, f1852);
    }
    var vLS54 = "";
    if (v11061.home) {
      var v11062 = this.listData[this.tabIndex];
      if (v11062 && v11062.list) {
        var v11063 = v11062.list[UTILS.randInt(0, v11062.list.length - 1)];
        var v11064 = UTILS.cleanseString(v11063.creatorname);
        var v11065 = UTILS.getAssetData(v11063.mod_info);
        var v11066 = v11065 && v11065.t ? UTILS.userAssetsUrl("/m" + ("d" + v11063.mod_id) + "/thumb.png") : "";
        vLS54 += "<div class='bigMFeatHold' style='background-image:linear-gradient(to right, black, rgba(0, 0, 0, 0.5)),url(" + v11066 + ".png);'><div id='bigMFeatName' style='top:200px;'>" + v11063.mod_name + "</div><div id='bigMFeatVbar' style='top:275px;'>" + UTILS.commaNumber(v11063.mod_votes) + "<span class='material-icons' style='margin-left:10px;font-size:33px;vertical-align:top;color:rgba(255,255,255,0.5);'>thumb_up</span><div style='color:#7d7d7d;margin-left:20px;margin-top:-12px;display:inline-block;vertical-align:middle;'>by <a>" + v11064 + "</a></div></div><div id='bigMFeatPBtn' style='bottom:30px;width:230pxheight:40px;padding-top:10px;' onclick='loadUserMod(`" + v11063.mod_name + "`,`" + v11063.mod_url + "`,`" + v11063.mod_id + "`,`" + v11064 + "`," + ~~(v11065 && v11065.t) + ")'>Load Mod <span class='material-icons' style='font-size:40px;color:#fff;vertical-align:top;margin-top:-3px;margin-left:5px'>move_to_inbox</span></div><div id='bigMFeatHBtn' style='bottom:30px;right:320px;width:auto;height:40px;padding-top:8px;' onclick='openURL(`/social.html?p=profile&q=" + v11064 + "`)'>by <span style='color:#fff;'>" + v11064 + "</span></div></div>";
        vLS54 += "<div class='mapListCat' style='margin-bottom:10px;padding-bottom:10px;margin-top:20px;'>Featured Mods</div>";
      }
    }
    return "<a href='javascript:;' onclick='showWindow(18)' class='menuLink'>Load Mod</a> | <a href='/social.html?p=mods&openPubMo' target='_blank' class='menuLink'>Upload Mod</a><div style='float:right'> <span style='color:rgba(255,255,255,0.5)'>30,000+</span> Mods | <a href='/viewer.html' class='menuLink'>Model Viewer</a></div><div style='margin-top:30px;margin-bottom:10px'>" + vLSdivClassbigMenTabs + "</div>" + vLS54 + "<div style='color:rgba(255,255,255,0.3)' id='modList'>" + vLS53 + "</div>";
  }
}, {
  header: i18n.t("windows.account.header"),
  label: "profile",
  aSuccess: false,
  dark: true,
  width: 1280,
  maxH: "calc(100% - 330px)",
  aResp: function (p13720, p13721) {
    if (p13720) {
      io_showPopup(null, p13720);
    } else {
      io_showPopup("SUCCESS");
      account.alias = p13721;
      updateMenuAccountData();
      updateClassPreview();
      updateWindow(null, true);
    }
  },
  tabIndex: 0,
  switchTab: function (p13722) {
    windows[4].tabIndex = p13722;
    updateWindow(5);
  },
  friendsLoaded: function (p13723) {
    updateWindow(5);
  },
  promoData: undefined,
  promosLoaded: function (p13724) {
    this.promoData = p13724 || null;
    updateWindow(5);
  },
  drops: null,
  dropsLoaded: function (p13725) {
    if (!p13725 || !p13725.length) {
      io_showPopup(null, "Nothing to Claim");
      return;
    }
    if (account) {
      var vLSdivStylecolorffffont = "<div style='color:#fff;font-size:20px;position:relative;margin-bottom:15px;text-align: center;'>Drops Redeemed</div><div id='skinList' style='text-align: center;'>";
      var vA608 = [];
      for (var vLN01743 = 0; vLN01743 < p13725.length; vLN01743++) {
        p13725[vLN01743] = parseInt(p13725[vLN01743]);
        account.addSkin(p13725[vLN01743]);
        player = Game.store.skins[p13725[vLN01743]];
        if (player) {
          vLSdivStylecolorffffont += "<div class='tItemHolder' style='border: 2px solid " + Game.store.rarities[player.rarity].color + ";' onclick='openSales(" + p13725[vLN01743] + ")'>" + (player.type && player.type == itemTypes.SPRAY ? "<div class='tItemSprayImg' style='background: url(&quot;" + player.thumbnail + "&quot;);" + UTILS.getFrameAnim(player, "sprayAnm") + "'></div>" : "<img draggable='false' class='tItemImg' loading='lazy' src='" + player.thumbnail + "'>") + "<div class='tItemN'>" + player.name + "</div></div>";
          if (player.type && player.type == itemTypes.SPRAY && player.frames && vA608.indexOf(player.frames) == -1) {
            vA608.push(player.frames);
          }
        }
      }
      vLSdivStylecolorffffont += "</div>";
      if (vA608.length) {
        var vLSstyle = "<style>";
        for (var vLN01743 = 0; vLN01743 < vA608.length; vLN01743++) {
          vLSstyle += "@keyframes sprayAnm" + vA608[vLN01743] + " {100%{background-position:-" + vA608[vLN01743] * 68 + "px}}";
        }
        vLSstyle += "</style>";
        vLSdivStylecolorffffont = vLSstyle + vLSdivStylecolorffffont;
      }
      genericPopup(vLSdivStylecolorffffont, "twitchPop");
      updateWindow(5);
    }
  },
  claimDrops: function () {
    io_loadingPopup("Please Wait...");
    io.send("gtd");
  },
  claimNFTs: function () {
    io_loadingPopup("Please Wait...");
    io.send("cnft");
  },
  collapseCon: function (p13726) {
    let v11067 = document.getElementById("setBod_" + p13726.id.split("setHed_")[1]);
    let v11068 = v11067.style.display == "none";
    p13726.children[0].innerHTML = "keyboard_arrow_" + (v11068 ? "down" : "right");
    v11067.style.display = v11068 ? null : "none";
  },
  switchStat: function (p13727) {
    for (var vLN01744 = 0, v11069; vLN01744 < config.statTabs.length; ++vLN01744) {
      v11069 = document.getElementById("statTab" + vLN01744);
      if (v11069) {
        if (vLN01744 == p13727) {
          v11069.classList.add("bigMenTabA");
        } else {
          v11069.classList.remove("bigMenTabA");
        }
        document.querySelectorAll(".statTabB" + vLN01744).forEach(function (p13728) {
          if (p13727 == vLN01744) {
            p13728.classList.remove("hide");
          } else {
            p13728.classList.add("hide");
          }
        });
      }
    }
  },
  gen: function () {
    if (window.isBotFTUE) {
      return exitBotFTUE(true);
    }
    var vLS55 = "";
    this.width = account ? 1280 : 955;
    if (account) {
      vLS55 += "<div style='height:15px;'></div><div class='bigMenTabs'>";
      for (var vLN01752 = 0; vLN01752 < config.profileTabs.length; ++vLN01752) {
        if (window.canConnectExternalAccounts || !config.profileTabs[vLN01752].includes("Connections")) {
          vLS55 += "<div class='bigMenTab" + (this.tabIndex == vLN01752 ? " bigMenTabA" : "") + "' style='font-size:16px' onmouseenter='playTick(0.1);' onclick='playSelect();windows[4].switchTab(" + vLN01752 + ")'>" + config.profileTabs[vLN01752] + "</div>";
        }
      }
      vLS55 += "</div>";
      if (this.tabIndex == 0) {
        vLS55 += "<div class='setHed' style='margin-top:10px;margin-bottom:20px;'>Your Account</div>";
        var v11070 = account.premiumT > 0 ? UTILS.userAssetsUrl("/p" + account.id + "/profile.png") : UTILS.assetsUrl("/textures/classes/icon_0.png");
        vLS55 += "<div id='profilePicM' class='" + (account.premiumT > 0 ? "" : "blurred") + "'><img style='width: inherit;height: inherit;border-radius: inherit;' loading='lazy' src='" + v11070 + "' onerror='this.onerror=null;this.parentNode.className='blurred';this.src='" + UTILS.assetsUrl("/textures/classes/icon_0.png") + "';'><a class='pfpAction' onmouseenter='playTick(0.1)' onclick='pfpPopup();'>" + i18n.t("windows.profile.picture") + "</a></div>";
        vLS55 += "<div class='setBodH' style='display:inline-block;padding-top:10px;vertical-align:top;width:1004px;margin-left:15px;margin-top:0px;'><div class='settName' style='width:100%;margin-top:0px'>" + i18n.t("generic.name") + "<a href='/social.html?p=profile&q=" + account.name + "' class='floatR' target='_blank'>" + account.name + "</a></div><div class='settName' style='width:100%'>" + i18n.t("generic.clan") + "<a style='float:right'  onclick='showWindow(13)'>" + (account.clan ? "[" + account.clan + "]" : "None") + "</a></div><div class='settName'>" + i18n.t("generic.level") + "<span class='floatR' style='color:rgba(255,255,255,0.8)'>" + account.level + "</span></div></div>";
        vLS55 += "<div class='setHed' style='margin-top:10px;margin-bottom:15px;'>Your Stats</div>";
        vLS55 += "<div class='xpBar' style='height:31px;line-height:34px;font-size:28px;'><div class='xpBarB' style='width:" + account.levelProg + "%'></div><span class='xpBarV'>" + UTILS.xpBarText(account) + "</span></div>";
        var v11071 = account.stats;
        vLS55 += "<div id='statHolder'>";
        vLS55 += "<div style='height:15px;'></div><div class='bigMenTabs' style='margin-bottom: 5px;table-layout: fixed;'>";
        for (var vLN01752 = 0; vLN01752 < config.statTabs.length; ++vLN01752) {
          vLS55 += "<div id='statTab" + vLN01752 + "' class='bigMenTab" + (vLN01752 == 0 ? " bigMenTabA" : "") + "' onclick='playSelect(0.1);windows[4].switchStat(" + vLN01752 + ")' style='padding-left: 5px; padding-right: 5px; padding-top: 10px; padding-bottom: 5px; line-height: 35px;font-size: 16px;'onmouseenter='playTick();'>" + config.statTabs[vLN01752] + "</div>";
        }
        vLS55 += "</div>";
        vLS55 += "<div class='statTabB0'>";
        vLS55 += "<div class='pSt'>LVL<strong>" + account.level + "</strong></div>";
        vLS55 += "<div class='pSt'>KR<strong>" + UTILS.commaFloat(account.funds) + "</strong></div>";
        vLS55 += "<div class='pSt'>Junk<strong>" + UTILS.commaFloat(account.junk) + "</strong></div>";
        vLS55 += "<div class='pSt'>Inventory<strong> ~" + UTILS.commaFloat(account.invVal || 0) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.get("generic.score") + "<strong>" + UTILS.commaFloat(account.score) + "</strong></div>";
        vLS55 += "<div class='pSt'>SPK<strong>" + UTILS.commaFloat((account.score / Math.max(account.kills, 1)).toFixed(2)) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.get("generic.kills") + "<strong>" + UTILS.commaFloat(account.kills) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.get("generic.deaths") + "<strong>" + UTILS.commaFloat(account.deaths) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.get("generic.kdr") + "<strong>" + UTILS.commaFloat((account.kills / Math.max(account.deaths, 1)).toFixed(4)) + "</strong></div>";
        vLS55 += "<div class='pSt'>KPG<strong>" + UTILS.commaFloat((account.kills / Math.max(account.games, 1)).toFixed(4)) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.get("generic.games") + "<strong>" + UTILS.commaFloat(account.games) + "</strong></div>";
        vLS55 += "<div class='pSt'>W/L<strong>" + (account.wins / Math.max(account.games - account.wins, 1)).round(3) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.get("generic.wins") + "<strong>" + UTILS.commaFloat(account.wins) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.get("generic.lose") + "<strong>" + UTILS.commaFloat(Math.max(account.games - account.wins, 0)) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.t("stats.assists") + "<strong>" + UTILS.commaFloat(v11071.ast || 0) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.t("stats.melee") + "<strong>" + UTILS.commaFloat(v11071.mk || 0) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.t("stats.fistkills") + "<strong>" + UTILS.commaFloat(v11071.fk || 0) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.t("stats.thrownkills") + "<strong>" + UTILS.commaFloat(v11071.tmk || 0) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.t("stats.headshots") + "<strong>" + UTILS.commaFloat(v11071.hs || 0) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.t("stats.legshots") + "<strong>" + UTILS.commaFloat(v11071.ls || 0) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.t("stats.wallbangs") + "<strong>" + UTILS.commaFloat(v11071.wb || 0) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.t("stats.shots") + "<strong>" + UTILS.commaFloat(v11071.s || 0) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.t("stats.hits") + "<strong>" + UTILS.commaFloat(Math.min(v11071.s || 0, v11071.h || 0)) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.t("stats.misses") + "<strong>" + UTILS.commaFloat((v11071.s || 0) - Math.min(v11071.s || 0, v11071.h || 0)) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.get("generic.accuracy") + "<strong>" + UTILS.commaFloat((v11071.s ? Math.min(v11071.s || 0, v11071.h || 0) / v11071.s * 100 : 0).round(2)) + "%</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.get("generic.timep") + "<strong>" + UTILS.getReadableTime(account.timePlayed) + "</strong></div>";
        vLS55 += "</div>";
        vLS55 += "<div class='statTabB1 hide'>";
        vLS55 += "<div class='pSt'>" + i18n.t("stats.nukes") + "<strong>" + UTILS.commaFloat(v11071.n || 0) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.t("stats.airdrops") + "<strong>" + UTILS.commaFloat(v11071.ad || 0) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.t("stats.airdrops.stolen") + "<strong>" + UTILS.commaFloat(v11071.sad || 0) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.t("stats.slimers") + "<strong>" + UTILS.commaFloat(v11071.sl || 0) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.t("stats.juggernauts") + "<strong>" + UTILS.commaFloat(v11071.jg || 0) + "</strong></div>";
        vLS55 += "<div class='pSt' style='font-size: 12px;padding-left: 0px;padding-right: 0px;width: 174px;'>" + i18n.t("stats.juggernauts.killed") + "<strong>" + UTILS.commaFloat(v11071.kjg || 0) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.t("stats.warmachines") + "<strong>" + UTILS.commaFloat(v11071.wm || 0) + "</strong></div>";
        vLS55 += "</div>";
        vLS55 += "<div class='statTabB2 hide'>";
        vLS55 += "<div class='pSt'>" + i18n.t("stats.crouches") + "<strong>" + UTILS.commaFloat(v11071.crc || 0) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.t("stats.sprays") + "<strong>" + UTILS.commaFloat(v11071.spry || 0) + "</strong></div>";
        vLS55 += "<div class='pSt'>" + i18n.t("stats.kpd") + "<strong>" + (parseInt(account.jobRatingPos) || 0) + "/" + (parseInt(account.jobRating) || 0) + "</strong></div>";
        vLS55 += "</div>";
        vLS55 += "<div class='statTabB3 hide'>";
        for (var vLN01752 = 0; vLN01752 < Game.classes.length; ++vLN01752) {
          if (!Game.classes[vLN01752].hide) {
            var v11072 = v11071 && v11071["c" + vLN01752] ? v11071["c" + vLN01752] : 0;
            var v11073 = config.rankVar * Math.sqrt(v11072);
            var v11074 = Math.floor(v11073);
            var v11075 = Math.round((v11073 - v11074) * 100);
            var v11076 = v11074 > 1 ? Math.pow(v11074 / config.rankVar, 2) : 0;
            var v11077 = Math.pow((v11074 + 1) / config.rankVar, 2);
            v11074 = Math.max(1, v11074 + 1);
            vLS55 += "<div class='clsStatCard'><img class='clsStatImg' src='" + UTILS.assetsUrl("/textures/classes/icon_" + vLN01752 + ".png") + "'/><div class='clsStatName'>" + Game.classes[vLN01752].name + "</div><div class='clsStatWeap'>" + Game.weapons[Game.classes[vLN01752].loadout[0]].name + "</div><div class='clsStatXPBar'><div class='clsStatXPBarC' style='width:" + v11075 + "%'></div><div class='clsStatXPBarV'>" + (parseInt(v11072 - v11076) + " / " + parseInt(v11077 - v11076)) + "</div></div><div class='clsStatLvl'>Lvl " + v11074 + "</div></div>";
          }
        }
        vLS55 += "</div>";
        vLS55 += "</div>";
      }
      if (this.tabIndex == 1) {
        vLS55 += "<div class='setBodH' style='padding-top:10px;padding-bottom:10px;margin-bottom:20px;'>Friends can send private messages and see eachothers online status.<div style='height:10px;'></div>You can add new friends by following eachother.</div>";
        if (friends) {
          vLS55 += "<div id='friendList'>";
          if (!friends.length) {
            vLS55 += "<span style='color:#9a9a9a'>You don't have any friends yet.</span>";
          } else {
            for (var vLN01752 = 0; vLN01752 < friends.length; ++vLN01752) {
              var v11078 = friends[vLN01752];
              var vLS56 = "";
              vLS56 = v11078.st == 1 ? "<div class='onStatus' style='background:#27ab32'></div>" + (v11078.sm ? v11078.sm : "Online") : "<div class='onStatus' style='background:#7f7f7f'></div>Offline";
              vLS55 += "<div><div style='margin-bottom:10px;text-align:left;padding-bottom:10px;border-bottom:3px solid #ffffff33;padding-top:10px;'><img class='folPfp' onerror='this.onerror=null;this.src=\"./img/player_pfp.png\";' src='" + (v11078.sub ? UTILS.userAssetsUrl("/p" + v11078.fid + "/profile.png") : "./img/player_pfp.png") + "' /><div class='folInfHldr'>" + (v11078.sub ? "<i class='material-icons' style='color:" + COLORS.premium + ";margin-top:-8px;font-size:28px;vertical-align:middle;'>beenhere</i>" : "") + (v11078.plf ? "<i class='material-icons' style='color:" + COLORS.verified.player + ";margin-top:-8px;margin-right: 4px;font-size:28px;vertical-align:middle;'>check_circle</i>" : "") + "<a target='_blank' href='/social.html?p=profile&q=" + v11078.fna + "' class='lName' style='color:rgba(255,255,255,0.9)'>" + v11078.fna + "</a><div style='color:rgba(255,255,255,0.4);font-size:16px;margin-top:4px;max-width:500px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;'>" + vLS56 + "</div></div><div style='float:right;'>" + (v11078.gid ? "<div class='button buttonG' style='padding:10px;margin-right:15px;' onclick='openURL(`/?game=" + v11078.gid + "`,1)'>Join</div>" : "") + "<div class='button buttonR' style='padding:10px;' onclick='deleteFollower(`" + v11078.fna + "`," + vLN01752 + ")'>Remove Friend</div></div></div></div>";
            }
          }
          vLS55 += "</div>";
        } else {
          vLS55 += "<div id='friendList'>Loading Friends...</div>";
        }
      }
      if (this.tabIndex == 2) {
        io.send("vprt");
        var vLS57 = "";
        vLS57 += account.partnerApp ? "<div class='setBodH'><div class='settName'><a class='menuLink' onclick='showWindow(28)'>Partner Dashboard</a> <span style='float:right;color:rgba(255,255,255,0.4)'>(Open off Stream)</span></div><div class='settName'><a class='menuLink' href='javascript:windows[20].tabIndex=1;showWindow(21);'>Top Referrers</a> <span style='float:right;color:rgba(255,255,255,0.4)'>View top Referrers</span></div><div class='settName'><a class='menuLink' href='https://frvr.com/legal/krunker#TermsofService'>Partner Terms</a> <span style='float:right;color:rgba(255,255,255,0.4)'>Review Partner Terms</span></div><div class='settName'><a class='menuLink' href='./docs/partner_tips.txt'>Partner Tips</a> <span style='float:right;color:rgba(255,255,255,0.4)'>Increase Revenue</span></div></div>" : "<div class='setHed' style='margin-top:10px;'>Krunker Partner Benefits</div><div class='setBodH'><div class='settName' style='font-size:17px;'>You get <span style='color:#fff !important'>20-40% of Revenue</span> from KR Sales on your Partner Code in the Shop</div><div class='settName' style='font-size:17px;'>You <span style='color:#fff !important;'>earn money</span> when someone Plays your Custom Games/Maps</div><div class='settName' style='font-size:17px;'>Every time a referred player plays the game, you get a <span style='color:#fff !important;'>cut of the Ad Revenue</span></div></div></div><div class='setHed' style='padding-bottom:10px'>Partner Application</div><div class='setBodH' style='padding-top:10px;padding-bottom:10px;'><div style='font-size:19px;color:rgba(255,255,255,0.4);margin-top:5px;margin-bottom:10px;'>By submitting an Application you agree to the <a href='https://frvr.com/legal/krunker#TermsofService'>Partner Terms</a></div><input type='text' id='crtrCode' class='smlInput' style='width:100%;margin-bottom:8px' placeholder='Partner Code Name' /><input type='text' id='crtrEmail' class='smlInput' style='width:86%;margin-bottom:8px' placeholder='PayPal Email for Payouts' /><a class='menuLink' style='margin-left:20px;vertical-align:middle' onclick='submitCrtrCod()'>" + i18n.t("generic.submit") + "</a></div><div id='ctrtRes' style='color:rgba(255,255,255,0.5)'></div></div>";
        vLS55 += vLS57;
      }
      if (this.tabIndex == 3) {
        vLS55 += "<div class='setHedS' style='margin-top:10px;'>Account Settings</div>";
        if (account.premiumT) {
          vLS55 += "<div class='setBodH'><div class='settName'>Display Name<div class='updDisN' onclick='clearName();' style='background-color: var(--red);'>Clear</div><div class='updDisN' onclick='changeName();'>Update</div><input type='search' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' id='displayN' class='smlInput' placeholder='" + account.alias + "'><div id='aliasRes'></div></div>";
          this.aSuccess = false;
        }
        if (account.stats.flg == null) {
          account.stats.flg = -1;
        }
        vLS55 += "<div class='settName'>" + i18n.t("windows.loadout.flag") + "<select onchange='selectFlag(this.value)' class='inputGrey2' style='padding:4px;margin-top:4px'><option value='-1' " + (account.stats.flg == -1 ? "selected" : "") + ">None</option>";
        for (var vLN01752 = 0; vLN01752 < Game.flags.length; vLN01752++) {
          vLS55 += "<option value='" + vLN01752 + "' " + (account.stats.flg == vLN01752 ? "selected" : "") + ">" + Game.flags[vLN01752][0] + "</option>";
        }
        vLS55 += "</select></div>";
        if (account.stats.bdg == null) {
          account.stats.bdg = -1;
        }
        var v11079 = account.stats.bdg >= 0 && Game.badges[account.stats.bdg] && account.badges.indexOf(account.stats.bdg) >= 0 ? Game.badges[account.stats.bdg] : null;
        vLS55 += "<div class='settName'>" + i18n.t("windows.loadout.badge") + "<div class='updDisN' onclick='selectBadge(-1);' style='background-color: var(--red);'>Clear</div><div class='updDisN' onclick='selectBadgePop();'>Select</div>" + (v11079 ? "<img draggable='false' src='" + v11079.url + "' class='customBadge'>" : "") + "</div>";
        if (account.stats.hds == null) {
          account.stats.hds = 0;
        }
        vLS55 += "<div class='settName'>Hide Detailed Online Status<label class='switch' style='margin-left:10px'><input type='checkbox' onclick='toggleStatus(this.checked)'" + (account.stats.hds ? " checked" : "") + "><span class='slider'></span></label></div>";
        vLS55 += "</div>";
        var v11080 = account.isDev || account.partnerApp >= 2 || account.featured || account.level >= 20;
        var v11081 = !!account.twoFA;
        vLS55 += account.hack ? "" : "<div class='setHedS'>Account Security</div><div class='setBodH' style='padding-bottom:10px;'><div style='font-size:21px;color:rgba(255,255,255,0.4);margin-top:5px'>You can update your password every 30 minutes. <span style='color:#fff'>Never share your password</span> with anyone and keep it in a secure place</div><input type='password' id='oldPass' class='smlInput' style='width:100%;margin-bottom:8px' placeholder='Current Password' /><input type='password' id='newPass' class='smlInput' style='width:100%;margin-bottom:8px' placeholder='New Password' /><input type='password' id='repNPass' class='smlInput' style='width:82%;margin-bottom:8px' placeholder='Repeat Password' /><div class='subPassChg' onclick='changePass()'>" + i18n.t("generic.submit") + "</div><div id='newPRes' style='color:rgba(255,255,255,0.5)'></div>" + (v11080 ? "<div class='settName' style='margin-bottom:20px;'></div><div style='font-size:21px;color:rgba(255,255,255,0.4);margin-top:5px;margin-bottom: 10px;'>To further protect your account, you can add enable <span style='color:#fff'>2FA</span>:<div class='subPassChg' onclick='" + (v11081 ? "dact2FA()" : "act2FA()") + "' style='float: right;margin-top: -8px;'>" + (v11081 ? "Disable" : "Enable") + "</div></div>" : "") + "</div>";
        vLS55 += "<div class='setHedS'>Account Privacy</div><div class='setBodH' style='padding-bottom:15px;'><div style='font-size:21px;color:rgba(255,255,255,0.4);margin-top:5px'>" + i18n.t("account.delete") + "</div>";
        vLS55 += "<div style='height:10px;'></div>";
        vLS55 += (account.reqDel ? "<div style='margin-top:10px'>Processing Deletion <a class='menuLink' onclick='requestDeletion(0)' style='float:right;font-size:18px'>Cancel</a></div>" : "<div style='margin-top:10px'>Delete Account <a class='menuLink' onclick='requestDeletion(1)' style='float:right;font-size:20px'>Request Deletion</a></div>") + "</div>";
      }
      if (this.tabIndex == 4) {
        if (window.canShowNFTs) {
          vLS55 += "<div>NFTs use blockchain technology to verify ownership of an item.</div>";
          vLS55 += "<div class='setHed' id='setHed_metamask' style='margin-top:0px'onclick='window.windows[4].collapseCon(this)'><span class='material-icons plusOrMinus3'>keyboard_arrow_right</span> <img src='" + UTILS.assetsUrl("/img/connections/metamask.svg") + "' style='height: 40px;'><span style='padding-left: 20px;padding-right: 20px;vertical-align: super;font-size: 18px;'>/</span><img src='" + UTILS.assetsUrl("/img/connections/opensea.png") + "' style='height: 40px;'></div>";
          vLS55 += "<div class='setBodH' id='setBod_metamask' style='display:none'><div class='settName'>Metamask Account (" + (account.metamask || "none") + ")<div class='lnkTw' onclick='" + (account.metamask ? "unlinkMetaPop();" : "linkMetaPop();") + "' style='background-color:#f5841f'>" + (account.metamask ? "Unlink" : "Link") + "</div></div><div class='settName'>Opensea NFT's" + (account.metamask ? "<div class='lnkTw' style='background-color:#4144a5;width: 140px;' onclick='window.windows[4].claimNFTs();'>Claim Items</div>" : "") + "</div>";
          vLS55 += "</div>";
        }
        vLS55 += "<div class='setHed' id='setHed_twitch' style='margin-top:0px'onclick='window.windows[4].collapseCon(this)'><span class='material-icons plusOrMinus3'>keyboard_arrow_right</span> <img src='" + UTILS.assetsUrl("/img/connections/twitch.png") + "' style='height: 40px;'></div>";
        vLS55 += "<div class='setBodH' id='setBod_twitch' style='display:none'><div style=\"margin-bottom: 20px;margin-top:10px;text-align: center;color: var(--yellow);font-size: 19px;\">\n\t\t\t\t\t\tTwitch linking creates a permanent connection to this Krunker account regardless of unlinking</div><div class='settName'>Twitch Account (" + (account.twitch || "none") + ")" + (account.twitchId ? "<div class='lnkTw' style='background-color:#4144a5;' onclick='window.windows[4].claimDrops();'>Claim</div>" : "") + "<div class='lnkTw' onclick='" + (account.twitchId ? "unlinkTwitchPop();" : "linkTwitchPop();") + "'>" + (account.twitchId ? "Unlink" : "Link") + "</div></div>";
        if (!config.redeemDrops) {
          vLS55 += "<div style='margin-bottom:10px;color:rgba(0,0,0,0.5);'>Twitch Drops will return soon</div>";
        } else {
          vLS55 += account.twitchId ? "<div style='margin-bottom:10px;margin-top:10px'>Watch <a href='https://www.twitch.tv/directory/game/Krunker' target='_blank' style='color:#6441a5'>Krunker on Twitch</a> to earn more Drops & Items (When Available)</div>" : "<div style='margin-top:10px;'>Link <a href='https://www.twitch.tv/directory/game/Krunker' target='_blank' style='color:#6441a5'>Twitch</a> to earn Drops & Items</div>";
          if (account) {
            vLS55 += "<div id='skinList' style='text-align: center;'>";
            var vA609 = [];
            var v11082 = [...f1799(account, true)].sort(function (p13729, p13730) {
              var v11083 = p13730.ind != null && Game.store.skins[p13730.ind] ? Game.store.skins[p13730.ind].rarity : 0;
              var v11084 = p13729.ind != null && Game.store.skins[p13729.ind] ? Game.store.skins[p13729.ind].rarity : 0;
              var v11085 = p13730.ind != null && Game.store.skins[p13730.ind] ? Game.store.skins[p13730.ind].seas || 1 : 0;
              var v11086 = p13729.ind != null && Game.store.skins[p13729.ind] ? Game.store.skins[p13729.ind].seas || 1 : 0;
              if (v11083 > v11084) {
                return 1;
              } else if (v11083 < v11084) {
                return -1;
              } else if (v11085 > v11086) {
                return 1;
              } else if (v11085 < v11086) {
                return -1;
              } else {
                return (p13730.ind || 0) - (p13729.ind || 0);
              }
            }).filter(p13731 => p13731 && Game.store.skins[p13731.ind] && Game.store.skins[p13731.ind].drop);
            if (v11082.length) {
              vLS55 += "<div class='setHed' style='margin-bottom:20px;'>Drops Earned</div>";
            }
            for (var vLN01752 = 0; vLN01752 < v11082.length; vLN01752++) {
              player = Game.store.skins[v11082[vLN01752].ind];
              if (player) {
                vLS55 += "<div class='dItemHolder' style='border: 2px solid " + Game.store.rarities[player.rarity].color + ";' onclick='openSales(" + v11082[vLN01752].ind + ")'>" + (player.type && player.type == itemTypes.SPRAY ? "<div class='dItemSprayImg' style='background: url(&quot;" + player.thumbnail + "&quot;);" + UTILS.getFrameAnim(player, "sprayAnmD") + "'></div>" : "<img draggable='false' class='dItemImg' loading='lazy' src='" + player.thumbnail + "'>") + "<div class='tItemN'>" + player.name + "</div></div>";
                if (player.type && player.type == itemTypes.SPRAY && player.frames && vA609.indexOf(player.frames) == -1) {
                  vA609.push(player.frames);
                }
              }
            }
            vLS55 += "</div>";
            if (vA609.length) {
              var vLSstyle2 = "<style>";
              for (var vLN01752 = 0; vLN01752 < vA609.length; vLN01752++) {
                vLSstyle2 += "@keyframes sprayAnmD" + vA609[vLN01752] + " {100%{background-position:-" + vA609[vLN01752] * 68 + "px}}";
              }
              vLSstyle2 += "</style>";
              vLS55 = vLSstyle2 + vLS55;
            }
          }
        }
        vLS55 += "</div>";
      }
      if (this.tabIndex == 5) {
        if (this.promoData == null) {
          io.send("gcd");
        }
        if (this.promoData && this.promoData.length) {
          vLS55 += "<div class='promoCodesH'>";
          for (var vLN01752 = 0; vLN01752 < this.promoData.length; vLN01752++) {
            var v11087 = false;
            var v11088 = Game.store.promos[this.promoData[vLN01752].partner];
            if (v11088) {
              vLS55 += "<div class='promoCard" + (v11087 ? " makeGray" : "") + "' onmouseenter='playTick()' style='color:" + (v11088.headCol || "#fff") + ";border: 4px solid;text-shadow: 0px 0px 30px rgb(0 0 0);width: 293px;height: 202px;background-image:url(" + UTILS.assetsUrl("/img/shop/filter/vignette.png") + "),url(&quot;" + UTILS.assetsUrl("/img/shop/promos/promo_" + (v11088.icon || 0) + ".png") + "&quot;)'" + (v11087 ? "" : " onclick='promoPopup(&quot;" + this.promoData[vLN01752].token + "&quot;)'") + "><div class='promoValH'>" + (this.promoData[vLN01752].value ? "$" + this.promoData[vLN01752].value + " " : "") + v11088.name + "<div class='promoValL' style='color:" + (v11088.headCol || "#fff") + " !important;'>Claim</div></div><div class='promoImgGrad' style='background-image: linear-gradient(transparent, " + (v11088.headCol || "#fff") + "30);'></div></div>";
            }
          }
          vLS55 += "</div>";
        } else {
          vLS55 += "<div style='margin-bottom:10px;color:rgba(255,255,255,0.5);'>You have No Promo Codes</div>";
        }
      }
      vLS55 += "<div style='height:15px;margin-top:30px;border-top:4px solid rgba(255, 255, 255, 0.8);'></div><a class='menuLink' onclick='logoutAcc()'>" + i18n.t("generic.logout") + "</a>" + (v10805 ? "" : "<a style='float:right' class='menuLink' onclick='logoutSessions(this)'>" + i18n.t("generic.logout.sessions") + "</a>");
    } else if (vF17344) {
      vLS55 += "<img id='registerBackImg' />";
      vLS55 += "<div style='position:relative;z-index:9'><div id='referralHeader'>Register now to Play!</div><div style='width:100%;text-align:center;margin-top:10px;margin-bottom:20px;font-size:23px;opacity:0.7'>and to support <b>" + vF17344 + "</b></div><input id='accName' type='text' placeholder='" + i18n.t("generic.username") + "' class='accountInput' style='margin-top:0' value=''></input><input id='accPass' type='password' placeholder='" + i18n.t("generic.password") + "' class='accountInput'></input><div class='setBodH' style='margin-left:0px;width:calc(100% - 40px)'><div id='accResp' style='margin-top:10px;margin-bottom:10px;font-size:18px;text-align:center;width:100%;color:rgba(255,255,255,0.5);'>By playing Krunker you directly support <span style='color:rgba(255,255,255,0.8)'>" + vF17344 + "</span></div></div><div class='accBtn button buttonP' style='width: calc(100% - 7px);margin-left: 0px;' onclick='registerAcc()'>" + i18n.t("generic.register") + "</div></div>";
    } else {
      vLS55 += "<div style='position:relative;z-index:9'><div id='referralHeader'>Register or Login</div><div style='height:20px;'></div><input id='accName' type='text' placeholder='" + i18n.t("generic.username") + "' class='accountInput' style='margin-top:0' value='" + (getSavedVal("krunker_username") || "") + "'></input><input id='accPass' type='password' placeholder='" + i18n.t("generic.password") + "' class='accountInput'></input><div class='setBodH' style='margin-left:0px;width:calc(100% - 40px)'><div id='accResp' style='margin-top:20px;margin-bottom:20px;font-size:18px;color:rgba(255,255,255,0.5);text-align:center'>For lost Passwords/Accounts contact <a style='color:rgba(255,255,255,0.8)'>recovery@yendis.ch</a></div></div><div style='width:100%;text-align:center;margin-top:10px;background-color:rgba(0,0,0,0.3);padding-top:10px;padding-bottom:20px;'><div class='accBtn button buttonP' onclick='registerAcc()'>" + i18n.t("generic.register") + "</div><div class='accBtn button buttonG' onclick='loginAcc()'>" + i18n.t("generic.login") + "</div></div>";
    }
    return vLS55;
  }
}, {
  header: i18n.t("windows.battlepass.header"),
  label: "battlepass",
  width: 1580,
  maxHeight: "calc(100% - 189px)",
  wrapAround: false,
  columnsToScroll: 8,
  updateScroll: function (p13732, p13733) {
    var v11089 = document.querySelector(".bpCols");
    if (v11089) {
      var v11090 = v11089.children[0].scrollWidth;
      var v11091 = (v11089.children.length - 1) * v11090 - v11089.clientWidth;
      var v11092 = v11089.scrollLeft + p13732 * (v11090 * (p13733 || this.columnsToScroll));
      var v11093 = v11089.clientWidth + v11089.scrollLeft;
      var v11094 = !!this.wrapAround || !(v11092 <= 0) || p13732 != -1;
      var v11095 = !!this.wrapAround || !(v11093 >= v11091) || p13732 != 1;
      if (this.wrapAround && v11093 >= v11091 && p13732 == 1) {
        v11092 = 0;
      } else if (this.wrapAround && v11092 < 0 && p13732 == -1) {
        v11092 = 50000;
      }
      v11089.scrollLeft = v11092;
      var v11096 = document.querySelectorAll(".bSliderBtn");
      if (v11096) {
        v11096[0].classList.toggle("disabled", !v11094);
        v11096[1].classList.toggle("disabled", !v11095);
      }
    }
  },
  updateScrollWheel: function () {
    this.updateScroll(window.event.deltaY > 0 ? -1 : 1);
  },
  showBalloon: function () {
    document.querySelector(".bpInfoBalloon").style.display = "block";
  },
  hideBalloon: function () {
    document.querySelector(".bpInfoBalloon").style.display = "none";
  },
  tabIndex: 0,
  switchTab: function (p13734) {
    windows[5].tabIndex = p13734;
    updateWindow(6);
  },
  syncBPProg: function (p13735) {
    if (account) {
      this.itemsClaimed = (account.BP.items_claimed + "").split(",");
    }
    updateWindow(6);
  },
  itemsClaimed: [],
  data: null,
  dataStatus: 0,
  dataLoaded: function (p13736) {
    windows[5].data = p13736 || null;
    windows[5].dataStatus = 2;
    updateWindow(6);
    if (windows[5].afterData) {
      windows[5].afterData();
      windows[5].afterData = null;
    }
  },
  genDailyCard: function (p13737, p13738) {
    var v11097 = p13737.DAT;
    var vLS58 = "";
    var v11098 = (p13737.REW && p13737.REW.sk ? p13737.REW.sk : null) || [];
    if (!Array.isArray(v11098)) {
      v11098 = (v11098 + "").split(",");
    }
    for (var vLN01753 = 0, v11099; vLN01753 < v11098.length; vLN01753++) {
      v11099 = Game.store.skins[v11098[vLN01753]];
      if (v11099) {
        vLS58 += "<div class='chalRewSkn' style='background-image:url(" + v11099.thumbnail + ");border:2px solid " + Game.store.rarities[v11099.rarity].color + ";' onclick='viewItem(" + v11099.index + ")'></div>";
      }
    }
    var v11100 = !!p13737.PT;
    return "<div class='chalCard' style='margin-top:" + (p13738 || 0) + "px;" + (v11097.boss ? "box-shadow: 0 0 14px #ffa000;background:rgb(79 50 0 / 40%);border:4px solid #ff9c00;" : "") + "'><img class='chalImgC' src='" + UTILS.assetsUrl("img/chals/icon_" + (p13737.IC || 0) + ".png") + "'  style='" + (v11097.boss ? "border: 4px solid #ff9c00;" : "") + (v11100 ? "filter:grayscale(1);brightness(0.8);" : "") + "' />" + (v11100 ? "<div class='challComplB'><span class='material-icons' style='font-size:110px;color:#38cd3a;'>done</span></div>" : "") + "<div class='chalRight'>" + p13737.N + (p13737.TR ? "<div class='chalExpr'>" + UTILS.getReadableTime(p13737.TR || 0) + " left</div>" : "") + "<div class='chalXPBar'><div class='chalXPVal'>" + (v11100 ? "Completed" : p13737.DAT.ky == "time" ? UTILS.getReadableTime(v11097.val) : (p13737.PV || 0) + "/" + v11097.val) + "</div><div class='chalXPBarC' style='width:" + (v11100 ? 100 : p13737.DAT.ky == "time" ? 0 : (p13737.PV || 0) / v11097.val * 100) + "%;'></div></div></div><div class='chalRews' style='" + (v11097.boss ? "border-left: 3px solid #ff9c00;" : "") + "'><div class='chalRewV' style='" + (p13737.REW && p13737.REW.bpp ? "" : "filter:grayscale(1);") + "'><span style='color:white'>+</span>" + (p13737.REW ? p13737.REW.bpp || 0 : 0) + " <span style='color:#fbc02d'>BPP</span></div><div class='chalRewV' style='" + (p13737.REW && p13737.REW.kr ? "" : "filter:grayscale(1);") + "'><span style='color:white'>+</span>" + (p13737.REW ? p13737.REW.kr || 0 : 0) + " <span style='color:#fbc02d'>KR</span></div><div class='chalRewV' style='" + (p13737.REW && p13737.REW.jnk ? "" : "filter:grayscale(1);") + "'><span style='color:white'>+</span>" + (p13737.REW ? p13737.REW.jnk || 0 : 0) + " <span class='material-icons' style='color:#cc51f8;font-size:29px;vertical-align:top;'>plumbing</span></div>" + vLS58 + "</div></div>";
  },
  gen: function () {
    this.width = this.tabIndex ? 1200 : 1580;
    var vLSdivClassbpBGdivdivSt = "<div class=\"bpBG\"></div>\n\t\t\t<div style=\"height:15px;\"></div>\n\t\t\t<div class=\"bigMenTabs\">";
    for (var vLN01758 = 0; vLN01758 < config.bpTabs.length; ++vLN01758) {
      vLSdivClassbpBGdivdivSt += "<div class=\"bigMenTab flex" + (this.tabIndex == vLN01758 ? " bigMenTabA" : "") + "\"\n\t\t\t\tonclick=\"playSelect();windows[5].switchTab(" + vLN01758 + ")\"\n\t\t\t\tonmouseenter=\"SOUND.play('tick_0',0.1)\"\n\t\t\t\tstyle=\"font-size:16px\">" + config.bpTabs[vLN01758] + "</div>";
    }
    vLSdivClassbpBGdivdivSt += "</div>";
    if (!account) {
      vLSdivClassbpBGdivdivSt += "<div style=\"font-size: 40px;text-align: center;display: inline-block;position: relative;width: 100%;\">\n\t\t\t\t\tSign-in to use the Battle Pass feature\n\t\t\t\t</div>";
    } else if (!this.data || !account.BP) {
      if (!this.dataStatus) {
        this.dataStatus = 1;
        io.send("bpdl");
      }
      vLSdivClassbpBGdivdivSt += "<div style=\"font-size: 40px;text-align: center;display: inline-block;position: relative;width: 100%;\">\n\t\t\t\t" + (this.dataStatus == 2 && account.BP ? "No Battle Pass Found" : "Loading Battle Pass") + "\n\t\t\t</div>";
    } else if (this.tabIndex == 0) {
      var v11101 = this.data.itemcount;
      var v11102 = this.data.itemcount * this.data.bpp_perlevel;
      this.battlepassLvl = Math.floor(account.BP.bpp / this.data.bpp_perlevel) + 1;
      var v11103 = this.battlepassLvl > v11101;
      this.bpPoints = account.BP.bpp % this.data.bpp_perlevel;
      if (v11103) {
        this.battlepassLvl = v11101;
        this.bpPoints = this.data.bpp_perlevel;
      }
      this.itemsClaimed = (account.BP.items_claimed + "").split(",");
      var v11104 = account.BP.tier >= 1;
      var v11105 = new Date(this.data.enddate).getTime();
      var v11106 = (Math.floor((Date.now() - new Date(this.data.startdate).getTime()) / 86400000) + 1) * config.bppCapDay;
      var v11107 = Math.max(v11106 - account.BP.bpp, 0);
      vLSdivClassbpBGdivdivSt += "<div style=\"display: inline-block;position: relative;\">";
      vLSdivClassbpBGdivdivSt += "<div class=\"bpTopH\">\n\t\t\t\t<div class=\"bpSeasonH\">\n\t\t\t\t\t" + this.data.name + "\n\t\t\t\t</div>";
      vLSdivClassbpBGdivdivSt += v11103 ? "<div class=\"bpLevelH\">\n\t\t\t\t\t<div class=\"bpLevelText\">Battlepass Complete</div>\n\t\t\t\t</div>" : "<div class=\"bpLevelH\">\n\t\t\t\t\t<div class=\"bpLevelText\">Level " + this.battlepassLvl + "/" + v11101 + "</div>\n\t\t\t\t\t<div class=\"bpXPText\">\n\t\t\t\t\t\t<span style='color:#fbc02d'>BPP</span> " + this.bpPoints + "/" + this.data.bpp_perlevel + "\n\t\t\t\t\t\t<div class=\"bpXPBarH\">\n\t\t\t\t\t\t\t<div class=\"bpXPBar\" style=\"width:" + this.bpPoints / this.data.bpp_perlevel * 100 + "%;\"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"bpXPText\">\n\t\t\t\t\t\tAvailable BPP <img class=\"bpXPIcon\" onmouseenter=\"windows[5].showBalloon()\" onmouseleave=\"windows[5].hideBalloon()\" src=\"./img/frvr-ui/info-icon.svg\">\n\t\t\t\t\t\t<div class=\"bpXPBarH\">\n\t\t\t\t\t\t\t<div class=\"bpXPBar\" style=\"width:" + v11107 / v11106 * 100 + "%;\"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"bpInfoBalloon\">\n\t\t\t\t\t\t<div>BPP has a daily cap. The amount you can earn increases every day.</div>\n\t\t\t\t\t\t<div style=\"margin-top: 20px\">Current available BPP: <span style='color:#00b1ff'>" + v11107 + "</span></div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>";
      vLSdivClassbpBGdivdivSt += "</div>";
      vLSdivClassbpBGdivdivSt += "<div class=\"bpMidH\">";
      vLSdivClassbpBGdivdivSt += "<div class=\"bpRowTitles\">\n\t\t\t\t<div class=\"bpCard free\">\n\t\t\t\t\t<div class=\"bpRowTitleText\">Free</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"bpCard vip active\">\n\t\t\t\t\t" + (v11104 ? "" : "<div class=\"bpCardLock\"></div>") + "\n\t\t\t\t\t<div class=\"bpRowTitleText\" style=\"left: 19%;\">VIP</div>\n\t\t\t\t</div>\n\t\t\t</div>";
      vLSdivClassbpBGdivdivSt += "<div class=\"bSliderH\">\n\t\t\t\t<div class=\"bSliderBtn disabled\" onmouseenter=\"playTick(0.1);\" onmousedown=\"playSelect(0.1);windows[5].updateScroll(-1);\">\n\t\t\t\t\t<div class=\"bpSliderArrow\"></div>\n\t\t\t\t</div>\n\t\t\t</div>";
      vLSdivClassbpBGdivdivSt += "<div class=\"bpCols\" onwheel=\"windows[5].updateScrollWheel();\">";
      for (var v11108 = UTILS.arrayChunk(this.data.itemdata.split(","), 4), vO354 = {}, vLN01758 = 0; vLN01758 < v11108.length; ++vLN01758) {
        vO354[v11108[vLN01758][1] + "_" + v11108[vLN01758][2]] = {
          id: v11108[vLN01758][0],
          sk: parseInt(v11108[vLN01758][3])
        };
      }
      for (var vLN01758 = 0; vLN01758 < v11101; vLN01758++) {
        var v11109 = vLN01758 + 1;
        var v11110 = this.battlepassLvl >= v11109;
        var v11111 = this.battlepassLvl == v11109;
        var vLS59 = "";
        for (var vLN01757 = 0; vLN01757 < 2; ++vLN01757) {
          var v11112 = vLN01757 + "_" + vLN01758;
          var v11113 = vO354[v11112];
          var v11114 = v11113 ? v11113.id : null;
          var v11115 = null;
          var v11116 = vLN01757 == 0;
          var v11117 = this.itemsClaimed.includes(v11114);
          var v11118 = (v11116 || v11104) && v11114 != null && !v11117;
          var v11119 = v11116 && !v11104;
          var v11120 = true;
          if (v11113) {
            if (v11113.sk) {
              v11115 = {
                thumbnail: Game.store.skins[v11113.sk].thumbnail,
                shine: Game.store.rarities[Game.store.skins[v11113.sk].rarity].color,
                click: "viewItem(" + v11113.sk + ");",
                index: v11113.sk
              };
            } else {
              v11113 = null;
            }
          }
          let vLSimgStyleverticalalig = "<img style='vertical-align: bottom;margin-right:10px;display:inline' height='30px' src ='./img/frvr-ui/ad-icon.svg' class='frvr-button__icon'/>";
          vLS59 += "<div class=\"bpCard " + (v11116 ? "free" : "vip") + ((v11110 ? " completed" : "") + "\">") + (v11115 ? "<div class=\"bpCardSlot\" onmouseenter=\"playTick(0.1);\" onclick=\"playSelect(0.1);" + v11115.click + ("\">\n\t\t\t\t\t\t\t" + (v11104 || v11116 ? "" : "<div class=\"bpCardLock\"></div>") + "\n\t\t\t\t\t\t\t<div class=\"bpCardImgH\">\n\t\t\t\t\t\t\t\t<img class=\"bpCardImg\" loading=\"lazy\" draggable=\"false\" src=\"" + v11115.thumbnail + "\" style=\"filter:drop-shadow(0 0 0.2rem " + v11115.shine + "88)\">\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t" + (v11115.label ? "<div class='bpClaimLabel'>" + v11115.val + " " + v11115.label + "</div>" : "") + "\n\t\t\t\t\t\t" + (v11110 && v11118 ? "<div class='bpClaimB' onclick=\"windows[5]." + (v11119 ? "free" : "") + "claimItem(" + v11114 + ")\"> " + (v11119 ? vLSimgStyleverticalalig : "") + "CLAIM</div>" : "") + "\n\n\t\t\t\t\t\t" + (v11117 ? "<div class=\"bpClaimed\"><span class=\"material-icons\" style=\"font-size:160px;color:#38cd3a;line-height:256px\">done</span></div>" : "") + "\n\n\t\t\t\t\t\t") : "") + "</div>";
        }
        vLSdivClassbpBGdivdivSt += "<div class=\"bpCol\" style='" + (v11110 ? "" : "filter:grayscale(100%)") + ("'>\n\t\t\t\t\t<div class=\"bpLevelNum" + (v11111 ? " active" : v11110 ? " completed" : "") + "\">" + v11109 + "</div>\n\t\t\t\t\t" + vLS59 + "\n\t\t\t\t</div>");
      }
      vLSdivClassbpBGdivdivSt += "</div>";
      vLSdivClassbpBGdivdivSt += "<div class=\"bSliderH\">\n\t\t\t\t<div class=\"bSliderBtn\" onmouseenter=\"playTick(0.1);\" onmousedown=\"playSelect(0.1);windows[5].updateScroll(1);\">\n\t\t\t\t\t<div class=\"bpSliderArrow right\"></div>\n\t\t\t\t</div>\n\t\t\t</div>";
      vLSdivClassbpBGdivdivSt += "</div>";
      vLSdivClassbpBGdivdivSt += "<div class=\"bpBotH\">\n\t\t\t\t<div class=\"bpBtn claim" + (v11104 ? " blockClick" : "") + "\" onmouseenter=\"playTick(0.1);\" onclick=\"playSelect(0.1);windows[5].purchasePop();\">Purchase VIP Tier</div>\n\t\t\t\t<div class=\"bpBtn skip" + (!v11120 || account.BP.bpp >= v11102 ? " blockClick" : "") + "\" onmouseenter=\"playTick(0.1);\" onclick=\"playSelect(0.1);windows[5].skipLevelPop()\">Skip levels</div>\n\t\t\t</div>";
      vLSdivClassbpBGdivdivSt += "</div>";
    } else if (this.tabIndex == 1) {
      var v11121 = account.activeChallenges.filter(p13739 => p13739 && p13739.T == "daily");
      var v11122 = v11121.filter(p13740 => p13740 && p13740.PT).length;
      vLSdivClassbpBGdivdivSt += "<div class='challCrdMsg' style='margin-bottom:25px;font-size:27px;color:#9f9f9f;position: relative;'>Abandoning a match will result in the loss of challenge progress.</div>";
      vLSdivClassbpBGdivdivSt += "<div style='margin-top:10px;'>";
      if (v11121.length) {
        v11121.sort(function (p13741, p13742) {
          return p13742.PT - p13741.PT;
        });
        for (var vLN01758 = 0, v11123; vLN01758 < v11121.length; vLN01758++) {
          v11123 = v11121[vLN01758];
          vLSdivClassbpBGdivdivSt += this.genDailyCard(v11123, vLN01758 ? 20 : 0);
        }
      } else {
        vLSdivClassbpBGdivdivSt += "<div class='challCrdMsg'>Check back later for new daily battle pass challenges!</div>";
      }
      vLSdivClassbpBGdivdivSt += "</div>";
    }
    return vLSdivClassbpBGdivdivSt;
  },
  post: function () {
    if (this.tabIndex == 0 && this.battlepassLvl - 3 > 0) {
      this.updateScroll(1, this.battlepassLvl - 3);
    }
  },
  claimItemRes: function (p13743, p13744, p13745, p13746, p13747, p13748) {
    let v11124 = p13748.id;
    if (account) {
      let v11125;
      let v11126;
      if (p13748.tier && p13748.col) {
        v11125 = parseInt(p13748.tier) >= 1 ? "premium" : "free";
        v11126 = parseInt(p13748.col) + 1;
      }
      if (p13745) {
        p13745 = parseInt(p13745);
        account.addSkin(p13745);
      }
      let vLS60 = "";
      let vLN01759 = 0;
      if (p13748.sk > 0) {
        vLS60 = "skin_" + p13748.sk;
        vLN01759 = 1;
      }
      logEventFRVR("battle_pass_claim_reward", {
        level: v11126,
        battle_pass_track: v11125,
        item: vLS60,
        item_amount: vLN01759,
        season: config.currentSeason
      });
      windows[5].itemsClaimed.push(v11124);
      account.BP.items_claimed = windows[5].itemsClaimed.join(",");
    }
    updateMenuAccountData();
    updateWindow(6);
    io_showPopup("SUCCESS", null, "Item Claimed");
  },
  freeclaimItem: function (p13749) {
    window.showRewardedAd(() => {
      io_loadingPopup("Claiming...");
      io.send("bpclm", parseInt(p13749));
    });
  },
  claimItem: function (p13750) {
    io_loadingPopup("Claiming...");
    io.send("bpclm", parseInt(p13750));
  },
  increaseSkip: function (p13751) {
    var v11127 = document.getElementById("bp-skip-num");
    if (v11127) {
      var v11128 = parseInt(v11127.textContent) || 1;
      v11128 += p13751;
      v11128 = UTILS.limitMM(v11128, 1, Math.max(1, this.data.itemcount - this.battlepassLvl));
      v11127.textContent = v11128;
      var vParseFloat2 = parseFloat(config.levelSkipPrice);
      var v11129 = document.getElementById("bp-skip-levels");
      if (v11129) {
        v11129.textContent = "$" + (vParseFloat2 * v11128).toFixed(2);
      }
    }
  },
  skipLevels: function (p13752, p13753) {
    var v11130 = document.getElementById("bp-skip-num");
    if (v11130) {
      var v11131 = parseInt(v11130.textContent) || 1;
      if (!p13753 && v10514) {
        return io_showPopup(null, "Invalid Steam Account");
      }
      if (p13753 && v10514) {
        var v11132 = !!window.ClientSession && !!window.ClientSession.settings && !!window.ClientSession.settings.gameCap && !!window.ClientSession.settings.gameCap.val;
        if (!v11132) {
          return io_showPopup(null, "Game Capture must be enabled to use Steam Purchase");
        }
        io.send("stpbplV", p13753 + "", v11131);
      } else {
        io.send("xstbpl", v11131, SETTINGS.list.lang.val, null, null, window.paymentsChannelId);
      }
      p13752.style.pointerEvents = "none";
      requestAnimationFrame(() => {
        if (p13752) {
          p13752.style.pointerEvents = "";
        }
      }, 3500);
    }
  },
  purchaseLvlRes: function (p13754, p13755, p13756, p13757, p13758, p13759, p13760, p13761, p13762, p13763) {
    CONTROLS.idleTimer = 0;
    f1748();
    if (p13755) {
      purchaseError(p13754, p13755, "battlepass_levels_" + p13757);
    } else {
      if (account) {
        var vParseInt36 = parseInt(account.BP.bpp);
        account.BP.bpp = parseInt(p13758);
        var v11133 = account.BP.bpp - vParseInt36;
        if (v11133 > 0) {
          logEventFRVR("item_flow", {
            item: "bpp",
            flow_type: "source",
            amount: v11133,
            item_context: "iap",
            wallet: account.BP ? account.BP.bpp || 0 : 0
          });
        }
        logEventFRVR("battle_pass_level_up", {
          level: windows[5].battlepassLvl + parseInt(p13757),
          hasPremium: account.BP.tier ? "premium" : "free",
          levels_skipped: parseInt(p13757) || 0,
          season: config.currentSeason
        });
        if (p13763) {
          account.badges.push(p13763);
        }
      }
      updateMenuAccountData();
      updateWindow(null, true);
      UI.toggleMenuHider(true);
      purchaseLoad.style.display = "none";
      windows[5].skippedLevelPop(p13757);
      logEventFRVR("iap_request_payment_success", {
        product_id: "pass_skip_" + p13757 + "_levels_season_" + config.currentSeason,
        payment_provider: p13754,
        price_amount: p13759,
        price_currency_code: p13760,
        transaction_id: p13761,
        external_transaction_id: p13762,
        productId: "pass_skip_" + p13757 + "_levels_season_" + config.currentSeason,
        provider: p13754,
        priceValue: p13759,
        currencyCode: p13760,
        transactionId: p13762,
        trackingName: "Pass " + config.currentSeason + " Skip levels ",
        label: "Pass " + config.currentSeason + " Skip levels "
      });
    }
  },
  skipLevelPop: function () {
    var vParseFloat3 = parseFloat(config.levelSkipPrice);
    var v11134 = "<div class=\"bp-generic-img-holder\">\n\t\t\t<div class=\"bp-generic-img-back\"></div>\n\t\t\t<div class=\"bp-generic-img bp-generic-img-skip\"></div>\n\t\t</div>\n\t\t<div class=\"bp-generic-text\">\n\t\t\t<div class=\"bp-generic-header\">Skip levels</div>\n\t\t\t<div class=\"bp-generic-info\">\n\t\t\t\tSkip Battle Pass level\n\t\t\t\t<div style=\"color: var(--yellow);font-size: 12px;\">*BPP limit will not increase*</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"bp-generic-btn-holder\">\n\t\t\t<div class='button bp-generic-btn-small' onmouseenter=\"playTick(0.1);\" onclick='playSelect(0.1);windows[5].increaseSkip(-1)'>-</div>\n\t\t\t<div id='bp-skip-num'>1</div>\n\t\t\t<div class='button bp-generic-btn-small' onmouseenter=\"playTick(0.1);\" onclick='playSelect(0.1);windows[5].increaseSkip(1)'>+</div>\n\t\t\t<div id=\"bp-skip-levels\" class='button bp-generic-btn' onmouseenter=\"playTick(0.1);\" onclick='playSelect(0.1);skipLevels(this)'>$" + vParseFloat3.toFixed(2) + "</div>\n\t\t</div>";
    genericPopup(v11134, "bp-generic-pop no-box-shadow");
  },
  skippedLevelPop: function (p13764) {
    var v11135 = "<div class=\"bp-generic-img-holder\">\n\t\t\t<div class=\"bp-generic-img-back\"></div>\n\t\t\t<div class=\"bp-generic-img bp-generic-img-skip\"></div>\n\t\t</div>\n\t\t<div class=\"bp-generic-text\">\n\t\t\t<div class=\"bp-generic-header\">" + (p13764 || 0) + " levels skipped</div>\n\t\t\t<div class=\"bp-generic-info\">On the way to the top!</div>\n\t\t</div>\n\t\t<div class=\"bp-generic-btn-holder\">\n\t\t\t<div class='button bp-generic-btn' onmouseenter=\"playTick(0.1);\" onclick='playSelect(0.1);clearPops();'>Awesome!</div>\n\t\t</div>";
    genericPopup(v11135, "bp-generic-pop");
  },
  selectBPTier: function (p13765, p13766, p13767) {
    var v11136 = document.getElementById("battlepassCreatorCode") || {};
    if (!p13767 && v10514) {
      return io_showPopup(null, "Invalid Steam Account");
    }
    if (p13767 && v10514) {
      var v11137 = !!window.ClientSession && !!window.ClientSession.settings && !!window.ClientSession.settings.gameCap && !!window.ClientSession.settings.gameCap.val;
      if (!v11137) {
        return io_showPopup(null, "Game Capture must be enabled to use Steam Purchase");
      }
      io.send("stpbpV", p13767 + "", p13766, v11136.value || null);
    } else {
      io.send("xstbp", p13766, v11136.value || null, SETTINGS.list.lang.val, null, null, window.paymentsChannelId);
    }
    p13765.style.pointerEvents = "none";
    requestAnimationFrame(() => {
      if (p13765) {
        p13765.style.pointerEvents = "";
      }
    }, 3500);
  },
  purchaseRes: function (p13768, p13769, p13770, p13771, p13772, p13773, p13774, p13775) {
    CONTROLS.idleTimer = 0;
    f1748();
    if (p13769) {
      purchaseError(p13768, p13769, "battlepass_" + p13770);
    } else {
      if (account) {
        account.BP.tier = p13771;
      }
      updateMenuAccountData();
      updateWindow(null, true);
      UI.toggleMenuHider(true);
      purchaseLoad.style.display = "none";
      windows[5].purchasedPop(0);
      logEventFRVR("iap_request_payment_success", {
        product_id: "premium_pass_season_" + config.currentSeason,
        payment_provider: p13768,
        price_amount: p13772,
        price_currency_code: p13773,
        transaction_id: p13774,
        external_transaction_id: p13775,
        productId: "premium_pass_season_" + config.currentSeason,
        provider: p13768,
        priceValue: p13772,
        currencyCode: p13773,
        transactionId: p13775,
        trackingName: "Premium pass " + config.currentSeason,
        label: "Premium pass " + config.currentSeason
      });
    }
  },
  purchasedPop: function (p13776) {
    var v11138 = "<div class=\"bp-generic-img-holder\">\n\t\t\t<div class=\"bp-generic-img-back\"></div>\n\t\t\t<div class=\"bp-generic-img-splash\"></div>\n\t\t\t<div class=\"bp-generic-img\"></div>\n\t\t</div>\n\t\t<div class=\"bp-generic-text\">\n\t\t\t<div class=\"bp-generic-header\">VIP" + (p13776 ? "+" : "") + " battle pass unlocked!</div>\n\t\t\t<div class=\"bp-generic-info\">You now have access to vip rewards" + (p13776 ? " <span style=\"color:#FFE540\">plus 15 Battle Pass levels</span>" : "") + "!</div>\n\t\t</div>\n\t\t<div class=\"bp-generic-btn-holder\">\n\t\t\t<div class='button bp-generic-btn' onmouseenter=\"playTick(0.1);\" onclick='playSelect(0.1);clearPops();'>Awesome!</div>\n\t\t</div>";
    genericPopup(v11138, "bp-generic-pop");
  },
  purchasePop: function () {
    if (!this.data) {
      this.afterData = () => this.purchasePop();
      showWindow(6);
      return;
    }
    var v11139 = JSON.parse(getSavedVal("krk_cc") || "{}");
    if (v11139 && Date.now() - v11139.t >= config.creatorReset) {
      deleteVal("krk_cc");
      v11139 = null;
    } else {
      v11139 = v11139.code;
    }
    var v11140 = account && account.refCode ? account.refCode : null;
    if (v11140 && (v11140 + "").toLowerCase() == "krunker") {
      v11140 = null;
    }
    const v11141 = v11139 || v11140 || null;
    var v11142 = "<div class='battlepassCreatorH'><div class='battlepassCreatorText'>" + i18n.t("windows.store.creator") + "</div><div><input type='text' id='battlepassCreatorCode' class='smlInput' " + (v11141 ? "value='" + v11141 + "'" : "placeholder='Enter Creator Code'") + " " + (v11139 ? "disabled" : "") + "/><div id='battlepassCreatorCodeBtn' style='background-color:" + (v11139 ? "#eb5656" : "#41c300") + "' onclick='creatorCodeAction(" + (v11139 ? 0 : 1) + ", 3)'>" + (v11139 ? "Remove" : "Save") + "</div></div></div>";
    var vLN1151 = 1;
    var v11143 = this.data["tier" + vLN1151 + "price"];
    var v11144 = this.data["tier" + vLN1151 + "name"];
    var v11145 = "<div class=\"bp-generic-img-holder\">\n\t\t\t<div class=\"bp-generic-img-back\"></div>\n\t\t\t<div class=\"bp-generic-img\"></div>\n\t\t</div>\n\t\t<div class=\"bp-generic-text\">\n\t\t\t<div class=\"bp-generic-header\" style=\"margin-bottom: 25px;\">Purchase " + v11144.toUpperCase() + " Battle Pass</div>\n\t\t\t<div class=\"bp-generic-info\">Unlock " + v11144.toLowerCase() + " rewards\n\t\t\t\t" + v11142 + "\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"bp-generic-btn-holder\">\n\t\t\t<div class='button bp-generic-btn' onmouseenter=\"playTick(0.1);\" onclick='playSelect(0.1);selectBPTier(this, 1);'>$" + v11143 + "</div>\n\t\t</div>";
    genericPopup(v11145, "bp-purchase-pop");
  }
}, {
  header: i18n.t("windows.controls.header"),
  label: "controls",
  width: 1300,
  tabs: [{
    n: "General",
    list: [["forward", "move", 0, undefined, "Movement"], ["backward", "move", 1, undefined, "Movement"], ["left", "move", 2, undefined, "Movement"], ["right", "move", 3, undefined, "Movement"], ["jump", "jump", undefined, undefined, "Movement"], ["crouch", "crouch", undefined, undefined, "Movement"], ["reload", "reload", undefined, undefined, "Weapon"], ["aim1", "aim", undefined, undefined, "Weapon"], ["shoot1", "shoot", undefined, undefined, "Weapon"], ["prim", "primary", undefined, undefined, "Weapon"], ["melee", "melee", undefined, undefined, "Weapon"], ["swap", "swap", undefined, undefined, "Weapon"], ["equip", "equip", undefined, undefined, "Weapon"], ["inspect", "inspect", undefined, undefined, "Weapon"], ["spray", "spray", undefined, undefined, "Weapon"], ["sprayWheel", "sprayWheel", undefined, undefined, "Weapon"], ["list", "playerList", undefined, undefined, "Interface"], ["board", "scoreBoard", undefined, undefined, "Interface"], ["hidePlayers", "hidePlayers", undefined, undefined, "Players"]]
  }, {
    n: "Chat & Toggles",
    list: [["chat", "chat", undefined, undefined, "Interface & Audio"], ["voice", "voiceChat", undefined, undefined, "Interface & Audio"], ["premium0", "premium", 0, undefined, "Premium & Host"], ["premium1", "premium", 1, undefined, "Premium & Host"], ["premium2", "premium", 2, undefined, "Premium & Host"], ["premium3", "premium", 3, undefined, "Premium & Host"], ["message0", "message", 0, "chatMessages", "Chat Messages", 0], ["message1", "message", 1, "chatMessages", "Chat Messages", 1], ["message2", "message", 2, "chatMessages", "Chat Messages", 2], ["message3", "message", 3, "chatMessages", "Chat Messages", 3], ["message4", "message", 4, "chatMessages", "Chat Messages", 4], ["message5", "message", 5, "chatMessages", "Chat Messages", 5], ["wepVis", "wepVis", undefined, undefined, "Toggle Settings"], ["toggle0", "toggle", 0, "toggleSets", "Toggle Settings", 0], ["toggle1", "toggle", 1, "toggleSets", "Toggle Settings", 1], ["toggle2", "toggle", 2, "toggleSets", "Toggle Settings", 2], ["toggle3", "toggle", 3, "toggleSets", "Toggle Settings", 3], ["toggle4", "toggle", 4, "toggleSets", "Toggle Settings", 4], ["toggle5", "toggle", 5, "toggleSets", "Toggle Settings", 5]]
  }, {
    n: "Interaction",
    list: [["interact", "interact", undefined, undefined, "Interaction"], ["interactSec", "secondaryInteract", undefined, undefined, "Interaction"], ["drop", "drop", undefined, undefined, "Interaction"], ["confirm", "confirm", undefined, undefined, "Interaction"], ["streak0", "streak", 0, undefined, "Killstreaks"], ["streak1", "streak", 1, undefined, "Killstreaks"], ["streak2", "streak", 2, undefined, "Killstreaks"]]
  }, {
    n: "Spectate & Vote",
    list: [["specFocus", "specFocus", undefined, undefined, "Spectating"], ["specFree", "specFree", undefined, undefined, "Spectating"], ["specObj", "specObj", undefined, undefined, "Spectating"], ["specFirst", "specFirst", undefined, undefined, "Spectating"], ["specNames", "specNames", undefined, undefined, "Spectating"], ["specMiniMap", "specMiniMap", undefined, undefined, "Spectating"], ["kpdVoteY", "kpdVoteY", undefined, undefined, "KPD"], ["kpdVoteN", "kpdVoteN", undefined, undefined, "KPD"], ["kpdVision", "kpdVision", undefined, undefined, "KPD"], ["kickVoteY", "kickVoteY", undefined, undefined, "Vote"], ["kickVoteN", "kickVoteN", undefined, undefined, "Vote"]]
  }, {
    n: "Modes",
    list: [["prop", "prop", undefined, undefined, "Prop Hunt"], ["propRand", "propRand", undefined, undefined, "Prop Hunt"], ["propRot", "propRot", undefined, undefined, "Prop Hunt"], ["propRotR", "propRotR", undefined, undefined, "Prop Hunt"], ["taunt0", "taunt", 0, undefined, "Prop Hunt"], ["taunt1", "taunt", 1, undefined, "Prop Hunt"], ["taunt2", "taunt", 2, undefined, "Prop Hunt"], ["taunt3", "taunt", 3, undefined, "Prop Hunt"], ["taunt4", "taunt", 4, undefined, "Prop Hunt"], ["taunt5", "taunt", 5, undefined, "Prop Hunt"], ["reset", "reset", undefined, undefined, "Parkour & Race"], ["resetLast", "resetLast", undefined, undefined, "Parkour & Race"], ["noclipSB", "noclipSB", undefined, undefined, "Sandbox (Test mode)"], ["godModeSB", "godModeSB", undefined, undefined, "Sandbox (Test mode)"], ["killSB", "killSB", undefined, undefined, "Sandbox (Test mode)"], ["spawnBot", "spawnBot", undefined, undefined, "Sandbox (Test mode)"], ["clearBots", "clearBots", undefined, undefined, "Sandbox (Test mode)"]]
  }],
  sticky: true,
  tabIndex: 0,
  switchTab: function (p13777, p13778) {
    if (this.tabIndex != p13777 || p13778) {
      CONTROLS.inputChanger = null;
      this.tabIndex = p13777;
      updateWindow(7);
    }
  },
  collapseFolder: function (p13779) {
    let v11146 = document.getElementById("setBindBod_" + p13779.id.split("setBindHed_")[1]);
    let v11147 = v11146.style.display == "none";
    p13779.children[0].innerHTML = "keyboard_arrow_" + (v11147 ? "down" : "right");
    v11146.style.display = v11147 ? null : "none";
  },
  gen: function () {
    var vLSdivIdbindsHeaderdivC = "<div id='bindsHeader'><div class='bigMenTabs' style='table-layout: fixed;margin-top: 18px!important;margin-bottom: unset;'>";
    for (var vLN01761 = 0; vLN01761 < this.tabs.length; ++vLN01761) {
      vLSdivIdbindsHeaderdivC += "<div class='bigMenTab" + (this.tabIndex == vLN01761 ? " bigMenTabA" : "") + "' onclick='windows[6].switchTab(" + vLN01761 + ")' style='padding-top:10px;padding-bottom:5px;'>" + this.tabs[vLN01761].n + "</div>";
    }
    vLSdivIdbindsHeaderdivC += "</div></div>";
    vLSdivIdbindsHeaderdivC += "<div id='bindsHolder'>";
    for (var v11148 = this.tabs[this.tabIndex].list, vA610 = [], vLN01761 = 0, v11156; vLN01761 < v11148.length; vLN01761++) {
      v11156 = v11148[vLN01761][4].replace(/[^\w]/gmi, "_").toLowerCase();
      if (!vA610[v11156]) {
        vA610[v11156] = {
          body: [],
          head: "<div class='setHed' id='setBindHed_" + v11156 + "' onclick='window.windows[6].collapseFolder(this)'><span class='material-icons plusOrMinus'>keyboard_arrow_down</span> " + v11148[vLN01761][4] + "</div><div class='setBodH' id='setBindBod_" + v11156 + "'>"
        };
      }
      var vLSdivClasssettName = "<div class='settName'>";
      if (v11148[vLN01761][3] == null) {
        vLSdivClasssettName += i18n.t("windows.controls." + v11148[vLN01761][0]);
      } else {
        var v11150 = CONTROLS[v11148[vLN01761][3]][v11148[vLN01761][5]];
        if (v11148[vLN01761][1] == "toggle") {
          vLSdivClasssettName += "Toggle <select class='setToggle' onchange='changeContSet(" + v11148[vLN01761][2] + ", this.value)'><option value='-1'" + (v11150 == -1 ? " selected" : "") + ">None</option>";
          for (var v11151 in SETTINGS.list) {
            if (SETTINGS.list[v11151].toggle) {
              vLSdivClasssettName += "<option value='" + v11151 + "'" + (v11150 == v11151 ? " selected" : "") + ">" + i18n.t(SETTINGS.list[v11151].name) + " [" + i18n.t("settings." + SETTINGS.list[v11151].cat + ".header") + "]</option>";
            }
          }
          vLSdivClasssettName += "</select>";
        } else {
          var vFilterCM = filterCM(v11150);
          vLSdivClasssettName += "Message <input type='text' name='" + v11148[vLN01761][0] + "' class='inputGrey2' placeholder='Message to Send' style='float: none;' value='" + vFilterCM + "' oninput='changeContMsg(" + v11148[vLN01761][2] + ", this.value)' />";
        }
      }
      var v11152 = v11148[vLN01761][2] == null ? CONTROLS.binds[v11148[vLN01761][1]].val : CONTROLS.binds[v11148[vLN01761][1]][v11148[vLN01761][2]].val;
      var v11153 = v11148[vLN01761][2] == null ? CONTROLS.binds[v11148[vLN01761][1]].altVal : CONTROLS.binds[v11148[vLN01761][1]][v11148[vLN01761][2]].altVal;
      var v11154 = v11152 == 10001 || v11152 == 10002 || v11152 == 10003 || v11152 == 20000;
      var v11155 = v11153 == 10001 || v11153 == 10002 || v11153 == 10003 || v11153 == 20000;
      if (SETTINGS.list[v11148[vLN01761][1] + "Trigger"] != null) {
        vLSdivClasssettName += f1798(v11148[vLN01761][1] + "Trigger");
      }
      vLSdivClasssettName += "<div style='float:right'><span class='reset' title='Reset Bind' onclick='resetCont(&quot;" + v11148[vLN01761][1] + "&quot;,1," + v11148[vLN01761][2] + ")'><i class='material-icons' style='font-size:40px;color:var(--yellow);'>refresh</i></span><span class='unbind' title='Unbind' onclick='unbindCont(&quot;" + v11148[vLN01761][1] + "&quot;,1," + v11148[vLN01761][2] + ")'><i class='material-icons' style='font-size:40px;color:var(--red);'>delete_forever</i></span><span class='settText floatRNoC keyIcon' id='cont" + (v11148[vLN01761][1] + (v11148[vLN01761][2] == null ? "" : "_" + v11148[vLN01761][2])) + "_alt' onmouseover='playTick()' onclick='changeCont(&quot;" + v11148[vLN01761][1] + "&quot;,1," + v11148[vLN01761][2] + ")'>" + UTILS.getKeyName(v11153) + "</span>" + (v11155 ? "<div class='mouseBtn' style='background-image: url(" + UTILS.assetsUrl("/img/mouse/" + v11153 + ".png") + ");'></div>" : "") + "</div>";
      vLSdivClasssettName += "<div class='bindSep'></div>";
      vLSdivClasssettName += "<div style='float:right'><span class='reset' title='Reset Bind' onclick='resetCont(&quot;" + v11148[vLN01761][1] + "&quot;,0," + v11148[vLN01761][2] + ")'><i class='material-icons' style='font-size:40px;color:var(--yellow);'>refresh</i></span><span class='unbind' title='Unbind' onclick='unbindCont(&quot;" + v11148[vLN01761][1] + "&quot;,0," + v11148[vLN01761][2] + ")'><i class='material-icons' style='font-size:40px;color:var(--red);'>delete_forever</i></span><span class='settText floatRNoC keyIcon' id='cont" + (v11148[vLN01761][1] + (v11148[vLN01761][2] == null ? "" : "_" + v11148[vLN01761][2])) + "' onmouseover='playTick()' onclick='changeCont(&quot;" + v11148[vLN01761][1] + "&quot;,0," + v11148[vLN01761][2] + ")'>" + UTILS.getKeyName(v11152) + "</span>" + (v11154 ? "<div class='mouseBtn' style='background-image: url(" + UTILS.assetsUrl("/img/mouse/" + v11152 + ".png") + ");'></div>" : "") + "</div>";
      vLSdivClasssettName += "</div>";
      vA610[v11156].body.push(vLSdivClasssettName);
    }
    for (var v11156 in vA610) {
      vLSdivIdbindsHeaderdivC += vA610[v11156].head + vA610[v11156].body.join("") + "</div>";
    }
    vLSdivIdbindsHeaderdivC += "</div>";
    return vLSdivIdbindsHeaderdivC;
  }
}, {
  header: i18n.t("windows.host.header"),
  label: "host_games",
  presets: {},
  width: 1200,
  maxH: "calc(100% - 300px)",
  forceScroll: true,
  yPos: 48,
  dark: true,
  popup: true,
  updateSet: function (p13780, p13781) {
    if (p13781) {
      windows[7].costVal += p13781.checked ? p13780 : -p13780;
      hCustCost.innerHTML = windows[7].costVal ? windows[7].costVal + " KR" : "None";
    }
  },
  presetLoaded: function (p13782, p13783, p13784) {
    try {
      if (p13782 && windows[7].presets[p13782] && p13783) {
        windows[7].presets[p13782].data = JSON.parse(p13783);
        windows[7].presets[p13782].funds = p13784 || 0;
      } else {
        windows[7].presets[p13782].data = "DEFAULT";
        windows[7].presets[p13782].funds = p13784 || 0;
      }
    } catch (e127) {
      windows[7].presets[p13782].data = "DEFAULT";
      windows[7].presets[p13782].funds = p13784 || 0;
    }
    updateWindow(8);
  },
  toggle: function (p13785) {
    for (var v11157 = document.querySelectorAll("input[id^='" + p13785 + "']"), vLN01762 = 0; vLN01762 < v11157.length; vLN01762++) {
      v11157[vLN01762].checked = !v11157[vLN01762].checked;
    }
  },
  changeWep: function (p13786) {
    if (windows[7].wepConf) {
      for (var v11158 = document.querySelectorAll("div[id^='weaponConf']"), vLN01763 = 0; vLN01763 < v11158.length; vLN01763++) {
        v11158[vLN01763].style.display = v11158[vLN01763].id == "weaponConf" + p13786 ? "block" : "none";
      }
    }
  },
  toggleWep: function (p13787) {
    windows[7].wepConf = p13787 == null ? !windows[7].wepConf : p13787;
    if (p13787 != null) {
      var v11159 = document.getElementById("togConfW");
      if (v11159) {
        v11159.checked = p13787;
      }
    }
    var v11160 = windows[7].wepConf ? weaponSelect.value || 0 : -1;
    for (var v11161 = document.querySelectorAll("div[id^='weaponConf']"), vLN01764 = 0; vLN01764 < v11161.length; vLN01764++) {
      v11161[vLN01764].style.display = v11161[vLN01764].id == "weaponConf" + v11160 ? "block" : "none";
    }
  },
  changeCls: function (p13788) {
    if (windows[7].clsConf) {
      for (var v11162 = document.querySelectorAll("div[id^='classConf']"), vLN01765 = 0; vLN01765 < v11162.length; vLN01765++) {
        v11162[vLN01765].style.display = v11162[vLN01765].id == "classConf" + p13788 ? "block" : "none";
      }
    }
  },
  toggleCls: function (p13789) {
    windows[7].clsConf = p13789 == null ? !windows[7].clsConf : p13789;
    if (p13789 != null) {
      var v11163 = document.getElementById("togConfC");
      if (v11163) {
        v11163.checked = p13789;
      }
    }
    var v11164 = windows[7].clsConf ? classSelect.value || 0 : -1;
    for (var v11165 = document.querySelectorAll("div[id^='classConf']"), vLN01766 = 0; vLN01766 < v11165.length; vLN01766++) {
      v11165[vLN01766].style.display = v11165[vLN01766].id == "classConf" + v11164 ? "block" : "none";
    }
  },
  changeEffects: function (p13790) {
    if (windows[7].effectConf) {
      for (var v11166 = document.querySelectorAll("div[id^='effectConf']"), vLN01767 = 0; vLN01767 < v11166.length; vLN01767++) {
        v11166[vLN01767].style.display = v11166[vLN01767].id == "effectConf" + p13790 ? "block" : "none";
      }
    }
  },
  toggleEffects: function (p13791) {
    windows[7].effectConf = p13791 == null ? !windows[7].effectConf : p13791;
    if (p13791 != null) {
      var v11167 = document.getElementById("togConfE");
      if (v11167) {
        v11167.checked = p13791;
      }
    }
    var v11168 = windows[7].effectConf ? effectSelect.value || 0 : -1;
    for (var v11169 = document.querySelectorAll("div[id^='effectConf']"), vLN01768 = 0; vLN01768 < v11169.length; vLN01768++) {
      v11169[vLN01768].style.display = v11169[vLN01768].id == "effectConf" + v11168 ? "block" : "none";
    }
  },
  toggleKRRew: function (p13792) {
    var v11170 = document.getElementById("krRewards");
    if (v11170 && !p13792) {
      var v11171 = document.getElementById("defaultSetts");
      if (v11171) {
        v11171.checked = true;
      }
      windows[7].toggleDefault(true);
    }
  },
  toggleDefault: function (p13793) {
    var v11172 = document.getElementById("defaultSetts");
    if (v11172) {
      if (!p13793) {
        var v11173 = document.getElementById("krRewards");
        if (v11173) {
          v11173.checked = false;
        }
        windows[7].toggleKRRew(true);
      }
      forcedSettings.style.display = v11172.checked ? "none" : "block";
      hostGamePreset.style.display = v11172.checked ? "none" : "block";
      for (var vLN01769 = 0; vLN01769 < this.setTabs.length; ++vLN01769) {
        var v11174 = document.getElementById("hstTab" + vLN01769);
        var v11175 = !v11172.checked;
        if (this.setTabs[vLN01769].rd) {
          if (v11175) {
            v11174.classList.remove("bigMenTabDis");
          } else {
            v11174.classList.add("bigMenTabDis");
          }
        }
      }
    }
  },
  setTabs: [{
    n: "Select"
  }, {
    n: "Game Settings",
    rd: true
  }, {
    n: "Advanced",
    rd: true
  }, {
    n: "Server"
  }],
  switchTab: function (p13794) {
    for (var vLN01770 = 0, v11176; vLN01770 < this.setTabs.length; ++vLN01770) {
      v11176 = document.getElementById("hstTab" + vLN01770);
      if (v11176) {
        if (vLN01770 == p13794) {
          v11176.classList.add("bigMenTabA");
        } else {
          v11176.classList.remove("bigMenTabA");
        }
        document.querySelectorAll(".hostTb" + vLN01770).forEach(function (p13795) {
          if (p13794 == vLN01770) {
            p13795.classList.remove("hide");
          } else {
            p13795.classList.add("hide");
          }
        });
      }
    }
  },
  tabIndex: 0,
  switchTab2: function (p13796) {
    if (p13796 == 0) {
      v11724 = null;
    }
    windows[7].tabIndex = p13796;
    updateWindow(8);
  },
  buyTabs: [{
    n: "Rent Server"
  }, {
    n: "My Servers"
  }],
  dediRes: function (p13797, p13798, p13799) {
    if (p13797 == 0) {
      windows[7].dediServers.data = p13798;
      updateWindow(8);
    } else if (p13797 == 1 && (dediHostErr.innerHTML = p13798, dediHostErr.style.color = "#fff", !p13799)) {
      var v11177 = document.getElementById("rentServBtn");
      if (v11177) {
        v11177.style.display = "inline-block";
      }
      var v11178 = document.getElementById("updDediServBtn");
      if (v11178) {
        v11178.style.display = "inline-block";
      }
    }
  },
  dediCst: function (p13800) {
    dediCostI.innerHTML = UTILS.commaFormatNum(config.dediPrices[p13800]);
  },
  gen: function () {
    windows[7].costVal = 0;
    windows[7].wepConf = false;
    windows[7].clsConf = false;
    windows[7].effectConf = false;
    var v11179 = windows[7].presets[v11724 ? v11724.name : null];
    if (v11723 && !v11724) {
      try {
        var v11180 = JSON.parse(v11723);
        if (v11180 && v11180.config) {
          v11179 = {
            data: v11180.config
          };
          if (!v11179.data.modes) {
            v11179.data.modes = [0];
          }
        }
      } catch (e128) {}
    }
    var vLS62 = "";
    var v11181 = !v11724 || v11179 && v11179.data;
    var v11182 = v11724 && v11181;
    var v11183 = v11724 && v11181 && v11179.funds;
    if (v11183) {
      v11182 = true;
    }
    var v11184 = config.hostTypes[vLN01938 || 0];
    var v11185 = !!v11182;
    var v11186 = !v11181 && !windows[7].presets[v11724 ? v11724.name : null];
    var vA611 = [];
    if (v11185) {
      vA611.push(1, 2);
    }
    if (v11186) {
      vA611.push(1, 2, 3);
    }
    if (v11184.disTabs) {
      vA611.push(...v11184.disTabs);
    }
    if (v11184.buyServ) {
      var vLS62 = "";
      var vO355 = {};
      var vO356 = {};
      if (!this.dediServers) {
        io.send("dsrvl");
        this.dediServers = {};
      } else if (this.dediServers.data) {
        for (var vLN01794 = 0, v11199; vLN01794 < this.dediServers.data.length; ++vLN01794) {
          v11199 = this.dediServers.data[vLN01794];
          if (!vO355[v11199.REG]) {
            vO355[v11199.REG] = [];
          }
          vO355[v11199.REG].push(v11199);
          if (v11199.TRM <= 0) {
            vO356[v11199.REG] = (vO356[v11199.REG] || 0) + 1;
          }
        }
      }
      vLS62 += "<div class='bigMenTabs' style='margin-top:0px !important;margin-left:0px;'>";
      for (var vLN01794 = 0; vLN01794 < this.buyTabs.length; ++vLN01794) {
        vLS62 += "<div class='bigMenTab" + (this.tabIndex == vLN01794 ? " bigMenTabA" : "") + (this.tabIndex >= 2 ? " bigMenTabDis" : "") + "' onclick='playSelect();" + (this.tabIndex >= 2 ? "" : "windows[7].switchTab2(" + vLN01794 + ")") + "' onmouseenter='playTick(0.1);'>" + this.buyTabs[vLN01794].n + "</div>";
      }
      if (this.tabIndex >= 2) {
        vLS62 += "<div class='bigMenTab bigMenTabA' onclick='playSelect();windows[7].switchTab2(0)' onmouseenter='playTick(0.1);'><span class='material-icons-outlined' style='font-size:40px;color:#fb5555;vertical-align:middle;margin-top:-12px;'>close</span></div>";
      }
      vLS62 += "</div>";
      if (this.tabIndex == 0) {
        for (var vLN01794 = 0; vLN01794 < config.purchServRegions.length; ++vLN01794) {
          var v11199 = config.purchServRegions[vLN01794];
          var v11194 = vO355[vLN01794] || [];
          vLS62 += "<div class='serverCard' onclick='windows[7].servInd=" + vLN01794 + ";playSelect();windows[7].switchTab2(2);'><img class='serverFlag' src='" + UTILS.assetsUrl("/img/flags/3x2/" + v11199.f + ".svg") + "' /><div class='serverCardInfo'><span style='padding-left:10px;color:#fff;'>" + v11199.n + "</span><span class='servCrdAv'>" + (vO356[vLN01794] || 0) + " Available</span></div></div>";
        }
      } else if (this.tabIndex == 1) {
        if (!this.dediServers || !this.dediServers.data) {
          vLS62 += "<div style='text-align:center;color:#fff'>Loading...</div>";
        } else {
          for (var v11194 = this.dediServers.data || [], vLN01774 = 0, vLN01794 = 0, v11199; vLN01794 < v11194.length; ++vLN01794) {
            v11199 = v11194[vLN01794];
            if (account && !(v11199.TRM <= 0) && account.id == v11199.OID) {
              var v11202 = JSON.parse(v11199.CONF || "{}");
              var v11203 = UTILS.userAssetsUrl("/m" + v11202.gid + "/thumb.png");
              vLS62 += "<div class='serverCard' onclick='windows[7].servInd=" + vLN01794 + ";playSelect();windows[7].switchTab2(3);'><div style='background-image:url(" + v11203 + ")' class='serverCardI'></div><img class='serverFlag' src='" + UTILS.assetsUrl("/img/flags/3x2/" + config.purchServRegions[v11199.REG].f + ".svg") + "' /><div class='serverCardInfo'><span style='padding-left:10px;color:#fff;'>" + v11199.SVN + "_" + v11199.SID + "</span><span class='servCrdAv'>Cloud Compute</span></div></div>";
              vLN01774++;
            }
          }
          if (!vLN01774) {
            vLS62 += "<div style='color:#fff;text-align:center;'>No available servers</div>";
          }
        }
      } else if (this.tabIndex == 2) {
        if (!this.dediServers || !this.dediServers.data) {
          vLS62 += "<div style='text-align:center;color:#fff;'>Loading...</div>";
        } else {
          var v11194 = vO355[this.servInd] || [];
          if (v11194.length) {
            for (var vLN01794 = 0; vLN01794 < v11194.length; ++vLN01794) {
              var v11199 = v11194[vLN01794];
              var v11196 = this.dediServers.data.indexOf(v11199);
              var v11202 = JSON.parse(v11199.CONF || "{}");
              if (v11199.TRM <= 0) {
                v11202 = {};
              }
              var v11203 = UTILS.userAssetsUrl("/m" + v11202.gid + "/thumb.png");
              vLS62 += "<div class='serverCard' style='" + (v11199.TRM > 0 ? "filter:grayscale(100%);" : "") + "'" + (v11199.TRM > 0 ? "" : "onclick='windows[7].servInd=" + v11196 + ";playSelect();windows[7].switchTab2(3);'") + "><div style='background-image:url(" + v11203 + ")' class='serverCardI'></div><img class='serverFlag' src='" + UTILS.assetsUrl("/img/flags/3x2/" + config.purchServRegions[v11199.REG].f + ".svg") + "' /><div class='serverCardInfo'><span style='padding-left:10px;color:#fff;'>" + v11199.SVN + "_" + v11199.SID + "</span><span class='servCrdAv'>Cloud Compute</span></div></div>";
            }
          } else {
            vLS62 += "<div style='color:#fff;text-align:center;'>No available servers</div>";
          }
        }
      } else if (this.tabIndex == 3) {
        var v11199 = this.dediServers.data[this.servInd];
        if (v11199) {
          var v11200 = v11199.SVN + "_" + v11199.SID;
          var v11201 = config.purchServRegions[v11199.REG];
          var v11202 = JSON.parse(v11199.CONF || "{}");
          if (v11199.TRM <= 0) {
            v11202 = {};
          }
          var v11203 = UTILS.userAssetsUrl("/m" + (v11724 ? v11724.id : v11202.gid) + "/thumb.png");
          var v11204 = v11202.typ || 0;
          var v11205 = v11202.mn || null;
          var v11206 = v11199.OID == account.id && v11199.TRM > 0;
          var vLS63 = "";
          for (var vLN01794 = 0, v11207; vLN01794 < config.dediDurat.length; ++vLN01794) {
            v11207 = config.dediDurat[vLN01794];
            vLS63 += "<option value='" + vLN01794 + "' " + (vLN01794 == v11204 ? " selected=''" : "") + ">" + v11207 + " Days</option>";
          }
          vLS62 += "<div class='serverCard'><div style='background-image:url(" + v11203 + ")' class='serverCardI'></div><img class='serverFlag' src='" + UTILS.assetsUrl("/img/flags/3x2/" + v11201.f + ".svg") + "' /><div class='serverCardInfo'><span style='padding-left:10px;color:#fff;'>" + v11200 + "</span><span class='servCrdAv'>Cloud Compute</span></div></div><div class='setBodH' style='width:731px;display:inline-block;margin-top:8px;margin-left:10px;'><div class='settName' style='font-size:20px;'>Server Name <span class='floatR'>" + v11200 + "</span></div><div class='settName' style='font-size:20px;'>Server Region <span class='floatR'>" + v11201.r + "</span></div><div class='settName' style='font-size:20px;'>City <span class='floatR'>" + v11201.n + "</span></div><div class='settName' style='font-size:20px;'>Type <span class='floatR'>Cloud Compute single-core</span></div></div><div class='setBodH' style='margin-top:10px;'>" + (v11199.TRM > 0 ? "<div class='settName' style='font-size:20px;padding-bottom:15px;padding-top:10px;'>Time remaining<span style='float:right;color:#c2c2c2;'>" + UTILS.getReadableTime(v11199.TRM) + "</span></div>" : "") + "<div class='settName' style='font-size:20px;padding-bottom:15px;padding-top:10px;'>" + (v11206 ? "Extend Time" : "Rental Duration") + "<select onchange='windows[7].dediCst(this.value)' class='inputGrey2' style='margin-top:-5px;' id='dediHostDur'>" + vLS63 + "</select></div><div class='settName' style='font-size:20px;padding-bottom:15px;padding-top:10px;'>" + (v11206 ? "Change Game" : "Select Game") + "<span class='floatR' style='margin-top:-5px;'><a href='javascript:showGames(2);'>" + (v11724 ? v11724.name : v11205 || "Select Game") + "</a></span></div><div class='setBodH' style='margin-top:20px;padding-bottom:5px;padding-top:15px;'>By renting a server, you agree to the <a>Terms & Conditions</a>. It may take up to 10 minutes for a server to become available once it starts up.<div class='settName' style='font-size:20px;padding-top:10px;border-top: 3px solid rgba(255, 255, 255, 0.2);'>Server Cost<span class='floatR' style='color:#fff'><span id='dediCostI' style='color:rgba(255,255,255,0.7)'>" + UTILS.commaFormatNum(config.dediPrices[v11204]) + "</span> KR</span></div></div></div><div style='font-size:22px;padding-left:10px;margin-top:20px;display:none;width:100%;text-align:center;' id='dediHostErr'></div><div id='rentServBtn' onclick='rentDediServer(`" + v11199.ID + "`);' style='" + (v11206 ? "width:calc(50% - 20px);" : "") + "'>" + (v11206 ? "Extend Rental" : "Rent Server") + "</div>" + (v11206 ? "<div id='updDediServBtn' onclick='rentDediServer(" + v11199.ID + ", 1)'>Restart/Update</div>" : "");
        }
      }
      return vLS62;
    }
    var vLSdivClassbigMenTabsSt = "<div class='bigMenTabs' style='margin-top:30px !important;margin-left:0px;'>";
    for (var vLN01794 = 0; vLN01794 < this.setTabs.length; ++vLN01794) {
      vLSdivClassbigMenTabsSt += "<div id='hstTab" + vLN01794 + "' class='bigMenTab" + (vLN01794 == 0 ? " bigMenTabA" : vA611.indexOf(vLN01794) >= 0 ? " bigMenTabDis" : "") + "' onclick='playSelect();" + (this.setTabs[vLN01794].click ? this.setTabs[vLN01794].click : "windows[7].switchTab(" + vLN01794 + ")") + "' onmouseenter='playTick(0.1);'>" + this.setTabs[vLN01794].n + "</div>";
    }
    var v11208 = !!isGameHost && !!account && !!account.canRehost;
    vLSdivClassbigMenTabsSt += "<div class='bigMenTab' id='startServBtn' style='background:" + (v11186 ? "#595959" : "#4582d1") + "!important;" + (v11208 ? "" : "border-top-right-radius:6px;border-bottom-right-radius:6px;") + "' onclick='" + (v11186 ? "" : "playSelect(0.1);createPrivateRoom();") + "'>Start Game</div>";
    if (v11208) {
      vLSdivClassbigMenTabsSt += "<div class='bigMenTab' id='startServBtn' style='background:" + (v11186 ? "#595959" : "var(--red)") + "!important;border-top-right-radius:6px;border-bottom-right-radius:6px;' onclick='" + (v11186 ? "" : "playSelect(0.1);createPrivateRoom(true);") + "'>Rehost</div>";
    }
    vLSdivClassbigMenTabsSt += "</div>";
    vLS62 += "<div class='hostHeader' style='margin-bottom:15px;width:100%;margin-top:-10px;padding-left:15px;'>" + v11184.title + "<span style='color:#919191;font-size:22px;float:right;' id='hostGameMsg'>" + (v11186 ? "Loading preset..." : "") + "</span></div>" + vLSdivClassbigMenTabsSt;
    vLS62 += "<div class='hostTb2 hide' style='margin-top:-10px;'></div>";
    vLS62 += "<div class='hostTb0'>";
    if (!v11724) {
      if (v11184.topHedr) {
        vLS62 += v11184.topHedr();
      }
    } else {
      var v11209 = UTILS.userAssetsUrl("/m" + v11724.id + "/thumb.png");
      vLS62 += "<div style='margin-top:30px;'>\n\t\t\t\t<div style=\"width:360px;display:inline-block;margin-left:10px;margin-right:20px;\">\n\t\t\t\t\t<div class=\"setSugBox sugBoxSelCus blackShad\" style=\"background:url(" + v11209 + ")\"\n\t\t\t\t\t\tonmouseenter=\"playTick(0.1);\" onclick=\"playSelect();showGames(1)\">\n\t\t\t\t\t\t<div class=\"segSugIH\">\n\t\t\t\t\t\t\t<div class=\"setSugInf\">Change Game</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div id=\"hostGameNameHolder\">\n\t\t\t\t\t\t<span><i style=\"color:#eb5656;font-size:30px;vertical-align:-3px;cursor:pointer\" onclick=\"openHostWindow(true)\" class=\"material-icons\">delete</i> </span>\n\t\t\t\t\t\t<span id=\"commMap\" style=\"color:white\">" + v11724.name + "</span>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"setBodH\" style=\"width:745px;display:inline-block;margin-top:0px;vertical-align:top\">\n\t\t\t\t\t<div class=\"settNameSmall\" style=\"font-size:19px\">Players<span id=\"customSetPrev0\" style=\"color:white;float:right\">...</span></div>\n\t\t\t\t\t<div class=\"settNameSmall\" style=\"font-size:19px\">Minutes<span id=\"customSetPrev2\" style=\"color:white;float:right\">...</span></div>\n\t\t\t\t\t<div class=\"settNameSmall\" style=\"font-size:19px\">Gamemodes\n\t\t\t\t\t<span id=\"gameModesC\" style=\"max-width:480px;color:white;float:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;\"\n\t\t\t\t\tclass=\"textOverflow\">...</span></div>\n\t\t\t\t\t<div class=\"settNameSmall\" style=\"font-size:19px\">Likes<span id=\"gameLikesC\" style=\"color:white;float:right\">...</span></div>\n\t\t\t\t</div>\n\t\t\t</div>";
    }
    if (!v11186 && (v11184.info || v11724)) {
      vLS62 += "<div class='setBodH' style='padding-top:10px'>";
      if (!v11184.noCustM && v11724) {
        vLS62 += "<div class='settNameSmall' style='margin:0px;margin-top:10px;border-bottom:none;padding-bottom: 0px;'>" + i18n.t("server.config.forceDefault") + "<label class='switch'><input id='defaultSetts' type='checkbox' onclick='windows[7].toggleDefault()' checked><span class='slider'></span></label></div>";
        vLS62 += "<div id='defaultSettsInfo' style='margin-top:15px;margin-bottom:15px;'><div style='padding:10px;background-color:rgba(0,0,0,0.6);border: 3px solid rgba(255, 255, 255, 0.4);margin-bottom:0px;margin-top:10px;padding-left:15px;font-size:18px'>" + i18n.t("windows.host.default.settings") + "</div></div>";
      }
      if (v11184.info) {
        vLS62 += "<div id='krRewardsInfo' style='margin-top:10px;padding-bottom:0px;'><div style='padding:10px;background-color:rgba(0,0,0,0.4);border: 3px solid rgba(255, 255, 255, 0.4);margin-bottom:0px;margin-top:0px;padding-left:15px;font-size:18px'>" + v11184.info + "</div>" + (v11184.infoAdd ? "<span style='color:rgba(255,255,255,0.4);font-size:14px;margin-bottom:5px'>" + v11184.infoAdd + "</span>" : "") + "</div>";
      }
      if (v11183) {
        vLS62 += "<div class='settNameSmall' style='margin:0px;margin-top:20px;border-bottom:none;padding-top:0px;padding-bottom:0px;'>" + i18n.t("server.config.krRewards") + "<div class='krIconHost'>KR</div> <label class='switch'><input id='krRewards' type='checkbox' onclick='windows[7].toggleKRRew()'" + (v11183 ? " checked" : "") + "><span class='slider'></span></label></div>";
        vLS62 += "<div id='krRewardsInfo' style='margin-top:15px;margin-bottom:5px;'><div style='padding:10px;background-color:rgba(0,0,0,0.4);border: 3px solid rgba(255, 255, 255, 0.4);margin-bottom:0px;margin-top:10px;padding-left:15px;font-size:18px'>" + i18n.t("windows.host.rewards") + "<div style='margin-top:20px;'>Available <span style='float:right;color:rgba(255,255,255,0.4)'>" + UTILS.commaFormatNum(v11179.funds || 0) + " <span style='color:rgba(255,255,255,0.8)'>KR</span></span></div></div></div>";
        vLS62 += "<div style='height:10px;'></div>";
      }
      vLS62 += "</div>";
    }
    if (!v11724 && !v11184.noCustM) {
      vLS62 += "<div class='setBodH'><div class='settNameSmall'>" + i18n.t("windows.host.raw") + "<input id='rawMapData' type='search' " + (v11723 ? "value='" + v11723.replace("'", "\"") + "'" : "placeholder='" + i18n.t("windows.host.raw") + "'") + " autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false'></div></div>";
    }
    vLS62 += "<div style='margin-top:20px;margin-bottom:-10px;'>";
    if (!v11724) {
      vLS62 += "<div class='mapListCat'>" + (v11184.mapH || "Default Krunker Maps") + "</div>";
      for (var vLN01794 = 0; vLN01794 < maps.length; vLN01794++) {
        var v11210 = maps[vLN01794];
        var v11211 = v11210.name.toLowerCase();
        if (!v11184.allMaps || !(v11184.allMaps.indexOf(v11211) < 0)) {
          vLS62 += "<label class='hostMap'><div class='hostMapName blackShad'>" + UTILS.capFirst(v11210.name) + "</div><input onclick='playSelect(0.1)' id='gameMap" + vLN01794 + "' type='checkbox'><img loading='lazy' onmouseenter='playTick();' draggable='false' class='hostMapImg' src='" + UTILS.assetsUrl("/img/maps/map_" + vLN01794 + ".png") + "'></label>";
        }
      }
    }
    vLS62 += "</div>";
    vLS62 += "</div>";
    if (v11181) {
      if (v11179) {
        v11179 = v11179.data;
      }
      if (v11179 == "DEFAULT") {
        v11179 = null;
      }
      vLS62 += "<div id='forcedSettings' style='display:" + (v11185 ? "none" : "block") + "'>";
      if (!v11184.comp && !v11184.restrict) {
        vLS62 += "<div class='hostTb1 hide'>";
        vLS62 += "<div class='setHed' style='margin-bottom:15px;margin-top:30px;'>" + i18n.t("windows.host.modes") + "<div class='hostToggle' onclick='windows[7].toggle(&quot;gameMode&quot;)'>Toggle</div></div>";
        vLS62 += "<div style='margin-top:5px'>";
        for (var vLN01794 = 0, v11212; vLN01794 < gameModes.length; vLN01794++) {
          v11212 = gameModes[vLN01794];
          if (!v11212.preventCustomGames || account && account.isDev) {
            var v11229 = v11179 && v11179.modes && v11179.modes.length ? v11179.modes.indexOf(vLN01794) >= 0 : vLN01794 == 0;
            vLS62 += "<label class='hostOpt' onmouseenter='playTick()'><span class='optName'>" + UTILS.capFirst(v11212.name) + "</span><input id='gameMode" + vLN01794 + "' type='checkbox'" + (v11229 ? "checked" : "") + "><div class='optCheck'></div></label>";
          }
        }
        vLS62 += "</div>";
        vLS62 += "<div class='setHed' style='margin-bottom:15px;'>" + i18n.t("windows.host.classes") + "<div class='hostToggle' onclick='windows[7].toggle(&quot;gameClass&quot;)'>Toggle</div></div>";
        vLS62 += "<div style='margin-top:5px'>";
        for (var vLN01794 = 0; vLN01794 < Game.classConfig.length; vLN01794++) {
          var v11214 = Game.classConfig[vLN01794];
          var v11229 = !v11179 || !v11179.classes || v11179.classes.indexOf(vLN01794) >= 0;
          vLS62 += "<label class='hostOpt' onmouseenter='playTick()'><span class='optName'>" + v11214.name + "</span><img loading='lazy' class='optImg' src='" + UTILS.assetsUrl("textures/classes/icon_" + vLN01794 + ".png", true) + "' /><input id='gameClass" + vLN01794 + "' type='checkbox'" + (v11229 ? "checked" : "") + "><div class='optCheck'></div></label>";
        }
        vLS62 += "</div>";
        vLS62 += "</div>";
        vLS62 += "<div class='hostTb2 hide'><div class='setHed' style='margin-bottom:15px;'>Weapon Config<select id='weaponSelect' class='inputGrey2' onchange='windows[7].changeWep(this.value)'>";
        windows[7].wepConf = v11179 && v11179.weps;
        for (var vLN01795 = 0; vLN01795 < Game.weapons.length; vLN01795++) {
          vLS62 += "<option value='" + vLN01795 + "' " + (vLN01795 == 0 ? "selected" : "") + ">" + Game.weapons[vLN01795].name + "</option>";
        }
        vLS62 += "</select><label class='switch'><input type='checkbox' id='togConfW' onchange='windows[7].toggleWep()' " + (windows[7].wepConf ? "checked" : "") + "><span class='slider'></span></label></div>";
        for (var vLN01795 = 0; vLN01795 < Game.weapons.length; vLN01795++) {
          vLS62 += "<div id='weaponConf" + vLN01795 + "' style='display:" + (vLN01795 == 0 && v11179 && v11179.weps ? "block" : "none") + ";margin-top:10px'><div class='setBodH'>";
          var v11216 = v11179 && v11179.weps && v11179.weps[vLN01795] != null ? v11179.weps[vLN01795] : null;
          for (var vLN01794 = 0; vLN01794 < config.weaponConfig.length; vLN01794++) {
            player = config.weaponConfig[vLN01794];
            if (Game.weapons[vLN01795][player.varN] != null) {
              var v11227 = player.name;
              var v11224 = v11216 && v11216[player.varN] != null ? v11216[player.varN] : Game.weapons[vLN01795][player.varN];
              if (player.bool) {
                vLS62 += "<div class='settNameSmall'>" + v11227 + " <label class='switch'><input type='checkbox' id='customW" + vLN01795 + "" + player.varN + "' " + (v11224 ? "checked" : "") + "><span class='slider'></span></label>" + (player.cost ? "<span style='float:right;margin-right:10px;color:rgba(0,0,0,0.5)'>" + player.cost + " <b>KR</b></span>" : "") + "</div>";
              } else if (player.select) {
                vLS62 += "<div class='settNameSmall'>" + v11227;
                vLS62 += "<select id='customW" + vLN01795 + "" + player.varN + "' class='inputGrey2'>";
                for (var vLN01793 = 0; vLN01793 < player.options.length; vLN01793++) {
                  vLS62 += "<option value='" + vLN01793 + "' " + (vLN01793 == v11224 ? "selected" : "") + ">" + player.options[vLN01793] + "</option>";
                }
                vLS62 += "</select></div>";
              } else {
                vLS62 += player.input ? "<div class='settNameSmall'>" + v11227 + "<input id='customW" + vLN01795 + "" + player.varN + "' value='" + v11224 + "' type='text'style='border-radius:6px;border:none;background:#eee;padding:6px;padding-bottom:6px;float:right;margin-top:5px;margin-bottom:5px;' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false'></div>" : "<div class='settNameSmall'>" + v11227 + "<span class='sliderVal' id='customWSet" + vLN01795 + "_" + vLN01794 + "'>" + v11224 + "</span><div class='slidecontainer'><input type='range' min='" + player.min + "' max='" + player.max + "' step='" + player.step + "' id='customW" + vLN01795 + "" + player.varN + "' value='" + v11224 + "' oninput='updateSliderLabel2(0," + vLN01795 + "," + vLN01794 + ",this.value)' class='sliderM'></div></div>";
              }
            }
          }
          vLS62 += "</div></div>";
        }
        vLS62 += "</div>";
        vLS62 += "<div class='hostTb2 hide'><div class='setHed' style='margin-bottom:15px'>Class Config<select id='classSelect' class='inputGrey2' onchange='windows[7].changeCls(this.value)'>";
        windows[7].clsConf = v11179 && v11179.cls;
        for (var vLN01795 = 0; vLN01795 < Game.classes.length; vLN01795++) {
          vLS62 += "<option value='" + vLN01795 + "' " + (vLN01795 == 0 ? "selected" : "") + ">" + Game.classes[vLN01795].name + "</option>";
        }
        vLS62 += "</select><label class='switch'><input type='checkbox' id='togConfC' onchange='windows[7].toggleCls()' " + (windows[7].clsConf ? "checked" : "") + "><span class='slider'></span></label></div>";
        for (var vLN01795 = 0; vLN01795 < Game.classes.length; vLN01795++) {
          vLS62 += "<div id='classConf" + vLN01795 + "' style='display:" + (vLN01795 == 0 && v11179 && v11179.cls ? "block" : "none") + ";margin-top:10px;'><div class='setBodH'>";
          var v11219 = v11179 && v11179.cls && v11179.cls[vLN01795] != null ? v11179.cls[vLN01795] : null;
          for (var vLN01794 = 0; vLN01794 < config.classConfig.length; vLN01794++) {
            player = config.classConfig[vLN01794];
            if (Game.classes[vLN01795][player.varN] != null) {
              var v11227 = player.name;
              var v11224 = v11219 && v11219[player.varN] != null ? v11219[player.varN] : Game.classes[vLN01795][player.varN];
              if (player.bool) {
                vLS62 += "<div class='settNameSmall'>" + v11227 + " <label class='switch'><input type='checkbox' id='customC" + vLN01795 + "" + player.varN + "' " + (v11224 ? "checked" : "") + "><span class='slider'></span></label></div>";
              } else if (player.select) {
                vLS62 += "<div class='settNameSmall'>" + v11227;
                vLS62 += "<select id='customC" + vLN01795 + "" + player.varN + "' class='inputGrey2'>";
                for (var vLN01793 = 0; vLN01793 < player.options.length; vLN01793++) {
                  vLS62 += "<option value='" + vLN01793 + "' " + (vLN01793 == v11224 ? "selected" : "") + ">" + player.options[vLN01793] + "</option>";
                }
                vLS62 += "</select></div>";
              } else {
                vLS62 += player.input ? "<div class='settNameSmall'>" + v11227 + "<input id='customC" + vLN01795 + "" + player.varN + "' value='" + v11224 + "' type='text'style='border-radius:6px;border:none;background:#eee;padding:6px;padding-bottom:6px;float:right;margin-top:5px;margin-bottom:5px;' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false'></div>" : "<div class='settNameSmall'>" + v11227 + "<span class='sliderVal' id='customCSet" + vLN01795 + "_" + vLN01794 + "'>" + v11224 + "</span><div class='slidecontainer'><input type='range' min='" + player.min + "' max='" + player.max + "' step='" + player.step + "' id='customC" + vLN01795 + "" + player.varN + "' value='" + v11224 + "' oninput='updateSliderLabel2(1," + vLN01795 + "," + vLN01794 + ",this.value)' class='sliderM'></div></div>";
              }
            }
          }
          vLS62 += "</div></div>";
        }
        vLS62 += "</div>";
        vLS62 += "<div class='hostTb2 hide'><div class='setHed' style='margin-bottom:15px'>Effect Config<select id='effectSelect' class='inputGrey2' onchange='windows[7].changeEffects(this.value)'>";
        windows[7].effectConf = v11179 && v11179.prks;
        for (var vLN01795 = 0; vLN01795 < Game.effects.length; vLN01795++) {
          vLS62 += "<option value='" + vLN01795 + "' " + (vLN01795 == 0 ? "selected" : "") + ">" + Game.effects[vLN01795].name + "</option>";
        }
        vLS62 += "</select><label class='switch'><input type='checkbox' id='togConfE' onchange='windows[7].toggleEffects()' " + (windows[7].effectConf ? "checked" : "") + "><span class='slider'></span></label></div>";
        for (var vLN01795 = 0; vLN01795 < Game.effects.length; vLN01795++) {
          vLS62 += "<div id='effectConf" + vLN01795 + "' style='display:" + (vLN01795 == 0 && v11179 && v11179.prks ? "block" : "none") + ";margin-top:10px;'><div class='setBodH'>";
          var v11222 = v11179 && v11179.prks && v11179.prks[vLN01795] != null ? v11179.prks[vLN01795] : null;
          for (var vLN01794 = 0; vLN01794 < config.effectConfig.length; vLN01794++) {
            player = config.effectConfig[vLN01794];
            if (Game.effects[vLN01795][player.varN] != null) {
              var v11227 = player.name;
              var v11224 = v11222 && v11222[player.varN] != null ? v11222[player.varN] : Game.effects[vLN01795][player.varN];
              if (player.bool) {
                vLS62 += "<div class='settNameSmall'>" + v11227 + " <label class='switch'><input type='checkbox' id='customE" + vLN01795 + "" + player.varN + "' " + (v11224 ? "checked" : "") + "><span class='slider'></span></label></div>";
              } else if (player.select) {
                vLS62 += "<div class='settNameSmall'>" + v11227;
                vLS62 += "<select id='customE" + vLN01795 + "" + player.varN + "' class='inputGrey2'>";
                for (var vLN01793 = 0; vLN01793 < player.options.length; vLN01793++) {
                  vLS62 += "<option value='" + vLN01793 + "' " + (vLN01793 == v11224 ? "selected" : "") + ">" + player.options[vLN01793] + "</option>";
                }
                vLS62 += "</select></div>";
              } else {
                vLS62 += player.input ? "<div class='settNameSmall'>" + v11227 + "<input id='customE" + vLN01795 + "" + player.varN + "' value='" + v11224 + "' type='text'style='border-radius:6px;border:none;background:#eee;padding:6px;padding-bottom:6px;float:right;margin-top:5px;margin-bottom:5px;' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false'></div>" : "<div class='settNameSmall'>" + v11227 + "<span class='sliderVal' id='customESet" + vLN01795 + "_" + vLN01794 + "'>" + v11224 + "</span><div class='slidecontainer'><input type='range' min='" + player.min + "' max='" + player.max + "' step='" + player.step + "' id='customE" + vLN01795 + "" + player.varN + "' value='" + v11224 + "' oninput='updateSliderLabel2(2," + vLN01795 + "," + vLN01794 + ",this.value)' class='sliderM'></div></div>";
              }
            }
          }
          vLS62 += "</div></div>";
        }
        vLS62 += "</div>";
      }
      vLS62 += "<div class='hostTb2 hide'>";
      vLS62 += "<div class='setHed' style='margin-bottom:15px'>" + i18n.t("windows.host.settings") + "</div><div class='setBodH'>";
      var v11225 = UTILS.getAccountType(account);
      var v11226 = true;
      for (var vLN01794 = 0; vLN01794 < config.serverConfig.length; vLN01794++) {
        player = config.serverConfig[vLN01794];
        if ((player.hostTypes || [0]).indexOf(vLN01938 || 0) != -1) {
          var v11227 = i18n.t("server.config." + player.varN);
          var v11228 = !!v11184.showAll || !!player.basic;
          if (player.head && !v11184.hideHead) {
            if (v11226) {
              vLS62 += "</div>";
            }
            v11226 = true;
            vLS62 += "<div class='setHed' style='margin-bottom:15px'>" + player.head + "</div><div class='setBodH'>";
          }
          if (player.bool) {
            var v11229 = v11184.comp && player.defC != null ? player.defC : player.def;
            if (v11179 && v11179.settings && v11179.settings[player.varN] != null && !player.cost) {
              v11229 = !!v11179.settings[player.varN];
            }
            vLS62 += "<div class='settNameSmall' style='" + (player.hide ? "display:none" : "") + "'>" + v11227 + " <label class='switch'><input type='checkbox' onchange='windows[7].updateSet(" + (player.cost || 0) + ",this)' id='customS" + player.varN + "' " + (v11229 ? "checked" : "") + "><span class='slider'></span></label>" + (player.cost ? "<span style='float:right;margin-right:10px;color:rgba(0,0,0,0.5)'>" + player.cost + " <b>KR</b></span>" : "") + "</div>";
          } else if (player.input) {
            vLS62 += "<div class='settNameSmall' style='" + (player.hide ? "display:none" : "") + "'>" + v11227 + "<input id='customS" + player.varN + "' value='" + (v11184.comp && player.defC != null ? player.defC : player.def) + "' type='text'style='border-radius:6px;border:none;background:#eee;padding:6px;padding-bottom:6px;float:right;margin-top:5px;margin-bottom:5px;' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false'></div>";
          } else if (player.select) {
            vLS62 += "<div class='settNameSmall' style='" + (player.hide ? "display:none" : "") + "'>" + v11227;
            vLS62 += "<select id='customS" + player.varN + "' class='inputGrey2'>";
            for (var vLN01795 = 0; vLN01795 < player.options.length; vLN01795++) {
              vLS62 += "<option value='" + vLN01795 + "' " + (vLN01795 == (v11184.comp && player.defC != null ? player.defC : player.def) ? "selected" : "") + ">" + player.options[vLN01795] + "</option>";
            }
            vLS62 += "</select></div>";
          } else {
            var v11230 = v11184.comp && player.defC != null ? player.defC : player.def;
            var v11231 = player.max;
            if (v11225 == 3) {
              v11231 = player.maxF || player.max;
            } else if (v11225 == 2) {
              v11231 = player.maxP || player.max;
            } else if (v11225 == 0) {
              v11231 = player.maxG || player.max;
            }
            if (v11179 && v11179.settings && v11179.settings[player.varN] != null && !player.cost) {
              v11230 = v11179.settings[player.varN];
              if (v11230 > v11231) {
                v11230 = v11231;
              }
            }
            vLS62 += "<div class='settNameSmall' style='" + (player.hide ? "display:none" : "") + "'>" + (player.classIcon == null ? "" : "<img loading='lazy' class='classLimitIcon' src='" + UTILS.assetsUrl("textures/classes/icon_" + player.classIcon + ".png", true) + "' />") + v11227 + "<span class='sliderVal' id='customSet" + vLN01794 + "'>" + v11230 + "</span><div class='slidecontainer' style='vertical-align:top;margin-top:-6px'><input type='range' min='" + player.min + "' max='" + v11231 + "' step='" + player.step + "' id='customS" + player.varN + "' value='" + v11230 + "' oninput='updateSliderLabel(" + vLN01794 + ",this.value)' class='sliderM'></div></div>";
          }
        }
      }
      if (v11226) {
        vLS62 += "</div>";
      }
      vLS62 += "</div></div></div>";
      vLS62 += "<div class='hostTb3 hide' style='margin-top:-10px;'>";
      if (account && account.level >= 10 && !v11184.comp && !v11184.restrict) {
        vLS62 += "<div class='setHed' style='margin-bottom:15px'>Social</div>";
        vLS62 += "<div class='setBodH'><div class='settNameSmall'>Share on Hub <label class='switch'><input id='shareToHub' type='checkbox'><span class='slider'></span></label></div></div>";
      }
      if (account && !v11184.comp && !v11184.restrict) {
        vLS62 += "<div class='setHed' style='margin-bottom:15px;'>Server Upgrades</div><div class='setBodH'>";
        for (var vLN01796 = 0; vLN01796 < config.serverUpg.length; ++vLN01796) {
          vLS62 += "<div class='settNameSmall'>" + config.serverUpg[vLN01796].name + " <label class='switch'><input id='servUp" + config.serverUpg[vLN01796].varN + "' type='checkbox' onchange='windows[7].updateSet(" + config.serverUpg[vLN01796].cost + ",this)'><span class='slider'></span></label><span style='float:right;margin-right:10px;color:rgba(255,255,255,0.5)'>" + config.serverUpg[vLN01796].cost + " <b style='color:#fff'>KR</b></span></div>";
        }
        vLS62 += "</div>";
      }
      if (!v11184.comp && !v11184.restrict) {
        vLS62 += "<div class='setHed' style='margin-bottom:15px;'>Privacy</div>";
        vLS62 += "<div class='setBodH'><div class='settNameSmall'>" + i18n.t("server.config.private") + " <label class='switch'><input id='makePrivate' type='checkbox'><span class='slider'></span></label></div>";
        vLS62 += "<div class='settNameSmall'>Server Password<input id='passCode' value='' type='text' placeholder='Enter Password'style='border-radius:6px;border:none;background:#eee;padding:6px;padding-bottom:6px;float:right;margin-top:5px;margin-bottom:5px;' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false'></div></div>";
        vLS62 += "<div id='hostGamePreset' style='text-align:left;margin-top:20px;margin-bottom:10px;display:" + (v11185 || v11184.comp ? "none" : "block") + "'>" + windows[7].genPresets(true) + "</div>";
      }
      vLS62 += "</div>";
    } else if (!windows[7].presets[v11724.name]) {
      windows[7].presets[v11724.name] = {};
      API_CLIENT.getMapPreset(v11724.name, this.presetLoaded);
    }
    vLS62 += "<div style='margin-top:40px'></div>";
    vLS62 += "<div id='stickyHostH'>Server Cost <span id='hCustCost' style='float:right;color:rgba(255,255,255,0.6)'>None</span></div>";
    return vLS62;
  },
  presetAction: function (p13801) {
    if (p13801 == 0 && presetSelect.value == "Select") {
      return;
    }
    if (p13801 == 2 && presetSelect.value == "Select") {
      return;
    }
    let vGetSavedVal11 = getSavedVal("krk_hostPresets");
    vGetSavedVal11 = vGetSavedVal11 ? JSON.parse(vGetSavedVal11) : {};
    var v11232 = presetName.value.length ? presetName.value : presetSelect.value == "Select" ? "Preset1" : presetSelect.value;
    if (p13801 == 2) {
      if (vGetSavedVal11[presetSelect.value]) {
        delete vGetSavedVal11[presetSelect.value];
      }
      saveVal("krk_hostPresets", JSON.stringify(vGetSavedVal11));
    } else {
      let v11233 = p13801 == 1 ? {} : vGetSavedVal11[presetSelect.value];
      for (var vLN01806 = 0, v11234, v11235; vLN01806 < maps.length; vLN01806++) {
        v11235 = maps[vLN01806];
        v11234 = document.getElementById("gameMap" + vLN01806);
        if (v11234) {
          if (p13801 == 1) {
            v11233["gameMap" + vLN01806] = v11234.checked;
          } else if ("gameMap" + vLN01806 in v11233) {
            v11234.checked = v11233["gameMap" + vLN01806];
          }
        }
      }
      for (var vLN01806 = 0; vLN01806 < gameModes.length; vLN01806++) {
        if (!gameModes[vLN01806].preventCustomGames || account && account.isDev) {
          v11234 = document.getElementById("gameMode" + vLN01806);
          if (v11234) {
            if (p13801 == 1) {
              v11233["gameMode" + vLN01806] = v11234.checked;
            } else if ("gameMode" + vLN01806 in v11233) {
              v11234.checked = v11233["gameMode" + vLN01806];
            }
          }
        }
      }
      for (var vLN01806 = 0, v11236; vLN01806 < Game.classConfig.length; vLN01806++) {
        v11236 = Game.classConfig[vLN01806];
        v11234 = document.getElementById("gameClass" + vLN01806);
        if (v11234) {
          if (p13801 == 1) {
            v11233["gameClass" + vLN01806] = v11234.checked;
          } else if ("gameClass" + vLN01806 in v11233) {
            v11234.checked = v11233["gameClass" + vLN01806];
          }
        }
      }
      for (var vLN01806 = 0; vLN01806 < config.serverConfig.length; vLN01806++) {
        player = config.serverConfig[vLN01806];
        v11234 = document.getElementById("customS" + player.varN);
        if (v11234) {
          if (p13801 == 1) {
            v11233[player.varN] = v11234[player.bool ? "checked" : "value"];
          } else if (player.varN in v11233) {
            if (!player.bool && !player.input) {
              document.getElementById("customSet" + vLN01806).textContent = v11233[player.varN];
            }
            v11234[player.bool ? "checked" : "value"] = v11233[player.varN];
          }
        }
      }
      var v11237 = false;
      for (var vLN01805 = 0; vLN01805 < Game.weapons.length; vLN01805++) {
        for (var vLN01806 = 0; vLN01806 < config.weaponConfig.length; vLN01806++) {
          player = config.weaponConfig[vLN01806];
          if (Game.weapons[vLN01805][player.varN] != null && (v11234 = document.getElementById("customW" + vLN01805 + "" + player.varN), v11234)) {
            var v11242 = player.varN + "_W_" + vLN01805;
            if (p13801 == 1) {
              v11233[v11242] = v11234[player.bool ? "checked" : "value"];
            } else if (v11242 in v11233) {
              if (!player.bool && !player.input) {
                updateSliderLabel2(0, vLN01805, vLN01806, v11233[v11242]);
              }
              v11234[player.bool ? "checked" : "value"] = v11233[v11242];
              if (v11233[v11242] != Game.weapons[vLN01805][player.varN]) {
                v11237 = true;
              }
            }
          }
        }
      }
      if (v11237) {
        windows[7].toggleWep(true);
      }
      var v11239 = false;
      for (var vLN01805 = 0; vLN01805 < Game.classes.length; vLN01805++) {
        for (var vLN01806 = 0; vLN01806 < config.classConfig.length; vLN01806++) {
          player = config.classConfig[vLN01806];
          if (Game.classes[vLN01805][player.varN] != null && (v11234 = document.getElementById("customC" + vLN01805 + "" + player.varN), v11234)) {
            var v11242 = player.varN + "_C_" + vLN01805;
            if (p13801 == 1) {
              v11233[v11242] = v11234[player.bool ? "checked" : "value"];
            } else if (v11242 in v11233) {
              if (!player.bool && !player.input) {
                updateSliderLabel2(1, vLN01805, vLN01806, v11233[v11242]);
              }
              v11234[player.bool ? "checked" : "value"] = v11233[v11242];
              if (v11233[v11242] != Game.classes[vLN01805][player.varN]) {
                v11239 = true;
              }
            }
          }
        }
      }
      if (v11239) {
        windows[7].toggleCls(true);
      }
      var v11241 = false;
      for (var vLN01805 = 0; vLN01805 < Game.effects.length; vLN01805++) {
        for (var vLN01806 = 0; vLN01806 < config.effectConfig.length; vLN01806++) {
          player = config.effectConfig[vLN01806];
          if (Game.effects[vLN01805][player.varN] != null && (v11234 = document.getElementById("customE" + vLN01805 + "" + player.varN), v11234)) {
            var v11242 = player.varN + "_E_" + vLN01805;
            if (p13801 == 1) {
              v11233[v11242] = v11234[player.bool ? "checked" : "value"];
            } else if (v11242 in v11233) {
              if (!player.bool && !player.input) {
                updateSliderLabel2(2, vLN01805, vLN01806, v11233[v11242]);
              }
              v11234[player.bool ? "checked" : "value"] = v11233[v11242];
              if (v11233[v11242] != Game.effects[vLN01805][player.varN]) {
                v11241 = true;
              }
            }
          }
        }
      }
      if (v11241) {
        windows[7].toggleEffects(true);
      }
      if (p13801 == 1) {
        if (v11724) {
          v11233.commMap = v11724.name;
        }
        v11234 = document.getElementById("rawMapData");
        if (v11234 && v11234.value != "") {
          v11233.rawMapData = v11234.value;
        }
        v11234 = document.getElementById("makePrivate");
        if (v11234 && v11234.checked != 0) {
          v11233.makePrivate = v11234.checked;
        }
        v11234 = document.getElementById("krRewards");
        if (v11234 && v11234.checked != 0) {
          v11233.krRewards = v11234.checked;
        }
        vGetSavedVal11[v11232] = v11233;
        saveVal("krk_hostPresets", JSON.stringify(vGetSavedVal11));
      } else {
        if ("commMap" in v11233) {
          document.getElementById("commMap").textContent = v11724.name = v11233.commMap;
        }
        if ("rawMapData" in v11233) {
          document.getElementById("rawMapData").value = v11233.rawMapData;
        }
        if ("makePrivate" in v11233) {
          document.getElementById("makePrivate").checked = v11233.makePrivate;
        }
        if ("krRewards" in v11233) {
          document.getElementById("krRewards").checked = v11233.krRewards;
        }
      }
    }
    windows[7].genPresets();
  },
  genPresets: function (p13802 = false) {
    let vGetSavedVal12 = getSavedVal("krk_hostPresets");
    vGetSavedVal12 = vGetSavedVal12 ? JSON.parse(vGetSavedVal12) : {};
    var v11243 = "<div class='setHed' style='margin-bottom:15px;'>" + i18n.t("windows.host.preset") + "</div><div class='setBodH' style='padding-top:20px;padding-bottom:15px;'>";
    v11243 += "<span class='settNameSmall'><input id='presetName' type='text' class='formInput' placeholder='" + i18n.t("windows.host.preset.name") + "' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' style='border:none;background:#eee;padding-bottom:6px;float:left;margin-top:5px;margin-bottom:5px;'><select id='presetSelect' style='border-radius:6px;margin-left:10px;border:none;background:#eee;;padding:6px;padding-bottom:6px;margin-top:5px;margin-bottom:5px;'><option selected>Select</option>";
    for (let v11244 in vGetSavedVal12) {
      v11243 += "<option>" + v11244 + "</option>";
    }
    v11243 += "</select>";
    v11243 += "<div class='hostPresetBtn' onclick='windows[7].presetAction(2)'>" + i18n.t("generic.delete") + "</div><div class='hostPresetBtn' onclick='windows[7].presetAction(1)'>" + i18n.t("generic.save") + "</div><div class='hostPresetBtn' onclick='windows[7].presetAction(0)'>" + i18n.t("generic.load") + "</div></span></div>";
    if (p13802) {
      return v11243;
    } else {
      hostGamePreset.innerHTML = v11243;
      return;
    }
  }
}, {
  header: i18n.t("windows.spray.header"),
  label: "spray_selection",
  width: 877,
  height: "calc(100% - 300px)",
  sticky: true,
  dark: true,
  hideScroll: true,
  gen: function () {
    var vA612 = [];
    var vLS64 = "";
    var v11245 = "<div id='itemSearchH'><div class='custBack' onclick='playSelect(0.1);goBackWindow(2)' onmouseenter='playTick();'><span class='material-icons custBackArr'>arrow_back</span></div><input id='itemSearch' type='text' placeholder='Search Item' onkeyup='searchItems(this, &quot;noBtnCard&quot;)'><div class='winClose' onclick='playSelect(0.1);closWind()' onmouseenter='playTick();'><span class='material-icons winCloseArr'>close</span></div></div><div id='skinList' style='overflow-y: scroll;height: calc(100% - 95px);'><div class='noBtnCard blackShad' onclick='selectSpray(-2)' style='height:158px;border: 5px solid lightgrey'>" + i18n.t("generic.random") + "<div class='itemOwn' style='opacity:0;''>by ???</div><img draggable='false' style='margin-top:10px;width:110px;' class='noBtnImgC skinSil' src='" + UTILS.assetsUrl("/textures/sprays/0.png") + "' onmouseenter='playTick()'><div class='skinRandom blackShad' style='top: 80px;'>?</div></div>";
    var v11246 = [...f1799(account, true)].sort(function (p13803, p13804) {
      return (p13804.ind != null && Game.store.skins[p13804.ind] ? Game.store.skins[p13804.ind].rarity == null ? -1 : Game.store.skins[p13804.ind].rarity || 0 : 0) - (p13803.ind != null && Game.store.skins[p13803.ind] ? Game.store.skins[p13803.ind].rarity == null ? -1 : Game.store.skins[p13803.ind].rarity || 0 : 0);
    });
    v11246.sort(function (p13805, p13806) {
      return ~~(favoriteItemIds.indexOf(p13806.ind) >= 0) - ~~(favoriteItemIds.indexOf(p13805.ind) >= 0);
    });
    for (var vLN01808 = 0; vLN01808 < v11246.length; ++vLN01808) {
      player = Game.store.skins[v11246[vLN01808].ind];
      if (player && player.type == itemTypes.SPRAY) {
        var v11247 = favoriteItemIds.indexOf(player.index) >= 0;
        if (player.frames && vA612.indexOf(player.frames) == -1) {
          vA612.push(player.frames);
        }
        v11245 += "<div class='noBtnCard" + (player.rarity == rarities.CONTRABAND ? "" : " blackShad") + (!player.free && RENDER.rarityAnim && Game.store.rarities[player.rarity].animate ? " rainbow" : "") + "' style='height:158px;" + (player.free ? "border: 5px solid lightgrey" : "color:" + Game.store.rarities[player.rarity].color + ";border: 5px solid " + Game.store.rarities[player.rarity].color) + "'onclick='selectSpray(" + v11246[vLN01808].ind + ");cancelTip()' data-index='" + player.index + "' onmouseover='createTip(this)' onmouseout='cancelTip()'>" + (player.free ? "" : "<div class='sprayCnt'>x" + v11246[vLN01808].cnt + "</div>") + player.name + "<div class='itemOwn'>" + (player.free ? i18n.t("windows.spray.default") : player.creator ? "by " + player.creator : i18n.t("windows.spray.spin")) + "</div><div draggable='false' class='sprayImg' onmouseenter='playTick()' style='background: url(&quot;" + player.thumbnail + "&quot;) -1px;" + UTILS.getFrameAnim(player, "sprayAnm") + "'></div><div class='selctInfoBtn' onmouseenter='playTick()'onclick='viewItem(" + player.index + ")'>?</div><div class='selctFavBtn material-icons' onmouseenter='playTick()' data-col='" + (v11247 ? "yellow" : "white") + "' data-icon='" + (v11247 ? "star" : "star_border") + "' onclick='favItem(this, " + player.index + ")'></div></div>";
      }
    }
    v11245 += "</div>";
    if (vA612.length) {
      vLS64 += "<style>";
      for (var vLN01808 = 0; vLN01808 < vA612.length; vLN01808++) {
        vLS64 += "@keyframes sprayAnm" + vA612[vLN01808] + " {100%{background-position:-" + vA612[vLN01808] * 110 + "px}}";
      }
      vLS64 += "</style>";
    }
    return vLS64 + v11245;
  },
  close: () => cancelTip(),
  clear: () => {
    f1822(window.event);
    selectSpray(-1, true, true);
  }
}, {
  header: i18n.t("windows.maps.header"),
  label: "games",
  width: 1950,
  maxH: "calc(100% - 325px)",
  yPos: 48,
  dark: true,
  popup: true,
  playerData: {},
  hostType: null,
  updatePlayers: function () {
    if (!Object.keys(this.playerData).length) {
      fetchMatches(function (p13807) {
        if (p13807) {
          windows[9].playerData = p13807;
          windows[9].updatePlayers();
        }
      });
    } else {
      for (var v11248 in this.playerData) {
        var v11249 = document.getElementById("pcnt_" + v11248);
        if (v11249 && v11249.firstChild) {
          v11249.firstChild.textContent = this.playerData[v11248];
        }
      }
    }
  },
  update: function () {
    updateWindow(10);
    this.updatePlayers();
  },
  post: function () {
    f1824(this.hostType);
  },
  searchId: config.mapTabs.findIndex(p13808 => p13808.search),
  searchMaps: function () {
    var v11250 = document.getElementById("mpCat");
    var v11251 = v11250.options[v11250.selectedIndex].value;
    searchResultsMA.innerHTML = "Loading...";
    API_CLIENT.searchMap(mpSrch.value, v11251, f1853);
  },
  searchResp: function (p13809) {
    var vLS65 = "";
    if (p13809.length) {
      vLS65 += "<div style='height:10px'></div>";
      vLS65 += f1825(p13809, "map", this.searchId, this.hostType);
    } else {
      vLS65 = i18n.t("windows.maps.none");
    }
    if (document.getElementById("searchResultsMA")) {
      document.getElementById("searchResultsMA").innerHTML = vLS65;
    }
    this.updatePlayers();
    f1824(this.hostType);
  },
  loadMore: function (p13810) {
    if (!this.listData[this.tabIndex].waiting) {
      if (p13810) {
        p13810.className = "loadMoreW";
        p13810.innerHTML = "Loading...";
      }
      this.listData[this.tabIndex].waiting = true;
      this.listData[this.tabIndex].loadInd += 1;
      API_CLIENT.listMaps(this.tabIndex, this.listData[this.tabIndex].loadInd, account ? account.id : null, f1851);
    }
  },
  mapsLoaded: function (p13811, p13812, p13813) {
    if (mapList) {
      this.listData[p13812].waiting = false;
      if (!p13811 || !p13811.length) {
        if (!this.listData[p13812].dat) {
          mapList.innerHTML = i18n.t("windows.maps.none");
          this.listData[p13812] = null;
        }
      } else if (p13813) {
        if (!this.listData[p13812].dat) {
          mapList.innerHTML = p13813;
          this.listData[p13812] = null;
        }
      } else {
        var vIii23 = f1825(p13812 == 2 ? UTILS.shuffleArray(p13811) : p13811, "map", p13812, this.hostType);
        this.listData[p13812].dat = (this.listData[p13812].dat || "") + vIii23;
        if (this.tabIndex == p13812) {
          this.update();
        }
      }
    }
  },
  tabIndex: 0,
  listData: {},
  switchTab: function (p13814) {
    if (this.tabIndex != p13814) {
      this.tabIndex = p13814;
      this.update();
    }
  },
  gen: function () {
    var v11252 = config.mapTabs[this.tabIndex];
    var vLSdivClassbigMenTabsSt2 = "<div class='bigMenTabs' style='margin-top:0px'>";
    for (var vLN01810 = 0; vLN01810 < config.mapTabs.length; ++vLN01810) {
      if (!config.mapTabs[vLN01810].hide) {
        vLSdivClassbigMenTabsSt2 += "<div class='bigMenTab" + (this.tabIndex == vLN01810 ? " bigMenTabA" : "") + "' onclick='playSelect();" + (config.mapTabs[vLN01810].click ? config.mapTabs[vLN01810].click : "windows[9].switchTab(" + vLN01810 + ")") + "' onmouseenter='playTick(0.1);'>" + (config.mapTabs[vLN01810].txt || config.mapTabs[vLN01810].n) + "</div>";
      }
    }
    vLSdivClassbigMenTabsSt2 += "</div>";
    var vLS66 = "";
    if (v11252.n == "Home") {
      if (this.listData[this.tabIndex]) {
        if (this.listData[this.tabIndex].dat) {
          vLS66 = this.listData[this.tabIndex].dat;
          if (this.listData[this.tabIndex].waiting) {
            vLS66 += "<div class='loadMoreW'>Loading...</div>";
          }
        } else {
          vLS66 = "<div class='loadMoreW'>Loading...</div>";
        }
      } else {
        vLS66 = "<div class='loadMoreW'>Loading...</div>";
        this.listData[this.tabIndex] = {
          loadInd: 0
        };
        API_CLIENT.listMaps(this.tabIndex, 0, account ? account.id : null, f1851);
      }
      var vLS67 = "";
      if (v12130 && v12130.length >= 1) {
        if (this.fetInd == null) {
          this.fetInd = UTILS.randInt(0, v12130.length - 1);
        }
        var v11253 = v12130[this.fetInd];
        var v11254 = config.fetMapVids[v11253.map_name];
        if (v11253.map_videolink && v11253.map_videolink != "") {
          v11254 = v11253.map_videolink;
        }
        vLS67 = "<div class='bigMFeatHold' style='background-image:linear-gradient(to right, black, rgba(0, 0, 0, 0.6)),url(" + UTILS.userAssetsUrl("/m" + v11253.map_id + "/thumb.png") + ");width:1300px;display:inline-block;'><div id='bigMFeatName'>" + v11253.map_name + "</div><div id='bigMFeatVbar'><span style='color:#fff;'>" + UTILS.commaNumber(v11253.map_pl) + "</span><span class='material-icons' style='margin-top:-8px;margin-left:0px;font-size:46px;vertical-align:middle;color:rgba(255,255,255,0.5);margin-right:10px;'>play_arrow</span>" + UTILS.commaNumber(v11253.map_votes) + "<span class='material-icons' style='margin-left:10px;font-size:33px;vertical-align:top;color:rgba(255,255,255,0.5);'>thumb_up</span><div style='color:#7d7d7d;margin-left:20px;margin-top:-12px;display:inline-block;vertical-align:middle;'>by <a>" + v11253.creatorname + "</a></div></div><div id='bigMFeatDesc'>" + v11253.map_description + "</div><iframe id='bigMFeatVid' width='100px' height='100px' src='https://www.youtube.com/embed/" + v11254 + "?autoplay=1&mute=1' frameborder='0' allowfullscreen></iframe><div id='bigMFeatPBtn' onclick='openURL(&quot;/?play=" + v11253.map_name + "&quot;, 1)' style='color:#fff !important;'>Play Now</div><div id='bigMFeatHBtn' onclick='selectHostMap(&quot;" + v11253.map_name + "&quot;,null,&quot;" + v11253.map_id + "&quot;)'>Host Server</div></div>";
      }
      var v11255 = "<div class='bigMFeatHold' style='margin-left:20px;background:#0b0b0b;display:inline-block;width:580px;vertical-align:top;'><div class='biMFeatInfH'>Create your own game & earn real money! Over $750,000 USD has been paid out so far!</div>" + (window.canShowKrunkerEditor ? "<div class='biMFeatInfB' onclick='openURL(`./editor.html`)'>Open Editor</div>" : "") + "<div class='biMFeatInfB' onclick='openURL(`./games`)'>Discover Games</div>" + (window.canShowExternalLinks ? "<div class='biMFeatInfB' onclick='openURL(`https://discord.com/invite/Kfypyp5`)'>Dev Community</div>" : "") + "</div>";
      return "<div style='margin-top:15px;margin-bottom:15px'>" + vLSdivClassbigMenTabsSt2 + "</div>" + vLS67 + v11255 + "<div id='mapList'>" + vLS66 + "</div>";
    }
    if (v11252.search) {
      vLS66 = "<input type='text' id='mpSrch' class='smlInput' placeholder='Game Name or Keyword' onkeydown='if(window.event.keyCode==13)windows[9].searchMaps()' />";
      vLS66 += "<select id='mpCat'><option value='-1'>All</option>";
      for (var vLN01810 = 0; vLN01810 < config.mapCats.length; vLN01810++) {
        vLS66 += "<option value='" + vLN01810 + "'>" + config.mapCats[vLN01810] + "</option>";
      }
      vLS66 += "</select>";
      vLS66 += "<div class='searchBtn' onclick='windows[9].searchMaps()'><span class='material-icons' style='color:#fff;font-size:45px;margin-bottom:-30px;line-height:75px'>search</span></div><div style='color:rgba(0,0,0,0.5);margin-top:10px' id='searchResultsMA'></div>";
    } else if (this.listData[this.tabIndex]) {
      if (this.listData[this.tabIndex].dat) {
        vLS66 = this.listData[this.tabIndex].dat;
        if (this.listData[this.tabIndex].waiting) {
          vLS66 += "<div class='loadMoreW'>Loading...</div>";
        } else if (!v11252.sendID && !v11252.noPages) {
          vLS66 += "<div class='loadMoreD' onclick='windows[9].loadMore(this)'>Load More</div>";
        }
      } else {
        vLS66 = "<div class='loadMoreW'>Loading...</div>";
      }
    } else {
      vLS66 = "<div class='loadMoreW'>Loading...</div>";
      this.listData[this.tabIndex] = {
        loadInd: 0
      };
      API_CLIENT.listMaps(this.tabIndex, 0, account ? account.id : null, f1851);
    }
    var vLS68 = "";
    if (v11252.n == "My Games") {
      vLS68 += "<div class='setBodH'><div class='settName'>View Game earnings and stats on your dashboard<a style='float:right' href='javascript:windows[27].tabIndex=1;showWindow(28);'>Open Dashboard</a></div>" + (window.canShowKrunkerEngine ? "<div class='settName'>Publish or create a game<a style='float:right' href='./editor.html' target='_blank'>Open Editor</a></div><div class='settName'>Learn how to make a game<a style='float:right' href='//docs.krunker.io' target='_blank'>Open Documentation</a></div>" : "") + "</div>";
    }
    return "<div style='margin-top:15px;margin-bottom:15px'>" + vLSdivClassbigMenTabsSt2 + "</div>" + vLS68 + "<div id='mapList'>" + vLS66 + "</div>";
  }
}, {
  header: i18n.t("windows.publish.map.header"),
  label: "unused",
  gen: function () {
    return "";
  }
}, {
  header: "",
  label: "unused",
  gen: function () {
    var vLS69 = "";
    return vLS69;
  }
}, {
  header: i18n.t("windows.clans.header"),
  label: "clan",
  clanData: null,
  width: 1000,
  maxH: "calc(100% - 320px)",
  kickReq: function (p13815, p13816) {
    confKickClan(p13815, p13816);
  },
  kick: function (p13817) {
    io.send("cln", 5, p13817);
    if (this.clanData && this.clanData.members) {
      for (var v11256 = this.clanData.members.length - 1; v11256 >= 0; --v11256) {
        if (this.clanData.members[v11256].i == p13817) {
          this.clanData.members.splice(v11256, 1);
        }
      }
      updateWindow(13);
    }
  },
  sendReq: function (p13818, p13819) {
    var v11257 = document.getElementById("clanErr");
    if (v11257) {
      v11257.style.color = "rgba(0,0,0,0.6)";
      v11257.innerHTML = i18n.t("generic.loading");
    }
    v11257 = document.getElementById("clanInp" + p13818);
    var v11258 = v11257 ? v11257.value : null;
    io.send("cln", p13818, p13819 || v11258 || 1);
  },
  updReq: function (p13820, p13821, p13822) {
    io.send("clnR", p13821, p13822);
    if (this.clanData.members && p13822 == 1) {
      this.clanData.members.push({
        p: this.clanData.requests[p13820].player_name
      });
    }
    this.clanData.requests.splice(p13820, 1);
    updateWindow(13);
  },
  delReq: function () {
    confDelClan(account && this.clanData.clan_playerid == account.id);
  },
  del: function () {
    this.clanData = null;
    if (account) {
      account.clan = null;
    }
    showWindow(5);
  },
  updRolR: function (p13823) {},
  updRol: function (p13824) {
    var v11259 = document.getElementById("clanRolD" + p13824);
    io_loadingPopup("Please Wait...");
    io.send("cln", 6, p13824, {
      r: parseInt(v11259.options[v11259.selectedIndex].value || 0)
    });
  },
  chngFunds: function (p13825) {
    var v11260 = clanFundsIn.value || 0;
    if (v11260) {
      io_loadingPopup("Please Wait...");
      io.send("cln", 7, parseInt(v11260), {
        wd: p13825
      });
    }
  },
  calcFee: function (p13826) {
    if (p13826) {
      var v11261 = p13826.value || 0;
      if (v11261 < 0) {
        v11261 = 0;
      }
      if (v11261) {
        p13826.value = v11261;
      }
      var v11262 = Math.floor(v11261 * 0.1);
      p13826 = document.getElementById("clnFeeVal");
      if (p13826) {
        p13826.innerHTML = v11262 ? "<span style='color:rgba(255,255,255,0.7)'>-" + UTILS.commaFormatNum(v11262) + " <span style='color:#fff'>KR</span></span>" : "None";
      }
    }
  },
  mangFunds: function () {
    var v11263 = account && this.clanData.clan_playerid == account.id;
    var v11264 = "<div style='font-size:21px;color:#fff'>Manage Clan Funds<span style='float:right;color:rgba(255,255,255,0.6)'>" + UTILS.commaNumber(this.clanData.clan_funds || 0) + " <span style='color:#fff'>KR</span></span></div><div style='margin-top:20px;font-size:18px;color:#FFF'>Deposit Fee<span id='clnFeeVal' style='float:right;color:rgba(255,255,255,0.7)'>None</span></div><input type='number' oninput='windows[12].calcFee(this)' placeholder='Enter KR Amount' id='clanFundsIn'></input><div class='clanFndB' style='background-color:" + (v11263 ? "#fc5a4e" : "#6e6e6e") + "' " + (v11263 ? "onclick='windows[12].chngFunds(1)'" : "") + ">Withdraw</div><div class='clanFndB' style='margin-left:16px;background-color:#4ca9f5' onclick='windows[12].chngFunds(0)'>Deposit</div>";
    genericPopup(v11264, "contPop");
  },
  declinePop: function () {
    if (account && this.clanData.clan_playerid == account.id) {
      var vLSdivStylecolorffffont2 = "<div style='color:#fff;font-size:20px;position:relative;margin-bottom:15px;'>Are you sure you want to Decline All clan requests?</div><div id='confirmBtn' onclick='windows[12].decAll();' onmouseover='playTick(0.1)'>YES</div><div id='declineBtn' onclick='clearPops()' onmouseover='playTick(0.1)'>NO</div>";
      contPopup(vLSdivStylecolorffffont2, "433px", "2px solid #ffffff47");
    }
  },
  decAll: function () {
    clearPops();
    if (account && this.clanData.clan_playerid == account.id) {
      io.send("clnRA");
      this.clanData.requests.length = 0;
      updateWindow(13);
    }
  },
  discordPop: function () {
    if (account && this.clanData.clan_playerid == account.id) {
      var vLSdivStylefontsize20px = "<div style='font-size:20px;color:#fff'><div style='margin-top: 3px;font-size: 22px;color: rgba(255, 255, 255, 0.7);'>Discord Link:<input type='text' id='clanDiscordLink' class='inputGrey2' style='width: 300px;'></div><div class='mapFndB' onclick='windows[12].updateDis()' onmouseover='playTick(0.1)' style='background-color:#fc5a4e;width: 569px;margin-top: 10px;'>Update</div></div>";
      contPopup(vLSdivStylefontsize20px, "588px");
    } else if (this.clanData.clan_link4) {
      window.open("https://discord.gg/" + this.clanData.clan_link4);
    }
  },
  updateDis: function () {
    if (account && this.clanData.clan_playerid == account.id) {
      var v11265 = document.getElementById("clanDiscordLink");
      var v11266 = /discord(?:\.com|app\.com|\.gg)\/(?:invite\/)?([a-zA-Z0-9\-]{2,32})/gmi;
      if (v11265 && v11265.value && v11266.exec(v11265.value)) {
        io.send("cln", 9, v11265.value);
      } else {
        return io_showPopup(null, "Invalid Discord");
      }
    }
  },
  resp: function (p13827, p13828, p13829, p13830) {
    if (p13830 == 7) {
      if (p13829 && p13828) {
        account.funds = p13828.pf || 0;
        updateMenuAccountData();
        this.clanData.clan_funds = p13828.cf || 0;
        updateWindow(13);
        io_showPopup("SUCCESS", null, "Success");
      } else {
        io_showPopup(null, p13827 || "Error");
      }
    } else if (p13830 == 8) {
      if (p13829 && p13828) {
        if (this.clanData.members[p13828.i]) {
          this.clanData.clan_funds = p13828.cf || 0;
          this.clanData.members[p13828.i].st = 1;
          this.clanData.members[p13828.i].cr = p13828.cr;
          updateWindow(13);
        }
        io_showPopup("SUCCESS", null, "Success");
      } else {
        io_showPopup(null, p13827 || "Error");
      }
    } else {
      if (p13830 == 6) {
        if (p13829 && p13828) {
          var v11267 = this.clanData.members.find(p13831 => p13831.i == p13828.i);
          if (v11267) {
            v11267.r = p13828.r;
            updateWindow(13);
          }
          io_showPopup("SUCCESS", null, "Success");
        } else {
          io_showPopup(null, p13827 || "Error");
        }
        return;
      }
      var v11268 = document.getElementById("clanErr");
      if (p13827 && v11268) {
        v11268.style.color = p13829 ? "rgba(0,0,0,0.6)" : "rgba(255,0,0,0.6)";
        v11268.innerHTML = p13827;
      } else if (p13828) {
        if (account) {
          account.clan = p13828.clan_name;
        }
        this.clanData = p13828;
        this.clanData.members = this.clanData.members || [];
        this.clanData.requests = this.clanData.requests || [];
        updateWindow(13);
      }
    }
  },
  tabIndex: 0,
  switchTab: function (p13832) {
    windows[12].tabIndex = p13832;
    updateWindow(13);
  },
  gen: function () {
    if (!account) {
      return f1821(null, i18n.t("windows.clans.login"), true);
    }
    if (!account.clan) {
      return "<div class='setHed' style='margin-top:-5px'>" + i18n.t("windows.clans.create") + "</div><input id='clanInp1' type='text' class='smlInput' maxlength='4' placeholder='" + i18n.t("windows.clans.name") + "' /><a class='clanSubmitBtn' style='margin-left:20px' onclick='windows[12].sendReq(1)'>" + i18n.t("generic.create") + "</a><div class='setHed'>" + i18n.t("windows.clans.join") + " <a href='./social.html?p=leaders&q=clans' target='_blank' class='menuLink' style='float:right'>" + i18n.t("windows.clans.view") + "</a></div><input id='clanInp2' type='text' class='smlInput' maxlength='5' placeholder='" + i18n.t("windows.clans.name") + "' /><a class='clanSubmitBtn' style='margin-left:20px' onclick='windows[12].sendReq(2)'>" + i18n.t("generic.submit") + "</a><div id='clanErr' style='margin-top:10px'></div>";
    }
    io.send("vcln");
    var vLSdivStyleheight15pxdi = "<div style='height:15px;'></div>";
    vLSdivStyleheight15pxdi += "<div class='bigMenTabs'>";
    for (var vLN01816 = 0; vLN01816 < config.clanTabs.length; ++vLN01816) {
      vLSdivStyleheight15pxdi += "<div class='bigMenTab" + (this.tabIndex == vLN01816 ? " bigMenTabA" : "") + "' style='font-size:16px' onmouseenter='playTick(0.1);' onclick='playSelect();windows[12].switchTab(" + vLN01816 + ")'>" + config.clanTabs[vLN01816] + "</div>";
    }
    vLSdivStyleheight15pxdi += "</div>";
    vLSdivStyleheight15pxdi += "<div id='clanErr' style='margin-top:0px;color:rgba(0,0,0,0.5)'>";
    if (account && account.clan && !this.clanData) {
      this.sendReq(3);
      vLSdivStyleheight15pxdi += i18n.t("generic.loading");
    } else if (this.tabIndex == 0) {
      var vLN01812 = 0;
      var v11269 = this.clanData.clan_score || 0;
      var v11270 = config.rankVar * Math.sqrt(v11269);
      var v11271 = Math.floor(v11270);
      var v11272 = Math.round((v11270 - v11271) * 100);
      v11271 = Math.max(1, v11271);
      var v11273 = v11271 > 1 ? Math.pow(v11271 / config.rankVar, 2) : 0;
      var vParseInt37 = parseInt(Math.pow((v11271 + 1) / config.rankVar, 2) - v11273);
      v11273 = parseInt(v11269 - v11273);
      vLSdivStyleheight15pxdi += "<div class='setHed' style='margin-top:0px'><a target='_blank' href='/social.html?p=clan&q=" + account.clan + "'>" + i18n.t("windows.clans.page", account.clan) + "</a><a style='float:right' href='javascript:;' onclick='windows[12].delReq()' class='menuLink'>" + (account && this.clanData.clan_playerid == account.id ? i18n.t("generic.delete") : i18n.t("generic.leave")) + "</a></div><div class='setBodH'><div class='settName'>Rank<span class='floatR'>" + vLN01812 + "</span></div><div class='settName'>Clan Discord<a style='float:right' href='javascript:;' onclick='windows[12].discordPop()' class='menuLink'>" + (account && this.clanData.clan_playerid == account.id ? "Update Link" : "Link Here") + "</a></div><div class='settName'>Bank<span class='floatR'><span style='color:rgba(0,0,0,0.4)'><a href='javascript:;'  onclick='windows[12].mangFunds()' class='menuLink'>" + UTILS.commaNumber(this.clanData.clan_funds || 0) + "</a></span> KR</span></div><div class='settName'>" + i18n.t("generic.level") + "<span class='floatR'>" + v11271 + "</span></div><div class='settName'>Total Score<span class='floatR'>" + UTILS.commaNumber(v11269) + "</span></div><div class='xpBar' style='margin-bottom:15px;margin-top:20px'><div class='xpBarB' style='width:" + v11272 + "%'></div><span class='xpBarV'>" + UTILS.commaNumber(v11273) + " / " + UTILS.commaNumber(vParseInt37) + "</span></div></div>";
      vLSdivStyleheight15pxdi += "<div style=\"text-align: center;\">\n\t\t\t\t<span class=\"material-icons\" style=\"color: var(--yellow);font-size: 35px;margin-right: 10px;vertical-align: text-bottom;\">\n\t\t\t\t\twarning_amber\n\t\t\t\t</span>\n\t\t\t\tClan members will be limited to 100 in a Future Season\n\t\t\t</div>";
    } else if (this.tabIndex == 1) {
      var v11274 = account && this.clanData.clan_playerid == account.id;
      this.clanData.members.sort(function (p13833, p13834) {
        return p13834.s - p13833.s;
      });
      for (var v11275 = config.clanRoles.length - 1; v11275 >= 0; --v11275) {
        var v11276 = config.clanRoles[v11275];
        var vLN01813 = 0;
        var vLSdivClasssetBodH = "<div class='setBodH'>";
        for (var vLN01816 = 0, v11280; vLN01816 < this.clanData.members.length; ++vLN01816) {
          v11280 = this.clanData.members[vLN01816];
          if (this.clanData.clan_playerid == v11280.i && v11276.perms == 2 || v11280.r == v11275 && this.clanData.clan_playerid != v11280.i) {
            vLN01813++;
            var v11278 = "<select class='clanRolD' onchange='windows[12].updRol(" + v11280.i + ", this)' id='clanRolD" + v11280.i + "'>";
            for (var v11279 = config.clanRoles.length - 1; v11279 >= 0; --v11279) {
              if (config.clanRoles[v11279].perms != 2) {
                v11278 += "<option value='" + v11279 + "' " + (v11280.r == v11279 ? "selected" : "") + ">" + config.clanRoles[v11279].name + "</option>";
              }
            }
            v11278 += "</select>";
            vLSdivClasssetBodH += "<div class='settName'>" + (v11280.su ? "<i class='material-icons' style='color:" + COLORS.premium + ";margin-top:-8px;font-size:28px;vertical-align:middle;margin-right:2px'>beenhere</i>" : "") + (v11280.ve ? "<i class='material-icons' style='color:" + COLORS.verified.player + ";margin-top:4px;font-size:28px;vertical-align:baseline;margin-right:2px'>check_circle</i>" : "") + "<a target='_blank'href='/social.html?p=profile&q=" + v11280.p + "' " + (v11280.h ? "style='color:#E85656'" : "") + ">" + v11280.p + "</a>" + (v11274 && this.clanData.clan_playerid != v11280.i ? "<div style='float:right;'><i style='font-size:40px;color:rgba(255,0,0,0.9)'  class='material-icons h' onclick='windows[12].kickReq(&quot;" + v11280.p + "&quot;," + v11280.i + ")'>clear</i>" + v11278 + "</div>" : "") + "</div>";
          }
        }
        vLSdivClasssetBodH += "</div>";
        if (vLN01813 == 0) {
          vLSdivClasssetBodH = "No " + v11276.name + "s";
        }
        vLSdivStyleheight15pxdi += "<div class='setHed' style='margin-top:20px'>" + v11276.name + "s<span style='float:right;color:rgba(255,255,255,0.4)'>" + vLN01813 + (v11276.max ? "/" + v11276.max : "") + " <span style='color:#fff'>Members</span></span></div>" + vLSdivClasssetBodH;
      }
    } else if (this.tabIndex == 2) {
      vLSdivStyleheight15pxdi += "<div class='setHed' style='margin-top:10px;'>Top Scorers <span style='float:right;color:rgba(255,255,255,0.4)'>Last 7 Days</span></div>";
      this.clanData.members.sort(function (p13835, p13836) {
        return p13836.s7 - p13835.s7;
      });
      vLSdivStyleheight15pxdi += "<div class='setBodH'>";
      for (var vLN01816 = 0, v11280; vLN01816 < this.clanData.members.length; ++vLN01816) {
        v11280 = this.clanData.members[vLN01816];
        vLSdivStyleheight15pxdi += "<div class='settName'>" + (v11280.su ? "<i class='material-icons' style='color:" + COLORS.premium + ";margin-top:-8px;font-size:28px;vertical-align:middle;margin-right:2px'>beenhere</i>" : "") + (v11280.ve ? "<i class='material-icons' style='color:" + COLORS.verified.player + ";margin-top:4px;font-size:28px;vertical-align:baseline;margin-right:2px'>check_circle</i>" : "") + "<a target='_blank'href='/social.html?p=profile&q=" + v11280.p + "' " + (v11280.h ? "style='color:#E85656'" : "") + ">" + v11280.p + "</a><div style='float:right;color:rgba(255,255,255,0.8)'>" + UTILS.commaNumber(v11280.s7) + "</div></div>";
      }
      vLSdivStyleheight15pxdi += "</div>";
    } else if (this.tabIndex == 3) {
      vLSdivStyleheight15pxdi += "<div class='setHed' style='margin-top:18px'>Manage Requests <div id='clanDeclineAll' onclick='windows[12].declinePop()'>Decline All</div><span style='float:right;color:rgba(255,255,255,0.4)'>" + this.clanData.requests.length + "</span></div><div class='setBodH'>";
      for (var vLN01816 = 0; vLN01816 < this.clanData.requests.length; ++vLN01816) {
        vLSdivStyleheight15pxdi += "<div class='settName'><a target='_blank' href='/social.html?p=profile&q=" + this.clanData.requests[vLN01816].player_name + "'>" + this.clanData.requests[vLN01816].player_name + "</a><span style='float:right'><i style='font-size:40px;color:rgba(255,0,0,0.9)'  class='material-icons h' onclick='windows[12].updReq(" + vLN01816 + "," + this.clanData.requests[vLN01816].cr_playerid + ", 0)'>clear</i><i style='font-size:40px;color:rgba(0,255,0,0.9);margin-left:10px' class='material-icons h' onclick='windows[12].updReq(" + vLN01816 + "," + this.clanData.requests[vLN01816].cr_playerid + ", 1)'>done</i></span></div>";
      }
      vLSdivStyleheight15pxdi += "</div>";
      if (!this.clanData.requests.length) {
        vLSdivStyleheight15pxdi += "<div style='margin-top:10px;color:rgba(255,255,255,0.4)'>" + i18n.t("windows.clans.requests.none") + "</div>";
      }
    }
    vLSdivStyleheight15pxdi += "</div>";
    return vLSdivStyleheight15pxdi;
  }
}, {
  header: i18n.t("windows.store.header"),
  label: "shop_crafting",
  width: 1300,
  maxH: "calc(100% - 290px)",
  yPos: 48,
  dark: true,
  popup: true,
  resp: function (p13837, p13838, p13839, p13840) {
    if (p13837) {
      io_showPopup(null, p13837);
    } else {
      var v11281 = Game.store.premium[p13840];
      if (v11281) {
        logEventFRVR("item_flow", {
          item: "krunkers",
          flow_type: "sink",
          amount: v11281.price || 0,
          item_context: "premium_" + v11281.val + "days",
          wallet: account ? account.funds : 0
        });
      }
      account.premiumT = p13839;
      io_updateFunds(p13838);
      updateClassPreview();
      updateWindow(null, true);
      io_showPopup("SUCCESS");
    }
  },
  subTab: 0,
  subTabs: 3,
  subTabT: 3000,
  updSubTab: function (p13841) {
    if (this.tabIndex == 0 && (this.subTabT -= p13841, this.subTabT <= 0)) {
      this.subTabT = 3000;
      this.subTab++;
      if (this.subTab >= this.subTabs) {
        this.subTab = 0;
      }
      for (var v11282 = document.querySelectorAll(".windowSubTabs"), vLN01817 = 0; vLN01817 < v11282.length; vLN01817++) {
        v11282[vLN01817].style.display = vLN01817 == this.subTab ? "" : "none";
        if (vLN01817 == this.subTab) {
          var v11283 = v11282[vLN01817].querySelector(".shopMainSellTbs");
          if (v11283) {
            v11283.innerHTML = this.genSubBtns();
          }
        }
      }
    }
  },
  genSubBtns: function () {
    let vLS70 = "";
    for (var vLN01818 = 0; vLN01818 < this.subTabs; ++vLN01818) {
      vLS70 += "<div class='shpMTbsI' style='background:" + (vLN01818 == this.subTab ? "#fff" : "rgba(255,255,255,0.4)") + "' onclick='event.stopPropagation();windows[13].subTabT=5000;windows[13].subTab=" + vLN01818 + ";updateWindow(14);'></div>";
    }
    return vLS70;
  },
  tabIndex: 0,
  switchTab: function (p13842) {
    if (p13842 == 5) {
      return window.open("/social.html?p=market");
    } else if (p13842 == 4) {
      return voucherPopup();
    } else {
      if (p13842 == 3) {
        logEventFRVR("shop_action");
      }
      windows[13].tabIndex = p13842;
      updateWindow(14);
      return;
    }
  },
  purchase: function (p13843) {
    if (!p13843) {
      var v11284 = "<div style='color:#fff;font-size:20px;position:relative;margin-bottom:15px;'>" + i18n.t("funds.out") + "</div><div id='confirmBtn' style='width: calc(100% - 20px)' onmouseover='playTick(0.1)' onclick='windows[13].purchase(1)'>Purchase More</div>";
      contPopup(v11284, "513px");
    } else {
      logEventFRVR("shop_action");
      windows[13].tabIndex = 3;
      clearPops();
      showWindow(14, true);
    }
  },
  premium: function () {
    windows[13].tabIndex = 2;
    showWindow(14, true);
  },
  craftDatRes: function (p13844) {
    if (p13844 && p13844.length) {
      p13844 = p13844.sort(function (p13845, p13846) {
        if (p13846 && p13845) {
          return (parseFloat(p13846.JUNK) || 0) - parseFloat(p13845.JUNK || 0);
        } else {
          return 0;
        }
      });
    }
    windows[13].craftData = {
      dat: p13844,
      err: !p13844
    };
    updateWindow(14);
  },
  craftRes: function (p13847, p13848, p13849) {
    if (p13848) {
      for (var vLN01819 = 0, v11285; vLN01819 < windows[13].craftData.dat.length; ++vLN01819) {
        v11285 = windows[13].craftData.dat[vLN01819];
        if (v11285.SID == p13847) {
          v11285.EXP = v11285.DUR * 1000;
          v11285.STATORD = 1;
          logEventFRVR("item_flow", {
            item: "junks",
            flow_type: "sink",
            amount: v11285.JUNK || 0,
            item_context: "junkyard",
            item_context_details: "item_" + v11285.SOUT,
            wallet: account ? account.junk : 0
          });
        }
      }
      clearPops();
      updateWindow(14);
    } else {
      io_showPopup(null, p13849 || "Error");
    }
  },
  startCraft: function (p13850) {
    SOUND.play("craft_0", 0.4);
    io_loadingPopup("Please Wait...");
    io.send("crft", p13850);
  },
  sendCraft: function (p13851) {
    var v11286 = windows[13].craftData.dat.find(p13852 => p13852 && p13852.SID == p13851);
    if (v11286) {
      var v11287 = Game.store.skins[v11286.SOUT];
      var v11288 = Game.store.rarities[v11287.rarity].color;
      var vLS71 = "";
      for (var v11289 = (v11286.SIN || "").split(","), vLN01820 = 0, v11290; vLN01820 < v11289.length; vLN01820 += 2) {
        v11290 = Game.store.skins[v11289[vLN01820]];
        if (v11290) {
          vLS71 += "<div class='crftRecSml' style='" + (vLN01820 ? "" : "margin-left:-5px;") + "border: 2px solid " + Game.store.rarities[v11290.rarity].color + ";background-image:url(" + v11290.thumbnail + "'></div>";
        }
      }
      var v11291 = "<div style='color:#979797;'>Junk<span style='float:right;color:#e5e5e5;'>-" + parseFloat(v11286.JUNK || 0).toFixed(2) + "<span class='material-icons' style='color:#cc51f8;font-size:30px;vertical-align:middle;margin-top:-7px;margin-left:5px;margin-right:-5px;'>plumbing</span></span></div><div style='color:#979797;'>Materials<div style='float:right;'>-" + vLS71 + "</div></div><div style='color:#979797;'>Craft time<span style='float:right;color:#e5e5e5;'>" + UTILS.getReadableTime(v11286.DUR * 1000) + "</span></div>";
      var v11292 = "<div class='pubHed'>Craft <span style='color:" + v11288 + "'>" + v11287.name + "</span></div><div style='color:#fff;font-size:20px;position:relative;margin-bottom:15px;'>" + v11291 + "</div><div id='confirmBtn' onclick='logBtnFRVR(`craft_item_confirm`);windows[13].startCraft(" + v11286.SID + ")' onmouseover='playTick(0.1)'>Craft</div><div id='declineBtn' onclick='clearPops()' onmouseover='playTick(0.1)'>Cancel</div>";
      genericPopup(v11292, "confPremiumPop");
    }
  },
  craftMenu: function () {
    windows[13].tabIndex = 6;
    showWindow(14, true);
  },
  viewTickets: function () {
    var v11293 = account ? account.skins.filter(p13853 => p13853 && Game.store.skins[p13853.ind] && Game.store.skins[p13853.ind].type == itemTypes.TICKET) : [];
    if (!v11293.length) {
      return io_showPopup(null, "You don't have any Spin Tickets!");
    }
    var vLSdivdivClasspopHeader = "<div><div class=\"popHeader\" style=\"margin-bottom: 30px;\">Spin Tickets</div>";
    for (var vLN01821 = 0; vLN01821 < v11293.length; vLN01821++) {
      player = Game.store.skins[v11293[vLN01821].ind];
      var v11294 = Game.store.rarities[player.rarity || 0];
      vLSdivdivClasspopHeader += "<div class=\"ticketCard\" onmouseenter=\"playTick()\" onclick=\"playSelect();prizeWheel(null, " + v11293[vLN01821].ind + ");cancelTip()\"\n\t\t\t\tdata-index='" + v11293[vLN01821].ind + "' onmouseover='createTip(this)' onmouseout='cancelTip()'\n\t\t\t\tstyle=\"background-image:url(" + player.thumbnail + ");border-color:" + v11294.color + "!important\">\n\t\t\t\t<div class=\"ticketCount\" style=\"width: unset;top:2px;right: 2px;color:" + v11294.color + "\">x" + v11293[vLN01821].cnt + "</div>\n\t\t\t\t<div class=\"ticketText\" style=\"color:" + v11294.color + "!important\">Redeem</div>\n\t\t\t</div>";
    }
    vLSdivdivClasspopHeader += "</div>";
    genericPopup(vLSdivdivClasspopHeader, "ticketPop");
  },
  wrapAround: false,
  columnsToScroll: 5,
  updateScroll: function (p13854, p13855) {
    var v11295 = document.querySelector(".bundleCols");
    if (v11295) {
      var v11296 = v11295.children[0]?.scrollWidth;
      var v11297 = (v11295.children.length - 1) * v11296 - v11295.clientWidth;
      var v11298 = v11295.scrollLeft + p13854 * (v11296 * (p13855 || this.columnsToScroll));
      var v11299 = v11295.clientWidth + v11295.scrollLeft;
      var v11300 = !!this.wrapAround || !(v11298 <= 0) || p13854 != -1;
      var v11301 = !!this.wrapAround || !(v11299 >= v11297) || p13854 != 1;
      if (this.wrapAround && v11299 >= v11297 && p13854 == 1) {
        v11298 = 0;
      } else if (this.wrapAround && v11298 < 0 && p13854 == -1) {
        v11298 = 50000;
      }
      v11295.scrollLeft = v11298;
      var v11302 = document.querySelectorAll(".bundleSliderBtn");
      if (v11302) {
        v11302[0].classList.toggle("disabled", !v11300);
        v11302[1].classList.toggle("disabled", !v11301);
      }
    }
  },
  updateScrollWheel: function () {
    this.updateScroll(window.event.deltaY > 0 ? -1 : 1);
  },
  gen: function () {
    var v11303 = UTILS.isKRSale() && !v10514;
    var vLSdivIdshopHeaderdivSt = "<div id='shopHeader'><div style='height:15px;'></div><div class='bigMenTabs'>";
    for (var vLN01829 = 0; vLN01829 < config.shopTabs.length; ++vLN01829) {
      if (window.canShowMarketplace || !config.shopTabs[vLN01829].includes("Marketplace")) {
        vLSdivIdshopHeaderdivSt += "<div class='bigMenTab" + (this.tabIndex == vLN01829 ? " bigMenTabA" : "") + "' onclick='playSelect();windows[13].switchTab(" + vLN01829 + ")'  onmouseenter='SOUND.play(`tick_0`,0.1)'  style='font-size:16px'>" + config.shopTabs[vLN01829] + "</div>";
      }
    }
    vLSdivIdshopHeaderdivSt += "</div></div>";
    if (this.tabIndex == 0) {
      var vLS72 = "";
      vLS72 += "<div class=\"bundleSliderH\">\n\t\t\t\t\t<div class=\"bundleSliderBtn disabled\" onmouseenter=\"playTick(0.1);\" onmousedown=\"playSelect(0.1);windows[13].updateScroll(-1);\">\n\t\t\t\t\t\t<div class=\"bundleSliderArrow\"></div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>";
      vLS72 += "<div class=\"bundleCols\" onwheel=\"windows[13].updateScrollWheel();\">";
      if (bundleData) {
        bundleData = bundleData.sort((p13856, p13857) => new Date(p13857.DATE).getTime() - new Date(p13856.DATE).getTime());
        if (!account || account && account.level <= config.bundleLvlSort) {
          bundleData = bundleData.sort((p13858, p13859) => p13858.PRICE - p13859.PRICE);
        }
        bundleData = bundleData.sort((p13860, p13861) => (p13861.OWNED ? -1 : 1) - (p13860.OWNED ? -1 : 1));
        for (var vLN01829 = 0; vLN01829 < bundleData.length; ++vLN01829) {
          var v11304 = bundleData[vLN01829];
          var v11305 = v11304.SKINS.split(",");
          vLS72 += "<div class=\"bundleCrd\"" + (v11304.OWNED ? " style=\"filter:grayscale(1)\"" : "") + ">\n\t\t\t\t\t\t<div class=\"bundleIcn\" loading=\"lazy\" onmouseover='playTick(0.1)' onclick=\"playSelect(0.1);bundlePopup(true, false, " + v11304.ID + ")\" style=\"background-image: url(" + UTILS.assetsUrl("/img/backgrounds/bundles/b_" + v11304.ID + ".png") + ");background-repeat: no-repeat;background-size: cover;\">\n\t\t\t\t\t\t\t<div class=\"bundleItmNm\">" + v11304.NAME + "</div>\n\t\t\t\t\t\t</div>";
          vLS72 += "<div class=\"bundleHl\">";
          const v11306 = v11305.length > 4 ? 3 : 4;
          for (let vLN01824 = 0; vLN01824 < v11306; vLN01824++) {
            var v11307 = Game.store.skins[v11305[vLN01824]];
            vLS72 += v11307 ? "<div class=\"bundleItmReq\" onclick=\"viewItem(" + v11305[vLN01824] + ");\" style=\"border:2px solid " + Game.store.rarities[v11307.rarity || 0].color + ";background-image:url(" + v11307.thumbnail + ")\"></div>" : "<div class=\"bundleItmReq\"></div>";
          }
          if (v11305.length > 4) {
            vLS72 += "<div class=\"bundleItmReq\">\n\t\t\t\t\t\t\t<div class=\"bundleItmMore\">+" + (v11305.length - v11306) + "</div>\n\t\t\t\t\t\t</div>";
          }
          vLS72 += "</div>";
          vLS72 += "<div class=\"bundleItmBtn\" onmouseover='playTick(0.1)' onclick=\"playSelect(0.1);bundlePopup(true, false, " + v11304.ID + ")\">\n\t\t\t\t\t\t<div class=\"bundleItmBtnT\">" + (v11304.OWNED ? "Already Purchased" : "BUY $" + v11304.PRICE) + "</div></div>";
          vLS72 += "</div>";
        }
      }
      vLS72 += "</div>";
      vLS72 += "<div class=\"bundleSliderH\">\n\t\t\t\t\t<div class=\"bundleSliderBtn\" onmouseenter=\"playTick(0.1);\" onmousedown=\"playSelect(0.1);windows[13].updateScroll(1);\">\n\t\t\t\t\t\t<div class=\"bundleSliderArrow right\"></div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>";
      this.subTab = this.subTab || 0;
      var v11308 = this.genSubBtns();
      vLSdivIdshopHeaderdivSt += "<div style='text-align: center;'>";
      vLSdivIdshopHeaderdivSt += "<div id='shopMainSellB' class='windowSubTabs' onclick='playSelect();showWindow(6);'  style='background:linear-gradient(rgb(0 0 0 / 38%), #00000000, rgb(10 10 10 / 41%)),url(" + UTILS.assetsUrl("/img/battlepass/bg_window_2.png", undefined, true) + ");background-size:100%;" + (this.subTab == 0 ? "" : "display:none;") + "'><div class='shopMainSellTbs'>" + v11308 + "</div><div id='shopMainNav'>Unlock new Items!</div><div id='shopMainHedr'><div id='shopMainSubT' style=''>Checkout the</div>Battle Pass</div></div>";
      vLSdivIdshopHeaderdivSt += "<div id='shopMainSellB' class='windowSubTabs' onclick='playSelect();windows[13].premium();'  style='background:linear-gradient(rgb(0 0 0 / 38%), #00000000, rgb(10 10 10 / 41%)),url(" + UTILS.assetsUrl("/img/prem_bg.png") + ");background-size:120%;" + (this.subTab == 2 ? "" : "display:none;") + "'><div class='shopMainSellTbs'>" + v11308 + "</div><div id='shopMainNav'>Unlock new benefits!</div><div id='shopMainHedr'><div id='shopMainSubT' style='color:var(--yellow)!important'>Subscribe to</div>Premium</div></div>";
      vLSdivIdshopHeaderdivSt += "<div id='shopMainSellB' class='windowSubTabs' onclick='windows[13].craftMenu();'  style='background: linear-gradient(rgb(10 10 10 / 37%), #0000003b),url(" + UTILS.assetsUrl("/img/backgrounds/junkyrd_0.png") + ");background-size:cover;background-position-x: -600px;" + (this.subTab == 1 ? "" : "display:none;") + "'><div class='shopMainSellTbs'>" + v11308 + "</div><div id='shopMainNav'>Craft new Items!</div><div id='shopJnkDsp'>" + (account ? parseFloat(account.junk || 0).toFixed(2) : "0.00") + "<span class='material-icons' style='color:#cc51f8;font-size:38px;margin-left:8px;vertical-align:top;margin-right:-9px;'>plumbing</span></div><div id='shopMainHedr'><div id='shopMainSubT'>Enter the</div>Junkyard</div></div>";
      var v11309 = Game.store.wheels[2];
      var v11324 = v11309.ticketIndex !== undefined;
      var v11321 = v11309.rarities.indexOf(v11309.rarities.filter(p13862 => p13862 > 0).slice(-1).pop());
      var vA613 = Game.store.getSpnItems(v11309, v11321, account, v11309.season || config.currentSeason, v11309.bigRar);
      UTILS.yateShuffle(vA613);
      var v11329 = Game.store.skins[vA613[0]].thumbnail;
      vLSdivIdshopHeaderdivSt += "<div id='shopSideSellB'" + (account ? "" : " onclick='showWindow(5)'") + " onmouseenter='playTick()' \n\t\t\t\tstyle='color:" + (v11309.headCol || "#fff") + ";border: 4px solid;text-shadow: 0px 0px 30px rgb(0 0 0);background: rgba(0, 0, 0, 0.4);height:361px!important'>";
      if (account) {
        var v11328 = account.skins.find(p13863 => p13863 && p13863.ind == v11309.ticketIndex);
        vLSdivIdshopHeaderdivSt += "<div class='shopActionOvrl'>";
        vLSdivIdshopHeaderdivSt += v11309.multi ? "<div class=\"shopActions\">\n\t\t\t\t\t\t\t<div class=\"shopSubAction\" onclick=\"playSelect();prizeWheel(2)\" onmouseenter='playTick()' style=\"font-size: 34px;!important\">\n\t\t\t\t\t\t\t\t1x Spin <div style=\"color:" + (v11309.headCol || "#fff") + "\">" + (v11309.price + " KR") + "</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"shopSubActionSep\" style=\"background:" + (v11309.headCol || "#fff") + "\"></div>\n\t\t\t\t\t\t\t<div class=\"shopSubAction\" onclick=\"playSelect();prizeWheel(2, null, " + v11309.multi + ")\" onmouseenter='playTick()' style=\"font-size: 34px;!important\">\n\t\t\t\t\t\t\t\t" + v11309.multi + "x Spin <div style=\"color:" + (v11309.headCol || "#fff") + "\">" + (v11309.price * v11309.multi + " KR") + "</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>" : "<div class=\"shopAction\" onclick=\"playSelect();prizeWheel(2)\" onmouseenter='playTick()'>\n\t\t\t\t\t\t\tSpend <div style=\"color:" + (v11309.headCol || "#fff") + "\">" + (v11309.price + " KR") + "</div>\n\t\t\t\t\t\t</div>";
        vLSdivIdshopHeaderdivSt += "<div style='display: table-cell;'><div class=\"shopActionSep\" style=\"background:" + (v11309.headCol || "#fff") + "\"></div></div>";
        vLSdivIdshopHeaderdivSt += "<div class=\"shopAction\" onclick=\"playSelect();prizeWheel(null, " + v11309.ticketIndex + ")\"\n\t\t\t\t\t\tonmouseenter='playTick()' style=\"font-size: 34px;!important\">\n\t\t\t\t\t\tRedeem\n\t\t\t\t\t\t<div style=\"color:" + (v11309.headCol || "#fff") + "\">\n\t\t\t\t\t\t\t<img class=\"ticketImg\" src=\"" + Game.store.skins[v11309.ticketIndex].thumbnail + "\" style=\"width:70px!important;\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>";
        vLSdivIdshopHeaderdivSt += "<div class=\"ticketCount\" style=\"font-size:22px!important;color:" + (v11309.headCol || "#fff") + "\">You have " + (v11328 ? v11328.cnt : 0) + "</div>";
        vLSdivIdshopHeaderdivSt += "</div>";
      }
      vLSdivIdshopHeaderdivSt += "<div class='shopSpinValH'>" + i18n.t("windows.store.spin", v11309.name) + "<div class='shopSpinValL' style='color:" + (v11309.headCol || "#fff") + " !important;'>" + (v11309.price + " KR" + ("<div class=\"ticketImgSep\">|</div><img class=\"ticketImg\" src=\"" + Game.store.skins[v11309.ticketIndex].thumbnail + "\" style=\"width:56px!important\">")) + "</div></div>";
      vLSdivIdshopHeaderdivSt += "<div class='shopSpinImg' style='background-image: url(" + v11329 + ");'></div><div class='shopImgGrad' style='margin-left:0!important;background-image: linear-gradient(transparent, " + (v11309.headCol || "#fff") + "30);'></div>";
      vLSdivIdshopHeaderdivSt += "</div>";
      vLSdivIdshopHeaderdivSt += "<div id='shopBundleHolder'>" + vLS72 + "</div>";
      vLSdivIdshopHeaderdivSt += "</div>";
    }
    if (this.tabIndex == 1) {
      vLSdivIdshopHeaderdivSt += "<div class='setBodH' style='padding-top:15px'><div style='color:rgba(255,255,255,0.6);margin-bottom:10px;margin-top:0px;width:100%;text-align:center'>" + i18n.t("windows.store.wheels.sub") + "</div></div>";
      vLSdivIdshopHeaderdivSt += "<div class='prizeWheelTable'>";
      var v11315 = Game.store.wheels.filter(p13864 => p13864 && !p13864.hide && p13864.primary).length;
      for (var vLN01829 = 0; vLN01829 < Game.store.wheels.length; ++vLN01829) {
        player = Game.store.wheels[vLN01829];
        if (!player.hide && (!player.kr || !isMobileClient())) {
          var v11316 = !account || player.free && account.level < player.minLvl || player.locked;
          var v11317 = player.locked ? "Coming Soon" : v11316 ? "Sold Out" : player.priceT || player.price;
          var v11318 = true;
          if (account && player.aReq && account[player.aReq.ind] < player.aReq.val || player.locked) {
            v11316 = true;
            v11318 = false;
            if (player.aReq && player.aReq.txt) {
              v11317 = player.aReq.txt;
            }
          }
          if (player.kr) {
            updateRewardTimer();
            var v11319 = UTILS.getTimeH(Math.max(0, vLN01713));
            v11317 = vLN01713 <= 0 ? player.priceT : v11319 == "00:00:00" ? player.priceT : v11319;
            v11316 = !!(vLN01713 > 0);
            v11318 = false;
          }
          if (!player.kr && !player.locked && account) {
            var v11320 = player.rarities;
            var v11321 = v11320.indexOf(v11320.filter(p13865 => p13865 > 0).slice(-1).pop());
            var vA613 = Game.store.getSpnItems(player, v11321, account, player.season || config.currentSeason, player.bigRar);
            UTILS.yateShuffle(vA613);
            var v11329 = Game.store.skins[vA613[0]].thumbnail;
          }
          var v11324 = player.ticketIndex !== undefined;
          var v11325 = !!player.ticketOnly;
          var v11326 = false;
          vLSdivIdshopHeaderdivSt += "<div class='shopCard" + (v11316 ? " makeGray" : "") + "' onmouseenter='playTick()' style='color:" + (player.headCol || "#fff") + ";border: 4px solid;text-shadow: 0px 0px 30px rgb(0 0 0);width:" + (v11326 ? "454px" : "293px") + ";height: 202px;" + (player.kr || player.locked ? "background-image:url(" + UTILS.assetsUrl("/img/shop/filter/vignette.png") + "),url(&quot;" + UTILS.assetsUrl("/img/shop/spins/" + vLN01829 + ("_" + UTILS.randInt(0, player.icons - 1)) + ".png") + "&quot;)'" : "background: rgba(0, 0, 0, 0.4);'") + (v11316 || v11324 && !v11325 ? "" : " onclick='" + (player.kr ? "claimReward()" : v11325 ? "prizeWheel(null, " + player.ticketIndex + ")" : "prizeWheel(" + vLN01829 + ")") + "'") + ">";
          if (v11324 && !v11325 && account) {
            var v11328 = account.skins.find(p13866 => p13866 && p13866.ind == player.ticketIndex);
            vLSdivIdshopHeaderdivSt += "<div class='shopActionOvrl'>";
            vLSdivIdshopHeaderdivSt += player.multi ? "<div class=\"shopActions\">\n\t\t\t\t\t\t\t<div class=\"shopSubAction\" onclick=\"playSelect();prizeWheel(" + vLN01829 + ")\" onmouseenter='playTick()'>\n\t\t\t\t\t\t\t\t1x Spin\n\t\t\t\t\t\t\t\t<div style=\"color:" + (player.headCol || "#fff") + "\">\n\t\t\t\t\t\t\t\t\t" + (v11317 + (player.priceT || !v11318 ? "" : " KR")) + "\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"shopSubActionSep\" style=\"background:" + (player.headCol || "#fff") + "\"></div>\n\t\t\t\t\t\t\t<div class=\"shopSubAction\" onclick=\"playSelect();prizeWheel(" + vLN01829 + ", null, " + player.multi + ")\" onmouseenter='playTick()'>\n\t\t\t\t\t\t\t\t" + player.multi + "x Spin\n\t\t\t\t\t\t\t\t<div style=\"color:" + (player.headCol || "#fff") + "\">\n\t\t\t\t\t\t\t\t\t" + (v11317 * player.multi + (player.priceT || !v11318 ? "" : " KR")) + "\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>" : "<div class=\"shopAction\" onclick=\"playSelect();prizeWheel(" + vLN01829 + ")\" onmouseenter='playTick()'>\n\t\t\t\t\t\t\tSpend\n\t\t\t\t\t\t\t<div style=\"color:" + (player.headCol || "#fff") + "\">\n\t\t\t\t\t\t\t\t" + (v11317 + (player.priceT || !v11318 ? "" : " KR")) + "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>";
            vLSdivIdshopHeaderdivSt += "<div style='display: table-cell;'><div class=\"shopActionSep\" style=\"background:" + (player.headCol || "#fff") + "\"></div></div>";
            vLSdivIdshopHeaderdivSt += "<div class=\"shopAction\" onclick=\"playSelect();prizeWheel(null, " + player.ticketIndex + ")\"\n\t\t\t\t\t\tonmouseenter='playTick()'>\n\t\t\t\t\t\tRedeem\n\t\t\t\t\t\t<div style=\"color:" + (player.headCol || "#fff") + "\">\n\t\t\t\t\t\t\t<img class=\"ticketImg\" src=\"" + Game.store.skins[player.ticketIndex].thumbnail + "\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>";
            vLSdivIdshopHeaderdivSt += "<div class=\"ticketCount\" style=\"color:" + (player.headCol || "#fff") + "\">You have " + (v11328 ? v11328.cnt : 0) + "</div>";
            vLSdivIdshopHeaderdivSt += "</div>";
          }
          if (v11325 && account) {
            var v11328 = account.skins.find(p13867 => p13867 && p13867.ind == player.ticketIndex);
            vLSdivIdshopHeaderdivSt += "<div class=\"ticketCount\" style=\"width: unset;top:7px;right: 10px;color:" + (player.headCol || "#fff") + "\">You have " + (v11328 ? v11328.cnt : 0) + "</div>";
          }
          vLSdivIdshopHeaderdivSt += "<div class='spinValH'>" + i18n.t("windows.store.spin", player.name) + "<div class='spinValL' style='color:" + (player.headCol || "#fff") + " !important;width:" + (v11326 ? "474px" : "314px") + "'>" + (v11325 ? "Redeem <img class=\"ticketImg\" src=\"" + Game.store.skins[player.ticketIndex].thumbnail + "\">" : v11317 + (player.priceT || !v11318 ? "" : " KR") + (v11324 ? "<div class=\"ticketImgSep\">|</div><img class=\"ticketImg\" src=\"" + Game.store.skins[player.ticketIndex].thumbnail + "\">" : "")) + "</div></div>";
          vLSdivIdshopHeaderdivSt += (player.kr || player.locked ? "" : "<div class='shopImg' style='background-image: url(" + v11329 + ");left:" + (v11326 ? "136px" : "60px") + "'></div>") + "<div class='shopImgGrad' style='background-image: linear-gradient(transparent, " + (player.headCol || "#fff") + "30);'></div>";
          vLSdivIdshopHeaderdivSt += "</div>";
        }
      }
      player = Game.store.wheels[3];
      var vLSfc038d = "#fc038d";
      var vA613 = [...Game.store.skins.filter(p13868 => p13868 && p13868.type == itemTypes.TICKET)];
      UTILS.yateShuffle(vA613);
      var v11329 = vA613[0].thumbnail;
      var v11330 = (account ? account.skins.filter(p13869 => p13869 && Game.store.skins[p13869.ind] && Game.store.skins[p13869.ind].type == itemTypes.TICKET) : []).reduce((p13870, p13871) => p13870 + p13871.cnt, 0);
      vLSdivIdshopHeaderdivSt += "<div class='shopCard' onmouseenter='playTick()' style='color:" + vLSfc038d + ";border: 4px solid;text-shadow: 0px 0px 30px rgb(0 0 0);width:293px;height: 202px;background: rgba(0, 0, 0, 0.4);' onclick='windows[13].viewTickets()'>";
      vLSdivIdshopHeaderdivSt += "<div class='spinValH'>View Tickets" + ("<div class='spinValL' style='color:" + vLSfc038d + "!important;width:314px'>You have " + v11330 + "</div>");
      vLSdivIdshopHeaderdivSt += "</div>";
      vLSdivIdshopHeaderdivSt += "<div class='shopImg' style='background-image: url(" + v11329 + ");left:60px'></div>" + ("<div class='shopImgGrad' style='background-image: linear-gradient(transparent, " + vLSfc038d + "30);'></div>");
      vLSdivIdshopHeaderdivSt += "</div>";
    }
    if (this.tabIndex == 2) {
      vLSdivIdshopHeaderdivSt += "<div class='setBodH' style='padding-top:15px'><div style='color:rgba(255,255,255,0.5);margin-bottom:10px'>" + i18n.t("windows.store.buyP") + " <a href='javascript:;' onclick='showWindow(36)'>" + i18n.t("windows.store.premium2") + "</a></div></div>";
      vLSdivIdshopHeaderdivSt += "<div id='storeList' style='margin-bottom:10px'>";
      for (var vLN01829 = 0; vLN01829 < Game.store.premium.length; ++vLN01829) {
        player = Game.store.premium[vLN01829];
        vLSdivIdshopHeaderdivSt += "<div class='shopCard' onmouseenter='playTick()' onclick='premiumPopup(" + vLN01829 + ")' style='color:" + (player.headCol || "#fff") + ";border: 4px solid;width:293px;height:212px;background-image:linear-gradient(transparent, " + (player.headCol || "#fff") + "30), url(&quot;" + UTILS.assetsUrl("/img/prem_crd.png") + "&quot;);'>" + player.val + " Days<div class='spinVal' style='margin-top:119px;width: 309px;line-height: 63px;'>$" + player.price + " <span style='color:#fff'>USD</span></div></div>";
      }
      vLSdivIdshopHeaderdivSt += "</div><div id='premiumRes'></div>";
      vLSdivIdshopHeaderdivSt += "<div class='setBodH' style='padding-top:10px;padding-bottom:10px;'><span style='color:#fff'>Time Remaining</span><span id='premTime'>" + UTILS.getReadableTime(account && account.premiumT ? Math.floor(account.premiumT) : 0) + "</span></div>";
    }
    if (this.tabIndex == 3) {
      var v11331 = JSON.parse(getSavedVal("krk_cc") || "{}");
      if (v11331 && Date.now() - v11331.t >= config.creatorReset) {
        deleteVal("krk_cc");
        v11331 = null;
      } else {
        v11331 = v11331.code;
      }
      var v11332 = account && account.refCode ? account.refCode : null;
      if (v11332 && (v11332 + "").toLowerCase() == "krunker") {
        v11332 = null;
      }
      var v11333 = v11331 || v11332 || null;
      vLSdivIdshopHeaderdivSt += "<div id='purchaseInfoTable'>";
      vLSdivIdshopHeaderdivSt += "<div class='purchKRInfoH'><div style='color:rgba(255,255,255,0.5);font-size:18px;margin-top:5px;margin-bottom:5px;'>" + i18n.t("windows.store.creator") + "</div><div><input type='text' id='creatorCodeI' class='smlInput' style='width:280px' " + (v11333 ? "value='" + v11333 + "'" : "placeholder='Enter Creator Code'") + " " + (v11331 ? "disabled" : "") + "/><div class='creatorCodeBtn' style='background-color:" + (v11331 ? "#eb5656" : "#41c300") + "' onclick='creatorCodeAction(" + (v11331 ? 0 : 1) + ", 0)'>" + (v11331 ? "Remove" : "Save") + "</div></div></div>";
      for (var vLN01829 = 0; vLN01829 < Game.store.purchases.length; ++vLN01829) {
        player = Game.store.purchases[vLN01829];
        if (!player.hide && !player.type) {
          var v11334 = v10514 ? v11303 ? player.priceSteamSale : player.priceSteam : v11303 ? player.priceSale : player.price;
          vLSdivIdshopHeaderdivSt += "<div class='shopCard' onmouseenter='playTick()' onclick='logBtnFRVR(`buy_kr_" + player.val + "`);showPurchase(" + vLN01829 + ")' style='background-image:url(" + UTILS.assetsUrl("/img/shop/filter/vignette.png") + "),url(&quot;" + UTILS.assetsUrl("/img/shop/" + vLN01829 + ".png") + "&quot;);border: 4px solid;color:" + (player.col || "") + "'>" + (player.tag || v11303 ? "<div class='shopSale' style='background-color:" + (v11303 ? "#E040FB" : player.tagCol) + "'>" + (v11303 ? "10% Off" : player.tag) + "</div>" : "") + player.val + " <span style='color:#fff'>KR</span><div class='spinVal' style='color:#fff'>$" + v11334 + " USD</div></div>";
        }
      }
      vLSdivIdshopHeaderdivSt += "</div>";
      vLSdivIdshopHeaderdivSt += "<div style='font-size:15px;text-align:center;margin-bottom:10px;margin-top:10px;color:#d4d4d4;'>" + i18n.t("windows.store.currency") + "</div>";
      vLSdivIdshopHeaderdivSt += "<div>";
      vLSdivIdshopHeaderdivSt += "<div style='color:#d4d4d4;font-size:16px;text-align:center;margin-bottom:10px;margin-top:10px;'>" + i18n.t("windows.store.agree", "<a target='_blank' href='https://frvr.com/legal/krunker#TermsofService'>") + "</a>.</div>";
    }
    this.tabIndex == 4;
    if (this.tabIndex == 6) {
      vLSdivIdshopHeaderdivSt += "<div id='crftHeaderImg' style='background-image:linear-gradient(rgb(10 10 10 / 37%),#0000003b),url(" + UTILS.assetsUrl("/img/backgrounds/junkyrd_0.png") + ");'><div id='crftHeaderName'>Welcome to the Junkyard</div><div id='crftHeaderDesc'>Craft brand new skins & items by using Junk and other Materials, which can be found scattered around every map in the game or earned from challenges.</div></div>";
      if (!this.craftData && account) {
        this.craftData = {};
        io.send("recps");
      }
      vLSdivIdshopHeaderdivSt += "<div style='margin-top:0px;'>";
      if (!this.craftData || !this.craftData.dat) {
        vLSdivIdshopHeaderdivSt += account && this.craftData ? "<div style='color:#fff;text-align:center;margin-top:20px;'>" + (this.craftData.error ? "No Recipes Found" : "Loading Recipes...") + "</div>" : "<div style='color:#fff;text-align:center;margin-top:20px;cursor: pointer;' onclick='showWindow(5)'><span style='color:#31caec'>Register</span> to craft! </div>";
      } else {
        this.craftData.dat.forEach(p13872 => {
          p13872.order = parseFloat(p13872.JUNK || 0);
          var v11335 = (p13872.STATORD || 0) > 0;
          var vParseFloat4 = parseFloat(p13872.JUNK || 0);
          if (!v11335) {
            var v11336 = Math.abs(Game.now - (p13872.DAT || 0)) < 172800000;
            if (v11336) {
              p13872.order += 10000;
            }
            var v11337 = account && account.junk >= vParseFloat4;
            if (v11337) {
              for (var v11338 = UTILS.arrayChunk((p13872.SIN || "").split(","), 2), vLN01828 = 0, v11339; vLN01828 < v11338.length; vLN01828++) {
                v11339 = v11338[vLN01828][0];
                if (v11339) {
                  var v11340 = (account ? account.skins : []).find(p13873 => p13873.ind == v11339 && p13873.cnt >= parseInt(v11338[vLN01828][1] || 0));
                  if (!v11340 && v11337) {
                    v11337 = false;
                  }
                }
              }
            }
            if (v11337) {
              p13872.order += 15000;
            } else {
              p13872.order -= 15000;
            }
          } else {
            p13872.order -= 20000;
          }
        });
        this.craftData.dat = this.craftData.dat.sort((p13874, p13875) => (p13875.order || -1) - (p13874.order || -1));
        for (var vLN01829 = 0; vLN01829 < this.craftData.dat.length; ++vLN01829) {
          var v11341 = this.craftData.dat[vLN01829];
          var v11342 = v11341.STATORD || 0;
          var v11343 = Game.store.skins[v11341.SOUT];
          if (v11343) {
            var v11344 = v11341.EXP;
            var v11345 = (v11341.SIN || "").split(",");
            var vLSdiv = "<div>";
            var vParseFloat5 = parseFloat(v11341.JUNK || 0);
            var vParseInt38 = parseInt(v11341.CNT || 0);
            var v11346 = !account || account.junk < vParseFloat5 ? "Not enough Junk" : null;
            if (vParseInt38 == 0) {
              v11346 = "Sold out";
            }
            var vO357 = {};
            var v11347 = Math.abs(Game.now - (v11341.DAT || 0)) < 172800000;
            var vLN01830 = 0;
            for (var vLN01831 = 0, v11348; vLN01831 < 10; vLN01831 += 2) {
              v11348 = v11345[vLN01831];
              if (v11348) {
                var v11349 = Game.store.skins[v11348];
                var v11350 = (account ? account.skins : []).find(p13876 => p13876.ind == v11348 && p13876.cnt >= parseInt(v11345[vLN01831 + 1] || 0));
                if (!v11350 && !v11346) {
                  v11346 = "Missing materials";
                }
                vLSdiv += "<div class='crftItmReq' onclick='viewItem(" + v11348 + ");' style='" + (v11350 ? "" : "filter:grayscale(1);border: 2px solid #5e5e5e !important;") + "border: 2px solid " + Game.store.rarities[v11349.rarity].color + ";background-image:url(" + v11349.thumbnail + "'><div class='crftReqCnt'>x" + (v11345[vLN01831 + 1] || 0) + "</div></div>";
              } else {
                vLSdiv += "<div class='crftItmReq' style='" + (vLN01831 ? "" : "margin-left:-5px;") + "'></div>";
              }
            }
            vLSdiv += "</div>";
            vLSdivIdshopHeaderdivSt += "<div class='crftRcpeCrd'><div class='craftRcIcn' style='border:3px solid " + Game.store.rarities[v11343.rarity].color + ";' onclick='viewItem(" + v11341.SOUT + ")'><img style='height:100%' src='" + v11343.thumbnail + "'><div class='crftItmNm' style='color:" + Game.store.rarities[v11343.rarity].color + "'>" + v11343.name + "</div><div class='crftItmJnk'>" + vParseFloat5.toFixed(2) + "<span class='material-icons' style='color:#cc51f8;font-size:34px;margin-left:5px;vertical-align:top;'>plumbing</span></div>" + (v11347 && v11342 == 0 ? "<div class='crftNewRc'>NEW</div>" : "") + (vParseInt38 > 0 ? "<div class='crftLimAmnt' title='" + (vParseInt38 || 0) + " left in the world'>x" + (vParseInt38 || 0) + "</div>" : "") + (v11342 == 1 ? "<div class='crftHmmrAnm'><span class='material-icons crftHammrIcn'>plumbing</span></div>" : "") + (v11342 == 2 ? "<div class='donCrftIcn'><span class='material-icons' style='font-size:160px;color:#38cd3a;line-height:175px;'>done</span></div>" : "") + "</div><div class='craftRiHl'>" + vLSdiv + "</div>" + (v11342 == 1 ? "<div class='crftTim'>" + UTILS.getReadableTime(Math.max(0, v11344)) + " remaining</div>" : v11346 || v11342 == 2 ? "<div class='crftTim'>" + (v11342 == 2 ? "Complete" : v11346 || "Error") + "</div>" : "<div class='crftItmBtn' onclick='logBtnFRVR(`craft_item`);windows[13].sendCraft(" + v11341.SID + ")'>Craft</div>") + "</div>";
          }
        }
      }
      vLSdivIdshopHeaderdivSt += "</div>";
    }
    return vLSdivIdshopHeaderdivSt;
  }
}, {
  header: i18n.t("windows.skin.header"),
  label: "skin_selection",
  width: 877,
  height: "calc(100% - 300px)",
  sticky: true,
  dark: true,
  hideScroll: true,
  gen: function () {
    var v11351 = Game.weaponConfig[activeSkinSel] && Game.weaponConfig[activeSkinSel].secondary ? 19 : 2;
    var v11352 = "<div id='itemSearchH'><div class='custBack' onclick='playSelect(0.1);goBackWindow(" + v11351 + ")' onmouseenter='playTick();'><span class='material-icons custBackArr'>arrow_back</span></div><input id='itemSearch' type='text' placeholder='Search Item' onkeyup='searchItems(this)'><div class='winClose' onclick='playSelect(0.1);closWind()' onmouseenter='playTick();'><span class='material-icons winCloseArr'>close</span></div></div><div id='skinList' style='margin-top: 8px;overflow-y: scroll;height: calc(100% - 95px);'><div class='skinCard blackShad' style='border:5px solid lightgrey' onmouseenter='playTick()' onclick='selectSkin(-3," + activeSkinSel + ")'>" + i18n.t("generic.none") + "<div class='itemOwn'>" + i18n.t("generic.default") + "</div><div class='itemSea' style='opacity:0;'>Season 1</div><img draggable='false' class='skinImg' src='" + UTILS.assetsUrl("/textures/previews/weapons/" + Game.weaponConfig[activeSkinSel].src + ".png") + "'></div><div class='skinCard blackShad' style='border:5px solid lightgrey' onmouseenter='playTick()' onclick='selectSkin(-2," + activeSkinSel + ")'>" + i18n.t("generic.random") + "<div class='itemOwn' style='opacity:0;'>by ???</div><div class='itemSea' style='opacity:0;'>All Seasons</div><img draggable='false' class='skinImg skinSil' onmouseenter='playTick()' src='" + UTILS.assetsUrl("/textures/previews/weapons/" + Game.weaponConfig[activeSkinSel].src + ".png") + "'><div class='skinRandom blackShad' style='top:68px'>?</div></div>";
    var v11353 = [...f1799(account, true)].sort(function (p13877, p13878) {
      var v11354 = p13878.ind != null && Game.store.skins[p13878.ind] ? Game.store.skins[p13878.ind].rarity || 0 : 0;
      var v11355 = p13877.ind != null && Game.store.skins[p13877.ind] ? Game.store.skins[p13877.ind].rarity || 0 : 0;
      var v11356 = p13878.ind != null && Game.store.skins[p13878.ind] ? Game.store.skins[p13878.ind].seas || 1 : 0;
      var v11357 = p13877.ind != null && Game.store.skins[p13877.ind] ? Game.store.skins[p13877.ind].seas || 1 : 0;
      if (v11354 > v11355) {
        return 1;
      } else if (v11354 < v11355) {
        return -1;
      } else if (v11356 > v11357) {
        return 1;
      } else if (v11356 < v11357) {
        return -1;
      } else {
        return (p13878.ind || 0) - (p13877.ind || 0);
      }
    });
    v11353.sort(function (p13879, p13880) {
      return ~~(favoriteItemIds.indexOf(p13880.ind) >= 0) - ~~(favoriteItemIds.indexOf(p13879.ind) >= 0);
    });
    for (var vLN01832 = 0; vLN01832 < v11353.length; ++vLN01832) {
      player = Game.store.skins[v11353[vLN01832].ind];
      if (player && !player.type && player.weapon == activeSkinSel + 1) {
        var v11358 = account && account.isDev || player.classIndex == null || player.classIndex == classIndex || Game.isSandbox;
        var v11359 = favoriteItemIds.indexOf(player.index) >= 0;
        v11352 += "<div class='skinCard" + (player.rarity == rarities.CONTRABAND ? "" : " blackShad") + (!player.free && RENDER.rarityAnim && Game.store.rarities[player.rarity].animate ? " rainbow" : "") + "' style='color:" + (player.free ? "border: 5px solid lightgrey" : "color:" + Game.store.rarities[player.rarity].color + ";border:5px solid" + Game.store.rarities[player.rarity].color) + "' onmouseenter='playTick()' " + (v11358 ? "onclick='selectSkin(" + v11353[vLN01832].ind + "," + (player.weapon - 1) + ");cancelTip()' " : " ") + "data-index='" + player.index + "' onmouseover='createTip(this)' onmouseout='cancelTip()'>" + (player.free ? "" : "<div class='itemCnt' data-badge='x" + v11353[vLN01832].cnt + "'></div>") + player.name + "<div class='itemOwn' style='z-index: 3;position: relative;'>" + (v11358 ? player.free ? i18n.t("windows.skins.default") : "by " + (player.creator || "Krunker.io") : i18n.t("windows.skins.classOnly", Game.classes[player.classIndex].name)) + "</div>" + (player.free ? "" : "<div class='itemSea'>Season " + (player.seas || 1) + "</div>") + "<img loading='lazy' draggable='false' class='skinImg" + (player.type ? "C" : "") + (player.rgb ? " rgbHue" : "") + "' src='" + player.thumbnail + "' /><div class='selctInfoBtn' onmouseenter='playTick()'onclick='viewItem(" + v11353[vLN01832].ind + ")'>?</div><div class='selctFavBtn material-icons' onmouseenter='playTick()' data-col='" + (v11359 ? "yellow" : "white") + "' data-icon='" + (v11359 ? "star" : "star_border") + "' onclick='favItem(this, " + v11353[vLN01832].ind + ")'></div>" + (v11358 ? "" : "<div class='lockedSkin'><span class='material-icons' style='font-size: 55px;color:#fff'>lock</span></div>") + "</div>";
      }
    }
    v11352 += "</div>";
    return v11352;
  }
}, {
  header: i18n.t("windows.hat.header"),
  label: "hat_selection",
  width: 877,
  height: "calc(100% - 300px)",
  sticky: true,
  dark: true,
  hideScroll: true,
  gen: () => f1828("selectHat", 1),
  close: () => cancelTip(),
  clear: () => {
    f1822(window.event);
    selectHat(-1, true, true);
  }
}, {
  header: i18n.t("windows.body.header"),
  label: "body_selection",
  width: 877,
  height: "calc(100% - 300px)",
  sticky: true,
  dark: true,
  hideScroll: true,
  gen: function () {
    return f1828("selectBody", 2);
  },
  close: () => cancelTip(),
  clear: () => {
    f1822(window.event);
    selectBody(-1, true, true);
  }
}, {
  header: i18n.t("windows.mods.load.header"),
  label: "mods_load",
  gen: function () {
    return "<div id='modPckHead' class='setHed' style='margin-top:0px;margin-bottom:20px;'>Mod Loader</div><form id='modDropper'><input onchange='loadMod()' id='modInput'type='file'><p id='modLInfo'>" + i18n.t("windows.mods.drop") + "</p></form><input type='text' id='modURL' class='accountInput' style='width:78%' placeholder='" + i18n.t("windows.mods.paste") + "'><a class='menuLink' style='display:inline-block;margin-left:10px' onclick='loadModURL()'>" + i18n.t("windows.mods.load") + "</a>";
  }
}, {
  header: i18n.t("windows.publish.mod.header"),
  label: "unused",
  gen: function () {
    return "";
  }
}, {
  header: i18n.t("windows.secondary.header"),
  label: "secondary_selection",
  dark: true,
  goBack: function () {
    showWindow(20);
  },
  gen: function () {
    var vLSdivClasswinBackHdivC = "<div class='winBackH'><div class='custBack' onclick='playSelect(0.1);goBackWindow(44)' onmouseenter='playTick();'><span class='material-icons custBackArr'>arrow_back</span></div><div class='winSelH'>Select Secondary</div><div class='winClose' onclick='playSelect(0.1);closWind()' onmouseenter='playTick();'><span class='material-icons winCloseArr'>close</span></div></div>";
    vLSdivClasswinBackHdivC += "<div id='skinList'>";
    for (var v11360 = Game.weaponConfig.filter(p13881 => p13881.secondary).sort((p13882, p13883) => (p13882.minRec == null ? 0 : p13882.minRec) - (p13883.minRec == null ? 0 : p13883.minRec)), vLN01833 = 0; vLN01833 < v11360.length; ++vLN01833) {
      player = v11360[vLN01833];
      if (player) {
        var v11361 = !player.req || player.req(account, Game) || Game.isSandbox;
        var v11362 = Game.weaponConfig.findIndex(p13884 => p13884.name == player.name);
        var v11363 = skinsLoadout[v11362] >= 0 ? v11363 = Game.store.skins[skinsLoadout[v11362]] : null;
        vLSdivClasswinBackHdivC += "<div class='skinCard blackShad' style='height: 165px;border:5px solid lightgrey'" + (v11361 ? " onclick='skinSelector(" + v11362 + ", true)'" : "") + ">" + player.name + "<div class='itemOwn'>" + (player.req ? i18n.t("windows.secondary." + (v11361 ? "unlocked" : player.customOnly ? "customOnly" : player.premiumOnly ? "premiumOnly" : "req"), player.minRec) : i18n.t("generic.default")) + "</div><img loading='lazy' draggable='false' class='secImg' onmouseenter='playTick()' src='" + (v11363 ? v11363.thumbnail : UTILS.assetsUrl("/textures/previews/weapons/" + Game.weaponConfig[v11362].src + ".png")) + "' />" + (v11361 ? "" : "<div class='lockedCard'><span class='material-icons' style='font-size: 70px;color:" + (player.premiumOnly ? "var(--yellow)" : "#fff") + ";'>" + (player.premiumOnly ? "beenhere" : "lock") + "</span></div>") + "</div>";
      }
    }
    vLSdivClasswinBackHdivC += "</div>";
    return vLSdivClasswinBackHdivC;
  }
}, {
  header: i18n.t("windows.advertise.header"),
  label: "advertise",
  width: 1000,
  maxH: "calc(100% - 330px)",
  tabIndex: 0,
  getReferrerInfo: function () {
    io.send("refL");
    this.refData = {};
  },
  applyRefInfo: function (p13885) {
    this.refData.list = p13885;
    updateWindow(21);
  },
  switchTab: function (p13886, p13887) {
    if (this.tabIndex != p13886 || p13887) {
      this.tabIndex = p13886;
      updateWindow(21);
    }
  },
  gen: function () {
    var vLSdivStyleheight15pxdi2 = "<div style='height:15px;'></div><div class='bigMenTabs'>";
    for (var vLN01835 = 0; vLN01835 < config.businessTabs.length; ++vLN01835) {
      vLSdivStyleheight15pxdi2 += "<div class='bigMenTab" + (this.tabIndex == vLN01835 ? " bigMenTabA" : "") + "' onclick='playSelect(0.1);windows[20].switchTab(" + vLN01835 + ")' onmouseenter='playTick();' style='width:" + 100 / config.businessTabs.length + "%;padding-top:10px;padding-bottom:5px;'>" + config.businessTabs[vLN01835].n + "</div>";
    }
    vLSdivStyleheight15pxdi2 += "</div>";
    if (this.tabIndex != 0) {
      if (this.tabIndex == 1) {
        vLSdivStyleheight15pxdi2 += "<div class='setHed' style='margin-top:0px;'>Recovery</div><div class='setBodH' style='padding-top:10px'><div style='color:rgba(255,255,255,0.4);margin-top:0px'>To recover your account <b>username or password</b>, please contact <a>recovery@yendis.ch</a> Recovery is only possible if certain information can be provided.<div style='height:10px'></div></div></div> <div class='setHed' style='margin-top:20px;'>General Support</div><div class='setBodH'><div style='color:rgba(255,255,255,0.4);margin-top:10px'>Contact us on <a href='mailto:krunker+support@frvr.com?subject=Krunker Support'>krunker+support@frvr.com</a> for <b>General Support</b> requests.<div style='height:10px'></div> </div></div><div class='setHed' style='margin-top:20px;'>Payments & Refunds</div><div class='setBodH'><div style='color:rgba(255,255,255,0.4);margin-top:10px'>Contact us on <a href='mailto:krunker+support@frvr.com?subject=Krunker Payment'>krunker+support@frvr.com</a> for support requests relating to <b>Payments & Refunds</b>.<div style='height:10px'></div> </div></div><div class='setHed' style='margin-top:20px;'>Forums</div><div class='setBodH' style='padding-top:15px'>For <b>Bug Reports, Suggestions</b> or <b>Other Queries</b> join our <a href='" + config.discordInvite + "'>Discord</a> or <a href='https://www.reddit.com/r/KrunkerIO'>Reddit</a> communities.<div style='height:10px'></div></div><div class='setHed' style='margin-top:20px;'>Company Information</div><div class='setBodH' style='padding-top:10px;padding-bottom:10px'>FRVR Limited</br>61 Saint Paul Street Valletta,</br>AVLT 1212,</br>Malta</br></div><div class='setHed' style='margin-top:20px;'>Contact</div><div class='setBodH' style='padding-top:10px;padding-bottom:15px;'>Legal<a style='float:right' href='mailto:legal+krunker@frvr.com?subject=Krunker Legal'>legal+krunker@frvr.com</a></br>Bug Bounties<a style='float:right' href='mailto:krunker+bugs@frvr.com?subject=Krunker Bugs'>krunker+bugs@frvr.com</a></br>Ban Appeals<a style='float:right' href='mailto:krunker+banappeal@frvr.com?subject=Krunker Ban Appeal'>krunker+banappeal@frvr.com</a></br>Advertising/Acquisition<a style='float:right' href='mailto:krunker+info@frvr.com?subject=Krunker Advertising'>krunker+info@frvr.com</a></div>";
      }
    } else if (windows[20].refData && windows[20].refData.list) {
      vLSdivStyleheight15pxdi2 += "<div class='setBodH' style='padding-top:10px;padding-bottom:10px;margin-bottom:25px;color:rgba(255,255,255,0.5);'>Every hour a referred player plays the game, you get paid real money! <span style='color:#fff'>($0.04 x Hours)</span></div><div class='setHed' style='margin-top:10px;' >Top Referrers <span style='float:right;color:rgba(255, 255, 255, 0.6)'>Referred Hours (Last 30d)</span></div><div class='setBodH'>";
      for (var vLN01835 = 0, v11364; vLN01835 < windows[20].refData.list.length; ++vLN01835) {
        v11364 = windows[20].refData.list[vLN01835];
        vLSdivStyleheight15pxdi2 += "<div class='settName'>" + (vLN01835 + 1 + ". ") + "<a href='/social.html?p=profile&q=" + v11364.pna + "'>" + v11364.pna + "</a><div style='float:right;color:rgba(255,255,255,0.5)'>" + UTILS.commaNumber(v11364.pl3) + " <span style='color:#fff'>Hours</span></div></div>";
      }
      vLSdivStyleheight15pxdi2 += "</div>";
    } else {
      if (!windows[20].refData) {
        windows[20].getReferrerInfo();
      }
      vLSdivStyleheight15pxdi2 += "<div style='width:100%;text-align:center;background-color:rgba(0,0,0,0.3);padding-top:10px;padding-bottom:10px;'>Loading...</div>";
    }
    return vLSdivStyleheight15pxdi2;
  }
}, {
  header: "Social",
  label: "unused",
  gen: function () {
    return "TODO";
  }
}, {
  header: i18n.t("windows.players.header"),
  label: "player_list",
  width: 1020,
  sticky: true,
  dark: true,
  playerSearch: null,
  searchMatches: function (p13888) {
    return !!p13888.name && ((p13888.name || "").toLowerCase().indexOf((this.playerSearch || "").toLowerCase()) >= 0 || (p13888.alias || "").toLowerCase().indexOf((this.playerSearch || "").toLowerCase()) >= 0);
  },
  searchPlayers: function (p13889) {
    this.playerSearch = p13889 && p13889.value != "" ? p13889.value : null;
    var v11365 = document.getElementById("playerListH");
    if (v11365) {
      v11365.innerHTML = this.genList();
    }
  },
  genList: function () {
    var vLStableClasspListTable = "<table class='pListTable' style='margin-top: 8px;overflow-y: scroll;height: calc(100% - 75px);'><tbody>";
    var v11366 = currentKpdCase ? Game.players.list.find(p13890 => p13890.id == currentKpdCase.sus) : null;
    if (v11366) {
      var v11373 = COLORS.ping[v11366.ping >= 150 ? "high" : v11366.ping >= 50 ? "medium" : !v11366.ping || v11366.ping <= 0 ? "unknown" : "low"];
      vLStableClasspListTable += "<tr style='border:solid 2px red'><td class='pListName'>" + (window.spectating ? "<span onmouseenter='playTick()' title='Focus Player' class='punishButton' onclick='focusPlayer(\"" + v11366.id + "\", this)'><span class='takeAction material-icons'>" + (v11366.id == focusedPlayerId ? "visibility_off" : "visibility") + "</span></span>" : "") + "<span class='pListPing material-icons' style='color:" + v11373 + "' title='" + (v11366.ping || 0) + "ms'>signal_cellular_alt</span><a target='_blank' class='red' href='/social.html?p=profile&q=" + v11366.name + "' oncontextmenu='copyUser(this, &quot;" + v11366.id + "&quot;)'>" + v11366.alias + (v11366.clan ? "<span style='color:" + COLORS.getClanCol(v11366.clan, "#353535") + "'> [" + v11366.clan + "]</span>" : "") + "</a></td></td><td class='pListActions'>" + (isGameHost || account && (account.canSilentKick || account.canGlobalKick || account.canGlobalBan || account.canGlobalFlag) ? "<span onmouseenter='playTick()' class='punishButton kick' onclick='punishPopup(\"" + v11366.id + "\")'><span class='takeAction material-icons'>construction</span></span>" : "") + "</td></tr>";
    }
    if (tmpPlayer) {
      vLStableClasspListTable += "<tr><td class='pListName'>" + (isGameHost ? "<i class='material-icons' style='font-size:25px'>stars</i>" : "") + tmpPlayer.alias + (tmpPlayer.clan ? "<span style='color:" + COLORS.getClanCol(tmpPlayer.clan, "#353535") + "'> [" + tmpPlayer.clan + "]</span>" : "") + "</td><td class='pListActions'>" + (window.spectating ? "<span onmouseenter='playTick()' title='Clear Focus' class='punishButton kick' onclick='clearFocus()'>Clear Focus</span>" : "") + (isGameHost || account && account.canGlobalKick ? "<span onmouseenter='playTick()' class='punishButton kick' onclick='punishPlayer(null, 2)'>Kick Spec</span>" : "") + (account && account.isDev ? "<span onmouseenter='playTick()' class='punishButton kill' onclick='punishPlayer(\"" + tmpPlayer.id + "\", 3)'>Kill</span>" : "") + (account && account.isDev ? "<span onmouseenter='playTick()' class='punishButton tpall' onclick='punishPlayer(null, 9)'>TPAll</span>" : "") + (account && account.isDev ? "<span onmouseenter='playTick()' class='punishButton kick' onclick='botsPopup();'><span class='takeAction material-icons'>smart_toy</span></span>" : "") + "</td></tr>";
    }
    for (let v11368 of Game.players.list.filter(p13891 => !config.isProd || !p13891.isYou)) {
      if ((!v11366 || v11366.id != v11368.id) && (!v11368.isBot || !Game.mode.botsAsAI)) {
        var v11369 = account && !Game.isCustom && kickVoteSubmittedAliases.indexOf(v11368.alias) == -1 && (activeKickVoteTargetAlias == v11368.alias || !activeKickVoteTargetAlias && !hasStartedKickVote);
        var v11370 = !Game.isCustom && account && account.level >= config.minKDFCall;
        var v11371 = v11368.level >= 1;
        var v11372 = v11368.level >= 1;
        var v11373 = COLORS.ping[v11368.ping >= 150 ? "high" : v11368.ping >= 50 ? "medium" : !v11368.ping || v11368.ping <= 0 ? "unknown" : "low"];
        var v11374 = "<tr><td class='pListName'>" + (window.spectating ? "<span onmouseenter='playTick()' title='Focus Player' class='punishButton' onclick='focusPlayer(\"" + v11368.id + "\", this)'><span class='takeAction material-icons'>" + (v11368.id == focusedPlayerId ? "visibility_off" : "visibility") + "</span></span>" : "") + (currentHostId == v11368.id ? "<i class='material-icons' style='font-size:25px'>stars</i>" : "") + "<span class='pListPing material-icons' style='color:" + v11373 + "' title='" + (v11368.ping || 0) + "ms'>signal_cellular_alt</span><a target='_blank' class='" + (v11368.isHacker ? "red" : "") + "' href='/social.html?p=profile&q=" + v11368.name + "' oncontextmenu='copyUser(this, &quot;" + v11368.id + "&quot;)'>" + v11368.alias + (v11368.clan ? "<span style='color:" + COLORS.getClanCol(v11368.clan, "#353535") + "'> [" + v11368.clan + "]</span>" : "") + "</a>" + (voiceChatQueues[v11368.alias] ? "<span class='pListVoice material-icons'>volume_up</span>" : "") + "</td><td class='pListActions'>" + (Game && Game.mode && Game.mode.canTrade ? "<span onmouseenter='playTick()' title='Trade Player' class='punishButton' onclick='requestTrade(\"" + v11368.id + "\", this)'><span class='takeAction material-icons'>store</span></span>" : "") + (v11371 ? "<span title='Chat mute/unmute' onmouseenter='playTick()' class='muteUserBtn material-icons' onclick='muteUser(this, `" + v11368.id + "`, 0)'>" + (mutedChatAccountIds.includes(v11368.accid) ? "speaker_notes_off" : "chat") + "</span>" : "") + (v11372 ? "<span title='Voice mute/unmute' onmouseenter='playTick()' class='muteUserBtn material-icons' onclick='muteUser(this, `" + v11368.id + "`, 1)'>" + (mutedVoiceAccountIds.includes(v11368.accid) ? "voice_over_off" : "record_voice_over") + "</span>" : "") + (v11370 ? "<span onmouseenter='playTick()' class='punishButton kdf' onclick='confirmPolice(`" + v11368.alias + "`,`" + v11368.id + "`)'><img src='./img/police.png' style='height:25px;vertical-align:middle;margin-top:-6px'></span>" : "") + (v11369 ? "<span onmouseenter='playTick()' class='punishButton vote' onclick='kickVote(\"" + v11368.id + "\")'>Votekick</span>" : "") + (account && account.isDev ? "<span onmouseenter='playTick()' class='punishButton kill' onclick='punishPlayer(\"" + v11368.id + "\", 3)'>Kill</span>" : "") + (account && account.canTeleport ? "<span onmouseenter='playTick()' class='punishButton tp2' onclick='punishPlayer(\"" + v11368.id + "\", 4)'>TP2</span>" : "") + (account && account.canTeleport ? "<span onmouseenter='playTick()' class='punishButton tpme' onclick='punishPlayer(\"" + v11368.id + "\", 5)'>TPME</span>" : "") + (account && account.isDev ? "<span onmouseenter='playTick()' class='punishButton tpme' onclick='punishPlayer(\"" + v11368.id + "\", 6)'>FREEZE</span>" : "") + (isGameHost || account && (account.canGlobalKick || account.canSilentKick || account.canGlobalBan || account.canGlobalFlag) ? "<span onmouseenter='playTick()' class='punishButton kick' onclick='punishPopup(\"" + v11368.id + "\")'><span class='takeAction material-icons'>construction</span></span>" : "") + "</td></tr>";
        if (!this.playerSearch || this.searchMatches(v11368)) {
          vLStableClasspListTable += v11374;
        }
      }
    }
    vLStableClasspListTable += "</tbody></table>";
    return vLStableClasspListTable;
  },
  gen: function () {
    var v11375 = Game.players.list.length ? "<div id='playerSearchH' class='setHed'>" + i18n.t("windows.players.header") + " [" + Game.players.list.length + "]<div id='plySearchH'><input id='plySearch' type='text' " + (this.playerSearch ? "value='" + this.playerSearch + "' " : "") + "placeholder='Search Player' oninput='windows[22].searchPlayers(this)'></div></div>" : "<div style='margin-top:0px;' class='setHed'><center>" + i18n.t("windows.players.none") + "<center></div>";
    v11375 += "<div id='playerListH'>" + this.genList() + "</div>";
    return v11375;
  }
}, {
  header: i18n.t("windows.join.header"),
  label: "join_game",
  dark: true,
  gen: function () {
    return "<input id='gameURL' type='text' placeholder='" + i18n.t("windows.join.code") + "' class='accountInput' style='margin-top:0;margin-bottom:10px;' value=''></input><div class='joinBtn' onclick='joinGame()' style='width:100%'>" + i18n.t("windows.join.header") + "</div>";
  }
}, {
  header: i18n.t("windows.client.header"),
  label: "client_download",
  gen: function () {
    var v11376 = "<div class='setHed' style='text-align:center;margin-top:0px'>Download Krunker Client</div><div class='setBodH' style='padding-bottom:10px'>Clients provide a more integrated experience with better performance.</div><div><ul style='padding:0;display:flex;list-style:none;text-align:center;margin:0;margin-top:-10px'><li style='display: flex;flex-basis:200px;-webkit-box-flex:1;flex-grow:1;margin-right:10px'><a href='//client2.krunker.io/setup.exe' style='display:block;width:100%;padding-top:1em;'><img src ='./img/windows.png' style='width:80px;height:80px;display:block;margin:0 auto 10px;'>" + i18n.t("windows.client.windows") + "</a></li><li style='display: flex;flex-basis:200px;-webkit-box-flex:1;flex-grow:1;'><a href='//client2.krunker.io/setup.dmg' style='display: block;width: 100%;padding-top:1em;'><img src ='./img/mac.png' style='width:80px;height:80px;display:block;margin:0 auto 10px;'>" + i18n.t("windows.client.mac") + "</a></li><li style='display: flex;flex-basis:200px;-webkit-box-flex:1;flex-grow:1;'><a href='//client2.krunker.io/setup.AppImage' style='display: block;width: 100%;padding-top:1em;'><img src ='./img/linux.png' style='width:80px;height:80px;display:block;margin:0 auto 10px;'>" + i18n.t("windows.client.linux") + "</a></li></ul></div>";
    return v11376;
  }
}, {
  header: i18n.t("windows.melee.header"),
  label: "melee_selection",
  width: 877,
  height: "calc(100% - 300px)",
  sticky: true,
  dark: true,
  hideScroll: true,
  gen: function () {
    return f1828("selectMelee", 3);
  },
  close: () => cancelTip()
}, {
  header: i18n.t("windows.ranked.header"),
  label: "ranked",
  justCopied: null,
  tabIndex: 0,
  dark: true,
  popup: true,
  width: 1800,
  extraCls: "menuWindowF",
  maxH: "calc(100% - 325px)",
  yPos: 48,
  flagLinks: [UTILS.assetsUrl("/img/flags/flag_4.png"), UTILS.assetsUrl("/img/flags/flag_0.png"), UTILS.assetsUrl("/img/flags/flag_3.png"), UTILS.assetsUrl("/img/flags/flag_2.png"), UTILS.assetsUrl("/img/flags/flag_1.png"), UTILS.assetsUrl("/img/flags/flag_0.png"), UTILS.assetsUrl("/img/flags/flag_0.png"), UTILS.assetsUrl("/img/flags/flag_0.png"), UTILS.assetsUrl("/img/flags/flag_0.png"), UTILS.assetsUrl("/img/flags/flag_0.png")],
  switchTab: function (p13892, p13893) {
    if (this.tabIndex != p13892 || p13893) {
      this.tabIndex = p13892;
      updateWindow(27);
    }
  },
  gen: function () {
    var vLS73 = "";
    return vLS73;
  }
}, {
  header: "Partner Dashboard",
  label: "partner_dashboard",
  width: 1200,
  maxH: "calc(100% - 320px)",
  upPar: function () {
    var v11377 = document.getElementById("prtnrBtnHold");
    if (v11377) {
      v11377.innerHTML = "<div>Upgrade Request submitted</div>";
    }
    if (io) {
      io.send("pUbgr");
    }
  },
  data: [],
  tabIndex: 0,
  switchTab: function (p13894, p13895) {
    if (this.tabIndex != p13894 || p13895) {
      this.tabIndex = p13894;
      updateWindow(28);
    }
  },
  getData: function (p13896, p13897) {
    this.data[p13897] = p13896;
    updateWindow(28);
  },
  statIndex: -1,
  toggleStat: function (p13898) {
    var v11378 = this.data[1];
    if (v11378) {
      for (var vLN01836 = 0, v11379; vLN01836 < v11378.length; ++vLN01836) {
        v11379 = document.getElementById("gmpCanv" + vLN01836);
        if (v11379) {
          v11379.style.display = vLN01836 == p13898 ? "block" : "none";
        }
        v11379 = document.getElementById("gmtCanv" + vLN01836);
        if (v11379) {
          v11379.style.display = vLN01836 == p13898 ? "block" : "none";
        }
        v11379 = document.getElementById("gmpHedNav" + vLN01836);
        if (v11379) {
          v11379.innerHTML = vLN01836 == p13898 ? "expand_more" : "navigate_next";
        }
      }
      if (p13898 == this.statIndex) {
        v11379 = document.getElementById("gmpCanv" + p13898);
        if (v11379) {
          v11379.style.display = "none";
        }
        v11379 = document.getElementById("gmtCanv" + p13898);
        if (v11379) {
          v11379.style.display = "none";
        }
        v11379 = document.getElementById("gmpHedNav" + p13898);
        if (v11379) {
          v11379.innerHTML = "navigate_next";
        }
        this.statIndex = -1;
        return;
      }
      this.statIndex = p13898;
      var v11380 = (v11378[p13898].gpday || "").split(",");
      f1823(v11380, {
        tit: "Gameplays & Revenue",
        t1: "Gameplays",
        t2: "Earnings",
        col: "#85bb65",
        label: function (p13899, p13900) {
          if (p13899.datasetIndex == 0) {
            return " " + UTILS.commaNumber(p13899.value) + " Plays";
          }
          if (p13899.datasetIndex == 1) {
            var v11381 = ((p13899.value || 0) / 1000 * config.EPM).round(2);
            var v11382 = UTILS.commaFloat(v11381);
            return " " + v11382 + " USD ~";
          }
        }
      }, document.getElementById("gmpCanv" + p13898).getContext("2d"));
      f1823((v11378[p13898].tiday || "").split(","), {
        tit: "Time Played (h)",
        t1: "Hours",
        t2: "Avg Session",
        col: "#eb9a2a",
        label: function (p13901, p13902) {
          if (p13901.datasetIndex == 0) {
            return " " + UTILS.commaNumber(p13901.value) + " Hours";
          }
          if (p13901.datasetIndex == 1) {
            var v11383 = (p13901.value / (v11380[p13901.index] || 1)).round(1);
            return " " + v11383 + "h per Player";
          }
        }
      }, document.getElementById("gmtCanv" + p13898).getContext("2d"));
    }
  },
  post: function () {
    if (this.afterDat) {
      if (this.tabIndex == 0 && this.afterDat.length) {
        var v11387 = document.getElementById("prntGStatC");
        if (!v11387) {
          return;
        }
        v11387.style.display = "block";
        f1823(this.afterDat, {
          tit: "Total Revenue (last 30d)",
          t1: "Revenue",
          col: "#85bb65",
          label: function (p13903, p13904) {
            if (p13903.datasetIndex == 0) {
              var v11385 = p13903.value || 0;
              var v11386 = UTILS.commaFloat(v11385);
              return " " + v11386 + " USD ~";
            }
          }
        }, v11387.getContext("2d"));
      }
      if (this.tabIndex == 1 && this.afterDat.length) {
        var v11387 = document.getElementById("prntGStatC");
        if (!v11387) {
          return;
        }
        v11387.style.display = "block";
        f1823(this.afterDat, {
          tit: "Total Daily Summary (30d)",
          t1: "Gameplays",
          t2: "Earnings",
          col: "#85bb65",
          label: function (p13905, p13906) {
            if (p13905.datasetIndex == 0) {
              return " " + UTILS.commaNumber(p13905.value) + " Plays";
            }
            if (p13905.datasetIndex == 1) {
              var v11388 = ((p13905.value || 0) / 1000 * config.EPM).round(2);
              var v11389 = UTILS.commaFloat(v11388);
              return " " + v11389 + " USD ~";
            }
          }
        }, v11387.getContext("2d"));
      }
    }
  },
  gen: function () {
    if (!account || !account.partnerApp) {
      return "Error";
    }
    var vLSdivStyleheight15pxdi3 = "<div style='height:15px;'></div><div class='bigMenTabs'>";
    for (var vLN01849 = 0; vLN01849 < config.partnerTabs.length; ++vLN01849) {
      vLSdivStyleheight15pxdi3 += "<div class='bigMenTab" + (this.tabIndex == vLN01849 ? " bigMenTabA" : "") + "' onclick='playSelect(0.1);windows[27].switchTab(" + vLN01849 + ")' onmouseenter='playTick();' style='width:" + 100 / config.partnerTabs.length + "%;padding-top:10px;padding-bottom:5px;'>" + config.partnerTabs[vLN01849].n + "</div>";
    }
    vLSdivStyleheight15pxdi3 += "</div>";
    if (this.tabIndex == 0) {
      if (!this.data[0]) {
        io.send("crtD", 0);
        this.data[0] = {};
      }
      var v11401 = this.data[0];
      this.afterDat = [];
      for (var v11391 = (v11401.revenue || "").split(","), vLN01838 = 0, vLN01847 = 0; vLN01847 < v11391.length; ++vLN01847) {
        this.afterDat[vLN01847] = (this.afterDat[vLN01847] || 0) + parseFloat(v11391[vLN01847] || 0);
        vLN01838 = this.afterDat[vLN01847];
      }
      var v11392 = UTILS.convCoNum(v11401.rmc || "0") + UTILS.convCoNum(v11401.tm || "0") + UTILS.convCoNum(v11401.sm || "0");
      vLSdivStyleheight15pxdi3 += "<div class='setBodH' style='padding-top:10px;padding-bottom:10px;margin-bottom:25px;'><div class='settName'>Partner Level <span style='float:right;color:#ffffff99;'>" + account.partnerApp + "</span></div><div class='settName'>Revenue Today <span style='float:right;color:#ffffff99;'>" + (vLN01838 ? "~ " + UTILS.commaNumber(vLN01838) + " <span style='color:#fff'>USD</span>" : "-") + "</span></div><canvas id='prntGStatC'  style='width:100%;height:420px;margin-top:20px;background-color:rgba(0,0,0,0.4);margin-bottom:10px;display:none;'></canvas></div>";
      if (account.partnerApp < 2) {
        var v11393 = (v11401.smc || 0) + (v11401.slmc || 0);
        var v11394 = UTILS.commaNumber(config.partnerPReq);
        var v11395 = v11393 >= config.partnerPReq;
        vLSdivStyleheight15pxdi3 += "<div class='partnerStatHead'>Upgrade Partner Status</div><div>By upgrading your Partner status, you can start to earn Revenue from your Maps/Games.</div><div style='height:10px;'></div><div id='partnerPrTx'>" + v11393 + "/" + v11394 + "</div><div id='partnerProg'><div id='partnerProgB'  style='width:" + Math.min(100, v11393 / config.partnerPReq * 100) + "%'></div></div><div style='font-size:16px;opacity:0.8'>" + v11394 + " Gameplays (last 2 Months) required to Upgrade to Level 2</div><div id='prtnrBtnHold'><div" + (v11395 ? " id='partnrUpBtn' onclick='windows[27].upPar()'" : " id='partnrUpBtnD'") + ">" + (v11395 ? "Upgrade to Lvl 2" : "More plays required") + "</div></div><div style='height:15px'></div>";
      }
      var v11396 = "krunker.io/?ref=" + account.partnerName;
      vLSdivStyleheight15pxdi3 += "<div class='setHed' style='margin-top:10px;padding-bottom:10px;'  onclick='copyToClip(`" + v11396 + "`)'>Send this Link to Friends & Viewers: <a style='float:right'>" + v11396 + "</a></div><div class='setBodH' style='padding-top:15px;padding-bottom:15px'>Once you've invited someone to play Krunker, you earn revenue every time they play. </div><div class='setBodH' style='padding-top:10px;padding-bottom:10px'><div class='settName'>Sign-ups Total <span style='color:rgba(255,255,255,0.4);float:right'>" + UTILS.commaFormatNum(v11401.suma || 0, "-") + " <span style='color:#fff'>players</span></span></div><div class='settName'>Sign-ups this Month <span style='color:rgba(255,255,255,0.4);float:right'>" + UTILS.commaFormatNum(v11401.sum || 0, "-") + " <span style='color:#fff'>players</span></span></div><div class='settName'>Playtime this Month <span style='color:rgba(255,255,255,0.4);float:right'>" + UTILS.getReadableTime(v11401.rm || 0, null, "-") + "</span></div><div class='settName'>Playtime last Month <span style='color:rgba(255,255,255,0.4);float:right'>" + UTILS.getReadableTime(v11401.rlm || 0, null, "-") + "</span></div><div class='settName'>Rate Per Hour <span style='color:rgba(255,255,255,0.4);float:right'>" + (v11401.rst || "-") + " <span style='color:#fff'>USD</span></span></div><div class='settName'>Revenue this Month <span style='color:rgba(255,255,255,0.4);float:right'><span class='material-icons' style='color:#46b84d;font-size:40px;vertical-align:middle;margin-right: 10px;margin-top:-5px;'>trending_up</span>" + (v11401.rmc || "-") + " <span style='color:#fff'>USD</span></span></div><div class='settName'>Revenue last Month <span style='color:rgba(255,255,255,0.4);float:right'>" + (v11401.rlmc || "-") + " <span style='color:#fff'>USD</span></span></div></div>";
      if (account.partnerApp >= 2) {
        var vLSdivStylewidth100 = "<div style='width:100%;'>";
        var vLN01840 = 0;
        var vLN01841 = 0;
        var v11397 = parseInt(v11401.smc) || 0;
        var v11398 = null;
        for (var vLN01849 = 0; vLN01849 < config.gamePlBonus.length; ++vLN01849) {
          vLN01840 += config.gamePlBonus[vLN01849].val;
        }
        for (var vLN01849 = 0; vLN01849 < config.gamePlBonus.length; ++vLN01849) {
          var v11399 = config.gamePlBonus[vLN01849];
          var v11400 = config.gamePlBonus[vLN01849 - 1];
          var vV11397 = v11397;
          if (v11397 - v11399.val < 0) {
            if (v11398) {
              vV11397 = 0;
            } else {
              v11398 = config.gamePlBonus[vLN01849];
            }
          }
          vLSdivStylewidth100 += "<div style='width:" + v11399.val / vLN01840 * 100 + "%;display:inline-block;text-align:left;vertical-align:top;'><div class='gameplBonB'" + (vV11397 / v11399.val >= 1 ? "style='border-color:#46b84d'" : "") + "><div class='gameplBonBP' style='width:" + Math.min(1, vV11397 / v11399.val) * 100 + "%'></div></div>" + (v11400 ? "<div class='bonBAmnt'><span style='color:#fff;'>+</span>$" + v11400.bon + "</div>" : "") + (vLN01849 == config.gamePlBonus.length - 1 ? "<div class='bonBAmnt' style='float:right;'><span style='color:#fff;'>+</span>$" + v11399.bon + "</div>" : "") + "</div>";
          if (v11397 / v11399.val >= 1) {
            vLN01841 += v11399.bon;
          }
        }
        vLSdivStylewidth100 += "</div>";
        v11392 += vLN01841;
        vLSdivStylewidth100 = "<div class='setBodH' style='padding-top:10px;padding-bottom:10px'><div style='margin-top:10px;margin-bottom:10px;'>" + (v11398 ? "Next bonus <span style='color:white;'>@" + UTILS.commaFormatNum(v11398.val) + "</span> plays:<span style='float:right;color:rgba(255,255,255,0.4)'>" + UTILS.commaFormatNum(v11398.bon) + "<span style='color:#fff;'> USD</span></span>" : "Max bonus reached") + "</div>" + vLSdivStylewidth100 + "</div>";
        vLSdivStyleheight15pxdi3 += "<div class='setHed' style='padding-bottom:10px;'>Partner Code<span style='float:right;color:#fff'>" + account.partnerName + "</span></div><div class='setBodH' style='padding-top:10px;padding-bottom:10px'><div class='settName'>Sales this Month <span style='color:rgba(255,255,255,0.4);float:right'>" + (v11401.am || "-") + "<span style='color:#fff'> sales</span></span></div><div class='settName'>Revenue this Month <span style='color:rgba(255,255,255,0.4);float:right'><span class='material-icons' style='color:#46b84d;font-size:40px;vertical-align:middle;margin-right: 10px;margin-top:-5px;'>trending_up</span>" + (v11401.tm || "-") + " <span style='color:#fff'>USD</span></span></div><div class='settName'>Revenue last Month <span style='color:rgba(255,255,255,0.4);float:right'>" + (v11401.lm || "-") + " <span style='color:#fff'>USD</span></span></div></div><div class='setHed' style='padding-bottom:10px;'>Sales Revenue</div><div class='setBodH' style='padding-top:10px;padding-bottom:10px'>Coming soon</div><div class='setHed' style='padding-bottom:10px;'>Gameplay Revenue</div>" + vLSdivStylewidth100 + "<div class='setBodH' style='padding-top:10px;padding-bottom:10px'><div class='settName' style='color:#fff !important;margin-bottom:10px'>Minimum 10'000 Gameplays (Last 30d) required to earn revenue</div><div class='settName'>Gameplays this Month <span style='color:rgba(255,255,255,0.4);float:right'>" + UTILS.commaFormatNum(v11401.smc || 0, "-") + "<span style='color:#fff'> plays</span></span></div><div class='settName'>Gameplays last Month <span style='color:rgba(255,255,255,0.4);float:right'>" + UTILS.commaFormatNum(v11401.slmc || 0, "-") + "<span style='color:#fff'> plays</span></span></div><div class='settName'>RPM ($ per 1000 gamplays)<span style='color:rgba(255,255,255,0.4);float:right'>~0.80 <span style='color:#fff'>USD</span></span></div><div class='settName'>Revenue this Month <span style='color:rgba(255,255,255,0.4);float:right'><span class='material-icons' style='color:#46b84d;font-size:40px;vertical-align:middle;margin-right: 10px;margin-top:-5px;'>trending_up</span>" + (v11401.sm || "-") + " <span style='color:#fff'>USD</span></span></div><div class='settName'>Gameplay bonus this Month <span style='color:rgba(255,255,255,0.4);float:right'><span class='material-icons' style='color:#46b84d;font-size:40px;vertical-align:middle;margin-right: 10px;margin-top:-5px;'>trending_up</span>" + UTILS.commaFormatNum(vLN01841.toFixed(2), "-") + " <span style='color:#fff'>USD</span></span></div><div class='settName'>Revenue last Month <span style='color:rgba(255,255,255,0.4);float:right'>" + (v11401.slm || "-") + " <span style='color:#fff'>USD</span></span></div></div><div class='setHed' style='padding-bottom:10px;'>Ad Revenue</div><div class='setBodH' style='padding-top:10px;padding-bottom:10px'><div class='settName' style='color:#fff !important;margin-bottom:10px'>Minimum 5,000 impressions (Last 30d) required to earn revenue</div><div class='settName'>Video impressions this month<span style='color:rgba(255,255,255,0.4);float:right'>" + UTILS.commaFormatNum(v11401.aim || 0, "-") + "<span style='color:#fff'> ad plays</span></span></div><div class='settName'>RPM ($ per 1000 impressions)<span style='color:rgba(255,255,255,0.4);float:right'>~1.80 <span style='color:#fff'>USD</span></span></div><div class='settName'>Revenue this Month <span style='color:rgba(255,255,255,0.4);float:right'><span class='material-icons' style='color:#46b84d;font-size:40px;vertical-align:middle;margin-right: 10px;margin-top:-5px;'>trending_up</span>" + UTILS.commaFormatNum(v11401.arm || 0, "-") + " <span style='color:#fff'>USD</span></span></div></div>";
      } else {
        vLSdivStyleheight15pxdi3 += "<div style='background-color:rgba(0,0,0,0.15);padding:10px;font-size:17px;padding-left:15px;padding-bottom:20px'>Once you reach enough referrals you will be considered for Level 2 Partner status with the following benefits:<div style='margin-top:10px;opacity:0.7'>- Creator Code (Rev share from KR Sales)</div><div style='margin-top:10px;opacity:0.7'>- Game Earnings (Rev Share on your Maps)</div></div><div style='height:25px'></div>";
      }
      v11392 = v11392.round(2);
      v11392 = UTILS.commaFormatNum(v11392);
      vLSdivStyleheight15pxdi3 += "<div class='setBodH' style='padding-top:10px;padding-bottom:15px;margin-top:40px;'><div class='settName'>Total this Month<span style='float:right;color:rgba(255,255,255,0.4)'><span class='material-icons' style='color:#46b84d;font-size:40px;vertical-align:middle;margin-right: 10px;margin-top:-5px;'>trending_up</span>" + v11392 + " <span style='color:#fff'>USD</span></span></div><div style='color:rgba(255,255,255,0.5);margin-top:10px;font-size:18px;'>Paid to <a>" + (v11401.poc ? UTILS.maskEmail(v11401.poc) : "-") + "</a>. Payouts happen on a monthly basis. The values shown are estimates only. If you experience issues or delayed payouts, please contact: <a href='mailto:invoices@frvr.com?subject=UGC Payment'>invoices@frvr.com</a></div></div>";
    } else if (this.tabIndex == 1) {
      if (!this.data[1]) {
        io.send("crtD", 1);
        this.data[1] = [];
      }
      this.statIndex = -1;
      var v11401 = this.data[1];
      var vLN01844 = 0;
      var vLN01845 = 0;
      var vLS74 = "";
      this.afterDat = [];
      for (var vLN01849 = 0, v11402; vLN01849 < v11401.length; ++vLN01849) {
        v11402 = (v11401[vLN01849].gpday || "").split(",");
        for (var vLN01847 = 0; vLN01847 < v11402.length; ++vLN01847) {
          this.afterDat[vLN01847] = (this.afterDat[vLN01847] || 0) + parseInt(v11402[vLN01847] || 0);
        }
        vLN01844 += v11401[vLN01849].gpall || 0;
        vLN01845 += v11401[vLN01849].gptday || 0;
        var v11403 = "<canvas id='gmpCanv" + vLN01849 + "'  style='width:100%;height:420px;margin-top:20px;background-color:rgba(0,0,0,0.4);display:none'></canvas><canvas id='gmtCanv" + vLN01849 + "'  style='width:100%;height:420px;margin-top:20px;background-color:rgba(0,0,0,0.4);display:none;margin-bottom:25px;'></canvas>";
        vLS74 += "<div class='setHed' style='margin-top:15px;' onclick='windows[27].toggleStat(" + vLN01849 + ")'><span id='gmpHedNav" + vLN01849 + "' class='material-icons plusOrMinus'>navigate_next</span>" + v11401[vLN01849].mn + "<span style='float:right;color:rgba(255,255,255,0.6)'>" + UTILS.commaNumber(v11401[vLN01849].gpall || 0) + " <span style='color:#fff'>Plays</span></span></div>" + v11403;
      }
      vLSdivStyleheight15pxdi3 += "<div class='setBodH' style='padding-top:10px;padding-bottom:10px;margin-bottom:25px;'><div class='settName'>Games Published <span style='float:right;color:#ffffff99;'>" + (v11401.length || "-") + "<span style='color:#fff'> releases</span></span></div><div class='settName'>Total Plays <span style='float:right;color:#ffffff99;'>" + (vLN01844 ? UTILS.commaNumber(vLN01844) : "-") + "<span style='color:#fff'> plays</span></span></div><div class='settName'>Revenue Total <span style='float:right;color:#ffffff99;'>" + (vLN01844 ? "~ " + UTILS.commaNumber((vLN01844 / 1000 * config.EPM).round(2)) + " <span style='color:#fff'>USD</span>" : "-") + "</span></div><div class='settName'>Plays Today <span style='float:right;color:#ffffff99;'>" + (vLN01845 ? UTILS.commaNumber(vLN01845) : "-") + "<span style='color:#fff'> plays</span></span></div><div class='settName'>Revenue Last 24h <span style='float:right;color:#ffffff99;'>" + (vLN01845 ? "~ " + UTILS.commaNumber((vLN01845 / 1000 * config.EPM).round(2)) + " <span style='color:#fff'>USD</span>" : "-") + "</span></div><canvas id='prntGStatC'  style='width:100%;height:420px;margin-top:20px;background-color:rgba(0,0,0,0.4);margin-bottom:10px;display:none;'></canvas></div>" + vLS74;
    } else if (this.tabIndex == 2) {
      if (!this.data[2]) {
        io.send("crtD", 2);
        this.data[2] = [];
      }
      if (this.data[2].length) {
        var vLS75 = "";
        var vLN01848 = 0;
        for (var vLN01849 = 0; vLN01849 < this.data[2].length; ++vLN01849) {
          vLS75 += "<div class='settName'><a href='./p/" + this.data[2][vLN01849].buyername + "'>" + this.data[2][vLN01849].buyername + "</a><span style='float:right;color:rgba(255,255,255,0.6)'>" + UTILS.getDate(this.data[2][vLN01849].purchasedate) + " - <span style='color:#fff;'>" + this.data[2][vLN01849].amount + " USD</span></span></div>";
          vLN01848 += parseFloat(this.data[2][vLN01849].amount) || 0;
        }
        vLSdivStyleheight15pxdi3 += "<div class='setBodH' style='padding-top:10px;padding-bottom:10px;margin-bottom:25px;'><div class='settName'>Sales last 90d<span style='float:right;'>" + this.data[2].length + "</span></div></div>";
        +"<div class='settName'>Gross rev 90d<span style='float:right;'>" + vLN01848 + " USD</span></div></div>";
        vLSdivStyleheight15pxdi3 += "<div class='setBodH' style='padding-top:10px;padding-bottom:10px;margin-bottom:25px;'>" + vLS75 + "</div>";
      } else {
        vLSdivStyleheight15pxdi3 += "<div style='color:#fff;text-align:center;'>Loading...</div>";
      }
    }
    return vLSdivStyleheight15pxdi3;
  }
}, {
  header: i18n.t("windows.support.header"),
  label: "unused",
  gen: function () {
    return "";
  }
}, {
  header: i18n.t("windows.mail.header"),
  label: "mail",
  mailData: null,
  width: 1000,
  count: 0,
  mailCount: function (p13907) {
    this.count = p13907;
    if (p13907 > 99) {
      p13907 = "99";
    }
    if (p13907 < 0) {
      p13907 = 0;
    }
    mailCount.innerHTML = p13907;
    mailCount.style.display = p13907 ? "inline-block" : "none";
  },
  onData: function (p13908, p13909) {
    this.tabIndex = p13908;
    if (p13909) {
      p13909.forEach(p13910 => {
        if (p13910.km_notificationtype == 4 && p13910.km_link && p13910.km_subject.includes("Creator code")) {
          p13910.km_notificationtype = 5;
        }
        if (p13910.km_notificationtype == null && p13910.km_subject == "Item sold") {
          p13910.km_notificationtype = 4;
        }
      });
      this.mailData = {
        d: p13909
      };
    } else {
      this.mailData = null;
    }
    updateWindow(30);
  },
  onReadData: function (p13911, p13912) {
    if (p13911) {
      p13911 = p13911[0];
      var v11406 = document.getElementById("mail_" + p13911.km_id);
      if (v11406 && (v11406.style.border = "", v11406.classList.remove("mailUnread"), p13912 != 0)) {
        var v11405 = p13911.km_text.replace(/<|>/g, "").replace("&", "").replace(/[^\x00-\x7F]/g, "");
        if (p13911.km_type == 5) {
          v11405 = v11405.replace("Post!", "<a target='_blank' href='./social.html?p=post&q=" + p13911.km_link + "'>Post</a>");
        }
        if (v11406.children[3]) {
          v11406.children[3].innerHTML = v11405.length ? v11405 : "No message provided";
        }
      }
      this.mailCount(this.count - 1);
    } else if (p13912 != 0 && p13912 != 5) {
      var v11406 = document.getElementById("mail_" + p13911.km_id);
      if (v11406) {
        v11406.children[3].innerHTML = "Failed to load mail";
      }
    }
  },
  readMail: function (p13913, p13914, p13915) {
    if (p13915 != 0 && p13915 != 5) {
      p13913.children[3].style.display = "block";
      p13913.children[3].innerHTML = "Loading...";
    }
    io.send("rml", p13914, p13915);
  },
  clickFollow: function (p13916, p13917, p13918) {
    this.readMail(p13916, p13917, p13918);
    window.open("/social.html?p=profile&q=" + p13916.innerText, "_blank");
  },
  readAll: function () {
    io.send("raml");
    this.switchTab(config.mailTabs.length - 1);
    this.mailCount(0);
  },
  tabIndex: 0,
  listData: {},
  switchTab: function (p13919, p13920) {
    if (this.tabIndex != p13919 || p13920) {
      this.tabIndex = p13919;
      this.mailData = null;
      updateWindow(30);
    }
  },
  gen: function () {
    var vO358 = {};
    if (this.mailData && this.mailData.d) {
      for (var v11414 = this.mailData.d.filter(p13921 => !p13921.km_archive), vLN01854 = 0, v11408; vLN01854 < v11414.length; ++vLN01854) {
        v11408 = v11414[vLN01854].km_notificationtype;
        if (v11408 == 4 || v11408 == 5) {
          v11408 = 3;
        }
        if (v11408 != null) {
          vO358[v11408] = (vO358[v11408] || 0) + 1;
        }
      }
    }
    var vLSdivClassbigMenTabsSt3 = "<div class='bigMenTabs' style='table-layout: fixed;'>";
    +"<div style='height:20px;'></div>";
    for (var vLN01854 = 0; vLN01854 < config.mailTabs.length; ++vLN01854) {
      vLSdivClassbigMenTabsSt3 += "<div class='bigMenTab" + (this.tabIndex == vLN01854 ? " bigMenTabA" : "") + "' onclick='windows[29].switchTab(" + vLN01854 + ")' style='height:30px;'>" + config.mailTabs[vLN01854].n + (vO358[vLN01854] ? "<div class='unreadBtnM'>" + vO358[vLN01854] + "</div>" : "") + "</div>";
    }
    vLSdivClassbigMenTabsSt3 += "</div>";
    vLSdivClassbigMenTabsSt3 += "<div id='mailList'>";
    if (this.tabIndex == 4) {
      if (!this.mailData) {
        this.mailData = null;
        io.send("kml", 1, this.tabIndex);
        vLSdivClassbigMenTabsSt3 += "Loading...";
      } else if (this.mailData.d) {
        for (var v11409 = this.mailData.d.filter(p13922 => p13922.km_archive), vLN01854 = 0; vLN01854 < v11409.length; ++vLN01854) {
          player = v11409[vLN01854];
          var v11415 = player.km_notificationtype;
          if (player.km_link || v11415 != 0) {
            vLSdivClassbigMenTabsSt3 += "<div class='mailObj' id='mail_" + player.km_id + "' onclick='windows[29].readMail(this, " + player.km_id + ", " + v11415 + ")'>";
            var v11416 = "<div style='position:relative;'><div class='mailDate'>" + UTILS.getReadableTime2(new Date().getTime() - new Date(player.km_datesent).getTime());
            if (v11415 == 0) {
              var v11417 = player.km_link.replace(/<|>/g, "").replace("&", "").replace(/[^\x00-\x7F]/g, "");
              v11416 += "<div class='followBack' onclick='followPlayer(&quot;" + v11417 + "&quot;, this)'>Follow Back</div></div></div>";
              vLSdivClassbigMenTabsSt3 += v11416 + "<div class='followFrom'><a onclick='windows[29].clickFollow(this, " + player.km_id + ", " + v11415 + ")'>" + v11417 + "</a> has followed you!</div></div>";
            } else if (v11415 == 5) {
              var v11418 = player.km_link.replace(/<|>/g, "").replace("&", "").replace(/[^\x00-\x7F]/g, "");
              v11416 += "</div></div>";
              vLSdivClassbigMenTabsSt3 += v11416 + "<div class='followFrom'><a onclick='windows[29].clickFollow(this, " + player.km_id + ", " + v11415 + ")'>" + v11418 + "</a> used your creator code!</div></div>";
            } else {
              v11416 += "</div></div>";
              vLSdivClassbigMenTabsSt3 += v11416 + "<div class='mailFrom' style='margin-bottom:15px'>" + player.km_playerfrom + "</div><span class='mailSubj'>" + player.km_subject + "</span><div class='mailText'></div></div>";
            }
          }
        }
        if (!v11409.length) {
          vLSdivClassbigMenTabsSt3 += "No archive messages";
        }
        this.mailData = null;
      } else {
        vLSdivClassbigMenTabsSt3 += "Loading...";
      }
    } else if (!this.mailData) {
      this.mailData = null;
      io.send("kml", 0, this.tabIndex);
      vLSdivClassbigMenTabsSt3 += "Loading...";
    } else if (this.mailData.d) {
      for (var v11414 = this.mailData.d.filter(p13923 => !p13923.km_archive), vLN01853 = 0, vLN01854 = 0; vLN01854 < v11414.length; ++vLN01854) {
        player = v11414[vLN01854];
        var v11415 = player.km_notificationtype;
        if ((player.km_link || v11415 != 0) && (v11415 == this.tabIndex || (v11415 == 4 || v11415 == 5) && this.tabIndex == 3)) {
          vLN01853++;
          vLSdivClassbigMenTabsSt3 += "<div class='mailObj mailUnread' id='mail_" + player.km_id + "' onclick='windows[29].readMail(this, " + player.km_id + ", " + v11415 + ")' style='border: 2px solid #5699eb;'>";
          var v11416 = "<div style='position:relative;'><div class='mailDate'>" + UTILS.getReadableTime2(new Date().getTime() - new Date(player.km_datesent).getTime());
          if (v11415 == 0) {
            var v11417 = player.km_link.replace(/<|>/g, "").replace("&", "").replace(/[^\x00-\x7F]/g, "");
            v11416 += "<div class='followBack' onclick='followPlayer(&quot;" + v11417 + "&quot;, this)'>Follow Back</div></div></div>";
            vLSdivClassbigMenTabsSt3 += v11416 + "<div class='followFrom'><a onclick='windows[29].clickFollow(this, " + player.km_id + ", " + v11415 + ")'>" + v11417 + "</a> has followed you!</div></div>";
          } else if (v11415 == 5) {
            var v11418 = player.km_link.replace(/<|>/g, "").replace("&", "").replace(/[^\x00-\x7F]/g, "");
            v11416 += "</div></div>";
            vLSdivClassbigMenTabsSt3 += v11416 + "<div class='followFrom'><a onclick='windows[29].clickFollow(this, " + player.km_id + ", " + v11415 + ")'>" + v11418 + "</a> used your creator code!</div></div>";
          } else {
            v11416 += "</div></div>";
            vLSdivClassbigMenTabsSt3 += v11416 + "<div class='mailFrom' style='margin-bottom:15px'>" + player.km_playerfrom + "</div><span class='mailSubj'>" + player.km_subject + "</span><div class='mailText'></div></div>";
          }
        }
      }
      if (!vLN01853 || !v11414.length) {
        vLSdivClassbigMenTabsSt3 += "No messages";
      }
      this.mailData = null;
    } else {
      vLSdivClassbigMenTabsSt3 += "Loading...";
    }
    vLSdivClassbigMenTabsSt3 += "</div>";
    return "<div>Your Notifications" + (this.tabIndex == config.mailTabs.length - 1 ? "" : "<div class='button buttonR readAll' onclick='windows[29].readAll()'>Read All</div>") + "</div><div style='height:30px;'></div>" + vLSdivClassbigMenTabsSt3;
  }
}, {
  header: i18n.t("windows.attach.header"),
  label: "attachment_selection",
  dark: true,
  gen: function () {
    var v11419 = "<div id='skinList'><div class='noBtnCard blackShad' style='height:150px;border:5px solid lightgrey' onclick='selectAttachment(-1)'>" + i18n.t("generic.none") + "<div class='skinRandom blackShad' style='top: 60px;'>X</div></div>";
    var v11420 = Game.weaponConfig[Game.classConfig[classIndex].loadout[0]].attach != null || Game.store.skins[skinsLoadout[Game.classConfig[classIndex].loadout[0]]] && Game.store.skins[skinsLoadout[Game.classConfig[classIndex].loadout[0]]].attachBypass;
    var v11421 = Game.attach.sort((p13924, p13925) => (p13924.minRec == null ? 0 : p13924.minRec) - (p13925.minRec == null ? 0 : p13925.minRec));
    if (v11420) {
      for (var vLN01855 = 0; vLN01855 < v11421.length; ++vLN01855) {
        player = v11421[vLN01855];
        if (player) {
          var v11422 = account && account.stats && account.stats["c" + classIndex] ? account.stats["c" + classIndex] : 0;
          var v11423 = Math.max(1, Math.floor(config.rankVar * Math.sqrt(v11422)) + 1);
          var v11424 = Game.isCustom || !player.req || player.req(account, classIndex) || Game.isSandbox;
          v11419 += "<div class='noBtnCard blackShad' style='height:150px;border:5px solid lightgrey'" + (v11424 ? " onclick='selectAttachment(" + player.id + ")'" : "") + ">" + player.name + "<div class='itemOwn'>" + (player.minRec ? i18n.t("windows.secondary." + (v11424 ? "unlocked" : "req"), player.minRec) : i18n.t("generic.default")) + "</div><img loading='lazy' draggable='false' class='noBtnImgA' src='" + UTILS.assetsUrl("/textures/previews/attach/attach_" + player.id + ".png") + "' />" + (v11424 ? "" : "<div class='lockedCard'><span class='material-icons' style='font-size: 70px;color:#fff;'>lock</span></div>") + "</div>";
        }
      }
    }
    v11419 += "</div>";
    return v11419;
  }
}, {
  header: i18n.t("windows.reticle.header"),
  label: "reticle_selection",
  dark: true,
  width: 900,
  gen: function () {
    var v11425 = "<div>" + f1797("reticleWidth") + f1797("reticleHeight") + "</div>";
    v11425 += "<div id='skinList' style='margin-top:18px;'><div class='noBtnCard blackShad' style='height:140px;border:5px solid lightgrey' onclick='selectReticle(-1)' onmouseenter='playTick()'>None<div class='skinRandom blackShad' style='top: 60px;' onmouseenter='playTick()'>X</div></div>";
    var v11426 = Game.weaponConfig[Game.classConfig[classIndex].loadout[0]].attach != null || Game.store.skins[skinsLoadout[Game.classConfig[classIndex].loadout[0]]] && Game.store.skins[skinsLoadout[Game.classConfig[classIndex].loadout[0]]].attachBypass;
    if (v11426) {
      v11425 += "<div class='noBtnCard blackShad' style='height:140px;border:5px solid lightgrey'><div style='color: #fff;margin-top: 33px;' onclick='window.windows[31].newPop()' onmouseenter='playTick()'>ADD<br>CUSTOM</div></div>";
      for (var vLN01857 = 0; vLN01857 < customReticles.length; ++vLN01857) {
        player = customReticles[vLN01857];
        if (player) {
          var v11427 = player[0].replace(/[^a-zA-Z0-9 _-]+/gim, "");
          var vF17413 = sanitizeCustomImageUrl(player[1]);
          v11425 += "<div class='noBtnCard blackShad' style='height:140px;border:5px solid #fc5a4e' onclick='selectReticle(-2, &quot;" + vF17413 + "&quot;)'>" + (v11427 || "Custom") + "<div class='itemOwn' style='margin-top:1px'>Custom</div><img loading='lazy' class='noBtnImgR' draggable='false' src='" + (vF17413 || "") + "' onmouseenter='playTick()' /><div class='selctDelBtn' onmouseenter='playTick()'onclick='removeReticle(" + vLN01857 + ")'>X</div></div>";
        }
      }
      for (var vLN01857 = 0; vLN01857 < reticles.length; ++vLN01857) {
        player = reticles[vLN01857];
        if (player) {
          v11425 += "<div class='noBtnCard blackShad' style='height:140px;border:5px solid lightgrey' onclick='selectReticle(" + vLN01857 + ")'>" + player.name + "<div class='itemOwn' style='margin-top:1px'>" + i18n.t("generic.default") + "</div><img loading='lazy' class='noBtnImgR' draggable='false' src='" + UTILS.assetsUrl("/textures/reticles/reticle_" + player.id + "." + (player.type || "png")) + "' onmouseenter='playTick()' /></div>";
        }
      }
    }
    v11425 += "</div>";
    return v11425;
  },
  newPop: function () {
    var vLSdivClasspubHedNewIma = "<div class='pubHed'>New Image</div><div style='font-size:20px;color:#fff'><div style='margin-top: 3px;font-size: 22px;color: rgba(255, 255, 255, 0.7);'>Name:<input type='text' id='newCustomName' class='inputGrey2' placeholder='Name'></div><div style='margin-top: 3px;font-size: 22px;color: rgba(255, 255, 255, 0.7);'>Image:<input type='url' id='newCustomImg' class='inputGrey2' placeholder='Image URL'></div><div class='mapFndB' onclick='window.windows[31].addNew()' onmouseover='playTick(0.1)' style='background-color:#fc5a4e;width: 380px;margin-top: 10px;'>Add</div></div>";
    genericPopup(vLSdivClasspubHedNewIma, "imageNewPop");
  },
  addNew: function () {
    var v11428 = document.getElementById("newCustomImg");
    var v11429 = document.getElementById("newCustomName");
    if (v11429 && v11428 && v11428.value && v11429.value) {
      var v11430 = v11429.value.replace(/[^a-zA-Z0-9 _-]+/gim, "");
      if (!v11430.length) {
        return io_showPopup(null, "Invalid Name");
      }
      var vF17414 = sanitizeCustomImageUrl(v11428.value);
      if (!vF17414) {
        return io_showPopup(null, "Invalid Image");
      }
      customReticles.push([v11430, vF17414]);
      setCustomRets(customReticles, true);
      clearPops();
      updateWindow(32);
    } else {
      return io_showPopup(null, "Something Went Wrong");
    }
  }
}, {
  header: i18n.t("windows.chall.header"),
  label: "challenges",
  dark: true,
  width: 1200,
  tabIndex: 0,
  genChallengeCard: function (p13926, p13927) {
    var v11431 = p13926.DAT;
    var vLSdiv2 = "<div>";
    var v11432 = (p13926.REW && p13926.REW.sk ? p13926.REW.sk : null) || [];
    if (!Array.isArray(v11432)) {
      v11432 = (v11432 + "").split(",");
    }
    for (var vLN01858 = 0; vLN01858 < 3; ++vLN01858) {
      var v11433 = Game.store.skins[v11432[2 - vLN01858]];
      var v11434 = null;
      var v11435 = null;
      var v11436 = null;
      if (v11433) {
        v11434 = v11433.thumbnail;
        v11435 = Game.store.rarities[v11433.rarity].color;
        v11436 = v11432[2 - vLN01858];
      }
      vLSdiv2 += "<div class='chalRewSkn' style='" + (v11434 ? "background-image:url(" + v11434 + ");" : "") + (v11435 ? "border:2px solid " + v11435 + ";" : "") + "' " + (v11436 ? "onclick='viewItem(" + v11436 + ")'" : "") + "></div>";
    }
    vLSdiv2 += "</div>";
    var v11437 = !!p13926.PT;
    return "<div class='chalCard' style='margin-top:" + (p13927 || 0) + "px;" + (v11431.boss ? "box-shadow: 0 0 14px #ffa000;background:rgb(79 50 0 / 40%);border:4px solid #ff9c00;" : "") + "'><img class='chalImgC' src='" + UTILS.assetsUrl("img/chals/icon_" + (p13926.IC || 0) + ".png") + "'  style='" + (v11431.boss ? "border: 4px solid #ff9c00;" : "") + (v11437 ? "filter:grayscale(1);brightness(0.8);" : "") + "' />" + (v11437 ? "<div class='challComplB'><span class='material-icons' style='font-size:110px;color:#38cd3a;'>done</span></div>" : "") + "<div class='chalRight'>" + p13926.N + (p13926.TR ? "<div class='chalExpr'>" + UTILS.getReadableTime(p13926.TR || 0) + " left</div>" : "") + "<div class='chalXPBar'><div class='chalXPVal'>" + (v11437 ? "Completed" : p13926.DAT.ky == "time" ? UTILS.getReadableTime(v11431.val) : (p13926.PV || 0) + "/" + v11431.val) + "</div><div class='chalXPBarC' style='width:" + (v11437 ? 100 : p13926.DAT.ky == "time" ? 0 : (p13926.PV || 0) / v11431.val * 100) + "%;'></div></div></div><div class='chalRews' style='" + (v11431.boss ? "border-left: 3px solid #ff9c00;" : "") + "'><div class='chalRewV' style='" + (p13926.REW && p13926.REW.kr ? "" : "filter:grayscale(1);") + "'><span style='color:white'>+</span>" + (p13926.REW ? p13926.REW.kr || 0 : 0) + " <span style='color:#fbc02d'>KR</span></div><div class='chalRewV' style='" + (p13926.REW && p13926.REW.jnk ? "" : "filter:grayscale(1);") + "'><span style='color:white'>+</span>" + (p13926.REW ? p13926.REW.jnk || 0 : 0) + " <span class='material-icons' style='color:#cc51f8;font-size:29px;vertical-align:top;'>plumbing</span></div>" + vLSdiv2 + "</div></div>";
  },
  openChallenge: null,
  closeChallengeCat: function () {
    playSelect(0.1);
    windows[32].openChallenge = null;
    menuWindow.scrollTop = 0;
    updateWindow(33);
  },
  openHome: function () {
    windows[32].openChallenge = null;
    showWindow(33);
  },
  openChallengeCat: function (p13928, p13929) {
    playSelect(0.1);
    windows[32].openChallenge = {
      typ: p13928,
      ind: p13929
    };
    menuWindow.scrollTop = 0;
    updateWindow(33);
  },
  gen: function () {
    if (!account) {
      return f1821(null, i18n.t("windows.chall.login"), true);
    }
    if (account.level < config.minChalLevel) {
      return f1821(config.minChalLevel, "for Challenges");
    }
    if (!account.activeChallenges || account.activeChallenges.length == 0) {
      return "<span style='color: #fff;'>No active challenges.</span>";
    }
    var vLS76 = "";
    var vLS77 = "";
    var vLSdivClasschallCrdMsgS = "<div class='challCrdMsg' style='margin-bottom:25px;font-size:27px;color:#9f9f9f;'>Abandoning a match will result in the loss of challenge progress.</div>";
    var vO359 = {};
    var vO360 = {};
    var vO361 = {};
    var vO362 = {};
    for (var vLN01867 = 0; vLN01867 < account.activeChallenges.length; vLN01867++) {
      var v11459 = account.activeChallenges[vLN01867];
      var v11439 = v11459.T;
      if (!vO359[v11439]) {
        vO359[v11439] = [];
      }
      vO359[v11439].push(v11459);
      if (v11459.DAT) {
        if (v11439 == "map") {
          var v11442 = v11439 + "_" + v11459.DAT.mp;
          vO360[v11442] = (vO360[v11442] || 0) + 1;
          if (v11459.PT) {
            vO361[v11442] = (vO361[v11442] || 0) + 1;
            vO362.map = (vO362.map || 0) + 1;
          }
        } else if (v11439 == "weapon") {
          var v11442 = v11439 + "_" + v11459.DAT.wep;
          vO360[v11442] = (vO360[v11442] || 0) + 1;
          if (v11459.PT) {
            vO361[v11442] = (vO361[v11442] || 0) + 1;
            vO362.weapon = (vO362.weapon | 0) + 1;
          }
        } else if (v11439 == "event") {
          var v11442 = v11439 + "_" + v11459.DAT.evt;
          vO360[v11442] = (vO360[v11442] || 0) + 1;
          if (v11459.PT) {
            vO361[v11442] = (vO361[v11442] || 0) + 1;
            vO362.event = (vO362.event | 0) + 1;
          }
        }
      }
    }
    vO359.event = vO359.event || [];
    vO359.ranked = vO359.ranked || [];
    vO359.map = vO359.map || [];
    vO359.weapon = vO359.weapon || [];
    vO359.nightmare = vO359.nightmare || [];
    vO359.clan = vO359.clan || [];
    if (!windows[32].openChallenge) {
      let v11443 = false;
      if (vO359.event.length && UTILS.hasActiveEvents()) {
        vLS77 += "<div class='challHeadrI' style='background-image:url(" + UTILS.assetsUrl("img/chals/hed_1.png") + ");'><div class='challHeadrT'>Event Challenges</div><div class='challHeadrS'>" + (vO362.event || 0) + "<span style='color:#fff;'>/" + vO359.event.length + "</span></div></div>";
        vLS77 += "<div style='margin-top:10px;text-align:center;'>";
        for (var vLN01867 = 0, v11444; vLN01867 < config.events.length; vLN01867++) {
          v11444 = config.events[vLN01867];
          if (vO360["event_" + v11444.id]) {
            vLS77 += "<div class='challMapCrd' style='background-image:url(" + UTILS.assetsUrl("/img/events/event_" + v11444.id + ".png") + ")' onmouseenter='playTick()' onclick='windows[32].openChallengeCat(`event`," + v11444.id + ");'><div class='challMapCvr'></div><div class='challMapName blackShad'>" + UTILS.capFirst(v11444.name) + "</div><div class='challMapPrg'>" + (vO361["event_" + v11444.id] || 0) + "<span style='color:#fff;'>/" + (vO360["event_" + v11444.id] || 0) + "</span></div></div>";
          }
        }
        vLS77 += "</div>";
        v11443 = true;
      }
      vLS76 = "";
      vLS77 += "<div class='challHeadrI' style='background-image:url(" + UTILS.assetsUrl("img/chals/hed_1.png") + ");margin-top:" + (v11443 ? 30 : 0) + "px;'><div class='challHeadrT'>Map Challenges</div><div class='challHeadrS'>" + (vO362.map || 0) + "<span style='color:#fff;'>/" + vO359.map.length + "</span></div></div>";
      vLS77 += "<div style='margin-top:10px;text-align:center;'>";
      for (var vLN01867 = 0; vLN01867 < maps.length; vLN01867++) {
        var v11445 = maps[vLN01867];
        var v11446 = v11445.name.toLowerCase();
        if (vO360["map_" + vLN01867]) {
          vLS77 += "<div class='challMapCrd' style='background-image:url(" + UTILS.assetsUrl("/img/maps/map_" + vLN01867 + ".png") + ")' onmouseenter='playTick()' onclick='windows[32].openChallengeCat(`map`," + vLN01867 + ");'><div class='challMapCvr'></div><div class='challMapName blackShad'>" + UTILS.capFirst(v11445.name) + "</div><div class='challMapPrg'>" + (vO361["map_" + vLN01867] || 0) + "<span style='color:#fff;'>/" + (vO360["map_" + vLN01867] || 0) + "</span></div></div>";
        }
      }
      vLS77 += "</div>";
      vLS77 += "<div class='challHeadrI' style='background-image:url(" + UTILS.assetsUrl("img/chals/hed_2.png") + ");margin-top:30px;'><div class='challHeadrT'>Weapon Challenges</div><div class='challHeadrS'>" + (vO362.weapon || 0) + "<span style='color:#fff;'>/" + vO359.weapon.length + "</span></div></div>";
      vLS77 += "<div style='margin-top:10px;text-align:center;'>";
      for (var vLN01867 = 0; vLN01867 < Game.weapons.length; vLN01867++) {
        var v11447 = Game.weapons[vLN01867];
        var v11448 = v11447.name.toLowerCase();
        if (v11447.type != weaponTypes.EQUIPMENT && !v11447.customOnly && vO360["weapon_" + vLN01867]) {
          vLS77 += "<div class='challMapCrd' onmouseenter='playTick()' onclick='windows[32].openChallengeCat(`weapon`," + vLN01867 + ");'><img class='challRotImg' style='background-image:url(" + UTILS.assetsUrl("/img/chals/" + (v11447.src || v11447.challSrc) + ".png") + ");background-size:contain;background-repeat:no-repeat;' /><div class='challMapCvr'></div><div class='challMapName blackShad'>" + UTILS.capFirst(v11447.name) + "</div><div class='challMapPrg'>" + (vO361["weapon_" + vLN01867] || 0) + "<span style='color:#fff;'>/" + (vO360["weapon_" + vLN01867] || 0) + "</span></div></div>";
        }
      }
      vLS77 += "</div>";
      var vLN01863 = 0;
      vLS76 += "<div style='margin-top:10px;'>";
      if (vO359.nightmare.length) {
        vO359.nightmare.sort(function (p13930, p13931) {
          return (p13931.DAT.boss ? 2 : p13931.PT) - (p13930.DAT.boss ? 2 : p13930.PT);
        });
      }
      for (var vLN01867 = 0, v11459; vLN01867 < vO359.nightmare.length; vLN01867++) {
        v11459 = vO359.nightmare[vLN01867];
        if (v11459.PT) {
          vLN01863++;
        }
        vLS76 += windows[32].genChallengeCard(v11459, vLN01867 ? 20 : 0);
      }
      if (!vO359.nightmare.length) {
        vLS76 += "<div class='challCrdMsg'>Check back later for new nightmare challanges!</div>";
      }
      vLS76 += "</div>";
      vLS77 += "<div class='challHeadrI' style='background-image:url(" + UTILS.assetsUrl("img/chals/hed_4.png") + ");margin-top:30px;'><div class='challHeadrT'>Nightmare Challenges</div><div class='challHeadrS'>" + (vLN01863 || 0) + "<span style='color:#fff'>/" + vO359.nightmare.length + "</span></div></div>";
      vLS77 += vLS76;
      vLS76 = "";
    } else if (windows[32].openChallenge.typ == "map") {
      var v11456 = windows[32].openChallenge.ind;
      vLS77 += "<div class='challHeadrI' style='background-image:url(" + UTILS.assetsUrl("img/chals/hed_1.png") + ");margin-top:0px;'><div class='challHeadrBck' onclick='windows[32].closeChallengeCat();'><span class='material-icons challBackArr'>arrow_back</span></div><div class='challHeadrT'>" + maps[v11456].name + " Challenges</div><div class='challHeadrS'>" + (vO361["map_" + v11456] || 0) + "<span style='color:#fff;'>/" + (vO360["map_" + v11456] || 0) + "</span></div></div>";
      vLS77 += vLSdivClasschallCrdMsgS;
      vLS77 += "<div style='margin-top:10px;'>";
      var v11458 = false;
      if (vO359.map.length) {
        vO359.map.sort(function (p13932, p13933) {
          return (p13933.DAT.boss ? 2 : p13933.PT) - (p13932.DAT.boss ? 2 : p13932.PT);
        });
      }
      for (var vLN01867 = 0, v11459; vLN01867 < vO359.map.length; vLN01867++) {
        v11459 = vO359.map[vLN01867];
        if (v11459.DAT && v11459.DAT.mp == v11456) {
          vLS77 += windows[32].genChallengeCard(v11459, v11458 ? 20 : 0);
          v11458 = true;
        }
      }
      if (!v11458) {
        vLS77 += "<div class='challCrdMsg'>Check back later for new challenges!</div>";
      }
      vLS77 += "</div>";
    } else if (windows[32].openChallenge.typ == "weapon") {
      var v11456 = windows[32].openChallenge.ind;
      vLS77 += "<div class='challHeadrI' style='background-image:url(" + UTILS.assetsUrl("img/chals/" + (Game.weapons[v11456].src || Game.weapons[v11456].challSrc) + ".png") + ");margin-top:0px;filter: saturate(0.8);'><div class='challHeadrBck' onclick='windows[32].closeChallengeCat();'><span class='material-icons challBackArr'>arrow_back</span></div><div class='challHeadrT'>" + Game.weapons[v11456].name + " Challenges</div><div class='challHeadrS'>" + (vO361["weapon_" + v11456] || 0) + "<span style='color:#fff;'>/" + (vO360["weapon_" + v11456] || 0) + "</span></div></div>";
      vLS77 += vLSdivClasschallCrdMsgS;
      vLS77 += "<div style='margin-top:10px;'>";
      var v11458 = false;
      if (vO359.weapon.length) {
        vO359.weapon.sort(function (p13934, p13935) {
          return (p13935.DAT.boss ? 2 : p13935.PT) - (p13934.DAT.boss ? 2 : p13934.PT);
        });
      }
      for (var vLN01867 = 0, v11459; vLN01867 < vO359.weapon.length; vLN01867++) {
        v11459 = vO359.weapon[vLN01867];
        if (v11459.DAT && v11459.DAT.wep == v11456) {
          vLS77 += windows[32].genChallengeCard(v11459, v11458 ? 20 : 0);
          v11458 = true;
        }
      }
      if (!v11458) {
        vLS77 += "<div class='challCrdMsg'>Check back later for new challenges!</div>";
      }
      vLS77 += "</div>";
    } else if (windows[32].openChallenge.typ == "event") {
      var v11456 = windows[32].openChallenge.ind;
      var v11457 = config.events.find(p13936 => p13936.id == v11456);
      vLS77 += "<div class='challHeadrI' style='background-image:url(" + UTILS.assetsUrl("img/chals/hed_1.png") + ");margin-top:0px;'><div class='challHeadrBck' onclick='windows[32].closeChallengeCat();'><span class='material-icons challBackArr'>arrow_back</span></div><div class='challHeadrT'>" + v11457.name + " Challenges</div><div class='challHeadrS'>" + (vO361["event_" + v11456] || 0) + "<span style='color:#fff;'>/" + (vO360["event_" + v11456] || 0) + "</span></div></div>";
      vLS77 += vLSdivClasschallCrdMsgS;
      vLS77 += "<div style='margin-top:10px;'>";
      var v11458 = false;
      vO359.event.sort(function (p13937, p13938) {
        return (p13938.DAT.boss ? 2 : p13938.PT) - (p13937.DAT.boss ? 2 : p13937.PT);
      });
      for (var vLN01867 = 0, v11459; vLN01867 < vO359.event.length; vLN01867++) {
        v11459 = vO359.event[vLN01867];
        if (v11459.DAT && v11459.DAT.evt == v11456) {
          vLS77 += windows[32].genChallengeCard(v11459, v11458 ? 20 : 0);
          v11458 = true;
        }
      }
      vLS77 += "</div>";
    }
    return vLS77;
  }
}, {
  header: i18n.t("windows.dye.header"),
  label: "dye_selection",
  width: 877,
  height: "calc(100% - 300px)",
  sticky: true,
  dark: true,
  hideScroll: true,
  gen: () => f1828("selectDye", 5),
  close: () => cancelTip(),
  clear: () => {
    f1822(window.event);
    selectDye(-1, true, true);
  }
}, {
  header: i18n.t("windows.changelog.header"),
  label: "changelog",
  logData: null,
  parsedLog: {},
  rawLog: {},
  tabIndex: 3,
  dark: true,
  width: 1000,
  latestUpd: null,
  fetchLog: function () {
    fetch("/docs/versions.txt?t=" + UTILS.randInt(1, 10000000)).then(p13939 => p13939.text()).then(p13940 => this.onFetched(p13940)).catch(p13941 => {});
  },
  onFetched: function (p13942) {
    if (p13942) {
      this.logData = p13942.split(/^\s*== (?=.*?\bUPDATE|UPADTE|INITIAL|TRICKSHOT\b)(.*) ==/gm);
      for (var vLN1152 = 1, v11460; vLN1152 < this.logData.length - 2; vLN1152 += 2) {
        v11460 = this.logData[vLN1152].match(/[\d\.]+/);
        if (v11460) {
          v11460 = v11460[0];
          if (!this.parsedLog[v11460[0]]) {
            this.parsedLog[v11460[0]] = {};
          }
          this.parsedLog[v11460[0]][v11460] = this.fixChanges(this.logData[vLN1152 + 1]);
          if (!this.rawLog[v11460[0]]) {
            this.rawLog[v11460[0]] = {};
          }
          this.rawLog[v11460[0]][v11460] = this.fixRawChanges(this.logData[vLN1152 + 1]);
        }
      }
      this.tabIndex = parseInt(Object.keys(this.parsedLog).slice(-1));
      this.latestUpd = Object.keys(this.parsedLog[Object.keys(this.parsedLog).slice(-1)]).slice(0, 1);
      updateWindow(35);
    }
  },
  toggleLog: function (p13943) {
    p13943.children[2].style.display = p13943.children[2].style.display == "none" ? "block" : "none";
    p13943.children[0].innerHTML = p13943.children[2].style.display == "none" ? "arrow_drop_down" : "arrow_drop_up";
  },
  fixChanges: function (p13944) {
    return "<li class='changeText' style='color: rgba(255, 255, 255, 0.5);'>" + p13944.split(String.fromCharCode(10)).map(p13945 => {
      if (p13945.startsWith("*") || p13945.startsWith(" *")) {
        p13945 = "";
      }
      if (p13945.startsWith("@") || p13945.startsWith(" @")) {
        p13945 = "";
      }
      return p13945.trim().replace("- ", "");
    }).filter(p13946 => p13946.length).join("</li><li class=\"changeText\" style=\"color: rgba(255, 255, 255, 0.5);\">") + "</li>";
  },
  fixRawChanges: function (p13947) {
    return p13947.split(String.fromCharCode(10)).map(p13948 => p13948.trim()).filter(p13949 => p13949.length);
  },
  switchTab: function (p13950) {
    if (this.tabIndex != p13950) {
      this.tabIndex = p13950;
      updateWindow(35);
    }
  },
  viewAll: function () {
    v10540 = config.gameVersion;
    saveVal("lastViewedUpdate", v10540);
    showWindow(35, true);
  },
  gen: function () {
    var vLS78 = "";
    if (!this.logData) {
      this.fetchLog();
      vLS78 = "Loading...";
    } else if (v10540 != config.gameVersion) {
      updateAd.style.display = "none";
      var v11461 = this.rawLog[parseInt(Object.keys(this.rawLog).slice(-1))][config.gameVersion];
      vLS78 += "<div class='logVersionHed' style='background:url(" + UTILS.assetsUrl("/img/backgrounds/whatsnew.png") + ");'>Whats New in v" + config.gameVersion + " ?</div>";
      var v11462 = false;
      for (var v11467 in v11461) {
        if (v11461[v11467].startsWith("*") || v11461[v11467].startsWith(" *")) {
          if (v11462) {
            vLS78 += "</div>";
          }
          v11462 = true;
          vLS78 += "<div class='mapListCat'>" + v11461[v11467].substr(1) + "</div><div class='setBodH' style='padding-top:20px;padding-bottom:20px;'>";
        } else {
          var v11464 = v11461[v11467].substr(1);
          if (v11464.substr(0, 1) == " ") {
            v11464 = v11464.substr(1);
          }
          vLS78 += v11461[v11467].startsWith("@") ? "<img class='logImg' src='" + v11464 + "'><div></div>" : "- <span style='color:rgba(255,255,255,0.6);'>" + v11464 + "</span><div></div>";
        }
      }
      vLS78 += "</div><div class='viewAllUpdates' onclick='windows[34].viewAll()'>View All Updates</div>";
    } else {
      var v11465 = Object.keys(this.parsedLog).reverse();
      var vLSdivStyleheight20pxdi = "<div style='height:20px;'></div><div class='bigMenTabs'>";
      for (var v11467 in v11465) {
        vLSdivStyleheight20pxdi += "<div class='bigMenTab" + (this.tabIndex == parseInt(v11465[v11467]) ? " bigMenTabA" : "") + "' onclick='windows[34].switchTab(" + parseInt(v11465[v11467]) + ")'>v" + v11465[v11467] + ".x</div>";
      }
      vLSdivStyleheight20pxdi += "</div>";
      var vLSdivIdmailList = "<div id='mailList'>";
      for (var v11467 in this.parsedLog[this.tabIndex]) {
        vLSdivIdmailList += "<div class='mailObj' onclick='windows[34].toggleLog(this)'><i class='material-icons' style='vertical-align:middle;margin-top:-10px;font-size:50px;float:right;margin-right:10px;color:#fff'>" + (this.latestUpd == v11467 ? "arrow_drop_up" : "arrow_drop_down") + "</i><div class='mailFrom' style='color: #fbc02d;'>" + (this.latestUpd == v11467 ? "LATEST UPDATE" : "UPDATE") + " " + v11467 + "</div><div style='margin-top:10px;" + (this.latestUpd == v11467 ? "" : "display:none;") + "'>" + this.parsedLog[this.tabIndex][v11467] + "</div></div>";
      }
      vLSdivIdmailList += "</div>";
      vLS78 += "<div style='margin-bottom:15px'>" + vLSdivStyleheight20pxdi + "</div>";
      vLS78 += vLSdivIdmailList;
    }
    return vLS78;
  }
}, {
  header: i18n.t("windows.premium.header"),
  label: "premium",
  width: 1000,
  maxH: "calc(100% - 350px)",
  gen: function () {
    var v11468 = "<div style='font-size: 24px;margin-bottom:20px;background:#000;width:100%;text-align:center;padding-bottom:10px;padding-top:10px;'>Premium Benefits</div><div style='background-color:#333;padding:15px;border-radius:6px;border:5px solid var(--yellow)'>" + config.premiumBenifits.map(p13951 => "<div class='settNameSmall premText'><i class='material-icons'>grade</i>" + p13951 + "</div>").join("") + "</div>";
    return v11468;
  }
}, {
  header: i18n.t("windows.trade.header"),
  width: 1146,
  label: "trade",
  trades: [[], []],
  inventories: [],
  trader: null,
  inv: null,
  otherInv: null,
  hideScroll: true,
  gen: function () {
    var v11469 = Game.players.findBySid(this.trader);
    if (!v11469) {
      return "Error";
    }
    this.trades = [[], []];
    this.inventories.length = 0;
    var vA614 = [];
    var vLS79 = "";
    this.inventories[0] = UTILS.sortItems(this.inv, Game.store.skins);
    var vLSdiv3 = "<div>";
    vLSdiv3 += "<div class='tHolderL'><div class='tListN inv'>Your Inventory</div><div id='invList0' class='tList' style='height: 225px;'>";
    for (var vLN01870 = 0; vLN01870 < this.inventories[0].length; vLN01870++) {
      player = Game.store.skins[this.inventories[0][vLN01870].i];
      if (player && this.inventories[0][vLN01870].c) {
        var v11471 = player.free || player.noSale || player.blackM || player.opensea || player.itemShop && player.itemShop == 1;
        var vV11471 = v11471;
        if (!player.free && account && account.isDev) {
          v11471 = false;
        }
        if (v11471 && SETTINGS.tmp.hideNonTrade) {
          continue;
        }
        vLSdiv3 += "<div id='trd_inv_0_" + this.inventories[0][vLN01870].i + "' class='tItemHolder' onclick='windows[36].add(" + this.inventories[0][vLN01870].i + ")' style='border: 2px solid " + Game.store.rarities[player.rarity].color + ";' oncontextmenu='openSales(" + this.inventories[0][vLN01870].i + ")' data-index='" + this.inventories[0][vLN01870].i + "' onmouseover='createTip(this)' onmouseout='cancelTip()'>" + (player.type && player.type == itemTypes.SPRAY ? "<div class='tItemSprayImg' style='background: url(&quot;" + player.thumbnail + "&quot;);" + UTILS.getFrameAnim(player, "sprayAnm") + "'></div>" : "<img draggable='false' class='tItemImg' loading='lazy' src='" + player.thumbnail + "'>") + "<div class='tItemN'>" + player.name + "</div><div class='tItemCnt'>x" + this.inventories[0][vLN01870].c + "</div>" + (vV11471 ? "<div class='tItemBound'><span class='material-icons' style='font-size:30px;color:#fff;'>lock</span></div>" : "") + "</div>";
        if (player.type && player.type == itemTypes.SPRAY && player.frames && vA614.indexOf(player.frames) == -1) {
          vA614.push(player.frames);
        }
      }
    }
    vLSdiv3 += "</div>";
    vLSdiv3 += "<input class='tSearch' type='text' placeholder='Search Item' onkeyup='windows[36].searchItems(this, 0)'>";
    vLSdiv3 += "<div id='tHeader0' class='tListN trade'>You <span id='tradeTotal0' class='tTotal'>0/" + (account.premiumT ? config.tradeMaxOutP : config.tradeMaxOut) + "</span><span id='tradeReady0' class='tReady'></span></div><div id='tradeList0' class='tList' style='height:125px;margin-bottom: 5px;'></div><div class='estOfferVal' id='offerVal0'>Est. Value <span style='color: var(--red);'>0</span> KR</div><label class='tSubHolder' onmouseenter='playTick()'><span id='tSubName'>Accept Offer - 10 KR</span><input id='tSubOffer' type='checkbox' onclick='windows[36].accept()'><div class='tSubCheck'></div></label></div>";
    this.inventories[1] = UTILS.sortItems(this.otherInv, Game.store.skins);
    vLSdiv3 += "<div class='tHolderR'><div class='tListN inv'>" + v11469.alias + "'s Inventory</div><div id='invList1' class='tList' style='height: 225px;'>";
    for (var vLN01870 = 0; vLN01870 < this.inventories[1].length; vLN01870++) {
      player = Game.store.skins[this.inventories[1][vLN01870].i];
      if (player && this.inventories[1][vLN01870].c) {
        var v11471 = player.free || player.noSale || player.blackM || player.opensea || player.itemShop && player.itemShop == 1;
        var vV11471 = v11471;
        if (!player.free && account && account.isDev) {
          v11471 = false;
        }
        if (v11471 && SETTINGS.tmp.hideNonTrade) {
          continue;
        }
        vLSdiv3 += "<div id='trd_inv_1_" + this.inventories[1][vLN01870].i + "' class='tItemHolder' style='border: 2px solid " + Game.store.rarities[player.rarity].color + ";' onclick='windows[36].request(" + this.inventories[1][vLN01870].i + ")' oncontextmenu='openSales(" + this.inventories[1][vLN01870].i + ")' data-index='" + this.inventories[1][vLN01870].i + "' onmouseover='createTip(this)' onmouseout='cancelTip()'>" + (player.type && player.type == itemTypes.SPRAY ? "<div class='tItemSprayImg' style='background: url(&quot;" + player.thumbnail + "&quot;);" + UTILS.getFrameAnim(player, "sprayAnm") + "'></div>" : "<img draggable='false' class='tItemImg' loading='lazy' src='" + player.thumbnail + "'>") + "<div class='tItemN'>" + player.name + "</div><div class='tItemCnt'>x" + this.inventories[1][vLN01870].c + "</div>" + (vV11471 ? "<div class='tItemBound'><span class='material-icons' style='font-size:30px;color:#fff;'>lock</span></div>" : "") + "</div>";
        if (player.type && player.type == itemTypes.SPRAY && player.frames && vA614.indexOf(player.frames) == -1) {
          vA614.push(player.frames);
        }
      }
    }
    vLSdiv3 += "</div>";
    vLSdiv3 += "<input class='tSearch' type='text' placeholder='Search Item' onkeyup='windows[36].searchItems(this, 1)'>";
    vLSdiv3 += "<div id='tHeader1' class='tListN trade'>" + v11469.alias + " <span id='tradeTotal1' class='tTotal'>0/" + (v11469.premiumT ? config.tradeMaxOutP : config.tradeMaxOut) + "</span><span id='tradeReady1' class='tReady'></span></div><div id='tradeList1' class='tList' style='height:125px;margin-bottom: 5px;'></div><div class='estOfferVal' id='offerVal1'>Est. Value <span style='color: var(--red);'>0</span> KR</div><label class='tSubHolder' onmouseenter='playTick()'><span id='tDecName'>Decline Offer</span><input id='tDecOffer' type='checkbox' onclick='windows[36].decline()'><div class='tDecCheck'></div></label></div>";
    vLSdiv3 += "<div id='tradeChatHolder'><div id='tradeChatInner'><div id='tradeChatList'></div><input id='tradeChatInput' placeholder='Enter Message' maxlength='70' autocomplete='off'></input></div></div>";
    vLSdiv3 += "</div>";
    if (vA614.length) {
      vLS79 += "<style>";
      for (var vLN01870 = 0; vLN01870 < vA614.length; vLN01870++) {
        vLS79 += "@keyframes sprayAnm" + vA614[vLN01870] + " {100%{background-position:-" + vA614[vLN01870] * 60 + "px}}";
      }
      vLS79 += "</style>";
    }
    return vLS79 + vLSdiv3;
  },
  searchItems: function (p13952, p13953) {
    var v11472 = p13952.value;
    for (var v11473 = this.inventories[p13953], vLN01871 = 0, v11474; vLN01871 < v11473.length; vLN01871++) {
      v11474 = false;
      if (!v11472 || !Game.store.skins[v11473[vLN01871].i]) {
        v11474 = true;
      } else if (Game.store.skins[v11473[vLN01871].i].keyW && UTILS.compareString(v11472, Game.store.skins[v11473[vLN01871].i].keyW)) {
        v11474 = true;
      } else if (Game.store.skins[v11473[vLN01871].i].drop && UTILS.compareString(v11472, "drops")) {
        v11474 = true;
      } else if (Game.store.skins[v11473[vLN01871].i].limT && UTILS.compareString(v11472, Game.store.skins[v11473[vLN01871].i].limT)) {
        v11474 = true;
      } else if (Game.store.skins[v11473[vLN01871].i].weapon && UTILS.compareString(v11472, Game.weapons[Game.store.skins[v11473[vLN01871].i].weapon - 1].name)) {
        v11474 = true;
      } else if (UTILS.compareString(v11472, Game.store.skins[v11473[vLN01871].i].name)) {
        v11474 = true;
      } else if (Game.store.skins[v11473[vLN01871].i].creators) {
        for (var vLN01872 = 0; vLN01872 < Game.store.skins[v11473[vLN01871].i].creators.length; vLN01872++) {
          if (UTILS.compareString(v11472, Game.store.skins[v11473[vLN01871].i].creators[vLN01872])) {
            v11474 = true;
            break;
          }
        }
      }
      var v11475 = document.getElementById("trd_inv_" + p13953 + "_" + v11473[vLN01871].i);
      if (v11475) {
        v11475.style.display = v11474 ? "inline-block" : "none";
      }
    }
  },
  request: function (p13954) {
    var v11476 = Game.store.skins[p13954];
    if (v11476) {
      var v11477 = v11476.free || v11476.noSale || v11476.blackM || v11476.opensea || v11476.itemShop && v11476.itemShop == 1;
      if (!v11476.free && account && account.isDev) {
        v11477 = false;
      }
      if (!v11477) {
        if (this.active) {
          io.send("utrd", p13954, 2);
        }
      }
    }
  },
  add: function (p13955) {
    var v11478 = Game.store.skins[p13955];
    if (v11478) {
      var v11479 = v11478.free || v11478.noSale || v11478.blackM || v11478.opensea || v11478.itemShop && v11478.itemShop == 1;
      if (!v11478.free && account && account.isDev) {
        v11479 = false;
      }
      if (!v11479) {
        if (this.active) {
          io.send("utrd", p13955, 1);
        }
      }
    }
  },
  addItem: function (p13956, p13957) {
    var v11480 = p13957 == tmpPlayer.id ? 0 : 1;
    var v11481 = Game.store.skins[p13956];
    if (this.trades[v11480][p13956]) {
      this.trades[v11480][p13956].c++;
    } else {
      this.trades[v11480][p13956] = {
        i: p13956,
        c: 1
      };
    }
    var v11482 = document.getElementById("trd_sel_" + v11480 + "_" + p13956);
    player = this.trades[v11480][p13956];
    if (v11482) {
      v11482.children[2].innerHTML = "x" + player.c;
    } else {
      document.getElementById("tradeList" + v11480).insertAdjacentHTML("beforeend", "<div id='trd_sel_" + v11480 + "_" + p13956 + "' class='tItemHolder' oncontextmenu='openSales(" + p13956 + ")' " + (v11480 ? "" : "onclick='windows[36].remove(" + p13956 + ")' ") + "style='border: 2px solid " + Game.store.rarities[v11481.rarity].color + ";' data-index='" + p13956 + "' onmouseover='createTip(this)' onmouseout='cancelTip()'>" + (v11481.type && v11481.type == itemTypes.SPRAY ? "<div class='tItemSprayImg' style='background: url(&quot;" + v11481.thumbnail + "&quot;);" + UTILS.getFrameAnim(v11481, "sprayAnm") + "'></div>" : "<img draggable='false' class='tItemImg' loading='lazy' src='" + v11481.thumbnail + "'>") + "<div class='tItemN'>" + v11481.name + "</div><div class='tItemCnt'>x" + player.c + "</div></div>");
    }
    if (!v11480) {
      v11482 = document.getElementById("trd_inv_0_" + p13956);
      var v11483 = this.inv.find(p13958 => p13958.i == p13956);
      if (v11482 && v11483) {
        v11482.children[2].textContent = "x" + (v11483.c - player.c);
      }
    }
    document.getElementById("tradeTotal" + v11480).textContent = document.getElementById("tradeTotal" + v11480).textContent.replace(/\d{1,2}\//g, this.trades[v11480].reduce((p13959, p13960) => p13959 + p13960.c, 0) + "/");
    var v11484 = this.trades[v11480].reduce((p13961, p13962) => p13961 + Math.round((prices.estimateValue(p13962.i) || 0) * p13962.c), 0);
    document.getElementById("offerVal" + v11480).children[0].innerHTML = UTILS.commaNumber(v11484);
  },
  remove: function (p13963) {
    if (this.active) {
      io.send("utrd", p13963, 0);
    }
  },
  removeItem: function (p13964, p13965) {
    var v11485 = p13965 == tmpPlayer.id ? 0 : 1;
    if (this.trades[v11485][p13964]) {
      this.trades[v11485][p13964].c--;
      var v11487 = document.getElementById("trd_sel_" + v11485 + "_" + p13964);
      if (this.trades[v11485][p13964].c <= 0) {
        delete this.trades[v11485][p13964];
        if (v11487) {
          v11487.remove();
        }
        cancelTip();
      } else {
        v11487.children[2].innerHTML = "x" + this.trades[v11485][p13964].c;
      }
    } else {
      return;
    }
    if (!v11485) {
      var v11487 = document.getElementById("trd_inv_0_" + p13964);
      var v11488 = this.inv.find(p13966 => p13966.i == p13964);
      var v11489 = this.trades[v11485][p13964] ? this.trades[v11485][p13964].c : 0;
      if (v11487 && v11488) {
        v11487.children[2].textContent = "x" + (v11488.c - v11489);
      }
    }
    document.getElementById("tradeTotal" + v11485).textContent = document.getElementById("tradeTotal" + v11485).textContent.replace(/\d{1,2}\//g, this.trades[v11485].reduce((p13967, p13968) => p13967 + p13968.c, 0) + "/");
    var v11490 = this.trades[v11485].reduce((p13969, p13970) => p13969 + Math.round((prices.estimateValue(p13970.i) || 0) * p13970.c), 0);
    document.getElementById("offerVal" + v11485).children[0].innerHTML = UTILS.commaNumber(v11490);
  },
  cancel: function () {
    if (this.active) {
      io.send("ctrd");
    }
  },
  canceled: function () {
    this.active = false;
    showWindow(0);
  },
  accept: function () {
    if (this.active && !tSubOffer.disabled) {
      io.send("atrd");
    }
  },
  accepted: function (p13971) {
    var v11491 = p13971 == tmpPlayer.sid ? 0 : 1;
    if (v11491 == 0) {
      tSubOffer.disabled = true;
      tSubOffer.checked = true;
      tHeader0.style.backgroundColor = "#5ce05a";
      tradeReady0.textContent = "READY";
    } else {
      tHeader1.style.backgroundColor = "#5ce05a";
      tradeReady1.textContent = "READY";
    }
  },
  decline: function () {
    if (this.active) {
      io.send("dtrd");
    }
  },
  process: function (p13972) {
    tSubName.textContent = "Loading " + p13972;
  },
  done: function () {
    showWindow(0);
    io_addChati18n(-1, null, "modes.trade.success", 2, "#5ce05a");
  },
  failed: function (p13973) {
    showWindow(0);
    io_addChat(-1, null, p13973, 2, "#ed4242");
  },
  updateButtons: function () {
    tSubOffer.disabled = false;
    tSubOffer.checked = false;
    tHeader0.style.backgroundColor = "#ed4242";
    tHeader1.style.backgroundColor = "#ed4242";
    tradeReady0.textContent = "";
    tradeReady1.textContent = "";
    tSubName.textContent = "Accept Offer - 10 KR";
  },
  close: function () {
    this.cancel();
    cancelTip();
  }
}, {
  header: i18n.t("windows.waist.header"),
  label: "waist_selection",
  width: 877,
  height: "calc(100% - 300px)",
  sticky: true,
  dark: true,
  hideScroll: true,
  gen: () => f1828("selectWaist", 6),
  close: () => cancelTip(),
  clear: () => {
    f1822(window.event);
    selectWaist(-1, true, true);
  }
}, {
  header: i18n.t("windows.face.header"),
  label: "face_selection",
  width: 877,
  height: "calc(100% - 300px)",
  sticky: true,
  dark: true,
  hideScroll: true,
  gen: () => f1828("selectFace", 7),
  close: () => cancelTip(),
  clear: () => {
    f1822(window.event);
    selectFace(-1, true, true);
  }
}, {
  header: i18n.t("windows.shoe.header"),
  label: "shoe_selection",
  width: 877,
  height: "calc(100% - 300px)",
  sticky: true,
  dark: true,
  hideScroll: true,
  gen: () => f1828("selectShoe", 8),
  close: () => cancelTip(),
  clear: () => {
    f1822(window.event);
    selectShoe(-1, true, true);
  }
}, {
  header: i18n.t("windows.scope.header"),
  label: "scope_selection",
  width: 900,
  dark: true,
  gen: function () {
    var v11492 = "<div>" + f1797("scopeBorderCol") + f1797("scopeBorders") + f1797("scopeBorderOpac") + f1797("scopeWidth") + f1797("scopeHeight") + f1797("scopeOpac") + "</div>";
    v11492 += "<div id='skinList' style='margin-top:18px'><div class='noBtnCard blackShad' style='height:140px;border:5px solid lightgrey' onclick='selectScope(-1)' onmouseenter='playTick()'>None<div class='skinRandom blackShad' style='top: 60px;' onmouseenter='playTick()'>X</div></div>";
    var v11493 = Game.weaponConfig[Game.classConfig[classIndex].loadout[0]].scope != null;
    if (v11493) {
      v11492 += "<div class='noBtnCard' style='height:140px;border:5px solid lightgrey'><div style='color: #fff;margin-top: 33px;' onclick='window.windows[40].newPop()' onmouseenter='playTick()'>ADD<br>CUSTOM</div></div>";
      for (var vLN01874 = 0; vLN01874 < customScopes.length; ++vLN01874) {
        player = customScopes[vLN01874];
        if (player) {
          var v11494 = player[0].replace(/[^a-zA-Z0-9 _-]+/gim, "");
          var vF17415 = sanitizeCustomImageUrl(player[1]);
          v11492 += "<div class='noBtnCard blackShad' style='height:140px;border:5px solid #fc5a4e' onclick='selectScope(-2, &quot;" + vF17415 + "&quot;)'>" + (v11494 || "Custom") + "<div class='itemOwn' style='margin-top:1px'>Custom</div><img loading='lazy' class='noBtnImgR' draggable='false' src='" + (vF17415 || "") + "' onmouseenter='playTick()' /><div class='selctDelBtn' onmouseenter='playTick()'onclick='removeScope(" + vLN01874 + ")'>X</div></div>";
        }
      }
      for (var vLN01874 = 0; vLN01874 < aimRecticles.length; ++vLN01874) {
        player = aimRecticles[vLN01874];
        if (player) {
          v11492 += "<div class='noBtnCard blackShad' style='height:140px;border:5px solid lightgrey' onclick='selectScope(" + vLN01874 + ")'>" + player.name + "<div class='itemOwn' style='margin-top:1px'>" + i18n.t("generic.default") + "</div><img loading='lazy' class='noBtnImgR' draggable='false' src='" + UTILS.assetsUrl("/textures/scopes/scope_" + player.id + "." + (player.type || "png")) + "' onmouseenter='playTick()' /></div>";
        }
      }
    }
    v11492 += "</div>";
    return v11492;
  },
  newPop: function () {
    var vLSdivClasspubHedNewIma2 = "<div class='pubHed'>New Image</div><div style='font-size:20px;color:#fff'><div style='margin-top: 3px;font-size: 22px;color: rgba(255, 255, 255, 0.7);'>Name:<input type='text' id='newCustomName' class='inputGrey2' placeholder='Name'></div><div style='margin-top: 3px;font-size: 22px;color: rgba(255, 255, 255, 0.7);'>Image:<input type='url' id='newCustomImg' class='inputGrey2' placeholder='Image URL'></div><div class='mapFndB' onclick='window.windows[40].addNew()' onmouseover='playTick(0.1)' style='background-color:#fc5a4e;width: 380px;margin-top: 10px;'>Add</div></div>";
    genericPopup(vLSdivClasspubHedNewIma2, "imageNewPop");
  },
  addNew: function () {
    var v11495 = document.getElementById("newCustomImg");
    var v11496 = document.getElementById("newCustomName");
    if (v11496 && v11495 && v11495.value && v11496.value) {
      var v11497 = v11496.value.replace(/[^a-zA-Z0-9 _-]+/gim, "");
      if (!v11497.length) {
        return io_showPopup(null, "Invalid Name");
      }
      var vF17416 = sanitizeCustomImageUrl(v11495.value);
      if (!vF17416) {
        return io_showPopup(null, "Invalid Image");
      }
      customScopes.push([v11497, vF17416]);
      setCustomScopes(customScopes, true);
      clearPops();
      updateWindow(41);
    } else {
      return io_showPopup(null, "Something Went Wrong");
    }
  }
}, {
  header: i18n.t("windows.maps.header"),
  label: "host_type",
  width: 985,
  dark: true,
  popup: true,
  hideScroll: true,
  gen: function () {
    var v11498 = "<div class='serverHostOpH'>Select a Server Type to Host</div><div class='serverHostOpGroup'><div class='serverHostOp serverHostOp-small' style='margin-bottom:15px;background-image:url(&quot;" + UTILS.assetsUrl("img/backgrounds/server_raids_2.png") + "&quot;);' onclick='playSelect(0.1);openHostWindow(false, 4)' onmouseenter='playTick()'>Raids</div><div class='serverHostOp serverHostOp-small' style='margin-bottom:15px;background-image:url(&quot;" + UTILS.assetsUrl("img/backgrounds/server_zombies_2.png") + "&quot;);' onclick='playSelect(0.1);openHostWindow(false, 3)' onmouseenter='playTick()'>Zombies</div><div class='serverHostOp serverHostOp-small' style='background-image:url(&quot;" + UTILS.assetsUrl("img/backgrounds/server_comp_2.png") + "&quot;);' onclick='playSelect(0.1);openHostWindow(false, 1)' onmouseenter='playTick()'>Comp</div></div><div class='serverHostOp' style='margin-right:20px;background-image:url(&quot;" + UTILS.assetsUrl("img/backgrounds/customs.png") + "&quot;);' onmouseenter='playTick()' onclick='playSelect(0.1);openHostWindow(false, 0)'>Custom</div><div class='serverHostOp' onmouseenter='playTick()' style='background-image:url(&quot;" + UTILS.assetsUrl("/img/host-bg/2.png") + "&quot;);' onclick='playSelect(0.1);openHostWindow(false, 2)'>Dedicated</div>";
    return v11498;
  }
}, {
  header: i18n.t("windows.pet.header"),
  label: "pet_selection",
  width: 877,
  height: "calc(100% - 300px)",
  sticky: true,
  dark: true,
  hideScroll: true,
  gen: () => f1828("selectPet", 9),
  close: () => cancelTip(),
  clear: () => {
    f1822(window.event);
    selectPet(-1, true, true);
  }
}, {
  header: i18n.t("windows.wrist.header"),
  label: "wrist_selection",
  width: 877,
  height: "calc(100% - 300px)",
  sticky: true,
  dark: true,
  hideScroll: true,
  gen: () => f1828("selectWrist", 11),
  close: () => cancelTip(),
  clear: () => {
    f1822(window.event);
    selectWrist(-1, true, true);
  }
}, {
  header: i18n.t("windows.streaks.header"),
  label: "streak_selection",
  width: 877,
  dark: true,
  selected: [],
  goBack: function () {
    showWindow(3);
  },
  gen: function () {
    var vLSdivClasswinBackHdivC2 = "<div class='winBackH'><div class='custBack' onclick='playSelect(0.1);goBackWindow(44)' onmouseenter='playTick();'><span class='material-icons custBackArr'>arrow_back</span></div><div class='winSelH'>Select Streaks</div><div class='winClose' onclick='playSelect(0.1);closWind()' onmouseenter='playTick();'><span class='material-icons winCloseArr'>close</span></div></div>";
    var vA615 = [streakIndex1, streakIndex2, streakIndex3];
    var v11499 = Game.streaks.filter(p13974 => !p13974.devOnly || p13974.devOnly && account && account.isDev).sort((p13975, p13976) => (p13975.kills == null ? 0 : p13975.kills) - (p13976.kills == null ? 0 : p13976.kills)).sort((p13977, p13978) => (p13977.slot == null ? 0 : p13977.slot) - (p13978.slot == null ? 0 : p13978.slot));
    vLSdivClasswinBackHdivC2 += "<div id='custStreakListH'>";
    for (var vLN01876 = 0; vLN01876 < v11499.length; ++vLN01876) {
      player = v11499[vLN01876];
      if (player) {
        var v11500 = vA615[player.slot || 0] == player.index;
        var v11501 = vA615[player.slot || 0] == -1;
        vLSdivClasswinBackHdivC2 += "<div class='streakCard blackShad' style='height: 165px;border:5px solid lightgrey'" + (v11501 ? " onclick='selectStreak(" + player.index + ", " + (player.slot || 0) + ");cancelTip()'" : "") + " data-index='" + player.index + "' onmouseover='createStreakTip(this)' onmouseout='cancelTip()' id='streakSel" + (player.slot || 0) + "_" + player.index + "'>" + player.name + "<div class='itemOwn'>Slot " + ((player.slot || 0) + 1) + " | " + (player.kills || 0) + " kills</div><img loading='lazy' draggable='false' class='streakImg' onmouseenter='playTick()' src='" + UTILS.assetsUrl("/img/streaks/" + player.index + ".png") + "' />" + (v11501 ? "" : "<div class='lockedCard'><span class='material-icons' style='font-size: 70px;color:#fff'>lock</span></div>") + "</div>";
      }
    }
    vLSdivClasswinBackHdivC2 += "</div>";
    vLSdivClasswinBackHdivC2 += "<div id='custStreakSelH'>";
    for (var vLN01876 = 0; vLN01876 < 3; ++vLN01876) {
      player = Game.streaks[vA615[vLN01876]];
      vLSdivClasswinBackHdivC2 += "<div class='streakCard blackShad' style='height: 165px;border:5px solid lightgrey' onclick='selectStreak(-1, " + vLN01876 + ")'><div class='streakActionOvrl'><div class='streakActionHol'><div class='streakActionB'><span class='material-icons' style='font-size:70px;color:#fff;'>close</span></div></div></div>" + (player ? player.name : "None") + "<div class='itemOwn'>Slot " + (vLN01876 + 1) + "</div>" + (player ? "<img loading='lazy' draggable='false' class='streakImg' onmouseenter='playTick()' src='" + UTILS.assetsUrl("/img/streaks/" + (player ? player.index : 1) + ".png") + "'/>" : "<div class='skinRandom blackShad' style='top:68px;left: 57px;'>?</div>") + "</div>";
    }
    vLSdivClasswinBackHdivC2 += "</div>";
    return vLSdivClasswinBackHdivC2;
  },
  close: () => cancelTip()
}, {
  header: i18n.t("windows.charm.header"),
  label: "charm_selection",
  width: 877,
  height: "calc(100% - 300px)",
  sticky: true,
  dark: true,
  hideScroll: true,
  gen: () => f1828("selectCharm", 12),
  close: () => cancelTip(),
  clear: () => {
    f1822(window.event);
    selectCharm(-1, true, true);
  }
}, {
  label: "terms",
  dark: false,
  width: 1460,
  dark: true,
  hideScroll: false,
  gen: function () {
    return "\n\t\t\t<iframe width=1460 height=1460 border=0 src=\"https://frvr.com/legal/krunker/\"></iframe>\n\t\t";
  }
}, {
  header: i18n.t("windows.maps.header"),
  label: "host_type",
  width: 985,
  dark: true,
  popup: true,
  hideScroll: true,
  gen: function () {
    var v11502 = "<div class='serverHostOpH'>Select a Server</div><div class='serverHostOpGroup'><div class='serverHostOp serverHostOp-small' style='margin-bottom:15px;background-image:url(&quot;" + UTILS.assetsUrl("img/backgrounds/server_raids_2.png") + "&quot;);' onclick='playSelect(0.1);openServerWindow(2)' onmouseenter='playTick()'>Raids</div><div class='serverHostOp serverHostOp-small' style='margin-bottom:15px;background-image:url(&quot;" + UTILS.assetsUrl("img/backgrounds/server_zombies_2.png") + "&quot;);' onclick='playSelect(0.1);openServerWindow(3)' onmouseenter='playTick()'>Zombies</div><div class='serverHostOp serverHostOp-small' style='background-image:url(&quot;" + UTILS.assetsUrl("img/backgrounds/server_trade.png") + "&quot;);' onclick='playSelect(0.1);openServerWindow(4)' onmouseenter='playTick()'>Trade Plaza</div></div><div class='serverHostOp' style='margin-right:20px;background-image:url(&quot;" + UTILS.assetsUrl("/img/host-bg/2.png") + "&quot;);' onmouseenter='playTick()' onclick='playSelect(0.1);openServerWindow(0)'>Public</div><div class='serverHostOp' onmouseenter='playTick()' style='background-image:url(&quot;" + UTILS.assetsUrl("img/backgrounds/customs.png") + "&quot;);' onclick='playSelect(0.1);openServerWindow(1)'>Customs</div>";
    return v11502;
  }
}, {
  header: i18n.t("windows.esports.header"),
  width: 985,
  dark: true,
  popup: true,
  list: [{
    description: "NACK is currently the official pickup server for North America. They provide both a casual and competitive experience for players trying to get better at Krunker.io and start competing.",
    link: "https://discord.gg/nJmqWam3tj",
    image: UTILS.assetsUrl("/img/esports/nack.png")
  }, {
    description: "KPC is the largest competitive Krunker community for Europe. They host many community events on the server, as well as supporting the competitive scene through pickup games.",
    link: "https://discord.gg/k6TR9hT",
    image: UTILS.assetsUrl("/img/esports/kpc.png")
  }, {
    description: "CKA is the official competitive hub for Asia, where they host PUGs, monthly tournaments and other events with cash prizes. Anyone is welcome to participate once they meet the requirements.",
    link: "https://discord.gg/bRs2PVzZza",
    image: UTILS.assetsUrl("/img/esports/cka.png")
  }],
  gen: function () {
    let vLSdivClassscrimHeaderR = "<div class=\"scrimHeader\">Regional Pickup Servers</div>\n\t\t\t<div class=\"scrimSub\">Official community-run scrim servers. Each server may have different sign-up requirements and events.</div>\n\t\t\t<div class=\"scrimHolder\">";
    for (let vLN01877 = 0; vLN01877 < this.list.length; vLN01877++) {
      vLSdivClassscrimHeaderR += "<a target=\"_blank\" href=\"" + this.list[vLN01877].link + "\">\n\t\t\t\t<img class=\"scrimImage\" src=\"" + this.list[vLN01877].image + "\">\n\t\t\t</a>\n\t\t\t<div class=\"scrimDesc\">" + this.list[vLN01877].description + "\n\t\t\t\t<div class=\"scrimLink\">Join here: <a target=\"_blank\" href=\"" + this.list[vLN01877].link + "\">" + this.list[vLN01877].link + "</a></div>\n\t\t\t</div>";
    }
    vLSdivClassscrimHeaderR += "</div></div>";
    return vLSdivClassscrimHeaderR;
  }
}, {
  header: i18n.t("windows.back.header"),
  label: "back_selection",
  width: 877,
  height: "calc(100% - 300px)",
  sticky: true,
  dark: true,
  hideScroll: true,
  gen: function () {
    return f1828("selectBack", 14);
  },
  close: () => cancelTip(),
  clear: () => {
    f1822(window.event);
    selectBack(-1, true, true);
  }
}, {
  header: i18n.t("windows.head.header"),
  label: "head_selection",
  width: 877,
  height: "calc(100% - 300px)",
  sticky: true,
  dark: true,
  hideScroll: true,
  gen: function () {
    return f1828("selectHead", 15);
  },
  close: () => cancelTip(),
  clear: () => {
    f1822(window.event);
    selectHead(-1, true, true);
  }
}, {
  header: i18n.t("windows.playercard.header"),
  label: "playercard_selection",
  width: 877,
  height: "calc(100% - 300px)",
  sticky: true,
  dark: true,
  hideScroll: true,
  gen: function () {
    return f1828("selectPlayerCard", 16);
  },
  close: () => cancelTip(),
  clear: () => {
    f1822(window.event);
    selectPlayerCard(-1, true, true);
  }
}];
window.searchItems = function (p13979, p13980) {
  p13980 = p13980 || "skinCard";
  var v11503 = p13979.value;
  for (var v11504 = document.querySelectorAll("#menuWindow>#skinList>." + p13980), vLN225 = 2; vLN225 < v11504.length; vLN225++) {
    var v11505 = false;
    var v11506 = v11504[vLN225].getAttribute("data-index");
    if (!v11503 || !Game.store.skins[v11506]) {
      v11505 = true;
    } else if (Game.store.skins[v11506].keyW && UTILS.compareString(v11503, Game.store.skins[v11506].keyW)) {
      v11505 = true;
    } else if (Game.store.skins[v11506].drop && UTILS.compareString(v11503, "drops")) {
      v11505 = true;
    } else if (Game.store.skins[v11506].limT && UTILS.compareString(v11503, Game.store.skins[v11506].limT)) {
      v11505 = true;
    } else if (Game.store.skins[v11506].weapon && UTILS.compareString(v11503, Game.weapons[Game.store.skins[v11506].weapon - 1].name)) {
      v11505 = true;
    } else if (UTILS.compareString(v11503, Game.store.skins[v11506].name)) {
      v11505 = true;
    } else if (Game.store.skins[v11506].creators) {
      for (var vLN01878 = 0; vLN01878 < Game.store.skins[v11506].creators.length; vLN01878++) {
        if (UTILS.compareString(v11503, Game.store.skins[v11506].creators[vLN01878])) {
          v11505 = true;
          break;
        }
      }
    }
    v11504[vLN225].style.display = v11505 ? "inline-block" : "none";
  }
};
window.fetchMatches = function (p13981) {
  return fetch(config.matchmakerURL + "/game-list?hostname=" + location.hostname, {
    cache: "no-cache"
  }).then(p13982 => p13982.json()).catch(p13983 => p13981({})).then(p13984 => {
    let vO363 = {};
    if (p13984.games) {
      for (var vLN01879 = 0; vLN01879 < p13984.games.length; vLN01879++) {
        var [v11507, v11508, v11509, v11510, v11511] = p13984.games[vLN01879];
        if (v11511 && v11511.c) {
          var v11512 = UTILS.escapeStr(v11511.i);
          vO363[v11512] = (vO363[v11512] || 0) + Math.min(v11509, v11510);
        }
      }
    }
    p13981(vO363);
  });
};
window.clientExitPopup = function () {
  var vA616 = [m("div", {
    style: "color:#fff;font-size:20px;position:relative;margin-bottom:15px;"
  }, "Are you sure you want to close krunker?"), m("#confirmBtn", {
    onclick: () => closeClient(),
    onmouseover: () => playTick(0.1)
  }, "YES"), m("#declineBtn", {
    onclick: () => clearPops(),
    onmouseover: () => playTick(0.1)
  }, "NO")];
  genericPopup(vA616, "clientExitPop");
};
if (!window.closeClient) {
  window.closeClient = function () {};
}
var v11513 = null;
function f1803(p13985) {
  if (!window.ethereum) {
    return p13985("Please install MetaMask first.");
  }
  if (!v11513) {
    try {
      window.ethereum.enable().then(p13986 => {
        v11513 = new Web3(window.ethereum);
        v11513.eth.getCoinbase().then(p13987 => {
          if (!p13987) {
            return p13985("Please activate MetaMask first.");
          }
          var v11514 = p13987.toLowerCase();
          return p13985(null, v11513, v11514);
        }).catch(p13988 => p13985("Please activate MetaMask first."));
      });
    } catch (e129) {
      return p13985("You need to allow MetaMask.");
    }
  } else {
    v11513.eth.getCoinbase().then(p13989 => {
      if (!p13989) {
        return p13985("Please activate MetaMask first.");
      }
      var v11515 = p13989.toLowerCase();
      return p13985(null, v11513, v11515);
    }).catch(p13990 => p13985("Please activate MetaMask first."));
  }
}
function io_openMetamaskAuth(p13991) {
  if (v10514 || !account || account.metamask) {
    return undefined;
  } else if (p13991) {
    f1803(function (p13992, p13993, p13994) {
      if (p13992) {
        return alert(p13992);
      }
      try {
        p13993.eth.personal.sign("I am signing my one-time nonce: " + p13991, p13994, "").then(p13995 => {
          io.send("vmms", p13995, p13994);
        });
      } catch (e130) {
        return alert("You need to sign the message to be able to log in.");
      }
    });
    return;
  } else {
    return io_showPopup(null, "Please Try later");
  }
}
function io_metamaskLinkResponse(p13996) {
  if (account) {
    account.metamask = p13996;
  }
  io_showPopup("SUCCESS", null, "Metamask Linked!");
  updateWindow(5);
}
function io_metamaskUnlinkResponse() {
  if (account) {
    account.metamask = null;
  }
  io_showPopup("SUCCESS", null, "Metamask Unlinked!");
  updateWindow(5);
}
window.linkMetaPop = function () {
  if (!v10514 && !!account && !account.metamask) {
    var vA617 = [m("div", {
      style: "color: #ffffff;font-size: 24px;"
    }, "Re-enter Krunker Password"), m("input.accountInput", {
      id: "accPass2",
      type: "password",
      style: "margin-top: 5px",
      placeholder: i18n.t("generic.password"),
      onclick: () => unlinkTwitch(),
      onmouseover: () => playTick(0.1)
    }, "YES"), m(".metaLoginBtn", {
      onclick: () => requestMetaLink()
    }, "Link Metamask")];
    genericPopup(vA617, "metaPop");
  }
};
window.requestMetaLink = function () {
  f1803(function (p13997, p13998) {
    if (p13997) {
      return alert(p13997);
    } else {
      io_loadingPopup("Please Wait...");
      io.send("vmm", accPass2.value);
      return;
    }
  });
};
window.unlinkMetaPop = function () {
  if (!v10514 && account && account.metamask) {
    var vA618 = [m("div", {
      style: "color: #ffffff;font-size: 24px;"
    }, "Are you sure you want to unlink?"), m(".metaLoginBtn", {
      onclick: () => unlinkMeta()
    }, "Unlink")];
    genericPopup(vA618, "metaPop");
  }
};
window.unlinkMeta = function () {
  io_loadingPopup("Please Wait...");
  io.send("rmm");
};
function io_nftResponse(p13999) {
  var vLSdivStylecolorffffont3 = "<div style='color:#fff;font-size:20px;position:relative;margin-bottom:15px;text-align: center;'>NFT'S Claimed</div><div id='skinList' style='text-align: center;'>";
  var vA619 = [];
  for (var vLN01881 = 0; vLN01881 < p13999.length; vLN01881++) {
    p13999[vLN01881] = parseInt(p13999[vLN01881]);
    account.addSkin(p13999[vLN01881]);
    player = Game.store.skins[p13999[vLN01881]];
    if (player) {
      vLSdivStylecolorffffont3 += "<div class='tItemHolder' style='border: 2px solid " + Game.store.rarities[player.rarity].color + ";' onclick='openSales(" + p13999[vLN01881] + ")'>" + (player.type && player.type == itemTypes.SPRAY ? "<div class='tItemSprayImg' style='background: url(&quot;" + player.thumbnail + "&quot;);" + UTILS.getFrameAnim(player, "sprayAnm") + "'></div>" : "<img draggable='false' class='tItemImg' loading='lazy' src='" + player.thumbnail + "'>") + "<div class='tItemN'>" + player.name + "</div></div>";
      if (player.type && player.type == itemTypes.SPRAY && player.frames && vA619.indexOf(player.frames) == -1) {
        vA619.push(player.frames);
      }
    }
  }
  vLSdivStylecolorffffont3 += "</div>";
  if (vA619.length) {
    var vLSstyle3 = "<style>";
    for (var vLN01881 = 0; vLN01881 < vA619.length; vLN01881++) {
      vLSstyle3 += "@keyframes sprayAnm" + vA619[vLN01881] + " {100%{background-position:-" + vA619[vLN01881] * 68 + "px}}";
    }
    vLSstyle3 += "</style>";
    vLSdivStylecolorffffont3 = vLSstyle3 + vLSdivStylecolorffffont3;
  }
  genericPopup(vLSdivStylecolorffffont3, "nftPop");
}
window.linkTwitchPop = function () {
  if (!config.twitchLinking) {
    return io_showPopup(null, "Under Maintenance");
  }
  var vA620 = [m("div", {
    style: "color:#fff;font-size:20px;position:relative;margin-bottom:15px;"
  }, i18n.t("twitch.link")), m("#confirmBtn", {
    onclick: () => linkTwitch(),
    onmouseover: () => playTick(0.1)
  }, "YES"), m("#declineBtn", {
    onclick: () => clearPops(),
    onmouseover: () => playTick(0.1)
  }, "NO")];
  genericPopup(vA620, "twitchPop");
};
window.linkTwitch = function () {
  if (config.twitchLinking) {
    if (account) {
      window.open(location.origin + "/?twitch_auth", "_self");
    }
    return;
  } else {
    return io_showPopup(null, "Under Maintenance");
  }
};
window.unlinkTwitchPop = function () {
  var vA621 = [m("div", {
    style: "color:var(--red);"
  }, i18n.t("twitch.unlink.warning")), m("div", {
    style: "color:#fff;font-size:20px;position:relative;margin-bottom:15px;"
  }, i18n.t("twitch.unlink")), m("#confirmBtn", {
    onclick: () => unlinkTwitch(),
    onmouseover: () => playTick(0.1)
  }, "YES"), m("#declineBtn", {
    onclick: () => clearPops(),
    onmouseover: () => playTick(0.1)
  }, "NO")];
  genericPopup(vA621, "twitchPop");
};
window.unlinkTwitch = function () {
  if (account && account.twitchId) {
    io_loadingPopup("Please Wait...");
    io.send("rtw");
  }
};
function io_vtRes(p14000, p14001, p14002) {
  if (p14000) {
    twitchRes.style.color = "#ff0000";
    twitchRes.innerHTML = p14000;
  } else {
    f1810(true);
    if (account) {
      account.twitch = p14001;
      account.twitchId = p14002;
    }
  }
}
function io_rtRes() {
  if (account) {
    account.twitch = null;
    account.twitchId = null;
  }
  var vM = m("div", {
    style: "width:100%;text-align:center"
  }, [m("div", m("i.material-icons", {
    style: "font-size:80px;color:#3be354"
  }, "done")), m("div", {
    style: "font-size:20px;color:rgba(255,255,255,0.5)"
  }, "Twitch Account Unlinked"), "Go to ", m("a", {
    href: "https://www.twitch.tv/settings/connections"
  }, "Twitch Connections"), " and Click disconnect on Krunker Events"]);
  genericPopup(vM, "twitchPop");
}
window.connectTwitchAcc = function () {
  var v11516 = location.origin == "http://127.0.0.1:8080" ? "http://localhost:8080" : location.origin;
  window.open("https://id.twitch.tv/oauth2/authorize?response_type=code&client_id=" + config.dropsClientId + "&scope=user_read+viewing_activity_read&redirect_uri=" + v11516 + "/?twitch_auth", "_self");
};
function f1810(p14003) {
  if (!window.canShowTwitch) {
    return false;
  }
  if (!v10537) {
    return false;
  }
  resetPops();
  popupBack.style.backgroundColor = "rgba(0, 0, 0, 1)";
  infoHolder.style.display = "none";
  aHolder.style.display = "none";
  var v11517 = document.getElementById("onetrust-consent-sdk");
  if (v11517) {
    v11517.style.display = "none";
  }
  if (p14003) {
    var vLSimgSrcimgtwitch_1png2 = "<img src='/img/twitch_1.png' style='width: 200px;margin-left: 25px;'><div class='twitchSuccess'>Twitch Account Linked</div><div class='twitchLoginBtn' onclick='window.open(&quot;/&quot;,&quot;_self&quot;)'>Click to Continue</div>";
    genericPopup(vLSimgSrcimgtwitch_1png2, "twitchLinkPop");
  } else if (v10538) {
    var vLSimgSrcimgtwitch_1png2 = "<img src='/img/twitch_1.png' style='margin-bottom: 20px;width: 200px;'><div style='color: #ffffff;font-size: 24px;'>Sign In to finish linking</div><span style='color: #cccccc;font-size: 16px;'>With your Krunker Account</span><div id='twitchRes' style='color: #ff0000;font-size: 16px;'></div><input id='accName' type='text' placeholder='" + i18n.t("generic.username") + "' class='accountTwitchInput' value='" + (getSavedVal("krunker_username") || "") + "'></input><input id='accPass' type='password' placeholder='" + i18n.t("generic.password") + "' class='accountTwitchInput'></input><div id='accResp' style='margin-top: 10px;margin-bottom: 10px;font-size: 13px;color: rgba(255,255,255,0.5);'>For lost Passwords/Accounts contact <span style='color:rgba(255,255,255,0.8)'>recovery@yendis.ch</span></div><div class='twitchLoginBtn' onclick='registerAcc()'>Register</div><div class='twitchLoginBtn' onclick='loginAcc()'>Sign In</div>";
    genericPopup(vLSimgSrcimgtwitch_1png2, "twitchConPop");
  } else {
    var vLSimgSrcimgtwitch_1png2 = "<img src='/img/twitch_1.png' style='margin-bottom: 20px;width: 200px;margin-left: 25px;'><div class='twitchLoginBtn' onclick='connectTwitchAcc()'>Connect Twitch Account</div>";
    genericPopup(vLSimgSrcimgtwitch_1png2, "twitchLinkPop");
  }
  clearPops = function () {};
  return true;
}
window.promoPopup = function (p14004) {
  var vA622 = [m("img", {
    src: UTILS.assetsUrl("/img/gsupps_logo2.png"),
    style: "margin-bottom: 20px;width: 100%;"
  }), m("div", {
    style: "color:#cfcfcf;font-size:23px;text-align:center;"
  }, ["You won a ", m("span", {
    style: "color:#ffb800;"
  }, "Free $40 GamerSupps")]), m("input#promoCode", {
    type: "text",
    value: "XXXX-XXXX-XXXX-XXXX-XXXX-XXXX",
    disabled: "true"
  }), m("div", {
    style: "color: #ffffff;font-size: 19px;"
  }, "You might want to grab one of these with your code"), m("img.promoIcon", {
    src: UTILS.assetsUrl("/img/gsupps_icon_0.png"),
    onclick: () => openURL("https://gamersupps.gg/products/citrus-lemonade-100-serving"),
    onmouseover: () => playTick(0.1)
  }), m("img.promoIcon", {
    src: UTILS.assetsUrl("/img/gsupps_icon_1.png"),
    onclick: () => openURL("https://gamersupps.gg/products/blue-razz-100-serving"),
    onmouseover: () => playTick(0.1)
  }), m("img.promoIcon", {
    src: UTILS.assetsUrl("/img/gsupps_icon_2.png"),
    onclick: () => openURL("https://gamersupps.gg/products/dragonfruit-punch-100-serving"),
    onmouseover: () => playTick(0.1)
  }), m("img.promoIcon", {
    src: UTILS.assetsUrl("/img/gsupps_icon_3.png"),
    onclick: () => openURL("https://gamersupps.gg/products/waifu-candy-100-serving"),
    onmouseover: () => playTick(0.1)
  }), m("img.promoIcon", {
    src: UTILS.assetsUrl("/img/gsupps_icon_4.png"),
    onclick: () => openURL("https://gamersupps.gg/products/misfits-melon"),
    onmouseover: () => playTick(0.1)
  }), m(".codeBtn", {
    src: UTILS.assetsUrl("/img/gsupps_icon_4.png"),
    onclick: function () {
      copyPromoCode(this, p14004);
    },
    onmouseover: () => playSelect(0.1)
  }, "Copy Code"), m(".codeBtn", {
    src: UTILS.assetsUrl("/img/gsupps_icon_4.png"),
    onclick: () => revealPromoCode(p14004),
    onmouseover: () => playSelect(0.1)
  }, "Reveal Code"), m("div", {
    style: "margin-top: 20px;font-size:17px;color: rgba(255,255,255,0.5);text-align: center;"
  }, ["Use code at ", m("span.promoLink", {
    onclick: () => openURL("https://gamersupps.gg/")
  }, "GamerSupps.GG"), " to claim your free item!"])];
  genericPopup(vA622, "promoPop");
};
window.copyPromoCode = function (p14005, p14006) {
  var v11519 = p14005.textContent;
  UTILS.copyToClipboard(p14006);
  p14005.textContent = "Copied";
  requestAnimationFrame(() => p14005.textContent = v11519, 1250);
};
window.revealPromoCode = function (p14007) {
  promoCode.removeAttribute("disabled");
  promoCode.setAttribute("readonly", true);
  promoCode.value = p14007;
};
function f1811(p14008) {
  var v11520 = Game.store.wheels[p14008].rarities;
  var v11521 = v11520.indexOf(UTILS.getRandom(v11520.filter(p14009 => p14009 > 0)));
  var v11522 = Game.store.getSpnItems(Game.store.wheels[p14008], v11521, null, config.currentSeason);
  UTILS.yateShuffle(v11522);
  return Game.store.skins[v11522[0]];
}
window.resetPops = function () {
  popupHolder.style.zIndex = 2147483645;
  popupHolder.style.display = "block";
  popupContent.style.display = "none";
  popupContent.style.backgroundColor = "#353535";
  itemViewPop.style.display = "none";
  bundlePop.style.display = "none";
  premiumPop.style.display = "none";
  spinHistoryPop.style.display = "none";
  genericPop.style.display = "none";
  genericPop.removeAttribute("class");
  if (genericPop.innerHTML) {
    m.render(genericPop, m.trust(""));
  }
  hidePolicePop();
  if (activeBundleSoundId) {
    SOUND.stop(activeBundleSoundId);
    activeBundleSoundId = null;
  }
};
window.clearPops = function (p14010) {
  resetPops();
  popupHolder.style.zIndex = 2147483647;
  popupHolder.style.display = "none";
};
window.contPopup = function (p14011, p14012, p14013) {
  genericPopup(p14011, "contPop", "width:" + (p14012 || "700px") + ";border:" + (p14013 || "") + ";");
};
window.genericPopup = function (p14014, p14015, p14016) {
  resetPops();
  if (p14015) {
    genericPop.setAttribute("class", p14015);
  }
  genericPop.setAttribute("style", p14016 || "");
  m.render(genericPop, typeof p14014 == "object" ? p14014 : m.trust(p14014));
  genericPop.style.display = "block";
  return genericPop;
};
function io_showPopup(p14017, p14018, p14019, p14020) {
  var vLS80 = "";
  if (p14018 && typeof p14018 == "object") {
    p14018 = p14018.join("<br>");
  }
  if (p14019 && typeof p14019 == "object") {
    p14019 = p14019.join("<br>");
  }
  if (p14017 == "SUCCESS") {
    if (!p14020) {
      p14020 = "Success";
    }
    vLS80 = "<div style='width:100%;text-align:center'><div><i class='material-icons' style='font-size:80px;color:#3be354'>done</i></div><div style='font-size:20px;color:rgba(255,255,255,0.5)'>" + (p14019 || "Success!") + "</div></div>";
  } else if (p14017 == "INFO") {
    if (!p14020) {
      p14020 = "Info";
    }
    vLS80 = "<div style='width:100%;text-align:center'><div><i class='material-icons' style='font-size:80px;color:rgba(255,255,255,0.9)'>info</i></div><div style='font-size:20px;color:rgba(255,255,255,0.9)'>" + (p14019 || "Warning!") + "</div></div>";
  } else {
    if (!p14020) {
      p14020 = "Error";
    }
    vLS80 = "<div style='width:100%;text-align:center'><div><i class='material-icons' style='font-size:80px;color:#e33b3b'>clear</i></div><div style='font-size:20px;color:rgba(255,255,255,0.5)'>" + (p14018 || i18n.get("social.market.failed")) + "</div></div>";
  }
  genericPopup(vLS80, p14017 == "INFO" ? "infoPop" : "responsePop");
}
function io_loadingPopup(p14021) {
  if (p14021 == null) {
    if (genericPop.classList.includes("loadingPop")) {
      clearPops();
    }
    return;
  }
  var vM2 = m("div", {
    style: "width:100%;text-align:center"
  }, [m("div", {
    class: "lds-ring sm"
  }, [m("div"), m("div"), m("div"), m("div")]), m("div", {
    style: "font-size:20px;color:rgba(255,255,255,0.5)"
  }, p14021)]);
  genericPopup(vM2, "loadingPop");
}
function f1814() {
  var vLSdivStylewidth100text = "<div style='width:100%;text-align:center;color:#fff;font-size:24px;margin-bottom:15px'><br>We are discontinuing this version of the Krunker Client. If you want to update your client to the latest version. Please download and install the new client</div>";
  vLSdivStylewidth100text += "<div><ul style='padding:0;display:flex;list-style:none;text-align:center;margin:0;margin-top:-10px'><li style='display: flex;flex-basis:200px;-webkit-box-flex:1;flex-grow:1;margin-right:10px'><a href='//client2.krunker.io/setup.exe?v=1.9.7' style='display:block;width:100%;padding-top:1em;'><img src ='./img/windows.png' style='width:80px;height:80px;display:block;margin:0 auto 10px;'>Windows Installer</a></li><li style='display: flex;flex-basis:200px;-webkit-box-flex:1;flex-grow:1;'><a href='//client2.krunker.io/setup.dmg?v=1.9.7' style='display: block;width: 100%;padding-top:1em;'><img src ='./img/mac.png' style='width:80px;height:80px;display:block;margin:0 auto 10px;'>macOS Installer</a></li><li style='display: flex;flex-basis:200px;-webkit-box-flex:1;flex-grow:1;'><a href='//client2.krunker.io/setup.AppImage?v=1.9.7' style='display: block;width: 100%;padding-top:1em;'><img src ='./img/linux.png' style='width:80px;height:80px;display:block;margin:0 auto 10px;'>Linux Installer</a></li></ul></div>";
  genericPopup(vLSdivStylewidth100text, "clientPop");
}
window.confDelClan = function (p14022) {
  var v11523 = "<div style='color:#fff;font-size:20px;position:relative;margin-bottom:15px;'>" + i18n.t("windows.clan." + (p14022 ? "delete" : "leave")) + "</div><div id='confirmBtn' onclick='delClanConfirmed()' onmouseover='playTick(0.1)'>YES</div><div id='declineBtn' onclick='clearPops()' onmouseover='playTick(0.1)'>NO</div>";
  genericPopup(v11523, "confPop");
};
window.delClanConfirmed = function () {
  io_loadingPopup("Please Wait...");
  io.send("cln", 4, 1);
};
window.confKickClan = function (p14023, p14024) {
  var v11524 = "<div style='color:#fff;font-size:20px;position:relative;margin-bottom:15px;'>" + i18n.t("windows.clan.kick", p14023) + "</div><div id='confirmBtn' onclick='kickClanConfirmed(" + p14024 + ")' onmouseover='playTick(0.1)'>YES</div><div id='declineBtn' onclick='clearPops()' onmouseover='playTick(0.1)'>NO</div>";
  genericPopup(v11524, "confPop");
};
window.kickClanConfirmed = function (p14025) {
  clearPops();
  windows[12].kick(p14025);
};
var vA623 = ["I'm here to spin KR and bust hackers...and I'm all out of KR", "A fine day for Hacker Hunting", "What's a cops favourite food? I DONUT know...", "A really good Detective never gets married", "I love this song..."];
var vA624 = ["You look Strong. Why don't you join us?", "Sign In to Join the Fight against the Hackers!", "Your Level isn't High enough to Join us. Call Us if you find a Hacker!", "Welcome Back Officer. Let's see who needs our help today..."];
window.hidePolicePop = function () {
  if (policePop.style.display == "block") {
    updateClassPreview();
    SOUND.stop("ambient_9");
  }
  policePop.style.display = "none";
};
var vLN01882 = 0;
window.switchKPDTab = function (p14026) {
  vLN01882 = p14026;
  shoPolicePop();
};
window.shoPolicePop = function () {
  resetPops();
  popupHolder.style.zIndex = 20;
  policePop.style.display = "block";
  var vLN01883 = 0;
  if (account) {
    if (account.isMod || account.isDeputy) {
      vLN01883 = 3;
    }
  } else {
    vLN01883 = 1;
  }
  vO349 = {
    name: "Officer Buddy",
    classN: account && account.isDeputy ? "Deputy" : account && account.isMod ? "Marshal" : "Officer",
    class: 5,
    back: 1487,
    body: -1,
    hat: 1890,
    head: -1,
    dye: 1891,
    face: 1842,
    pet: -1,
    waist: -1
  };
  updateClassPreview();
  SOUND.play("ambient_9", 0.14, true);
  vLN01889 = UTILS.randInt(15000, 30000);
  io_showSpeechBubble(vA624[vLN01883], 3400, true);
  var vLS81 = "";
  if (vLN01883 == 3) {
    var vLSdivClassmenuTabsNewS = "<div class='menuTabsNew' style='margin-top:10px;table-layout: fixed;'>";
    for (var vLN01884 = 0; vLN01884 < config.kpdTabs.length; ++vLN01884) {
      vLSdivClassmenuTabsNewS += "<div class='menuTabNew" + (vLN01882 == vLN01884 ? " tabANew" : "") + "' onclick='switchKPDTab(" + vLN01884 + ")'>" + config.kpdTabs[vLN01884].n + "</div>";
    }
    vLSdivClassmenuTabsNewS += "</div>";
    vLS81 = "<div style='margin-top:0px;color:rgba(0,0,0,0.6)'>When responding to a <b>Distress Call</b>, please remember to follow the <a href='./docs/kpd.txt' class='menuLink' style='font-size:15px'>Mod Rules</a></div>" + vLSdivClassmenuTabsNewS + "<div id='kpdCalls'>Loading...</div>";
    io.send("kpd", vLN01882 + 1);
  } else {
    var vLN01885 = 0;
    if (account) {
      vLN01885 = (account.jobRatingPos || 1) / (account.jobRating || 1);
    }
    var vLS63de26 = "#63de26";
    if (vLN01885 <= 0.7) {
      vLS63de26 = "#f7d31e";
    }
    if (vLN01885 <= 0.5) {
      vLS63de26 = "#fc3232";
    }
    vLS81 = "<div style='color:rgba(0,0,0,0.6);font-size: 23px;'>The <b>K.P.D</b> allows you to <b>Combat & Report Hackers</b> in an easier way. <div style='height:15px'></div>If you suspect that there is a Hacker in your Current Lobby you can <b>Call for Aid by pressing the K.P.D Icon on the player list</b>. <div style='height:15px'></div>Any Active <b>Moderators</b> will then be able to respond to your call from a list of Active Distress calls & Deal with the Hacker accordingly.</div><div style='height:15px'></div>";
    vLS81 += account ? "<div id='trustProg'><div id='trustProgHD'>" + ((account.jobRatingPos || 0) + "/" + (account.jobRating || 0)) + " Helpful Reports</div><div id='trustPrgHD' style='width:" + vLN01885 * 100 + "%;background-color:" + vLS63de26 + "'></div></div>" : "";
    var vLN2011 = 20;
    vLS81 += "<div style='margin-top:20px;margin-bottom:20px;font-size:25px;color: #858585;'>";
    vLS81 += vLN01883 ? "Sign-in to apply for K.P.D" : (account.jobRatingPos || 0) >= vLN2011 && vLN01885 > 0.7 ? "You may qualify to become a K.P.D officer. Submit a application <a href='https://forms.gle/1xy2LznPkYn9gh8Q7' target='_blank' style='color:#fff'>here</a>" : vLN2011 + " positive reports are required to apply.";
    vLS81 += "</div>";
  }
  var v11525 = "<div style='font-size:30px;margin-bottom:12px;color:#858585'>Krunker Police Department</div>" + (account && account.role > 1 ? "<div class='kpdRank'>" + (account.role == 2 ? "Marshal" : "Deputy") + "</div>" : "") + vLS81;
  policePopC.innerHTML = v11525;
};
window.kpdSubmit = function () {
  io_loadingPopup("Loading...");
  var v11526 = document.getElementById("kpdDiscord");
  var v11527 = document.getElementById("kpdExplain");
  if (account && account.level >= config.minKDFLvl && !account.hack) {
    if (v11526 && v11526.value.length) {
      if (v11527 && v11527.value.length) {
        if (account && (account.isMod || account.isDeputy)) {
          return io_showPopup(null, "Already K.P.D");
        } else {
          io.send("kpdA", v11526.value, v11527.value);
          return;
        }
      } else {
        return io_showPopup(null, "Invalid Reason");
      }
    } else {
      return io_showPopup(null, "Invalid Discord");
    }
  } else {
    return io_showPopup(null, "Requires Lvl " + config.minKDFLvl);
  }
};
var v11528 = false;
var v11529;
window.confirmPolice = function (p14027, p14028) {
  if (!v11528) {
    var v11530 = "<div style='color:rgba(255,255,255,0.6);font-size:20px;margin-bottom:15px;'>Only call the <b>K.P.D</b> if you strongly suspect <b>" + p14027 + "</b> of using Hacks. <div style='height:10px'></div>False Reports can result in a Ban or Loss of Perms.</div><div id='confirmBtn' style='width:142px;margin-right:5px' onclick='callPolice(`" + p14027 + "`,`" + p14028 + "`)'>Call<span class='material-icons' style='color:#fff;margin-left:10px;font-size:28px;vertical-align:bottom;margin-bottom:1px'>call</span></div><div id='declineBtn' style='width:142px;margin-left:3px' onclick='clearPops()'>Cancel</div>";
    genericPopup(v11530, "polConfPop");
  }
};
window.callPolice = function (p14029, p14030) {
  if (!v11528) {
    clearPops();
    v11528 = true;
    v11544 = false;
    vLN01890 = 0;
    SOUND.play("dial_0", 0.2);
    vLN01892 = 700;
    SOUND.play("whoosh_0", 0.1);
    io_addChat(-1, null, "Calling K.P.D ...", 2);
    phoneImg.style.marginBottom = "0px";
    io.send("kpd", 0, {
      id: p14030
    });
  }
};
window.policeJoin = function (p14031, p14032, p14033, p14034) {
  SOUND.play("siren_1", 0.1);
  saveVal("queuePort", p14034);
  saveVal("queueHost", p14033);
  saveVal("bpt", p14032);
  saveVal("gId", p14031);
  window.switchServer(p14031);
};
window.callSort = (p14035, p14036) => 0;
window.policeRes = function (p14037, p14038, p14039) {
  p14039 = p14039 || {};
  if (p14037 == 0) {
    v11528 = false;
    SOUND.stop("ring_0");
    if (p14038 == "reported") {
      SOUND.play("siren_1", 0.1);
      p14038 = "Reported " + p14039.n + " to the K.P.D";
      v11544 = true;
      requestAnimationFrame(function () {
        phoneImg.style.marginBottom = "-700px";
        SOUND.play("whoosh_0", 0.1);
      }, 2200);
    } else {
      SOUND.play("busy_0", 0.1);
      phoneImg.style.marginBottom = "-700px";
      SOUND.play("whoosh_0", 0.1);
    }
    io_addChat(-1, null, p14038, 2);
  }
  if (p14037 == 1) {
    var v11542 = document.getElementById("kpdCalls");
    if (v11542) {
      var v11543 = p14039.length ? "" : "No Active Distress Calls";
      if (p14039.length) {
        p14039 = p14039.sort(function (p14040, p14041) {
          var v11533 = (p14040.jop || 1) / (p14040.jor || 1);
          var v11534 = (p14041.jop || 1) / (p14041.jor || 1);
          var v11535 = 1 + (p14040.jop || 0);
          if (v11533 <= 0.7) {
            v11535 = 1;
          }
          if (v11533 <= 0.5) {
            v11535 = 0;
          }
          var v11536 = 1 + (p14041.jop || 0);
          if (v11534 <= 0.7) {
            v11536 = 1;
          }
          if (v11534 <= 0.5) {
            v11536 = 0;
          }
          return (v11536 || 0) - (v11535 || 0);
        });
        p14039 = p14039.sort(function (p14042, p14043) {
          return (p14043.typ || 0) - (p14042.typ || 0);
        });
        p14039 = p14039.sort(window.callSort);
        v11543 += "<table style=\"width:100%\">\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th style=\"font-size: 16px;\">Rating</th>\n\t\t\t\t\t\t<th style=\"font-size: 16px;\">Reporter</th>\n\t\t\t\t\t\t<th style=\"font-size: 16px;\">Suspect</th>\n\t\t\t\t\t\t<th style=\"font-size: 16px;\">Info</th>\n\t\t\t\t\t\t<th style=\"font-size: 16px;\">Join</th>\n\t\t\t\t\t</tr>";
        for (var vLN01888 = 0; vLN01888 < p14039.length; ++vLN01888) {
          var v11537 = Math.max(1, Math.floor(config.rankVar * Math.sqrt(p14039[vLN01888].cos || 0)));
          var v11538 = Math.max(1, Math.floor(config.rankVar * Math.sqrt(p14039[vLN01888].crs || 0)));
          var v11539 = (p14039[vLN01888].jop || 1) / (p14039[vLN01888].jor || 1);
          var vLS63de262 = "#63de26";
          if (v11539 <= 0.7) {
            vLS63de262 = "#f7d31e";
          }
          if (v11539 <= 0.5) {
            vLS63de262 = "#fc3232";
          }
          v11543 += "<tr>";
          v11543 += "<td><span class='kpdRepLvl' style='color:" + vLS63de262 + "'>" + ((p14039[vLN01888].jop || 0) + "/" + (p14039[vLN01888].jor || 0)) + "</span></td>";
          v11543 += "<td><span class='kpdRepLvl'>" + v11538 + "</span>\n\t\t\t\t\t\t<a target='_blank' href='/social.html?p=profile&q=" + p14039[vLN01888].can + "' class='menuLink' style='font-size:16px'>" + p14039[vLN01888].can + "</a>\n\t\t\t\t\t\t</td>";
          v11543 += p14039[vLN01888].con == "guest" || p14039[vLN01888].con == null ? "<td style='color: var(--red);'>Guest</td>" : "<td><span class='kpdRepLvl'>" + v11537 + "</span>\n\t\t\t\t\t\t<a target='_blank' href='/social.html?p=profile&q=" + p14039[vLN01888].con + "' class='menuLink' style='font-size:16px;color: var(--red);'>" + p14039[vLN01888].con + "</a>\n\t\t\t\t\t\t</td>";
          v11543 += "<td>\n\t\t\t\t\t\t<span style='color:#858585;margin-right:12px'>" + UTILS.getReadableTime(p14039[vLN01888].tim) + " ago</span>\n\t\t\t\t\t\t<span class='callRegion'>" + p14039[vLN01888].gco.split(":")[0] + "</span>\n\t\t\t\t\t</td>";
          v11543 += "<td>\n\t\t\t\t\t\t<span class='policeJoinB' onclick=\"policeJoin('" + p14039[vLN01888].gco + "','" + p14039[vLN01888].tok + "','" + p14039[vLN01888].hos + "','" + p14039[vLN01888].por + "')\">Join</span>\n\t\t\t\t\t</td>";
          v11543 += "</tr>";
        }
        v11543 += "</table>";
      }
      v11542.innerHTML = v11543;
    }
  }
  if (p14037 == 2) {
    var v11542 = document.getElementById("kpdCalls");
    if (v11542) {
      var v11543 = p14039.length ? "" : "No Data";
      if (p14039.length) {
        v11543 += "<table style=\"width:100%\">\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th style=\"font-size: 16px;\">Moderator</th>\n\t\t\t\t\t\t<th style=\"font-size: 16px;\">Action</th>\n\t\t\t\t\t\t<th style=\"font-size: 16px;\">Suspect</th>\n\t\t\t\t\t\t<th style=\"font-size: 16px;\">Time</th>\n\t\t\t\t\t</tr>";
        for (var vLN01888 = 0; vLN01888 < p14039.length; ++vLN01888) {
          v11543 += "<tr>\n\t\t\t\t\t\t<td><a target='_blank' href='/social.html?p=profile&q=" + p14039[vLN01888].modn + "' class='menuLink' style='font-size:16px'>" + p14039[vLN01888].modn + "</a></td>\n\t\t\t\t\t\t<td><span style='color:#858585'>" + (p14039[vLN01888].htag == 1 ? "tagged" : "untagged") + "</span></td>\n\t\t\t\t\t\t<td><a target='_blank' href='/social.html?p=profile&q=" + p14039[vLN01888].hckn + "' class='menuLink' style='font-size:16px;color: var(--red);'>" + p14039[vLN01888].hckn + "</a></td>\n\t\t\t\t\t\t<td><span style='color:#858585;'>" + UTILS.getDate(p14039[vLN01888].dat, true) + " ago</span></td>\n\t\t\t\t\t</tr>";
        }
        v11543 += "</table>";
      }
      v11542.innerHTML = v11543;
    }
  }
  if (p14037 == 3) {
    var v11542 = document.getElementById("kpdCalls");
    if (v11542) {
      var v11543 = p14039.length ? "" : "No Data";
      var vA625 = ["1day", "3day", "7day", "14day", "30day", "90day", "alltime"];
      if (p14039.length) {
        v11543 += "<table style=\"width:100%\">\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th style=\"font-size: 16px;\">Range</th>\n\t\t\t\t\t\t<th style=\"font-size: 16px;\">Tag Count</th>\n\t\t\t\t\t</tr>";
        for (var vLN01888 = 0; vLN01888 < vA625.length; ++vLN01888) {
          v11543 += "<tr>\n\t\t\t\t\t\t<td><span style='color:#858585'>" + vA625[vLN01888] + "</span></td>\n\t\t\t\t\t\t<td><span style='color:#858585'>" + p14039[0][vA625[vLN01888] + "Entries"] + "</span></td>\n\t\t\t\t\t</tr>";
        }
        v11543 += "</table>";
      }
      v11542.innerHTML = v11543;
    }
  }
};
var v11544 = false;
var vLN01889 = 0;
var vLN01890 = 0;
var vLN01891 = 0;
var vLN01892 = 0;
function updateMenuAmbientPopups(p14044) {
  if (phoneImg.style.marginBottom == "0px") {
    vLN01892 -= p14044;
    if (vLN01892 <= 0 && !v11544) {
      vLN01892 = 2200;
      SOUND.play("ring_0", 0.2);
    }
    if (v11544) {
      vLN01890 -= p14044;
      if (vLN01890 <= 0) {
        vLN01891 = vLN01891 ? 0 : 1;
        phoneImg.src = "./img/phone_" + (vLN01891 ? "r" : "b") + ".png";
        vLN01890 = UTILS.randInt(100, 300);
      }
    }
  }
  if (policePop.style.display == "block") {
    vLN01889 -= p14044;
    if (vLN01889 <= 0) {
      vLN01889 = UTILS.randInt(15000, 30000);
      io_showSpeechBubble(vA623[UTILS.randInt(0, vA623.length - 1)], 3400, true);
    }
  }
}
window.updateDropsScroll = function (p14045, p14046) {
  var v11545 = document.querySelector(".dropsCols");
  if (v11545) {
    var vLN315 = 3;
    var v11546 = v11545.children[0].scrollWidth;
    var v11547 = (v11545.children.length - 1) * v11546 - v11545.clientWidth;
    var v11548 = v11545.scrollLeft + p14045 * (v11546 * (p14046 || vLN315));
    var v11549 = v11545.clientWidth + v11545.scrollLeft;
    var v11550 = !(v11548 <= 0) || p14045 != -1;
    var v11551 = !(v11549 >= v11547) || p14045 != 1;
    v11545.scrollLeft = v11548;
    var v11552 = document.querySelectorAll(".dropsSliderBtn");
    if (v11552) {
      v11552[0].classList.toggle("disabled", !v11550);
      v11552[1].classList.toggle("disabled", !v11551);
    }
  }
};
window.updateDropsScrollWheel = () => updateDropsScroll(window.event.deltaY > 0 ? -1 : 1);
window.dropsPopup = function () {
  var v11553 = UTILS.getDropsTime();
  if (v11553[2]) {
    lastPriorityPopupTime = Date.now();
    var v11554 = config.twitchEvents[v11553[3]];
    var v11555 = Game.store.wheels.find(p14047 => p14047.twitch);
    var v11556 = Game.store.skins.filter(p14048 => p14048 && p14048.event == v11553[3] && p14048.rarity >= rarities.EPIC);
    if (v11554.randDrop) {
      v11556 = [];
      for (var vLN01896 = 0; vLN01896 < v11554.rarities.length; ++vLN01896) {
        v11556.push({
          name: Game.store.rarities[v11554.rarities[vLN01896]].name + (v11554.type ? " " + v11554.type : "") + " Drop",
          rarity: v11554.rarities[vLN01896],
          thumbnail: UTILS.assetsUrl("img/drops/drop_" + v11554.rarities[vLN01896] + ".png"),
          randDrop: true
        });
      }
    }
    var v11557 = v11556.sort(() => Math.random() - Math.random());
    var v11558 = "<div class=\"dropsPopHeader\">" + (v11554.titleName ? "<div class='dropsActive'>" + v11554.name + "</div>" : "<div class='dropsActive'>Twitch <span style='color: #eaf5ff;'>" + (v11554.charity ? "Charity Event!" : "Drops Are Back!") + "</span></div>") + "</div>";
    if (v11554.streamers) {
      v11558 += "<div style='color: rgba(0,0,0,0.5);font-size: 16px;'>Watch ";
      for (var vLN01894 = 0; vLN01894 < v11554.streamers.length; vLN01894++) {
        v11558 += "<a href='https://www.twitch.tv/" + v11554.streamers[vLN01894] + "' target='_blank' style='color: #9661f7!important;text-decoration: underline;' onmouseenter='playTick()'>" + v11554.streamers[vLN01894] + "</a>";
        if (vLN01894 < v11554.streamers.length - 1) {
          v11558 += ", ";
        }
      }
      v11558 += " to earn Exclusive Items & to Support Charity!</div>";
    } else {
      v11558 += "<div style='color: rgba(0,0,0,0.5);font-size: 16px;'><a href='https://www.twitch.tv/directory/game/Krunker' target='_blank' style='color: #9661f7!important;text-decoration: underline;' onmouseenter='playTick()'>Watch</a> your favorite Krunker Streamers to earn " + (v11554.type || "Unique") + " Items" + (v11554.charity ? " & to Support Charity" : "") + "!</div>";
    }
    if (v11554.desc) {
      v11558 += "<div style='color: rgba(255,255,255,0.5);font-size: 13px;margin-top: 5px;'>" + v11554.desc + "</div>";
    }
    v11558 += "<div style='margin-top:10px;'>";
    v11558 += "<div class=\"dropsSliderH\">\n\t\t\t<div class=\"dropsSliderBtn disabled\" onmouseenter=\"playTick(0.1);\" onmousedown=\"playSelect(0.1);updateDropsScroll(-1);\">\n\t\t\t\t<div class=\"dropsSliderArrow\"></div>\n\t\t\t</div>\n\t\t</div>";
    v11558 += "<div class=\"dropsCols\" onwheel=\"updateDropsScrollWheel();\">";
    var vA626 = [];
    for (var vLN01896 = 0; vLN01896 < v11557.length; ++vLN01896) {
      player = v11557[vLN01896];
      v11558 += "<div class='dropsCol'>";
      v11558 += "<div class='dropCard" + (player.rarity == rarities.CONTRABAND ? "" : " blackShad") + (RENDER.rarityAnim && Game.store.rarities[player.rarity].animate ? " rainbow" : "") + "' style='border:4px solid" + Game.store.rarities[player.rarity].color + "' onmouseenter='playTick()'" + (player.randDrop ? ">" : "onclick='viewItem(" + player.index + ", true)'>") + ("<div class=\"dropTxt\" style=\"color:" + Game.store.rarities[player.rarity].color + "\">" + player.name + "</div>");
      if (player && player.type == itemTypes.SPRAY) {
        if (player.frames && vA626.indexOf(player.frames) == -1) {
          vA626.push(player.frames);
        }
        v11558 += "<div draggable='false' class='dropImgSpray' style='background: url(&quot;" + player.thumbnail + "&quot;) -1px;" + UTILS.getFrameAnim(player, "dropImgAnm") + "'></div>";
      } else {
        v11558 += "<img draggable='false' class='dropImg" + (player.type == itemTypes.PLAYER_CARD ? "P" : "") + (player.rgb ? " rgbHue" : "") + "' src='" + player.thumbnail + "' />";
      }
      v11558 += "</div>";
      v11558 += "</div>";
    }
    v11558 += "</div>";
    v11558 += "<div class=\"dropsSliderH\">\n\t\t\t<div class=\"dropsSliderBtn\" onmouseenter=\"playTick(0.1);\" onmousedown=\"playSelect(0.1);updateDropsScroll(1);\">\n\t\t\t\t<div class=\"dropsSliderArrow right\"></div>\n\t\t\t</div>\n\t\t</div>";
    v11558 += "</div><div class='viewDrops' onclick='openURL(&quot;/?twitch_info&quot;)' style='width: 115px;' onmouseenter='playTick()'>View All</div>";
    v11558 += "<div class='viewDrops' onclick='showDrops()' onmouseenter='playTick()'>Check/Redeem</div>";
    v11558 += "<div class='viewDrops' onclick='openURL(&quot;https://youtu.be/ioLRZL3LDuk&quot;)' onmouseenter='playTick()'>Guide</div>";
    v11558 += "</div><div class='eventTimer'>Event " + (v11553[0] > 0 ? "starts" : "ends") + " in " + UTILS.getReadableTime(v11553[0] > 0 ? v11553[0] : v11553[1]) + "</div>";
    if (vA626.length) {
      v11558 += "<style>";
      for (var vLN01896 = 0; vLN01896 < vA626.length; vLN01896++) {
        v11558 += "@keyframes dropImgAnm" + vA626[vLN01896] + " {100%{background-position:-" + vA626[vLN01896] * 140 + "px}}";
      }
      v11558 += "</style>";
    }
    genericPopup("<div style='text-align:center'>" + v11558 + "</div>", "dropsPop");
    saveVal("dropPop", Date.now());
  }
};
window.pfpPopup = function (p14049) {
  if (!account) {
    return io_showPopup(null, i18n.t("account.login.required"));
  }
  if (account.premiumT <= 0) {
    return io_showPopup(null, "Must have premium");
  }
  var vLSdivClasspubHedUpload = "<div class='pubHed'>Upload or Update Profile Pic</div>";
  vLSdivClasspubHedUpload += "<div style='color: rgba(255,255,255,0.4);font-size:18px' id='pfpH'><input onclick='selectFile(&quot;pfp&quot;)' type='button' id='pfpBtn' style='cursor:pointer' value='Select'><input id='pfp' name='profilepic' type='file' accept='image/png' style='width:1px;visibility:hidden;' onchange='updateFile(this.id)'><span style='color: rgba(255,255,255,0.4);margin-left:10px;font-size: 14px;' id='pfpName'>Image (.png) - Max " + config.maxPfp + "KB</span><span style='color: rgba(255,255,255,0.4);font-size: 14px;float:right;margin-top: 5px;' id='pfpSize'></span></div>";
  vLSdivClasspubHedUpload += "<div id='pfpResHolder' style='margin-top:8px;margin-bottom:5px;display:inline-block'><div id='pfpUpResp' style='color: rgba(255,255,255,0.3);display: inline-block;'>Inappropriate Images will result in a ban</div></div><div id='pubPfp' onclick='uploadProfilePic()'>Publish/Update</div>";
  genericPopup(vLSdivClasspubHedUpload, "pfpPop");
};
function f1816(p14050) {
  var v11559 = document.getElementById(p14050).files[0];
  return v11559;
}
window.updateFile = function (p14051, p14052) {
  var v11560 = null;
  try {
    v11560 = document.getElementById(p14051).files[0];
  } catch (e131) {}
  document.getElementById(p14051 + "Name").innerHTML = v11560 ? v11560.name : i18n.t("generic.failed");
  var vF1816 = f1816(p14051);
  var v11561 = vF1816.size / 1000;
  var v11562 = document.getElementById(p14051 + "Size");
  v11562.innerHTML = (v11561 || 0) + " <span style='color:rgba(0,0,0,0.8);'>kb</span>";
};
window.selectFile = function (p14053) {
  document.getElementById(p14053).click();
};
window.uploadProfilePic = function () {
  io_uploadResponse("Loading...", 1);
  var v11563 = null;
  try {
    v11563 = document.getElementById("pfp").files[0];
  } catch (e132) {}
  if (v11563) {
    var v11564 = new FileReader();
    v11564.readAsDataURL(v11563);
    v11564.onload = function () {
      var v11565 = UTILS.thumbnailSize(v11564.result);
      if (v11565 > config.maxPfp) {
        io_uploadResponse(i18n.t("image.upload.limit", config.maxPfp), 1);
        return;
      } else {
        io.send("uploadP", v11564.result);
        return;
      }
    };
    v11564.onerror = function () {
      io_uploadResponse("Picture Error", 1);
    };
  } else {
    io_uploadResponse("Upload Error", 1);
  }
};
window.confPremium = function (p14054) {
  var v11566 = Game.store.premium[p14054];
  var v11567 = "<div class='pubHed'>Confirmation</div><div style='color:#fff;font-size:20px;position:relative;margin-bottom:15px;'>" + i18n.t("windows.store.premium.purchase", v11566.val) + "</div><div id='confirmBtn' onclick='logBtnFRVR(`buy_premium_confirm`);premiumConfirmed(" + p14054 + ")' onmouseover='playTick(0.1)'>YES</div><div id='declineBtn' onclick='clearPops()' onmouseover='playTick(0.1)'>NO</div>";
  genericPopup(v11567, "confPremiumPop");
};
window.premiumConfirmed = function (p14055) {
  io_loadingPopup("Please Wait...");
  io.send("prm", p14055);
};
window.selectPremium = function (p14056, p14057) {
  if (Game.store.premium[p14056]) {
    CONTROLS.idleTimer = 0;
  }
  if (!account) {
    showWindow(5);
    return;
  }
  var v11568 = document.getElementById("premiumCreatorCode") || {};
  if (!p14057 && v10514) {
    return io_showPopup(null, "Invalid Steam Account");
  }
  if (p14057 && v10514) {
    var v11569 = !!window.ClientSession && !!window.ClientSession.settings && !!window.ClientSession.settings.gameCap && !!window.ClientSession.settings.gameCap.val;
    if (!v11569) {
      return io_showPopup(null, "Game Capture must be enabled to use Steam Purchase");
    }
    io.send("stppV", p14057 + "", p14056, v11568.value || null);
  } else {
    io.send("xstp", p14056, v11568.value || null, SETTINGS.list.lang.val, null, null, window.paymentsChannelId);
  }
};
window.premiumPopup = function (p14058) {
  var v11570 = Game.store.premium[p14058];
  if (v11570) {
    var v11571 = JSON.parse(getSavedVal("krk_cc") || "{}");
    if (v11571 && Date.now() - v11571.t >= config.creatorReset) {
      deleteVal("krk_cc");
      v11571 = null;
    } else {
      v11571 = v11571.code;
    }
    var v11572 = account && account.refCode ? account.refCode : null;
    if (v11572 && (v11572 + "").toLowerCase() == "krunker") {
      v11572 = null;
    }
    var v11573 = v11571 || v11572 || null;
    const v11574 = config.premiumBenifits.slice(0, 10);
    var v11575 = "<div class='bundlPopImg' style='background:url(" + UTILS.assetsUrl("/img/prem_bg.png") + ");background-size: cover;background-position: center;'></div><div class='bundlPopSidH'><div class='bundlPopNam'>" + v11570.val + " days of Premium</div>";
    v11575 += "<div class='bundlPopInfo'>" + v11574.map(p14059 => "<li>" + p14059 + "</li>").join("") + "<li>& more</li></div>";
    v11575 += "<div class='bundlCreatorH' style='margin-top: 5px;'><div class='bundlCreatorText'>" + i18n.t("windows.store.creator") + "</div><div><input type='text' id='premiumCreatorCode' class='smlInput' " + (v11573 ? "value='" + v11573 + "'" : "placeholder='Enter Creator Code'") + " " + (v11571 ? "disabled" : "") + "/><div id='premiumCreatorCodeBtn' style='background-color:" + (v11571 ? "#eb5656" : "#41c300") + "' onclick='creatorCodeAction(" + (v11571 ? 0 : 1) + ", 2)'>" + (v11571 ? "Remove" : "Save") + "</div></div></div>";
    v11575 += "<div class='bundlPopBuyH'><div class='bundlPopBuyC' onclick='selectPremium(" + p14058 + ")'>Buy - " + v11570.price + " USD</div></div></div>";
    resetPops();
    premiumPop.innerHTML = v11575;
    premiumPop.style.display = "block";
  }
};
Object.defineProperty(window, "changeName", {
  writeable: false,
  value: function () {
    io_loadingPopup("Please Wait...");
    var v11576 = document.getElementById("displayN");
    if (account && account.premiumT) {
      io.send("nme", v11576 && v11576.value.length ? v11576.value : null);
    } else {
      io_showPopup(null, "Premium required");
    }
  }
});
Object.defineProperty(window, "clearName", {
  writeable: false,
  value: function () {
    io_loadingPopup("Please Wait...");
    if (account && account.premiumT) {
      io.send("nme");
    } else {
      io_showPopup(null, "Premium required");
    }
  }
});
function io_tradeResponse(p14060, p14061, p14062, p14063) {
  if (p14062 == 0) {
    f1820(p14061);
  } else if (p14062 == 1) {
    document.exitPointerLock();
    windows[36].trader = p14061;
    windows[36].active = true;
    windows[36].inv = p14063[0];
    if (account) {
      account.skins = UTILS.convertInv(p14063[0] || []);
    }
    windows[36].otherInv = p14063[1];
    showWindow(37);
  } else if (p14062 == 2) {
    windows[36].canceled();
  } else if (p14062 == 3) {
    windows[36].accepted(p14061);
  } else if (p14062 == 4) {
    windows[36].process(p14061);
  } else if (p14062 == 5) {
    windows[36].updateButtons();
  }
  if (p14060) {
    io_addChat(-1, null, p14060, 2);
  }
}
function io_tradeAResponse(p14064, p14065, p14066, p14067) {
  windows[36].active = false;
  windows[36].trader = null;
  if (p14064) {
    windows[36].failed(p14064);
  } else {
    io_updateFunds(p14065);
    windows[36].done();
    if (account) {
      if (p14066 && p14066.length) {
        for (var vLN01898 = 0; vLN01898 < p14066.length; vLN01898++) {
          p14066[vLN01898] = parseInt(p14066[vLN01898]);
          account.removeSkin(p14066[vLN01898]);
        }
      }
      if (p14067 && p14067.length) {
        for (var vLN01898 = 0; vLN01898 < p14067.length; vLN01898++) {
          p14067[vLN01898] = parseInt(p14067[vLN01898]);
          account.addSkin(p14067[vLN01898]);
        }
      }
    }
  }
}
function io_updateTradeResponse(p14068, p14069, p14070, p14071) {
  if (p14069) {
    windows[36].addItem(p14070, p14068, p14071);
  } else {
    windows[36].removeItem(p14070, p14068, p14071);
  }
  windows[36].updateButtons();
}
window.acceptRequest = function (p14072) {
  io.send("trd", p14072, 1);
};
function f1820(p14073) {
  var v11577 = Game.players.findBySid(p14073);
  if (v11577) {
    io_addChat(-1, v11577.alias, p14073, 3);
  }
}
function f1821(p14074, p14075, p14076) {
  var v11578 = "<div class='reqW" + (p14076 ? " login" : "") + "'" + (p14076 ? " onclick='showWindow(5)'" : "") + "><i class='material-icons reqWIcon'>clear</i><div class='reqWLvl'>" + (p14076 ? "LOGIN REQUIRED" : "LEVEL " + p14074 + " REQUIRED") + "</div><div class='reqWTxt'>" + p14075 + "</div></div>";
  return v11578;
}
window.openSales = function (p14077) {
  f1822(window.event);
  openURL("/social.html?p=itemsales&i=" + p14077);
};
window.viewItem = function (p14078, p14079) {
  f1822(window.event);
  var v11579 = Game.store.skins[p14078];
  if (!v11579 || p14079) {
    return openSales(p14078);
  }
  var vLN01899 = 0;
  if (account && account.skins) {
    vLN01899 = account.getSkinCount(p14078) || 0;
  }
  resetPops();
  var v11580 = Game.store.rarities[v11579.rarity] || {};
  itemViewPop.style.display = "block";
  itemViewPop.style.border = "5px solid " + (v11580.color || "lightgrey");
  itemViewPop.classList.remove("rainbow");
  if (v11580.animate) {
    itemViewPop.classList.add("rainbow");
  }
  var v11581 = "<div class='itemViewName" + (v11579.rarity == rarities.CONTRABAND ? "" : " blackShad") + (RENDER.rarityAnim && v11580.animate ? " rainbow" : "") + "' style='color:" + (v11580.color || "#fff") + ";'>" + v11579.name + "</div>" + (v11579.blackM ? "<div class='itemViewSea' style='background:#00ffff'>Black Market</div>" : v11579.limT ? "<div class='itemViewSea' style='background:" + (Game.store.tags[v11579.limT] || "#41c300") + "'>" + v11579.limT + "</div>" : v11579.seas != config.currentSeason || v11579.limited && v11579.noSpin && !v11579.itemShop ? "<div class='itemViewSea'>Vaulted</div>" : v11579.limited || v11579.blocked ? "<div class='itemViewSea' style='background:#faa332;'>Limited</div>" : "") + (v11579.type == itemTypes.PLAYER_CARD ? "<div class='viewItemCard' style='background-image:url(" + v11579.thumbnail + ")'></div>" : "<iframe style='width: 100%;height: 450px;border:none;margin-top:10px;' src='/viewer.html?nobg&showcase=" + p14078 + "'></iframe>") + "<div class='itemViewCnt'>x" + (vLN01899 || 0) + " <span style='color:#ffffff8f;'>Owned</span></div><div id='itemInfoBtn' onclick='openSales(" + p14078 + ")'>More Information</div>";
  itemViewPop.innerHTML = v11581;
};
window.favItem = function (p14080, p14081) {
  f1822(window.event);
  var v11582 = Game.store.skins[p14081];
  if (v11582) {
    var v11583 = favoriteItemIds.indexOf(v11582.index);
    if (v11583 == -1) {
      favoriteItemIds.push(v11582.index);
    } else {
      favoriteItemIds.splice(v11583, 1);
    }
    p14080.dataset.col = v11583 == -1 ? "yellow" : "white";
    p14080.dataset.icon = v11583 == -1 ? "star" : "star_border";
    updateFavList(favoriteItemIds, true);
  }
};
window.openTwitch = function (p14082) {
  f1822(window.event);
  openURL("https://twitch.tv/" + p14082);
};
function f1822(p14083) {
  if (p14083) {
    p14083.stopPropagation();
    p14083.cancelBubble = true;
  }
}
window.quickJoinRegion = function (p14084, p14085) {
  let v11584 = windows[1].getServers(p14084, p14085);
  var vLN109 = 10;
  for (let vLN01900 = 0; vLN01900 < v11584.length && (client.switchGame(v11584[vLN01900], !FRVR.channelCharacteristics.allowNavigation), vLN109--, !(vLN109 <= 0)); vLN01900++) {
    ;
  }
};
const vA627 = ["creatorCodeI", "bundlCreatorCode", "premiumCreatorCode", "battlepassCreatorCode"];
Object.defineProperty(window, "creatorCodeAction", {
  writeable: false,
  value: function (p14086, p14087) {
    if (p14086 == 1) {
      var v11587 = document.getElementById(vA627[p14087]);
      if (v11587 && v11587.value.length) {
        saveVal("krk_cc", JSON.stringify({
          code: v11587.value,
          t: Date.now()
        }));
      }
    } else {
      deleteVal("krk_cc");
    }
    if (p14087 == 0) {
      updateWindow(14);
    } else {
      var v11586 = document.getElementById(vA627[p14087] + "Btn");
      if (v11586) {
        v11586.style.backgroundColor = p14086 == 1 ? "#eb5656" : "#41c300";
        v11586.setAttribute("onclick", "creatorCodeAction(" + (p14086 == 1 ? 0 : 1) + ", " + p14087 + ")");
        v11586.textContent = p14086 == 1 ? "Remove" : "Save";
      }
      if (p14086 == 0) {
        var v11587 = document.getElementById(vA627[p14087]);
        if (v11587) {
          v11587.value = "";
        }
      }
    }
  }
});
function f1823(p14088, p14089, p14090) {
  var vA628 = [];
  for (var vLN01901 = 0; vLN01901 < p14088.length; ++vLN01901) {
    vA628.push(p14088.length - vLN01901 + "d ago");
  }
  const vO364 = {
    labels: vA628,
    datasets: [{
      label: p14089.t1,
      backgroundColor: p14089.col + "55",
      borderColor: p14089.col,
      tension: 0,
      data: p14088
    }, {
      label: p14089.t2,
      backgroundColor: "#00000000",
      borderColor: "#00000000",
      tension: 0,
      data: p14088
    }]
  };
  new Chart(p14090, {
    type: "line",
    data: vO364,
    options: {
      responsive: true,
      title: {
        text: p14089.tit,
        display: true,
        fontSize: 25,
        fontFamily: "GameFont",
        fontColor: "rgba(255,255,255,0.7)",
        paddingTop: 20,
        paddingBottom: 20
      },
      legend: {
        display: false
      },
      elements: {
        point: {
          hoverRadius: 5,
          radius: 5
        }
      },
      tooltips: {
        mode: "index",
        intersect: false,
        titleFontSize: 20,
        bodyFontSize: 20,
        caretPadding: 12,
        caretSize: 9,
        yPadding: 19,
        xPadding: 12,
        callbacks: {
          label: p14089.label
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            fontColor: "white",
            fontSize: 22
          }
        }],
        xAxes: [{
          ticks: {
            fontColor: "white",
            fontSize: 14
          }
        }]
      },
      layout: {
        padding: {
          top: 30,
          right: 20,
          left: 10
        }
      },
      hover: {
        mode: "nearest",
        intersect: true
      }
    }
  });
}
function f1824(p14091) {
  document.querySelectorAll(".hideOnHost").forEach(function (p14092) {
    p14092.style.display = p14091 ? "none" : "inline-block";
  });
}
function f1825(p14093, p14094, p14095) {
  var vLS82 = "";
  var v11588 = p14094 == "map" ? "selectHostMap" : "loadUserMod";
  var v11589 = config[p14094 == "map" ? "mapTabs" : "modTabs"][p14095];
  var v11590 = null;
  if (p14095 == 0 && p14094 == "map") {
    p14093 = UTILS.shuffleArray(p14093);
    var vO365 = {};
    for (var vLN01905 = 0; vLN01905 < p14093.length; ++vLN01905) {
      if (!vO365[p14093[vLN01905].category]) {
        vO365[p14093[vLN01905].category] = [];
      }
      if (vO365[p14093[vLN01905].category].length < 8) {
        vO365[p14093[vLN01905].category].push(p14093[vLN01905]);
      }
    }
    p14093.length = 0;
    for (var v11591 in vO365) {
      if (vO365.hasOwnProperty(v11591)) {
        if (vO365[v11591].length < 8 && vO365[v11591].length >= 4) {
          vO365[v11591].length = 4;
        }
        p14093.push(...vO365[v11591]);
      }
    }
  }
  let v11592 = !!window.ClientSession && !!window.ClientSession.downloadPack;
  for (var vLN01903 = 0; vLN01903 < p14093.length; ++vLN01903) {
    if (p14093[vLN01903].dte) {
      p14093[vLN01903][p14094 + "_date"] = p14093[vLN01903].dte;
    }
    if (p14093[vLN01903].mna) {
      p14093[vLN01903][p14094 + "_name"] = p14093[vLN01903].mna;
    }
    if (p14093[vLN01903].mid != null) {
      p14093[vLN01903][p14094 + "_id"] = p14093[vLN01903].mid;
    }
    if (p14093[vLN01903].inf != null) {
      p14093[vLN01903][p14094 + "_info"] = p14093[vLN01903].inf;
    }
    if (p14093[vLN01903].minf != null) {
      p14093[vLN01903][p14094 + "_info"] = p14093[vLN01903].minf;
    }
    if (p14093[vLN01903].pli != null) {
      p14093[vLN01903][p14094 + "_player"] = p14093[vLN01903].pli;
    }
    if (p14093[vLN01903].ctn) {
      p14093[vLN01903].creatorname = p14093[vLN01903].ctn;
    }
    if (p14093[vLN01903].url) {
      p14093[vLN01903][p14094 + "_url"] = p14093[vLN01903].url;
    }
    if (p14093[vLN01903].vte != null) {
      p14093[vLN01903][p14094 + "_votes"] = p14093[vLN01903].vte;
    }
    if (p14093[vLN01903].upd != null) {
      p14093[vLN01903][p14094 + "_updatecounter"] = p14093[vLN01903].upd;
    }
    var v11593 = -1;
    if (p14093[vLN01903] && p14093[vLN01903][p14094 + "_date"]) {
      var vLN01904 = 0;
      var v11594 = new Date(p14093[vLN01903][p14094 + "_date"]);
      if (v11594) {
        vLN01904 = gameTime - (v11594.getTime() || 0);
      }
      v11593 = vLN01904 / 86400000;
    }
    var v11595 = UTILS.getAssetData(p14093[vLN01903][p14094 + "_info"]);
    var v11596 = p14093[vLN01903].fav || p14094 == "map" && v11589.fav || p14094 == "mod" && v11589.fav;
    if (p14094 == "mod" && p14093[vLN01903].mod_url == "ua") {
      p14093[vLN01903].mod_url = UTILS.userAssetsUrl("/md" + p14093[vLN01903].mod_id + "/mod.zip");
    }
    var v11597 = windows[9].playerData[UTILS.escapeStr(p14093[vLN01903].map_name)] || 0;
    var v11598 = UTILS.commaFormatNum(p14093[vLN01903].fund || 0);
    var v11599 = account && (account.canGlobalEdit || account.name == p14093[vLN01903].creatorname && v11589.owned);
    if (p14093[vLN01903].category && v11590 != p14093[vLN01903].category) {
      v11590 = p14093[vLN01903].category;
      vLS82 += "<div class='mapListCat'>" + v11590 + "</div>";
    }
    vLS82 += "<div style='display:inline-block;'><div class='mapListItem'><div class='mapActionOvrl'><div class='mapActionHol'><div class='mapActionB' title='" + (p14094 == "map" ? "Host" : "Load") + "' onclick='" + v11588 + "(&quot;" + p14093[vLN01903][p14094 + "_name"] + "&quot;,&quot;" + p14093[vLN01903].mod_url + "&quot;,&quot;" + p14093[vLN01903][p14094 + "_id"] + "&quot;,&quot;" + UTILS.cleanseString(p14093[vLN01903].creatorname) + "&quot;," + ~~(v11595 && v11595.t) + ")'>" + (p14094 == "map" ? "<span class='material-icons' style='font-size:70px;color:#fff;'>video_settings</span>" : "<span class='material-icons' style='font-size:70px;color:#fff;'>play_arrow</span>") + "</div><div class='mapActionSep'></div>" + (p14094 == "map" ? "<div class='hideOnHost mapActionB' onclick='openURL(&quot;/?play=" + p14093[vLN01903].map_name + "&quot;, 1)' title='Play' style='margin-top:-5px;'><span class='material-icons' style='font-size:80px;color:#fff;'>play_arrow</span></div><div class='mapActionSep' style='margin-left:2px'></div>" : "") + (p14094 == "map" && v11599 && v11589.owned ? "<div class='mapActionB' onclick='openEdit(&quot;" + UTILS.escapeStr(p14093[vLN01903].map_name) + "&quot;," + p14093[vLN01903].map_id + "," + p14093[vLN01903].fund + ")' title='Edit' style='margin-top:0px;'><span class='material-icons' style='font-size:70px;color:#fff;'>create</span></div>" : "<div class='mapActionB" + (v11596 ? "" : " sel") + "'onclick='favoriteM(" + (p14094 == "map" ? 0 : 1) + ",this, " + p14093[vLN01903][p14094 + "_id"] + ");'>" + (v11596 ? "<span class='material-icons' style='font-size:70px;color:#fff;'>star</span>" : "<span class='material-icons' style='font-size:70px;color:#fff;'>star_border</span>") + "</div>") + (p14094 == "mod" && v11592 ? "<div class='mapActionB'onclick='downloadPack(" + p14093[vLN01903][p14094 + "_id"] + ");'><span class='material-icons' style='font-size:70px;color:#fff;'>download</span></div>" : "") + "</div></div>" + (v11593 >= 0 && v11593 <= 7 ? "<div class='mapAgeD' style='background-image:" + (p14093[vLN01903][p14094 + "_updatecounter"] > 1 ? "linear-gradient(to right,#E040FB,#6240fb);" : "linear-gradient(to right,#fb9c40,#fb4040);") + "'>" + (p14093[vLN01903][p14094 + "_updatecounter"] > 1 ? "UPDATED" : "NEW!") + "</div>" : "") + (p14094 == "map" ? "<div class='mapsVotes' title='Players Online' id='pcnt_" + UTILS.escapeStr(p14093[vLN01903].map_name) + "' style='left:10px;right:unset'>" + v11597 + "<span style='color:#999999;'> online</span></div>" : "") + "<div style='height:200px;width:100%;overflow: hidden;'><img class='mapListThumb' loading='lazy' src='" + (v11595 && v11595.t ? UTILS.userAssetsUrl("/m" + (p14094 == "mod" ? "d" + p14093[vLN01903].mod_id : p14093[vLN01903][p14094 + "_id"]) + "/thumb.png") : p14093[vLN01903][p14094 + "_image"] || "./img/noimg.png") + "' /></div><div style='margin-top:5px;padding-left:5px;padding-right:5px;line-height:30px;margin-bottom:0px;'><div style='display:inline-block;max-width:250px;overflow:hidden;white-space:nowrap'><a href='javascript:;' onclick='openURL(&quot;https://krunker.io/social.html?q=" + p14093[vLN01903][p14094 + "_name"] + "&p=" + p14094 + "&quot;)' />" + p14093[vLN01903][p14094 + "_name"] + "</a></div><span style='font-size:15px;text-align:right;padding-right:2px;float:right;color:#fff;'>" + UTILS.formatNumYT(p14093[vLN01903][p14094 == "map" ? "map_pl" : "mod_votes"] || 0) + " <span style='color:rgba(255,255,255,0.5)'>" + (p14094 == "map" ? "plays" : "likes") + "</span></span></div></div>" + (p14093[vLN01903].friendname ? "<div class='likdByFrnd'><span class='material-icons' style='color:#fff;font-size:23px;vertical-align:middle;margin-right:6px;margin-top:-4px;'>thumb_up</span>liked by <span style='color:rgba(255,255,255,0.6);'>" + p14093[vLN01903].friendname + "</span></div>" : "<div style='height:10px;'></div>") + "</div>";
  }
  if (p14095 == 0 && p14094 == "map") {
    vLS82 += "<div class='mapListCat'>Popular Categories</div>";
    var vLS83 = "";
    for (var vLN01905 = 0; vLN01905 < config.mapCatsP.length; ++vLN01905) {
      vLS83 += "<div class='mapListItem' style='width:624px;height:130px;'><div class='mapLICat' onclick='windows[9].switchTab(7);mpCat.selectedIndex=" + (config.mapCats.indexOf(config.mapCatsP[vLN01905].n) + 1) + ";windows[9].searchMaps();' style='background:url(" + UTILS.assetsUrl("/img/backgrounds/gamecats/c_" + (config.mapCatsP[vLN01905].i || 0) + ".png") + ")'>" + config.mapCatsP[vLN01905].n + "</div></div>";
    }
    vLS82 += vLS83;
  }
  return vLS82;
}
function f1826(p14096, p14097) {
  var vLS84 = "";
  for (var vLN01906 = 0, v11600; vLN01906 < p14096.length; ++vLN01906) {
    v11600 = UTILS.getAssetData(p14096[vLN01906].mod_info);
    if (p14096[vLN01906].mod_url == "ua") {
      p14096[vLN01906].mod_url = UTILS.userAssetsUrl("/md" + p14096[vLN01906].mod_id + "/mod.zip");
    }
    vLS84 += "<div class='mapListItem'><div style='height:200px;width:100%;overflow: hidden;'><img class='mapListThumb' loading='lazy' src='" + (v11600 && v11600.t ? UTILS.userAssetsUrl("/m" + ("d" + p14096[vLN01906].mod_id) + "/thumb.png") : p14096[vLN01906].mod_image || "./img/noimg.png") + "' /></div><div style='margin-top:1px'><a href='javascript:;'>" + p14096[vLN01906].mod_name + "</a></div></div>";
  }
  return vLS84;
}
function f1827(p14098, p14099, p14100 = 5) {
  var v11601 = document.createElement("div");
  v11601.className = "tooltip";
  v11601.insertAdjacentHTML("beforeend", p14099);
  var v11602 = document.body.firstChild;
  v11602.parentNode.insertBefore(v11601, v11602);
  var v11603 = p14098.getBoundingClientRect();
  var v11604 = v11601.getBoundingClientRect();
  var v11605 = v11603.top - (v11604.height + p14100) - 4;
  var v11606 = v11603.left;
  v11601.setAttribute("style", "top:" + v11605 + "px;left:" + v11603.left + "px;");
}
window.createTip = function (p14101, p14102, p14103) {
  var vParseInt39 = parseInt(p14101.getAttribute("data-index"));
  var v11607 = Game.store.skins[vParseInt39];
  var v11608 = prices.estimateValue(vParseInt39);
  f1827(p14101, (v11607.lore ? "<div class='tooltipSub' style='font-style:italic;font-size:10px;'>" + v11607.lore + "</div>" : "") + "<div class='tooltipSub'><span style='color:" + (v11607.free ? "lightgrey" : Game.store.rarities[v11607.rarity || 0].color) + "'>" + v11607.name + "</span></div>" + (v11607.free ? "" : "<div class='tooltipSub' style='font-size:10px'>Est <span style='color: #FBC02D;'>" + (v11608 == null ? "Unknown</span>" : UTILS.commaNumber(v11608) + "</span> KR") + "</div>"));
};
window.createStreakTip = function (p14104) {
  var vParseInt40 = parseInt(p14104.getAttribute("data-index"));
  var v11609 = Game.streaks[vParseInt40];
  if (v11609) {
    f1827(p14104, "<div class='tooltipSub'><span style='color:#FBC02D'>" + v11609.name + "</span></div><div class='tooltipSub' style='font-style:italic;font-size:8px;max-width: 300px;'>" + v11609.desc + "</div>");
  }
};
window.createSpinHistoryTip = function (p14105) {
  var vParseInt41 = parseInt([...p14105.parentElement.children].indexOf(p14105));
  var v11610 = vA636[vParseInt41];
  if (v11610) {
    var v11611 = Game.store.skins[v11610.ind];
    if (v11611) {
      var v11612 = prices.estimateValue(v11611.index);
      var v11613 = new Date(v11610.dte);
      f1827(p14105, "<div class='tooltipSub'><span style='color:" + Game.store.rarities[v11611.rarity].color + "'>" + v11611.name + "</span></div><div class='tooltipSub' style='font-size:10px'>Est: <span style='color: #FBC02D;'>" + (v11612 == null ? "Unknown</span>" : UTILS.commaNumber(v11612) + "</span> KR") + "</div><div class='tooltipSub' style='font-size:10px'>Date: <span style='color: #FBC02D;'>" + UTILS.getReadableTime(Date.now() - v11613.getTime()) + " ago</span></div><div class='tooltipSub' style='font-size:10px'>Cost: <span style='color: #FBC02D;'>" + UTILS.commaNumber(v11610.fds || 0) + " KR</span></div>");
    }
  }
};
window.cancelTip = function () {
  var v11614 = document.querySelector(".tooltip");
  if (v11614) {
    v11614.remove();
  }
};
function f1828(p14106, p14107, p14108) {
  var v11615 = p14107 ? p14107 == 16 ? "skinImgP" : p14107 == 5 ? "skinImgD" : "skinImgC" : "skinImg";
  var v11616 = "<div id='itemSearchH'><div class='custBack' onclick='playSelect(0.1);goBackWindow(2)' onmouseenter='playTick();'><span class='material-icons custBackArr'>arrow_back</span></div><input id='itemSearch' type='text' placeholder='Search Item' onkeyup='searchItems(this)'><div class='winClose' onclick='playSelect(0.1);closWind()' onmouseenter='playTick();'><span class='material-icons winCloseArr'>close</span></div></div><div id='skinList' style='overflow-y: scroll;height: calc(100% - 95px);'><div class='skinCard blackShad' style='border:5px solid lightgrey' onmouseenter='playTick()' onclick='" + p14106 + "(-3)'>" + (p14107 == 3 ? "Combat Knife" : i18n.t("generic.none")) + "<div class='itemOwn'>" + i18n.t("generic.default") + "</div>" + (p14107 == 5 ? "" : "<div class='itemSea' style='opacity:0;'>Season 1</div>") + (p14108 ? "<div class='skinRandom blackShad'>X</div>" : "<img class='" + v11615 + "' src='" + UTILS.assetsUrl("/textures/previews/cosmetics/" + p14107 + "_default.png") + "'>") + "</div><div class='skinCard blackShad' style='border:5px solid lightgrey' onmouseenter='playTick()' onclick='" + p14106 + "(-2)'>" + i18n.t("generic.random") + "<div class='itemOwn' style='opacity:0;'>by ???</div>" + (p14107 == 5 ? "" : "<div class='itemSea' style='opacity:0;'>All Seasons</div>") + (p14108 ? "" : "<img class='" + v11615 + " skinSil' src='" + UTILS.assetsUrl("/textures/previews/cosmetics/" + p14107 + "_default.png") + "'>") + "<div class='skinRandom blackShad'>?</div></div>";
  for (var v11617 = [...f1799(account, true)].sort(function (p14109, p14110) {
      var v11618 = p14110.ind != null && Game.store.skins[p14110.ind] ? Game.store.skins[p14110.ind].rarity || 0 : 0;
      var v11619 = p14109.ind != null && Game.store.skins[p14109.ind] ? Game.store.skins[p14109.ind].rarity || 0 : 0;
      var v11620 = p14110.ind != null && Game.store.skins[p14110.ind] ? Game.store.skins[p14110.ind].seas || 1 : 0;
      var v11621 = p14109.ind != null && Game.store.skins[p14109.ind] ? Game.store.skins[p14109.ind].seas || 1 : 0;
      if (v11618 > v11619) {
        return 1;
      } else if (v11618 < v11619) {
        return -1;
      } else if (v11620 > v11621) {
        return 1;
      } else if (v11620 < v11621) {
        return -1;
      } else {
        return (p14110.ind || 0) - (p14109.ind || 0);
      }
    }).sort(function (p14111, p14112) {
      return ~~(favoriteItemIds.indexOf(p14112.ind) >= 0) - ~~(favoriteItemIds.indexOf(p14111.ind) >= 0);
    }).filter(p14113 => Game.store.skins[p14113.ind] && Game.store.skins[p14113.ind].type == p14107), vLN01907 = 0; vLN01907 < v11617.length; ++vLN01907) {
    player = Game.store.skins[v11617[vLN01907].ind];
    var v11622 = account && account.isDev || player.classIndex == null || player.classIndex == classIndex || Game.isSandbox;
    var v11623 = favoriteItemIds.indexOf(player.index) >= 0;
    v11616 += "<div class='skinCard" + (player.rarity == rarities.CONTRABAND ? "" : " blackShad") + (!player.free && RENDER.rarityAnim && Game.store.rarities[player.rarity].animate ? " rainbow" : "") + "' style='" + (player.free ? "border: 5px solid lightgrey" : "color:" + Game.store.rarities[player.rarity].color + ";border:5px solid" + Game.store.rarities[player.rarity].color) + "' onmouseenter='playTick()'" + (v11622 ? "onclick='" + p14106 + "(" + v11617[vLN01907].ind + ");cancelTip()' " : " ") + "data-index='" + v11617[vLN01907].ind + "' onmouseover='createTip(this)' onmouseout='cancelTip()'>" + (player.free ? "" : "<div class='itemCnt' data-badge='x" + v11617[vLN01907].cnt + "'></div>") + player.name + "<div class='itemOwn' style='z-index: 3;position: relative;'>" + (v11622 ? player.free ? i18n.t("windows.skins.default") : "by " + (player.creator || "Krunker.io") : i18n.t("windows.skins.classOnly", Game.classes[player.classIndex].name)) + "</div>" + (p14107 == 5 || player.free ? "" : "<div class='itemSea'>Season " + (player.seas || 1) + "</div>") + "<img loading='lazy' class='" + v11615 + (player.rgb ? " rgbHue" : "") + "' src='" + player.thumbnail + "' /><div class='selctInfoBtn' onmouseenter='playTick()'onclick='viewItem(" + v11617[vLN01907].ind + ")'>?</div><div class='selctFavBtn material-icons' onmouseenter='playTick()' data-col='" + (v11623 ? "yellow" : "white") + "' data-icon='" + (v11623 ? "star" : "star_border") + "' onclick='favItem(this, " + v11617[vLN01907].ind + ")'></div>" + (v11622 ? "" : "<div class='lockedSkin'><span class='material-icons' style='font-size: 55px;color:#fff'>lock</span></div>") + "</div>";
  }
  v11616 += "</div>";
  return v11616;
}
for (var vLN01908 = 0; vLN01908 < windows.length; ++vLN01908) {
  windows[vLN01908].html = "";
}
var vLN01909 = 0;
var activeSubTabWindowId = null;
Object.defineProperty(window, "updateWindow", {
  writeable: false,
  value: function (p14114, p14115) {
    if (windowHolder.style.display == "block") {
      if (vLN01909 == p14114 && p14114 != null) {
        showWindow(p14114, true, true);
      } else if (p14115) {
        showWindow(vLN01909, true);
      }
    }
  }
});
window.goBackWindow = function (p14116) {
  windows[p14116].goBack();
};
Object.defineProperty(window, "showWindow", {
  writeable: false,
  value: function (p14117, p14118, p14119) {
    if (UTILS.isNumber(p14117) && !(p14117 < 0)) {
      CONTROLS.idleTimer = 0;
      if (p14117) {
        var v11625 = vLN01909 && windows[vLN01909 - 1] ? windows[vLN01909 - 1].label || "home" : "home";
        var v11626 = p14117 && windows[p14117 - 1] ? windows[p14117 - 1].label || "home" : "home";
        if (v11625 != v11626) {
          logEventFRVR("win_open", {
            source: v11625,
            destination: v11626
          });
        }
      }
      if (Game && Game.mode && Game.mode.canTrade && p14117 != 37) {
        windows[36].cancel();
      }
      closeWindow(p14119);
      if (!p14118 && (!p14117 || windowHolder.style.display == "block" && p14117 == vLN01909)) {
        UI.toggleWindow(false, CONTROLS.gamepad.active);
        CONTROLS.inputChanger = null;
      } else {
        activeSubTabWindowId = p14117;
        UI.toggleMenu(true);
        let v11627 = windows[p14117 - 1];
        if (v11627.menuOpen && !p14119) {
          SOUND.play(v11627.menuOpen, 0.1);
        }
        menuWindow.className = v11627.extraCls ? v11627.extraCls : "";
        menuWindow.innerHTML = v11627.gen ? v11627.gen() : v11627.html;
        vLN01909 = p14117;
        v11627.closed = false;
        menuWindow.classList.toggle("stickyHeader", !!v11627.sticky);
        menuWindow.style.overflowY = windows[p14117 - 1].hideScroll ? "hidden" : "auto";
        if (v11627.forceScroll) {
          menuWindow.style.overflowY = "scroll";
        }
        menuWindow.style.width = v11627.width == null ? "" : UTILS.isString(v11627.width) ? v11627.width : v11627.width + "px";
        menuWindow.style.height = v11627.height ? v11627.height : "";
        menuWindow.style.maxHeight = v11627.maxHeight ? v11627.maxHeight : "";
        menuWindow.style.borderRadius = v11627.radius == null ? "" : v11627.radius + "px";
        menuWindow.classList.toggle("dark", true);
        menuWindow.classList.toggle("forceFill", !!v11627.forceFill);
        windowHolder.classList.toggle("popupWin", true);
        windowHeader.innerHTML = v11627.header;
        UI.toggleWindow(true, CONTROLS.gamepad.active);
        if (v11627.post) {
          v11627.post();
        }
      }
    }
  }
});
window.closWind = function () {
  UI.toggleWindow(false);
};
Object.defineProperty(window, "closeWindow", {
  writeable: false,
  value: function (p14120) {
    activeSubTabWindowId = null;
    if (vLN01909 && windows[vLN01909 - 1].close && !windows[vLN01909 - 1].closed) {
      windows[vLN01909 - 1].closed = true;
      windows[vLN01909 - 1].close();
    }
    if (vLN01909 && windows[vLN01909 - 1].menuOpen && !p14120) {
      SOUND.stop(windows[vLN01909 - 1].menuOpen);
    }
    updateClassPreview();
  }
});
window.openGuide = function (p14121) {
  guidePopupH.style.display = p14121 ? "block" : "none";
};
window.copyToClip = function (p14122, p14123) {
  UTILS.copyToClipboard(p14122);
  if (!p14123) {
    alert("Link Copied!");
  }
};
window.copyGameLink = function (p14124, p14125, p14126) {
  var v11628 = p14124.textContent;
  UTILS.copyToClipboard("http" + (location.hostname == "127.0.0.1" ? "" : "s") + "://" + location.host + "/?game=" + p14125 + (p14126 ? "&tm=" + p14126 : ""));
  p14124.textContent = i18n.t("menu.btn.invite.clicked");
  requestAnimationFrame(() => p14124.textContent = v11628, 1250);
};
window.playTick = function (p14127) {
  SOUND.play("hover_0", p14127 || 0.2);
};
window.playTickAndPreventRedraw = function (p14128) {
  window.playTick();
  p14128.redraw = false;
};
window.playSelect = function (p14129) {
  SOUND.play("select_0", p14129 || 0.15);
};
window.copyInviteLink = function (p14130) {
  UTILS.copyToClipboard("https://" + location.host + "/?game=" + v10544);
  inviteButton.textContent = i18n.t("menu.btn.invite.clicked");
  requestAnimationFrame(() => inviteButton.textContent = i18n.t("menu.btn.invite"), 1250);
  if (p14130) {
    io_addChat(-1, null, "Link Copied. Send it to someone to invite them", 2);
  }
};
Object.defineProperty(window, "muteUser", {
  writeable: false,
  value: function (p14131, p14132, p14133) {
    player = Game.players.findById(p14132);
    if (p14133 == 0) {
      var v11631 = mutedChatAccountIds.indexOf(player.accid);
      var v11632 = v11631 >= 0;
      if (p14131) {
        p14131.textContent = v11632 ? "chat" : "speaker_notes_off";
      }
      if (v11632) {
        mutedChatAccountIds.splice(v11631, 1);
      } else {
        mutedChatAccountIds.push(player.accid);
      }
      saveVal("mute_chat", mutedChatAccountIds);
    } else if (p14133 == 1) {
      var v11631 = mutedVoiceAccountIds.indexOf(player.accid);
      var v11632 = v11631 >= 0;
      if (p14131) {
        p14131.textContent = v11632 ? "record_voice_over" : "voice_over_off";
      }
      if (v11632) {
        mutedVoiceAccountIds.splice(v11631, 1);
      } else {
        mutedVoiceAccountIds.push(player.accid);
      }
      saveVal("mute_chat", mutedVoiceAccountIds);
    }
  }
});
Object.defineProperty(window, "punishPlayer", {
  writeable: false,
  value: function (p14134, p14135) {
    if (p14135 > 8 || p14135 == 2) {
      io.send("pnh", p14135, null);
    } else {
      for (var vLN01910 = 0; vLN01910 < Game.players.list.length; ++vLN01910) {
        player = Game.players.list[vLN01910];
        if (player.id == p14134) {
          io.send("pnh", p14135, player.id, !!SETTINGS.list.extraBan.val);
          break;
        }
      }
    }
  }
});
Object.defineProperty(window, "requestTrade", {
  writeable: false,
  value: function (p14136) {
    var v11633 = Game.players.list.find(p14137 => p14137.id == p14136);
    if (v11633) {
      io.send("strd", p14136);
    }
  }
});
Object.defineProperty(window, "focusPlayer", {
  writeable: false,
  value: function (p14138, p14139, p14140) {
    var v11634 = Game.players.list.find(p14141 => p14141.id == p14138);
    if (p14139 || p14140) {
      if (focusedPlayerId == p14138 && !p14140) {
        return clearFocus();
      }
      if (v11634) {
        io_addChat(-1, null, "Focusing - " + v11634.name, 2);
      } else if (currentKpdCase && currentKpdCase.sus == p14138 && p14140) {
        io_addChat(-1, null, "Auto Focusing Suspect", 2);
      }
    }
    focusedPlayerId = p14138;
    if (v11634 && v11634.active) {
      f1765();
      CONTROLS.spect.target = v11634;
      spectateCameraInitialized = false;
      io.send("fpSp", v11634.sid);
      f1766();
    }
    if (p14139 && p14139.firstChild) {
      window.updateWindow(23);
    }
  }
});
Object.defineProperty(window, "clearFocus", {
  writeable: false,
  value: function () {
    if (focusedPlayerId) {
      focusedPlayerId = null;
      f1765();
      window.updateWindow(23);
      io_addChat(-1, null, "Focus Cleared", 2);
    }
  }
});
Object.defineProperty(window, "copyUser", {
  writeable: false,
  value: function (p14142, p14143) {
    var v11635 = Game.players.list.find(p14144 => p14144 && p14144.id == p14143);
    var v11636 = p14142.innerHTML;
    UTILS.copyToClipboard("https://krunker.io/social.html?p=profile&q=" + v11635.name);
    p14142.innerHTML = i18n.t("menu.btn.invite.clicked");
    requestAnimationFrame(() => {
      if (p14142) {
        p14142.innerHTML = v11636;
      }
    }, 1250);
  }
});
Object.defineProperty(window, "banPlayer", {
  writeable: false,
  value: function (p14145) {
    var v11637 = Game.players.list.find(p14146 => p14146.id == p14145);
    var v11638 = "<div style='color:#fff;font-size:20px;position:relative;margin-bottom:15px;'>" + i18n.t("windows.playerlist.ban", v11637.alias) + "</div><div id='confirmBtn' onclick='banPlayerConfirmed(\"" + v11637.id + "\")' onmouseover='playTick(0.1)'>YES</div><div id='declineBtn' onclick='clearPops()' onmouseover='playTick(0.1)'>NO</div>";
    genericPopup(v11638, "confPop");
  }
});
Object.defineProperty(window, "flagPlayer", {
  writeable: false,
  value: function (p14147, p14148) {
    var v11639 = Game.players.list.find(p14149 => p14149.id == p14147);
    p14148 = p14148 == null ? v11639.isHacker ? 0 : 1 : parseInt(p14148);
    var v11640 = "<div style='color:#fff;font-size:20px;position:relative;margin-bottom:15px;'>" + i18n.t("windows.playerlist." + (p14148 ? "flag" : "unflag"), v11639.alias) + "</div><div id='confirmBtn' onclick='flagPlayerConfirmed(\"" + v11639.id + "\"," + p14148 + ")' onmouseover='playTick(0.1)'>YES</div><div id='declineBtn' onclick='clearPops()' onmouseover='playTick(0.1)'>NO</div>";
    genericPopup(v11640, "confPop");
  }
});
Object.defineProperty(window, "punishPopup", {
  writeable: false,
  value: function (p14150) {
    var v11641 = Game.players.list.find(p14151 => p14151.id == p14150);
    var v11642 = v11641.isHacker ? 0 : 1;
    var v11643 = "<div style='color:#fff;font-size:15px;position:relative;margin-bottom:15px;'>" + i18n.t("windows.playerlist.punish", v11641.alias) + "</div><div class='takeActionTable'>" + (isGameHost || account && account.canGlobalKick ? "<span onmouseenter='playTick()' class='takeActionBtn kick' onclick='punishPlayer(\"" + v11641.id + "\", 0);clearPops();'>Kick</span>" : "") + (isGameHost || account && account.canGlobalBan ? "<span onmouseenter='playTick()' class='takeActionBtn ban' onclick='banPlayer(\"" + v11641.id + "\")'>Ban</span>" : "") + (account && account.canGlobalFlag && v11641.level > 0 ? "<span onmouseenter='playTick()' class='takeActionBtn tag' onclick='flagPlayer(\"" + v11641.id + "\", " + v11642 + ")'>" + (v11642 ? "Flag" : "Unflag") + "</span>" : "") + "</div><div class='takeActionTable'>" + (account && account.canSilentKick ? "<span onmouseenter='playTick()' class='takeActionBtn kick' onclick='punishPlayer(\"" + v11641.id + "\", 7);clearPops();'>Disconnect</span>" : "") + (isGameHost ? "<span onmouseenter='playTick()' class='takeActionBtn enabled' onclick='punishPlayer(\"" + v11641.id + "\", 8);clearPops();'>Transfer Host</span>" : "") + "</div>";
    genericPopup(v11643, "confPop");
  }
});
window.banPlayerConfirmed = function (p14152) {
  clearPops();
  punishPlayer(p14152, 1);
};
window.flagPlayerConfirmed = function (p14153, p14154) {
  clearPops();
  var v11644 = Game.players.list.find(p14155 => p14155.id == p14153);
  if (v11644) {
    io.send("flgu", v11644.id, parseInt(p14154));
  }
};
Object.defineProperty(window, "debugBots", {
  writeable: false,
  value: function (...iÎïíîîì) {
    if (account && account.isDev) {
      io.send("bots", ...iÎïíîîì);
    }
  }
});
Object.defineProperty(window, "botsPopup", {
  writeable: false,
  value: function (p14156) {
    if (account && account.isDev) {
      if (p14156 == null) {
        return io.send("bcfg");
      }
      p14156 = p14156 || {};
      var vLSdivStylecolorffffont4 = "<div style='color:#fff;font-size: 19px;position:relative;margin-bottom:15px;text-align: center;'>Bot Debugging</div><div style='color: var(--green);font-size: 13px;position:relative;margin-bottom:15px;text-align: center;'>Left Click Toggle, Right Click Disable</div>";
      vLSdivStylecolorffffont4 += "<div class='takeActionTable'><span onmouseenter='playTick()' class='takeActionBtn kick' onclick='debugBots(0);clearPops();'>Clear All</span><span onmouseenter='playTick()' class='takeActionBtn kick' onclick='debugBots(1);clearPops();'>Spawn 1</span><span onmouseenter='playTick()' class='takeActionBtn kick' onclick='debugBots(2);clearPops();'>Bring to</span></div>";
      vLSdivStylecolorffffont4 += "<div class='takeActionTable'><span onmouseenter='playTick()' class='takeActionBtn " + (p14156.followTarget ? "enabled" : "disabled") + "' onclick='debugBots(3);clearPops();' oncontextmenu='debugBots(3, false);clearPops();'>Follow</span><span onmouseenter='playTick()' class='takeActionBtn " + (p14156.watchTarget ? "enabled" : "disabled") + "' onclick='debugBots(4);clearPops();' oncontextmenu='debugBots(4, false);clearPops();'>Watch</span><span onmouseenter='playTick()' class='takeActionBtn " + (p14156.mimicTarget ? "enabled" : "disabled") + "' onclick='debugBots(6);clearPops();' oncontextmenu='debugBots(6, false);clearPops();'>Mimic</span><span onmouseenter='playTick()' class='takeActionBtn " + (p14156.attackTarget ? "enabled" : "disabled") + "' onclick='debugBots(9);clearPops();' oncontextmenu='debugBots(9, false);clearPops();'>Attack</span></div>";
      vLSdivStylecolorffffont4 += "<div class='takeActionTable'><span onmouseenter='playTick()' class='takeActionBtn " + (p14156.targetTeam ? "enabled" : "disabled") + "' onclick='debugBots(7);clearPops();' oncontextmenu='debugBots(7, false);clearPops();'>Target Team</span><span onmouseenter='playTick()' class='takeActionBtn " + (p14156.targetBots ? "enabled" : "disabled") + "' onclick='debugBots(8);clearPops();' oncontextmenu='debugBots(8, false);clearPops();'>Target Bots</span></div>";
      vLSdivStylecolorffffont4 += "<div class='takeActionTable'><span onmouseenter='playTick()' class='takeActionBtn " + (p14156.slideHop ? "enabled" : "disabled") + "' onclick='debugBots(5);clearPops();' oncontextmenu='debugBots(5, false);clearPops();'>Bhop</span><span onmouseenter='playTick()' class='takeActionBtn " + (p14156.forceCrouch ? "enabled" : "disabled") + "' onclick='debugBots(10);clearPops();' oncontextmenu='debugBots(10, false);clearPops();'>Crouch</span><span onmouseenter='playTick()' class='takeActionBtn " + (p14156.nodYes ? "enabled" : "disabled") + "' onclick='debugBots(17);clearPops();' oncontextmenu='debugBots(17, false);clearPops();'>Nod Yes</span><span onmouseenter='playTick()' class='takeActionBtn " + (p14156.roam ? "enabled" : "disabled") + "' onclick='debugBots(19);clearPops();' oncontextmenu='debugBots(19, false);clearPops();'>Roam</span></div>";
      vLSdivStylecolorffffont4 += "<div class='takeActionTable'><span onmouseenter='playTick()' class='takeActionBtn " + (p14156.canRespawn ? "enabled" : "disabled") + "' onclick='debugBots(11);clearPops();' oncontextmenu='debugBots(11, false);clearPops();'>Can Respawn</span><span onmouseenter='playTick()' class='takeActionBtn " + (p14156.useSpawnDelay ? "enabled" : "disabled") + "' onclick='debugBots(12);clearPops();' oncontextmenu='debugBots(12, false);clearPops();'>Spawn Delay</span></div>";
      vLSdivStylecolorffffont4 += "<div class='takeActionTable'><span onmouseenter='playTick()' class='takeActionBtn " + (p14156.joinMessage ? "enabled" : "disabled") + "' onclick='debugBots(14);clearPops();' oncontextmenu='debugBots(14, false);clearPops();'>Join Message</span><span onmouseenter='playTick()' class='takeActionBtn " + (p14156.leaveMessage ? "enabled" : "disabled") + "' onclick='debugBots(15);clearPops();' oncontextmenu='debugBots(15, false);clearPops();'>Leave Message</span></div>";
      vLSdivStylecolorffffont4 += "<div class='takeActionTable'><span onmouseenter='playTick()' class='takeActionBtn " + (p14156.removeOnDeath ? "enabled" : "disabled") + "' onclick='debugBots(13);clearPops();' oncontextmenu='debugBots(13, false);clearPops();'>Leave on Death</span><span onmouseenter='playTick()' class='takeActionBtn " + (p14156.voiceChat ? "enabled" : "disabled") + "' onclick='debugBots(16);clearPops();' oncontextmenu='debugBots(16, false);clearPops();'>Voice on Death</span></div>";
      vLSdivStylecolorffffont4 += "<div class='takeActionTable'><span onmouseenter='playTick()' class='takeActionBtn " + (p14156.godMode ? "enabled" : "disabled") + "' onclick='debugBots(18);clearPops();' oncontextmenu='debugBots(18, false);clearPops();'>God Mode</span></div>";
      vLSdivStylecolorffffont4 += "<div class='takeActionTable'><span onmouseenter='playTick()' class='takeActionBtn kick' onclick='debugBots(19);clearPops();'>Slimer</span><span onmouseenter='playTick()' class='takeActionBtn kick' onclick='debugBots(20);clearPops();'>Juggernaut</span></div>";
      vLSdivStylecolorffffont4 += "<div style='font-size: 12px;color: var(--yellow);text-align: center;'>Dont forget to clear bots</div>";
      genericPopup(vLSdivStylecolorffffont4, "confPop");
    }
  }
});
window.crtrCodRes = function (p14157, p14158, p14159) {
  if (!p14157) {
    windows[27].getData(p14158, p14159);
  } else if (p14157 == "success") {
    p14158 = p14158 || {};
    if (account) {
      account.partnerApp = 1;
      if (p14158.nm) {
        account.partnerName = p14158.nm;
      }
    }
    updateWindow(5);
  } else {
    var v11645 = document.getElementById("ctrtRes");
    if (v11645) {
      v11645.innerHTML = p14157;
    }
  }
};
window.submitCrtrCod = function () {
  var v11646 = document.getElementById("crtrEmail");
  var v11647 = document.getElementById("crtrCode");
  if (v11646.value && v11647.value) {
    var v11648 = document.getElementById("ctrtRes");
    if (v11648) {
      v11648.innerHTML = "Loading...";
    }
    io.send("crtC", v11647.value, v11646.value);
  }
};
Object.defineProperty(window, "redeemVoucher", {
  writeable: false,
  value: function () {
    var v11649 = document.getElementById("redVouch");
    if (v11649 && v11649.value) {
      var v11650 = v11649.value;
      v11649 = document.getElementById("vouchRes");
      if (v11649) {
        v11649.style.display = "block";
        v11649.innerHTML = "Loading...";
      }
      io.send("vo", v11650);
    }
  }
});
window.voucherPopup = function () {
  if (!account) {
    showWindow(5, true);
    return;
  }
  var v11651 = "<div style='color:rgba(255,255,255,0.7);margin-top:-5px;font-size:19px;text-align:center;margin-bottom:5px;'>" + i18n.t("windows.store.voucherinfo") + "</div>";
  v11651 += "<div><input type='text' id='redVouch' class='smlInput' placeholder='Enter KR Code' /><div class='redVouchBtn' onclick='redeemVoucher()'>Redeem</div></div>";
  v11651 += "<div id='vouchRes' style='display:none'></div>";
  genericPopup(v11651, "vouchPop");
};
function io_redeemVoucherResponse(p14160, p14161) {
  var v11652 = document.getElementById("vouchRes");
  if (v11652) {
    v11652.style.display = "block";
    v11652.innerHTML = p14161 || "";
  }
  if (p14160 != null && p14160 != null) {
    io_updateFunds(p14160);
    updateWindow(null, true);
  }
}
function io_openMail(p14162, p14163) {
  windows[29].onReadData(p14162, p14163);
}
function io_updateMail(p14164) {
  windows[29].mailCount(p14164);
}
function io_addMail(p14165, p14166) {
  windows[29].onData(p14165, p14166);
}
var vSpinWindow = spinWindow;
var v11653 = vSpinWindow.getContext("2d");
var vLN05100 = 0.5;
var vLN06100 = 0.6;
var vLN03100 = 0.3;
var v11654 = null;
var v11655 = false;
var vLN01911 = 0;
var vLN305 = 30;
var vLN3002 = 300;
var vLN01912 = 0;
var vA629 = [0];
var vA630 = [0];
var vA631 = [];
var vA632 = [];
var vLN01913 = 0;
var vLN01914 = 0;
var v11656 = null;
var v11657 = false;
var v11658 = false;
var vLN01915 = 0;
var v11659 = true;
var v11660 = false;
var v11661 = false;
var vLN01916 = 0;
var vLN01917 = 0;
var vA633 = [];
var v11662 = new THREE.PerspectiveCamera(45, 1, 0.1, 100);
var v11663 = new THREE.WebGLRenderer({
  precision: "mediump",
  antialias: false,
  alpha: true
});
var v11664;
var spinnerPreview;
var v11666;
var v11667;
v11663.setPixelRatio(window.devicePixelRatio * 0.6);
v11662.position.y = 10;
spinItemCanvas.appendChild(v11663.domElement);
Object.defineProperty(window, "prizeWheel", {
  writeable: false,
  value: function (p14167, p14168, p14169, p14170, p14171) {
    v11657 = p14168 && Game.store.skins[p14168].spinWheel;
    v11667 = v11657 ? Game.store.skins[p14168].spinWheel : Game.store.wheels[p14167];
    if (v11667) {
      v11658 = p14169 && v11667.multi;
      spinAgainBtn.style.display = v11667.free ? "none" : "";
      spinInfoBtn.style.display = v11667.free ? "none" : "";
      spinEquipBtn.style.display = "";
      spinNextBtn.style.display = v11658 ? "" : "none";
      vLN01914 = p14167;
      v11656 = p14168;
      showWindow(0);
      vLN01912 = p14171 ? 1 : 0;
      v11659 = !v11655;
      v11660 = false;
      v11661 = !v11667.kr;
      vA632 = [];
      vA629 = [0];
      vLN01917 = 0;
      vA630 = [0];
      vLN01915 = vLN01911 = 0;
      if (spinUI.style.display != "block") {
        UI.toggleMenuHider(false);
      }
      spinItem.style.display = "none";
      spinUIBtns.style.display = "none";
      spinUI.style.display = "block";
      spinItemName.style.display = "none";
      v11662.position.x = vLN3002;
      spinButton.style.opacity = 1;
      spinText.style.display = "table-cell";
      spinHeader.innerHTML = "SPIN";
      spinCost.innerHTML = "-" + v11667.price * (v11658 ? v11667.multi : 1) + "KR";
      spinCost.style.display = v11656 ? "none" : "";
      spinAgainBtn.innerHTML = "<i class='material-icons' style='margin-top: -10px;margin-left: -10px;text-shadow: none;vertical-align: middle;font-size: 38px;color: #fff;'>refresh</i> " + (v11657 ? "Redeem<img src=\"" + Game.store.skins[v11656].thumbnail + "\" style=\"width: 40px;vertical-align: text-top;display: inline-block;\">" : +(v11667.price * (v11658 ? v11667.multi : 1)) + " KR");
      var v11668 = "<div style='font-size:50px;color:#fff'>" + v11667.name.toUpperCase() + "</div>";
      for (var vLN01920 = 0; vLN01920 < Game.store.rarities.length; ++vLN01920) {
        player = Game.store.rarities[vLN01920];
        if (!player.noSpin) {
          var v11669 = v11667.rarities[vLN01920] || 0;
          if (v11667.kr && !v11669) {
            continue;
          }
          v11668 += "<div style='margin-top:5px;color:#fff'>" + (RENDER.rarityAnim && player.animate ? "<div class='colCub rainbowBG'></div>" : "<div class='colCub' style='background-color:" + player.color + "'></div>") + (v11667.kr ? "<span style='color:rgba(255,255,255,0.5)'>&emsp;" + Game.store.getFreeKR(vLN01920, account).kr + " KR</span>" : player.name + "<span style='color:rgba(255,255,255,0.5);float:right'>&emsp;" + ((v11669 || 0) + "%") + "</span>") + "</div>";
        }
      }
      if (!v11667.kr) {
        v11668 += "<div id=\"spinHistoryBtn\" onclick=\"spinHistoryPopup()\">Spin History</div>";
      }
      spinInfo.innerHTML = v11668;
      if (account) {
        spinKR.innerHTML = "<span style='color:rgba(255,255,255,0.6)'>" + UTILS.commaNumber(account.funds) + "</span> KR";
      }
      if (!v11667.kr) {
        v11668 = "";
        var v11670 = v11667.rarities;
        var v11671 = v11670.indexOf(v11670.filter(p14172 => p14172 > 0).slice(-1).pop());
        var v11672 = Game.store.getSpnItems(v11667, v11671, account, v11667.season || config.currentSeason, v11667.bigRar);
        var vA634 = [];
        var vLS85 = "";
        for (var vLN01920 = 0, v11673; vLN01920 < 4; ++vLN01920) {
          v11673 = v11672[UTILS.randInt(0, v11672.length - 1)];
          player = Game.store.skins[v11673];
          if (player) {
            if (player.frames && vA634.indexOf(player.frames) == -1) {
              vA634.push(player.frames);
            }
            v11668 += player.type && player.type == itemTypes.SPRAY ? "<div onclick='viewItem(" + v11673 + ")' class='spinSprayDiv' style='border-color:" + Game.store.rarities[player.rarity].color + "'><div class='spinSprayIcon' style='background: url(&quot;" + player.thumbnail + "&quot;);" + UTILS.getFrameAnim(player, "sprayAnm") + "'></div></div>" : "<img class='spinPrevIcon' style='border-color:" + Game.store.rarities[player.rarity].color + "' onclick='viewItem(" + v11673 + ")' src='" + player.thumbnail + "' />";
          }
        }
        if (vA634.length) {
          vLS85 += "<style>";
          for (var vLN01920 = 0; vLN01920 < vA634.length; vLN01920++) {
            vLS85 += "@keyframes sprayAnm" + vA634[vLN01920] + " {100%{background-position:-" + vA634[vLN01920] * 91 + "px}}";
          }
          vLS85 += "</style>";
        }
        if (v11672.length) {
          v11668 += "<span style='color:#fff;line-height:85px;margin-left:6px'>+ More</span>";
        }
        spinItems.innerHTML = vLS85 + v11668;
      }
      if (p14170) {
        spinButton.click();
      }
    }
  }
});
spinAgainBtn.onclick = () => {
  if (v11660) {
    prizeWheel(vLN01914, v11656, v11658, true, true);
  }
};
spinInfoBtn.onclick = () => {
  if (v11660) {
    openURL("/social.html?p=itemsales&i=" + Game.store.skins.findIndex(p14173 => p14173 == v11654));
  }
};
spinNextBtn.onclick = () => {
  f1847(true);
};
spinEquipBtn.onclick = () => {
  if (v11661) {
    const vA635 = [null, "selectHat", "selectBody", "selectMelee", "selectSpray", "selectDye", "selectWaist", "selectFace", "selectShoe", "selectPet", null, "selectWrist", null, null, "selectBack", "selectHead"];
    if (v11654.type && vA635[v11654.type]) {
      window[vA635[v11654.type]](v11654.index, true);
    } else if (v11654.weapon != null) {
      var v11674 = Game.weapons[v11654.weapon - 1];
      skinSelector(v11674.id, v11674.secondary, true);
      selectSkin(v11654.index, v11674.id, true);
    }
    io_showPopup("SUCCESS", null, "Skin equipped");
  }
};
var vLN3243 = 3243;
window.dontInc = false;
var v11675 = false;
spinButton.onclick = function (p14174) {
  p14174.stopPropagation();
  p14174.preventDefault();
  CONTROLS.idleTimer = 0;
  if (!config.isProd && v11675) {
    v11655 = true;
    v11659 = false;
    if (!window.dontInc) {
      vLN3243++;
    }
    io_spinResponse(null, 100, vLN3243, account.funds);
    spinHeader.innerHTML = "";
    spinCost.innerHTML = i18n.t("windows.store.purchasing");
    SOUND.play("buy_1", 0.1);
    return;
  }
  if (io && v11667.kr && !account) {
    io.send("fkr");
    return;
  }
  if (io && !v11655 && v11659 && account) {
    if (!v11656 && account.funds < v11667.price) {
      return f1835("Spin Error 9");
    }
    v11655 = true;
    v11659 = false;
    if (v11667.kr) {
      io.send("fkr");
    } else {
      io.send("spin", vLN01914, v11656, !!v11658);
    }
    spinHeader.innerHTML = "";
    spinCost.innerHTML = i18n.t("windows.store.purchasing");
    SOUND.play("buy_1", 0.1);
  } else if (v11660 && p14174.shiftKey) {
    prizeWheel(vLN01914, v11656, v11658, true, true);
  }
};
spinUI.onclick = function (p14175) {
  showWindow(14);
  UI.toggleMenuHider(true);
  spinUI.style.display = "none";
  if (confetti) {
    confetti.reset();
  }
  if (io) {
    io.send("unbx");
  }
  if (account) {
    spinKR.innerHTML = "<span style='color:rgba(255,255,255,0.6)'>" + UTILS.commaNumber(account.funds) + "</span> KR";
  }
  if (v11660 && p14175.shiftKey) {
    prizeWheel(vLN01914, v11656, v11658, true, true);
  }
};
spinUI.addEventListener("mousewheel", function (v11676) {
  var v11676 = window.event || v11676;
  if (spinItem.style.display == "block" && v11676.target.id && v11676.target.id.startsWith("spin")) {
    var v11677 = -Math.max(-1, Math.min(1, v11676.wheelDelta || -v11676.detail));
    window.rotPrev(v11677 > 0 ? -0.1 : 0.1);
  }
  return false;
}, false);
function io_unboxMessage(p14177, p14178, p14179) {
  if (SETTINGS.tmp.showUnboxings) {
    var v11678 = null;
    v11678 = p14179 ? {
      rarity: Game.store.freeKR[p14178].rarity,
      name: p14179 + " KR"
    } : Game.store.skins[p14178];
    if (v11678) {
      var v11679 = RENDER.rarityAnim && Game.store.rarities[v11678.rarity].animate;
      io_addChat(0, null, "<span style='color:#fff'>" + i18n.t("windows.store.unboxed", UTILS.fixStr(SETTINGS.tmp.streamMode ? UTILS.scrambleS(p14177) : p14177), "</span>") + " <span class='click" + (v11679 ? " rainbowText" : "") + "' style='color:" + Game.store.rarities[v11678.rarity].color + "'" + (p14179 ? "" : " onclick='viewItem(" + p14178 + ")'") + ">[" + UTILS.fixStr(v11678.name) + "]</span>", spinUI.style.display == "block" ? 4 : 1);
    }
  }
}
function io_unboxMesssageS(p14180, p14181) {
  if (SETTINGS.tmp.showUnboxings) {
    var v11680 = Game.store.skins[p14181];
    var v11681 = Game.players.findById(p14180);
    if (v11680 && v11681) {
      var v11682 = v11681.name;
      var v11683 = RENDER.rarityAnim && Game.store.rarities[v11680.rarity].animate;
      io_addChat(0, null, "<span style='color:#fff'>" + i18n.t("windows.store.unboxed", UTILS.fixStr(SETTINGS.tmp.streamMode ? UTILS.scrambleS(v11682) : v11682), "</span>") + " <span class='click" + (v11683 ? " rainbowText" : "") + "' style='color:" + Game.store.rarities[v11680.rarity].color + "' onclick='viewItem(" + p14181 + ")'>[" + UTILS.fixStr(v11680.name) + "]</span>", 4);
    }
  }
}
function f1835(p14182) {
  if (p14182 != "Spin Error 9") {
    if (spinUI.style.display == "block") {
      prizeWheel(vLN01914, v11656, v11658);
    }
    var v11684 = "<div class=\"popHeader\">Spin Error</div>" + p14182;
    genericPopup(v11684, "spinErrorPop");
  } else {
    windows[13].purchase();
  }
}
window.rotPrev = function (p14183) {
  if (v11666) {
    v11666.rotation.y += p14183;
  }
};
let vA636 = [];
let v11685 = false;
let vA637 = [];
let v11686 = -1;
let vLN01921 = 0;
let v11687 = true;
function f1836(p14184, p14185, p14186) {
  var vLS86 = "";
  player = Game.store.skins[p14184.ind];
  if (player && !player.blackM && player.limT != "Raid" && player.itemShop == null) {
    vLS86 += player.type && player.type == itemTypes.SPRAY ? "<div onclick='viewItem(" + player.index + ");cancelTip()' onmouseover='createSpinHistoryTip(this)' onmouseout='cancelTip()' class='spinSprayDiv' style='margin:5px;border-color:" + Game.store.rarities[player.rarity].color + "'><div class='spinSprayIcon' loading='lazy' style='background: url(&quot;" + player.thumbnail + "&quot;);" + UTILS.getFrameAnim(player, "sprayAnm") + "'></div></div>" : "<img class='spinPrevIcon' style='margin:5px;border-color:" + Game.store.rarities[player.rarity].color + "'  onmouseover='createSpinHistoryTip(this)' onmouseout='cancelTip()' onclick='viewItem(" + player.index + ");cancelTip()' loading='lazy' src='" + player.thumbnail + "' />";
  }
  if (p14185) {
    p14185.insertAdjacentHTML(p14186 || "beforeend", vLS86);
    return;
  } else {
    return vLS86;
  }
}
function io_saveSpinHistory(p14187) {
  vLN01921 += p14187 ? p14187.length || 0 : 0;
  v11686 = vA636.length;
  if (p14187) {
    vA636.push(...f1839(p14187));
  }
  v11685 = true;
  spinHistoryPopup(true);
}
function f1838(p14188) {
  if (v11685) {
    vA636.unshift({
      ind: p14188,
      dte: new Date().toString(),
      fds: v11667 && v11667.price ? v11667.price : 0
    });
    if (v11685) {
      v11686++;
      vLN01921++;
    }
    var v11688 = document.getElementById("spinHistoryList");
    if (v11688) {
      f1836(vA636[0], v11688, "afterbegin");
    }
  }
}
window.getSpinHistory = p14189 => {
  if (p14189) {
    p14189.classList.toggle("disabled", true);
    p14189.innerHTML = "Loading...";
  } else {
    io_loadingPopup("Fetching Spin History...");
  }
  io.send("spinH", vLN01921);
};
window.clearSpinHistory = () => {
  vA636.length = 0;
  v11685 = false;
  v11686 = -1;
  vLN01921 = 0;
  v11687 = true;
};
function f1839(p14190) {
  return p14190.filter(p14191 => p14191 && Game.store.skins[p14191.ind] && !Game.store.skins[p14191.ind].blackM && Game.store.skins[p14191.ind].limT != "Raid" && Game.store.skins[p14191.ind].itemShop == null);
}
window.showSpinStats = function (p14192) {
  f1822(window.event);
  if (!vA636.length) {
    io_showPopup(null, "No spin history found");
    return;
  }
  var v11689 = new Date(vA636[0].dte).toDateString();
  var v11690 = new Date(vA636[vA636.length - 1].dte).toDateString();
  var vLN01922 = 0;
  var vA638 = [];
  var vLN01923 = 0;
  for (var vLN01925 = 0, v11691; vLN01925 < vA636.length; ++vLN01925) {
    v11691 = Game.store.skins[vA636[vLN01925].ind];
    vA638[v11691.rarity || 0] = (vA638[v11691.rarity || 0] || 0) + 1;
    vLN01922 += vA636[vLN01925].fds;
    var v11692 = prices.estimateValue(vA636[vLN01925].ind) || 0;
    vLN01923 += Math.round(v11692);
  }
  var v11693 = "<div class=\"popHeader\">Spin Stats</div>\n\t\t<div class=\"spinHistoryTime\">Current Date Range: " + v11690 + " - " + v11689 + "</div>\n\t\t<div style=\"text-align:left\">\n\t\t<div style=\"color:#fff\">Total Spent:<span style='color:rgba(255,255,255,0.5);float:right'>&emsp;" + UTILS.commaNumber(vLN01922) + " KR</span></div>\n\t\t<div style=\"color:#fff\">Est Value:<span style='color:rgba(255,255,255,0.5);float:right'>&emsp;" + UTILS.commaNumber(vLN01923) + " KR</span></div>\n\t\t<div style=\"color:#fff\">Total Spins:<span style='color:rgba(255,255,255,0.5);float:right'>&emsp;" + UTILS.commaNumber(vA636.length) + "</span></div>";
  for (var vLN01925 = 0; vLN01925 < Game.store.rarities.length; ++vLN01925) {
    player = Game.store.rarities[vLN01925];
    if (!player.noSpin) {
      v11693 += "<div style='margin-top:5px;color:#fff'>" + (RENDER.rarityAnim && player.animate ? "<div class='colCub rainbowBG'></div>" : "<div class='colCub' style='background-color:" + player.color + "'></div>") + player.name + "<span style='color:rgba(255,255,255,0.5);float:right'>&emsp;" + UTILS.commaNumber(vA638[vLN01925] || 0) + "</span></div>";
    }
  }
  v11693 += "</div>";
  genericPopup(v11693, "spinHistoryStatsPop");
};
window.spinHistoryPopup = function (p14193) {
  f1822(window.event);
  if (f1846()) {
    if (!v11685) {
      getSpinHistory();
      return;
    }
    if (!vA636.length) {
      io_showPopup(null, "No spin history found");
      return;
    }
    resetPops();
    spinHistoryPop.style.display = "block";
    var vLSdivClassspinHistoryH = "";
    var v11694 = new Date(vA636[0].dte).toDateString();
    var v11695 = new Date(vA636[vA636.length - 1].dte).toDateString();
    if (v11687) {
      var vLSdivClassspinHistoryH = "<div class='spinHistoryHeader'><div class='spinHistoryStats' onmouseover='playTick();' onclick='playSelect();showSpinStats(this);'>Stats</div>Recent Items<div class='spinHistoryClear' onmouseover='playTick();' onclick='playSelect();getSpinHistory(this);'>Load More</div></div>";
      vLSdivClassspinHistoryH += "<div class=\"spinHistoryTime\">Current Date Range: " + v11695 + " - " + v11694 + "</div>";
      vLSdivClassspinHistoryH += "<div id='spinHistoryList'></div>";
      vLSdivClassspinHistoryH += "<div class='spinHistoryWarning'>Data only tracks back to April 2020</div>";
      vLSdivClassspinHistoryH += "<style id='spinHistoryStyle'>";
      for (var vLN01926 = 1; vLN01926 < 10; vLN01926++) {
        vLSdivClassspinHistoryH += "@keyframes sprayAnm" + vLN01926 + " {100%{background-position:-" + vLN01926 * 91 + "px}}";
      }
      vLSdivClassspinHistoryH += "</style>";
      spinHistoryPop.innerHTML = vLSdivClassspinHistoryH;
    } else {
      var v11696 = document.querySelector(".spinHistoryClear");
      if (v11696) {
        v11696.classList.toggle("disabled", false);
        v11696.innerHTML = "Load More";
      }
      var v11697 = document.querySelector(".spinHistoryTime");
      if (v11697) {
        v11697.textContent = "Current Date Range: " + v11695 + " - " + v11694;
      }
    }
    var v11698 = document.getElementById("spinHistoryList");
    for (var vLN01926 = 0; vLN01926 < vA636.length; ++vLN01926) {
      if (!(vLN01926 < v11686) || v11687) {
        f1836(vA636[vLN01926], v11698, "beforeend");
      }
    }
    if (!v11687 && p14193) {
      v11698.scrollTop = v11698.scrollHeight;
    }
    if (v11687) {
      v11687 = false;
    }
    v11686 = vA636.length;
  }
};
function f1840() {
  if (vA632[vLN01913]) {
    v11654 = vA632[vLN01913];
    const v11699 = account.getSkinCount(v11654.index);
    spinItemName.innerHTML = v11654.name + "<div style='color:rgba(255,255,255,0.5)'>" + UTILS.getItemDesc(v11654, Game.weapons, i18n).replace(" Item", "") + "</div><div style='color:rgba(255,255,255,0.5)'>" + (v11699 > 1 ? "<span style='color:#fff'>x" + v11699 + "</span> Owned" : "<span style='color:#fff'>NEW</span>") + "</div>";
    vLN01916 = 0;
    v11664 = new THREE.Scene();
    v11664.name = "Wheel";
    v11664.add(new THREE.AmbientLight(5197647));
    var v11700 = new THREE.DirectionalLight("#ffffff", 0.5);
    v11700.position.set(3, 1, 0);
    v11664.add(v11700);
    var v11701 = v11654.type ? v11654 : Game.store.previews[v11654.weapon] || {};
    v11666 = RENDER.genObj3D(0, 0, 0);
    spinnerPreview = RENDER.genObj3D(0, 1 + (v11701.yOff || 0), v11701.xOff || 0);
    if (v11654.type != itemTypes.PLAYER_CARD) {
      spinnerPreview.rotateX(v11654.type && v11654.type == itemTypes.DYE ? -Math.PI / 11 : -Math.PI / 7);
      spinnerPreview.rotateY(Math.PI + 0.5 + (v11701.zRota || 0));
      spinnerPreview.rotateZ(-0.5);
    }
    spinnerPreview.orgXR = spinnerPreview.rotation.x;
    spinnerPreview.orgYP = spinnerPreview.position.y;
    if (v11654.type && v11654.type == itemTypes.DYE) {
      player = new Player(-1, this, Game, true);
      player.sid = -1;
      player.init(0.5, 0, -7, "preview", false);
      player.skins = [-1, -1];
      player.dyeIndex = parseInt(v11654.index);
      player.setClass(Game, 9, 2, true);
      Game.players.swapWeapon(player, 0, true);
      Game.players.generateMeshes(player, false, true, true);
      spinnerPreview.add(player.objInstances);
      player.swapTime = 0;
      if (player && player.weaponMeshes && player.weaponMeshes[0]) {
        player.weaponMeshes[0].visible = true;
      }
      if (player && player.weaponGeos && player.weaponGeos[0]) {
        player.weaponGeos[0].visible = false;
      }
      Game.players.updateMshClient(player, true);
    } else if (v11654.type && v11654.type == itemTypes.SPRAY) {
      player = new THREE.Mesh(new THREE.PlaneGeometry(1, 1));
      player.scale.set(9, 7.2, 1);
      player.material = RENDER.getMat(Game.store.types[v11654.type] + (v11654.id || 0), {
        local: v11654.local,
        depthWrite: false,
        transparent: true,
        frames: v11654.frames,
        frameT: v11654.frameT,
        centerZ: true
      });
      spinnerPreview.add(player);
      player.rotation.y = Math.PI * 1.1;
    } else if (v11654.type && v11654.type == itemTypes.PLAYER_CARD) {
      player = new THREE.Mesh(new THREE.PlaneGeometry(1, 1));
      player.scale.set(13, 3.7, 1);
      player.material = RENDER.getMat(Game.store.types[v11654.type] + (v11654.id || 0), {
        texExt: v11654.texExt,
        local: v11654.local,
        depthWrite: false,
        transparent: true,
        frames: v11654.frames,
        frameT: v11654.frameT,
        centerZ: true,
        side: 2
      });
      spinnerPreview.add(player);
      player.rotation.y = Math.PI / 2;
    } else {
      RENDER[v11654.hasAnim ? "loadAnimMesh" : "loadMesh"]({
        fileExt: v11654.fileExt,
        setLayer: 0,
        hasAnim: v11654.hasAnim,
        animS: v11654.animS,
        inspectAnim: v11654.inspectAnim,
        local: v11654.local,
        localM: v11654.localM,
        src: Game.store.types[v11654.assetType || v11654.type || 0] + (v11654.assetType || v11654.type ? v11654.id : v11654.weapon) + (v11654.mid == null ? "" : "_" + v11654.mid),
        texSrc: v11654.mid == null ? v11654.type && v11654.type == itemTypes.MELEE ? v11654.pat ? v11654.tex : "melee/melee_" + (v11654.id || 0) + (v11654.tex ? "_" + v11654.tex : "") : v11654.type ? v11654.tex ? Game.store.types[v11654.assetType || v11654.type || 0] + v11654.id + "_" + v11654.tex : null : v11654.tex ? v11654.tex : "weapons/skins/weapon_" + v11654.weapon + "_" + v11654.id : UTILS.getReModel(Game.store, v11654),
        rotT: v11654.rotT,
        movT: v11654.movT,
        movD: v11654.movD,
        pulsT: v11654.pulsT,
        repeatY: v11654.tileS || 0,
        repeatX: v11654.tileS || 0,
        frames: v11654.frames,
        frameT: v11654.frameT,
        sameGlow: v11654.sameGlow,
        sameEnv: v11654.sameEnv,
        env: v11654.env || v11654.sameEnv ? v11654.env || 3 : undefined,
        glowText: v11654.glow || v11654.sameGlow,
        emissive: v11654.glow || v11654.sameGlow ? v11654.emiss || "#ffffff" : null,
        emissInt: v11654.glowInt,
        rgb: v11654.rgb,
        rgbS: v11654.rgbS,
        uv2: true,
        fillScale: 60,
        centerZ: true,
        color: v11654.color || null,
        rAnim: v11654.rAnim,
        rAnimA: v11654.rAnimA,
        rAnimT: v11654.rAnimT,
        rAnimM: v11654.rAnimM,
        transparent: v11654.opac != null || v11654.trans,
        useWireframe: v11654.wire,
        side: v11654.side || 0,
        opacity: v11654.opac || 1,
        alphaTest: v11654.alpha || 0,
        shaderNum: v11654.shaderNum,
        video: v11654.video,
        projection: v11654.projection
      }, 0, 0, 0, (v11654.type && v11654.type != itemTypes.MELEE ? Math.PI : Math.PI / 2) + (v11701.xRot || 0), (v11654.spnScl || v11701.scl || 1) * 2.2, spinnerPreview);
    }
    v11666.add(spinnerPreview);
    v11664.add(v11666);
    v11662.lookAt(v11664.position);
    spinItemCanvas.style.filter = "drop-shadow(0 0 20px " + Game.store.rarities[v11654.rarity].color + ")";
    vLN01913++;
  }
}
function io_spinResponse(p14194, p14195, p14196, p14197, p14198) {
  v11655 = false;
  if (p14194) {
    if (p14194 == "DISABLED") {
      f1835(i18n.t("spins.banned"));
    } else {
      f1835(p14194);
    }
  } else {
    if (!Array.isArray(p14195)) {
      p14195 = [p14195];
    }
    if (!Array.isArray(p14196)) {
      p14196 = [p14196];
    }
    vLN01913 = 0;
    p14196.map((p14199, p14200) => ({
      n: p14195[p14200],
      i: p14199
    })).sort((p14201, p14202) => (Game.store.skins[p14202.i].rarity || 0) - (Game.store.skins[p14201.i].rarity || 0)).forEach((p14203, p14204) => {
      p14195[p14204] = p14203.n;
      p14196[p14204] = p14203.i;
    });
    vA632 = p14196.map(p14205 => Game.store.skins[p14205]);
    vA632.forEach(p14206 => f1838(p14206.index));
    if (account) {
      if (v11667 && v11667.price) {
        vA632.forEach(p14207 => {
          logEventFRVR("item_flow", {
            item: "krunkers",
            flow_type: "sink",
            amount: v11667.price || 0,
            item_context: v11667.name.toLowerCase() + "_spin",
            item_context_details: Game.store.rarities[p14207.rarity].name.toLowerCase(),
            wallet: account ? account.funds : 0
          });
        });
      }
      account.funds = p14197;
      updateMenuAccountData();
      spinKR.innerHTML = "<span style='color:rgba(255,255,255,0.6)'>" + UTILS.commaNumber(account.funds) + "</span> KR";
      vA632.forEach(p14208 => account.addSkin(p14208.index));
      if (p14198) {
        account.removeSkin(p14198);
      }
    }
    vA629 = Array(vA632.length).fill(0).map((p14209, p14210) => p14210 % 2 == 0 ? Math.PI * 2 * (p14195[p14210] / 100 + 13) + Math.PI / 2 : Math.PI / 2 - Math.PI * 2 * (13 - p14195[p14210] / 100));
    vA630 = Array(vA632.length).fill(0);
    vA631 = Array(vA632.length).fill(0).map(() => 0.4 + Math.random() * 0.6);
    let v11702 = Math.max(...vA631);
    vA631 = vA631.map(p14211 => p14211 / v11702);
    spinCost.innerHTML = "";
    f1840();
  }
}
function io_spinWheelResponse(p14212, p14213, p14214, p14215, p14216, p14217) {
  if (!p14214) {
    if (p14212 && p14212 == io.socketId && account) {
      v11654 = Game.store.skins[p14216];
      if (Game.map.manager.spinners.length) {
        for (var vLN01927 = 0; vLN01927 < Game.map.manager.spinners.length; ++vLN01927) {
          player = Game.map.manager.spinners[vLN01927];
          if (player.uid == p14213) {
            var v11703 = Game.store.wheels[player.wheel];
            if (v11703 && v11703.price) {
              logEventFRVR("item_flow", {
                item: "krunkers",
                flow_type: "sink",
                amount: v11703.price || 0,
                item_context: v11703.name.toLowerCase() + "_spin",
                item_context_details: Game.store.rarities[v11654.rarity].name.toLowerCase(),
                wallet: account ? account.funds : 0
              });
            }
            break;
          }
        }
      }
      account.funds = p14217;
      updateMenuAccountData();
      account.addSkin(p14216);
    }
    Game.updateSpinner(p14213, p14215, p14216);
  }
}
function io_skinFoundMessage(p14218, p14219) {
  if (SETTINGS.tmp.showUnboxings) {
    var v11704 = Game.store.skins[p14219];
    var v11705 = Game.players.findById(p14218);
    if (v11704 && v11705) {
      var v11706 = v11705.name;
      var v11707 = RENDER.rarityAnim && Game.store.rarities[v11704.rarity].animate;
      io_addChat(0, null, "<span style='color:#fff'>" + i18n.t("windows.store.found", UTILS.fixStr(SETTINGS.tmp.streamMode ? UTILS.scrambleS(v11706) : v11706), "</span>") + " <span class='click" + (v11707 ? " rainbowText" : "") + "' style='color:" + Game.store.rarities[v11704.rarity].color + "' onclick='viewItem(" + p14219 + ")'>[" + UTILS.fixStr(v11704.name) + "]</span>", 4);
    }
    if (tmpPlayer && tmpPlayer.isYou) {
      if (!matchRewardSummary.skins) {
        matchRewardSummary.skins = [];
      }
      var v11708 = matchRewardSummary.skins.find(p14220 => p14220 && p14220.i == p14219);
      if (v11708) {
        v11708.c++;
      } else {
        matchRewardSummary.skins.push({
          i: p14219,
          c: 1
        });
      }
    }
  }
}
function io_skinReward(p14221) {
  if (account) {
    account.addSkin(p14221);
  }
  var v11709 = Game.store.skins[p14221];
  if (v11709) {
    skinRewards.style.display = "block";
    var v11710 = RENDER.rarityAnim && Game.store.rarities[v11709.rarity].animate;
    skinRewards.innerHTML = "<div class='skinRewCard' onclick='openSales(" + p14221 + ")' onmouseenter='playTick()'><img class='skinRewImg" + (v11710 ? " rainbowBorder" : "") + "' src='" + v11709.thumbnail + "' style='border: 3px solid " + Game.store.rarities[v11709.rarity].color + "' /><div class='skinRewRight'>" + v11709.name + "<div class='skinRewDesc'>Item Found!</div></div></div>";
    requestAnimationFrame(function () {
      skinRewards.style.display = "none";
      skinRewards.innerHTML = "";
    }, 5000);
    io_addChat(-1, null, "<span style='color:#fff'>You</span> found <span class='click" + (v11710 ? " rainbowText" : "") + "' style='color:" + Game.store.rarities[v11709.rarity].color + "' onclick='viewItem(" + p14221 + ")'>[" + UTILS.fixStr(v11709.name) + "]</span>", 1);
  }
  if (!matchRewardSummary.skins) {
    matchRewardSummary.skins = [];
  }
  var v11711 = matchRewardSummary.skins.find(p14222 => p14222 && p14222.i == p14221);
  if (v11711) {
    v11711.c++;
  } else {
    matchRewardSummary.skins.push({
      i: p14221,
      c: 1
    });
  }
}
function io_skinKR(p14223, p14224, p14225, p14226, p14227) {
  v11655 = false;
  if (p14227) {
    f1835(p14227);
  } else {
    v11654 = Game.store.getFreeKR(p14225, account);
    spinItemName.innerHTML = v11654.kr + " KR";
    spinVal = Math.PI * 2 * (p14224 / 100 + 13) + Math.PI / 2;
    logEventFRVR("item_flow", {
      item: "krunkers",
      flow_type: "source",
      amount: v11654.kr,
      item_context: "free_spin",
      wallet: account ? account.funds : 0
    });
    if (account) {
      account.lastReward = parseInt(p14223);
      account.funds = p14226;
      updateMenuAccountData();
    }
    updateRewardTimer();
    spinCost.innerHTML = "";
    vA630 = [0];
    vLN01916 = 0;
    v11664 = new THREE.Scene();
    v11664.name = "KR";
    v11664.add(new THREE.AmbientLight(5197647));
    var v11712 = new THREE.DirectionalLight(16777215, 0.5);
    v11712.position.set(3, 1, 0);
    v11664.add(v11712);
    spinnerPreview = RENDER.genObj3D(0, 1, 0);
    spinnerPreview.rotateX(-Math.PI / 7);
    spinnerPreview.rotateY(1.07);
    spinnerPreview.rotateZ(-2.4499999999999997);
    spinnerPreview.orgXR = spinnerPreview.rotation.x;
    spinnerPreview.orgYP = spinnerPreview.position.y;
    RENDER.loadMesh({
      src: "krunkie_0",
      texSrc: "krunkie_0",
      noGreen: true,
      uv2: true,
      fillScale: 60,
      centerZ: true
    }, 0, 0, 0, 0.3, 4.840000000000001, spinnerPreview);
    v11664.add(spinnerPreview);
    v11662.lookAt(v11664.position);
  }
}
function f1846() {
  for (let vLN01928 = 0; vLN01928 < vA630.length; vLN01928++) {
    if (vA630[vLN01928] != vA629[vLN01928]) {
      return false;
    }
  }
  return true;
}
function f1847(p14228) {
  if (f1846()) {
    if (p14228) {
      f1840();
    }
    vLN01915 = 0;
    vLN01911 = 100 - v11667.rarities[v11654.rarity];
    SOUND.play("reward", 0.3);
    if (confetti) {
      confetti.reset();
    }
    confetti({
      spread: 360,
      origin: {
        x: 0.5,
        y: 0.5
      },
      particleCount: Game.store.rarities[v11654.rarity].confC,
      colors: Game.store.rarities[v11654.rarity].confCols
    });
    if (io) {
      io.send("unbx");
    }
    if (v11667.kr && account) {
      spinKR.innerHTML = "<span style='color:rgba(255,255,255,0.6)'>" + UTILS.commaNumber(account.funds) + "</span> KR";
    }
    if (v11654.rarity >= rarities.RELIC) {
      SOUND.play("cheer_1", 0.1);
    } else if (v11654.rarity >= rarities.RARE) {
      SOUND.play("cheer_0", 0.1);
    }
  }
}
var vLN01929 = 0;
function updateSpinUi(p14229) {
  if (spinUI.style.display == "block" && (vSpinWindow.width = vSpinWindow.clientWidth, vSpinWindow.height = vSpinWindow.clientHeight, spinItemCanvas.style.width = vSpinWindow.clientWidth * 2.1 / 2 + "px", spinItemCanvas.style.height = vSpinWindow.clientWidth * 2.1 / 2 + "px", v11663.setSize(vSpinWindow.clientWidth * 2.1 / 2, vSpinWindow.clientWidth * 2.1 / 2), vSpinWindow.width > 0)) {
    if (vLN01912 < 1) {
      vLN01912 += p14229 * 0.008;
      if (vLN01912 >= 1) {
        vLN01912 = 1;
      }
    }
    if (vLN01915 < vLN01911) {
      vLN01915 += p14229 * 0.4;
      if (vLN01915 >= vLN01911) {
        vLN01915 = vLN01911;
      }
      if (!v11667.free) {
        v11660 = true;
      }
      spinItem.style.display = "block";
      spinItemName.style.display = "inline-block";
      spinUIBtns.style.display = "inline-block";
      spinEquipBtn.style.display = "inline-block";
      spinNextBtn.style.display = vLN01913 < vA632.length ? "inline-block" : "none";
    }
    for (let vLN01930 = 0; vLN01930 < vA630.length; vLN01930++) {
      if (vA630[vLN01930] != vA629[vLN01930]) {
        vA630[vLN01930] += (vA629[vLN01930] - vA630[vLN01930]) * vA631[vLN01930] * 0.024;
        vLN01917 -= Math.abs(vA629[vLN01930] - vA630[vLN01930]) * vA631[vLN01930] * 0.024;
        if (vLN01917 <= 0) {
          vLN01917 += Math.PI / 1.5;
          SOUND.play("tick_0", 0.2);
        }
        if (Math.abs(vA629[vLN01930] - vA630[vLN01930]) <= 0.003 / vA631[vLN01930]) {
          vA630[vLN01930] = vA629[vLN01930];
          f1847();
        }
      }
    }
    var v11713 = 1 - (vLN01911 ? vLN01915 / vLN01911 : 0);
    v11653.translate(2, 2);
    var v11714 = vSpinWindow.width / 2 * vLN05100 * vLN01912;
    spinButton.style.opacity = v11713;
    var v11715 = v11714 * 0.3 * (1 - v11713);
    spinButton.style.width = v11714 * 2 * vLN06100 * 0.8 + v11715 + "px";
    spinButton.style.height = v11714 * 2 * vLN06100 * 0.8 + v11715 + "px";
    spinText.style.fontSize = v11714 * 2 * vLN06100 * 0.15 + v11715 + "px";
    spinCost.style.fontSize = v11714 * 2 * vLN06100 * 0.08 + v11715 + "px";
    v11653.fillStyle = "#2b2b2b";
    v11653.beginPath();
    v11653.arc(vSpinWindow.width / 2, vSpinWindow.height / 2, v11714, 0, Math.PI * 2);
    v11653.closePath();
    v11653.fill();
    var vLN01931 = 0;
    v11653.save(1);
    v11653.translate(vSpinWindow.width / 2, vSpinWindow.height / 2);
    if (vLN01911) {
      var vLN01932 = 0;
      for (var vLN01934 = 0; vLN01934 < Game.store.rarities.length; vLN01934++) {
        if (v11654.rarity == vLN01934) {
          vLN01932 += v11667.rarities[vLN01934] / 2;
          break;
        } else {
          vLN01932 += v11667.rarities[vLN01934];
        }
      }
      vLN01932 /= 100;
      vLN01932 = Math.PI * 2 * vLN01932 * (vLN01915 / vLN01911) % (Math.PI * 2);
      v11653.rotate(vLN01932 - Math.PI * (vLN01915 / vLN01911));
    }
    for (var vLN01934 = 0; vLN01934 < Game.store.rarities.length; vLN01934++) {
      player = Game.store.rarities[vLN01934];
      v11653.fillStyle = player.color;
      v11653.beginPath();
      var v11716 = v11667.rarities[vLN01934];
      if (vLN01911) {
        if (v11654.rarity == vLN01934) {
          if (RENDER.rarityAnim && player.animate) {
            v11653.fillStyle = UTILS.hexFromHue(Math.round(vLN01929));
            vLN01929 += p14229 * 0.3;
            if (vLN01929 >= 360) {
              vLN01929 = 0;
            }
          }
          v11716 += vLN01915;
        } else {
          v11716 -= vLN01915 * (v11667.rarities[vLN01934] / vLN01911);
        }
      }
      if (v11716 > 0) {
        v11653.moveTo(0, 0);
        v11653.arc(0, 0, v11714 * 0.95, vLN01931, vLN01931 + Math.PI * 2 * (v11716 / 100), false);
        v11653.lineTo(0, 0);
        v11653.fill();
      }
      vLN01931 += Math.PI * 2 * (v11716 / 100);
    }
    v11653.restore(-1);
    v11653.fillStyle = "#F44336";
    v11653.shadowColor = "black";
    v11653.shadowBlur = 20;
    for (let vLN01935 = 0; vLN01935 < vA630.length; vLN01935++) {
      v11653.save(1);
      v11653.translate(vSpinWindow.width / 2, vSpinWindow.height / 2);
      v11653.rotate(vA630[vLN01935]);
      v11653.beginPath();
      v11653.moveTo(0, v11714 * vLN06100 * -1.2 * v11713);
      v11653.lineTo(v11714 * vLN06100 * 0.7 * v11713, 0);
      v11653.lineTo(-(v11714 * vLN06100 * 0.7) * v11713, 0);
      v11653.closePath();
      v11653.fill();
      v11653.restore(-1);
    }
    v11653.fillStyle = "#2b2b2b";
    v11653.beginPath();
    v11653.arc(vSpinWindow.width / 2, vSpinWindow.height / 2, v11714 * vLN06100, 0, Math.PI * 2);
    v11653.closePath();
    v11653.fill();
    if (spinItem.style.display == "block" && v11664) {
      var v11717 = 1 - Math.abs(v11662.position.x - vLN305) / (vLN3002 - vLN305);
      spinItemName.style.opacity = v11717;
      spinItemName.style.marginTop = v11714 * 0.6 + "px";
      spinItemName.style.fontSize = v11714 / 6.5 * v11717 + "px";
      if (!v11667.kr && spinItemName.children[0]) {
        spinItemName.children[0].style.fontSize = v11714 / 12 * v11717 + "px";
      }
      if (!v11667.kr && spinItemName.children[1]) {
        spinItemName.children[1].style.fontSize = v11714 / 12 * v11717 + "px";
      }
      spinItemName.style.padding = v11714 / 20 * v11717 + "px";
      spinItemName.style.paddingLeft = v11714 / 1.4 * v11717 + "px";
      spinItemName.style.paddingRight = v11714 / 1.4 * v11717 + "px";
      if (v11662.position.x != vLN305) {
        v11662.position.x -= (v11662.position.x - vLN305) * 0.24;
        if (Math.abs(vLN305 - v11662.position.x) <= 0.05) {
          v11662.position.x = vLN305;
        }
        v11662.lookAt(v11664.position);
      }
      vLN01916 += p14229 * 0.0018;
      spinnerPreview.position.y = spinnerPreview.orgYP + Math.sin(vLN01916) * 0.55;
      spinnerPreview.rotation.x = spinnerPreview.orgXR + Math.sin(vLN01916 * 0.9) * -0.042;
      v11663.render(v11664, v11662);
    }
  }
}
function io_premiumResponse(p14230, p14231, p14232, p14233) {
  try {
    windows[13].resp(p14230, p14231, p14232, p14233);
  } catch (e133) {}
}
function io_aliasResponse(p14234, p14235) {
  try {
    windows[4].aResp(p14234, p14235);
  } catch (e134) {}
}
function f1851(p14236, p14237) {
  try {
    if (p14237 && mapList) {
      windows[9].mapsLoaded(p14237.data, p14237.index, p14237.error);
    }
  } catch (e135) {}
}
function f1852(p14238, p14239) {
  try {
    if (p14239 && modList) {
      windows[3].modsLoaded(p14239.data, p14239.index, p14239.error);
    }
  } catch (e136) {}
}
function f1853(p14240, p14241) {
  if (p14241) {
    windows[p14241.index].searchResp(p14241.data);
  }
}
function io_clanResponse(p14242, p14243, p14244, p14245) {
  windows[12].resp(p14242, p14243, p14244, p14245);
}
function io_clanLeaveResponse() {
  windows[12].del();
}
function io_refL(p14246) {
  windows[20].applyRefInfo(p14246);
}
function io_tdR(p14247) {
  windows[4].dropsLoaded(p14247);
}
function io_promosResponse(p14248) {
  windows[4].promosLoaded(p14248);
}
function io_dediBuyResponse(p14249, p14250, p14251) {
  windows[7].dediRes(p14249, p14250, p14251);
}
function io_friendsListResponse(p14252) {
  if (p14252 && p14252.length) {
    p14252.sort(function (p14253, p14254) {
      p14253.st = p14253.st || 0;
      p14254.st = p14254.st || 0;
      if (p14253.st < p14254.st) {
        return 1;
      } else if (p14253.st > p14254.st) {
        return -1;
      } else {
        return 0;
      }
    });
  }
  friends = p14252 || [];
  windows[4].friendsLoaded(p14252);
  if (friends.length) {
    vLN02047 = 2;
    f2045();
  }
}
function io_updateChallenges(p14255) {
  if (account && p14255) {
    for (var vLN01936 = 0, v11718; vLN01936 < p14255.length; vLN01936 += 3) {
      v11718 = account.activeChallenges.find(p14256 => p14256 && p14256.CI == p14255[vLN01936 + 1]);
      if (v11718) {
        v11718.PV = p14255[vLN01936 + 2];
        v11718.PT = parseInt(p14255[vLN01936]);
      }
    }
  }
  if (!inGame) {
    updateWindow(33);
  }
}
function io_updateChallengesProgress(p14257) {
  if (account && p14257) {
    for (var vLN01937 = 0, v11719; vLN01937 < p14257.length; vLN01937 += 2) {
      v11719 = account.activeChallenges.find(p14258 => p14258 && p14258.CI == p14257[vLN01937]);
      if (v11719) {
        v11719.PV = p14257[vLN01937 + 1];
        if (v11719.PV >= v11719.DAT.val) {
          v11719.PT = 1;
        }
      }
    }
  }
}
function io_challengeCompleted(p14259, p14260, p14261) {
  if (account) {
    var v11720 = account.activeChallenges[p14259];
    if (!p14260) {
      endChals.insertAdjacentHTML("beforeend", "<div class='endChalCard' onclick='showWindow(33, true)' onmouseenter='playTick()'><img class='endChalImg' src='" + UTILS.assetsUrl("/img/chals/icon_" + (v11720.IC || 0) + ".png") + "' /><div class='endChalRight'>" + v11720.N + "<div class='endChalDesc'>Completed!</div></div></div>");
    } else {
      io_addChat(-1, null, "<span style='color:#fff'>Finish the game to complete:</span> <span style='color:#FBC02D'>[" + v11720.N + "]</span> challenge", 1);
      if (p14261.jnk) {
        matchRewardSummary.junk = (matchRewardSummary.junk || 0) + parseFloat(p14261.jnk);
      }
      if (p14261.sk) {
        if (!matchRewardSummary.skins) {
          matchRewardSummary.skins = [];
        }
        var v11721 = Array.isArray(p14261.sk) ? p14261.sk : [p14261.sk];
        v11721.forEach(p14262 => {
          var v11722 = matchRewardSummary.skins.find(p14263 => p14263 && p14263.i == p14262);
          if (v11722) {
            v11722.c++;
          } else {
            matchRewardSummary.skins.push({
              i: p14262,
              c: 1
            });
          }
        });
      }
    }
  }
}
function io_countryFlagUpdate(p14264) {
  if (account) {
    account.stats.flg = p14264 == null ? account.stats.flg : p14264;
    updateWindow(5);
  }
}
function io_badgeUpdate(p14265) {
  if (account) {
    account.stats.bdg = p14265 == null ? account.stats.bdg : p14265;
    clearPops();
    updateWindow(5);
  }
}
function io_badgeClaimResponse(p14266) {
  if (account) {
    account.badges.push(p14266);
    io_showPopup("SUCCESS", null, "Badge Claimed!");
  }
}
function io_badgeClaimMultiRes(p14267) {
  if (account) {
    account.badges.push(...p14267);
    io_showPopup("SUCCESS", null, "You unlocked new badges");
  }
}
function io_hideStatus(p14268) {
  if (account) {
    account.stats.hds = p14268;
    updateWindow(5);
  }
}
function io_dataLoaded(p14269) {
  return windows[5].dataLoaded(p14269);
}
function io_syncBpProg(p14270) {
  if (account) {
    account.BP = p14270;
  }
  return windows[5].syncBPProg(p14270);
}
var vLN01938 = 0;
var v11723;
var v11724;
Object.defineProperty(window, "selectHostMap", {
  writeable: false,
  value: function (p14271, p14272 = null, p14273) {
    var v11725 = windows[9];
    if (v11725.hostType == 2) {
      v11724 = {
        id: p14273,
        name: p14271
      };
    } else {
      v11724 = {
        id: p14273,
        name: p14271
      };
      vLN01938 = 0;
      v11723 = null;
      if (p14272 != "undefined" && p14272 != null) {
        v11724 = null;
        v11723 = p14272;
      }
    }
    showWindow(8);
  }
});
Object.defineProperty(window, "autoHostMap", {
  writeable: false,
  value: function (p14274, p14275) {
    if (p14275) {
      loadGamNm.innerHTML = i18n.t("generic.hosting.noGames");
    }
    API_CLIENT.getMapPreset(p14274, function (p14276, p14277, p14278) {
      if (p14275) {
        loadGamNm.innerHTML = i18n.t("generic.hosting") + " " + p14274 + " ...";
      }
      var v11726 = null;
      try {
        v11726 = p14276 && p14277 ? JSON.parse(p14277) : null;
      } catch (e137) {
        v11726 = null;
      }
      var vA639 = [];
      for (var vLN01947 = 0, v11727; vLN01947 < gameModes.length; vLN01947++) {
        v11727 = gameModes[vLN01947];
        if (!v11727.preventCustomGames || account && account.isDev) {
          var v11730 = v11726 ? v11726.modes && v11726.modes.indexOf(vLN01947) >= 0 : vLN01947 == 0;
          if (v11730) {
            vA639.push(vLN01947);
          }
        }
      }
      if (!vA639.length) {
        vA639.push(0);
      }
      var vA640 = [];
      for (var vLN01947 = 0; vLN01947 < Game.classConfig.length; vLN01947++) {
        var v11729 = Game.classConfig[vLN01947];
        var v11730 = !v11726 || !v11726.classes || v11726.classes.indexOf(vLN01947) >= 0;
        if (v11730) {
          vA640.push(vLN01947);
        }
      }
      var vO366 = {
        private: false,
        krRewards: (p14278 || 0) > 0,
        defaultSetts: true,
        override: 0,
        customMap: p14274,
        rawMapData: null,
        maps: [],
        modes: vA639,
        classes: vA640,
        passCode: null
      };
      var v11731 = UTILS.getAccountType(account);
      for (var vLN01947 = 0; vLN01947 < config.serverConfig.length; vLN01947++) {
        player = config.serverConfig[vLN01947];
        let v11732;
        if (player.bool) {
          v11732 = player.def;
          if (v11726 && v11726.settings && v11726.settings[player.varN] != null && !player.cost) {
            v11732 = !!v11726.settings[player.varN];
          }
        } else if (player.input) {
          v11732 = "";
        } else if (player.select) {
          v11732 = player.def;
        } else {
          var v11733 = player.def;
          var v11734 = player.max;
          if (v11731 == 3) {
            v11734 = player.maxF || player.max;
          } else if (v11731 == 2) {
            v11734 = player.maxP || player.max;
          } else if (v11731 == 0) {
            v11734 = player.maxG || player.max;
          }
          if (v11726 && v11726.settings && v11726.settings[player.varN] != null && !player.cost) {
            v11733 = v11726.settings[player.varN];
            if (v11733 > v11734) {
              v11733 = v11734;
            }
          }
          v11732 = parseFloat(v11733) || 0;
        }
        vO366[player.varN] = v11732;
      }
      if (v11726 && v11726.weps) {
        for (var vLN01946 = 0, v11735; vLN01946 < Game.weapons.length; vLN01946++) {
          v11735 = v11726.weps && v11726.weps[vLN01946] != null ? v11726.weps[vLN01946] : null;
          for (var vLN01947 = 0; vLN01947 < config.weaponConfig.length; vLN01947++) {
            player = config.weaponConfig[vLN01947];
            if (Game.weapons[vLN01946][player.varN] != null) {
              var v11742 = v11735 && v11735[player.varN] != null ? v11735[player.varN] : Game.weapons[vLN01946][player.varN];
              if (player.bool) {
                v11742 = !!v11742;
              } else if (player.select) {
                v11742 = player.options[v11742] == null ? player.def : parseInt(v11742);
              } else if (player.input) {
                v11742 = v11742 ? v11742 : "";
                if (!UTILS.isString(v11742)) {
                  v11742 = Game.weapons[vLN01946][player.varN];
                }
                if (/[^\w \-\|]+/gmi.test(v11742)) {
                  v11742 = Game.weapons[vLN01946][player.varN];
                }
                if (v11742.length > (player.len || 16)) {
                  v11742 = Game.weapons[vLN01946][player.varN];
                }
              } else {
                var v11743 = player.decs;
                v11742 = UTILS.fixFloat(v11742, v11743);
              }
              if (v11742 != Game.weapons[vLN01946][player.varN]) {
                if (!vO366.weps) {
                  vO366.weps = {};
                }
                if (!vO366.weps[vLN01946]) {
                  vO366.weps[vLN01946] = {};
                }
                vO366.weps[vLN01946][player.varN] = v11742;
              }
            }
          }
        }
      }
      if (v11726 && v11726.cls) {
        for (var vLN01946 = 0, v11738; vLN01946 < Game.classes.length; vLN01946++) {
          v11738 = v11726.cls && v11726.cls[vLN01946] != null ? v11726.cls[vLN01946] : null;
          for (var vLN01947 = 0; vLN01947 < config.classConfig.length; vLN01947++) {
            player = config.classConfig[vLN01947];
            if (Game.classes[vLN01946][player.varN] != null) {
              var v11742 = v11738 && v11738[player.varN] != null ? v11738[player.varN] : Game.classes[vLN01946][player.varN];
              if (player.bool) {
                v11742 = !!v11742;
              } else if (player.select) {
                v11742 = player.options[v11742] == null ? player.def : parseInt(v11742);
              } else if (player.input) {
                v11742 = v11742 ? v11742 : "";
                if (!UTILS.isString(v11742)) {
                  v11742 = Game.classes[vLN01946][player.varN];
                }
                if (/[^\w \-\|]+/gmi.test(v11742)) {
                  v11742 = Game.classes[vLN01946][player.varN];
                }
                if (v11742.length > (player.len || 16)) {
                  v11742 = Game.classes[vLN01946][player.varN];
                }
              } else {
                var v11743 = player.decs;
                v11742 = UTILS.fixFloat(v11742, v11743);
              }
              if (v11742 != Game.classes[vLN01946][player.varN]) {
                if (!vO366.cls) {
                  vO366.cls = {};
                }
                if (!vO366.cls[vLN01946]) {
                  vO366.cls[vLN01946] = {};
                }
                vO366.cls[vLN01946][player.varN] = v11742;
              }
            }
          }
        }
      }
      if (v11726 && v11726.prks) {
        for (var vLN01946 = 0, v11741; vLN01946 < Game.effects.length; vLN01946++) {
          v11741 = v11726.prks && v11726.prks[vLN01946] != null ? v11726.prks[vLN01946] : null;
          for (var vLN01947 = 0; vLN01947 < config.effectConfig.length; vLN01947++) {
            player = config.effectConfig[vLN01947];
            if (Game.effects[vLN01946][player.varN] != null) {
              var v11742 = v11741 && v11741[player.varN] != null ? v11741[player.varN] : Game.effects[vLN01946][player.varN];
              if (player.bool) {
                v11742 = !!v11742;
              } else if (player.select) {
                v11742 = player.options[v11742] == null ? player.def : parseInt(v11742);
              } else if (player.input) {
                v11742 = v11742 ? v11742 : "";
                if (!UTILS.isString(v11742)) {
                  v11742 = Game.effects[vLN01946][player.varN];
                }
                if (/[^\w \-\|]+/gmi.test(v11742)) {
                  v11742 = Game.effects[vLN01946][player.varN];
                }
                if (v11742.length > (player.len || 16)) {
                  v11742 = Game.effects[vLN01946][player.varN];
                }
              } else {
                var v11743 = player.decs;
                v11742 = UTILS.fixFloat(v11742, v11743);
              }
              if (v11742 != Game.effects[vLN01946][player.varN]) {
                if (!vO366.prks) {
                  vO366.prks = {};
                }
                if (!vO366.prks[vLN01946]) {
                  vO366.prks[vLN01946] = {};
                }
                vO366.prks[vLN01946][player.varN] = v11742;
              }
            }
          }
        }
      }
      f1732("hosting", function (p14279, p14280) {
        if (!p14280) {
          io.send("custom", vO366, p14279);
        }
      });
    });
  }
});
function f1871(p14281, p14282, p14283) {
  return new Promise((p14284, p14285) => {
    client.fetchGameList().then(p14286 => {
      var v11751 = p14286;
      var v11744 = v11751.games;
      var v11745 = SETTINGS.list.defaultRegion.val;
      var vA641 = [];
      for (var v11746 of v11744) {
        var [v11747, v11748, v11749, v11750, v11751] = v11746;
        if (!(v11749 >= v11750)) {
          var vLN01948 = 0;
          for (var v11752 in p14281) {
            vLN01948++;
            if (p14281[v11752] == v11751[v11752]) {
              vLN01948--;
            }
          }
          if (vLN01948 == 0) {
            vA641.push({
              id: v11747,
              region: v11748,
              clients: v11749,
              maxClients: v11750,
              data: v11751
            });
          }
        }
      }
      vA641 = vA641.sort((p14287, p14288) => (p14288.clients || 0) - (p14287.clients || 0));
      if (!p14283) {
        vA641 = vA641.sort((p14289, p14290) => (p14290.region == v11745 ? 1 : 0) - (p14289.region == v11745 ? 1 : 0));
      }
      if (vA641.length) {
        if (vA641.length > p14282) {
          vA641.length = p14282;
        }
        p14284(vA641);
      } else {
        p14285();
      }
    });
  });
}
Object.defineProperty(window, "openServerWindow", {
  writeable: false,
  value: function (p14291) {
    var v11753 = !!window.event && !!window.event.shiftKey;
    if (p14291 == 0) {
      showWindow(2);
    } else if (p14291 == 1) {
      showWindow(2);
      requestAnimationFrame(() => {
        var v11754 = !!SETTINGS.tmp.oldBrowser;
        if (v11754) {
          setExpandedRegion(-1);
        } else {
          windows[1].switchTab(1);
        }
      }, 500);
    } else if (p14291 == 2) {
      io_loadingPopup("Searching...");
      f1871({
        oc: 1,
        g: 23
      }, 20, v11753).then(p14292 => {
        for (var vLN01949 = 0; vLN01949 < p14292.length; vLN01949++) {
          f1736(p14292[vLN01949].id);
        }
        requestAnimationFrame(() => io_showPopup(null, "Took to long to find"), 2000);
      }).catch(() => {
        io_showPopup(null, "Couldnt find any");
      });
    } else if (p14291 == 3) {
      io_loadingPopup("Searching...");
      f1871({
        oc: 1,
        g: 35
      }, 20, v11753).then(p14293 => {
        for (var vLN01950 = 0; vLN01950 < p14293.length; vLN01950++) {
          f1736(p14293[vLN01950].id);
        }
        requestAnimationFrame(() => io_showPopup(null, "Took to long to find"), 2000);
      }).catch(() => {
        io_showPopup(null, "Couldnt find any");
      });
    } else if (p14291 == 4) {
      io_loadingPopup("Searching...");
      f1871({
        oc: 1,
        g: 18
      }, 20, true).then(p14294 => {
        for (var vLN01951 = 0; vLN01951 < p14294.length; vLN01951++) {
          f1736(p14294[vLN01951].id);
        }
        requestAnimationFrame(() => io_showPopup(null, "Took to long to find"), 2000);
      }).catch(() => {
        io_showPopup(null, "Couldnt find any");
      });
    }
  }
});
Object.defineProperty(window, "openHostWindow", {
  writeable: false,
  value: function (p14295, p14296) {
    if (Game && Game.isOfficial) {
      return showWindow(0);
    } else {
      v11724 = null;
      v11723 = null;
      vLN01938 = p14295 ? 0 : p14296 || 0;
      showWindow(8, p14295);
      return;
    }
  }
});
Object.defineProperty(window, "openJoinWindow", {
  writeable: false,
  value: function (p14297, p14298) {
    if (p14298 || !navigator.clipboard) {
      return showWindow(24);
    } else {
      if (!p14298) {
        navigator.clipboard.readText().then(function (p14299) {
          f1886(p14299);
        }).catch(p14300 => {
          showWindow(24);
        });
      }
      return;
    }
  }
});
window.downloadFile = function (p14301, p14302) {
  var v11755 = document.createElement("a");
  v11755.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(JSON.stringify(p14302)));
  v11755.setAttribute("download", p14301);
  v11755.style.display = "none";
  document.body.appendChild(v11755);
  v11755.click();
  document.body.removeChild(v11755);
};
function io_uploadResponse(p14303, p14304) {
  try {
    if (pfpUpResp && p14304 == 1) {
      pfpUpResp.innerHTML = p14303;
    }
  } catch (e138) {}
  try {
    if (setUpResp && p14304 == 2) {
      setUpResp.innerHTML = p14303;
    }
  } catch (e139) {}
}
function io_uploadProfileResponse() {
  f1773();
  updateWindow(5);
  io_showPopup("SUCCESS", null, "Uploaded!");
}
window.loadCSSF = function (p14305) {
  var v11756 = document.getElementsByTagName("head")[0];
  var v11757 = document.createElement("link");
  v11757.id = "cssLoadr" + UTILS.randInt(0, 10000);
  v11757.rel = "stylesheet";
  v11757.type = "text/css";
  v11757.href = "./css/" + p14305 + "/main.css";
  v11757.media = "all";
  v11756.appendChild(v11757);
};
var vA642 = [];
var vA643 = [];
var v11758 = new FileReader();
var v11759 = null;
v11758.onload = p14306 => loadModPack(p14306.target.result);
var v11760 = null;
function f1874(p14307) {
  this.imgAsDataURL = "";
  this.process = function (p14308) {
    if (p14307) {
      this.imgAsDataURL = URL.createObjectURL(p14308);
      try {
        if (p14307 == "textures/logo.png") {
          if (SETTINGS.tmp.canChangeLogo) {
            if (!v11760) {
              v11760 = mainLogo.src.toString();
            }
            mainLogo.src = this.imgAsDataURL;
          }
        } else if (p14307 == "scares/scare_2.png") {
          vA660[0].img = this.imgAsDataURL;
        } else if (p14307 == "textures/muzflash.png") {
          overlay.updateMuzzle(this.imgAsDataURL);
        } else if (p14307 == "textures/objective_1.png" || p14307 == "textures/objective_7.png") {
          overlay.updateObjectiveMarker(this.imgAsDataURL);
        } else if (p14307 == "textures/objective_6.png" || p14307 == "textures/objective_8.png") {
          overlay.updateNextObjectiveMarker(this.imgAsDataURL);
        } else if (p14307 == "textures/flag_r.png") {
          overlay.updateFlagMarker(this.imgAsDataURL, 0);
        } else if (p14307 == "textures/flag_b.png") {
          overlay.updateFlagMarker(this.imgAsDataURL, 1);
        } else if (p14307.startsWith("img/medals/")) {
          var v11761 = parseInt(p14307.replace("img/medals/", "").replace("badge_", "").replace("medal_", "").replace(".png", "")) || 0;
          overlay.updateMedalIcon(this.imgAsDataURL, p14307.includes("badge_") ? -1 : v11761);
        } else {
          var v11762 = new Image();
          v11762.onload = function () {
            RENDER.updateTexture(p14307.replace("textures/", "").replace("img/", "").replace(".png", ""), this);
          };
          v11762.src = this.imgAsDataURL;
        }
      } catch (e140) {}
    }
    v11784.close();
  };
}
function f1875(p14309) {
  this.process = function (p14310) {
    var v11763 = URL.createObjectURL(p14310);
    if (v11763) {
      try {
        var v11764 = p14309.split("/")[1];
        SOUND.updateSound(v11764, v11763);
        var vParseInt42 = parseInt(Game.mode.ambInd || Game.map.maps[Game.mapIndex].ambInd || 1);
        if (v11764 == "ambient_" + vParseInt42) {
          SOUND.play("ambient_" + vParseInt42, config.amvVols[vParseInt42] || 0.12, true, 1);
        }
      } catch (e141) {}
    }
    v11784.close();
  };
}
function f1876(p14311) {
  this.process = function (p14312) {
    if (p14311) {
      try {
        var v11765 = p14311.split(".").slice(-1).pop();
        var v11766 = new FileReader();
        v11766.addEventListener("loadend", p14313 => {
          var v11767 = p14313.srcElement.result;
          RENDER.updateMesh(p14311.replace(/models\/|\.obj|\.gltf|\.glb|\.fbx/gmi, ""), v11767, v11765);
        });
        v11766.readAsText(p14312);
      } catch (e142) {}
    }
    v11784.close();
  };
}
var vA644 = ["aimAnim", "hideADS", "showHands", "showWeapon", "showWeaponSec", "showWeaponMel"];
function f1877(p14314) {
  if (p14314 && UTILS.isString(p14314)) {
    for (var v11768 = p14314.split(/\r?\n/).filter(p14315 => p14315.length).map(p14316 => p14316.trim()), vLN01952 = 0, v11769; vLN01952 < v11768.length; vLN01952++) {
      v11769 = v11768[vLN01952].split(",");
      if (SETTINGS.list[v11769[0]] && SETTINGS.list[v11769[0]].type != "url" && SETTINGS.list[v11769[0]].type != "text" && !SETTINGS.list[v11769[0]].dev && !SETTINGS.list[v11769[0]].kpd && !SETTINGS.list[v11769[0]].admin && !SETTINGS.list[v11769[0]].partner && !SETTINGS.list[v11769[0]].premium && !SETTINGS.list[v11769[0]].verified && !SETTINGS.list[v11769[0]].noMod) {
        v11769[1] = (v11769[1] || "").trim();
        if (vA644.indexOf(v11769[0]) > -1) {
          if (parseInt(v11769[1]) == 0) {
            v11769[1] = false;
          }
          if (parseInt(v11769[1]) == 1) {
            v11769[1] = true;
          }
        }
        setSetting(v11769[0], v11769[1], true, true, true);
      } else if (v11769[0] == "defaultSkins") {
        useDefaultCosmetics = !!v11769[1];
      }
    }
  }
}
function f1878(p14317) {
  this.process = function (p14318) {
    if (p14317) {
      try {
        var v11770 = p14317.replace("scripts/", "").replace(".txt", "");
        var v11771 = new FileReader();
        v11771.addEventListener("loadend", p14319 => {
          var v11772 = p14319.srcElement.result;
          if (v11770 == "settings") {
            f1877(v11772);
          }
        });
        v11771.readAsText(p14318);
      } catch (e143) {}
    }
    v11784.close();
  };
}
function f1879(p14320) {
  this.process = function (p14321) {
    if (p14320) {
      try {
        var v11773 = p14320.replace("shaders/", "").replace(".json", "");
        var v11774 = new FileReader();
        v11774.addEventListener("loadend", p14322 => {
          var v11775 = p14322.srcElement.result;
          RENDER.insertShaderPass(JSON.parse(v11775));
          v11784.close();
        });
        v11774.readAsText(p14321);
      } catch (e144) {
        v11784.close();
      }
    } else {
      v11784.close();
    }
  };
}
function f1880(p14323, p14324) {
  this.process = function (p14325) {
    if (p14323) {
      try {
        var v11776 = p14323.replace("css/", "").replace(".css", "");
        var v11777 = new FileReader();
        v11777.addEventListener("loadend", p14326 => {
          var v11778 = p14326.srcElement.result;
          if (config.cssBypass.indexOf(p14324) < 0) {
            if (!UTILS.cssCheck(v11778)) {
              v11784.close();
              return;
            }
            for (var v11779 = /aHolder|aMerger|aContainer|krunkerio_728x90_1|\/21823819281\/frvr-krunker_io-krunker-display-banner-krunkerio_728x90_1|\/21823819281\/frvr-frvr-krunker-display-banner-krunkerio_728x90_1|mapVote|mapVoteD|mapVoteU|modVoteHold|modVoteD|modVoteU|modVote|mapInfoHolder|tDecCheck|tSubCheck|tSubOffer|tHeader0|tHeader1|tradeReady0|tradeReady1|tSubName|tradeChatHolder|tradeChatList|tradeChatItem|tradeTotal|trd_|offerVal|trd_inv_|tItemN|tItemCnt|tItemImg|tItemSprayImg|tItemHolder|tSubHolder|tDecOffer|tradeList0|tradeList1|offerVal0|offerVal1|estOfferVal|tDecName|tTotal|tListN|tHolderR|tHolderL|invList1|tList|invList0|jumpSIMG|jumpSVID|jumpSVIDHolder|material-icons|vote|ot-sdk-btn-floating|interactMsg/gim; v11779.test(v11778);) {
              v11778 = v11778.replace(v11779, "");
            }
          }
          var v11780 = document.getElementById("customCSS");
          if (!v11780) {
            v11780 = document.createElement("style");
            v11780.id = "customCSS";
            document.head.appendChild(v11780);
          }
          v11780.innerHTML = v11778;
          v11784.close();
        });
        v11777.readAsText(p14325);
      } catch (e145) {
        v11784.close();
      }
    } else {
      v11784.close();
    }
  };
}
function f1881(p14327) {
  this.process = function (p14328) {
    if (p14327) {
      try {
        var v11781 = p14327.replace("css-img/", "").replace(".png", "");
        vA642[v11781] = URL.createObjectURL(p14328);
      } catch (e146) {}
    }
    v11784.close();
  };
}
function f1882(p14329) {
  this.process = function (p14330) {
    if (p14329) {
      try {
        var v11782 = p14329.replace("css/fonts/", "").replace(".ttf", "").replace(".woff2", "");
        vA643[v11782] = URL.createObjectURL(p14330);
      } catch (e147) {}
    }
    v11784.close();
  };
}
function f1883() {
  var v11783 = document.getElementById("customCSS");
  if (v11783) {
    if (Object.keys(vA642).length) {
      v11783.innerHTML = v11783.innerHTML.replace(/CSSIMAGE:(\w+)/gm, function (p14331, p14332) {
        if (vA642[p14332]) {
          return "url('" + vA642[p14332] + "')";
        } else {
          return "";
        }
      });
    }
    if (Object.keys(vA643).length) {
      v11783.innerHTML = v11783.innerHTML.replace(/CSSFONT:(\w+)/gm, function (p14333, p14334) {
        if (vA643[p14334]) {
          return "url('" + vA643[p14334] + "')";
        } else {
          return "";
        }
      });
    }
    UI.toggleWholeUI(true);
  }
}
function f1884() {
  this.init = function (p14335, p14336) {
    this.numFiles = p14336;
    this.progress = 0;
    this.reader = p14335;
  };
  this.close = function () {
    if (this.reader) {
      this.progress++;
      f1885(i18n.t("mod.extracting", this.progress, this.numFiles));
      if (this.numFiles === this.progress) {
        f1885(i18n.t("generic.success"), true);
        f1883();
        this.reader.close();
        this.reader = undefined;
      }
    }
  };
}
function f1885(p14337, p14338) {
  try {
    if (p14338) {
      requestAnimationFrame(function () {
        UI.toggleWholeUI(true);
      }, 1000);
    }
    modLInfo.textContent = p14337;
  } catch (e148) {}
}
var v11784 = new f1884();
Object.defineProperty(window, "loadUserMod", {
  writeable: false,
  value: function (p14339, p14340, p14341, p14342, p14343, p14344) {
    showWindow(18);
    f1885(i18n.t("generic.loading"));
    loadModPack(p14340, true, false, p14339, p14341, p14342, p14343, p14344);
  }
});
window.loadModURL = function () {
  if (modURL.value) {
    loadModPack(modURL.value, true);
  }
};
const vF100 = (p14345, p14346, p14347) => p14345.getData(p14346).then(p14348 => p14347(p14348, p14345));
Object.defineProperty(window, "loadModPack", {
  writeable: false,
  value: function (p14349, p14350, p14351, p14352, p14353, p14354, p14355, p14356) {
    if (p14349) {
      p14349 = UTILS.replaceUserAsset(p14349);
    }
    if ((!!UTILS.isDropbox(p14349) || !!UTILS.isUserAsset(p14349)) && !(p14349.indexOf("&") > -1) || !p14350) {
      if (!SETTINGS.tmp.canLoadMods) {
        return f1885(i18n.t("mod.disabled"), true);
      }
      if (p14350 && !p14351 && SETTINGS.list.autoLoadLast.val) {
        setLastMod(p14349);
      }
      if (p14352 != null && p14353 != null) {
        v11850 = 0;
        modVoteName.innerHTML = p14352 + " Mod";
        modVoteHold.innerHTML = "\n\t\t\t\t<div class=\"voteHint vHR\" onclick=\"openURL('/social.html?p=profile&q=" + p14354 + "&autoGift=1&mn=" + p14352 + "')\">Donate</div>\n\t\t\t\t<div style=\"float:right;\">\n\t\t\t\t\t<i id=\"modVoteD\" onclick=\"voteMod(" + p14353 + ", -1);\" class='material-icons vote'>thumb_down</i>\n\t\t\t\t\t<i id=\"modVoteU\" onclick=\"voteMod(" + p14353 + ", 1);\" class='material-icons vote'>thumb_up</i>\n\t\t\t\t</div>\n\t\t\t";
        modVote.style.display = "block";
      } else {
        modVote.style.display = "none";
      }
      try {
        windows[3].loaded(p14349, p14350, p14351, p14352, p14353, p14354, p14355, p14349 == lastLoadedModUrl);
        p14349 = p14349.replace("dropbox.com", "dl.dropboxusercontent.com").replace(/&/g, "nope");
        var vLS88 = "";
        var v11785 = p14350 ? new zip.HttpReader(p14349) : new zip.Data64URIReader(p14349);
        vA642.length = 0;
        vA643.length = 0;
        let v11786 = new zip.ZipReader(v11785);
        v11786.getEntries().then(function (p14357) {
          var v11787 = !!p14357.find(p14358 => p14358.filename.startsWith("css/"));
          if (!v11787) {
            UI.toggleWholeUI(true);
          }
          if (p14357.length) {
            v11784.init(v11786, p14357.length);
            for (var vLN01953 = 0, v11788; vLN01953 < p14357.length; vLN01953++) {
              v11788 = p14357[vLN01953];
              if (v11788.directory) {
                v11784.close();
                continue;
              }
              vLS88 = v11788.filename.split("/");
              if (vLS88[0] == "textures" || vLS88[0] == "img") {
                vF100(v11788, new zip.BlobWriter("image/png"), (p14359, p14360) => new f1874(p14360.filename).process(p14359));
              } else if (vLS88[0] == "sound") {
                vF100(v11788, new zip.BlobWriter("audio/mp3"), (p14361, p14362) => new f1875(p14362.filename.replace(".mp3", "")).process(p14361));
              } else if (vLS88[0] == "models" && !v11788.filename.includes("event_0")) {
                vF100(v11788, new zip.BlobWriter(v11788.filename.endsWith("glb") ? "model/gltf-binary" : v11788.filename.endsWith("gltf") ? "model/gltf+json" : "application/x-tgif"), (p14363, p14364) => new f1876(p14364.filename).process(p14363));
              } else if (vLS88[0] == "scripts") {
                vF100(v11788, new zip.BlobWriter("text/plain"), (p14365, p14366) => new f1878(p14366.filename).process(p14365));
              } else if (vLS88[0] == "shaders") {
                vF100(v11788, new zip.BlobWriter("application/json"), (p14367, p14368) => new f1879(p14368.filename).process(p14367));
              } else if (vLS88[0] != "css") {
                if (vLS88[0] == "css-img") {
                  vF100(v11788, new zip.BlobWriter("image/png"), (p14369, p14370) => new f1881(p14370.filename).process(p14369));
                } else {
                  v11784.close();
                }
              } else if (vLS88[1] && vLS88[1] == "fonts") {
                var v11789 = v11788.filename.includes("woff2") ? "font/woff2" : "font/ttf";
                vF100(v11788, new zip.BlobWriter(v11789), (p14371, p14372) => new f1882(p14372.filename).process(p14371));
              } else {
                vF100(v11788, new zip.BlobWriter("text/css"), (p14373, p14374) => new f1880(p14374.filename, p14354).process(p14373));
              }
            }
          }
        }).catch(function (p14375) {
          f1885(i18n.t("mod.error"), true);
        });
      } catch (e149) {
        f1885(i18n.t("mod.error"), true);
      }
    }
  }
});
if (SETTINGS.list.autoLoadLast.val && lastLoadedModUrl.length) {
  loadModPack(lastLoadedModUrl, true);
}
window.loadMod = function () {
  if (modInput.files && modInput.files[0]) {
    var v11790 = modInput.files[0];
    var v11791 = v11790.name.split(".").pop().toLowerCase();
    if (v11791 == "zip") {
      f1885(i18n.t("mod.loading"));
      v11758.readAsDataURL(v11790);
    } else {
      f1885(i18n.t("mod.invalid"), true);
    }
  }
};
function f1886(p14376) {
  var v11792 = p14376.match(/^(https?:\/\/)?(www\.)?(.+)(krunker\.io|127\.0\.0\.1:8080)\/\?(party|game)=(.+)$/);
  if (v11792 && v11792.length == 7) {
    var v11793 = f1887(p14376) == f1887(window.location.href);
    if ((!v11793 || v11792[5] == "game") && FRVR.channelCharacteristics.allowNavigation) {
      window.location.href = vF91(window.location, p14376, vA577);
    } else {
      showWindow(24);
    }
  } else if (p14376.match(/^([A-Z]+):(\w+)$/)) {
    if (FRVR.channelCharacteristics.allowNavigation) {
      p14376 = window.location.origin + "/?game=" + p14376;
      window.location.href = vF91(window.location, p14376, vA577);
    }
  } else {
    showWindow(24);
  }
}
function f1887(p14377) {
  return p14377.match(/^(https?:\/\/)?(www\.)?(.+)(krunker\.io|127\.0\.0\.1:8080)\/\?(party|game)=(.+)$/).slice(3, 5).join("");
}
window.joinGame = function () {
  f1886(gameURL.value || "");
};
window.closeRankedPopup = function () {
  clearPops(true);
};
function io_startGame(p14378, p14379, p14380, p14381, p14382, p14383, p14384, p14385) {
  if (p14382 != null) {
    Game[p14382 ? "lockMove" : "unlockMove"]();
  }
  currentKpdCase = p14384;
  overlay.kpdData = currentKpdCase;
  if (currentKpdCase) {
    specControlHolder.firstElementChild.children[8].style.display = "";
    updateKpdVerdictPrompt(0);
  } else {
    specKPDContr.style.display = "none";
  }
  team = p14379;
  window.spectating = p14380;
  if (Game.eventIndex == 3) {
    RENDER.toggleMeshGroup("event_0", !p14380);
  } else {
    RENDER.toggleMeshGroup("event_0", false);
  }
  if (!team && p14380) {
    team = 1;
  }
  io_updateTimer(p14378);
  f1898();
  UI.toggleMenu(false);
  SOUND.play("reload_3", 0.2);
  resetGameSessionState();
  updateCamMouse(p14385);
  f1889();
  UI.toggleControlUI(CONTROLS.enabled);
  window.scaleBase(null, true);
  roundsDisplay.style.display = Game && Game.config.gamRounds > 1 && !window.spectating ? "inline-block" : "none";
  bottomLeftChallIcon.classList.toggle("challIconSkull", p14381);
  bottomLeftChallIcon.classList.toggle("challIconHP", !p14381);
  if (!p14383) {
    io_disconnect(null, "000003");
  }
  if (currentKpdCase && currentKpdCase.sus != focusedPlayerId) {
    focusPlayer(currentKpdCase.sus, false, true);
  }
  gameplayStartTime = Date.now();
  f2080(p14385);
}
function f1889(p14386) {
  speedRunHolder.style.display = "none";
  killCount.style.display = Game.mode.friendly || !SETTINGS.tmp.showKillC ? "none" : "inline-block";
  deathCount.style.display = Game.mode.friendly || !SETTINGS.tmp.showDeaths ? "none" : "inline-block";
  kdCount.style.display = Game.mode.friendly || !SETTINGS.tmp.showKD ? "none" : "inline-block";
  if (Game.mode.custUI && !window.spectating) {
    Game.mode.custUI(Game, config, p14386);
  }
}
var vO367 = {};
function io_syncPConObj(p14387, p14388) {
  vO367[p14387] = p14388;
  if (!p14388) {
    delete vO367[p14387];
  }
  f1892();
}
function io_syncPConData(p14389) {
  vO367 = p14389;
  f1892();
}
window.updSyncDat = function (p14390, p14391) {
  io.send("cd", p14390, p14391);
};
var vA645 = [];
function f1892() {
  var vO368 = {};
  var v11794 = Game.config.tmSize + 1;
  var v11795 = v11794 * 2;
  vA645.length = 0;
  for (var v11796 in vO367) {
    if (vO367.hasOwnProperty(v11796)) {
      var v11803 = vO367[v11796];
      if (v11796 == v12147) {
        vO368 = v11803;
      }
      if (v11803.a) {
        vA645.push(v11803);
      }
    }
  }
  compPlListL.innerHTML = "<div class='cmpTmHed'>" + config.teamNames[0] + "</div>";
  compPlListR.innerHTML = "<div class='cmpTmHed'>" + config.teamNames[1] + "</div>";
  var v11798 = vO368.t || 0;
  var v11799 = Game.config.limitClasses;
  for (var vLN01957 = 0; vLN01957 < Game.classConfig.length; vLN01957++) {
    var v11800 = false;
    var v11801 = Game.config["classLim" + vLN01957] || 0;
    var vLN01955 = 0;
    if (!v11799 || v11801) {
      if (v11799) {
        for (var vLN01958 = 0; vLN01958 < vA645.length; ++vLN01958) {
          if (vA645[vLN01958].c == vLN01957 && vA645[vLN01958].t == v11798 && (vLN01955++, vLN01955 >= v11801)) {
            v11800 = true;
            break;
          }
        }
      }
      var v11802 = document.getElementById("cmpClassIc" + vLN01957);
      if (v11802) {
        v11802.classList.toggle("cmpClassGr", v11800);
      }
      v11802 = document.getElementById("cmpClassLck" + vLN01957);
      if (v11802) {
        v11802.style.display = v11800 ? "inline-block" : "none";
      }
      v11802 = document.getElementById("cmpClassCnt" + vLN01957);
      if (v11802) {
        v11802.classList.toggle("cmpClassGr", v11800);
        if (v11799) {
          v11802.textContent = vLN01955 + "/" + v11801;
        }
      }
    }
  }
  for (var vLN01957 = 0; vLN01957 < v11795; ++vLN01957) {
    var v11803 = null;
    var v11804 = "compPfpI" + vLN01957;
    var v11805 = vLN01957 < v11795 / 2;
    for (var vLN01958 = 0; vLN01958 < vA645.length; ++vLN01958) {
      if (vLN01957 < v11795 / 2 && vA645[vLN01958].t == 1) {
        v11803 = vA645[vLN01958];
        vA645.splice(vLN01958, 1);
        break;
      } else if (vLN01957 >= v11795 / 2 && vA645[vLN01958].t == 2) {
        v11803 = vA645[vLN01958];
        vA645.splice(vLN01958, 1);
        break;
      }
    }
    var vLSfff = "#fff";
    var v11806 = !Game.isComp && v11803 && v11803.l ? "<div class='menuClassLevelBox' style='color:" + vLSfff + ";margin-top:-7px;font-size:20px;padding:3px;padding-right:12px;padding-left:12px;margin-right:0px'>" + (v11803.l || 0) + "</div>" : "";
    var v11807 = v11803 && v11803.v ? " <i class='material-icons' style='color:" + COLORS.verified.player + ";margin-top:-8px;font-size:35px;vertical-align:middle;'>check_circle</i> " : v11803 && v11803.l ? "<div style='display:inline-block;width:10px'></div>" : "";
    var v11808 = v11803 && v11803.c != null ? "<img src='" + UTILS.assetsUrl("/textures/weapons/" + Game.weaponConfig[Game.classConfig[v11803.c].loadout[0]].icon + ".png") + "' class='compPlWpIcn' />" : "";
    var v11809 = v11803 && v11803.f != null ? v11803.f : -1;
    var v11810 = v11809 >= 0 ? "<div class='cmpFlagIc" + (v11805 ? "L" : "") + " flag-icon flag-icon-" + Game.flags[v11809][1] + "'></div>" : "";
    var v11811 = account && v11803 && account.id == v11803.i ? "3px solid #fff" : "3px solid #fff";
    var vLSNone3 = "None";
    var v11812 = v11803 && v11798 != v11803.t;
    if (v11812) {
      v11808 = "";
      vLSNone3 = "???";
    }
    if (v11805) {
      compPlListL.innerHTML += "<div class='compPlLitL'><div class='compPlWepsL'>" + v11808 + "</div>" + v11810 + "<img class='compPLstIcn' id='" + v11804 + "' style='border:" + v11811 + "' /><div class='compPLstSt'>" + v11806 + v11807 + (v11803 ? v11803.n || "Guest Player" : "Open Slot") + "<div class='compPLstCl'>" + (v11803 && v11803.c != null && !v11812 ? Game.classConfig[v11803.c].name : vLSNone3) + "</div></div></div>";
    } else {
      compPlListR.innerHTML += "<div class='compPlLitR'><div class='compPLstSt compPLstStR' style='text-align:right'>" + (v11803 ? (v11803.n || "Guest Player") + v11807 + v11806 : "Open Slot") + "<div class='compPLstCl'>" + (v11803 && v11803.c != null && !v11812 ? Game.classConfig[v11803.c].name : vLSNone3) + "</div></div><img class='compPLstIcn' id='" + v11804 + "' style='border:" + v11811 + "' />" + v11810 + "<div class='compPlWepsR'>" + v11808 + "</div></div>";
    }
    var v11813 = v11803 ? parseInt(v11803.c) : -1;
    var vF1781 = f1781(document.getElementById(v11804), v11803 ? v11803.i : null, !!v11803 && !!v11803.i, UTILS.assetsUrl("/textures/classes/icon_" + (!v11812 && v11803 && v11813 >= 0 ? v11813 : -1) + ".png"));
  }
  var v11814 = !!Game.config.selTeam;
  if (v11814) {
    compPlListL.innerHTML += "<div class='compSwpTmB' style='background-color:#eb4034'  onmouseenter='SOUND.play(`tick_0`,0.1)' onclick='playSelect();toggleTeam(" + (v11798 == 1 ? 0 : 1) + ")'>" + (v11798 == 1 ? "Leave Team" : "Join Team") + "</div>";
    compPlListR.innerHTML += "<div class='compSwpTmB' style='background-color:#3489eb'  onmouseenter='SOUND.play(`tick_0`,0.1)' onclick='playSelect();toggleTeam(" + (v11798 == 2 ? 0 : 2) + ")'>" + (v11798 == 2 ? "Leave Team" : "Join Team") + "</div>";
  }
}
window.toggleTeam = function (p14392) {
  vLN1150 = p14392 || 0;
  teamNm1.style.color = p14392 ? "rgba(255,255,255,0.5)" : "#fff";
  teamNm2.style.color = p14392 ? "#fff" : "rgba(255,255,255,0.5)";
  updSyncDat("t", vLN1150);
};
window.gameCode = function () {
  var v11815 = "<div style='color:#fff;font-size:20px;position:relative;'>" + i18n.t("custom.passcode.input") + "</div><input type='text' id='codeInput' placeholder='Password'><div id='confirmBtn' onclick='submitGameCode()' onmouseover='playTick(0.1)'>Submit</div><div id='declineBtn' onclick='location=location.origin' onmouseover='playTick(0.1)'>Leave</div>";
  genericPopup(v11815, "gameCodePop");
};
function io_enterCode() {
  f1904(false);
  gameCode();
}
function io_codePassed() {
  clearPops();
}
function io_updateCodeTimer(p14393) {
  var v11816 = document.getElementById("confirmBtn");
  if (v11816) {
    v11816.innerHTML = "Submit - " + p14393 + "s";
  }
}
window.submitGameCode = function () {
  var v11817 = document.getElementById("codeInput");
  if (v11817 && v11817.value) {
    io.send("code", v11817.value);
  }
};
function f1896() {
  API_CLIENT.searchMod(vF17343, function (p14394, p14395) {
    if (p14395 && p14395.data && p14395.data.length) {
      var v11818 = p14395.data.find(p14396 => p14396.mod_name == vF17343);
      if (v11818) {
        var v11819 = UTILS.getAssetData(v11818.mod_info);
        if (v11818.mod_url == "ua") {
          v11818.mod_url = UTILS.userAssetsUrl("/md" + v11818.mod_id + "/mod.zip");
        }
        loadModPack(v11818.mod_url, true, true, v11818.mod_name, v11818.mod_id, UTILS.cleanseString(v11818.creatorname), v11819 && v11819.t);
      }
    }
    vF17343 = null;
  });
}
var v11820 = null;
function f1897(p14397) {
  if (v11820) {
    SOUND.stop(v11820);
  }
  v11820 = p14397;
  SOUND.play(p14397, 0.15, true, 1);
}
function f1898() {
  if (v11820) {
    SOUND.stop(v11820);
  }
  v11820 = null;
}
function io_updateRoundsDis(p14398, p14399, p14400, p14401) {
  if (!p14399) {
    for (var vLN01959 = 0; vLN01959 < Game.players.list.length; ++vLN01959) {
      player = Game.players.list[vLN01959];
      if (!player) {
        return;
      }
      player.active = false;
      if (player.objInstances) {
        Game.players.disposeMesh(player);
      }
      if (player.isYou) {
        Game.players.toggleAim(player, 0);
      }
    }
    if (Game.mode && Game.mode.canTrade) {
      window.closeWindow();
    }
    reloadMsg.style.display = "none";
    UI.toggleGameUI(false);
    deathUIHolder.style.display = "none";
    uiBase.classList.toggle("onDeathScrn", true);
    CONTROLS.camTarget(0, 220, 100, -(Math.PI / 2) * 0.7, 0);
    requestAnimationFrame(function () {
      if (!tmpPlayer || !tmpPlayer.active) {
        f1771();
      }
    }, 3000);
    var vLS89 = "";
    vLS89 = p14400 ? config.teamNames[parseInt(p14400) - 1] + " is in the Lead!" : "Both Teams are Equal!";
    SOUND.play("woosh_0", 0.5);
    io_textPopup("Switching Sides", vLS89, true);
    io_addChati18n(-1, "", "modes.round.switch", 2);
    Game.objtvTime = 0;
  }
  roundsVal.innerHTML = Game.config.gamRounds - (p14398 || 0) + "/" + Game.config.gamRounds;
  if (p14401 && p14401[1]) {
    f1995(1, p14401[1]);
  }
  if (p14401 && p14401[2]) {
    f1995(2, p14401[2]);
  }
}
function io_updateHost(p14402, p14403) {
  currentHostId = p14402;
  isGameHost = p14402 && p14402 == io.socketId;
  if (Game) {
    Game.isCustom = !!p14402;
    Game.host = p14402;
  }
  if (!p14403) {
    let v11821 = Game.players.list.find(p14404 => p14404.id == currentHostId);
    if (v11821) {
      io_addChati18n(0, null, isGameHost ? "host.transfer.you" : ["host.transfer", v11821.name], 2);
    }
  }
}
window.toggleMinimap = function (p14405) {
  overlay.miniMap.toggle(Game, p14405);
};
const v11822 = new WeakMap();
function io_initGame(p14406, p14407, p14408, p14409, p14410, p14411, p14412, p14413, p14414, p14415) {
  let v11823 = maps[p14406];
  if (v11823.didLoad || p14415 && p14415.data) {
    f1902.apply(this, arguments);
  } else {
    fetch("maps/" + maps[p14406].fileName + ".json?v=AD9yU").then(async p14416 => {
      let v11824 = await p14416.text();
      if (config.isProd) {
        const v11825 = new TextEncoder().encode(v11824);
        const v11826 = "67"; // await crypto.subtle.digest("SHA-256", v11825);
        const v11827 = Array.from(new Uint8Array(v11826));
        const v11828 = v11827.map(p14417 => p14417.toString(16).padStart(2, "0")).join("");
        if (v11828 != ["8a31d556c6c62258d0ebea29cc720f52d3f0c69f279e680d0c182361e8f6be8f", "abf2e575f5a3b89c0748438f08c259854f8f7eb5239aebbfd79860bc3eb4a7cd", "dfb59632bfda0695b6c947dfcce25aa9e69a3d02397c7f419257ae43b96af1a7", "3d075ef0dcb909f3f2696c387fcc425df458e1a5f508957afc8409c59568ca8d", "37840ba3ea2dc9e596e77f1a937cba9ed0d8ebac9d9c37a84a8bd9cd5d0b19d5", "844c114e40c064ef6085701c30a936bff7fec1216a7b1815378eeae1e1276111", "120b60bc847e8c9554e839076cc2688673556b51ee09e6231fd0ebce0da711d9", "1f391915e6dbfec9520672360cbcd81dab2b27e437074fdc3000f1006b01d82f", "e0922d5ad0cd5ad589d3adbc0289616f87df688d02eb9db330ad53d0bb6b586b", "fd3c38251265cc494d52c54e49f8d0432573b04b4ab8d0f89ea2dc4a3c26706f", "996b05711f1b6caf2cf6baeb75de896225b6e668867552e2f63fe8b9cfac3be4", "01f80ed7044ff5e4c3f8295382f1272a866d189defd2f38b0c34b678a7a72889", "777dc3ac7aae2df38bfde52dee072571d0cfaab252e0936b8a637792854e16be", "244d88003009fe55432f4985df52e1cd0c60bf7c9943cbd0c24c501e291e6b53", "3a486ece09656cebc628cdd56b82804be37fbf00d01d5cdc222c6bde19b6b737", "a4be4181bbf04f70cfe5387ae5f35afa3d44eccc49c64872f049e18faae0f9b3", "efd0bd516dcd9dc7c2869d259a4211d8c51ca51c2b86fcd7bed5bc1f2d1244fa", "1a4fd6fe0ed9679396a16b844889dee970ab7c1b89fb610e50bbcdd3b5b88ec2", "140c1ec06df4b360192c461c2bff8e70efa6610cd35504f0079bfe1e799d532e", "4dfe0ff646963c1bb7a88f6bc9b940e35a589fe9dd16f2a00e78cd16da56f034", "db63861e3807afe4be317e3a6077321c3a2a55c7977d49dcc6cebaf9d9d291e3", "3c89400721d1e6e01a182eef8664a82a55f2e1fc5311a904bc1fa97685082faa", "ce31cc6d6a77ca19d8df60f67f543b28a5ba70679b2b2113ba3d43a2d2ced7c1", "1e85710582f6c9dba786f3256364362a36b7acfc47dfda028facf43781d9e890", "0dd7a2c5696d1ef2bbc98cf621a669ed98461808de7b5dffe4250fadd21e3b61", "60b4c3280d412b06ef85090ea820b8fea4a035776ec05efae8c98949c19e7346", "015a2a92e6ba9abd4e7f592c826151b30d00e2039d9946c81989659ff265daad", "43cf16748a3d7fb6fda7c87d8661efbf8773e60a1454059a82f0cf2c6f5eb09e", "7b44e7e8d258684853dd522d0583ed98eea0197bcbb23c1a5e739f7639acefda", "a4aa266921bdfb77ccd7da7959a9cad1ebb9c05ab2fcbca30fec0b03e1bbbc11", "90dae566b793ad0ebd36f6504b97875c9c1d11f6347fa106eded51af86fa39cc", "55160190ff31976d47a49a84d771790c3556f9a1b0c91001d50fd975bbedb835"][p14406]) {
          //omg why do none of the maps match the sum
          // return;
        }
      }
      maps[p14406] = JSON.parse(v11824);
      maps[p14406].didLoad = true;
      Game.map.maps = maps;
      f1902.apply(this, arguments);
    }).catch(p14418 => {
      console.error("Error Download Map:", p14418);
    });
  }
}
function f1902(p14419, p14420, p14421, p14422, p14423, p14424, p14425, p14426, p14427, p14428, p14429, p14430, p14431, p14432, p14433, p14434, p14435, p14436) {
  if (vF17342) {
    vF1734 = false;
    vF17342 = false;
    return;
  }
  if (vF17343) {
    f1896();
  }
  f1952();
  UI.hasEndScreen = false;
  RENDER.isSandbox = Game.isSandbox;
  overlay.resetAll();
  Game.customGUIs.length = 0;
  Game.hidePlayers = false;
  matchRewardSummary = {};
  voiceChatQueues = {};
  if (SETTINGS.tmp.streamMode && FRVR.channelCharacteristics.allowNavigation) {
    window.history.replaceState({}, "Krunker", "/");
  }
  endMessageSent = false;
  Game.host = p14424;
  Game.isCustom = !!p14424;
  Game.isOfficial = !!p14432;
  Game.mainScript = null;
  Game.customsData = p14428;
  if (p14428) {
    if (p14428.data) {
      Game.prepareGame(p14428.data, p14428.id, p14428.creator, p14428.info, p14428.accType, true, p14419);
    }
  } else {
    Game.map.changedMaps = true;
  }
  p14429 = p14429 || {};
  if (!p14429.gor && !Game.isSandbox) {
    io_disconnect(null, "000004");
  }
  currentHostId = p14424;
  isGameHost = p14424 && p14424 == io.socketId;
  mapVote.innerHTML = "";
  mapVoteState = 0;
  currentMapVoteData.length = 0;
  Game.hasThumb = null;
  if (p14424 && p14428 && p14428.id != null) {
    Game.hasThumb = p14428.thumb ? UTILS.userAssetsUrl("/m" + p14428.id + "/thumb.png") : null;
    currentMapVoteData = [p14428.id, p14428.creator];
    mapVote.innerHTML = "<div class='voteHint'  onclick='openURL(&quot;/social.html?p=profile&q=" + p14428.creator + "&autoGift=2&mn=" + Game.map.maps[p14419].name + "&quot;)'>Donate</div><div style='float:right;'><i id='mapVoteD' onclick='voteMap(" + p14428.id + ",-1)' class='material-icons vote'>thumb_down</i><i id='mapVoteU' onclick='voteMap(" + p14428.id + ",1)' class='material-icons vote'>thumb_up</i></div>";
  }
  p14425 = p14425 || {};
  p14425.weps = p14426 ? p14426.weps : undefined;
  p14425.cls = p14426 ? p14426.cls : undefined;
  p14425.prks = p14426 ? p14426.prks : undefined;
  Game.applyNetworking(p14430);
  Game.applyConfig(p14425, p14428 ? p14428.accType : 1);
  Game.isComp = !!p14433;
  UI.useEmbedPlayer = !Game.isComp;
  Game.sessionId = p14434;
  Game.roundId = p14435;
  Game.init(p14419, p14420, p14421, p14431, false);
  if (Game.isDoubleXP) {
    io_addChati18n(0, null, "mode.doubleXP", 2);
  }
  requestAnimationFrame(() => {
    v11822.set(vO335, vO335);
    v11822.get(vO335);
    [].push(vO336);
  }, 2000);
  var v11829 = p14429.obj || [null, 0];
  if (Game.mode && Game.mode.objWep) {
    Game.setWeapon(v11829[0]);
  } else {
    Game.setObjective(v11829[0], v11829[1], true);
  }
  loadingBg.style.display = "none";
  menuBtnHost.classList.toggle("buttonD", !!Game && !!Game.isOfficial);
  uiBase.classList.toggle("isMobile", !!UI.isMobileControls);
  specControlHolder.firstElementChild.children[2].style.display = Game.mode.objective && Object.keys(Game.map.manager.spectateCams).length ? "" : "none";
  if (p14429.dest) {
    for (var vLN01977 = 0; vLN01977 < p14429.dest.length; ++vLN01977) {
      Game.destroyObj(p14429.dest[vLN01977]);
    }
  }
  if (p14429.mov) {
    for (var vLN01977 = 0; vLN01977 < p14429.mov.length; vLN01977 += 2) {
      Game.teleportToNode(p14429.mov[vLN01977], p14429.mov[vLN01977 + 1]);
    }
  }
  if (p14429.flg) {
    for (var vLN01977 = 0; vLN01977 < p14429.flg.length; ++vLN01977) {
      Game.updateFlag(...p14429.flg[vLN01977]);
    }
  }
  if (p14429.spwns) {
    for (var vLN01977 = 0; vLN01977 < p14429.spwns.length; ++vLN01977) {
      Game.createSpawnable(...p14429.spwns[vLN01977]);
    }
  }
  if (p14429.pkups) {
    for (var vLN01977 = 0; vLN01977 < p14429.pkups.length; ++vLN01977) {
      Game.updatePickup(...p14429.pkups[vLN01977]);
    }
  }
  if (p14429.gates) {
    for (var vLN01977 = 0; vLN01977 < p14429.gates.length; vLN01977 += 2) {
      Game.updateGate(p14429.gates[vLN01977], !!p14429.gates[vLN01977 + 1]);
    }
  }
  if (p14429.banks) {
    for (var vLN01977 = 0; vLN01977 < p14429.banks.length; vLN01977 += 2) {
      Game.updateBank(p14429.banks[vLN01977], p14429.banks[vLN01977 + 1]);
    }
  }
  if (p14429.dyno) {
    for (var vLN01977 = 0; vLN01977 < p14429.dyno.length; ++vLN01977) {
      Game.buildObj(...p14429.dyno[vLN01977], true);
    }
  }
  if (p14429.gbl) {
    for (var vLN01977 = 0; vLN01977 < p14429.gbl.length; vLN01977 += 2) {
      io_updateGlobalValue(p14429.gbl[vLN01977], p14429.gbl[vLN01977 + 1]);
    }
  }
  if (p14429.doms) {
    for (var vLN01977 = 0; vLN01977 < p14429.doms.length; vLN01977 += 2) {
      Game.updateDomZone(p14429.doms[vLN01977], p14429.doms[vLN01977 + 1]);
    }
  }
  if (p14429.asnd) {
    for (var vLN01977 = 0; vLN01977 < p14429.asnd.length; vLN01977 += 3) {
      Game.addPlayerSound(p14429.asnd[vLN01977], p14429.asnd[vLN01977 + 1], p14429.asnd[vLN01977 + 2]);
    }
  }
  if (p14429.mybx) {
    for (var vLN01977 = 0; vLN01977 < p14429.mybx.length; vLN01977 += 6) {
      Game.updateMysteryBox(p14429.mybx[vLN01977], p14429.mybx[vLN01977 + 1], p14429.mybx[vLN01977 + 2], p14429.mybx[vLN01977 + 3], p14429.mybx[vLN01977 + 4], p14429.mybx[vLN01977 + 5]);
    }
  }
  if (p14429.krm) {
    for (var vLN01977 = 0; vLN01977 < p14429.krm.length; vLN01977 += 6) {
      Game.updateKrumMachine(p14429.krm[vLN01977], p14429.krm[vLN01977 + 1], p14429.krm[vLN01977 + 2], p14429.krm[vLN01977 + 3], p14429.krm[vLN01977 + 4], p14429.krm[vLN01977 + 5]);
    }
  }
  if (p14429.pwup) {
    for (var vLN01977 = 0; vLN01977 < p14429.pwup.length; vLN01977++) {
      io_updatePowerUp(vLN01977, p14429.pwup[vLN01977]);
    }
  }
  Game.map.manager.syncAll(p14429.dest);
  if (p14429.zone) {
    Game.updateZone(...p14429.zone);
  }
  if (p14429.lck != null) {
    Game[p14429.lck ? "lockMove" : "unlockMove"]();
  }
  if (p14429.exf) {
    io_setExperimental(p14429.exf);
  }
  if (Game.mode && Game.mode.canTrade) {
    API_CLIENT.getPrices(function (p14437, p14438) {
      prices.update(p14438 || {});
    });
  }
  specNameTm0.textContent = teamNm1.textContent = Game.mode && Game.mode.teamOptions ? Game.mode.teamOptions[0] : Game.config.nameTeam1.replace(/\s/g, "").length > 0 ? Game.config.nameTeam1 : config.teamNames[0];
  specNameTm1.textContent = teamNm2.textContent = Game.mode && Game.mode.teamOptions ? Game.mode.teamOptions[1] : Game.config.nameTeam1.replace(/\s/g, "").length > 0 ? Game.config.nameTeam2 : config.teamNames[1];
  teamScores.style.display = "none";
  teamScores.innerHTML = "";
  specHeaderTm0.style.display = "none";
  specHeaderTm1.style.display = "none";
  f1903(p14423);
  var vLN01974 = 0;
  var vLN01975 = 0;
  for (var vLN01977 = 0; vLN01977 < Game.map.manager.objects.length; ++vLN01977) {
    if (Game.map.manager.objects[vLN01977].score) {
      vLN01974++;
      vLN01975 += Game.map.manager.objects[vLN01977].scoreP;
    }
  }
  if (vLN01974) {
    scoreZoneCount.style.display = "inline-block";
    scoreZoneVal.textContent = vLN01975;
  } else {
    scoreZoneCount.style.display = "none";
  }
  if (p14422) {
    for (var vLN01977 = 0; vLN01977 < p14422.length; ++vLN01977) {
      f1995(p14422[vLN01977][0], p14422[vLN01977][1] || 0);
    }
  }
  io_updateRoundsDis(p14429.roundC, true);
  if (Game.config.lives || Game.mode.lives || 0) {
    livesCount.style.display = "inline-block";
    io_updateLives(Game.config.lives || Game.mode.lives || 0);
  } else {
    livesCount.style.display = "none";
  }
  UI.setShowSpect(Game.config.allowSpect);
  UI.setShowSelTeam(Game.config.selTeam);
  if (Game.config.selTeam && v10535 && UTILS.isNumber(v10535)) {
    var v11830 = document.getElementById("selectT");
    if (v11830 && v10535 == 2) {
      selectT.click();
    }
    v10535 = null;
  }
  endAnimationTimer = null;
  CONTROLS.reset(!Game.detachedCam);
  var v11831 = Game.map.maps[p14419];
  var v11832 = v11831.camPos ? v11831.camPos : [0, 0, 0];
  hasStaticMenuCamera = !!v11832[3];
  if (!Game.detachedCam) {
    CONTROLS.moveCam(v11832[0] || 0, v11832[1] || 0, v11832[2] || 0);
    CONTROLS.rotateCam(v11832[5] || 0, v11832[4] || 0, v11832[6] || 0);
  }
  RENDER.clearSprays();
  RENDER.scene.add(CONTROLS.object);
  tmpPlayer = null;
  overlay.miniMap.reset(Game, SETTINGS.tmp.showMinimap);
  overlay.sprayWheelClose();
  overlay.propWheelClose();
  overlay.showObjective = !!Game.mode.objective && Game.map.manager.objectives.length > 0;
  endChals.innerHTML = "";
  killStreakHolder.innerHTML = "";
  krTagHolder.innerHTML = "";
  giftTagHolder.innerHTML = "";
  perkHolder.innerHTML = "";
  zPerksHolder.innerHTML = "";
  overlay.bloodOpacity = 0;
  bloodDisplay.style.display = "none";
  killsVal.textContent = 0;
  kdVal.textContent = "0.0";
  deathsVal.textContent = 0;
  myScoreVal.textContent = 0;
  currentKillStreak = 0;
  streakVal.textContent = currentKillStreak;
  pendingScorePopupValue = 0;
  kickVoteSubmittedAliases.length = 0;
  activeKickVoteTargetAlias = false;
  hasStartedKickVote = false;
  voteToKick.style.display = "none";
  voteToForfeit.style.display = "none";
  spectatingObjectiveCamera = false;
  spectateCameraInitialized = false;
  f1765();
  spectatorInterpState = {};
  f1766();
  spectatorPlayerStats = {};
  p14428 = null;
  CONTROLS.masterLock = false;
  updateCamMouse(0);
  CONTROLS.spect.maxD = Game.mode.specMaxD || config.specMaxD;
  updateClassPreview();
  lockoutTimer = p14429.lockT;
  f1904(Game.isComp);
  f1889(true);
  f2042();
  f1771(true);
  if (Game.map.maps && Game.map.maps[0] && Game.map.maps[0].modURL && Game.map.maps[0].modURL != "" && v11759 != Game.map.maps[0].modURL) {
    UI.toggleWholeUI(false);
    v11759 = Game.map.maps[0].modURL;
    loadModPack(v11759, true, true, undefined, undefined, Game.map.maps[0].creator);
  }
  f1794();
  if (config.dropsEnabled) {
    var v11833 = getSavedVal("dropPop") || 0;
    if (Date.now() - v11833 >= 3600000) {
      dropsPopup();
    }
    var v11834 = UTILS.getDropsTime();
    twitchDropsAd.style.display = v11834[2] ? "block" : "none";
    if (v11834[2]) {
      twitchDropsTimer.innerHTML = (v11834[0] > 0 ? "Starts" : "Ends") + " in " + UTILS.getReadableTime(v11834[0] > 0 ? v11834[0] : v11834[1]);
    }
  }
  doubleClassXPAd.style.display = UTILS.isDoubleClassXP() ? "block" : "none";
  doubleXPAd.style.display = Game && Game.mode && Game.mode.doubleXP ? "block" : "none";
  let v11835 = UTILS.getActiveEvent(Game.eventIndex);
  if (v11835) {
    var v11836 = new Date(v11835.start).getTime() - Date.now();
    var v11837 = new Date(v11835.end).getTime() - Date.now();
    eventAdName.firstChild.textContent = v11835.name;
    eventAdImg.src = UTILS.assetsUrl("/img/events/event_" + v11835.id + ".png");
    eventAdDesc.textContent = (v11836 > 0 ? "Starts" : "Ends") + " in " + UTILS.getReadableTime(v11836 > 0 ? v11836 : v11837);
    eventAd.setAttribute("onclick", "eventPopup()");
  }
  eventAd.style.display = v11835 ? "block" : "none";
  if (vLN02023 == 1 && (!Game || !Game.mode || !Game.mode.teams)) {
    switchChat(chatSwitch);
  }
  if (vLN02023 != 1 && Game && Game.isComp) {
    switchChat(chatSwitch);
  }
  f1905();
  krDiscountAd.style.display = UTILS.isKRSale() && !v10514 ? "" : "none";
  updateKeybindUI(null, true);
  if (Game.isCustom) {
    var v11838 = Game.map ? Game.map.getMapName() : null;
    if (v11838) {
      f2073(UTILS.escapeStr(v11838) + " - Krunker", null, null, "https://krunker.io/play/" + UTILS.escapeStr(v11838));
    }
  }
  f2078(p14436);
  RENDER.GEOS.reset();
  bhHolder.style.display = Game.mode.bighead ? "inline-block" : "none";
  instructionsFadeBG.style.opacity = 0;
  classPreviewEnabled = true;
  classPreviewDelayTicks = 4;
  if (UI.embedPlayer && Game && Game.isComp) {
    UI.toggleEmbedPlayer(false);
  }
}
function f1903(p14439) {
  if (Game.mode.teams) {
    Game.teamScores = {};
    if (!p14439) {
      return;
    }
    for (var vLN01978 = 0; vLN01978 < p14439.length; ++vLN01978) {
      Game.teamScores[p14439[vLN01978][0]] = p14439[vLN01978][1];
      if (Game.mode.flags) {
        Game.teamFlags[p14439[vLN01978][0]] = p14439[vLN01978][2];
      }
    }
    f1996();
  }
}
function f1904(p14440) {
  if (!window.canShowExternalLinks) {
    headerRightSocial.style.display = "none";
    applePayB.style.display = "none";
    androidPayB.style.display = "none";
  }
  if (!window.canShowSocialHub) {
    menuBtnSocial.parentNode.style.display = "none";
  }
  if (!window.canShowMods) {
    menuBtnMods.parentNode.style.display = "none";
  }
  instructionHider.style.display = "block";
  aHider.style.display = window.canShowAds && (!account || !(account.premiumT > 0)) ? "block" : "none";
  topRightAdHolder.style.display = window.canShowAds && (!account || !(account.premiumT > 0)) ? "inline-block" : "none";
  infoHider.style.display = "block";
  vsHolder.style.display = "none";
  mMenuHolDef.style.display = "none";
  mMenuHolComp.style.display = "none";
  uiBase.classList.toggle("onCompMenu", false);
  if (Game && Game.config && Game.config.tstCmp && p14440) {
    setClassIndex(0);
    var vLS90 = "";
    var v11839 = Game.config.limitClasses;
    for (var vLN01979 = 0; vLN01979 < Game.classConfig.length; vLN01979++) {
      if (Game.config.classes.indexOf(vLN01979) >= 0) {
        var v11840 = Game.config["classLim" + vLN01979] || 0;
        if (v11839 && !v11840) {
          continue;
        }
        vLS90 += "<div class='cmpClassLck'  style='display:none;' id='cmpClassLck" + vLN01979 + "'><span class='material-icons' style='font-size:70px;color:#fff;vertical-align:top;'>lock</span></div><div class='compClassPItm' onmouseenter='SOUND.play(`tick_0`,0.1)' onclick='SOUND.play(`reload_3`,0.09);playSelect(0.03);selectClass(" + vLN01979 + ")'><img src='" + UTILS.assetsUrl("textures/classes/icon_" + vLN01979 + ".png") + "' class='compClassPIcn'  id='cmpClassIc" + vLN01979 + "' />" + (v11839 ? "<span class='compClassPCnt' id='cmpClassCnt" + vLN01979 + "'>0/" + v11840 + "</span>" : "") + "</div>";
      }
    }
    compClassHold.innerHTML = vLS90;
    f1892();
    if (lockoutTimer) {
      vsHolder.style.display = "block";
      instructions.innerHTML = "";
      instructionHider.style.display = "none";
    }
    var vLSUnknown = "Unknown";
    try {
      vLSUnknown = Game.map.maps[Game.mapIndex].name;
    } catch (e150) {}
    cmpDatSub.innerHTML = Game.config.tmSize + 1 + "v" + (Game.config.tmSize + 1) + " <span style='color:rgba(255,255,255,0.5);'>on " + vLSUnknown + "</span>";
    SOUND.play("pop_3", 0.3);
    aHider.style.display = "none";
    infoHider.style.display = "none";
    mMenuHolComp.style.display = "block";
    uiBase.classList.toggle("onCompMenu", true);
    uiBase.classList.toggle("onMenu", false);
    f1897("ambient_14");
  } else {
    mMenuHolDef.style.display = "block";
  }
  endMidHolder.style.display = "none";
}
function f1905() {
  var vLS91 = "";
  for (var vLN01980 = 0; vLN01980 < Game.classConfig.length; ++vLN01980) {
    player = Game.classConfig[vLN01980];
    if (Game.config.classes.indexOf(vLN01980) >= 0) {
      vLS91 += "<div id='menuClassPicker" + vLN01980 + "' onmouseenter='playTick()' onclick='selectClass(" + vLN01980 + ")'></div>";
    }
  }
  hiddenClasses.innerHTML = vLS91;
}
window.updateCamMouse = function (p14441) {
  var v11841 = !!Game.classConfig[p14441].fPLock;
  CONTROLS.camOffset = Game.classConfig && (Game.classConfig[p14441].camOffX || Game.classConfig[p14441].camOffY || Game.classConfig[p14441].camOffZ);
  CONTROLS.camRot = Game.classConfig && Game.classConfig[p14441].camRot;
  CONTROLS.UsePointerLock = (!!CONTROLS.camRot || !CONTROLS.camOffset || !!v11841) && !UI.isMobileControls && !CONTROLS.forceFreeCam;
  CONTROLS.freeMouse = !CONTROLS.UsePointerLock && !UI.isMobileControls;
  CONTROLS.camType.isNormal = Game.classConfig[p14441].camType == 0;
  CONTROLS.camType.isTop = Game.classConfig[p14441].camType == 1;
  CONTROLS.camType.isSideX = Game.classConfig[p14441].camType == 2;
  CONTROLS.camType.isSideZ = Game.classConfig[p14441].camType == 3;
  CONTROLS.camType.isOrto = Game.classConfig[p14441].camType == 4;
  RENDER.setOrto(CONTROLS.camType.isOrto, Game.classConfig[p14441].orthoF);
  RENDER.aimFov = CONTROLS.camType.isNormal || Game.classConfig[p14441].shtToCam;
  overlay.speedLineMlt = Game.classConfig && Game.classConfig[p14441].spdLnTh ? Game.classConfig[p14441].spdLnTh : 500;
  var v11842 = Game.classConfig && Game.classConfig[p14441] && Game.classConfig[p14441].cID.length ? (Game.classConfig[p14441].cID || "").replace(/[^\d]/g, "") : "";
  overlay.mapCross = v11842 || "";
  var v11843 = Game.classConfig && Game.classConfig[p14441] && Game.classConfig[p14441].ccID.length ? (Game.classConfig[p14441].ccID || "").replace(/[^\d]/g, "") : "";
  overlay.mapCrossChase = v11843 || "";
};
function io_inst_id(p14442) {
  v10544 = p14442;
  client.fetchGameInfo(p14442).then(p14443 => {
    var [v11844, v11845, v11846, v11847, v11848] = p14443;
    v10547 = v11845;
    menuRegionLabel.textContent = config.regionNames[v11845];
  }).catch(p14444 => console.error("Failed to fetch game info", p14444));
}
Object.defineProperty(window, "updMatchVote", {
  writeable: false,
  value: function (p14445, p14446) {
    for (var vLN01981 = 0; vLN01981 < p14446.length; ++vLN01981) {
      player = document.getElementById("voteT" + p14446[vLN01981]);
      if (player) {
        var vLN01982 = 0;
        if (p14445) {
          for (var v11849 in p14445) {
            if (p14445.hasOwnProperty(v11849) && p14445[v11849] && p14446[vLN01981] == p14445[v11849][0]) {
              vLN01982 += p14445[v11849][1];
            }
          }
        }
        player.innerHTML = vLN01982;
        player.style.color = p14445 && p14445[io.socketId] && p14445[io.socketId][0] == p14446[vLN01981] ? COLORS.matchVote.selected : COLORS.matchVote.notSelected;
      }
    }
  }
});
Object.defineProperty(window, "voteOnMatch", {
  writeable: false,
  value: function (p14447) {
    io.send("maVote", p14447);
  }
});
var v11850;
window.voteMod = function (p14448, p14449) {
  if (account) {
    var v11851 = document.getElementById("modVoteU");
    var v11852 = document.getElementById("modVoteD");
    var vLN01983 = 0;
    if (p14449 == 1) {
      vLN01983 = 1;
      if (v11850 == 1) {
        vLN01983 = 0;
      }
    } else if (p14449 == -1) {
      vLN01983 = -1;
      if (v11850 == -1) {
        vLN01983 = 0;
      }
    }
    v11850 = vLN01983;
    io.send("vote", account.id, loginToken, p14448, vLN01983, 1);
    v11851.parentNode.style.display = "none";
  }
};
window.voteMap = function (p14450, p14451, p14452) {
  if (account) {
    var v11853 = document.getElementById("mapVoteU");
    var v11854 = document.getElementById("mapVoteD");
    var vLN01984 = 0;
    if (p14451 == 1) {
      vLN01984 = 1;
      if (mapVoteState == 1) {
        vLN01984 = 0;
      }
    } else if (p14451 == -1) {
      vLN01984 = -1;
      if (mapVoteState == -1) {
        vLN01984 = 0;
      }
    }
    mapVoteState = vLN01984;
    io.send("vote", account.id, loginToken, p14450, vLN01984);
    if (p14452) {
      io_addChat(-1, null, "Map " + (mapVoteState == 0 ? "Voted Removed" : mapVoteState == 1 ? "Upvoted" : "Downvoted"), 2);
    }
    v11853.parentNode.removeChild(v11853);
    v11854.parentNode.removeChild(v11854);
  } else {
    mapVote.innerHTML = "";
  }
};
function io_lockPlayer(p14453) {
  window.locked = p14453;
  blockerDiv.style.display = p14453 ? "block" : "none";
}
function io_reCa(p14454) {
  f1732("limit", function (p14455, p14456) {
    if (!p14456) {
      io.send("reCaR", p14455);
    }
  });
}
function f1909(p14457) {
  io.send("ct", vLN02023, p14457);
}
function io_endGame(p14458, p14459, p14460, p14461, p14462, p14463, p14464) {
  function f1911() {
    CONTROLS.disable();
    f1912(p14459, p14460, p14461, p14462, p14464);
  }
  if (window.isBotFTUE) {
    window.botMatches++;
    saveVal("ftue_bm", window.botMatches);
    if (window.botMatches >= window.ftueBotMatches) {
      exitBotFTUE();
    }
  }
  if (account) {
    window.gradualMenuProgress();
  }
  victorySub.style.display = "none";
  victorySub.src = "";
  shouldConfirmPageUnload = false;
  if (p14463) {
    logEventFRVR("item_flow", {
      item: "krunkers",
      flow_type: "source",
      amount: p14463,
      item_context: "gameplay",
      wallet: account ? account.funds : 0
    });
  }
  if (p14464) {
    if (p14464.cbp > 0) {
      logEventFRVR("item_flow", {
        item: "bpp",
        flow_type: "source",
        amount: p14464.cbp,
        item_context: "challenge",
        wallet: p14464.bpp || 0
      });
    }
    let v11855 = (p14464.gn || 0) - (p14464.bbpp || 0);
    if (v11855 > 0) {
      logEventFRVR("item_flow", {
        item: "bpp",
        flow_type: "source",
        amount: v11855,
        item_context: "gameplay",
        wallet: p14464.bpp || 0
      });
    }
    if (p14464.bbpp > 0) {
      logEventFRVR("item_flow", {
        item: "bpp",
        flow_type: "source",
        amount: p14464.bbpp,
        item_context: "bonus",
        wallet: p14464.bpp || 0
      });
    }
    let v11856 = Math.floor(p14464.pbpp / p14464.mx) + 1;
    let v11857 = Math.floor(p14464.bpp / p14464.mx) + 1;
    if (v11856 < v11857) {
      logEventFRVR("battle_pass_level_up", {
        level: v11857,
        hasPremium: account.BP.tier ? "premium" : "free",
        levels_skipped: 0,
        season: config.currentSeason
      });
    }
  }
  f1952();
  v10794 = null;
  f2042();
  let v11858 = p14459 == -1 ? "dra" : p14459 ? "vic" : "def";
  victorySub.src = "./img/" + v11858 + ".png";
  overlay.vicTitle.type = v11858;
  if (p14458 != 2) {
    UI.toggleWindow(false, CONTROLS.gamepad.active);
  }
  if (!!SETTINGS.list.endMessage.val.length && !currentKpdCase && !endMessageSent) {
    f1909(SETTINGS.list.endMessage.val);
    endMessageSent = true;
  }
  let vO369 = {};
  let v11859 = Game.mode.endStats || config.endStats;
  if (p14458 != 2 && (tmpPlayer && tmpPlayer.active || window.spectating)) {
    UI.showEndScreen(spinUI.style.display == "block");
    if (p14462 != 3) {
      overlay.vicTitle.show = true;
    }
    endAnimationTimer = config.endAnim;
    requestAnimationFrame(function () {
      if (io.connected || window.isBotFTUE) {
        f1911();
      }
      const vGetSavedVal13 = getSavedVal("forceGuestVideoAd");
      if (!isMobileClient() && !Game.isCustom && (vGetSavedVal13 || !account) && !Game.isSandbox) {
        const vGetSavedVal14 = getSavedVal("lastVideoAdTS");
        if (vGetSavedVal13 || vGetSavedVal14 && Date.now() - vGetSavedVal14 > config.guestMaxAdGrace) {
          showAd({
            type: FRVR.ads.AdType.INTERSTITIAL,
            onComplete: () => {
              saveVal("lastVideoAdTS", Date.now());
              accountCreatePopup();
            }
          });
        } else {
          saveVal("lastVideoAdTS", Date.now() - config.guestMaxAdGrace);
        }
      }
    }, config.endAnim);
  } else if (p14458 != 2) {
    if (p14458) {
      UI.showEndScreen(spinUI.style.display == "block");
      f1911(true);
    }
  }
  if (p14462 == 3 && !tmpPlayer) {
    CONTROLS.locklessChange(true);
  }
  f2079(p14459, p14460, p14462, p14464);
}
function f1912(p14465, p14466, p14467, p14468, p14469) {
  endInfo.style.display = "block";
  endUI.style.backgroundColor = "transparent";
  f1913(p14468);
  if (!account || !(account.premiumT > 0)) {
    endAHolderL.style.display = "inline-block";
    endAHolderR.style.display = "inline-block";
  }
  endMidHolder.style.display = "inline-block";
  let vO370 = {};
  let v11860;
  if (tmpPlayer && tmpPlayer.sid != null) {
    vO370 = f1914(p14466, p14465, p14468);
  } else {
    v11860 = true;
  }
  let vA646 = [];
  for (var vLN01985 = 0; vLN01985 < p14466.mdls.length; vLN01985 += 2) {
    vA646.push({
      n: p14466.mdls[vLN01985],
      c: p14466.mdls[vLN01985 + 1],
      i: overlay.medalsList.indexOf(p14466.mdls[vLN01985])
    });
  }
  f1915(p14466);
  initGameUI.endScreen.init(account, v11860, vO370, vA646, matchRewardSummary, Game.isCustom, !(p14466.mts.length <= 1), p14469, function () {
    f1916(p14466, p14467);
  }, function () {
    f1917(p14466, p14467);
  });
}
function f1913(p14470) {
  if (p14470 != 3) {
    victorySub.style.display = "";
  }
  overlay.vicTitle.show = false;
  endAHolderR.style.display = "none";
  endAHolderR.style.opacity = 1;
  endAHolderL.style.display = "none";
  endAHolderL.style.opacity = 1;
}
function f1914(p14471, p14472, p14473) {
  let v11861 = Game.mode.endStats || config.endStats;
  let v11862 = v11861.length;
  let v11863 = p14471.ed.filter((p14474, p14475) => !(p14475 % v11862)).indexOf(tmpPlayer.sid);
  let v11864 = v11863 * v11862;
  let v11865 = p14471.ed.slice(v11864, v11864 + v11862);
  let v11866 = v11861.includes("points") ? "points" : "score";
  return {
    rank: "#" + (v11863 + 1),
    score: v11865[v11861.indexOf(v11866)] || 0,
    kills: ["kills", "melees"].map(p14476 => v11865[v11861.indexOf(p14476)] || 0).reduce((p14477, p14478) => p14477 += p14478),
    deaths: ["deaths", "setbacks"].map(p14479 => v11865[v11861.indexOf(p14479)] || 0).reduce((p14480, p14481) => p14480 += p14481),
    funds: v11865[v11861.indexOf("reward")] || v11865[v11861.indexOf("MMR")] || "NONE",
    victory: p14472,
    medals: p14471.mdls,
    endInd: p14473
  };
}
function f1915(p14482) {
  if (p14482 && p14482.ed.length) {
    var vLS92 = "";
    var v11867 = p14482.mts;
    matchVoteHolder.style.display = "inline-block";
    if (v11867.length > 1) {
      for (var vLN01986 = 0; vLN01986 < v11867.length; ++vLN01986) {
        var v11868 = v11867[vLN01986].split(",");
        var v11869 = Game.map.modes[parseInt(v11868[0])];
        var v11870 = Game.map.maps[parseInt(v11868[1])];
        if (Game.isOfficial) {
          var v11871 = v11868[2] || v11870.name || "";
          var v11872 = parseInt(v11868[3]) ? UTILS.userAssetsUrl("/m" + parseInt(v11868[3]) + "/thumb.png") : null;
          if (v11869) {
            vLS92 += "<label class='matchVote' onclick='playSelect(0.1);voteOnMatch(\"" + v11867[vLN01986] + "\")'><img src='" + (v11872 || Game.hasThumb || UTILS.assetsUrl("/img/" + (parseInt(v11868[1]) == 0 && v11871 != "Burg" ? "noimg" : "maps/map_" + parseInt(v11868[1])) + ".png")) + "' class='matchVoteThumb' draggable='false'><div class='matchVoteMap'>" + v11871 + "</div><div class='matchVoteMode'>" + v11869.name.toUpperCase() + "</div><div class='matchVoteTotal' id='voteT" + v11867[vLN01986] + "'>0</div></label>";
          }
        } else if (v11869 && v11870) {
          vLS92 += "<label class='matchVote' style='" + (!Game.isCustom && v11869.tag ? "border: 4px solid " + v11869.tag[2] + ";box-shadow: 0 0 20px " + v11869.tag[2] + "9c;" : "") + "' onclick='voteOnMatch(\"" + v11867[vLN01986] + "\")'><img src='" + (Game.hasThumb || UTILS.assetsUrl("/img/" + (parseInt(v11868[1]) == 0 && v11870.name != "Burg" ? "noimg" : "maps/map_" + parseInt(v11868[1])) + ".png")) + "' class='matchVoteThumb' draggable='false'><div class='matchVoteMap'>" + v11870.name + "</div><div class='matchVoteMode'>" + v11869.name.toUpperCase() + "</div>" + (!Game.isCustom && v11869.tag ? "<div class='matchVoteModifier'" + (v11869.tag[1] ? " style='background:" + v11869.tag[1] + "'" : "") + ">" + v11869.tag[0].toUpperCase() + "</div>" : "") + "<div class='matchVoteTotal' id='voteT" + v11867[vLN01986] + "'>0</div></label>";
        }
      }
      matchVoteHolder.innerHTML = vLS92;
      if (vLS92.length) {
        endMidHolder.style.maxHeight = "calc(100% - 490px)";
      }
      if (p14482.vo) {
        updMatchVote(p14482.vo, p14482.mts);
      }
    } else {
      matchVoteHolder.style.display = "none";
      endMidHolder.style.top = "205px";
    }
  }
}
function f1916(p14483, p14484) {
  if (p14483 && p14483.ed.length) {
    endMidHolder.style.top = p14483.mts.length <= 1 ? "205px" : "310px";
    var v11873 = p14483.tms;
    if (v11873) {
      var v11874 = v11873.find(p14485 => p14485 && p14485[0] == 1);
      var v11875 = v11873.find(p14486 => p14486 && p14486[0] == 2);
      teamTotal0.innerHTML = (p14484 == 1 ? "<div class='material-icons teamWin0'>emoji_events</div>" : "") + "<span class=\"teamTotalN0\">" + teamNm1.textContent + "</span><span class=\"teamTotalScore\">" + (v11874 ? v11874[1] || 0 : 0) + "</span>";
      teamTotal1.innerHTML = "<span class=\"teamTotalScore\">" + (v11875 ? v11875[1] || 0 : 0) + "</span><span class=\"teamTotalN1\">" + teamNm2.textContent + "</span>" + (p14484 == 2 ? "<div class='material-icons teamWin1'>emoji_events</div>" : "");
      teamTotal0.style.display = "inline-block";
      teamTotal1.style.display = "inline-block";
    } else {
      teamTotal0.style.display = "none";
      teamTotal1.style.display = "none";
    }
    endMidHolder.style.display = "inline-block";
  } else {
    endMidHolder.style.display = "none";
  }
}
function f1917(p14487) {
  if (p14487 && p14487.ed.length) {
    var vLS93 = "";
    vLS93 = "<tr><th id='endlb_rank'>Rank</th>";
    var v11876 = Game.mode.endStats || config.endStats;
    if (Game.isOfficial && v11876.indexOf("reward") == -1) {
      v11876.push("reward");
    }
    for (var v11877 = v11876.length, vLN01987 = 1; vLN01987 < v11877; ++vLN01987) {
      vLS93 += "<th id='endlb_" + v11876[vLN01987].toLowerCase() + "'>" + UTILS.capFirst(v11876[vLN01987]) + "</th>";
    }
    vLS93 += "<th></th></tr>";
    vLS93 += "<tr height='20px;'></tr>";
    var vLN1155 = 1;
    var v11878 = tmpPlayer && tmpPlayer.team ? tmpPlayer.team : window.spectating ? 1 : 0;
    for (var vLN01987 = 0; vLN01987 < p14487.ed.length;) {
      player = Game.players.findBySid(p14487.ed[vLN01987]);
      vLS93 += "<tr style='" + (vLN01987 + v11877 >= p14487.ed.length ? "border-bottom:none" : "") + "'><td style='color:#fff'>" + vLN1155 + ".</td>";
      for (var vLN1156 = 1; vLN1156 < v11877; ++vLN1156) {
        vLS93 += "<td style='position: relative;'>";
        if (vLN1156 == 1) {
          if (player && player.flagIndex > -1) {
            vLS93 += "<div class='endTableFlag flag-icon flag-icon-" + Game.flags[player.flagIndex][1] + "'></div>";
          }
          var vLSimgplayer_pfppng = "./img/player_pfp.png";
          if (player && player.premiumT) {
            vLSimgplayer_pfppng = UTILS.userAssetsUrl("/p" + player.accid + "/profile.png");
          }
          vLS93 += "<img class='endTablePfp' onerror='this.onerror=null;this.src=\"./img/player_pfp.png\";'src='" + vLSimgplayer_pfppng + "'>";
          vLS93 += "<a class='endTableN' href='" + UTILS.toSocial(p14487.ed[vLN01987 + vLN1156][0] || p14487.ed[vLN01987 + vLN1156] || "") + "' target='_blank' style='color:" + (tmpPlayer && player && tmpPlayer.sid == player.sid ? "#fff'" : player && v11878 == player.team ? "rgba(255,255,255,0.6)'" : COLORS.teams[1] + "'") + ">";
          vLS93 += (SETTINGS.tmp.streamMode ? UTILS.scrambleS(player ? player.alias : p14487.ed[vLN01987 + vLN1156][0] || p14487.ed[vLN01987 + vLN1156]) : player ? player.alias : p14487.ed[vLN01987 + vLN1156][1] || p14487.ed[vLN01987 + vLN1156][0] || p14487.ed[vLN01987 + vLN1156]) + (player && player.clan ? "<span style='color:" + COLORS.getClanCol(player.clan, "#fff") + "'> [" + player.clan + "]</span>" : "") + "</a>";
          if (player) {
            vLS93 += (player.partner >= 2 ? "<i class='material-icons' style='color:" + COLORS.partner + ";margin-top:-12px;font-size:28px;vertical-align:middle;'>verified</i>" : "") + (player.premiumT ? "<i class='material-icons' style='color:" + COLORS.premium + ";margin-top:-12px;font-size:28px;vertical-align:middle;'>beenhere</i>" : "") + (player.featured ? "<i class='material-icons' style='color:" + COLORS.verified.player + ";margin-top:-12px;font-size:28px;vertical-align:middle;'>check_circle</i>" : "") + (player.badgeIndex >= 0 ? "<img src='" + Game.badges[player.badgeIndex].url + "' style='margin-top:-12px;font-size:28px;vertical-align:middle;width:26px;margin-left:2px;'>" : "");
          }
        } else if (v11876[vLN1156] == "reward" && Array.isArray(p14487.ed[vLN01987 + vLN1156])) {
          var v11879 = Game.store.skins[p14487.ed[vLN01987 + vLN1156][1]];
          vLS93 += "<div class='skinReward' style='border: 2px solid " + Game.store.rarities[v11879.rarity].color + ";' onclick='openSales(" + v11879.index + ")'><img draggable='false' style='width: 32px;image-rendering: auto;' loading='lazy' src='" + v11879.thumbnail + "'></div>";
          vLS93 += p14487.ed[vLN01987 + vLN1156][0] || 0;
        } else {
          vLS93 += p14487.ed[vLN01987 + vLN1156] || 0;
        }
        vLS93 += "</td>";
      }
      var vLS94 = "";
      if (account) {
        if (tmpPlayer && tmpPlayer == player) {
          if (!Game || !Game.isCustom) {
            vLS94 += "<div class='material-icons reportBut shareBut' title='Share Match Results' onclick='shareResult()'>share</div>";
          }
        } else if (player && player.level) {
          vLS94 += "<div class='material-icons reportBut' title='Report Player' onclick='reportPlayer(`" + player.name + "`,this)'>report</div>";
        }
      }
      vLS93 += "<td style='width: 1px;white-space: nowrap;padding-right: 0px;padding-left: 0px;'>" + vLS94 + "</td></tr>";
      vLN1155++;
      vLN01987 += v11877;
    }
    endTable.innerHTML = vLS93;
  }
}
Object.defineProperty(window, "followPlayer", {
  writeable: false,
  value: function (p14488, p14489) {
    if (p14489) {
      p14489.style.visibility = "hidden";
    }
    io.send("fo", p14488, 1);
  }
});
Object.defineProperty(window, "deleteFollower", {
  writeable: false,
  value: function (p14490, p14491) {
    if (friends && friends[p14491]) {
      friends.splice(p14491, 1);
      updateWindow(5);
    }
    io.send("fo", p14490, 0);
  }
});
Object.defineProperty(window, "shareResult", {
  writeable: false,
  value: function () {
    UI.toggleMenu(true);
    var vLSdivStylecolorffffont5 = "<div style='color:#fff;font-size:20px;position:relative;margin-bottom:15px;'>Share Match Results</div><textarea type='text' rows='5' id='shareTxt' style='width:100%' placeholder='Include a message with your stats'></textarea><div id='shareError'></div><div id='confirmBtn' style='width: calc(100% - 15px)' onmouseover='playTick(0.1)' onclick='shareMatch()'>Share</div>";
    genericPopup(vLSdivStylecolorffffont5, "contPop");
  }
});
Object.defineProperty(window, "shareMatch", {
  writeable: false,
  value: function () {
    var vLS95 = "";
    var v11880 = document.getElementById("shareTxt");
    if (v11880 && v11880.value && v11880.value != "") {
      vLS95 = v11880.value;
    }
    io.send("smr", vLS95);
    clearPops();
  }
});
Object.defineProperty(window, "reportPlayer", {
  writeable: false,
  value: function (p14492, p14493) {
    openURL("/social.html?p=profile&q=" + p14492 + "&autoReport=1");
  }
});
function io_voteKick(p14494, p14495, p14496, p14497, p14498) {
  if (account) {
    if (p14497) {
      if (p14498 == tmpPlayer.alias) {
        hasStartedKickVote = true;
      }
      activeKickVoteTargetAlias = p14494;
      voteKickInfo.innerHTML = p14498 + " voted to kick " + p14494;
      voteKickName.innerHTML = "Kick " + p14494;
      voteKickNum.innerHTML = "Votes: " + p14495 + "/" + p14496;
      voteToKick.style.display = "block";
      voteKickName.style.display = p14498 == tmpPlayer.alias ? "none" : "block";
      voteKickKeys.style.display = p14498 == tmpPlayer.alias ? "none" : "block";
    } else if (p14494) {
      if (p14494 == tmpPlayer.alias) {
        io_addChat(-1, null, "Vote Submitted - " + p14495 + "/" + p14496, 2);
        voteKickName.style.display = "none";
        voteKickKeys.style.display = "none";
      } else {
        voteToKick.style.display = "block";
      }
      voteKickNum.innerHTML = "Votes: " + p14495 + "/" + p14496;
    } else {
      activeKickVoteTargetAlias = false;
      voteToKick.style.display = "none";
    }
  }
}
function io_voteForfeit(p14499, p14500, p14501, p14502, p14503) {
  if (account) {
    if (p14502) {
      voteForfeitInfo.innerHTML = p14503 + " initiated vote";
      voteForfeitNum.innerHTML = "Votes: " + p14500 + "/" + p14501;
      voteToForfeit.style.display = "block";
    } else if (p14499) {
      if (p14499 == tmpPlayer.alias) {
        io_addChat(-1, null, "Vote Submitted - " + p14500 + "/" + p14501, 2);
      } else {
        voteToForfeit.style.display = "block";
      }
      voteForfeitNum.innerHTML = "Votes: " + p14500 + "/" + p14501;
    } else {
      voteToForfeit.style.display = "none";
    }
  }
}
Object.defineProperty(window, "kickVote", {
  writeable: false,
  value: function (p14504) {
    for (var vLN01988 = 0; vLN01988 < Game.players.list.length; ++vLN01988) {
      player = Game.players.list[vLN01988];
      if (player.id == p14504) {
        io.send("v2k", player.alias, 1);
        kickVoteSubmittedAliases.push(player.alias);
        updateWindow(23);
        break;
      }
    }
  }
});
function io_toggleElement(p14505, p14506) {
  overlay.customGUIs.forEach(p14507 => {
    if ((p14507.id || 0) == p14505 && p14507.t != 3) {
      p14507.nv = p14506 == 0 ? !p14507.nv : p14506 == 1 ? 0 : p14506 == 2 ? 1 : p14507.nv;
    }
  });
  overlay.divsToUpd.forEach(p14508 => {
    if ((p14508.data.id || 0) == p14505) {
      p14508.data.nv = p14506 == 0 ? !p14508.data.nv : p14506 == 1 ? 0 : p14506 == 2 ? 1 : p14508.data.nv;
      p14508.elm.style.display = p14508.data.nv ? "none" : "block";
    }
  });
}
function io_stopSound(p14509, p14510) {
  p14509 = UTILS.isNumber(p14509) && !p14510 ? config.networkSounds[p14509] : p14509;
  SOUND.stop(p14509);
}
function io_playSound(p14511, p14512, p14513, p14514, p14515, p14516, p14517, p14518, p14519, p14520) {
  p14511 = UTILS.isNumber(p14511) && !p14520 ? config.networkSounds[p14511] : p14511;
  if (p14513 == 1) {
    SOUND.play(p14511, p14512, 0, p14517 || 1, p14520);
  } else {
    SOUND.play3D(p14511, p14514, p14515, p14516, p14512, p14517 || 1, p14518 || 0, p14519 || 0, p14520);
  }
}
function io_playerSound(p14521, p14522, p14523, p14524, p14525, p14526, p14527, p14528, p14529, p14530, p14531) {
  Game.playerSound(UTILS.isNumber(p14521) && !p14531 ? config.networkSounds[p14521] : p14521, p14522, p14523, p14524, p14525, p14526, p14527, false, p14528, p14529, p14530, p14531);
}
window.changeAmbient = function (p14532, p14533) {
  p14532 = parseInt(p14532);
  if (p14532 != Game.lastAmbS) {
    if (Game.lastAmbS != null) {
      SOUND.stop(Game.lastAmbSC ? Game.lastAmbS : "ambient_" + Game.lastAmbS, !!Game.lastAmbSC || undefined);
    }
    Game.lastAmbS = p14532;
    Game.lastAmbSC = p14533;
    SOUND.play(p14533 ? p14532 : "ambient_" + p14532, config.amvVols[p14532] || 0.12, true, 1, p14533);
  }
};
window.changeEnvironment = function (p14534, p14535) {};
function io_playerAnim(p14536, p14537, p14538) {
  player = Game.players.findBySid(p14536);
  if (player) {
    Game.players.playClip(player, config.clipNames[p14537], p14538 || 1);
  }
}
function io_regenPlayer(p14539, p14540, p14541) {
  player = Game.players.findBySid(p14539);
  if (player) {
    player.updateItems(Game, null, p14540, p14541, true);
    if (player.isYou) {
      io_changeHealth(player.health, player.sid, null, null, true);
      updateClassPreview();
      f1773();
    }
  }
}
function io_updateAssetId(p14542, p14543) {
  player = Game.players.findBySid(p14542);
  if (player) {
    Game.players.updateAssetID(player, p14543);
  }
}
function io_setPlayerCharged(p14544, p14545) {
  player = Game.players.findBySid(p14544);
  if (player) {
    Game.players.updateMshClient(player);
    player.isKranked = true;
    player.krankedTimer = p14545;
    player.krankedTick = 1000;
    Game.players.updateMshClient(player);
  }
}
function io_updateLeaderBoard(p14546, p14547) {
  Game.map.manager.updatePendingLeader(p14546, p14547);
}
function io_updateGlobalValue(p14548, p14549) {
  Game.globalVals[p14548] = p14549;
}
function io_playerInteractions(p14550, p14551, p14552, p14553, p14554, p14555 = true, p14556 = true, p14557, p14558, p14559, p14560, p14561) {
  player = Game.players.findBySid(p14550);
  if (player) {
    if (player == tmpPlayer) {
      SOUND.play("pick_0", 0.2);
    }
    player.updateLoadout(Game, p14552, true, p14551, p14558, p14559, p14560, p14561);
  }
  if (p14555) {
    Game.updatePickup(p14553, p14554, null, p14556, p14557);
  }
}
function io_allPlayerInteractions(p14562, p14563) {
  for (var vLN01989 = 0; vLN01989 < Game.players.list.length; vLN01989++) {
    player = Game.players.list[vLN01989];
    if (player == tmpPlayer) {
      SOUND.play("pick_0", 0.2);
    }
    player.updateLoadout(Game, p14563, true, p14562);
  }
}
var sprayIndex = getSavedVal("sprayIndex") || getSavedVal("sprayindex") || 2482;
Object.defineProperty(window, "selectSpray", {
  writeable: false,
  value: function (p14564, p14565, p14566) {
    saveVal("sprayIndex", p14564);
    sprayIndex = p14564;
    if (!p14565) {
      showWindow(3);
    }
    if (p14566) {
      updateWindow(3);
    }
    f1796("spray", p14564);
    updateSprayWheel(true);
  }
});
function updateSprayWheel(p14567) {
  var v11882 = sprayIndex <= 0 ? 2482 : sprayIndex;
  var v11883 = f1799(account, true).filter(p14568 => p14568 && Game.store.skins[p14568.ind] && Game.store.skins[p14568.ind].type == itemTypes.SPRAY && p14568.ind != v11882);
  v11883.sort(function (p14569, p14570) {
    return ~~(favoriteItemIds.indexOf(p14570.ind) >= 0) - ~~(favoriteItemIds.indexOf(p14569.ind) >= 0);
  });
  if (v11883.length > overlay.sprayWheelMax) {
    v11883.length = overlay.sprayWheelMax;
  }
  overlay.sprayList = v11883.map(p14571 => Game.store.skins[p14571.ind]);
  overlay.sprayList.push(Game.store.skins[v11882] ? Game.store.skins[v11882] : Game.store.skins[2482]);
}
updateSprayWheel(true);
function io_nukeUpdate(p14572) {
  if (p14572 == 0) {
    SOUND.play("siren_0");
  } else if (p14572 == 1) {
    SOUND.play("nuke_0");
    imgFlash.style.display = "block";
    imgFlash.style.opacity = 1;
    imgFlash.style.backgroundImage = "";
    RENDER.shake(1);
  }
}
function io_bombardmentUpdate(p14573) {
  if (p14573 == 0) {
    SOUND.play("adrop_0");
  } else {
    p14573 == 1;
  }
}
function io_updateTimer(p14574, p14575, p14576) {
  if (!vF1734 && !vF17342) {
    if (p14575 == 1) {
      endTimer.textContent = i18n.t("timer.end", p14574);
    } else if (p14575 == 2) {
      endTimer.textContent = i18n.t("generic.matchover");
    } else if (p14575 == 3) {
      endTimer.textContent = i18n.t("generic.matchaband");
    } else {
      if (Game && UTILS.isNumber(p14576)) {
        Game.gameTimer = p14576;
      }
      timerVal.textContent = p14574;
      speedRunTimer.textContent = p14574;
      specTimer.textContent = p14574;
      timerHolder.style.display = p14574 == "0:00" ? "none" : "block";
    }
  }
}
var vA647 = [];
function f1936(p14577, p14578, p14579, p14580) {
  var v11884 = null;
  var vLN01990 = 0;
  for (var vLN01991 = 0; vLN01991 < vA647.length; ++vLN01991) {
    if (!vA647[vLN01991].player) {
      v11884 = vA647[vLN01991];
      vLN01990 = vLN01991;
      break;
    }
  }
  if (v11884) {
    v11884.player = p14577;
  } else {
    v11884 = {};
    vLN01990 = vA647.length;
    v11884.player = p14577;
    vA647.push(v11884);
  }
  if (v11884.elm) {
    v11884.elm.remove();
  }
  tempDomElement = document.createElement("div");
  tempDomElement.className = "specPlayerHolder" + p14579;
  tempDomElement.innerHTML = "<img src='" + UTILS.assetsUrl("textures/classes/icon_" + (p14577.classIndex || 0) + ".png", true) + "' class='specPlayerIcon" + (p14577.active ? "" : " silhouette") + "' id='specPI_" + (p14577.classIndex || 0) + "'><div class='specPlayerFlag" + (p14577.flagIndex > -1 ? " flag-icon flag-icon-" + Game.flags[p14577.flagIndex][1] : "") + "' id='sf_" + p14577.flagIndex + "'></div><div class='specPlayerName'>" + p14577.alias + "</div><div class='specNum'>" + (vLN01990 < 9 ? vLN01990 + 1 : "") + "</div><span class='material-icons' style='color:rgba(255,255,255,0.7);font-size:20px;text-shadow:none;margin-top:-47px;vertical-align: middle;' id='specH_" + p14577.sid + "'>visibility</span><span class='material-icons' id='specKPD'></span>";
  v11884.elm = tempDomElement;
  v11884.team = p14578;
  (p14579 ? specTeam1 : specTeam0).insertAdjacentElement("beforeend", v11884.elm);
}
function f1937(p14581) {
  for (var vLN01992 = 0; vLN01992 < vA647.length; vLN01992++) {
    player = vA647[vLN01992];
    if (player.player) {
      if (player.player.team != player.team) {
        if (player.elm) {
          player.elm.remove();
        }
        player.elm = null;
        player.team = null;
        player.player = null;
      }
      if (player.elm) {
        player.elm.classList.toggle("specKPDSuspect", !!currentKpdCase && currentKpdCase.sus == player.player.id);
        player.elm.classList.toggle("specKPDCaller", !!currentKpdCase && currentKpdCase.caller == player.player.id);
        if (player.elm.children[0].id != "specPI_" + (player.player.classIndex || 0)) {
          player.elm.children[0].src = UTILS.assetsUrl("textures/classes/icon_" + (player.player.classIndex || 0) + ".png", true);
          player.elm.children[0].id = "specPI_" + (player.player.classIndex || 0);
        }
        if (player.elm.children[1].id != "sf_" + player.player.flagIndex) {
          player.elm.children[1].className = "specPlayerFlag" + (player.player.flagIndex > -1 ? " flag-icon flag-icon-" + Game.flags[player.player.flagIndex][1] : "");
          player.elm.children[1].id = "sf_" + player.player.flagIndex;
        }
        player.elm.children[0].classList.toggle("silhouette", !player.player.active);
        player.elm.children[4].style.display = CONTROLS.spect.target && CONTROLS.spect.target.isPlayer && CONTROLS.spect.target.sid == player.player.sid ? "inline-block" : "none";
        player.elm.children[5].style.display = currentKpdCase && (currentKpdCase.sus == player.player.id || currentKpdCase.caller == player.player.id) ? "inline-block" : "none";
      }
    } else {
      if (player.elm) {
        player.elm.remove();
        player.elm = null;
      }
      if (player.player) {
        player.team = null;
        player.player = null;
      }
    }
  }
}
var vLN01993 = 0;
function updateSpectatorRoster(p14582) {
  if (window.spectating) {
    if (gameTime - vLN01993 >= 1000) {
      for (var vLN01994 = 0; vLN01994 < Game.players.list.length; ++vLN01994) {
        player = Game.players.list[vLN01994];
        if (!player.isYou && (!player.isBot || !Game.mode.botsAsAI)) {
          var v11885 = Game.mode.teams ? player.team - 1 : vLN01994 & 1;
          var v11886 = vA647.length && vA647.find(p14583 => p14583.player && p14583.player.sid == player.sid);
          if (!v11886) {
            f1936(player, player.team, v11885);
          }
        }
      }
    }
    f1937(p14582);
  }
}
const vLN472 = 47;
function io_addPlayers(p14584, p14585) {
  for (var vLN01995 = 0, v11887; vLN01995 < p14584.length;) {
    v11887 = p14584[vLN01995] == io.socketId;
    player = Game.players.add(p14584[vLN01995], p14584[vLN01995 + 1], p14584[vLN01995 + 2], p14584[vLN01995 + 3], p14584[vLN01995 + 4], p14584[vLN01995 + 5], p14584[vLN01995 + 6], p14584[vLN01995 + 12], p14584[vLN01995 + 33], p14584[vLN01995 + 29], p14584[vLN01995 + 13], p14584[vLN01995 + 43], p14584[vLN01995 + 14], p14584[vLN01995 + 42], p14584[vLN01995 + 30], p14584[vLN01995 + 35], p14584[vLN01995 + 37], p14584[vLN01995 + 19], p14584[vLN01995 + 20], p14584[vLN01995 + 32], p14584[vLN01995 + 24], p14584[vLN01995 + 22], p14584[vLN01995 + 23], p14584[vLN01995 + 15], p14584[vLN01995 + 21], p14584[vLN01995 + 9], v11887, p14584[vLN01995 + 16], p14584[vLN01995 + 17], null, p14584[vLN01995 + 28], p14584[vLN01995 + 38], p14584[vLN01995 + 39], p14584[vLN01995 + 40], p14584[vLN01995 + 41], p14584[vLN01995 + 45]);
    player.health = p14584[vLN01995 + 7] == null ? player.maxHealth : p14584[vLN01995 + 7];
    player.maxHealth = p14584[vLN01995 + 8];
    player.hpChase = player.health / player.maxHealth;
    player.team = p14584[vLN01995 + 9];
    player.level = p14584[vLN01995 + 10];
    player.clan = p14584[vLN01995 + 11];
    player.xDire = p14584[vLN01995 + 18];
    player.featured = p14584[vLN01995 + 25];
    player.partner = p14584[vLN01995 + 34];
    player.premiumT = p14584[vLN01995 + 27];
    player.flagIndex = parseInt(p14584[vLN01995 + 26]);
    player.accid = p14584[vLN01995 + 31];
    player.badgeIndex = parseInt(p14584[vLN01995 + 36]);
    player.playerCardIndex = parseInt(p14584[vLN01995 + 44]);
    Game.setBusy(player, p14584[vLN01995 + 46]);
    if (v11887) {
      if (account && account.canFlag) {
        player.kpd = true;
      }
      player.setInitPos();
      lastPlayerSyncTime = Date.now();
      tmpPlayer = player;
      bottomLeftTeamName.style.color = Game.mode.teamColors && Game.mode.teamColors[tmpPlayer.team - 1] ? Game.mode.teamColors[tmpPlayer.team - 1] : "#fff";
      bottomLeftTeamName.textContent = Game.mode.teamOptions ? Game.mode.teamOptions[tmpPlayer.team - 1] || config.teamNames[tmpPlayer.team - 1] : Game.mode.teams ? config.teamNames[tmpPlayer.team - 1] : "";
      bottomLeftTeamType.textContent = Game.mode.teamOptions || Game.mode.teams ? "Team" : "FFA";
      if (tmpPlayer.team) {
        var v11888 = document.getElementById((Game.mode.flags ? "tScoreF" : "tScoreC") + tmpPlayer.team);
        if (v11888) {
          v11888.className = (Game.mode.flags ? "material-icons tScoreF" : "tScoreC") + " you";
        } else {
          f1996();
        }
      }
      f1773();
      var v11889 = Game.mode.teamOptions && Game.mode.teamOptions[tmpPlayer.team - 1] == "Prop";
      botRightHider.style.display = v11889 ? "none" : "block";
      propControlHolder.style.display = v11889 ? "block" : "none";
      if (!Game.detachedCam) {
        CONTROLS.object.rotation.y = tmpPlayer.xDire;
        CONTROLS.xDr = CONTROLS.object.rotation.y % Math.PI2;
        CONTROLS.pchObjc.rotation.x = tmpPlayer.yDire;
        CONTROLS.yDr = CONTROLS.pchObjc.rotation.x % Math.PI2;
      }
      Game.players.updatePlayerFov(tmpPlayer);
      if (Game.mode.deposit) {
        io_updateKrTags(0, Game.mode.depositType);
      }
      if (Game.mode.bighead) {
        f2014(tmpPlayer.headMlt);
      }
    } else {
      player.objInstances.visible = false;
    }
    io_changeHealth(player.health, player.sid, null, null, true);
    vLN01995 += vLN472;
    if (player.id == focusedPlayerId && window.spectating) {
      focusPlayer(focusedPlayerId);
    }
    if (Game && Game.mainScript && Game.mainScript.onPlayerSpawn) {
      Game.mainScript.onPlayerSpawn(player.id + "");
    }
  }
}
function io_updateNames(p14586, p14587) {
  for (var vLN01996 = 0; vLN01996 < p14586.length;) {
    for (var vLN01997 = 0; vLN01997 < Game.players.list.length; ++vLN01997) {
      if (Game.players.list[vLN01997].id == p14586[vLN01996]) {
        Game.players.list[vLN01997].name = p14586[vLN01996 + 1];
        Game.players.list[vLN01997].alias = p14586[vLN01996 + 2];
      }
    }
    vLN01996 += 3;
  }
  if (!p14587) {
    io.socket.close();
  }
}
var vLN01998 = 0;
function io_syncFailed(p14588) {
  if (Game) {
    CONTROLS.tmpInpts.length = 0;
    queuedInputLookDeltas.length = 0;
    lastSentInputLookDeltas = [];
    lastQueuedInputValues = {};
    inputResyncFlag = 1;
    if (p14588 != 6 && p14588 != 7 && Game.now - vLN01998 >= 5000) {
      io_addChat(-1, null, "Input Failed " + p14588, 2);
    }
    vLN01998 = Game.now;
  }
}
var lastPlayerSyncTime = 0;
var vLN262 = 26;
function io_syncPlayer(p14589) {
  io.send("v");
  if (tmpPlayer && p14589) {
    var now = Date.now();
    var timeDiff = now - lastPlayerSyncTime;
    if (UTILS.inRange(timeDiff, 3000, 20000)) {
      f1790();
    }
    lastPlayerSyncTime = now;
    var x = tmpPlayer.x;
    var y = tmpPlayer.y;
    var z = tmpPlayer.z;
    tmpPlayer.x = p14589[2];
    tmpPlayer.y = p14589[3];
    tmpPlayer.z = p14589[4];
    tmpPlayer.onGround = p14589[9];
    tmpPlayer.didJump = p14589[10];
    tmpPlayer.didJumpW = p14589[11];
    tmpPlayer.wallJumpC = p14589[12];
    tmpPlayer.onWall = p14589[13];
    tmpPlayer.onLadder = p14589[14];
    tmpPlayer.aimVal = p14589[15];
    tmpPlayer.crouchVal = p14589[16];
    tmpPlayer.velocity.set(p14589[6], p14589[5], p14589[7]);
    tmpPlayer.xVelC = p14589[21];
    tmpPlayer.zVelC = p14589[22];
    tmpPlayer.xDire = p14589[8];
    Game.players.swapWeapon(tmpPlayer, 0, false, p14589[17], undefined, true);
    tmpPlayer.slideTimer = p14589[18];
    tmpPlayer.canSlide = p14589[19];
    tmpPlayer.onTerrain = p14589[20];
    tmpPlayer.grapple = p14589[23] || null;
    tmpPlayer.canSlideT = p14589[24];
    var v11895 = p14589[25];
    if (v11895 && tmpPlayer._protected) {
      for (var vLN02001 = 0; vLN02001 < v11895.length; vLN02001 += 2) {
        if (tmpPlayer._protected[v11895[vLN02001]] != null && typeof tmpPlayer._protected[v11895[vLN02001]] != "object") {
          tmpPlayer._protected[v11895[vLN02001]] = v11895[vLN02001 + 1];
        }
      }
    }
    var v11896 = Game.movement[tmpPlayer.config.movSch || 0];
    if (v11896 && v11896.sendVals && v11896.sendVals.length) {
      for (var vLN02001 = 0; vLN02001 < v11896.sendVals.length; ++vLN02001) {
        tmpPlayer[v11896.sendVals[vLN02001]] = p14589[vLN262 + vLN02001];
      }
    }
    if (!Game || !Game.noPred) {
      for (var vLN02002 = 0; vLN02002 < CONTROLS.tmpInpts.length;) {
        if (CONTROLS.tmpInpts[vLN02002][0] <= p14589[0]) {
          CONTROLS.tmpInpts.splice(vLN02002, 1);
        } else {
          tmpPlayer.procInputs(CONTROLS.tmpInpts[vLN02002], Game, true);
          vLN02002++;
        }
      }
    }
  }
  if (tmpPlayer && p14589 && p14589[1]) {
    var v11897 = currentPing != p14589[1];
    currentPing = p14589[1];
    if (v11897) {
      f1777();
    }
  }
}
function io_socketPing() {
  io.send("po");
}
function io_socketPingResult(p14590) {
  lastSocketPing = p14590;
}
var lastVisibilityRefreshTime = Date.now();
function updatePlayerVisibility() {
  var v11899 = window.spectating && CONTROLS.spect.target ? CONTROLS.spect.target.team : team;
  if (tmpPlayer && tmpPlayer.active || window.spectating) {
    for (var vLN02004 = 0; vLN02004 < Game.players.list.length; ++vLN02004) {
      player = Game.players.list[vLN02004];
      if (player.active && player.objInstances && player != tmpPlayer) {
        player.inView = (!Game.hidePlayers || player.isBot) && (!window.spectating || player != CONTROLS.spect.target);
        if (!player.latestData) {
          player.inView = false;
          Game.players.toggleLOD(player, !!window.spectating);
        } else {
          if (window.spectating && (!window.spectating || showSpectatorNameTags) || v11899 && v11899 == player.team && !Game.mode.fakeNames || v11899 && v11899 != player.team && Game.mode.teamSee && Game.mode.teamSee[0] == v11899 && Game.mode.teamSee[1] == player.team || !Game.config.nameTags && !Game.mode.hideNames && Game.canSee(window.spectating && CONTROLS.spect.target ? CONTROLS.spect.target : tmpPlayer, player.x, player.y, player.z) == null) {
            if (Game.config.nameTagsFR && v11899 && v11899 == player.team) {
              player.inView = false;
            }
          } else {
            player.inView = false;
          }
          if (SETTINGS.tmp.hideNames == 1 && (!Game.mode.teams || v11899 && v11899 != player.team) || SETTINGS.tmp.hideNames == 2 && team && team == player.team || SETTINGS.tmp.hideNames == 3 || Game.mode.hideNames) {
            player.inView = false;
          }
          if (Game.mode.nameDist) {
            var v11900 = RENDER.camera.getWorldPosition(RENDER.targetVector);
            var v11901 = UTILS.getD3D(v11900.x, v11900.y, v11900.z, player.x, player.y, player.z);
            if (v11901 > Game.mode.nameDist) {
              player.inView = false;
            }
          }
          var v11902 = RENDER.fpsCamera.getWorldPosition(RENDER.targetVector);
          Game.players.toggleLOD(player, !!window.spectating || Game.canSee(v11902, player.x, player.y + player.height + 1, player.z, 15, true) == null);
        }
      }
    }
    for (var vLN02004 = 0; vLN02004 < Game.AI.ais.length; ++vLN02004) {
      player = Game.AI.ais[vLN02004];
      if (player.active) {
        player.canBSeen = true;
        if (window.spectating || v11899 && v11899 == player.team && !Game.mode.fakeNames || v11899 && v11899 != player.team && Game.mode.teamSee && Game.mode.teamSee[0] == v11899 && Game.mode.teamSee[1] == player.team || !Game.config.nameTags && !Game.mode.hideNames && Game.canSee(tmpPlayer, player.x, player.y, player.z, 0, 0, true) == null) {
          if (Game.config.nameTagsFR && v11899 && v11899 == player.team) {
            player.canBSeen = false;
          }
        } else {
          player.canBSeen = false;
        }
        if (SETTINGS.tmp.hideNames == 1 && (!Game.mode.teams || v11899 && v11899 != player.team) || SETTINGS.tmp.hideNames == 2 && v11899 && v11899 == player.team || SETTINGS.tmp.hideNames == 3 || Game.mode.hideNames) {
          player.canBSeen = false;
        }
      }
    }
  }
}
function io_updateLockoutTim(p14591) {
  lockoutTimer = p14591;
  io_updateGameMessage("warmup starts in ", UTILS.getTime(p14591));
  if (!p14591) {
    vsHolder.style.display = "none";
    f2042();
    instructionHider.style.display = "block";
  }
}
function io_updateGameMessage(p14592, p14593, p14594, p14595, p14596) {
  if (p14594) {
    f2002(p14594);
  }
  if (p14595) {
    io_textPopup(p14595[0], p14595[1]);
  }
  if (p14592 == "wt") {
    p14592 = i18n.t("player.waiting");
  }
  if (p14592) {
    p14592 += p14593 ? " " + p14593 : "";
  }
  gameMessage.textContent = p14592 || "";
  specGMessage.textContent = p14592 || "";
  compTimBox.textContent = p14592 || "";
  Game.objActive = !!(p14592 || "").startsWith("next");
}
function io_updateZombieRound(p14597, p14598) {
  io_textPopup(p14598 || "Round", p14597, null, 35);
  roundMessage.textContent = "Round " + p14597;
  SOUND.play("mystery_1", 0.2);
}
function io_updateTeam(p14599, p14600) {
  player = Game.players.findBySid(p14599);
  if (player) {
    player.team = p14600;
    if (player == tmpPlayer) {
      team = p14600;
      bottomLeftTeamName.style.color = Game.mode.teamColors && Game.mode.teamColors[p14600 - 1] ? Game.mode.teamColors[p14600 - 1] : "#fff";
      bottomLeftTeamName.textContent = Game.mode.teamOptions ? Game.mode.teamOptions[p14600 - 1] || config.teamNames[p14600 - 1] : Game.mode.teams ? config.teamNames[p14600 - 1] : "";
      bottomLeftTeamType.textContent = Game.mode.teamOptions || Game.mode.teams ? "Team" : "FFA";
      if (Game.mode.teamOptions && Game.mode.teamOptions[p14600 - 1] == "Stalker") {
        Game.players.resetAim();
      }
    }
  }
}
function io_updateAmmo(p14601, p14602) {
  if (tmpPlayer) {
    tmpPlayer.ammos = p14601;
    tmpPlayer.reserveAmmos = p14602;
    Game.players.updatePlayerAmmo(tmpPlayer);
  }
}
function io_lockMove(p14603, p14604, p14605, p14606) {
  Game.lockMove(tmpPlayer, p14603, p14604, p14605, p14606);
}
function f1952() {
  for (var vLN02005 = 0, v11903; vLN02005 < Game.playerSounds.length; ++vLN02005) {
    v11903 = Game.playerSounds[vLN02005].obj;
    if (v11903) {
      v11903[0].isPlaying = false;
      v11903[0].stop(v11903[1]);
    }
  }
  Game.playerSounds.length = 0;
}
function io_updatePowerUp(p14607, p14608) {
  if (p14607 == 0) {
    Game.instaKillTimer = p14608;
    if (p14608 > 0) {
      SOUND.stop("instantkill_0");
      SOUND.play("instantkill_0", 0.5);
    } else if (p14608 <= 0) {
      SOUND.stop("instantkill_0");
    }
  } else if (p14607 == 1) {
    Game.fireSaleTimer = p14608;
    if (p14608 > 0) {
      SOUND.stop("firesale_0");
      SOUND.stop("firesale_1");
      SOUND.play("firesale_0", 0.5);
      SOUND.play("firesale_1", 0.1, true);
    } else if (p14608 <= 0) {
      SOUND.stop("firesale_0");
      SOUND.stop("firesale_1");
    }
  } else if (p14607 == 2) {
    Game.doublePointsTimer = p14608;
  }
  powerUpHolder.children[p14607].style.display = p14608 > 0 ? "" : "none";
}
function io_addHitboxHelper(p14609, p14610, p14611, p14612, p14613, p14614, p14615, p14616, p14617) {
  player = Game.players.findBySid(p14609);
  if (player) {
    if (player.debugMesh) {
      RENDER.scene.remove(...player.debugMesh);
    }
    if (!player.debugMesh) {
      player.debugMesh = [];
    }
    const v11904 = new THREE.BoxGeometry();
    const v11905 = new THREE.LineBasicMaterial({
      color: 255,
      linewidth: 5
    });
    let v11906 = new THREE.LineSegments(v11904, v11905);
    RENDER.moveMesh(v11906, p14610, p14611 + p14614 / 2, p14612);
    v11906.scale.set(p14613 * 2, p14614, p14613 * 2);
    RENDER.scene.add(v11906);
    player.debugMesh.push(v11906);
    const v11907 = new THREE.BoxGeometry();
    const v11908 = new THREE.MeshBasicMaterial({
      color: p14616 || 16711680
    });
    let v11909 = new THREE.Mesh(v11907, v11908);
    RENDER.moveMesh(v11909, p14610, p14615, p14612);
    v11909.scale.set(p14613 * 2, 0.2, p14613 * 2);
    RENDER.scene.add(v11909);
    player.debugMesh.push(v11909);
    const v11910 = new THREE.BoxGeometry();
    const v11911 = new THREE.MeshBasicMaterial({
      color: 65280,
      opacity: 0.25,
      transparent: true
    });
    let v11912 = new THREE.Mesh(v11910, v11911);
    RENDER.moveMesh(v11912, p14610, p14611 + p14614 - p14617 + p14617 / 2, p14612);
    v11912.scale.set(p14613 * 2, p14617, p14613 * 2);
    RENDER.scene.add(v11912);
    player.debugMesh.push(v11912);
  }
}
function io_setBusy(p14618, p14619) {
  player = Game.players.findBySid(p14618);
  if (player) {
    Game.setBusy(player, p14619);
  }
}
function io_setJuggernaut(p14620, p14621) {
  player = Game.players.findBySid(p14620);
  if (player) {
    player.isJuggernaut = p14621;
  }
}
function io_setExperimental(p14622) {
  if (Game) {
    Game.experimentalFeatures = p14622;
    io_addChat(-1, null, "Experimental Features - " + (Game.experimentalFeatures ? "Enabled" : "Disabled"), 2);
  }
}
function io_setNoclip(p14623) {
  var v11913 = Game.isSandbox ? sandboxPlayer : tmpPlayer;
  if (v11913) {
    v11913.noclip = p14623;
    tmpPlayer.noclip = p14623;
    io_addChati18n(-1, null, ["commands.noclip." + (v11913.noclip ? "on" : "off")], 2);
  }
}
function f1959(p14624) {
  var v11914 = Game.isSandbox ? sandboxPlayer : tmpPlayer;
  if (v11914) {
    v11914.godMode = p14624;
    tmpPlayer.godMode = p14624;
    io_addChati18n(-1, null, ["commands.god." + (v11914.godMode ? "on" : "off")], 2);
  }
}
function io_setFrozen(p14625) {
  if (tmpPlayer) {
    tmpPlayer.freeze = p14625;
    tmpPlayer.defaultMovement = !tmpPlayer.freeze;
    tmpPlayer.defaultVelocity = !tmpPlayer.freeze;
    tmpPlayer.disableShooting = tmpPlayer.freeze;
    tmpPlayer.disableMelee = tmpPlayer.freeze;
  }
}
function io_setSpeedBoost(p14626) {
  if (tmpPlayer) {
    tmpPlayer.speedBoost = p14626;
    io_addChat(-1, null, "SpeedBoost - " + tmpPlayer.speedBoost, 2);
  }
}
function io_setDebug(p14627) {
  if (tmpPlayer) {
    tmpPlayer.debugMode = p14627;
    io_addChat(-1, null, "Debug Mode - " + (tmpPlayer.debugMode ? "Enabled" : "Disabled"), 2);
  }
}
function io_setUnlimited(p14628) {
  if (tmpPlayer) {
    tmpPlayer.unlimitedAmmo = p14628;
    io_addChati18n(-1, null, ["commands.unlimited." + (tmpPlayer.unlimitedAmmo ? "on" : "off")], 2);
  }
}
function io_setHidden(p14629) {
  if (tmpPlayer) {
    tmpPlayer.forceHide = p14629;
    io_addChat(-1, null, "Hide - " + (tmpPlayer.forceHide ? "Enabled" : "Disabled"), 2);
  }
}
function io_setSharingIsCaring(p14630) {
  if (tmpPlayer) {
    tmpPlayer.sharingIsCaring = p14630;
    io_textPopup("Sharing is caring", "", true);
  }
}
function io_setPlayerKey(p14631, p14632) {
  if (tmpPlayer) {
    tmpPlayer[p14631] = p14632;
  }
}
function io_customVal(p14633, p14634) {
  if (tmpPlayer) {
    tmpPlayer.custVals[p14633] = p14634;
  }
}
function io_refillKnife() {
  if (tmpPlayer) {
    tmpPlayer.refillKnife();
  }
}
function io_confirmInteraction(p14635, p14636) {
  if (tmpPlayer) {
    tmpPlayer[p14636 == 2 ? "pendingSpin" : "pendingTrigger"] = p14635;
  }
}
function io_servAnim(p14637, p14638, p14639, p14640) {
  if (p14640) {
    Game.servAnim(p14637, p14638, p14639);
  } else {
    Game.AI.servAnim(p14637, p14638, p14639);
  }
}
let vLN1310 = 13;
function io_updatePlayers(p14641, p14642, p14643) {
  var now = Date.now();
  Game.players.hideAll();
  Game.servTim = p14643;
  Game.lastSync = +(Game.newSync || 0);
  Game.newSync = now;
  if (p14641) {
    for (var vLN02006 = 0; vLN02006 < p14641.length;) {
      player = Game.players.findBySid(p14641[vLN02006]);
      if (player && player != tmpPlayer) {
        if (player.objInstances) {
          player.objInstances.visible = !Game.hidePlayers && !player.lodActive;
          if (Game.hidePlayers && player.isBot) {
            player.objInstances.visible = !player.lodActive;
          }
        }
        player.sendRateA = p14642;
        player.latestData = true;
        if (player.forcePos) {
          player.x = p14641[vLN02006 + 1];
          player.y = p14641[vLN02006 + 2];
          player.z = p14641[vLN02006 + 3];
          player.xDire = UTILS.toRad(p14641[vLN02006 + 4]);
          player.yDire = UTILS.toRad(p14641[vLN02006 + 5]);
          player.stepVal = p14641[vLN02006 + 6];
          player.posBuffer.length = 0;
          player.interpolate = false;
          player.forcePos = false;
        } else {
          player.posBuffer.push({
            t: now,
            x: p14641[vLN02006 + 1],
            y: p14641[vLN02006 + 2],
            z: p14641[vLN02006 + 3],
            xD: UTILS.toRad(p14641[vLN02006 + 4]),
            yD: UTILS.toRad(p14641[vLN02006 + 5]),
            s: p14641[vLN02006 + 6]
          });
          player.interpolate = true;
        }
        player.onGround = p14641[vLN02006 + 7];
        player.crouchVal = p14641[vLN02006 + 8];
        player.aimVal = p14641[vLN02006 + 10];
        player.ping = p14641[vLN02006 + 12];
        var v11916 = p14641[vLN02006 + 11];
        if (v11916) {
          if (!player.grapple || player.grapple.x != v11916[0] || player.grapple.y != v11916[1] || player.grapple.z != v11916[2]) {
            player.grapple = {
              x: v11916[0],
              y: v11916[1],
              z: v11916[2]
            };
            PARTICLES.addRope(player, v11916[0], v11916[1], v11916[2]);
          }
        } else {
          player.grapple = null;
        }
        Game.players.swapWeapon(player, 0, false, p14641[vLN02006 + 9]);
      }
      vLN02006 += vLN1310;
    }
  }
}
function io_removePlayer(p14644) {
  if (spectatorPlayerStats[p14644]) {
    spectatorPlayerStats[p14644] = null;
  }
  if (vA647 && vA647.length) {
    var v11917 = vA647.find(p14645 => p14645.player && p14645.player.sid == p14644);
    if (v11917) {
      v11917.player = null;
    }
  }
  let v11918 = Game.players.findBySid(p14644);
  if (v11918 && v11918.id == focusedPlayerId) {
    clearFocus(true);
  }
  Game.players.remove(p14644);
}
function io_killPlayer(p14646, p14647, p14648, p14649, p14650, p14651) {
  player = Game.players.findBySid(p14646);
  otherPlayer = Game.players.findBySid(p14648);
  var v11919 = false;
  if (player) {
    if (otherPlayer && player != otherPlayer) {
      player.killedBy[otherPlayer.id] = (player.killedBy[otherPlayer.id] || 0) + 1;
    }
    const v11920 = !!tmpPlayer && !!tmpPlayer.team && tmpPlayer.team == player.team || !!player.isYou || !!window.spectating;
    if (v11920) {
      overlay.addDeathMarker(player.x, player.y, player.z, player.isYou);
    }
    Game.players.kill(player);
    if (player.isYou) {
      overlay.sprayWheelClose();
      overlay.propWheelClose();
      reloadMsg.style.display = "none";
      deathsVal.textContent = p14647 || 0;
      kdVal.textContent = ((parseInt(killsVal.textContent) || 0) / (p14647 || 1)).round(1).toString();
      currentKillStreak = 0;
      streakVal.textContent = currentKillStreak;
      if (otherPlayer && player != otherPlayer) {
        if ((otherPlayer.level <= 10 || !otherPlayer.level) && account && !Game.isCustom && kickVoteSubmittedAliases.indexOf(otherPlayer.alias) == -1) {
          v11919 = true;
        }
        if (Game && Game.config && Game && Game.config.kCams) {
          CONTROLS.camLookAt(otherPlayer.x, otherPlayer.y + otherPlayer.height / 1.5, otherPlayer.z);
          otherPlayer.interpolate = false;
          otherPlayer.inView = true;
          if (otherPlayer.objInstances) {
            otherPlayer.objInstances.visible = true;
          }
        }
      }
      f1975(player, otherPlayer, p14649, v11919);
      perkHolder.innerHTML = "";
      zPerksHolder.innerHTML = "";
      uiBase.classList.toggle("onDeathScrn", true);
      if (Game.mode && Game.mode.canTrade) {
        window.closeWindow();
      }
      UI.toggleGameUI(false);
      deathDelayTimer = requestAnimationFrame(function () {
        if (Game.forceSpawn) {
          f1737(Game.forceSpawn + 1);
        }
        inGame = false;
        let v11921 = CONTROLS.enabled;
        if (v11921) {
          v11921 = CONTROLS.resume();
        }
        if (!v11921) {
          f1771();
        }
      }, config.deathDelay);
      f2081();
    }
    if (!p14651 && SETTINGS.tmp.showKills) {
      var v11922 = player == tmpPlayer ? "<span style='color:" + COLORS.killFeed.you + "'>You</span>" : "<span style='color:" + (team && team == player.team ? COLORS.killFeed.ally : COLORS.killFeed.enemy) + "'>" + UTILS.fixStr(SETTINGS.tmp.streamMode ? UTILS.scrambleS(player.alias) : player.alias) + (player.clan && SETTINGS.tmp.leaderType == 1 ? "<span style='color:" + COLORS.getClanCol(player.clan, "#fff") + "'> [" + UTILS.fixStr(player.clan) + "]</span>" : "") + "</span>";
      var v11923 = player == otherPlayer ? "" : otherPlayer == tmpPlayer ? "<span style='color:" + COLORS.killFeed.you + "'>You</span>" : otherPlayer ? "<span style='color:" + (team && team == otherPlayer.team ? COLORS.killFeed.ally : COLORS.killFeed.enemy) + "'>" + UTILS.fixStr(SETTINGS.tmp.streamMode ? UTILS.scrambleS(otherPlayer.alias) : otherPlayer.alias) + (otherPlayer.clan && SETTINGS.tmp.leaderType == 1 ? "<span style='color:" + COLORS.getClanCol(otherPlayer.clan, "#fff") + "'> [" + UTILS.fixStr(otherPlayer.clan) + "]</span>" : "") + "</span>" : "";
      if (otherPlayer) {
        f2024(otherPlayer, p14650, v11923, v11922);
      } else {
        f2024(null, null, null, v11922 + " committed " + UTILS.fixStr(config.suicides[UTILS.randInt(0, config.suicides.length - 1)]));
      }
    }
    if (Game && Game.mainScript && Game.mainScript.onPlayerDeath) {
      Game.mainScript.onPlayerDeath(player.id + "", otherPlayer ? otherPlayer.id + "" : "");
    }
  }
}
function f1974(p14652, p14653, p14654) {
  const v11924 = Game.weaponConfig[p14653];
  const v11925 = v11924.melee && p14654 && p14654.pj;
  let v11926;
  v11926 = v11924.assetIcon.length ? UTILS.userAssetsUrl("/" + v11924.assetIcon.replace(/[^\d]/g, "") + "/texture.png") : v11924.melee && p14654 && p14654.fs ? UTILS.assetsUrl("/img/death-ui/icon_0.png") : v11924.melee ? UTILS.assetsUrl("/img/death-ui/icon_0_1.png") : UTILS.assetsUrl("/img/death-ui/" + v11924.icon + ".png");
  return v11926;
}
function f1975(p14655, p14656, p14657, p14658, p14659) {
  p14657 = p14657 || [];
  let vA648 = ["Time Survived", "Shots Fired", "Accuracy", "Kills", "Score"];
  let vLS96 = "";
  if (p14657 && p14657[3]) {
    for (let vLN02007 = 0; vLN02007 < vA648.length; vLN02007++) {
      vLS96 += "<div class=\"death-stats-row\">\n\t\t\t" + vA648[vLN02007] + " : <span style=\"color:rgba(255, 255, 255, 0.7)\">" + (p14657[3][vLN02007] == null ? "Unknown" : vLN02007 == 0 ? UTILS.getReadableTime(p14657[3][vLN02007], true, null, true) : p14657[3][vLN02007]) + "</span>\n\t\t</div>";
    }
  }
  let vLS97 = "";
  if (p14656 && p14655 != p14656) {
    const v11927 = account && account.stats && account.stats["c" + p14655.classIndex] ? account.stats["c" + p14655.classIndex] : 0;
    const v11928 = Math.max(1, Math.floor(config.rankVar * Math.sqrt(v11927)) + 1);
    const v11929 = Math.max(1, Math.floor(config.rankVar * Math.sqrt(p14657[1] || 0)) + 1);
    const vF1974 = f1974(p14655, p14655.weapon.id);
    const vF19742 = f1974(p14656, p14657[0], p14658);
    const v11930 = Game.store.skins[p14655.playerCardIndex] ? Game.store.skins[p14655.playerCardIndex].thumbnail : null;
    const v11931 = Game.store.skins[p14656.playerCardIndex] ? Game.store.skins[p14656.playerCardIndex].thumbnail : null;
    const v11932 = p14656.loadout.indexOf(p14657[0]);
    let v11933 = p14656.skins[v11932] == null ? null : p14656.skins[v11932];
    if (v11933 != null) {
      v11933 = Game.store.skins[v11933];
    }
    if (v11933 && v11933.weapon - 1 != p14656.loadout[v11932]) {
      v11933 = null;
    }
    let v11934 = v11933 ? Game.store.rarities[v11933.rarity].color : "rgba(255,255,255,0.7)";
    const v11935 = Game.weaponConfig[p14657[0]];
    let v11936 = v11933 ? v11933.name : v11935.name;
    let v11937 = !!v11933 && Game.store.rarities[v11933.rarity].animate;
    const v11938 = v11935.melee && p14658 && p14658.pj;
    if (v11935.melee && p14658 && p14658.fs) {
      v11936 = "Fists";
      v11934 = "rgba(255,255,255,0.7)";
      v11937 = false;
    } else if (v11935.melee && p14656.meleeIndex >= 0 && Game.store.skins[p14656.meleeIndex]) {
      v11936 = Game.store.skins[p14656.meleeIndex].name;
      v11934 = Game.store.rarities[Game.store.skins[p14656.meleeIndex].rarity].color;
      v11937 = Game.store.rarities[Game.store.skins[p14656.meleeIndex].rarity].animate;
    }
    const v11939 = p14655.weapon.name;
    vLS97 += "\n\t\t\t<div class=\"death-ui-bottom\" id='deathUIBottom'>\n\t\t\t\t<div class=\"death-column-empty\"></div>\n\t\t\t\t<div class=\"death-column\" style=\"justify-content: end;\">\n\t\t\t\t\t<div class=\"death-row-left\">\n\t\t\t\t\t\t<div class=\"death-row-weapon\">\n\t\t\t\t\t\t\t<div class=\"death-row-weapon-text" + (RENDER.rarityAnim && v11937 ? " rainbowText" : "") + "\" style=\"color:" + v11934 + "\">" + (v11938 ? "Thrown " : "") + "[" + v11936 + "]</div>\n\t\t\t\t\t\t\t<div class=\"death-row-weapon-img\" style=\"background-image:url(" + vF19742 + ")\"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"death-row-kills\">" + (p14655.killedBy[p14656.id] || 0) + "</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"death-row-bottom\">\n\t\t\t\t\t\t" + (v11931 ? "<img class=\"death-row-bottom-bg\" src=\"" + v11931 + "\">" : "") + "\n\t\t\t\t\t\t<div class=\"death-row-class\">\n\t\t\t\t\t\t\t<img class=\"death-row-class-img\" src=\"" + f1772(p14656.classIndex) + "\">\n\t\t\t\t\t\t\t<div class=\"death-row-class-level\">lvl " + v11929 + "</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"death-row-user\">\n\t\t\t\t\t\t\t<div class=\"death-row-user-text\">" + (SETTINGS.tmp.streamMode ? UTILS.scrambleS(p14656.alias) : p14656.alias) + "</div>\n\t\t\t\t\t\t\t" + (p14657 && p14657[2] ? "<div class=\"death-row-user-stat\">\n\t\t\t\t\t\t\t\t" + p14657[2][1] + " <span style=\"color:#fff\">" + config.playerCardStats[p14657[2][0]].name + "</span>\n\t\t\t\t\t\t\t</div>" : "") + "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"death-column\" style=\"justify-content: center;\">\n\t\t\t\t\t<div class=\"death-row-center\">-</div>\n\t\t\t\t\t<div class=\"death-row-center death-row-center-bottom\">VS</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"death-column\" style=\"justify-content: start;\">\n\t\t\t\t\t" + (p14659 ? "<div class=\"death-report\">\n\t\t\t\t\t\t<span class=\"death-report-text\">[" + UTILS.getKeyName(CONTROLS.binds.playerList.val) + "]</span> to Report\n\t\t\t\t\t</div>" : "") + "\n\t\t\t\t\t<div class=\"death-row-right\">\n\t\t\t\t\t\t<div class=\"death-row-kills\">" + (p14656.killedBy[p14655.id] || 0) + "</div>\n\t\t\t\t\t\t<div class=\"death-row-weapon\">\n\t\t\t\t\t\t\t<div class=\"death-row-weapon-text\" style=\"color:rgba(255,255,255,0.7)\">[" + v11939 + "]</div>\n\t\t\t\t\t\t\t<div class=\"death-row-weapon-img-right\" style=\"background-image:url(" + vF1974 + ")\"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"death-row-bottom\">\n\t\t\t\t\t\t" + (v11930 ? "<img class=\"death-row-bottom-bg\" src=\"" + v11930 + "\">" : "") + "\n\t\t\t\t\t\t<div class=\"death-row-class\">\n\t\t\t\t\t\t\t<img class=\"death-row-class-img\" src=\"" + f1772(p14655.classIndex) + "\">\n\t\t\t\t\t\t\t<div class=\"death-row-class-level\">lvl " + v11928 + "</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"death-row-user\">\n\t\t\t\t\t\t\t<div class=\"death-row-user-text\">" + (account ? account.premiumT > 0 && SETTINGS.tmp.premiumBadge ? account.alias : account.name : p14655.alias) + "</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"death-stats\">" + vLS96 + "</div>\n\t\t\t</div>\n\t\t";
  } else {
    vLS97 += "<div class=\"death-ui-bottom-empty\">\n\t\t\t<div class=\"death-column-empty\"></div>\n\t\t\t<div class=\"death-column\" style=\"justify-content: center;\">\n\t\t\t\t<div class=\"death-row-center-self\">You</div>\n\t\t\t\t<div class=\"death-row-center-self\">Died</div>\n\t\t\t</div>\n\t\t\t<div class=\"death-stats\">" + vLS96 + "</div>\n\t\t</div>";
  }
  deathUIHolder.innerHTML = vLS97;
  deathUIHolder.style.display = "block";
}
function io_krPackage(p14660, p14661) {
  player = Game.players.findBySid(p14660);
  otherPlayer = Game.players.findBySid(p14661);
  if (player) {
    var v11940 = player == tmpPlayer ? "<span style='color:" + COLORS.killFeed.you + "'>" + (player == otherPlayer ? "You" : "Your") + "</span>" : "<span style='color:" + (team && team == player.team ? COLORS.killFeed.ally : COLORS.killFeed.enemy) + "'>" + UTILS.fixStr(SETTINGS.tmp.streamMode ? UTILS.scrambleS(player.alias) : player.alias) + (player.clan && SETTINGS.tmp.leaderType == 1 ? "<span style='color:" + COLORS.getClanCol(player.clan, "#fff") + "'> [" + UTILS.fixStr(player.clan) + "]</span>" : "") + "</span>";
    var v11941 = player == otherPlayer ? "" : otherPlayer == tmpPlayer ? "<span style='color:" + COLORS.killFeed.you + "'>" + (player == otherPlayer ? "Your" : "You") + "</span>" : otherPlayer ? "<span style='color:" + (team && team == otherPlayer.team ? COLORS.killFeed.ally : COLORS.killFeed.enemy) + "'>" + UTILS.fixStr(SETTINGS.tmp.streamMode ? UTILS.scrambleS(otherPlayer.alias) : otherPlayer.alias) + (otherPlayer.clan && SETTINGS.tmp.leaderType == 1 ? "<span style='color:" + COLORS.getClanCol(otherPlayer.clan, "#fff") + "'> [" + UTILS.fixStr(otherPlayer.clan) + "]</span>" : "") + "</span>" : "";
    if (player == otherPlayer) {
      io_addChat(team && team == player.team ? 1 : 0, null, v11940 + " claimed a package", 1);
    } else {
      io_addChat(team && team == player.team ? 1 : 0, null, v11941 + " stole " + v11940 + " package", 1);
    }
  }
}
window.callInStreak = function (p14662) {
  p14662 = parseInt(p14662) || 0;
  if (Game.isSandbox) {
    sandboxGame.players.checkStreak(sandboxPlayer, p14662);
  } else {
    io.send("k" + p14662);
  }
};
function io_killStreak(p14663, p14664) {
  if (tmpPlayer) {
    if (p14664) {
      if (tmpPlayer.streaks[p14663]) {
        tmpPlayer.streaks[p14663].cnt = p14664;
      } else {
        tmpPlayer.streaks[p14663] = {
          cnt: p14664,
          streak: Game.streaks[p14663]
        };
      }
    } else {
      tmpPlayer.streaks[p14663] = null;
    }
    var vLS98 = "";
    for (var v11942 = [...Game.streaks].sort((p14665, p14666) => (p14665.kills == null ? 0 : p14665.kills) - (p14666.kills == null ? 0 : p14666.kills)).sort((p14667, p14668) => (p14667.slot == null ? 0 : p14667.slot) - (p14668.slot == null ? 0 : p14668.slot)), vLN02008 = 0; vLN02008 < v11942.length; ++vLN02008) {
      var v11943 = v11942[vLN02008].slot;
      var v11944 = v11942[vLN02008].index;
      if (tmpPlayer.streaks[v11944] && tmpPlayer.streaks[v11944].cnt) {
        vLS98 += "<div class='killStreakItem'" + (CONTROLS.isMobile || isMobileClient() ? " ontouchstart='callInStreak(" + v11943 + ")'" : "") + "><div class='killStreakItemInner'>" + (CONTROLS.isMobile || isMobileClient() ? "" : "<div class='killStreakKey'>" + UTILS.getKeyName(CONTROLS.binds.streak[v11943].val) + "</div>") + ("<div class='killStreakCnt'>x" + tmpPlayer.streaks[v11944].cnt + "</div>") + ("<img style='width: 100%;' src=\"" + UTILS.assetsUrl("/img/streaks/" + v11944 + ".png") + "\">") + "</div></div>";
      }
    }
    killStreakHolder.innerHTML = vLS98;
  }
}
function io_updateWeaponStreak(p14669, p14670) {
  if (tmpPlayer) {
    tmpPlayer.currentStreakWeapon = p14669;
    tmpPlayer.weaponStreak = p14670;
    const v11945 = weapHolder.querySelectorAll(".weapStreakHolder");
    if (v11945.length) {
      v11945.forEach(p14671 => {
        p14671.style.display = p14671.dataset.weaponIndex == p14669 ? "block" : "none";
        p14671.firstElementChild.firstChild.textContent = p14671.dataset.weaponIndex == p14669 ? p14670 : 0;
      });
    }
  }
}
function io_updateKrTags(p14672, p14673) {
  if (tmpPlayer) {
    tmpPlayer.dogTags = p14672;
    var v11946 = p14673 ? giftTagHolder : krTagHolder;
    var v11947 = tmpPlayer.dogTags >= Game.mode.tagHoldLimit ? "rgba(255, 0, 0, 0.5)" : "var(--div-grey)";
    if (v11946.firstChild) {
      v11946 = v11946.firstChild.firstChild;
      v11946.firstChild.textContent = "x" + (tmpPlayer.dogTags || 0);
      v11946.style.backgroundColor = v11947;
    } else {
      v11946.innerHTML = "<div class='killStreakItem'>" + ("<div class='killStreakItemInner' style=\"background-color:" + v11947 + "\">") + ("<div class='killStreakCnt'>x" + (tmpPlayer.dogTags || 0) + "</div>") + ("<img style='width: 100%;' src=\"" + UTILS.assetsUrl(p14673 ? "/img/props/prop_60.png" : "/textures/sprays/114.png") + "\">") + "</div></div>";
    }
  }
}
function io_updateZombiePerks(p14674, p14675) {
  player = Game.players.findBySid(p14674);
  if (player && (player.perks = p14675, player.isYou)) {
    var vLS99 = "";
    for (var vLN02009 = 0; vLN02009 < player.perks.length; ++vLN02009) {
      vLS99 += "<div class='zPerkItem' style='background-image: url(&quot;" + UTILS.assetsUrl("/img/perks/zombie/" + player.perks[vLN02009] + ".png") + "&quot;)'><span></span></div>";
    }
    zPerksHolder.innerHTML = vLS99;
  }
}
function io_effect(p14676, p14677) {
  if (tmpPlayer) {
    if (p14677) {
      tmpPlayer.effects[p14676] = tmpPlayer.effects[p14676] ? p14677 : p14677;
      Game.effectConfig[p14676].execute(Game, tmpPlayer);
    } else {
      Game.players.clearEffect(tmpPlayer, p14676);
    }
    var vLS101 = "";
    for (var vLN02010 = 0; vLN02010 < Game.effectConfig.length; ++vLN02010) {
      if (tmpPlayer.effects[vLN02010]) {
        vLS101 += "<div class='perkItem'><di class=\"perkItemInner\">" + ("<img src=\"" + UTILS.assetsUrl("/img/perks/" + vLN02010 + ".png") + "\" style=\"width: 100%;\">") + ("<div class='perkCnt'>x" + tmpPlayer.effects[vLN02010] + "</div></div></div>");
      }
    }
    perkHolder.innerHTML = vLS101;
  }
}
function io_killStreakM(p14678, p14679) {
  player = Game.players.findBySid(p14678);
  if (player) {
    var v11948 = player == tmpPlayer ? "<span style='color:" + COLORS.killFeed.you + "'>You're</span>" : "<span style='color:" + (team && team == player.team ? COLORS.killFeed.ally : COLORS.killFeed.enemy) + "'>" + UTILS.fixStr(SETTINGS.tmp.streamMode ? UTILS.scrambleS(player.alias) : player.alias) + "</span> is";
    io_addChat(0, null, i18n.t("player.killstreak", v11948, UTILS.fixStr(p14679)), 1);
  }
}
function io_actionFeed(p14680, p14681, p14682) {
  player = Game.players.findBySid(p14680);
  otherPlayer = Game.players.findBySid(p14681);
  if (player) {
    var v11949 = player == tmpPlayer ? "<span style='color:" + COLORS.killFeed.you + "'>You</span>" : "<span style='color:" + (team && team == player.team ? COLORS.killFeed.ally : COLORS.killFeed.enemy) + "'>" + UTILS.fixStr(SETTINGS.tmp.streamMode ? UTILS.scrambleS(player.alias) : player.alias) + "</span>";
    var v11950 = otherPlayer && otherPlayer == tmpPlayer ? "<span style='color:#fff'>You</span>" : otherPlayer ? "<span style='color:" + (team && team == otherPlayer.team ? COLORS.killFeed.ally : COLORS.killFeed.enemy) + "'>" + UTILS.fixStr(SETTINGS.tmp.streamMode ? UTILS.scrambleS(otherPlayer.alias) : otherPlayer.alias) + "</span>" : "";
    io_addChat(0, null, v11949 + " " + UTILS.fixStr(p14682) + " " + v11950, 1);
  }
}
function f1984(p14683) {
  var v11951 = Game && Game.mode && Game.mode.leaderStats ? Game.mode.leaderStats : ["score"];
  for (var v11952 = v11951.length + 1, vLN1157 = 1, vLS102 = "", vLN02011 = 0; vLN02011 < p14683.length; vLN02011 += v11952) {
    player = Game.players.findBySid(p14683[vLN02011]);
    if (player) {
      var v11953 = player.team - 1;
      vLS102 += "<div class='leaderItem'>";
      vLS102 += "<div class='leaderCounter'>" + vLN1157 + ".</div>";
      vLS102 += player.partner >= 2 ? " <i class='material-icons' style='color:" + COLORS.partner + ";margin-top:5px;font-size:23px;vertical-align:middle;'>verified</i>" : "";
      vLS102 += player.premiumT > 0 ? " <i class='material-icons' style='color:" + COLORS.verified.clan + ";margin-top:5px;font-size:23px;vertical-align:middle;'>beenhere</i>" : "";
      vLS102 += player.featured ? " <i class='material-icons' style='color:" + COLORS.verified.player + ";margin-top:5px;font-size:23px;vertical-align:middle;'>check_circle</i>" : "";
      vLS102 += player.badgeIndex >= 0 ? "<img src='" + Game.badges[player.badgeIndex].url + "' style='margin-top:5px;font-size:28px;vertical-align:middle;height:21px;margin-left:2px;'>" : "";
      vLS102 += "<div class='leaderName" + (tmpPlayer && p14683[vLN02011] == tmpPlayer.sid ? "M" : Game.mode.fakeNames || team && team == player.team ? "F" : "") + "'>" + (SETTINGS.tmp.streamMode ? UTILS.scrambleS(player.alias) : player.alias) + (player.clan ? "<span style='color:" + COLORS.getClanCol(player.clan, "#fff") + "'> [" + player.clan + "]</span>" : "") + "</div>";
      vLS102 += "<div class='leaderScore'>" + UTILS.formatNum(p14683[vLN02011 + 1], 2) + "</div>";
      vLS102 += "</div>";
      vLN1157++;
      if (vLN1157 > 10) {
        break;
      }
    }
  }
  if (leaderContainer) {
    leaderContainer.innerHTML = vLS102;
  }
  if (vLN1157 <= 1) {
    leaderContainer.innerHTML = i18n.t("leaderboard.empty");
  }
}
function f1985(p14684) {
  centerLeaderDisplay.innerHTML = "";
  var v11954 = Game.mode.teams && !Game.mode.fakeNames;
  var v11955 = Game && Game.mode && Game.mode.leaderStats ? Game.mode.leaderStats : ["score"];
  for (var v11956 = v11955.length + 1, vA649 = [], vA650 = [], vLN02012 = 0, v11957; vLN02012 < p14684.length; vLN02012 += v11956) {
    player = Game.players.findBySid(p14684[vLN02012]);
    if (player) {
      v11957 = v11954 ? player.team - 1 : 0;
      if (!vA650[v11957]) {
        vA650[v11957] = "";
        if (v11954) {
          var v11958 = document.getElementById("teamNm" + (v11957 + 1));
          vA650[v11957] = "<div class='newLeaderTeam'>" + (v11958 ? v11958.textContent : config.teamNames[v11957]) + "<div class='newLeaderTeamScore'>" + (Game.teamScores[v11957 + 1] || 0) + "</div></div>";
        }
        vA650[v11957] += "<table id='ingameTable'>";
        vA650[v11957] += "<tr><th>Name</th>";
        for (var vLN02013 = 0; vLN02013 < v11955.length; ++vLN02013) {
          vA650[v11957] += "<th>" + UTILS.capFirst(v11955[vLN02013]) + "</th>";
        }
        vA650[v11957] += "</tr>";
        vA650[v11957] += "<tr height='10px;'></tr>";
      }
      if (!vA649[v11957]) {
        vA649[v11957] = 1;
      }
      vA650[v11957] += "<tr><td>";
      vA650[v11957] += "<div class='newLeaderItem'>";
      vA650[v11957] += "<div class='newLeaderCounter'>" + vA649[v11957] + ".</div>";
      vA650[v11957] += player.partner >= 2 ? " <i class='material-icons' style='color:" + COLORS.partner + ";margin-top:3px;font-size:23px;vertical-align:middle;'>verified</i>" : "";
      vA650[v11957] += player.premiumT > 0 ? " <i class='material-icons' style='color:" + COLORS.verified.clan + ";margin-top:3px;font-size:23px;vertical-align:middle;'>beenhere</i>" : "";
      vA650[v11957] += player.featured ? " <i class='material-icons' style='color:" + COLORS.verified.player + ";margin-top:3px;font-size:23px;vertical-align:middle;'>check_circle</i>" : "";
      vA650[v11957] += player.badgeIndex >= 0 ? "<img src='" + Game.badges[player.badgeIndex].url + "' style='margin-top: 3px;font-size:28px;vertical-align:middle;height: 21px;margin-left:2px;'>" : "";
      vA650[v11957] += "<div class='newLeaderName" + (tmpPlayer && p14684[vLN02012] == tmpPlayer.sid ? "M" : Game.mode.fakeNames || team && team == player.team ? "F" : "") + "'>" + (SETTINGS.tmp.streamMode ? UTILS.scrambleS(player.alias) : player.alias) + (player.clan ? "<span style='color:" + COLORS.getClanCol(player.clan, "#fff") + "'> [" + player.clan + "]</span>" : "") + "</div>";
      vA650[v11957] += "</div>";
      vA650[v11957] += "</td>";
      for (var vLN02014 = 0; vLN02014 < v11955.length; vLN02014++) {
        vA650[v11957] += "<td>" + UTILS.formatNum(p14684[vLN02012 + 1 + vLN02014], 2) + "</td>";
      }
      vA650[v11957] += "</tr>";
      vA649[v11957]++;
    }
  }
  var vLS103 = "";
  for (var v11959 in vA650) {
    vA650[v11959] += vA649[v11959] <= 1 ? "<div class='newLeaderNoPlayers'>No players</div>" : "</table>";
    vLS103 += "<div class=\"centerLeaderContainer\"><div class=\"centerLeaderContainerInner\">" + vA650[v11959] + "</div></div>";
  }
  centerLeaderDisplay.innerHTML = vLS103;
}
function io_updateLeaders(p14685) {
  latestLeaderboardData = p14685;
  if (p14685) {
    f1984(p14685);
    f1985(p14685);
  }
}
function f1987(p14686) {
  var v11960 = SETTINGS.tmp.scoreBoardTrigger;
  var v11961 = centerLeaderDisplay.style.display != "none";
  if (v11960 == 0) {
    p14686 = p14686 == 1 ? ~~!v11961 : ~~!!v11961;
  }
  centerLeaderDisplay.style.display = p14686 ? "inline-grid" : "none";
}
function f1988(p14687) {
  if (p14687 && (!p14687.minimapTimer || p14687.minimapTimer < config.playerBlipTimer / 2)) {
    p14687.minimapTimer = config.playerBlipTimer;
    p14687.minimapPos = {
      x: p14687.x,
      y: p14687.y,
      z: p14687.z
    };
  }
}
function io_showTracer(p14688) {
  if (tmpPlayer && tmpPlayer.active || window.spectating) {
    var v11962 = p14688[1];
    var v11963 = p14688[2];
    var v11964 = p14688[3];
    var v11965 = p14688[4];
    var v11966 = p14688[5];
    var v11967 = p14688[6];
    var v11968 = p14688[7];
    var v11969 = p14688[8];
    var v11970 = p14688[9];
    var v11971 = p14688[10];
    player = Game.players.findBySid(p14688[0]);
    if (player && !player.isYou && Game && Game.hidePlayers && !player.isBot) {
      return;
    }
    f1988(player);
    if (player && PARTICLES.showTracers) {
      if (!player.latestData) {
        var v11976 = v11969 + v11970 - config.cameraHeight - player.crouchVal * config.crouchDst;
        var v11977 = UTILS.getD3D(v11968, v11976, v11971, v11962, v11963, v11964);
        var v11978 = UTILS.getDir(v11971, v11968, v11964, v11962);
        var v11979 = UTILS.getDir(UTILS.getDistance(v11968, v11971, v11962, v11964), v11963, 0, v11976);
        PARTICLES.physObj(v11968, v11976, v11971, v11978, v11979, v11977, v11967, 0);
      } else {
        var v11976 = player.y + player.height - config.cameraHeight - player.crouchVal * config.crouchDst;
        var v11977 = UTILS.getD3D(player.x, v11976, player.z, v11962, v11963, v11964);
        var v11978 = UTILS.getDir(player.z, player.x, v11964, v11962);
        var v11979 = UTILS.getDir(UTILS.getDistance(player.x, player.z, v11962, v11964), v11963, 0, v11976);
        PARTICLES.physObj(player.x, v11976, player.z, v11978, v11979, v11977, v11967, 0);
      }
    }
    if (v11965 != null && tmpPlayer && (player.latestData ? UTILS.getDistance(tmpPlayer.x, tmpPlayer.y, tmpPlayer.z, player.x, player.y, player.z) : UTILS.getDistance(tmpPlayer.x, tmpPlayer.y, tmpPlayer.z, v11968, v11969, v11971)) <= 160 && Game.canSee(tmpPlayer, v11962, v11963, v11964) == null) {
      PARTICLES.effect(v11962, v11963, v11964, v11965, v11966, 0);
      if (tmpPlayer) {
        SOUND.play3Dv("rico_" + UTILS.randInt(1, 2), v11962, v11963, v11964, 55, 0.55, 1, tmpPlayer);
      }
    }
  }
}
function io_endProjectile(p14689, p14690, p14691, p14692, p14693, p14694) {
  PARTICLES.disablePhys(p14689, p14690, p14694, p14691, p14692, p14693);
  if (p14694) {
    PARTICLES.effect(p14691, p14692, p14693, 0, 0, 0);
  }
}
function io_showBombardment(p14695) {
  if (!v10529) {
    var v11980 = Game.projectiles.stored[2];
    for (var vLN02015 = 0; vLN02015 < p14695.length; vLN02015 += 5) {
      PARTICLES.physObj(p14695[vLN02015], p14695[vLN02015 + 1], p14695[vLN02015 + 2], 0, v11980.yD, v11980.range, 1, null, null, v11980, p14695[vLN02015 + 3], null, p14695[vLN02015 + 4]);
    }
  }
}
function io_showProjectile(p14696, p14697, p14698, p14699, p14700, p14701, p14702, p14703, p14704, p14705) {
  if (!v10529) {
    var vP14704 = p14704;
    var v11981;
    if (p14703) {
      v11981 = Game.projectiles.stored[p14701];
    } else {
      v11981 = Game.weaponConfig[p14701].projectile;
      vP14704 = Game.weaponConfig[p14701].customProj;
    }
    if (v11981) {
      PARTICLES.physObj(p14696, p14697, p14698, p14699, p14700, v11981.range, false, null, null, v11981, p14702, null, vP14704);
    }
    if (p14705 != null) {
      f1988(Game.players.findBySid(p14705));
    }
  }
}
function io_explosion(p14706, p14707, p14708, p14709, p14710, p14711) {
  if (!v10529 && SETTINGS.tmp.showExplo && (tmpPlayer || window.spectating)) {
    player = RENDER.camera.getWorldPosition(RENDER.targetVector);
    var v11982 = UTILS.getD3D(p14706, p14707, p14708, player.x, player.y, player.z);
    var v11983 = 1 - v11982 / config.explosionRange;
    if (v11983 > 0) {
      RENDER.shake(v11983 * 0.14);
    }
    SOUND.play3D("explosion", p14706, p14707, p14708, 1);
    PARTICLES.ExplosionManager.explodeAt(p14706, p14707, p14708, p14709 * 0.08, p14710, p14711);
  }
}
function io_teamScore(p14712, p14713) {
  p14713 = p14713 || 0;
  if (p14712 == null || p14712 == null) {
    Game.teamScores = {};
    teamScores.innerHTML = "";
    f1996();
  } else {
    if (teamScores.style.display != "inline-block") {
      teamScores.style.display = "inline-block";
    }
    Game.teamScores[p14712] = p14713;
    var v11984 = document.getElementById("tScoreV" + p14712);
    if (v11984) {
      v11984.textContent = p14713;
      var v11985 = document.getElementById("specScoreTm" + (p14712 - 1));
      if (v11985) {
        v11985.textContent = p14713;
      }
    } else {
      f1996();
    }
  }
}
function f1995(p14714, p14715) {
  roundsDisplay.style.display = Game.config.gamRounds > 1 && !window.spectating ? "inline-block" : "none";
  if (p14714 != null) {
    var v11987 = document.getElementById("roundTSc" + p14714);
    if (v11987) {
      v11987.textContent = p14715;
    }
    v11987 = document.getElementById("compT" + p14714 + "Scr");
    if (v11987) {
      v11987.textContent = p14715;
    }
  } else {
    var v11987 = document.getElementById("roundTSc1");
    if (v11987) {
      v11987.textContent = 0;
    }
    v11987 = document.getElementById("roundTSc2");
    if (v11987) {
      v11987.textContent = 0;
    }
    v11987 = document.getElementById("compT1Scr");
    if (v11987) {
      v11987.textContent = 0;
    }
    v11987 = document.getElementById("compT2Scr");
    if (v11987) {
      v11987.textContent = 0;
    }
  }
}
function f1996() {
  if (Game.mode.teams && Object.keys(Game.teamScores).length) {
    teamScores.style.display = "inline-block";
    specHeaderTm0.style.display = "block";
    specHeaderTm1.style.display = "block";
    var vLS104 = "";
    for (var v11988 in Game.teamScores) {
      vLS104 += Game.mode.flags ? "<div class='tScore'><span class='tScoreT' id='tScoreV" + v11988 + "'>" + (Game.teamScores[v11988] || 0) + "</span><i class='material-icons tScoreF' id='tScoreF" + v11988 + "'>flag</i><span class='tScoreM' id='tScoreM" + v11988 + "'>" + (Game.teamFlags[v11988] || "AT BASE") + "</span></div>" : "<div class='tScore'><div id='tScoreC" + v11988 + "' class='tScoreC'></div><span class='tScoreT' id='tScoreV" + v11988 + "'>" + (Game.teamScores[v11988] || 0) + "</span></div>";
      var v11989 = document.getElementById("specScoreTm" + (v11988 - 1));
      if (v11989) {
        v11989.textContent = Game.teamScores[v11988];
      }
    }
    teamScores.innerHTML = vLS104;
  } else {
    teamScores.style.display = "none";
  }
  if (tmpPlayer) {
    var v11990 = document.getElementById((Game.mode.flags ? "tScoreF" : "tScoreC") + tmpPlayer.team);
    if (v11990) {
      v11990.className = (Game.mode.flags ? "material-icons tScoreF" : "tScoreC") + " you";
    }
  }
}
function io_captureControl(p14716, p14717) {
  Game.updateDomZone(p14716, p14717, 0, p14717, [p14717], 1);
  var v11991 = tmpPlayer && tmpPlayer.team ? tmpPlayer.team : window.spectating ? 1 : 0;
  var v11992 = p14717 == v11991 ? COLORS.killFeed.ally : COLORS.killFeed.enemy;
  var v11993 = config.alphabet[p14716 || 0] || "";
  io_addChat(-1, null, "<span style='color:" + v11992 + "'>" + UTILS.fixStr("Zone " + v11993 + " Captured") + "</span>", 1);
}
function io_updateDomZone(p14718) {
  for (var vLN02016 = 0; vLN02016 < p14718.length; vLN02016 += 6) {
    Game.updateDomZone(p14718[vLN02016], p14718[vLN02016 + 1], p14718[vLN02016 + 2], p14718[vLN02016 + 3], p14718[vLN02016 + 4], p14718[vLN02016 + 5]);
  }
}
function io_updateFlagInfo(p14719, p14720) {
  Game.teamFlags[p14719] = p14720;
  var v11994 = document.getElementById("tScoreM" + p14719);
  if (v11994) {
    v11994.textContent = p14720;
  } else {
    f1996();
  }
}
function io_getScore(p14721, p14722, p14723, p14724) {
  p14721 = p14721 || 0;
  if (!p14723) {
    pendingScorePopupValue += p14721;
    overlay.animateText(overlay.scoreText, (pendingScorePopupValue > 0 ? "+" : "") + pendingScorePopupValue, SETTINGS.tmp.scoreScale * 100, 0.38, 1100, 100, 0, function () {
      pendingScorePopupValue = 0;
    });
  }
  if (!p14722 && tmpPlayer && (tmpPlayer.score = p14721 + (p14723 ? 0 : tmpPlayer.score), myScoreVal.textContent = tmpPlayer.score, p14724 != null)) {
    var v11995 = !!Game.mode && Game.mode.randClassScr != null;
    var v11996 = Math.floor(p14721 * (Game && Game.isDoubleClassXP ? 2 : 1) * (v11995 ? Game.mode.randClassScr : 1));
    if (!tmpPlayer.classScores) {
      tmpPlayer.classScores = [];
    }
    if (!tmpPlayer.classScores[p14724 || 0]) {
      tmpPlayer.classScores[p14724 || 0] = 0;
    }
    tmpPlayer.classScores[p14724 || 0] += v11996;
  }
}
function io_textPopup(p14725, p14726, p14727, p14728) {
  if (!p14727) {
    SOUND.play("pop_3", 0.3);
  }
  if (p14725) {
    overlay.animateText(overlay.infoText, p14725, 90, 0.3, 2100, 100, 0, function () {}, 0.6, 10);
  }
  if (p14726) {
    overlay.animateText(overlay.infoSub, p14726, p14728 || 28, 0.1, 1500, 100, 0, function () {}, 0.9, 8);
  }
}
function f2002(p14729) {
  if (p14729) {
    SOUND.play("cntd_" + p14729, 0.2);
    overlay.animateText(overlay.timerText, p14729, 300, 1.2, 700, 100, 0, function () {}, null, 15);
  }
}
function io_checkPointSet(p14730) {
  if (p14730) {
    if (tmpPlayer) {
      tmpPlayer.checkPoint = null;
      tmpPlayer.checkPointList.length = 0;
      tmpPlayer.checkPointData.length = 0;
    }
    return;
  }
  SOUND.play("bhop_check", 0.9);
  if (SETTINGS.tmp.showMedals) {
    overlay.animateText(overlay.checkText, i18n.t("popup.checkpoint"), 75, 0.38, 1100, 100, 0, null);
  }
}
function io_changePosition(p14731, p14732, p14733, p14734, p14735, p14736, p14737) {
  player = Game.players.findById(p14731);
  if (player) {
    Game.players.changePosition(player, p14732, p14733, p14734, p14735, p14736, p14737);
  }
}
function io_updateLives(p14738) {
  player = document.getElementById("livesDisp");
  if (player) {
    player.textContent = p14738;
  }
}
var vA651 = [];
function io_getKill(p14739, p14740, p14741, p14742) {
  if (tmpPlayer) {
    tmpPlayer.killsC += p14742 || 1;
  }
  currentKillStreak += p14742 || 1;
  io_addMedal(p14739);
  if (p14740 && p14740 != -1) {
    SOUND.play(UTILS.isNumber(p14740) ? config.networkSounds[p14740] : p14740);
  }
  killsVal.textContent = p14741;
  streakVal.textContent = currentKillStreak;
  kdVal.textContent = ((p14741 || 0) / (parseInt(deathsVal.textContent) || 1)).round(1).toString();
}
function io_getAssist() {
  io_addMedal([31, config.assistScore, 0, 1]);
}
function io_addMedal(p14743, p14744) {
  if ((!Game || !Game.isComp) && p14743) {
    var v11997 = vA651.length == 0;
    for (var vLN02017 = 0, v11998; vLN02017 < p14743.length; vLN02017 += 4) {
      v11998 = p14743[vLN02017 + 3] || 1;
      if (p14743[vLN02017] != "") {
        if (!SETTINGS.tmp.classicMedals) {
          var v11999 = overlay.divs.find(p14745 => p14745 && p14745.medal && p14745.index == p14743[vLN02017]);
          if (v11999) {
            v11999.count += v11998;
            v11999.life = config.medalAnim;
          } else {
            var v12000 = vA651.find(p14746 => p14746 && p14746[0] == p14743[vLN02017]);
            if (v12000) {
              v12000[3] += v11998;
            } else {
              vA651.push([p14743[vLN02017], p14743[vLN02017 + 1], p14743[vLN02017 + 2], 1]);
            }
          }
        } else {
          vA651.push([p14743[vLN02017], p14743[vLN02017 + 1], p14743[vLN02017 + 2], 1]);
        }
      }
    }
    if (v11997) {
      f2009(config.medalDelay);
    }
  }
}
var vA652 = ["Reward", "Spent"];
function f2009(p14747) {
  if (vA651.length > 0 && vA651[0].length > 0) {
    if (!SETTINGS.tmp.showMedals && vA652.indexOf(vA651[0][0]) == -1) {
      return;
    }
    if (!SETTINGS.tmp.classicMedals && UTILS.isNumber(vA651[0][0]) && overlay.medalsList[vA651[0][0]]) {
      overlay.animateMedalNew(overlay.medalPrefab, vA651[0][0], vA651[0][1] ? (vA651[0][1] > 0 ? "+" : "") + vA651[0][1] : null, vA651[0][2], vA651[0][3], config.medalAnim, 50, p14747, function () {
        vA651.splice(0, 1);
        f2009(0);
      });
    } else {
      var v12001 = UTILS.isNumber(vA651[0][0]) ? overlay.medalsList[vA651[0][0]] || vA651[0][0] : vA651[0][0];
      overlay.animateMedal(overlay.chalName, v12001, vA651[0][1] ? (vA651[0][1] > 0 ? "+" : "") + vA651[0][1] : null, 130, 0.4, config.medalAnim, 100, p14747, function () {
        vA651.splice(0, 1);
        f2009(0);
      });
    }
  }
}
function io_updateProp(p14748, p14749, p14750, p14751) {
  player = Game.players.findBySid(p14748);
  if (player && !p14750) {
    Game.players.updateProp(player, p14749, true);
  }
  if (player && player.isYou) {
    var v12002 = overlay.propList.findIndex(p14752 => p14752.id = p14749);
    overlay.propWheelIndex = v12002 > -1 ? v12002 : 0;
    if (p14751 == null) {
      return;
    }
    if (p14751 == null) {
      io_addChati18n(-1, null, "modes.prophunt.limit", 2);
    } else {
      player.propSwitches = p14751;
      io_addChati18n(-1, null, ["modes.prophunt.left", Game.mode.propSwitches - player.propSwitches], 2);
    }
  }
}
function io_updatePropRot(p14753, p14754, p14755, p14756) {
  player = Game.players.findBySid(p14753);
  if (player) {
    player.propRot = p14754;
    player.propRotSaved = p14755;
    if (player.isYou) {
      if (p14756) {
        io_addChati18n(-1, null, "modes.prophunt.rotation.reset", 2);
      } else {
        io_addChati18n(-1, null, "modes.prophunt.rotation." + (p14754 ? "on" : "off"), 2);
      }
    }
  }
}
function io_interProg(p14757) {
  overlay.interactProg.display = p14757 && p14757 > 0;
  overlay.interactProg.prog = p14757 || 0;
}
function io_interMProg(p14758, p14759) {
  overlay.interactMProg.display = p14758 && p14758 > 0 || p14759;
  overlay.interactMProg.prog = p14758 || 0;
}
function f2014(p14760) {
  bhHolder.children[0].style.width = "calc(40px * " + player.headMlt + ")";
  bhHolder.children[0].style.height = "calc(40px * " + player.headMlt + ")";
}
function io_updateHeadSize(p14761, p14762, p14763) {
  player = Game.players.findBySid(p14761);
  if (player) {
    Game.players.updateHeadSize(player, p14762, p14763);
    if (player.isYou) {
      f2014(player.headMlt);
    }
    if (player.isYou && classPreviewPlayer) {
      Game.players.updateHeadSize(classPreviewPlayer, p14762, p14763);
    }
  }
}
var vLN02018 = 0;
var vLN02019 = 0;
var vLN02020 = 0;
function io_changeHealth(p14764, p14765, p14766, p14767, p14768, p14769) {
  if ((tmpPlayer || window.spectating) && (player = p14765 == null || p14765 == null ? tmpPlayer : Game.players.findBySid(p14765), player)) {
    player.health = p14764;
    if (player.health > player.maxHealth || p14769) {
      player.maxHealth = player.health;
      if (p14769) {
        player.hpChase = player.health / player.maxHealth;
      }
    }
    f1767(p14765, "HP", Math.ceil(player.health));
    f1767(p14765, "MHP", player.maxHealth);
    var v12003 = p14764 / player.maxHealth;
    if (player == tmpPlayer && tmpPlayer) {
      bottomLeftHealth.textContent = Math.ceil(p14764);
      var v12004 = tmpPlayer.config.segs;
      if (p14764 != vLN02018 || p14769 || p14768 || vLN02019 != v12004) {
        var vLS105 = "";
        vLN02019 = v12004;
        var v12005 = v12004 * v12003;
        var vV12005 = v12005;
        for (var vLN02021 = 0; vLN02021 < v12004; ++vLN02021) {
          var v12006 = Math.max(0, Math.min(1, vV12005)) * 100;
          var v12007 = v12005 <= 3 ? SETTINGS.tmp.hudHealthLow : SETTINGS.tmp.hudHealthHigh;
          vLS105 += "<div class='nHealthBarSeg'><div class='nHpBSeg' style='width:" + v12006 + "%;background-color:" + v12007 + ";color:" + v12007 + "'></div></div>";
          vV12005 -= 1;
        }
        bottomLeftHealthBar.innerHTML = vLS105;
      }
      if (SETTINGS.tmp.useDamageOverlay) {
        if (overlay.bloodCustom) {
          bloodDisplay.style.display = v12003 <= 0.8 ? "block" : "none";
          bloodDisplay.style.opacity = 1 - v12003 / 0.8;
        } else {
          overlay.bloodOpacity = 1 - v12003 / 0.8;
        }
      }
      if (p14764 < vLN02018 && !p14768) {
        if (p14766 != null && p14766 != null) {
          f2017(p14766, p14767);
        }
        if (Game.now - vLN02020 > 500) {
          RENDER.shake(0.02);
          SOUND.play("takedmg_" + UTILS.randInt(0, 1), 0.45);
        }
        vLN02020 = Game ? Game.now : 0;
      }
      vLN02018 = p14764;
    }
  }
}
function f2017(p14770, p14771) {
  if (overlay.showHits) {
    var v12008 = null;
    for (var vLN02022 = 0; vLN02022 < overlay.hits.length; ++vLN02022) {
      if (!overlay.hits[vLN02022].life) {
        v12008 = overlay.hits[vLN02022];
        break;
      }
    }
    if (!v12008) {
      v12008 = {};
      overlay.hits.push(v12008);
    }
    v12008.life = config.hitLife;
    v12008.x = p14770;
    v12008.z = p14771;
  }
}
var vLN02023 = 0;
window.switchChat = function (p14772) {
  playSelect(0.1);
  var v12009 = p14772.getAttribute("data-tab") == "public" ? 0 : 1;
  var v12010 = true;
  if (!Game || !Game.mode || !Game.mode.teams) {
    v12009 = 1;
    v12010 = false;
  }
  p14772.setAttribute("data-tab", v12009 ? "public" : "groups");
  v12009 = ~~!v12009;
  chatList.childNodes.forEach(p14773 => {
    var vParseInt43 = parseInt(p14773.getAttribute("data-tab"));
    p14773.style.display = vParseInt43 == v12009 || vParseInt43 == -1 ? "" : "none";
  });
  if (v12010) {
    io_addChat(-1, null, (v12009 ? "Team" : "Global") + " Text & Voice Chat", 2);
  }
  vLN02023 = v12009;
};
function f2018(p14774, p14775, p14776, p14777, p14778) {
  for (p14778 = p14778 || 0; chatList.childNodes.length >= config.chatListLength;) {
    var v12011 = chatList.childNodes[0];
    chatAndFeedItems[parseInt(v12011.id.replace("chatMsg_", ""))].life = 0;
    chatList.removeChild(v12011);
  }
  var v12012 = null;
  var v12013 = null;
  for (var vLN02024 = 0; vLN02024 < chatAndFeedItems.length; ++vLN02024) {
    if (!chatAndFeedItems[vLN02024].life && !chatAndFeedItems[vLN02024].elm) {
      v12012 = chatAndFeedItems[vLN02024];
      v12013 = vLN02024;
      break;
    }
  }
  if (!v12012) {
    v12012 = {};
    v12013 = chatAndFeedItems.length;
    chatAndFeedItems.push(v12012);
  }
  if (v12012.elm) {
    v12012.elm.remove();
  }
  v12012.type = 0;
  v12012.life = SETTINGS.tmp.chatTimer * 1000;
  tempDomElement = document.createElement("div");
  tempDomElement.style.display = p14778 == vLN02023 || p14778 == -1 ? "" : "none";
  tempDomElement.setAttribute("data-tab", p14778);
  tempDomElement.id = "chatMsg_" + v12013;
  tempDomElement.innerHTML = "<div class='chatItem" + (p14775 && p14775.length ? " " + p14775 : "") + "'" + (p14776 && p14776.length ? " style='" + p14776 + "'" : "") + ">" + p14774 + "</div><br>";
  v12012.elm = tempDomElement;
  chatList.insertAdjacentElement("beforeend", v12012.elm);
  chatList.scrollTop = chatList.scrollHeight - chatList.clientHeight;
}
function updateExpiringChatMessages(p14779) {
  for (var vLN02025 = 0; vLN02025 < chatAndFeedItems.length; vLN02025++) {
    if (chatAndFeedItems[vLN02025].life) {
      chatAndFeedItems[vLN02025].life -= p14779;
      if (chatAndFeedItems[vLN02025].life <= 0) {
        if (chatAndFeedItems[vLN02025].elm) {
          chatAndFeedItems[vLN02025].elm.remove();
        }
        chatAndFeedItems[vLN02025].elm = null;
        chatAndFeedItems[vLN02025].life = 0;
      }
    }
  }
}
var v12014;
function f2020(p14780, p14781, p14782) {
  var v12015 = document.getElementById("tradeChatList");
  if (v12015) {
    while (v12015.childNodes.length >= config.chatListLength) {
      var v12016 = v12015.childNodes[0];
      v12015.removeChild(v12016);
    }
    v12014 = document.createElement("div");
    v12014.innerHTML = "<div class='tradeChatItem" + (p14781 && p14781.length ? " " + p14781 : "") + "'" + (p14782 && p14782.length ? " style='" + p14782 + "'" : "") + ">" + p14780 + "</div><br>";
    v12015.insertAdjacentElement("beforeend", v12014);
    v12015.scrollTop = v12015.scrollHeight - v12015.clientHeight;
  }
}
function io_addTradeChat(p14783, p14784, p14785, p14786) {
  v12017 = SETTINGS.tmp.chatBGOp == 0.2 ? "" : "background-color: rgba(0, 0, 0, " + SETTINGS.tmp.chatBGOp + ")";
  v12018 = SETTINGS.tmp.chatTextOutline ? "chatTextOutline" : "";
  if ((SETTINGS.tmp.streamMode || SETTINGS.tmp.chatFilter) && filter) {
    p14784 = UTILS.isString(p14784) ? filter.clean(p14784) : "";
  }
  if (SETTINGS.tmp.streamMode) {
    p14783 = UTILS.scrambleS(p14783);
  }
  p14784 = UTILS.fixStr(p14784);
  if (p14785 == 2) {
    f2020("<span class='chatMsg' style='color:" + (p14786 || "#fc03ec") + "'>" + p14784 + "</span>", v12018, v12017);
  } else {
    f2020(UTILS.fixStr(p14783 || "unknown") + ": <span class='chatMsg'>" + p14784 + "</span>", v12018, v12017);
  }
}
window.welcome = function (p14787) {
  io_addChat(-1, null, p14787, 2);
};
function io_addChati18n(p14788, p14789, p14790, p14791, p14792, p14793) {
  if (!Array.isArray(p14790)) {
    p14790 = [p14790];
  }
  p14790 = i18n.t(...p14790);
  io_addChat(p14788, p14789, p14790, p14791, p14792, p14793);
}
var v12017;
var v12018;
function io_addChat(p14794, p14795, p14796, p14797, p14798, p14799, p14800) {
  if (p14800 == null || !mutedChatAccountIds.includes(p14800)) {
    p14794 = p14794 || 0;
    if (!Game || !Game.mode || !Game.mode.teams) {
      p14794 = -1;
    }
    if (p14797 || SETTINGS.tmp.showMessages) {
      v12017 = SETTINGS.tmp.chatBGOp == 0.2 ? "" : "background-color: rgba(0, 0, 0, " + SETTINGS.tmp.chatBGOp + ")";
      v12018 = SETTINGS.tmp.chatTextOutline ? "chatTextOutline" : "";
      if ((SETTINGS.tmp.streamMode || SETTINGS.tmp.chatFilter) && filter && p14797 != 3) {
        p14796 = UTILS.isString(p14796) ? filter.clean(p14796) : "";
      }
      if (SETTINGS.tmp.streamMode && (!p14797 || !(p14797 < 3))) {
        p14795 = UTILS.scrambleS(p14795);
      }
      if (p14797 != 3) {
        p14796 = UTILS.fixStr(p14796);
      }
      if (p14797 == 1 || p14797 == 4) {
        f2018("<span class='chatMsg'>" + p14796 + "</span>", v12018, v12017, p14797, p14794);
      } else if (p14797 == 2) {
        f2018("<span class='chatMsg' style='color:" + (p14798 || "#fc03ec") + "'>" + p14796 + "</span>", v12018, v12017, p14797, p14794);
      } else if (p14797 == 3) {
        f2018(UTILS.fixStr(p14795 || "unknown") + " wants to trade <span class='tradeMsg' style='color:" + (p14798 || "#5ce05a") + "' onclick='acceptRequest(" + p14796 + ");this.innerHTML=`[Accepted]`;'>[Accept]</span>", v12018, v12017, p14797, p14794);
      } else {
        p14795 = UTILS.fixStr(p14795 || "unknown");
        if (p14799) {
          p14795 = "<span style='color:" + p14799 + "'>" + p14795 + "</span>";
        }
        f2018(p14795 + ": <span class='chatMsg'>" + p14796 + "</span>", v12018, v12017, p14797, p14794);
      }
    }
  }
}
var vA653 = [5, -10, 5, -7, 2, 5, 0, 2, 6, 6, 7, 5, 5, 0, -8, 10, 0, -6, 7, -28, -28, 5, 5, -5, 5, 5, 5, 5];
var v12019;
function f2024(p14801, p14802, p14803, p14804) {
  var v12020 = SETTINGS.tmp.leaderType == 0;
  if (v12020) {
    while (chatList.childNodes.length >= config.chatListLength) {
      var v12022 = chatList.childNodes[0];
      chatAndFeedItems[parseInt(v12022.id.replace("chatMsg_", ""))].life = 0;
      chatList.removeChild(v12022);
    }
    v12017 = SETTINGS.tmp.chatBGOp == 0.2 ? "" : "background-color: rgba(0, 0, 0, " + SETTINGS.tmp.chatBGOp + ")";
    v12018 = SETTINGS.tmp.chatTextOutline ? "chatTextOutline" : "";
  } else {
    while (killFeed.childNodes.length >= SETTINGS.tmp.feedLimit) {
      var v12022 = killFeed.childNodes[0];
      chatAndFeedItems[parseInt(v12022.id.replace("feed_", ""))].life = 0;
      killFeed.removeChild(v12022);
    }
  }
  if ((SETTINGS.tmp.streamMode || SETTINGS.tmp.chatFilter) && filter) {
    p14804 = UTILS.isString(p14804) ? filter.clean(p14804) : "";
    p14803 = UTILS.isString(p14803) ? filter.clean(p14803) : "";
  }
  var v12023 = null;
  var v12024 = null;
  for (var vLN02026 = 0; vLN02026 < chatAndFeedItems.length; ++vLN02026) {
    if (!chatAndFeedItems[vLN02026].life && !chatAndFeedItems[vLN02026].elm) {
      v12023 = chatAndFeedItems[vLN02026];
      v12024 = vLN02026;
      break;
    }
  }
  if (!v12023) {
    v12023 = {};
    v12024 = chatAndFeedItems.length;
    chatAndFeedItems.push(v12023);
  }
  if (v12023.elm) {
    v12023.elm.remove();
  }
  v12023.type = v12020 ? 0 : 1;
  v12023.life = v12020 ? SETTINGS.tmp.chatTimer * 1000 : 4000;
  var v12025 = v12020 ? "chat" : "killfeed";
  tempDomElement = document.createElement("div");
  tempDomElement.id = (v12020 ? "chatMsg_" : "feed_") + v12024;
  if (p14801 == null) {
    tempDomElement.innerHTML = "<div class='" + v12025 + "Item" + (v12018 && v12018.length && v12020 ? " " + v12018 : "") + "'" + (v12017 && v12017.length && v12020 ? " style='" + v12017 + "'" : "") + "><span class='" + v12025 + "Msg'>" + p14804 + "</span></div><br>";
  } else {
    v12019 = Game.weaponConfig[p14802.wId == null ? p14801.loadout[p14801.loadoutIndex] : p14802.wId];
    var v12026 = "<div class='" + v12025 + "Item" + (v12018 && v12018.length && v12020 ? " " + v12018 : "") + "'" + (v12017 && v12017.length && v12020 ? " style='" + v12017 + "'" : "") + ">";
    v12026 += "<span class='" + v12025 + "Msg'>" + p14803;
    if (p14802.stk != null) {
      v12026 += "<img class='streakChatIcon' src='" + UTILS.assetsUrl("/img/streaks/" + (p14802.stk == 1 && p14802.pkg ? "package/" + p14802.pkg : p14802.stk) + ".png") + "' />";
    } else if (p14802.fs) {
      v12026 += "<img class='fistChatIcon' src='" + UTILS.assetsUrl("/textures/weapons/icon_0.png") + "' />";
    } else if (v12019.melee) {
      var v12027 = Game.store.skins[p14801.meleeIndex];
      if (p14802.pj) {
        v12026 += "<img class='thrownChatIcon' src='./img/thrown_0.png'>";
      }
      v12026 += "<img style='opacity:0.7;margin-right:" + vA653[v12027 ? v12027.id || 0 : 0] + "px;' class='meleeChatIcon' src='" + UTILS.assetsUrl("/textures/melee/icon_" + (v12027 ? v12027.id || 0 : 0) + ".png") + "' />";
    } else {
      v12026 += "<img style='opacity:0.7;margin-right:" + (v12019.icnPad || 0) + "px;' class='weaponChatIcon' src='" + UTILS.assetsUrl("/textures/weapons/" + v12019.icon + ".png") + "' />";
    }
    if (p14802.wb) {
      v12026 += "<img class='headShotChatIcon' src='./img/wallbang_0.png'>";
    }
    if (p14802.hs) {
      v12026 += "<img class='headShotChatIcon' src='./img/headshot_0.png'>";
    }
    v12026 += p14804 + "</span></div><br>";
    tempDomElement.innerHTML = v12026;
  }
  v12023.elm = tempDomElement;
  (v12020 ? chatList : killFeed).insertAdjacentElement("beforeend", v12023.elm);
  if (v12020 && inGame) {
    chatList.scrollTop = chatList.scrollHeight - chatList.clientHeight;
  }
}
function io_doDamage(p14805, p14806, p14807, p14808, p14809, p14810) {
  if (!p14810) {
    SOUND.play(p14807 ? "crit_0" : "hit_0", 3.1);
  }
  if (overlay.hitmarker.custom) {
    DIV.animateDiv(hitmarker, 350, 100, 105);
  } else if (overlay.hitmarker.image) {
    overlay.animateDiv(overlay.hitmarker, 350, 100, 105);
  } else {
    overlay.showHit(!!p14808);
  }
  if (SETTINGS.tmp.dmgType == 0) {
    p14806 = Math.ceil(p14806);
  }
  if (p14806 && p14805 != null) {
    if (p14809) {
      var v12029 = Game.AI.findBySid(p14805);
      if (v12029) {
        overlay.dmgVal(v12029.x, v12029.y, v12029.z, p14806, p14807, p14806 < 0);
      }
    } else {
      var v12029 = Game.players.findBySid(p14805);
      if (v12029) {
        overlay.dmgVal(v12029.x, v12029.y, v12029.z, p14806, p14807, p14806 < 0);
      }
    }
  }
}
function f2026(p14811) {
  var v12030 = p14811.loadout[p14811.loadoutIndex];
  if (Game.weaponConfig[v12030].melee) {
    setSetting("showWeaponMel", !SETTINGS.tmp.showWeaponMel);
  } else if (Game.weaponConfig[v12030].secondary) {
    setSetting("showWeaponSec", !SETTINGS.tmp.showWeaponSec);
  } else if (!Game.weaponConfig[v12030].melee && !Game.weaponConfig[v12030].secondary) {
    setSetting("showWeapon", !SETTINGS.tmp.showWeapon);
  }
}
function f2027(p14812) {
  var v12031 = CONTROLS.toggleSets[p14812];
  if (SETTINGS.list[v12031]) {
    setSetting(v12031, !SETTINGS.list[v12031].val);
  }
}
window.filterCM = function (p14813) {
  p14813 += "";
  p14813 = p14813 === null ? "" : p14813;
  p14813 = p14813 && p14813.replace ? p14813.replace(/[><]/g, "") : p14813;
  if (p14813 == "undefined") {
    p14813 = "";
  }
  if (p14813 && p14813.replace) {
    p14813 = p14813.replace(/\u0027/g, "").replace(/\u0022/g, "");
  }
  return p14813;
};
var lastMsgTime = 0;
function f2028(p14814) {
  var v12032 = CONTROLS.chatMessages[p14814];
  if (v12032 && v12032.length) {
    if (Date.now() - lastMsgTime <= 1500) {
      return;
    }
    f1909(v12032);
    lastMsgTime = Date.now();
  }
}
function io_createSpawnable(p14815, p14816, p14817, p14818, p14819, p14820, p14821) {
  Game.createSpawnable(p14815, p14816, p14817, p14818, p14819, p14820, p14821, tmpPlayer);
}
window.autoloadMod = function (p14822, p14823) {
  var v12033 = windows[3].listData[windows[3].tabIndex].list.find(p14824 => p14824.mod_id == p14822);
  if (v12033) {
    var v12034 = "<div style='font-size:20px;color:#fff'>Autoload - " + v12033.mod_name + "?</div><div class='mapFndB' onclick='windows[3].autoload(" + p14822 + ",1)' onmouseover='playTick(0.1)' style='background-color:#fc5a4e'>Add</div><div class='mapFndB' onclick='windows[3].autoload(" + p14822 + ",0)' onmouseover='playTick(0.1)' style='margin-left:16px;background-color:#4ca9f5'>Remove</div>";
    genericPopup(v12034, "autoLoadPop");
  }
};
window.favoriteM = function (p14825, p14826, p14827) {
  if (account) {
    var v12035 = p14826.classList.contains("sel");
    p14826.classList.toggle("sel", !v12035);
    p14826.innerHTML = v12035 ? "<span class='material-icons' style='font-size:50px;color:#fff;'>star</span>" : "<span class='material-icons' style='font-size:50px;color:#fff;'>star_border</span>";
    io.send("fvM", p14825, p14827, !!v12035);
  }
};
window.playMap = function (p14828) {
  window.open("/?play=" + p14828, "_self");
};
window.openEdit = function (p14829, p14830, p14831) {
  var v12036 = "<div class='pubHed' style='text-align:left!important'>" + p14829 + "<div style='float:right' class='editLink' onclick='grabMap(&quot;" + p14829 + "&quot;)'>Open in Editor</div></div><div></div><div style='margin-top:25px;font-size:18px;color:#fff'>Funds <span style='float:right;color:rgba(255,255,255,0.5)'>" + UTILS.commaFormatNum(p14831 || 0) + " <span style='color:#fff'>KR</span></span></div><div style='font-size:18px;color:#fff'>KR Fee <span id='mapFeeVal' style='float:right;color:rgba(255,255,255,0.5)'>None</span></div><input type='number' oninput='calcMapFee(this)' id='mapFundsInp' placeholder='Enter KR Amount'></input><div class='mapFndB' onclick='chngMapFunds(" + p14830 + ", 1)' onmouseover='playTick(0.1)' style='background-color:#fc5a4e'>Withdraw</div><div class='mapFndB' onclick='chngMapFunds(" + p14830 + ", 0)' onmouseover='playTick(0.1)' style='margin-left:16px;background-color:#4ca9f5'>Deposit</div>";
  genericPopup(v12036, "editMapPop");
};
window.calcMapFee = function (p14832) {
  if (p14832) {
    var v12037 = p14832.value || 0;
    if (v12037 < 0) {
      v12037 = 0;
    }
    if (v12037) {
      p14832.value = v12037;
    }
    var v12038 = Math.floor(v12037 * 0.1);
    p14832 = document.getElementById("mapFeeVal");
    if (p14832) {
      p14832.innerHTML = v12038 ? "<span style='color:rgba(255,255,255,0.7)'>-" + UTILS.commaFormatNum(v12038) + " <span style='color:#fff'>KR</span></span>" : "None";
    }
  }
};
window.chngMapFunds = function (p14833, p14834) {
  var v12039 = mapFundsInp.value || 0;
  if (v12039) {
    io_loadingPopup("Please Wait...");
    io.send("mfnds", p14833, p14834, parseInt(v12039));
  }
};
window.grabMap = function (p14835) {
  if (account) {
    io.send("edMp", p14835);
  }
};
function io_editMap(p14836) {
  if (p14836) {
    try {
      p14836 = JSON.parse(p14836);
      p14836.objects.forEach(p14837 => {
        if (p14837.col === false) {
          delete p14837.col;
        }
        if (p14837.l === false) {
          delete p14837.l;
        }
      });
      p14836 = JSON.stringify(p14836);
    } catch (e151) {}
    window.saveVal("mapToEdit", p14836);
    window.open("/editor.html", "_blank");
  }
}
window.pressButton = function (p14838, p14839, p14840) {
  if (sandboxGame && sandboxGame.isSandbox && CONTROLS.binds.spawnBot.isKey(p14838) && !sandboxGame.isBotFTUE) {
    sandboxGame.bots.add(null, true, false, {
      name: "Bot",
      dmgMlt: 0.01
    });
    io_addChat(-1, null, "Spawned a Bot", 2);
  }
  if (sandboxGame && sandboxGame.isSandbox && CONTROLS.binds.clearBots.isKey(p14838) && !sandboxGame.isBotFTUE) {
    sandboxGame.bots.reset();
    io_addChat(-1, null, "Cleared Bots", 2);
  }
  if (p14839 && Game && Game.mainScript && Game.mainScript.onKeyPress) {
    Game.mainScript.onKeyPress((p14839.key + "").toLowerCase(), p14839.which || p14839.keyCode || 0);
  }
  if (p14840 == "aim" || CONTROLS.binds.aim.isKey(p14838)) {
    if (CONTROLS.toggleADS[RENDER.getPlayerWeaponId(Game && Game.tmpPlayer ? Game.tmpPlayer : null)] && CONTROLS.adsToggled) {
      CONTROLS.adsToggled = false;
    } else {
      CONTROLS.adsToggled = true;
    }
  }
  if (p14838 == 27) {
    if (!CONTROLS.UsePointerLock) {
      CONTROLS.toggle(false);
      CONTROLS.resetKeys();
    }
    UI.toggleEndScreen();
  }
  if (activeKickVoteTargetAlias && tmpPlayer && tmpPlayer.active && kickVoteSubmittedAliases.indexOf(activeKickVoteTargetAlias) == -1) {
    if (CONTROLS.binds.kickVoteY.isKey(p14838)) {
      io.send("v2k", activeKickVoteTargetAlias, 1);
      kickVoteSubmittedAliases.push(activeKickVoteTargetAlias);
    } else if (CONTROLS.binds.kickVoteN.isKey(p14838)) {
      io.send("v2k", activeKickVoteTargetAlias);
      voteToKick.style.display = "none";
      kickVoteSubmittedAliases.push(activeKickVoteTargetAlias);
    }
  }
  if (window.spectating) {
    if (CONTROLS.binds.specMiniMap.isKey(p14838)) {
      setSetting("specMiniMap", !SETTINGS.list.specMiniMap.val);
    }
    if (CONTROLS.binds.specFree.isKey(p14838)) {
      spectMode();
    }
    if (CONTROLS.binds.specNames.isKey(p14838)) {
      showSpectatorNameTags = !showSpectatorNameTags;
    }
    if (CONTROLS.binds.specObj.isKey(p14838)) {
      if (!Game.mode.objective || !Object.keys(Game.map.manager.spectateCams).length) {
        return;
      }
      spectatingObjectiveCamera = true;
      spectateCameraInitialized = false;
      spectMode(-1);
    }
    if (p14838 == 48 && spectatingObjectiveCamera) {
      var v12043 = Game.map.manager.spectateCams[-1];
      var v12042 = v12043 ? v12043[0] : null;
      if (v12042 && v12042.active) {
        f1765();
        CONTROLS.spect.target = v12042;
      }
      spectateCameraInitialized = false;
    }
    if (p14838 > 48 && p14838 < 58) {
      var v12042 = null;
      if (spectatingObjectiveCamera) {
        var v12043 = Game.map.manager.spectateCams[Game.activeObjective || 0];
        v12042 = v12043 ? v12043[p14838 - 49] : null;
      } else {
        player = vA647[p14838 - 49];
        if (player) {
          v12042 = Game.players.list.find(p14841 => p14841.sid == player.player.sid);
        }
      }
      if (v12042 && v12042.active && (!v12042.isBot || v12042.isBot && !Game.mode.botsAsAI)) {
        f1765();
        CONTROLS.spect.target = v12042;
        spectateCameraInitialized = false;
        if (!spectatingObjectiveCamera) {
          io.send("fpSp", v12042.sid);
        }
        f1766();
      }
    }
    if (CONTROLS.binds.specFirst.isKey(p14838)) {
      f1764(!spectatorThirdPerson);
    }
    if (currentKpdCase) {
      if (CONTROLS.binds.kpdVoteN.isKey(p14838)) {
        updateKpdVerdictPrompt(-1);
      } else if (CONTROLS.binds.kpdVoteY.isKey(p14838)) {
        updateKpdVerdictPrompt(1);
      }
    }
    if (CONTROLS.binds.kpdVision.isKey(p14838) && account && (account.isMod || account.isDeputy) && currentKpdCase) {
      setSetting("kpdVision", !SETTINGS.list.kpdVision.val);
      io_addChat(-1, null, "KPD Vision " + (SETTINGS.tmp.kpdVision ? "Enabled" : "Disabled"), 2);
    }
    if (CONTROLS.binds.specFocus.isKey(p14838)) {
      if (CONTROLS.spect.target && CONTROLS.spect.target.id != focusedPlayerId) {
        focusPlayer(CONTROLS.spect.target.id, true);
      } else {
        clearFocus();
      }
    }
  }
  if (CONTROLS.binds.chat.isKey(p14838)) {
    if (window.tradeChatInput && document.activeElement == window.tradeChatInput) {
      if (window.tradeChatInput.value != "") {
        io.send("tct", window.tradeChatInput.value);
        window.tradeChatInput.value = "";
      }
      window.tradeChatInput.blur();
    } else if (document.activeElement == chatInput) {
      if (chatInput.value != "") {
        f1909(chatInput.value);
        chatInput.value = "";
      }
      chatInput.blur();
    } else if (window.tradeChatInput && document.activeElement != window.tradeChatInput && windows[36].active) {
      window.tradeChatInput.focus();
    } else if (document.activeElement != chatInput) {
      chatInput.focus();
    }
  }
  if (p14840 == "playerList" || CONTROLS.binds.playerList.isKey(p14838)) {
    if (document.activeElement.tagName == "INPUT") {
      return;
    }
    if (endUI.style.display == null) {
      return;
    }
    CONTROLS.resetKeys();
    if (CONTROLS.hasPointerlock) {
      CONTROLS.toggle(false);
    }
    requestAnimationFrame(() => showWindow(23), 0);
  }
  if (p14840 == "scoreBoard" || CONTROLS.binds.scoreBoard.isKey(p14838)) {
    f1987(1);
  }
  if (tmpPlayer && tmpPlayer.active) {
    if (CONTROLS.binds.sprayWheel.isKey(p14838) && (Game.isSandbox || account && account.premiumT > 0)) {
      overlay.propWheelClose();
      overlay.sprayWheelOpen();
    } else if (p14840 == "spray" || CONTROLS.binds.spray.isKey(p14838)) {
      if (Game.isSandbox) {
        sandboxGame.players.spray(tmpPlayer);
      } else {
        io.send("spry");
      }
    }
    if (tmpPlayer && Game && Game.mode && Game.mode.teamOptions && Game.mode.teamOptions[tmpPlayer.team - 1] == "Prop") {
      if (CONTROLS.binds.prop.isKey(p14838)) {
        overlay.sprayWheelClose();
        overlay.propWheelOpen();
      }
      if (CONTROLS.binds.propRand.isKey(p14838)) {
        var v12044 = overlay.pickRandomProp().id;
        if (tmpPlayer && tmpPlayer.propID != v12044) {
          io.send("prp", v12044);
        }
      }
      if (CONTROLS.binds.propRot.isKey(p14838)) {
        io.send("prpR");
      }
      if (CONTROLS.binds.propRotR.isKey(p14838)) {
        io.send("prpR", true);
      }
      for (var vLN02032 = 0; vLN02032 < CONTROLS.binds.taunt.length; vLN02032++) {
        if (CONTROLS.binds.taunt[vLN02032].isKey(p14838)) {
          io.send("prpt", vLN02032);
        }
      }
    }
    if (CONTROLS.binds.confirm.isKey(p14838) && UTILS.isNumber(tmpPlayer.pendingTrigger) && !UI.hidden) {
      io.send("cnfm");
      tmpPlayer.pendingTrigger = null;
    }
    if (CONTROLS.binds.confirm.isKey(p14838) && UTILS.isNumber(tmpPlayer.pendingSpin) && !UI.hidden) {
      io.send("cnfm", 2);
      tmpPlayer.pendingSpin = null;
    }
    if (p14840 == "interact" || CONTROLS.binds.interact.isKey(p14838)) {
      if (Game.isSandbox) {
        sandboxGame.players.interact(sandboxPlayer, tmpPlayer.lastInteractData.type, tmpPlayer.lastInteractData.id);
      } else {
        io.send("int", tmpPlayer.lastInteractData.type, tmpPlayer.lastInteractData.id);
      }
    }
    if (p14840 == "interactSec" || CONTROLS.binds.secondaryInteract.isKey(p14838)) {
      if (Game.isSandbox) {
        sandboxGame.players.interact(sandboxPlayer, tmpPlayer.lastInteractData.type, tmpPlayer.lastInteractData.id, true);
      } else {
        io.send("intSec", tmpPlayer.lastInteractData.type, tmpPlayer.lastInteractData.id);
      }
    }
    if (p14840 == "drop" || CONTROLS.binds.drop.isKey(p14838)) {
      if (Game.isSandbox) {
        sandboxGame.players.dropWeapon(sandboxPlayer);
      } else {
        io.send("drpw");
      }
    }
    if (p14840 == "inspect" || CONTROLS.binds.inspect.isKey(p14838)) {
      Game.players.wInspect(tmpPlayer);
    }
    for (var vLN02032 = 0; vLN02032 < CONTROLS.binds.streak.length; vLN02032++) {
      if (CONTROLS.binds.streak[vLN02032].isKey(p14838)) {
        window.callInStreak(vLN02032);
      }
    }
    if (p14840 == "wepvis" || CONTROLS.binds.wepVis.isKey(p14838)) {
      f2026(tmpPlayer);
    }
    for (var vLN02032 = 0; vLN02032 < CONTROLS.binds.toggle.length; vLN02032++) {
      if (CONTROLS.binds.toggle[vLN02032].isKey(p14838)) {
        f2027(vLN02032);
      }
    }
    for (var vLN02032 = 0; vLN02032 < CONTROLS.binds.message.length; vLN02032++) {
      if (CONTROLS.binds.message[vLN02032].isKey(p14838)) {
        f2028(vLN02032);
      }
    }
    for (var vLN02032 = 0; vLN02032 < CONTROLS.binds.premium.length; vLN02032++) {
      if (CONTROLS.binds.premium[vLN02032].isKey(p14838)) {
        io.send("prmA", vLN02032);
      }
    }
    if (CONTROLS.binds.hidePlayers.isKey(p14838)) {
      Game.hidePlayers = !Game.hidePlayers;
    }
    if (Game.isSandbox && !sandboxGame.isBotFTUE) {
      if (CONTROLS.binds.noclipSB.isKey(p14838)) {
        io_setNoclip(!sandboxPlayer.noclip);
      }
      if (CONTROLS.binds.godModeSB.isKey(p14838)) {
        f1959(!sandboxPlayer.godMode);
      }
      if (CONTROLS.binds.killSB.isKey(p14838)) {
        sandboxGame.players.kill(sandboxPlayer, null, null, true);
      }
    }
  }
};
window.releaseButton = function (p14842, p14843, p14844) {
  if (p14843 && Game && Game.mainScript && Game.mainScript.onKeyUp) {
    Game.mainScript.onKeyUp((p14843.key + "").toLowerCase(), p14843.which || p14843.keyCode || 0);
  }
  if (p14844 == "scoreboard" || CONTROLS.binds.scoreBoard.isKey(p14842)) {
    f1987(0);
  }
  if (CONTROLS.binds.sprayWheel.isKey(p14842) && (Game.isSandbox || account && account.premiumT > 0)) {
    if (Game.isSandbox) {
      sandboxGame.players.spray(sandboxPlayer, overlay.getSprayIndex().index);
    } else {
      io.send("spry", overlay.getSprayIndex().index);
    }
    overlay.sprayWheelClose();
  }
  if (CONTROLS.binds.prop.isKey(p14842) && tmpPlayer && Game && Game.mode && Game.mode.teamOptions && Game.mode.teamOptions[tmpPlayer.team - 1] == "Prop") {
    var v12045 = overlay.getPropIndex().id;
    if (tmpPlayer && tmpPlayer.propID != v12045) {
      io.send("prp", v12045);
    }
    overlay.propWheelClose();
  }
  if ((p14844 == "aim" || CONTROLS.binds.aim.isKey(p14842)) && !CONTROLS.toggleADS[RENDER.getPlayerWeaponId(Game && Game.tmpPlayer ? Game.tmpPlayer : null)]) {
    CONTROLS.adsToggled = false;
  }
};
var vLN02033 = 0;
var v12046 = false;
function io_kpdReset() {
  v12046 = false;
  updateKpdVerdictPrompt(0);
}
function updateKpdVerdictPrompt(kpdVerdictStep) {
  if (!v12046) {
    if (kpdVerdictStep == 0) {
      vLN02033 = 0;
    }
    vLN02033 += kpdVerdictStep;
    var v12047 = Game.players.list.find(p14846 => p14846.id == currentKpdCase.sus);
    var v12048 = v12047 ? v12047.name : "Suspect";
    if (vLN02033 == -1) {
      specKPDTxt.innerHTML = "Case submitted!<div>Suspect Not Tagged</div>";
      specKRHid.style.display = "none";
      io.send("rkpd", 0);
      v12046 = true;
    } else if (vLN02033 == 0) {
      specKPDTxt.innerHTML = "Is " + v12048 + " hacking?";
      specKRHid.style.display = "block";
    } else if (vLN02033 == 1) {
      specKPDTxt.innerHTML = "Are you 100% sure?";
      specKRHid.style.display = "block";
    } else if (vLN02033 == 2) {
      specKPDTxt.innerHTML = "Case submitted!<div>Suspect Tagged</div>" + (v12047 ? "<div>Profile URL Copied to Clipboard</div>" : "");
      specKRHid.style.display = "none";
      if (v12047) {
        UTILS.copyToClipboard("https://krunker.io/social.html?p=profile&q=" + v12048);
      }
      io.send("rkpd", 1);
      v12046 = true;
    }
  }
}
window.eventPopup = function () {
  let v12049 = UTILS.getActiveEvent(Game.eventIndex);
  if (v12049) {
    var v12050 = new Date(v12049.start).getTime() - Date.now();
    var v12051 = new Date(v12049.end).getTime() - Date.now();
    var v12052 = "<div class='eventPopHeader' style='background-image:url(" + UTILS.assetsUrl("/img/events/event_" + v12049.id + ".png") + ");'>" + ("<div class='eventPopName'>" + v12049.name + "</div></div>");
    var vA654 = [];
    var vLS106 = "";
    if (v12049.rewards && v12049.rewards.skins) {
      vLS106 += "<div class='eventPopSkinsH'>Earn these skins from completing challenges</div>";
      for (var vLN02035 = 0, v12053; vLN02035 < 12; ++vLN02035) {
        v12053 = Game.store.skins[v12049.rewards.skins[vLN02035]];
        if (v12053) {
          var v12054 = Game.store.rarities[v12053.rarity].color;
          if (v12053.type == itemTypes.SPRAY && v12053.frames && vA654.indexOf(v12053.frames) == -1) {
            vA654.push(v12053.frames);
          }
          vLS106 += "<div class='bundlItmC' style='background:url(" + v12053.thumbnail + ");" + (v12053.type == itemTypes.SPRAY && v12053.frames ? "background-size: cover !important;" + UTILS.getFrameAnim(v12053, "sprayAnmB") : "background-size: contain;background-position: center;") + "border: 3px solid " + v12054 + ";' onclick='viewItem(" + v12049.rewards.skins[vLN02035] + ")'></div>";
        } else {
          vLS106 += "<div class='bundlItmC' style='border: 3px solid #707070;'></div>";
        }
      }
    }
    if (vA654.length) {
      v12052 += "<style>";
      for (var vLN02035 = 0; vLN02035 < vA654.length; vLN02035++) {
        v12052 += "@keyframes sprayAnmB" + vA654[vLN02035] + " {100%{background-position:-" + vA654[vLN02035] * 81 + "px}}";
      }
      v12052 += "</style>";
    }
    v12052 += "<div class='eventPopInfoH'><div class='eventPopInfo'>" + v12049.longDesc + "</div>" + vLS106 + ("<div class='eventPopEnd'>" + (v12050 > 0 ? "Starts" : "Ends") + " in " + UTILS.getReadableTime(v12050 > 0 ? v12050 : v12051) + "</div>") + "</div>" + (v12049.noChallenges ? "" : "<div class='eventPopChallBtn' onclick='playSelect();logBtnFRVR(`challenges`);clearPops();windows[32].openHome()'>View Challenges</div>") + "</div>";
    genericPopup(v12052, "eventPop");
  }
};
AudioParam.prototype.setTargetAtTime = new Proxy(AudioParam.prototype.setTargetAtTime, {
  apply: function (p14847, p14848, [v12055, v12056, v12057]) {
    if (isFinite(v12055)) {
      p14847.apply(p14848, [v12055, v12056, v12057]);
    }
  }
});
AudioParam.prototype.setValueAtTime = new Proxy(AudioParam.prototype.setValueAtTime, {
  apply: function (p14849, p14850, [v12058, v12059]) {
    if (isFinite(v12058)) {
      p14849.apply(p14850, [v12058, v12059]);
    }
  }
});
var useRegularFrameRequest = true;
var oneTrustDismissed = false;
var mobileUiMoved = false;
function gameLoop() {
  if (!gameLoopPaused) {
    if (SETTINGS.tmp.updateRate || forceOneFpsUpdate) {
      var frameNow = performance.now();
      if (frameNow - lastUpdateRateTime < 1000 / (forceOneFpsUpdate ? 1 : SETTINGS.tmp.updateRate)) {
        requestAnimFrame(gameLoop);
        return;
      }
      lastUpdateRateTime = frameNow;
    }
    gameTime = Date.now();
    gameTimeDiff = gameTime - lastGameTime;
    gameTimeDiff = Math.min(gameTimeDiff, config.dltMx);
    lastGameTimeDiff = gameTimeDiff;
    lastGameTime = gameTime;
    if (twitchDropsInfo == null) {
      updateFpsCounter();
      CONTROLS.updateMouseInp();
      if (!CONTROLS.freeMouse) {
        CONTROLS.rotateCam(RENDER.shakeX + RENDER.swayX, RENDER.shakeY + RENDER.swayY, 0);
      }
      TWEEN.update();
      if (endAnimationTimer > 0) {
        endAnimationTimer -= gameTimeDiff;
        if (endAnimationTimer <= 0) {
          endAnimationTimer = 0;
        }
      }
      SOUND.rate = Game.config.deltaMlt;
      if (endAnimationTimer != null && spinUI.style.display != "block") {
        gameTimeDiff *= endAnimationTimer / config.endAnim;
        SOUND.rate = Game.config.deltaMlt * (endAnimationTimer / config.endAnim);
      }
      if (!Game.detachedCam && !tmpPlayer && !window.spectating && !hasStaticMenuCamera) {
        menuCameraYaw += gameTimeDiff * 0.0001;
        menuCameraYaw %= Math.PI * 2;
        CONTROLS.rotateCam(menuCameraYaw, 0, 0);
      }
      updateSpinUi(gameTimeDiff);
      if (classPreviewDelayTicks) {
        classPreviewDelayTicks--;
      }
      if (menuHolder.style.display != "none" && classPreviewEnabled && classPreviewDelayTicks <= 0) {
        if (!classPreviewVisible) {
          classPreviewCanvas.style.opacity = 1;
          classPreviewVisible = true;
        }
        if (classPreviewScene && classPreviewCanvas.offsetWidth > 0 && classPreviewCanvas.offsetHeight > 0) {
          Game.players.playerStep(classPreviewPlayer, gameTimeDiff * 0.015, true);
          classPreviewPlayer.idleAnim += config.idleAnimS * gameTimeDiff;
          Game.players.updateMshClient(classPreviewPlayer, true);
          Game.players.itemEffects(classPreviewPlayer, classPreviewScene, gameTimeDiff);
          classPreviewRenderer.render(classPreviewScene, classPreviewCamera);
          updateMenuAmbientPopups(gameTimeDiff);
        }
        updateRewardTimer();
        if (newsBody.style.display == "block") {
          newsScrollTimer -= gameTimeDiff;
          if (newsScrollTimer <= 0) {
            newsScrollTimer = 5000;
            newsPanelIndex++;
            if (newsPanelIndex >= 5) {
              newsPanelIndex = 0;
            }
            updateNewsStats();
            newsBody.scroll({
              top: newsBody.scrollHeight / 5 * newsPanelIndex,
              behavior: "smooth"
            });
          }
        }
        if (activeSubTabWindowId != null && windows[activeSubTabWindowId - 1] && windows[activeSubTabWindowId - 1].updSubTab) {
          windows[activeSubTabWindowId - 1].updSubTab(gameTimeDiff);
        }
      }
      CONTROLS.update(gameTimeDiff * Game.config.deltaMlt);
      if (tmpPlayer && tmpPlayer.active && !window.locked) {
        var cameraHasOffset = !!CONTROLS.camOffset;
        if (!Game.detachedCam) {
          if (Game.config.thirdPerson) {
            RENDER.camera.position.set(config.thrdPX, config.thrdPY, config.thrdPZ);
            cameraHasOffset = true;
          } else if (Game.mode && Game.mode.teamOptions && Game.mode.teamOptions[tmpPlayer.team - 1] == "Prop") {
            propCameraDistance += CONTROLS.scrollDelta * 5;
            propCameraDistance = Math.min(Math.max(10, propCameraDistance), 100);
            RENDER.camera.position.set(0, 0, propCameraDistance);
            cameraHasOffset = true;
          } else {
            RENDER.camera.position.set(0, 0, 0);
          }
        }
        var cameraYaw = CONTROLS.xDr;
        if (CONTROLS.camOffset) {
          RENDER.camera.position.x += tmpPlayer.config.camOffX;
          RENDER.camera.position.y += tmpPlayer.config.camOffY;
          RENDER.camera.position.z += tmpPlayer.config.camOffZ;
        }
        if (cameraHasOffset && !Game.detachedCam) {
          RENDER.camera.lookAt(tmpPlayer.x, tmpPlayer.y + tmpPlayer.height - config.cameraHeight, tmpPlayer.z);
        }
        if (CONTROLS.freeMouse) {
          RENDER.camera.getWorldPosition(freeMouseRay.origin);
          freeMouseRay.direction.set(CONTROLS.mouseX / window.innerWidth * 2 - 1, -(CONTROLS.mouseY / window.innerHeight) * 2 + 1, 0.5);
          freeMouseRay.direction.unproject(RENDER.camera);
          freeMouseRay.direction.sub(freeMouseRay.origin).normalize();
          if (CONTROLS.camType.isTop) {
            freeMousePlane.normal.set(0, 1, 0);
            freeMouseRay.origin.y -= tmpPlayer.y + tmpPlayer.height;
            freeMouseRay.direction.y = Math.min(freeMouseRay.direction.y, -0.0001);
          } else if (CONTROLS.camType.isSideX) {
            freeMousePlane.normal.set(0, 0, 1);
            freeMouseRay.origin.z -= tmpPlayer.z;
            freeMouseRay.direction.z = Math.min(freeMouseRay.direction.z, -0.0001);
          } else if (CONTROLS.camType.isSideZ) {
            freeMousePlane.normal.set(1, 0, 0);
            freeMouseRay.origin.x -= tmpPlayer.x;
            freeMouseRay.direction.x = Math.max(freeMouseRay.direction.x, 0.0001);
          }
          var freeMouseHitPoint = freeMousePoint;
          freeMouseRay.intersectPlane(freeMousePlane, freeMouseHitPoint);
          if (CONTROLS.camType.isTop) {
            freeMouseAngle = Math.atan2(freeMouseHitPoint.z - tmpPlayer.z, freeMouseHitPoint.x - tmpPlayer.x);
            cameraYaw = -freeMouseAngle - Math.PI / 2;
            CONTROLS.yDr = 0;
          } else if (CONTROLS.camType.isSideX || CONTROLS.camType.isSideZ) {
            freeMouseAngle = Math.atan2(freeMouseHitPoint.y - (tmpPlayer.y + tmpPlayer.height), CONTROLS.camType.isSideX ? freeMouseHitPoint.x - tmpPlayer.x : freeMouseHitPoint.z - tmpPlayer.z);
            var mouseTargetInFront = Math.abs(freeMouseAngle) < Math.PI / 2;
            if (CONTROLS.camType.isSideX) {
              cameraYaw = (mouseTargetInFront ? -1 : 1) * Math.PI / 2;
            } else if (CONTROLS.camType.isSideZ) {
              cameraYaw = (mouseTargetInFront ? 1 : 0) * Math.PI;
            }
            if (!mouseTargetInFront) {
              freeMouseAngle = -freeMouseAngle + Math.PI * Math.sign(freeMouseAngle);
            }
            CONTROLS.yDr = freeMouseAngle;
          }
        }
        if (jumpScareTimer > 0) {
          jumpScareTimer -= gameTimeDiff;
          if (jumpScareTimer <= 0) {
            jumpScareTimer = -1;
            jumpScare(jumpScareId - 1);
          }
        }
        inputFrameDelta += gameTimeDiff;
        inputSendTimer += gameTimeDiff;
        clientFrameCount++;
        var netRate = SETTINGS.tmp.netRate;
        var shouldSampleInput = UTILS.roundToClos(inputFrameDelta, 1000 / netRate) >= 1000 / netRate;
        if (shouldSampleInput) {
          CONTROLS.skipScroll = false;
          inputFrame = [CONTROLS.getISN(), Math.round(inputFrameDelta * Game.config.deltaMlt), Math.round(CONTROLS.yDr.round(3) * 1000), Math.round(cameraYaw.round(3) * 1000), Game.moveLock ? -1 : config.movDirs.indexOf(CONTROLS.moveDir), CONTROLS.isPressed("shoot", null, "shoot") ? 1 : 0, CONTROLS.adsToggled ? 1 : 0, !Game.moveLock && CONTROLS.isPressed("jump", null, "jump") ? 1 : 0, CONTROLS.isPressed("reload", null, "reload") ? 1 : 0, CONTROLS.isPressed("crouch", null, "crouch") ? 1 : 0, CONTROLS.scrollToSwap ? CONTROLS.scrollDelta * CONTROLS.getSetByWep(null, "scroll") : 0, CONTROLS.wSwap, 1 - CONTROLS.speedLmt.round(1), CONTROLS.isPressed("resetLast") ? 2 : CONTROLS.isPressed("reset") ? 1 : 0, CONTROLS.isPressed("interact", null, "interact") ? 1 : 0];
          inputFrameDelta = 0;
          if (CONTROLS.scrollDelta) {
            CONTROLS.skipScroll = CONTROLS.scrollToSwap;
            if (!CONTROLS.scrollToSwap) {
              CONTROLS.fakeKey(20000, 1);
            }
          }
          CONTROLS.scrollDelta = 0;
          CONTROLS.wSwap = 0;
          if (!Game.noPred && !Game.dontSendInputs) {
            CONTROLS.tmpInpts[CONTROLS.tmpInpts._push ? "_push" : "push"](inputFrame);
            tmpPlayer.procInputs(inputFrame, Game, false, Game.moveLock);
            if (Game.isSandbox && sandboxGame) {
              sandboxPlayer.procInputs(inputFrame, sandboxGame, false, sandboxGame.moveLock);
            }
          }
          if (!Game.isSandbox && !endAnimationTimer && !Game.dontSendInputs) {
            queueInputFrame(inputFrame);
          }
          if (!Game.detachedCam) {
            if (!CONTROLS.freeMouse) {
              CONTROLS.rotateCam(RENDER.shakeX + RENDER.swayX, RENDER.shakeY + RENDER.swayY + tmpPlayer.recoilAnimY * config.recoilMlt + tmpPlayer.landBobY * 0.1, 0);
            }
            CONTROLS.moveCam(tmpPlayer.x, tmpPlayer.y + tmpPlayer.height - config.cameraHeight, tmpPlayer.z);
          }
          var cameraYawOffset = 0;
          if (tmpPlayer.config.lockCamP) {
            if (tmpPlayer.camChase == null) {
              tmpPlayer.camChase = tmpPlayer.xDire;
            }
            var fullTurnRadians = Math.PI * 2;
            var cameraChaseDelta = (tmpPlayer.xDire - tmpPlayer.camChase) % fullTurnRadians;
            var cameraChaseLerp = tmpPlayer.config.lockCamP * (gameTimeDiff / 100);
            var cameraChaseStep = (cameraChaseDelta * 2 % fullTurnRadians - cameraChaseDelta) * cameraChaseLerp;
            tmpPlayer.camChase += cameraChaseStep;
            cameraYaw = tmpPlayer.camChase;
            CONTROLS.object.rotation.y = cameraYaw;
            cameraYawOffset = cameraYaw;
          }
          if (tmpPlayer.config.lckCmYR) {
            CONTROLS.pchObjc.rotation.x = -(Math.PI / 2) * tmpPlayer.config.lckCmYR;
          }
          if (tmpPlayer.config.yCmLim) {
            var pitchLimitRadians = tmpPlayer.config.yCmLim * Math.PI;
            var maxPitchRotation = -(Math.PI / 2) + pitchLimitRadians;
            var currentPitchOffset = CONTROLS.pchObjc.rotation.x + Math.PI / 2;
            if (currentPitchOffset >= pitchLimitRadians) {
              CONTROLS.pchObjc.rotation.x = maxPitchRotation;
            }
          }
          UI.updateCrosshair(Math.max(58, tmpPlayer.spread * 0.85 * crosshairScale), (Game.config.thirdPerson || CONTROLS.camOffset) & (!tmpPlayer.weapon.scope || tmpPlayer.currentSkin.noScope) ? 1 : tmpPlayer.aimVal * (tmpPlayer.inspecting ? 0 : 1) * (tmpPlayer.weapon && tmpPlayer.weapon.noCross ? 0 : 1) * (Game.mode && Game.mode.teamOptions && Game.mode.teamOptions[tmpPlayer.team - 1] == "Prop" ? 0 : 1) * (tmpPlayer.reloadTimer > 0 ? 0 : 1) * (CONTROLS.freeMouse ? 0 : 1));
          io_interProg(tmpPlayer.interProg || 0);
          io_interMProg(tmpPlayer.interMProg || 0, !!tmpPlayer.overCharged);
          Howler.pos(tmpPlayer.x, tmpPlayer.y + tmpPlayer.height - config.cameraHeight, tmpPlayer.z);
          Howler.orientation(Math.sin(CONTROLS.xDr + cameraYawOffset + Math.PI), CONTROLS.yDr, Math.cos(CONTROLS.xDr + cameraYawOffset + Math.PI));
        } else {
          if ((tmpPlayer.config.movSch || 0) == 0 && tmpPlayer.config.trnSp == 1) {
            tmpPlayer.yDire = CONTROLS.yDr;
            tmpPlayer.xDire = cameraYaw;
            Game.players.updateMshClient(tmpPlayer);
          }
          if (!Game.detachedCam) {
            if (!CONTROLS.freeMouse) {
              CONTROLS.rotateCam(RENDER.shakeX + RENDER.swayX, RENDER.shakeY + RENDER.swayY + tmpPlayer.recoilAnimY * config.recoilMlt + tmpPlayer.landBobY * 0.1, 0);
            }
            CONTROLS.moveCam(tmpPlayer.x, tmpPlayer.y + tmpPlayer.height - config.cameraHeight, tmpPlayer.z);
          }
        }
        let wallLeanAmount = SETTINGS.tmp.wallLean ? SETTINGS.tmp.wallLeanMlt * 0.15 : 0;
        if (!Game.detachedCam && wallLeanAmount > 0) {
          let cameraRotation = CONTROLS.object.rotation;
          let wallLeanSmoothing = 30;
          if (tmpPlayer.onWall && tmpPlayer.wallJump && tmpPlayer.crouchVal) {
            let wallDirection = CONTROLS.getWorldDirection();
            let useXWallLeanAxis = tmpPlayer.onWall == 3 || tmpPlayer.onWall == 4;
            cameraRotation.z += gameTimeDiff * (((useXWallLeanAxis ? -wallLeanAmount : wallLeanAmount) * (tmpPlayer.onWall % 2 ? -1 : 1) * wallDirection[useXWallLeanAxis ? "x" : "z"] - cameraRotation.z) / wallLeanSmoothing);
          } else {
            cameraRotation.z += (0 - cameraRotation.z) / 40;
            if (Math.abs(0 - cameraRotation.z) < 0.0001) {
              cameraRotation.z = 0;
            }
          }
        }
      } else if (window.spectating) {
        if (CONTROLS.spect.target) {
          window.noMouseInp = false;
          if (CONTROLS.spect.target.isPlayer && Game.players && Game.players.list && Game.players.list.indexOf(CONTROLS.spect.target) < 0) {
            spectMode();
          } else if (spectatingObjectiveCamera) {
            window.noMouseInp = true;
            if (!spectateCameraInitialized) {
              spectateCameraInitialized = true;
              CONTROLS.object.rotation.x = CONTROLS.spect.target.yR;
              CONTROLS.object.rotation.y = CONTROLS.spect.target.xR;
              CONTROLS.object.rotation.z = CONTROLS.spect.target.zR;
              var spectatorTarget = CONTROLS.spect.target;
              CONTROLS.object.position.set(spectatorTarget.x, spectatorTarget.y, spectatorTarget.z);
              RENDER.camera.position.set(0, 0, 0);
              RENDER.camera.updateProjectionMatrix();
              RENDER.updateFrustum();
            }
          } else if (!CONTROLS.spect.target.active) {
            spectMode();
          } else if (spectatorThirdPersonFollow && spectatorThirdPerson) {
            window.noMouseInp = true;
            overlay.fakeCross = true;
            var spectatorTarget = CONTROLS.spect.target;
            var spectatorCameraY = spectatorTarget.y + CONTROLS.spect.target.height - config.cameraHeight;
            if (CONTROLS.spect.target.isPlayer) {
              if (!spectatorInterpState.crouch) {
                spectatorInterpState.crouch = 0;
              }
              if (spectatorInterpState.crouch < CONTROLS.spect.target.crouchVal) {
                spectatorInterpState.crouch += gameTimeDiff * 0.0085;
                if (spectatorInterpState.crouch >= CONTROLS.spect.target.crouchVal) {
                  spectatorInterpState.crouch = CONTROLS.spect.target.crouchVal;
                }
              } else if (spectatorInterpState.crouch > CONTROLS.spect.target.crouchVal) {
                spectatorInterpState.crouch -= gameTimeDiff * 0.0085;
                if (spectatorInterpState.crouch <= CONTROLS.spect.target.crouchVal) {
                  spectatorInterpState.crouch = CONTROLS.spect.target.crouchVal;
                }
              }
              spectatorCameraY -= spectatorInterpState.crouch * config.crouchDst;
              if (CONTROLS.spect.target.weapon) {
                if (spectatorInterpState.aim == null) {
                  spectatorInterpState.aim = 1;
                }
                if (spectatorInterpState.aim < CONTROLS.spect.target.aimVal) {
                  spectatorInterpState.aim += gameTimeDiff * 0.009;
                  if (spectatorInterpState.aim >= CONTROLS.spect.target.aimVal) {
                    spectatorInterpState.aim = CONTROLS.spect.target.aimVal;
                  }
                } else if (spectatorInterpState.aim > CONTROLS.spect.target.aimVal) {
                  spectatorInterpState.aim -= gameTimeDiff * 0.009;
                  if (spectatorInterpState.aim <= CONTROLS.spect.target.aimVal) {
                    spectatorInterpState.aim = CONTROLS.spect.target.aimVal;
                  }
                }
                RENDER.zoom(1 + (CONTROLS.spect.target.weapon.zoom - 1) * (1 - spectatorInterpState.aim));
                if (CONTROLS.spect.target.weapon.scope) {
                  if (RENDER.aimRecticle.custom) {
                    aimRecticle.style.opacity = (1 - CONTROLS.spect.target.aimVal) * RENDER.aimRecticle.opacMlt;
                  } else {
                    RENDER.aimRecticle.opacity = 1 - CONTROLS.spect.target.aimVal;
                  }
                }
              }
            }
            var spectatorTarget = CONTROLS.spect.target;
            CONTROLS.moveCam(spectatorTarget.x, spectatorCameraY, spectatorTarget.z);
            CONTROLS.object.rotation.y = CONTROLS.spect.target.xDire;
            CONTROLS.pchObjc.rotation.x = CONTROLS.spect.target.yDire;
            if (CONTROLS.spect.target.objInstances) {
              CONTROLS.spect.target.objInstances.visible = false;
            }
          } else {
            CONTROLS.followCam(CONTROLS.spect.target, gameTimeDiff);
            if (CONTROLS.spect.target.objInstances) {
              CONTROLS.spect.target.objInstances.visible = true;
            }
          }
        }
        if (!CONTROLS.spect.target && (!Game || !Game.mode || !Game.mode.noFreeCam)) {
          CONTROLS.freeCam(gameTimeDiff);
        }
        if (CONTROLS.object && CONTROLS.object.position) {
          Howler.pos(CONTROLS.object.position.x, CONTROLS.object.position.y, CONTROLS.object.position.z);
          Howler.orientation(Math.sin(CONTROLS.xDr + Math.PI), CONTROLS.yDr, Math.cos(CONTROLS.xDr + Math.PI));
        }
        updateSpectatorRoster(gameTimeDiff);
      }
      Game.update(gameTimeDiff, gameTime, tmpPlayer);
      var isInsideEnvZone = false;
      for (var envZoneIndex = 0; envZoneIndex < Game.map.manager.envZones.length; ++envZoneIndex) {
        player = Game.map.manager.envZones[envZoneIndex];
        if (UTILS.pointInBox3D(CONTROLS.object.position.x, CONTROLS.object.position.y, CONTROLS.object.position.z, player)) {
          RENDER.updateGameEnvironment(envZoneIndex);
          isInsideEnvZone = true;
          break;
        }
      }
      if (!isInsideEnvZone && (RENDER.lastEnvId != -2 || !Game.eventIndex)) {
        RENDER.updateGameEnvironment(-1);
      }
      updateExpiringChatMessages(gameTimeDiff);
      DIV.update(gameTimeDiff);
      if (imgFlash.style.display == "block") {
        imgFlash.style.opacity -= gameTimeDiff * 0.002;
        if (imgFlash.style.opacity <= 0) {
          imgFlash.style.opacity = 0;
          imgFlash.style.display = "none";
        }
      }
      overlay.render(uiScale, Game, CONTROLS, RENDER, tmpPlayer, gameTimeDiff, lastGameTimeDiff, voiceChatQueues);
      if (Game && Game.mainScript && Game.mainScript.render) {
        overlay.ctx.save(1);
        overlay.ctx.scale(overlay.scale, overlay.scale);
        Game.mainScript.render(gameTimeDiff);
        overlay.ctx.restore(-1);
      }
      if (!window.spectating && menuHolder.style.display == "block" && !!config.isProd && !isGameHost && (!account || !account.developer) && !Game.config && (!Game || !Game.mode || !Game.mode.noKick && !Game.mode.noClientKick)) {
        CONTROLS.idleTimer += gameTimeDiff;
        if (CONTROLS.idleTimer >= config.kickTimer) {
          io_disconnect(i18n.t("player.inactive"), "000005");
        }
      }
      if (menuHider.style.display == "block" && streamRotationStartedAt && gameTime - streamRotationStartedAt >= config.streamRotation) {
        rotateStreamPanel();
      }
      if (menuHider.style.display == "block" && gameTime - lastStreamRefreshTime >= 900000 && streamAutoRefreshEnabled) {
        refreshTwitchStreams();
      }
      if (gameTime - lastVisibilityRefreshTime >= 200) {
        lastVisibilityRefreshTime = gameTime;
        updatePlayerVisibility();
      }
    }
    if (!oneTrustDismissed && !config.isProd) {
      var oneTrustButton = document.getElementById("onetrust-accept-btn-handler");
      if (oneTrustButton) {
        oneTrustButton.click();
        oneTrustDismissed = true;
      } else if (window.OneTrust && !window.OneTrust.IsAlertBoxClosed()) {
        try {
          window.OneTrust.Close();
          oneTrustDismissed = true;
        } catch (oneTrustError) {
          oneTrustDismissed = false;
        }
      }
    }
    if (twitchDropsInfo == null && (CONTROLS.isMobile || isMobileClient()) && !mobileUiMoved) {
      mobileUiMoved = true;
      UTILS.moveElement(interactMsg, "mobileUI");
      UTILS.moveElement(killStreakHolder, "mobileUI");
    }
    if (useRegularFrameRequest) {
      if (CONTROLS.keys && CONTROLS.isPressed("shoot", null, "shoot") && SETTINGS.tmp.aimFreezeFix) {
        useRegularFrameRequest = false;
      }
      requestAnimFrame(gameLoop);
    } else {
      requestAnimFrameF(gameLoop, gameTime);
      useRegularFrameRequest = true;
    }
  }
}
function f2034() {
  if (!twitchDropsInfo && !gameLoopPaused) {
    Game.updateSpinners(config.staticDlt * 3);
  }
}
var vLN02038 = 0;
function queueInputFrame(p14851) {
  if (firstQueuedInputId === null) {
    firstQueuedInputId = p14851[0];
  }
  if (p14851.syncTime) {
    if (!queuedInputServerTimes) {
      queuedInputServerTimes = {};
    }
    var vLN02039 = 0;
    var v12086 = Game.now - 1000 / Game.sendFrequency;
    if (Game.lastSync) {
      vLN02039 = ((v12086 - Game.newSync) / (Game.lastSync - Game.newSync)).round(2);
    }
    queuedInputServerTimes[queuedInputFrameTimes.length] = Game.servTim;
    if (vLN02039) {
      queuedInputServerTimes[queuedInputFrameTimes.length + "p"] = vLN02039;
    }
  }
  queuedInputFrameTimes.push(p14851[1]);
  for (var vLN415 = 2; vLN415 < 4; ++vLN415) {
    if (queuedInputLookDeltas.length < 2) {
      queuedInputLookDeltas.push(p14851[vLN415]);
    } else {
      var v12087 = p14851[vLN415] - (lastQueuedInputValues[vLN415] || 0);
      queuedInputLookDeltas.push(v12087);
    }
    lastQueuedInputValues[vLN415] = p14851[vLN415];
  }
  for (var vLN415 = 4; vLN415 < p14851.length; ++vLN415) {
    if (lastQueuedInputValues[vLN415] == null || lastQueuedInputValues[vLN415] != p14851[vLN415]) {
      lastQueuedInputValues[vLN415] = p14851[vLN415];
      queuedInputStateChanges[queuedInputFrameIndex + "-" + vLN415] = p14851[vLN415];
      hasQueuedInputStateChanges = true;
    }
  }
  queuedInputFrameIndex++;
  if (inputSendTimer >= Game.tickRate) {
    inputSendTimer = 0;
    vLN02038 = gameTime;
    flushQueuedInputFrames();
  }
}
function flushQueuedInputFrames() {
  if (!Game.isSandbox && tmpPlayer && tmpPlayer.active) {
    if (!hasQueuedInputStateChanges) {
      queuedInputStateChanges = 0;
    }
    var vLS107 = "";
    var vLN02040 = 0;
    var vLN02041 = 0;
    player = "";
    for (var vLN02044 = 0; vLN02044 < queuedInputFrameTimes.length; ++vLN02044) {
      player = queuedInputFrameTimes[vLN02044].toString();
      vLS107 += player;
      vLN02040 = player.length;
      if (!vLN02041) {
        vLN02041 = vLN02040;
      } else if (vLN02041 != vLN02040) {
        vLN02041 = 0;
        vLS107 = queuedInputFrameTimes;
        break;
      }
    }
    if (queuedInputLookDeltas && queuedInputLookDeltas.length > 2) {
      var vLN02043 = 0;
      for (var vLN02044 = 2; vLN02044 < queuedInputLookDeltas.length;) {
        if (queuedInputLookDeltas[vLN02044] == 0 && queuedInputLookDeltas[vLN02044 + 1] == 0) {
          vLN02043++;
          vLN02044 += 2;
        } else {
          vLN02043 = 0;
          break;
        }
      }
      if (vLN02043) {
        queuedInputLookDeltas.length = 2;
      }
    }
    var v12088 = true;
    for (var vLN02044 = 0; vLN02044 < queuedInputLookDeltas.length; ++vLN02044) {
      if (queuedInputLookDeltas[vLN02044] != lastSentInputLookDeltas[vLN02044]) {
        v12088 = false;
        break;
      }
    }
    var vA655 = [inputResyncFlag, firstQueuedInputId, vLS107, vLN02041];
    if (queuedInputServerTimes || queuedInputStateChanges || queuedInputLookDeltas.length && !v12088) {
      vA655.push(v12088 ? 0 : queuedInputLookDeltas);
    }
    if (queuedInputServerTimes || queuedInputStateChanges) {
      vA655.push(queuedInputStateChanges);
    }
    if (queuedInputServerTimes) {
      vA655.push(queuedInputServerTimes);
    }
    io.send("q", ...vA655);
    queuedInputStateChanges = {};
    lastSentInputLookDeltas = [...queuedInputLookDeltas];
    queuedInputLookDeltas.length = 0;
    queuedInputFrameTimes.length = 0;
    queuedInputServerTimes = null;
    hasQueuedInputStateChanges = false;
    inputResyncFlag = 0;
    firstQueuedInputId = null;
    queuedInputFrameIndex = 0;
  }
}
function resetGameSessionState() {
  vA651.length = 0;
  overlay.hits.length = 0;
  UI.toggleGameUI(true);
  DIV.reset();
  overlay.reset();
  CONTROLS.reset(!Game.detachedCam);
  io_lockPlayer(false);
  Game.players.forcePos();
  Game.players.resetAim();
  Game.AI.hideAll();
  queuedInputStateChanges = {};
  queuedInputFrameTimes.length = 0;
  queuedInputServerTimes = null;
  inputSendTimer = 0;
  queuedInputFrameIndex = 0;
  propCameraDistance = 30;
  inputFrameDelta = 0;
  clientFrameCount = 0;
  overlay.speedDisplay.max = 0;
  queuedInputLookDeltas.length = 0;
  lastSentInputLookDeltas = [];
  lastQueuedInputValues = {};
  inputResyncFlag = 0;
  firstQueuedInputId = null;
  hasQueuedInputStateChanges = false;
  window.noMouseInp = false;
  UI.loading = false;
  CONTROLS.idleTimer = 0;
  hiddenMsg.style.display = "none";
  overlay.interactProg.display = false;
  overlay.interactMProg.display = false;
  f2042();
  specTeam1.innerHTML = "";
  specTeam0.innerHTML = "";
  vA647.length = 0;
  f1765();
  v10811 = false;
}
var v12089;
function io_showSpeechBubble(p14852, p14853, p14854) {
  if (p14852) {
    if (p14854) {
      SOUND.play(["sigh_0", "sigh_1"][UTILS.randInt(0, 1)], 0.2);
    }
    txtBubble.innerHTML = p14852;
    bubbleContainer.style.transform = "scale(1.0)";
    if (v12089) {
      clearTimeout(v12089);
    }
    v12089 = requestAnimationFrame(function () {
      bubbleContainer.style.transform = "scale(0.0)";
    }, p14853 || 2500);
  }
}
function f2039(p14855) {
  v10544 = null;
  v10545 = null;
  v10546 = null;
  v10547 = null;
  v10548 = null;
  v10549 = null;
  if (Game.mode != null) {
    UI.setShowSpect(Game.config.allowSpect);
    UI.setShowSelTeam(Game.config.selTeam);
    if (Game.config.selTeam && v10535 && UTILS.isNumber(v10535)) {
      var v12090 = document.getElementById("selectT");
      if (v12090 && v10535 == 2) {
        selectT.click();
      }
      v10535 = null;
    }
    Game.resetClasses();
    endAnimationTimer = null;
    CONTROLS.toggle(false);
    var v12091 = Game.map.maps[p14855];
    var v12092 = v12091.camPos ? v12091.camPos : [0, 0, 0];
    hasStaticMenuCamera = !!v12092[3];
    RENDER.clearSprays();
    tmpPlayer = null;
    overlay.sprayWheelClose();
    overlay.propWheelClose();
    overlay.showObjective = !!Game.mode.objective && Game.map.manager.objectives.length > 0;
    killStreakHolder.innerHTML = "";
    krTagHolder.innerHTML = "";
    perkHolder.innerHTML = "";
    zPerksHolder.innerHTML = "";
    overlay.bloodOpacity = 0;
    bloodDisplay.style.display = "none";
    killsVal.textContent = 0;
    kdVal.textContent = "0.0";
    deathsVal.textContent = 0;
    myScoreVal.textContent = 0;
    currentKillStreak = 0;
    streakVal.textContent = currentKillStreak;
    pendingScorePopupValue = 0;
    kickVoteSubmittedAliases.length = 0;
    activeKickVoteTargetAlias = false;
    hasStartedKickVote = false;
    voteToKick.style.display = "none";
    voteToForfeit.style.display = "none";
    spectatingObjectiveCamera = false;
    spectateCameraInitialized = false;
    f1765();
    spectatorInterpState = {};
    f1766();
    spectatorPlayerStats = {};
    updateCamMouse(0);
    updateClassPreview();
    SOUND.stopALL();
  }
}
window.backToOrigin = function (p14856) {
  if (FRVR.channelCharacteristics.allowNavigation) {
    window.location = vF91(window.location, window.location.origin, vA577);
  } else {
    if (p14856) {
      f2039(0);
    }
    loadMatch();
  }
};
function f2040(p14857, p14858, p14859, p14860) {
  console.trace("Error message", p14857);
  instructionHolder.style.display = "block";
  menuHolder.style.display = "none";
  var v12093 = p14857 == "GAME UPDATING" || p14860 == "NoServersMatchQuery";
  var v12094 = !!p14857 && !!p14857.toLowerCase().includes("disconnected") || p14860 == "disconnected";
  UI.isUpdating = v12093;
  f2077("disconnect");
  if (v12093) {
    var v12095 = UTILS.randInt(0, config.updateBgs.length - 1);
    var v12096 = config.updateBgs[v12095];
    instructions.style.display = "none";
    instructionsUpdate.style.display = "block";
    instructionsUpdateBG.style.backgroundImage = "url(\"" + UTILS.assetsUrl("img/menu-bg/" + v12096.id + ".png") + "\")";
    instructionsUpdateBG.style.display = "block";
    instructionsUpdateCredit.innerHTML = "Art By " + v12096.creator;
    instructionsUpdateCredit.setAttribute("onclick", "openURL('" + v12096.link + "')");
    instructionsUpdateCredit.style.display = "block";
    instructionsUpdate.innerHTML = "<div class='instructionsHeader'>Game Updating</div><iframe id='updatingStream' style='width:635px;height:360px;border:none;margin-top:10px;display:none'></iframe><iframe id='updatingStreamChat' style='width:270px;height:360px;border:none;margin-top:10px;display:none' frameborder='0' scrolling='no'></iframe><div style='margin-top:10px;font-size:15px;color:rgba(255,255,255,0.4)'>While you wait <a target='_blank' href='https://www.twitch.tv/directory/game/Krunker'>go chat</a> with some Krunker Streamers</a></div>" + ("<div class=\"instructionsTabs\">\n\t\t\t\t<div class=\"instructionsTab\" onmouseenter=\"playTick();\" onclick=\"playSelect(0.1);logBtnFRVR('find_game');" + (v10536 ? "playMap('" + v10536 + "')" : "backToOrigin()") + "\">Find a Game</div>\n\t\t\t\t<div class=\"instructionsTab\" onmouseenter=\"playTick();\" onclick=\"playSelect(0.1);logBtnFRVR('settings');showWindow(1)\">Settings</div>\n\t\t\t\t<div class=\"instructionsTab\" onmouseenter=\"playTick();\" onclick=\"playSelect(0.1);logBtnFRVR('changelog');showWindow(35)\">Changelog</div>\n\t\t\t</div>");
    API_CLIENT.listStreams(2, function (p14861, p14862) {
      if (p14862 && p14862.n) {
        instructionsUpdate.style.width = "920px";
        updatingStream.src = "https://player.twitch.tv/?channel=" + p14862.n + "&parent=" + location.hostname;
        updatingStreamChat.src = "https://www.twitch.tv/embed/" + p14862.n + "/chat?darkpopout&parent=" + location.hostname;
        updatingStream.style.display = "inline-block";
        updatingStreamChat.style.display = "inline-block";
      }
    });
  } else {
    var v12097 = io && io.socket && io.socket.url ? (new URL(io.socket.url).hostname + "").replace("cf_", "").replace("ip_", "").split(".")[0] : "Unknown";
    instructions.style.display = "none";
    frvrFTUEVideoHolder.style.display = "none";
    instructionsUpdate.style.display = "block";
    instructionsUpdate.innerHTML = "<div class='instructionsHeader'>Lost Connection" + (v12094 ? "<div class='reportDC' onclick='disconnectPopup(&quot;" + (p14859 ? p14859.code || "0" : "0") + "&quot;,&quot;" + (p14859 ? p14859.reason || "0" : "0") + "&quot;)'>Report</div>" : "") + "</div><div style='color: rgba(255, 255, 255, 0.6);margin-top: 5px;font-size: 28px;'>" + p14857 + "</div><div style='margin-top:10px;font-size:15px;color:rgba(255,255,255,0.4)'>ID: 0x" + (p14858 || window.krunkerErrorCode || "000000") + " | Code: " + (p14859 ? p14859.code || "0" : "0") + " | Reason: " + (p14859 ? p14859.reason || "0" : "0") + "</div><div style='margin-top:10px;font-size:15px;color:rgba(255,255,255,0.4)'>" + (v12094 ? "ServerID: " + v12097 + " | " : "") + "Region: " + (config.regionNames[v10547] ? config.regionNames[v10547] || "0" : "0") + "</div>" + (p14857 && p14857.toLowerCase().includes("connection banned") ? "<div style='margin-top:10px;font-size:13px;color:rgba(255,255,255,0.4)'>Contact <span style='color:#fff'>krunker+banappeal@frvr.com</span> to Appeal the Ban</div><div></div>" : "<div style='margin-top:10px;font-size:15px;color:rgba(255,255,255,0.4)'>" + i18n.t("error.extentions") + "</div>") + ("<div class=\"instructionsTabs\">\n\t\t\t\t<div class=\"instructionsTab\" onmouseenter=\"playTick();\" onclick=\"playSelect(0.1);logBtnFRVR('find_game');" + (v10536 ? "playMap('" + v10536 + "')" : "backToOrigin()") + "\">Find a Game</div>\n\t\t\t\t<div class=\"instructionsTab\" onmouseenter=\"playTick();\" onclick=\"playSelect(0.1);logBtnFRVR('server_browser');showWindow(2)\">Servers</div>\n\t\t\t\t<div class=\"instructionsTab\" onmouseenter=\"playTick();\" onclick=\"playSelect(0.1);logBtnFRVR('settings');showWindow(1)\">Settings</div>\n\t\t\t\t<div class=\"instructionsTab\" onmouseenter=\"playTick();\" onclick=\"playSelect(0.1);logBtnFRVR('changelog');showWindow(35)\">Changelog</div>\n\t\t\t</div>");
  }
  instructionHolder.style.pointerEvents = "all";
  f1748();
}
function f2041() {
  if (io.socket && (io.socket.readyState == WebSocket.CLOSING || io.socket.readyState == WebSocket.CLOSED)) {
    return "";
  }
  var v12098 = i18n.t("app." + (spectateEnabled ? "spectate" : "play") + (CONTROLS.gamepad.active ? ".controller" : UI.isMobileControls ? ".mobile" : ""));
  v12098 += v10794 ? "<div id='instructionsSubtitle'>" + v10794.toUpperCase() + "</div>" : "";
  return v12098;
}
function f2042() {
  instructions.innerHTML = f2041();
}
UI.updatePlayInstructions = f2042;
var vUndefined8 = undefined;
function io_error(p14863, p14864, p14865) {
  io.connected = false;
  vUndefined8 = p14863;
  showWindow(0);
  CONTROLS.disable();
  UI.hideUI();
  UI.hideDiscon();
  f2040(p14863, p14864, undefined, p14865);
  if (FRVR.channelCharacteristics.allowNavigation) {
    if (io.socket) {
      io.socket.onclose = function () {};
    }
    io_disconnect = function () {};
  } else {
    f2039(0);
  }
}
function io_disconnect(p14866, p14867, p14868, p14869) {
  if (!vUndefined8 && !Game.isSandbox && (io && io.socket && (io.socket.onclose = function () {}, io.socket.close()), !p14869)) {
    showWindow(0);
    CONTROLS.disable();
    UI.hideUI();
    UI.hideDiscon();
    var v12099 = p14866 ? undefined : "disconnected";
    f2040(p14866 || i18n.t("player.disconnect"), p14867, p14868, v12099);
  }
}
Object.defineProperty(window, "openTab", {
  writeable: false,
  value: function (p14870) {
    window.open(p14870, "_blank");
  }
});
var activeFeaturedStream = false;
var v12101 = false;
var vA656 = [];
var streamRotationStartedAt = 0;
var lastStreamRefreshTime = 0;
var streamAutoRefreshEnabled = false;
var vLN02047 = 0;
function f2045(p14871) {
  adCon.style.display = "none";
  streamCon.style.display = "none";
  friendCon.style.display = "none";
  if (UI.embedPlayer) {
    UI.toggleEmbedPlayer(false);
  }
  streamRotationStartedAt = Date.now();
  var vLS108 = "";
  if (activeFeaturedStream) {
    vLN02047 = 0;
  }
  if (window.isBotFTUE || Game && Game.isSandbox) {
    vLN02047 = 1;
  }
  if (vLN02047 == 1) {
    adCon.style.display = "";
  } else if (vLN02047 != 2) {
    loadingStreams.style.display = "";
    streamEvents.style.display = "none";
    streamItems.style.display = "none";
    if (p14871 && p14871.length) {
      loadingStreams.style.display = "none";
      vA656 = p14871;
      if (!v12101) {
        if (vA656) {
          var v12103 = vA656.filter(p14872 => p14872.e).sort(() => Math.random() - Math.random());
          if (v12103.length) {
            activeFeaturedStream = v12103[0];
          }
        }
        if (activeFeaturedStream && !activeFeaturedStream.f) {
          v12101 = activeFeaturedStream;
        }
      }
      if (activeFeaturedStream && UI.useEmbedPlayer) {
        if (twitchEmbedScriptLoaded) {
          if (UI.embedPlayer && (UI.embedPlayer.getChannel() + "").toLowerCase() != activeFeaturedStream.n) {
            UI.embedPlayer.setChannel(activeFeaturedStream.n);
          }
        } else {
          streamEventEmbed.innerHTML = "";
          loadTwitchEmbedPlayer("streamEventEmbed", {
            channel: activeFeaturedStream.n,
            width: 300,
            height: 170,
            autoplay: true,
            parent: location.hostname
          });
        }
        streamEvents.style.display = "";
        streamEvents.setAttribute("onclick", "openTwitch('" + activeFeaturedStream.n + "')");
        streamEventEmbed.setAttribute("onclick", "openTwitch('" + activeFeaturedStream.n + "')");
      } else {
        for (var vLN02050 = 0, v12104; vLN02050 < 4; ++vLN02050) {
          v12104 = document.getElementById("streamItem" + vLN02050);
          if (v12104) {
            if (!p14871[vLN02050] || !p14871[vLN02050].a) {
              v12104.style.display = "none";
              continue;
            }
            var v12105 = "https://static-cdn.jtvnw.net/jtv_user_pictures/" + p14871[vLN02050].lo;
            if (v12104.children[0].src != v12105) {
              v12104.children[0].src = v12105;
            }
            if (v12104.children[1].children[0].innerText != p14871[vLN02050].n) {
              v12104.children[1].children[0].innerText = p14871[vLN02050].n;
            }
            v12104.children[1].children[1].style.display = p14871[vLN02050].p ? "inline-block" : "none";
            v12104.children[1].children[2].innerText = i18n.t("streamers.views", p14871[vLN02050].v);
            v12104.setAttribute("onclick", "onTwitchClick('" + p14871[vLN02050].n + "')");
          }
        }
        streamItems.style.display = "";
      }
    } else {
      loadingStreams.innerHTML = i18n.t("streamers.none");
    }
    streamCon.style.display = "";
  } else if (!friends || !friends.length) {
    rotateStreamPanel();
  } else {
    if (!friendCon.innerHTML.length) {
      for (var vLSdivClassstreamItemdi = "<div class='streamItem'><div class='strmCat friendHeader' style='margin-left:5px;'>Active Friends <div class='onStatus' style='background:#27ab32;vertical-align:middle;margin-top:-6px;margin-left:10px;'></div></div></div>", vLN02049 = 0, vLN02050 = 0, v12106; vLN02050 < friends.length && (v12106 = friends[vLN02050], v12106.st != 1 || !account || account.id == v12106.fid || !(vLSdivClassstreamItemdi += "<div class='streamItem' onclick=''><img class='strmIcn' onerror='this.onerror=null;this.src=\"./img/player_pfp.png\";' src='" + (v12106.sub ? UTILS.userAssetsUrl("/p" + v12106.fid + "/profile.png") : "./img/player_pfp.png") + "' /><div class='streamName'><div class='strmLink blackShad'>" + v12106.fna + "</div><div class='strmViews' style='color:rgba(255,255,255,0.5)'>" + (v12106.sm || "Online") + "</div></div>" + (v12106.gid ? "<div style='position:relative;float:right;' onclick='openURL(`/?game=" + v12106.gid + "`,1)'><div class='frndQickJoin' title='Join'><span class='material-icons'style='color:#fff;font-size:35px;margin-top:12px;'>launch</span></div></div>" : "") + "</div>", vLN02049++, vLN02049 >= 4)); ++vLN02050) {
        ;
      }
      if (vLN02049 > 0) {
        vLS108 += vLSdivClassstreamItemdi;
      } else {
        rotateStreamPanel();
        return;
      }
      friendCon.innerHTML = vLS108;
    }
    friendCon.style.display = "";
  }
}
Object.defineProperty(window, "onTwitchClick", {
  writeable: false,
  value: function (p14873) {
    var v12107 = "<div class='twitchIframe'><iframe src='https://player.twitch.tv/?channel=" + p14873 + "&amp;parent=" + location.hostname + "' height='340' width='600' frameborder='0' scrolling='no' autoplay='true' allowfullscreen='false'></iframe><iframe src='https://www.twitch.tv/embed/" + p14873 + "/chat?darkpopout&amp;parent=" + location.hostname + "' frameborder='0' scrolling='no' height='340' width='250'></iframe></div>";
    twitchHolder.innerHTML = v12107;
    twitchHolder.style.display = "block";
  }
});
window.closeTwitch = function () {
  twitchHolder.innerHTML = "";
  twitchHolder.style.display = "none";
};
function rotateStreamPanel() {
  if (activeFeaturedStream) {
    if (streamCon.style.display != "") {
      streamCon.style.display = "";
    }
    return;
  } else {
    vLN02047++;
    if (vLN02047 > 2) {
      vLN02047 = 0;
    }
    if (vLN02047 == 1 && v10514) {
      vLN02047 = 2;
    }
    if (activeFeaturedStream) {
      vLN02047 = 0;
    }
    if (window.isBotFTUE || Game && Game.isSandbox) {
      vLN02047 = 1;
    }
    if (vLN02047 == 0) {
      f2045(vA656);
    } else if (vLN02047 == 1) {
      f2045();
    } else {
      f2045();
    }
    return;
  }
}
function loadFTUEMap() {
  fetch("maps/bot_ftue_v2.json?v=AD9yU").then(async p14874 => {
    let v12108 = await p14874.text();
    loadSandbox(v12108);
  }).catch(p14875 => {
    console.error("Error Download FTUE Map:", p14875);
  });
}
window.exitBotFTUE = function (p14876) {
  saveVal("ftue_bm", 3);
  requestAnimationFrame(() => location.href = location.origin, p14876 ? 0 : 5000);
};
function loadSandbox(p14877) {
  connectToSandbox(p14877);
}
window.linkTwitch2 = function () {
  window.open(location.origin + "/?twitch_auth", "_self");
};
function loadTwitchDrops(p14878, p14879, p14880) {
  Game.isSandbox = true;
  if (io && io.socket) {
    io.socket.close();
  }
  io.send = function () {};
  document.title = "Krunker | Twitch Drops";
  uiBase.style.overflowY = "scroll";
  uiBase.style.pointerEvents = "auto";
  uiBase.style.backgroundColor = "#121414";
  uiBase.style.textAlign = "left";
  uiBase.style.color = "#fff";
  API_CLIENT.listStreams(3, function (p14881, p14882) {
    p14882 = p14882 || [];
    p14878 = parseInt(p14878);
    var v12109 = true;
    if (!UTILS.isNumber(p14878)) {
      v12109 = false;
      p14878 = UTILS.getCurrentDropId();
    }
    var v12110 = config.twitchEvents[p14878];
    var v12111 = UTILS.getDropsTime(p14878);
    var v12112 = v12109 || !(v12111[1] <= 0);
    var vA657 = [];
    var v12113 = "<div class='twitchEventN'>" + (v12112 ? v12110.name : "NO DROPS AVAILABLE") + (v12110.desc && v12112 ? "<span class='twitchEventSub'>" + v12110.desc + "</span>" : "") + "</div><div class='twitchEventLinks'><div class='twitchEventLink' onclick='linkTwitch2()'>Click here to Link Your Twitch</div><div class='twitchEventLink'  onclick='openURL(location.origin, true)'>Return to Krunker</div></div>" + (v12112 ? "<div class='twitchEventDate'><div class='twitchEventContainer'><div class='twitchEventT'>What’s available to unlock via Twitch Drops from <strong>" + new Date(v12110.time.start).toLocaleString(undefined, {
      dateStyle: "medium",
      timeStyle: "long"
    }) + "</strong> until <strong>" + new Date(v12110.time.end).toLocaleString(undefined, {
      dateStyle: "medium",
      timeStyle: "long"
    }) + "</strong>.</div></div></div>" : "");
    if (v12112) {
      var v12114 = Game.store.skins.filter(p14883 => p14883 && p14883.event == p14878 && p14883.streamer);
      if (v12114.length) {
        v12113 += "<div class='twitchEventSDH'><div class='twitchEventContainer'><div class='twitchSection'>STREAMER DROPS<span class='twitchEventSub'>What’s available to unlock via specific streamers.</span></div>";
        v12113 += "<div class='twitchDropsList'>";
        v12114 = v12114.sort(function (p14884, p14885) {
          var v12115 = p14884.streamers;
          var v12116 = p14885.streamers;
          var v12117 = ~~!!p14882.find(p14886 => p14886.n && v12115.indexOf(p14886.n.toLowerCase()) > -1);
          var v12118 = ~~!!p14882.find(p14887 => p14887.n && v12116.indexOf(p14887.n.toLowerCase()) > -1);
          return v12118 - v12117;
        });
        for (var vLN02054 = 0; vLN02054 < v12114.length; vLN02054++) {
          var v12126 = v12114[vLN02054];
          var v12127 = UTILS.getItemDesc(v12126, Game.weapons, i18n);
          var v12128 = v12126.thumbnail;
          var v12122 = p14882.filter(p14888 => p14888.n && v12126.streamers.indexOf(p14888.n.toLowerCase()) > -1);
          if (v12122) {
            v12122 = v12122.sort(() => Math.random() - Math.random())[0];
          }
          var v12123 = v12122 ? v12122.n : v12126.streamers[0];
          v12113 += "<div class='twitchCard' onmouseenter='SOUND.play(`tick_0`,0.1)' oncontextmenu='viewItem(" + v12126.index + ", true)' onclick='openURL(&quot;https://twitch.tv/" + v12123 + "&quot;)'><div class='twitchCardHeader'><div class='twitchCardDetails'><div class='twitchCardAvatar'>" + (v12122 ? "<img src='https://static-cdn.jtvnw.net/jtv_user_pictures/" + v12122.lo + "'>" : "") + "</div><div class='twitchCardStreamer'><span class='twitchCardStreamerN'>" + v12123 + "</span>" + (v12122 ? "<div class='streamerStatus is-live'>Live</div>" : "<div class='streamerStatus'>Offline</div>") + "</div></div></div>";
          v12113 += "<div class='twitchCardImg'>";
          if (v12126 && v12126.type == itemTypes.SPRAY) {
            if (v12126.frames && vA657.indexOf(v12126.frames) == -1) {
              vA657.push(v12126.frames);
            }
            v12113 += "<div draggable='false' class='dropsSpray' style='background: url(&quot;" + v12126.thumbnail + "&quot;) -1px;" + UTILS.getFrameAnim(v12126, "dropsAnm") + "'></div>";
          } else {
            v12113 += "<img draggable='false' src='" + v12128 + "' />";
          }
          v12113 += "</div>";
          var v12129 = v12126.watch || v12110.time.watch;
          v12113 += "<div class='twitchCardFooter'><div class='twitchCardItemName'>" + v12126.name + " - " + v12127.replace(/item/gi, "") + "</div>" + (v12129 ? "<div class='twitchCardWatch'><span class='material-icons twitchCardItemTimeIcon'>query_builder</span>Watch " + v12129 + "</div>" : "") + (v12126.time ? "<div class='twitchCardTime'>" + v12126.time.start + " until " + v12126.time.end + "</div>" : "") + "</div>";
          v12113 += "</div>";
        }
        v12113 += "</div>";
        v12113 += "</div></div>";
      }
      var v12125 = Game.store.skins.filter(p14889 => p14889 && p14889.event == p14878 && !p14889.streamer);
      if (v12110.randDrop) {
        v12125 = [];
        for (var vLN02054 = 0; vLN02054 < v12110.rarities.length; ++vLN02054) {
          v12125.push({
            name: Game.store.rarities[v12110.rarities[vLN02054]].name + (v12110.type ? " " + v12110.type : "") + " Drop",
            rarity: v12110.rarities[vLN02054],
            thumbnail: UTILS.assetsUrl("img/drops/drop_" + v12110.rarities[vLN02054] + ".png"),
            randDrop: true
          });
        }
      }
      if (v12125.length) {
        v12113 += "<div class='twitchEventGDH'><div class='twitchEventContainer'><div class='twitchSection'>GENERAL DROPS<span class='twitchEventSub'>Available across all Drops Enabled Krunker streams.</span></div>";
        v12113 += "<div class='twitchDropsList'>";
        for (var vLN02054 = 0; vLN02054 < v12125.length; vLN02054++) {
          var v12126 = v12125[vLN02054];
          var v12127 = v12126.randDrop ? null : UTILS.getItemDesc(v12126, Game.weapons, i18n);
          var v12128 = v12126.thumbnail;
          if (v12126.frames && vA657.indexOf(v12126.frames) == -1) {
            vA657.push(v12126.frames);
          }
          v12113 += "<div class='twitchCard' onmouseenter='SOUND.play(`tick_0`,0.1)' " + (v12126.randDrop ? " " : "oncontextmenu='viewItem(" + v12126.index + ", true)' ") + "onclick='openURL(&quot;https://www.twitch.tv/directory/game/Krunker&quot;)'><div class='twitchCardHeader'><div class='twitchCardDetails'><div class='twitchCardStreamer'><span class='twitchCardStreamerN'>All Streamers</span></div></div></div>";
          v12113 += "<div class='twitchCardImg'>";
          if (v12126 && v12126.type == itemTypes.SPRAY) {
            if (v12126.frames && vA657.indexOf(v12126.frames) == -1) {
              vA657.push(v12126.frames);
            }
            v12113 += "<div draggable='false' class='dropsSpray' style='background: url(&quot;" + v12126.thumbnail + "&quot;) -1px;" + UTILS.getFrameAnim(v12126, "dropsAnm") + "'></div>";
          } else {
            v12113 += "<img draggable='false' src='" + v12128 + "' />";
          }
          v12113 += "</div>";
          var v12129 = v12126.watch || v12110.time.watch;
          v12113 += "<div class='twitchCardFooter'><div class='twitchCardItemName'>" + v12126.name + (v12126.randDrop ? "" : " - " + v12127.replace(/item/gi, "")) + "</div>" + (v12129 ? "<div class='twitchCardWatch'><span class='material-icons twitchCardItemTimeIcon'>query_builder</span>Watch " + v12129 + "</div>" : "") + (v12126.time ? "<div class='twitchCardTime'>" + v12126.time.start + " until " + v12126.time.end + "</div>" : "") + "</div>";
          v12113 += "</div>";
        }
        v12113 += "</div>";
        v12113 += "</div></div>";
      }
      if (vA657.length) {
        v12113 += "<style>";
        for (var vLN02054 = 0; vLN02054 < vA657.length; vLN02054++) {
          v12113 += "@keyframes dropsAnm" + vA657[vLN02054] + " {100%{background-position:-" + vA657[vLN02054] * 351 + "px}}";
        }
        v12113 += "</style>";
      }
    }
    uiBase.innerHTML = v12113;
    clearPops = function () {};
  });
}
function io_initLoad(p14890, p14891, p14892) {
  v10545 = p14891;
  if (!!vF1730 && !v10514 && !window.OffCliV) {
    f1814();
  }
  if (window.utilities) {
    io_disconnect(null, null, null, true);
    f1814();
  }
  io.send("load");
}
function refreshTwitchStreams(p14893 = false) {
  if (window.canShowTwitch) {
    lastStreamRefreshTime = Date.now();
    if (p14893) {
      streamAutoRefreshEnabled = true;
    }
    API_CLIENT.listStreams(0, function (p14894, p14895) {
      if (p14895 && p14895.length) {
        vA656 = p14895;
      }
      if (vLN02047 == 0 && p14893) {
        f2045(vA656);
      }
    });
    return;
  } else {
    streamContainer.style.display = "none";
    return false;
  }
}
function io_ready(p14896) {
  if (p14896) {
    refreshTwitchStreams(true);
    API_CLIENT.listMaps(2, 0, null, function (p14897, p14898) {
      f2054(p14898);
    });
    f1786();
    f1810();
    f1782();
    if (v10540 != config.gameVersion) {
      updateAd.style.display = "block";
      updateAdVersion.textContent = "Update v" + config.gameVersion;
    }
  } else {
    io.socket.close();
  }
}
var newsPanelIndex = 0;
var newsScrollTimer = 5000;
var v12130 = null;
function updateNewsStats() {
  if (v12130.length > 0) {
    newsStatV.innerHTML = UTILS.formatNumYT(v12130 && v12130[newsPanelIndex] && v12130[newsPanelIndex].map_pl || 0);
  }
}
function f2054(p14899) {
  if (p14899 && p14899.data) {
    v12130 = UTILS.shuffleArray(p14899.data);
    var vLN02056 = 0;
    var vLS109 = "";
    for (var vLN02057 = 0; vLN02057 < v12130.length; ++vLN02057) {
      var v12131 = v12130[vLN02057];
      var vO371 = {};
      if (v12131.map_info) {
        try {
          vO371 = JSON.parse(v12131.map_info);
        } catch (e153) {}
      }
      if (vO371.t) {
        vLS109 += "<div class='newsItem'><img src='" + UTILS.userAssetsUrl("/m" + +v12131.map_id + "/thumb.png") + "' class='newsIMG'  onclick='openURL(&quot;/?play=" + v12131.map_name + "&quot;, 1)' /></div>";
        vLN02056++;
      }
      if (vLN02056 >= 5) {
        break;
      }
    }
    newsBody.innerHTML = vLS109;
    newsHed.style.display = "block";
    newsBody.style.display = "block";
    updateWindow(10);
    updateNewsStats();
  }
}
const v12132 = window.log || console.log;
function io_scriptLog(p14900, p14901) {
  v12132("%c[KRUNKSCRIPT] " + p14901.join(" "), (p14900 ? "background:#3a0000;" : "") + "color:#d50000");
}
var v12133 = false;
var spinnerUpdateInterval = null;
function loadStart(progressCallback) {
  if (!isNode && !webdriver && arrayIsArray) {
    var vF1727 = f1727();
    if ((!vF1727 || !vF1727.includes || !vF1727.includes("conmeego") && !vF1727.includes("krunkerio")) && !window.clientUtil && !v12133) {
      v12133 = true;
      if (progressCallback) {
        progressCallback(0.5);
      }
      if (params.get("qP")) {
        saveVal("queuePort", params.get("qP"));
      }
      if (params.get("qH")) {
        saveVal("queueHost", params.get("qH"));
      }
      if (params.get("bpt")) {
        saveVal("bpt", params.get("bpt"));
      }
      if (params.get("gId")) {
        saveVal("gId", params.get("gId"));
      }
      if (params.get("tc")) {
        testCode = params.get("tc");
        saveVal("testCode", params.get("tc"));
      }
      var v12135 = params.has("test") || params.has("sandbox") ? config.blankMap : null;
      var vGetSavedVal15 = getSavedVal("custMap");
      deleteVal("custMap");
      if (params.has("twitch_info") || params.has("twitch_drops")) {
        loadTwitchDrops(twitchDropsInfo);
      } else if (vGetSavedVal15 || v12135) {
        loadSandbox(vGetSavedVal15 || v12135);
      } else if (window.isBotFTUE) {
        loadFTUEMap();
      } else {
        loadMatch();
      }
      if (progressCallback) {
        progressCallback(0.7);
      }
      lastUpdateRateTime = performance.now();
      lastGameTime = Date.now();
      gameLoop();
      if (!spinnerUpdateInterval) {
        clearInterval(spinnerUpdateInterval);
      }
      spinnerUpdateInterval = setInterval(function () {
        f2034();
      }, config.staticDlt);
      if (progressCallback) {
        progressCallback(1);
      }
      f2076();
    }
  }
}
function f2057(p14903) {
  var vGetSavedVal16 = getSavedVal(p14903);
  if (UTILS.isString(vGetSavedVal16)) {
    vGetSavedVal16 = vGetSavedVal16.split(",");
  } else if (!Array.isArray(vGetSavedVal16)) {
    vGetSavedVal16 = [];
  }
  return vGetSavedVal16.map(Number).filter(p14904 => UTILS.isNumber(p14904));
}
window.changeQuickPlay = function (p14905, p14906, p14907) {
  var vF2057 = f2057("seek_" + p14906);
  var v12136 = vF2057.indexOf(p14907);
  if (p14905.checked && v12136 >= 0) {
    vF2057.splice(v12136, 1);
  } else if (!p14905.checked && v12136 == -1) {
    vF2057.push(p14907);
  }
  saveVal("seek_" + p14906, vF2057);
};
window.quickPlayPopup = function () {
  f1822(window.event);
  var vLS110 = "";
  var v12137 = Game.map.rotationMaps;
  var vA658 = [];
  var vF20572 = f2057("seek_maps");
  var vF20573 = f2057("seek_modes");
  vLS110 += "<div><div style='color: #fff;font-size: 24px;'>Select Maps:</div>";
  for (var vLN02060 = 0, v12138; vLN02060 < maps.length; vLN02060++) {
    v12138 = maps[vLN02060];
    if (v12137.indexOf(vLN02060) != -1) {
      for (var v12139 = v12138.config && v12138.config.modes ? v12138.config.modes : [0], vLN02059 = 0; vLN02059 < v12139.length; vLN02059++) {
        if (vA658.indexOf(v12139[vLN02059]) == -1) {
          vA658.push(v12139[vLN02059]);
        }
      }
      var v12142 = vF20572.indexOf(vLN02060) == -1;
      vLS110 += "<label class='quickPlayMap'><div class='quickPlayMapName blackShad'>" + UTILS.capFirst(v12138.name) + "</div><input onclick='playSelect(0.1)' type='checkbox'" + (v12142 ? "checked" : "") + " onchange='changeQuickPlay(this, &quot;maps&quot;, " + vLN02060 + ")'><img loading='lazy' onmouseenter='playTick();' draggable='false' class='quickPlayMapImg' src='" + UTILS.assetsUrl("/img/maps/map_" + vLN02060 + ".png") + "'></label>";
    }
  }
  vLS110 += "</div>";
  vA658.sort((p14908, p14909) => p14908 - p14909);
  vLS110 += "<div><div style='color: #fff;font-size: 24px;margin-top: 10px;'>Select Modes:</div>";
  for (var vLN02060 = 0, v12141; vLN02060 < vA658.length; vLN02060++) {
    v12141 = gameModes[vA658[vLN02060]];
    if (!v12141.preventCustomGames || account && account.isDev) {
      var v12142 = vF20573.indexOf(vA658[vLN02060]) == -1;
      vLS110 += "<label class='hostOpt' style='width: 172px;!important'onmouseenter='playTick()'><span class='optName'>" + UTILS.capFirst(v12141.name) + "</span><input type='checkbox'" + (v12142 ? "checked" : "") + " onchange='changeQuickPlay(this, &quot;modes&quot;, " + vA658[vLN02060] + ")'><div class='optCheck'></div></label>";
    }
  }
  vLS110 += "</div>";
};
function f2058(p14910) {
  loadGamNm.innerHTML = p14910 || i18n.t("generic.loading.simple") + "...";
  Object(vP132243.navigateBackAll)();
}
window.quickConnect = function (p14911) {
  if (FRVR.channelCharacteristics.allowNavigation) {
    Object(vP132243.navigateBackAll)();
  }
  vF1734 = v10536 = p14911;
  if (!FRVR.channelCharacteristics.allowNavigation) {
    f2058(i18n.t("generic.loading.simple") + " " + (p14911 || "") + " ...");
  }
  loadMatch();
};
function f2059() {
  account = null;
  friends = null;
  accountStateFlag = false;
  io_updateAccount();
}
let v12143 = false;
function loadMatch() {
  f2059();
  var vGetSavedVal17 = getSavedVal("queuePort");
  var vGetSavedVal18 = getSavedVal("queueHost");
  deleteVal("queueHost");
  deleteVal("queuePort");
  var vGetSavedVal19 = getSavedVal("bpt");
  deleteVal("bpt");
  var vGetSavedVal20 = getSavedVal("gId");
  deleteVal("gId");
  if (vGetSavedVal19) {
    joinServer(vGetSavedVal18, vGetSavedVal17, vGetSavedVal20, null, vGetSavedVal19);
  } else {
    Promise.resolve(v10510 ? vWP_MMToken : null).then(p14912 => {
      v10548 = p14912 = v10510 ? vWP_MMToken.split("").map(p14913 => String.fromCharCode(p14913.charCodeAt(0) - 5)).join("") : undefined;
      let vO372 = {
        [serverProps.VERSION]: version
      };
      if (config.useLooseClient) {
        delete vO372[serverProps.VERSION];
      }
      if (vF1734) {
        window.windows[1].autoPlaySearch = vF1734;
        vO372[serverProps.INFO] = vF1734;
        return client.seek({
          regionId: "any",
          gameId: null,
          autoChangeGame: false,
          dataQuery: vO372,
          skipReplaceState: SETTINGS.tmp.streamMode || !FRVR.channelCharacteristics.allowNavigation,
          validationToken: p14912
        });
      } else {
        var vF20574 = f2057("seek_maps");
        if (vF20574 && vF20574.length) {
          vO372[serverProps.DONT_SEEK_MAPS] = vF20574;
        }
        var vF20575 = f2057("seek_modes");
        if (vF20575 && vF20575.length) {
          vO372[serverProps.DONT_SEEK_MODES] = vF20575;
        }
        let vO373 = {
          autoChangeGame: false,
          dataQuery: vO372,
          skipReplaceState: SETTINGS.tmp.streamMode || !FRVR.channelCharacteristics.allowNavigation,
          validationToken: p14912
        };
        return client.seek(vO373);
      }
    }).then(p14914 => {
      vF1734 = false;
      joinServer(p14914.host, p14914.port, p14914.gameId, p14914.clientId);
    }).catch(p14915 => {
      window.gameLoaded = true;
      console.warn("Matchmaker error:", p14915, p14915.message, p14915.response);
      let v12144 = p14915.message;
      let v12145;
      if (p14915.response) {
        v12144 = p14915.response.data && p14915.response.data.error ? p14915.response.data.error : "GameIssue";
        v12145 = v12144;
        if (v12144 == "InvalidGameId" && FRVR.channelCharacteristics.allowNavigation) {
          window.history.replaceState(document.title, document.title, vF91(window.location, "/", vA577));
        }
        var v12146 = i18n.has("matchmaker." + v12144);
        if (v12146) {
          v12144 = v12146;
        } else {
          v12145 = undefined;
          console.warn("Unhandled error message", v12144);
        }
      } else {
        console.warn("No error response", p14915.response);
      }
      if (FRVR.channelCharacteristics.allowNavigation && vF1734) {
        openURL("/?host=" + vF1734, 1);
      } else if (vF1734 && v12145 == ClientManager.ERRORS.NoServersMatchQuery) {
        vF17342 = vF1734;
        vF1734 = false;
        loadMatch();
      } else {
        io_error(v12144, null, v12145);
      }
    });
  }
}
var v12147;
function io_conUid(p14916) {
  v12147 = p14916;
  saveVal("conUID_", p14916);
}
function joinServer(host, port, gameId, clientId, bpt) {
  window.gameLoaded = true;
  if (SETTINGS.tmp.netRerouting && host.startsWith("ip_")) {
    host = "cf_" + host;
  }
  v10549 = port;
  v10546 = host;
  var vA659 = [];
  var vGetSavedVal21 = getSavedVal("conUID_");
  if (gameId) {
    vA659.push("gameId=" + gameId);
  }
  if (clientId) {
    vA659.push("clientKey=" + clientId);
  }
  if (vGetSavedVal21) {
    vA659.push("clientUID=" + vGetSavedVal21);
    deleteVal("conUID_");
  }
  if (bpt) {
    vA659.push("bpt=" + bpt);
  }
  if (testCode) {
    vA659.push("tc=" + testCode);
  }
  var v12148 = "//" + host + ":" + port + "/ws?" + vA659.join("&");
  if (io) {
    if (!FRVR.channelCharacteristics.allowNavigation) {
      tmpPlayer = null;
    }
    io.reset();
  }
  io.connect(v12148, function (p14922) {
    if (p14922) {
      console.warn("IO connect error", p14922.error);
      if (vUndefined8 != null) {
        f2077("disconnect");
        return;
      }
      io_disconnect(null, "000001", p14922);
    } else if (vF17342) {
      autoHostMap(vF17342, true);
    } else {
      var vGetSavedVal22 = getSavedVal("mapToLoad");
      deleteVal("mapToLoad");
      if (vGetSavedVal22) {
        selectHostMap(vGetSavedVal22);
      }
      var vGetSavedVal23 = getSavedVal("custToLoad");
      deleteVal("custToLoad");
      if (vGetSavedVal23) {
        selectHostMap(false, vGetSavedVal23);
      }
      var vGetSavedVal24 = getSavedVal("mapToPlay");
      deleteVal("mapToPlay");
      if (vGetSavedVal24) {
        autoHostMap(vGetSavedVal24);
      }
    }
  }, {
    n: io_nukeUpdate,
    bbm: io_bombardmentUpdate,
    0: io_addPlayers,
    "00": io_updateNames,
    k: io_updatePlayers,
    code: io_enterCode,
    codeT: io_updateCodeTimer,
    codeP: io_codePassed,
    init: io_initGame,
    "inst-id": io_inst_id,
    load: io_initLoad,
    refL: io_refL,
    vr: io_redeemVoucherResponse,
    ctrR: crtrCodRes,
    kml: io_addMail,
    cust: io_customResponse,
    ready: io_ready,
    cln: io_clanResponse,
    start: io_startGame,
    nwT: newTok,
    pur: io_purchaseResponse,
    purprm: io_purchasePremiumResponse,
    purb: io_purchaseBundleResponse,
    purbp: windows[5].purchaseRes,
    purbpl: windows[5].purchaseLvlRes,
    bpclmr: windows[5].claimItemRes,
    gmsg: io_updateGameMessage,
    lkt: io_updateLockoutTim,
    inat: io_playerInteractions,
    inatA: io_allPlayerInteractions,
    sb: io_showSpeechBubble,
    clnL: io_clanLeaveResponse,
    upR: io_uploadResponse,
    upPR: io_uploadProfileResponse,
    lock: io_lockPlayer,
    end: io_endGame,
    spin: io_spinResponse,
    spinH: io_saveSpinHistory,
    spinW: io_spinWheelResponse,
    skin: io_skinReward,
    skinF: io_skinFoundMessage,
    spinKR: io_skinKR,
    ts: io_teamScore,
    t: io_updateTimer,
    pErr: purchaseError,
    error: io_error,
    dc: io_disconnect,
    unb: io_unboxMessage,
    unbS: io_unboxMesssageS,
    zn: Game.updateZone,
    uf: io_updateFunds,
    chlR: io_updateChallengeRewards,
    l: io_syncPlayer,
    f: io_syncFailed,
    ufi: io_updateFlagInfo,
    debug: io_setDebug,
    exf: io_setExperimental,
    noc: io_setNoclip,
    frz: io_setFrozen,
    spb: io_setSpeedBoost,
    unl: io_setUnlimited,
    sic: io_setSharingIsCaring,
    s: io_playerSound,
    c: io_playerAnim,
    7: io_updateLeaders,
    sp: Game.addSpray,
    ch: io_addChat,
    chi: io_addChati18n,
    tch: io_addTradeChat,
    9: io_showTracer,
    10: io_getAssist,
    h: io_changeHealth,
    so: io_playSound,
    sso: io_stopSound,
    6: io_getKill,
    p: io_interProg,
    mp: io_interMProg,
    lv: io_updateLives,
    ua: io_updateAccount,
    ex: io_explosion,
    ac: io_actionFeed,
    vc: io_voiceChat,
    a: io_accountResponse,
    4: io_doDamage,
    5: io_getScore,
    ufp: Game.updateFlagPing,
    fh: io_setHidden,
    bnk: Game.updateBank,
    uamo: io_updateAmmo,
    upp: io_newPassResponse,
    c2fa: twoFAres,
    ro: Game.respawnObj,
    st: io_killStreak,
    pk: io_effect,
    upk: io_updateZombiePerks,
    2: io_removePlayer,
    dbgp: io_addDebugPoing,
    recps: windows[13].craftDatRes,
    crftr: windows[13].craftRes,
    sd: io_customNetworkMessage,
    kpdf: io_kpdReset,
    kpd: policeRes,
    clog: console.log,
    3: io_killPlayer,
    wstk: io_updateWeaponStreak,
    krp: io_krPackage,
    ufl: Game.updateFlag,
    kst: io_killStreakM,
    am: io_addMedal,
    gt: Game.logTime,
    gte: Game.updateGate,
    mybx: Game.updateMysteryBox,
    smybx: Game.switchMysteryBox,
    krm: Game.updateKrumMachine,
    pwup: io_updatePowerUp,
    lm: io_lockMove,
    rml: io_openMail,
    gmc: io_updateMail,
    chp: io_checkPointSet,
    chgp: io_changePosition,
    ulm: Game.unlockMove,
    is: Game.triggerImgSound,
    pi: io_socketPing,
    mv: updMatchVote,
    frs: enterGame,
    chg: io_updateChallenges,
    uchp: io_updateChallengesProgress,
    vk: io_voteKick,
    vf: io_voteForfeit,
    pir: io_socketPingResult,
    scr: jumpScare,
    up: io_updateProp,
    prpR: io_updatePropRot,
    pr: io_showProjectile,
    bmb: io_showBombardment,
    chgC: io_challengeCompleted,
    flgr: io_countryFlagUpdate,
    bdgr: io_badgeUpdate,
    cbdgr: io_badgeClaimResponse,
    nbdgr: io_badgeClaimMultiRes,
    hdsr: io_hideStatus,
    tm: io_updateTeam,
    pre: io_endProjectile,
    wep: Game.setWeapon,
    do: Game.destroyObj,
    mo: Game.teleportToNode,
    mf: Game.teleportFromNode,
    obj: Game.setObjective,
    uobj: Game.updateObjective,
    prmR: io_premiumResponse,
    nmeR: io_aliasResponse,
    trd: io_tradeResponse,
    pRes: io_showPopup,
    lmsg: io_loadingPopup,
    ann: io_announcement,
    utrd: io_updateTradeResponse,
    atrd: io_tradeAResponse,
    tdR: io_tdR,
    nftR: io_nftResponse,
    pdR: io_promosResponse,
    dsrvl: io_dediBuyResponse,
    gfrnd: io_friendsListResponse,
    vm: window.voteMap,
    loadS: io_updateSettings,
    crsp: io_createSpawnable,
    dsp: Game.disposeSpawnable,
    vtRes: io_vtRes,
    rtRes: io_rtRes,
    reCa: io_reCa,
    bo: Game.buildObj,
    aai: Game.AI.cSpawn,
    rai: Game.AI.removeBySid,
    ai: Game.AI.syncAll,
    ad: Game.airDrop.cSync,
    rad: Game.airDrop.removeBySid,
    ana: io_servAnim,
    spk: io_setPlayerKey,
    rfl: io_refillKnife,
    cv: io_customVal,
    cnfm: io_confirmInteraction,
    edMp: io_editMap,
    xst: io_loadXsolla,
    rg: io_regenPlayer,
    ulb: io_updateLeaderBoard,
    rds: io_updateRoundsDis,
    gv: io_updateGlobalValue,
    cd: io_syncPConData,
    cda: io_syncPConObj,
    tgui: io_toggleElement,
    fe: io_failedToEnder,
    tx: io_textPopup,
    upz: io_updateZombieRound,
    uid: io_conUid,
    hlpr: RENDER.addHelperC,
    hbdb: io_addHitboxHelper,
    shk: RENDER.shake,
    ksL: io_scriptLog,
    cct: io_captureControl,
    uct: io_updateDomZone,
    chrg: io_setPlayerCharged,
    uai: io_updateAssetId,
    uh: io_updateHost,
    camb: changeAmbient,
    jnk: io_foundJunk,
    gbdr: io_availableBundleData,
    abd: io_allBundleData,
    vad: window.forceVideoAd,
    vmm: io_openMetamaskAuth,
    vmms: io_metamaskLinkResponse,
    rmm: io_metamaskUnlinkResponse,
    krt: io_updateKrTags,
    bcfg: botsPopup,
    jg: io_setJuggernaut,
    busy: io_setBusy,
    asnd: Game.addPlayerSound,
    rsnd: Game.removePlayerSound,
    cntry: io_updateCountry,
    bh: io_updateHeadSize,
    bpdl: io_dataLoaded,
    rrqdxp: io_recieveDoubleXp,
    bppd: io_syncBpProg,
    svybRes: io_surveyBundleResponse
  });
}
function initSandboxGame(rawMapData) {
  var sandboxConfig = parseSandboxMapConfig(rawMapData);
  if (window.isBotFTUE) {
    sandboxConfig.gameTime = 2;
  }
  sandboxGame = new GameObj(false, null, {
    call: () => {},
    callMultiple: () => {}
  }, null, null, null, null, null, null, {
    send: () => {}
  });
  window.sandboxGame = sandboxGame;
  sandboxGame.isSandbox = true;
  sandboxGame.isBotFTUE = window.isBotFTUE;
  sandboxGame.sandbox = ioSandbox;
  sandboxGame.sandbox.socketId = io.socketId;
  var mapIndex = 2;
  sandboxGame.prepareGame(sandboxConfig.rawMapData, null, null, null, mapIndex, true, undefined, undefined, undefined, true);
  if (sandboxConfig.modURL) {
    sandboxGame.modURL = sandboxConfig.modURL;
  } else {
    delete sandboxGame.modURL;
  }
  if (sandboxConfig.welMsg) {
    sandboxGame.welMsg = sandboxConfig.welMsg;
  } else {
    delete sandboxGame.welMsg;
  }
  sandboxGame.applyConfig(sandboxConfig, mapIndex, 0);
  sandboxGame.passCode = sandboxConfig.passCode;
  sandboxGame.private = !!sandboxConfig.private;
  sandboxGame.krRewards = !!sandboxConfig.krRewards;
  sandboxGame.mimicPubs = !!sandboxConfig.mimicPubs;
  sandboxGame.defaultSetts = !!sandboxConfig.defaultSetts;
  sandboxGame.maxPlayers = sandboxGame.config.maxPS ? 40 : sandboxGame.config.maxPlayers;
  sandboxGame.init(undefined, undefined, 0, true, false).then(() => {
    sandboxGame.broadcast("init", sandboxGame.mapIndex, sandboxGame.modeIndex, sandboxGame.eventIndex, sandboxGame.getTeamScores(true), sandboxGame.getTeamScores(), sandboxGame.host, sandboxGame.config, sandboxGame.customData, sandboxGame.modURL || 0, sandboxGame.customMapData, sandboxGame.getSyncData(), sandboxGame.networkData, true, !!sandboxGame.isOfficial, sandboxGame.isComp, sandboxGame.sessionId, sandboxGame.roundId, sandboxGame.gameTimer);
    try {
      var parsed = JSON.parse(rawMapData);
      if (parsed && parsed.player) {
        enterGame(true);
        io_setNoclip(true);
        sandboxPlayer.xDire = parsed.player.rot[0];
        sandboxPlayer.yDire = parsed.player.rot[1];
        sandboxPlayer.x = parsed.player.pos[0];
        sandboxPlayer.y = parsed.player.pos[1];
        sandboxPlayer.z = parsed.player.pos[2];
      }
    } catch (e154) {}
    if (sandboxGame.isBotFTUE) {
      sandboxGame.bots.setupLocal();
    }
  });
}
function f2064() {
  window.fullMenu();
  tlInfHold.style.display = "none";
  subLogoButtons.style.display = "none";
  streamContainer.style.top = "15px";
  topRightAdHolder.style.top = "15px";
  newsHolder.style.display = "none";
  signedOutHeaderBar.style.display = "none";
  signedInHeaderBar.style.display = "none";
  headerRight.style.display = "none";
  menuItemContainer.style.top = "0px";
  menuBtnMaps.parentNode.classList.toggle("mIH", true);
  menuBtnChall.parentNode.classList.toggle("mIH", true);
  menuBtnShop.parentNode.classList.toggle("mIH", true);
  menuBtnProfile.parentNode.classList.toggle("mIH", true);
  if (window.canShowAds) {
    topLeftAdHolder.style.display = "inline-block";
  }
  if (FRVR.channelCharacteristics.allowNavigation) {
    window.history.replaceState({}, "Krunker Sandbox", "?sandbox");
  }
}
function f2065() {
  vLN02047 = 1;
  f2045();
}
function f2066() {
  if (io && io.socket) {
    io.socket.close();
  }
  io.send = function () {};
  if (!window.isBotFTUE) {
    f2064();
  }
  f2065();
  f1771();
}
function parseSandboxMapConfig(p14924) {
  var vO374 = {};
  try {
    var v12150 = JSON.parse(p14924);
    if (v12150 && v12150.config) {
      vO374 = v12150.config.settings || {};
      vO374.weps = v12150.config.weps || null;
      vO374.cls = v12150.config.cls || null;
      vO374.prks = v12150.config.prks || null;
      if (v12150.config.classes) {
        vO374.classes = v12150.config.classes;
      }
      if (v12150.config.modes) {
        vO374.modes = v12150.config.modes;
      }
      if (v12150.modURL) {
        vO374.modURL = v12150.modURL;
      }
      if (v12150.welMsg) {
        vO374.welMsg = v12150.welMsg;
      }
    }
  } catch (e155) {}
  vO374.rawMapData = p14924;
  vO374.maps = [0];
  vO374.modes = vO374.modes && vO374.modes.length ? vO374.modes : [0];
  vO374.classes = vO374.classes || Array.from(Array(14), (p14925, p14926) => p14926);
  vO374.passCode = undefined;
  if (vO374.modes.length == 0) {
    vO374.modes = [0];
  }
  for (var vLN02061 = 0; vLN02061 < config.serverConfig.length; vLN02061++) {
    var v12151 = vO374.settings && vO374.settings[config.serverConfig[vLN02061].varN] != null ? vO374.settings[config.serverConfig[vLN02061].varN] : config.serverConfig[vLN02061].def;
    var v12152;
    v12152 = config.serverConfig[vLN02061].bool ? v12151 ? 1 : 0 : config.serverConfig[vLN02061].input ? v12151 ? UTILS.sanitizeStr(v12151) : 0 : config.serverConfig[vLN02061].select ? parseInt(v12151) : v12151 ? parseFloat(v12151) : 0;
    vO374[config.serverConfig[vLN02061].varN] = v12152;
  }
  return vO374;
}
function connectToSandbox(rawMapData) {
  ioSandbox.connect(null, () => {
    io.socketId = UTILS.randomString(12);
    Game.isSandbox = true;
    Game.sandbox = ioSandbox;
    Game.sandbox.socketId = io.socketId;
    f2066();
    try {
      initSandboxGame(rawMapData);
    } catch (e156) {}
  }, {
    n: io_nukeUpdate,
    bbm: io_bombardmentUpdate,
    0: io_addPlayers,
    "00": io_updateNames,
    k: io_updatePlayers,
    init: io_initGame,
    "inst-id": io_inst_id,
    load: io_initLoad,
    cust: io_customResponse,
    ready: io_ready,
    start: io_startGame,
    nwT: newTok,
    gmsg: io_updateGameMessage,
    lkt: io_updateLockoutTim,
    inat: io_playerInteractions,
    inatA: io_allPlayerInteractions,
    lock: io_lockPlayer,
    end: io_endGame,
    ts: io_teamScore,
    t: io_updateTimer,
    error: io_error,
    dc: io_disconnect,
    zn: Game.updateZone,
    l: io_syncPlayer,
    f: io_syncFailed,
    ufi: io_updateFlagInfo,
    debug: io_setDebug,
    exf: io_setExperimental,
    noc: io_setNoclip,
    frz: io_setFrozen,
    spb: io_setSpeedBoost,
    unl: io_setUnlimited,
    sic: io_setSharingIsCaring,
    s: io_playerSound,
    c: io_playerAnim,
    7: io_updateLeaders,
    sp: Game.addSpray,
    9: io_showTracer,
    10: io_getAssist,
    h: io_changeHealth,
    so: io_playSound,
    sso: io_stopSound,
    6: io_getKill,
    p: io_interProg,
    mp: io_interMProg,
    lv: io_updateLives,
    ex: io_explosion,
    ac: io_actionFeed,
    4: io_doDamage,
    5: io_getScore,
    ufp: Game.updateFlagPing,
    fh: io_setHidden,
    bnk: Game.updateBank,
    uamo: io_updateAmmo,
    ro: Game.respawnObj,
    st: io_killStreak,
    pk: io_effect,
    upk: io_updateZombiePerks,
    2: io_removePlayer,
    sd: io_customNetworkMessage,
    clog: console.log,
    3: io_killPlayer,
    wstk: io_updateWeaponStreak,
    krp: io_krPackage,
    ufl: Game.updateFlag,
    kst: io_killStreakM,
    am: io_addMedal,
    gt: Game.logTime,
    gte: Game.updateGate,
    mybx: Game.updateMysteryBox,
    smybx: Game.switchMysteryBox,
    krm: Game.updateKrumMachine,
    pwup: io_updatePowerUp,
    lm: io_lockMove,
    chp: io_checkPointSet,
    chgp: io_changePosition,
    ulm: Game.unlockMove,
    is: Game.triggerImgSound,
    pi: io_socketPing,
    frs: enterGame,
    pir: io_socketPingResult,
    scr: jumpScare,
    up: io_updateProp,
    prpR: io_updatePropRot,
    pr: io_showProjectile,
    bmb: io_showBombardment,
    tm: io_updateTeam,
    pre: io_endProjectile,
    wep: Game.setWeapon,
    do: Game.destroyObj,
    mo: Game.teleportToNode,
    mf: Game.teleportFromNode,
    obj: Game.setObjective,
    uobj: Game.updateObjective,
    pRes: io_showPopup,
    vm: window.voteMap,
    crsp: io_createSpawnable,
    dsp: Game.disposeSpawnable,
    bo: Game.buildObj,
    aai: Game.AI.cSpawn,
    rai: Game.AI.removeBySid,
    ai: Game.AI.syncAll,
    ad: Game.airDrop.cSync,
    rad: Game.airDrop.removeBySid,
    ana: io_servAnim,
    spk: io_setPlayerKey,
    rfl: io_refillKnife,
    cv: io_customVal,
    cnfm: io_confirmInteraction,
    rg: io_regenPlayer,
    ulb: io_updateLeaderBoard,
    rds: io_updateRoundsDis,
    gv: io_updateGlobalValue,
    cd: io_syncPConData,
    cda: io_syncPConObj,
    tgui: io_toggleElement,
    tx: io_textPopup,
    shk: RENDER.shake,
    ksL: io_scriptLog,
    cct: io_captureControl,
    uct: io_updateDomZone,
    chrg: io_setPlayerCharged,
    uai: io_updateAssetId,
    uh: io_updateHost,
    camb: changeAmbient,
    krt: io_updateKrTags,
    jg: io_setJuggernaut,
    busy: io_setBusy,
    asnd: Game.addPlayerSound,
    rsnd: Game.removePlayerSound,
    bh: io_updateHeadSize
  });
}
if (window.captchaReady) {
  grecaptcha.enterprise.ready(function () {});
} else {
  window.captchaCallback = function () {
    grecaptcha.enterprise.ready(function () {});
  };
}
function f2069() {
  var v12153 = "<div class=\"dxp-img-holder\">\n\t\t\t<div class=\"dxp-img-anim\"><div></div></div>\n\t\t\t<div class=\"dxp-img\"></div>\n\t\t</div>\n\t\t<div class=\"dxp-text\">\n\t\t\t<div class=\"dxp-header\">" + i18n.t("window.endgame.player.xpDoubled") + "</div>\n\t\t\t<div class=\"dxp-info\">" + i18n.t("window.endgame.player.xpDoubleSubTitle") + "</div>\n\t\t</div>\n\t\t<div class=\"dxp-btn-holder\">\n\t\t\t<div class='button dxp-btn' onmouseenter=\"playTick(0.1);\" onclick='playSelect(0.1);clearPops();'>" + i18n.t("generic.nice") + "</div>\n\t\t</div>";
  genericPopup(v12153, "dxp-pop no-box-shadow");
}
var v12154 = false;
function io_recieveDoubleXp(p14928) {
  if (account && p14928 && p14928.playerScore) {
    account.score = p14928.playerScore;
    account.lastDoubleAttempt = account.games;
    updateMenuAccountData();
    f2069();
  }
}
var vLN02062 = 0;
Object.defineProperty(window, "forceVideoAd", {
  writeable: false,
  value: function () {
    var now = Date.now();
    if (now - (vLN02062 || 0) >= 90000) {
      vLN02062 = now;
      io.send("vad", 1);
      showAd({
        onShow: () => io.send("vad", 2),
        onComplete: () => requestAnimationFrame(() => io.send("vad", 3), 200),
        onError: () => io.send("vad", -1)
      });
    }
  }
});
Object.defineProperty(window, "showDoubleXPRewardedAd", {
  writeable: false,
  value: function () {
    initGameUI.endScreen.clicked2XP = true;
    let v12156 = document.getElementById("doubleXPHolder");
    if (v12156) {
      v12156.style.display = "none";
    }
    account.lastDoubleAttempt = account.games;
    window.showRewardedAd(claimDoubleXpReward);
  }
});
Object.defineProperty(window, "showRewardedAd", {
  writeable: false,
  value: function (p14929) {
    if (v10514 && p14929) {
      p14929();
    }
    Object(vP132243.navigateBackAll)();
    window.showAd({
      onExit: p14929
    });
  }
});
Object.defineProperty(window, "showAd", {
  writeable: false,
  value: function ({
    type = FRVR.ads.AdType.REWARD,
    onShow: iÎíìííi,
    onComplete: iÎîïîíi,
    onError: iIîiîíi,
    onExit: iÎiíîíï
  }) {
    if (!v12154) {
      v12154 = true;
      FRVR.ads.show(type).then(function (p14930) {
        if (iÎíìííi) {
          iÎíìííi();
        }
        if (p14930 === FRVR.ads.AdShowResult.COMPLETED) {
          if (iÎîïîíi) {
            iÎîïîíi();
          }
        } else if (p14930 === FRVR.ads.AdShowResult.DELIVERED) {
          throw "skipped";
        } else {
          throw "ad-failed";
        }
      }).catch(p14931 => {
        if (iIîiîíi) {
          iIîiîíi(p14931);
        }
        Object(vP132243.navigateBack)();
      }).finally(() => {
        v12154 = false;
        if (iÎiíîíï) {
          iÎiíîíï();
        }
      });
    }
  }
});
function claimDoubleXpReward() {
  if (account && account.id && account.games % 3 == 0 && account.games != 0) {
    io.send("rqdxp");
  }
}
var vA660 = [{
  img: UTILS.assetsUrl("/scares/2.png")
}, {
  vid: UTILS.assetsUrl("/scares/1.mp4")
}];
var jumpScareId = getParam("scr", 0);
var jumpScareTimer = jumpScareId ? 30000 : 0;
var vLN02063 = 0;
window.jumpScare = function (p14932) {
  if (vA660[p14932]) {
    var now = Date.now();
    if (now - vLN02063 < 10000) {
      return;
    }
    vLN02063 = now;
    if (vA660[p14932].img) {
      jumpSIMG.src = vA660[p14932].img;
      if (vA660[p14932].loaded) {
        jumpSIMG.style.display = "block";
        SOUND.play("scare_1", 2);
        requestAnimationFrame(function () {
          jumpSIMG.style.display = "none";
        }, 3000);
      } else {
        SOUND.onLoad("scare_1", function () {
          vA660[p14932].loaded = true;
          jumpSIMG.style.display = "block";
          SOUND.play("scare_1", 2);
          requestAnimationFrame(function () {
            jumpSIMG.style.display = "none";
          }, 3000);
        });
      }
    } else if (vA660[p14932].vid) {
      jumpSVID.src = vA660[p14932].vid;
      jumpSVID.play();
      jumpSVIDHolder.style.display = "block";
      requestAnimationFrame(function () {
        jumpSVIDHolder.style.display = "none";
      }, 4000);
    }
  }
};
var v12159;
function f2072(p14933) {
  if (v12159) {
    v12159.classList.remove("shakeEffect");
    p14933.offsetWidth;
  }
  v12159 = p14933;
  v12159.classList.add("shakeEffect");
}
window.getGameActivity = function () {
  return {
    id: v10544,
    time: timerVal.textContent ? timerVal.textContent.split(":").reverse().reduce((p14934, p14935, p14936) => p14934 + p14935 * Math.pow(60, p14936), 0) : null,
    user: account ? account.alias : "Guest" + (tmpPlayer ? "_" + tmpPlayer.sid : ""),
    class: {
      name: Game.classConfig[classIndex].name || null,
      index: tmpPlayer ? tmpPlayer.classIndex : classIndex
    },
    map: Game.map ? Game.map.getMapName() : null,
    mode: Game.mode ? Game.mode.name : null,
    custom: Game.isCustom
  };
};
window.disconnectPopup = function (p14937, p14938) {
  var v12160 = "<div class='imageListHeader' style='font-size: 26px;'>Report</div><div style='font-size:20px;color:#fff'><div style='margin-top: 3px;font-size: 22px;color: rgba(255, 255, 255, 0.7);'>Copy Paste this error data and send it to us at: krunker@yendis.ch</div><div class='mapFndB' onclick='window.getDCExport(this, &quot;" + p14937 + "&quot;, &quot;" + p14938 + "&quot;)' onmouseover='playTick(0.1)' style='background-color:#fc5a4e;width: 380px;margin-top: 10px;'>Copy Data</div></div>";
  genericPopup(v12160, "disconnectPop");
};
window.getDCExport = function (p14939, p14940, p14941) {
  var v12161 = p14939.textContent;
  var vO375 = {
    ua: v10513,
    savedRegion: SETTINGS.list.defaultRegion.val,
    connectedRegion: v10547,
    connectedHost: v10546,
    ping: currentPing,
    v: config.gameVersion,
    steam: v10514,
    client: vF1730,
    mobile: isMobileClient(),
    browser: v10513.slice(v10513.lastIndexOf(") ") + 2, v10513.length),
    code: p14940,
    reason: p14941,
    time: new Date().toString()
  };
  UTILS.copyToClipboard(JSON.stringify(vO375, null, 2));
  p14939.textContent = "Copied";
  requestAnimationFrame(() => p14939.textContent = v12161, 1250);
};
function f2073(p14942, p14943, p14944, p14945) {
  p14945 = p14945 || "https://krunker.io";
  p14944 = p14944 || "Krunker.io is a free Multiplayer Online Game. No Download needed";
  p14943 = p14943 || UTILS.assetsUrl("/promo/og.png");
  p14942 = p14942 || "Krunker";
  document.title = p14942;
  document.querySelector("meta[property=\"og:title\"]").setAttribute("content", p14942);
  document.querySelector("meta[property=\"og:image\"]").setAttribute("content", p14943);
  document.querySelector("meta[property=\"og:description\"]").setAttribute("content", p14944);
  document.querySelector("meta[name=\"description\"]").setAttribute("content", p14944);
  document.querySelector("meta[property=\"og:url\"]").setAttribute("content", p14945);
}
window.openOneTrust = function () {
  if (window.OneTrust) {
    if (devConsentStyleOverride) {
      devConsentStyleOverride.remove();
    }
    var v12162 = document.querySelector(".onetrust-pc-dark-filter");
    if (v12162) {
      v12162.setAttribute("onclick", "closeOneTrust()");
    }
    try {
      OneTrust.ToggleInfoDisplay();
    } catch (e157) {}
  }
};
window.closeOneTrust = function () {
  if (window.OneTrust) {
    try {
      OneTrust.Close();
    } catch (e158) {}
  }
};
var gameBridgeApi = {
  getGame: () => Game
};
const clientBridgeApi = {
  get config() {
    return config;
  },
  get i18n() {
    return i18n;
  },
  get Game() {
    return Game;
  },
  get player() {
    return tmpPlayer;
  },
  get team() {
    return team;
  },
  get inGame() {
    return inGame;
  },
  get io() {
    return io;
  },
  get account() {
    return account;
  },
  get SETTINGS() {
    return SETTINGS;
  },
  spinResponse: io_spinResponse,
  loadout: {
    get attachIndex() {
      return attachIndex;
    },
    set attachIndex(v) {
      attachIndex = v;
    },
    get classIndex() {
      return classIndex;
    },
    set classIndex(v) {
      classIndex = v;
    },
    get skinColIndex() {
      return skinColIndex;
    },
    set skinColIndex(v) {
      skinColIndex = v;
    },
    get hairCol() {
      return hairCol;
    },
    set hairCol(v) {
      hairCol = v;
    },
    get chatCol() {
      return chatCol;
    },
    set chatCol(v) {
      chatCol = v;
    },
    get dyeIndex() {
      return dyeIndex;
    },
    set dyeIndex(v) {
      dyeIndex = v;
    },
    get faceIndex() {
      return faceIndex;
    },
    set faceIndex(v) {
      faceIndex = v;
    },
    get shoeIndex() {
      return shoeIndex;
    },
    set shoeIndex(v) {
      shoeIndex = v;
    },
    get reticleIndex() {
      return reticleIndex;
    },
    set reticleIndex(v) {
      reticleIndex = v;
    },
    get savedReticle() {
      return savedReticle;
    },
    set savedReticle(v) {
      savedReticle = v;
    },
    get scopeIndex() {
      return scopeIndex;
    },
    set scopeIndex(v) {
      scopeIndex = v;
    },
    get savedScope() {
      return savedScope;
    },
    set savedScope(v) {
      savedScope = v;
    },
    get meleeIndex() {
      return meleeIndex;
    },
    set meleeIndex(v) {
      meleeIndex = v;
    },
    get backIndex() {
      return backIndex;
    },
    set backIndex(v) {
      backIndex = v;
    },
    get hatIndex() {
      return hatIndex;
    },
    set hatIndex(v) {
      hatIndex = v;
    },
    get headIndex() {
      return headIndex;
    },
    set headIndex(v) {
      headIndex = v;
    },
    get waistIndex() {
      return waistIndex;
    },
    set waistIndex(v) {
      waistIndex = v;
    },
    get petIndex() {
      return petIndex;
    },
    set petIndex(v) {
      petIndex = v;
    },
    get wristIndex() {
      return wristIndex;
    },
    set wristIndex(v) {
      wristIndex = v;
    },
    get savedSkins() {
      return savedSkins;
    },
    set savedSkins(v) {
      savedSkins = v;
    },
    get skinsLoadout() {
      return skinsLoadout;
    },
    set skinsLoadout(v) {
      skinsLoadout = v;
    },
    get secondaryInd() {
      return secondaryIndex;
    },
    set secondaryInd(v) {
      secondaryIndex = v;
    },
    get pcStatIndex() {
      return pcStatIndex;
    },
    set pcStatIndex(v) {
      pcStatIndex = v;
    },
    get activeSkinSel() {
      return activeSkinSel;
    },
    set activeSkinSel(v) {
      activeSkinSel = v;
    },
    get sprayIndex() {
      return sprayIndex;
    },
    set sprayIndex(v) {
      sprayIndex = v;
    },
    get streakIndex1() {
      return streakIndex1;
    },
    set streakIndex1(v) {
      streakIndex1 = v;
    },
    get streakIndex2() {
      return streakIndex2;
    },
    set streakIndex2(v) {
      streakIndex2 = v;
    },
    get streakIndex3() {
      return streakIndex3;
    },
    set streakIndex3(v) {
      streakIndex3 = v;
    },
    get skinPrim() {
      let v12163 = Game.classConfig[classIndex || 0];
      let v12164 = v12163.loadout[0];
      return skinsLoadout[v12164] || -1;
    },
    get skinSec() {
      return skinsLoadout[secondaryIndex] || -1;
    }
  }
};
Object(clientExtensionBridge.c)(SETTINGS, gameBridgeApi, clientBridgeApi);
function startBootstrapLoading() {
  function handleBootstrapProgress(progressValue) {
    if (progressValue === 1) {
      reloadMsg.innerHTML = i18n.t("game.reload.keyboard");
      FRVR.bootstrapper.complete();
    }
  }
  FRVR.bootstrapper.setProgress(0.01);
  loadStart(handleBootstrapProgress);
}
FRVR.bootstrapper.init().then(startBootstrapLoading);
window.logEventFRVR = function (p14975, p14976) {
  p14976 = p14976 || {};
  FRVR.tracker.logEvent(p14975, p14976);
};
window.logBtnFRVR = function (p14977) {
  logEventFRVR("btn_click", {
    label: p14977
  });
};
var isSessionTrackingActive = false;
function f2076() {
  isSessionTrackingActive = true;
  var vO378 = {
    login_type: account ? "krunker_account" : "guest"
  };
  if (account) {
    vO378.player_level = account.level;
    vO378.krunkers_wallet = account.funds || 0;
    vO378.junk_wallet = account.junk || 0;
    vO378.n_friends = friends ? friends.length : 0;
    vO378.n_friends_online = friends ? friends.filter(p14978 => p14978.st == 1).length : 0;
  }
  logEventFRVR("session_start", vO378);
}
function f2077(p14979) {
  if (isSessionTrackingActive) {
    isSessionTrackingActive = false;
    var vO379 = {};
    if (account) {
      vO379.player_level = account.level;
    }
    vO379.end_reason = p14979 || "disconnect";
    logEventFRVR("session_end", vO379);
  }
}
function f2078(p14980) {
  var vO380 = {};
  if (Game && Game.map) {
    vO380.base_game = Game.map.getMapName();
  }
  vO380.match_rank = Game && Game.isSandbox ? "sandbox" : "non-ranked";
  if (Game) {
    var v12166 = p14980 && typeof p14980 == "number" && !Game.isCustom ? Math.floor(p14980 / 1000) : 0;
    vO380.game_seconds_left = v12166;
  }
  logEventFRVR("game_session_start", vO380);
}
function f2079(p14981, p14982, p14983, p14984) {
  var vO381 = {
    end_reason: "game_end",
    score: 0,
    total_xp: account ? account.score : 0,
    winner: !!p14981,
    kills: 0,
    deaths: 0,
    server: config.regionNames[v10547],
    season: config.currentSeason
  };
  if (p14984) {
    vO381.bpp_gained = (p14984.gn || 0) + (p14984.cbp || 0);
    vO381.bpp_gained_uncapped = p14984.unbpp || 0;
    vO381.bpp_remaining_cap = p14984.rbpp || 0;
  }
  var v12167 = Game.mode.endStats || config.endStats;
  if (Game.isOfficial && v12167.indexOf("reward") == -1) {
    v12167.push("reward");
  }
  for (var v12168 = v12167.length, vLN02064 = 0; vLN02064 < p14982.ed.length; vLN02064 += v12168) {
    player = Game.players.findBySid(p14982.ed[vLN02064]);
    if (tmpPlayer && tmpPlayer == player) {
      for (var vLN1158 = 1; vLN1158 < v12168; ++vLN1158) {
        if (v12167[vLN1158] == "score") {
          vO381.score = p14982.ed[vLN02064 + vLN1158] || 0;
          vO381.total_xp += vO381.score;
        }
        if (v12167[vLN1158] == "kills") {
          vO381.kills = p14982.ed[vLN02064 + vLN1158] || 0;
        }
        if (v12167[vLN1158] == "deaths") {
          vO381.deaths = p14982.ed[vLN02064 + vLN1158] || 0;
        }
      }
      break;
    }
  }
  logEventFRVR("game_session_end", vO381);
}
function f2080(p14985) {
  var v12169 = account && account.stats && account.stats["c" + p14985] ? account.stats["c" + p14985] : 0;
  var v12170 = config.rankVar * Math.sqrt(v12169);
  v12169 = Math.max(1, Math.floor(v12170) + 1);
  var vO382 = {
    character_level: v12169 || 0,
    character_class: Game && Game.classes[p14985] ? Game.classes[p14985].name : "unknown"
  };
  if (Game && Game.map) {
    vO382.base_game = Game.map.getMapName();
  }
  vO382.match_rank = Game && Game.isSandbox ? "sandbox" : "non-ranked";
  vO382.mode = window.spectating ? "spectator" : "player";
  logEventFRVR("game_play_start", vO382);
}
function f2081() {
  var vO383 = {};
  vO383.gameplay_length = Date.now() - gameplayStartTime || 0;
  logEventFRVR("game_play_end", vO383);
}
if (window.showWindowAfterLoad) {
  clearPops();
  showWindow(window.showWindowAfterLoad);
  window.showWindowAfterLoad = 0;
}
function devConsoleRefreshSandboxRefs() {
  window.Game = Game;
  window.sandboxGame = sandboxGame;
  window.player = player;
  window.sandboxPlayer = sandboxPlayer;
}
function devConsoleReenterSandbox() {
  if (Game && Game.isSandbox && typeof window.enterGame === "function") {
    inGame = false;
    window.enterGame(true);
  }
  devConsoleRefreshSandboxRefs();
  return sandboxPlayer;
}
Object.assign(window, {
  ClientManager,
  client,
  CONTROLS,
  RENDER,
  OVERLAY: overlay,
  Game,
  sandboxGame,
  io,
  config,
  THREE,
  UTILS,
  SETTINGS,
  joinServer,
  connectToSandbox,
  devConsoleReenterSandbox,
  player,
  sandboxPlayer,
});